(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
//! openseadragon 2.4.2
//! Built on 2020-03-05
//! Git commit: v2.4.2-0-c450749
//! http://openseadragon.github.io
//! License: http://openseadragon.github.io/license/
/*
 * OpenSeadragon
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *//*
 * Portions of this source file taken from jQuery:
 *
 * Copyright 2011 John Resig
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *//*
 * Portions of this source file taken from mattsnider.com:
 *
 * Copyright (c) 2006-2013 Matt Snider
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT
 * OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR
 * THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *//**
 * @namespace OpenSeadragon
 * @version openseadragon 2.4.2
 * @classdesc The root namespace for OpenSeadragon.  All utility methods
 * and classes are defined on or below this namespace.
 *
 */// Typedefs
/**
  * All required and optional settings for instantiating a new instance of an OpenSeadragon image viewer.
  *
  * @typedef {Object} Options
  * @memberof OpenSeadragon
  *
  * @property {String} id
  *     Id of the element to append the viewer's container element to. If not provided, the 'element' property must be provided.
  *     If both the element and id properties are specified, the viewer is appended to the element provided in the element property.
  *
  * @property {Element} element
  *     The element to append the viewer's container element to. If not provided, the 'id' property must be provided.
  *     If both the element and id properties are specified, the viewer is appended to the element provided in the element property.
  *
  * @property {Array|String|Function|Object} [tileSources=null]
  *     Tile source(s) to open initially. This is a complex parameter; see
  *     {@link OpenSeadragon.Viewer#open} for details.
  *
  * @property {Number} [tabIndex=0]
  *     Tabbing order index to assign to the viewer element. Positive values are selected in increasing order. When tabIndex is 0
  *     source order is used. A negative value omits the viewer from the tabbing order.
  *
  * @property {Array} overlays Array of objects defining permanent overlays of
  *     the viewer. The overlays added via this option and later removed with
  *     {@link OpenSeadragon.Viewer#removeOverlay} will be added back when a new
  *     image is opened.
  *     To add overlays which can be definitively removed, one must use
  *     {@link OpenSeadragon.Viewer#addOverlay}
  *     If displaying a sequence of images, the overlays can be associated
  *     with a specific page by passing the overlays array to the page's
  *     tile source configuration.
  *     Expected properties:
  *     * x, y, (or px, py for pixel coordinates) to define the location.
  *     * width, height in point if using x,y or in pixels if using px,py. If width
  *       and height are specified, the overlay size is adjusted when zooming,
  *       otherwise the size stays the size of the content (or the size defined by CSS).
  *     * className to associate a class to the overlay
  *     * id to set the overlay element. If an element with this id already exists,
  *       it is reused, otherwise it is created. If not specified, a new element is
  *       created.
  *     * placement a string to define the relative position to the viewport.
  *       Only used if no width and height are specified. Default: 'TOP_LEFT'.
  *       See {@link OpenSeadragon.Placement} for possible values.
  *
  * @property {String} [xmlPath=null]
  *     <strong>DEPRECATED</strong>. A relative path to load a DZI file from the server.
  *     Prefer the newer Options.tileSources.
  *
  * @property {String} [prefixUrl='/images/']
  *     Prepends the prefixUrl to navImages paths, which is very useful
  *     since the default paths are rarely useful for production
  *     environments.
  *
  * @property {OpenSeadragon.NavImages} [navImages]
  *     An object with a property for each button or other built-in navigation
  *     control, eg the current 'zoomIn', 'zoomOut', 'home', and 'fullpage'.
  *     Each of those in turn provides an image path for each state of the button
  *     or navigation control, eg 'REST', 'GROUP', 'HOVER', 'PRESS'. Finally the
  *     image paths, by default assume there is a folder on the servers root path
  *     called '/images', eg '/images/zoomin_rest.png'.  If you need to adjust
  *     these paths, prefer setting the option.prefixUrl rather than overriding
  *     every image path directly through this setting.
  *
  * @property {Boolean} [debugMode=false]
  *     TODO: provide an in-screen panel providing event detail feedback.
  *
  * @property {String} [debugGridColor=['#437AB2', '#1B9E77', '#D95F02', '#7570B3', '#E7298A', '#66A61E', '#E6AB02', '#A6761D', '#666666']]
  *     The colors of grids in debug mode. Each tiled image's grid uses a consecutive color.
  *     If there are more tiled images than provided colors, the color vector is recycled.
  *
  * @property {Number} [blendTime=0]
  *     Specifies the duration of animation as higher or lower level tiles are
  *     replacing the existing tile.
  *
  * @property {Boolean} [alwaysBlend=false]
  *     Forces the tile to always blend.  By default the tiles skip blending
  *     when the blendTime is surpassed and the current animation frame would
  *     not complete the blend.
  *
  * @property {Boolean} [autoHideControls=true]
  *     If the user stops interacting with the viewport, fade the navigation
  *     controls.  Useful for presentation since the controls are by default
  *     floated on top of the image the user is viewing.
  *
  * @property {Boolean} [immediateRender=false]
  *     Render the best closest level first, ignoring the lowering levels which
  *     provide the effect of very blurry to sharp. It is recommended to change
  *     setting to true for mobile devices.
  *
  * @property {Number} [defaultZoomLevel=0]
  *     Zoom level to use when image is first opened or the home button is clicked.
  *     If 0, adjusts to fit viewer.
  *
  * @property {Number} [opacity=1]
  *     Default proportional opacity of the tiled images (1=opaque, 0=hidden)
  *     Hidden images do not draw and only load when preloading is allowed.
  *
  * @property {Boolean} [preload=false]
  *     Default switch for loading hidden images (true loads, false blocks)
  *
  * @property {String} [compositeOperation=null]
  *     Valid values are 'source-over', 'source-atop', 'source-in', 'source-out',
  *     'destination-over', 'destination-atop', 'destination-in',
  *     'destination-out', 'lighter', 'copy' or 'xor'
  *
  * @property {Boolean} [imageSmoothingEnabled=true]
  *     Image smoothing for canvas rendering (only if canvas is used). Note: Ignored
  *     by some (especially older) browsers which do not support this canvas property.
  *     This property can be changed in {@link Viewer.Drawer.setImageSmoothingEnabled}.
  *
  * @property {String|CanvasGradient|CanvasPattern|Function} [placeholderFillStyle=null]
  *     Draws a colored rectangle behind the tile if it is not loaded yet.
  *     You can pass a CSS color value like "#FF8800".
  *     When passing a function the tiledImage and canvas context are available as argument which is useful when you draw a gradient or pattern.
  *
  * @property {Number} [degrees=0]
  *     Initial rotation.
  *
  * @property {Boolean} [flipped=false]
  *     Initial flip state.
  *
  * @property {Number} [minZoomLevel=null]
  *
  * @property {Number} [maxZoomLevel=null]
  *
  * @property {Boolean} [homeFillsViewer=false]
  *     Make the 'home' button fill the viewer and clip the image, instead
  *     of fitting the image to the viewer and letterboxing.
  *
  * @property {Boolean} [panHorizontal=true]
  *     Allow horizontal pan.
  *
  * @property {Boolean} [panVertical=true]
  *     Allow vertical pan.
  *
  * @property {Boolean} [constrainDuringPan=false]
  *
  * @property {Boolean} [wrapHorizontal=false]
  *     Set to true to force the image to wrap horizontally within the viewport.
  *     Useful for maps or images representing the surface of a sphere or cylinder.
  *
  * @property {Boolean} [wrapVertical=false]
  *     Set to true to force the image to wrap vertically within the viewport.
  *     Useful for maps or images representing the surface of a sphere or cylinder.
  *
  * @property {Number} [minZoomImageRatio=0.9]
  *     The minimum percentage ( expressed as a number between 0 and 1 ) of
  *     the viewport height or width at which the zoom out will be constrained.
  *     Setting it to 0, for example will allow you to zoom out infinity.
  *
  * @property {Number} [maxZoomPixelRatio=1.1]
  *     The maximum ratio to allow a zoom-in to affect the highest level pixel
  *     ratio. This can be set to Infinity to allow 'infinite' zooming into the
  *     image though it is less effective visually if the HTML5 Canvas is not
  *     available on the viewing device.
  *
  * @property {Number} [smoothTileEdgesMinZoom=1.1]
  *     A zoom percentage ( where 1 is 100% ) of the highest resolution level.
  *     When zoomed in beyond this value alternative compositing will be used to
  *     smooth out the edges between tiles. This will have a performance impact.
  *     Can be set to Infinity to turn it off.
  *     Note: This setting is ignored on iOS devices due to a known bug (See {@link https://github.com/openseadragon/openseadragon/issues/952})
  *
  * @property {Boolean} [iOSDevice=?]
  *     True if running on an iOS device, false otherwise.
  *     Used to disable certain features that behave differently on iOS devices.
  *
  * @property {Boolean} [autoResize=true]
  *     Set to false to prevent polling for viewer size changes. Useful for providing custom resize behavior.
  *
  * @property {Boolean} [preserveImageSizeOnResize=false]
  *     Set to true to have the image size preserved when the viewer is resized. This requires autoResize=true (default).
  *
  * @property {Number} [minScrollDeltaTime=50]
  *     Number of milliseconds between canvas-scroll events. This value helps normalize the rate of canvas-scroll
  *     events between different devices, causing the faster devices to slow down enough to make the zoom control
  *     more manageable.
  *
  * @property {Number} [rotationIncrement=90]
  *     The number of degrees to rotate right or left when the rotate buttons or keyboard shortcuts are activated.
  *
  * @property {Number} [pixelsPerWheelLine=40]
  *     For pixel-resolution scrolling devices, the number of pixels equal to one scroll line.
  *
  * @property {Number} [pixelsPerArrowPress=40]
  *     The number of pixels viewport moves when an arrow key is pressed.
  *
  * @property {Number} [visibilityRatio=0.5]
  *     The percentage ( as a number from 0 to 1 ) of the source image which
  *     must be kept within the viewport.  If the image is dragged beyond that
  *     limit, it will 'bounce' back until the minimum visibility ratio is
  *     achieved.  Setting this to 0 and wrapHorizontal ( or wrapVertical ) to
  *     true will provide the effect of an infinitely scrolling viewport.
  *
  * @property {Object} [viewportMargins={}]
  *     Pushes the "home" region in from the sides by the specified amounts.
  *     Possible subproperties (Numbers, in screen coordinates): left, top, right, bottom.
  *
  * @property {Number} [imageLoaderLimit=0]
  *     The maximum number of image requests to make concurrently. By default
  *     it is set to 0 allowing the browser to make the maximum number of
  *     image requests in parallel as allowed by the browsers policy.
  *
  * @property {Number} [clickTimeThreshold=300]
  *      The number of milliseconds within which a pointer down-up event combination
  *      will be treated as a click gesture.
  *
  * @property {Number} [clickDistThreshold=5]
  *      The maximum distance allowed between a pointer down event and a pointer up event
  *      to be treated as a click gesture.
  *
  * @property {Number} [dblClickTimeThreshold=300]
  *      The number of milliseconds within which two pointer down-up event combinations
  *      will be treated as a double-click gesture.
  *
  * @property {Number} [dblClickDistThreshold=20]
  *      The maximum distance allowed between two pointer click events
  *      to be treated as a double-click gesture.
  *
  * @property {Number} [springStiffness=6.5]
  *
  * @property {Number} [animationTime=1.2]
  *     Specifies the animation duration per each {@link OpenSeadragon.Spring}
  *     which occur when the image is dragged or zoomed.
  *
  * @property {OpenSeadragon.GestureSettings} [gestureSettingsMouse]
  *     Settings for gestures generated by a mouse pointer device. (See {@link OpenSeadragon.GestureSettings})
  * @property {Boolean} [gestureSettingsMouse.scrollToZoom=true] - Zoom on scroll gesture
  * @property {Boolean} [gestureSettingsMouse.clickToZoom=true] - Zoom on click gesture
  * @property {Boolean} [gestureSettingsMouse.dblClickToZoom=false] - Zoom on double-click gesture. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  * @property {Boolean} [gestureSettingsMouse.pinchToZoom=false] - Zoom on pinch gesture
  * @property {Boolean} [gestureSettingsMouse.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
  *     the zoom is centered at the canvas center.
  * @property {Boolean} [gestureSettingsMouse.flickEnabled=false] - Enable flick gesture
  * @property {Number} [gestureSettingsMouse.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
  * @property {Number} [gestureSettingsMouse.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
  * @property {Boolean} [gestureSettingsMouse.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
  *
  * @property {OpenSeadragon.GestureSettings} [gestureSettingsTouch]
  *     Settings for gestures generated by a touch pointer device. (See {@link OpenSeadragon.GestureSettings})
  * @property {Boolean} [gestureSettingsTouch.scrollToZoom=false] - Zoom on scroll gesture
  * @property {Boolean} [gestureSettingsTouch.clickToZoom=false] - Zoom on click gesture
  * @property {Boolean} [gestureSettingsTouch.dblClickToZoom=true] - Zoom on double-click gesture. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  * @property {Boolean} [gestureSettingsTouch.pinchToZoom=true] - Zoom on pinch gesture
  * @property {Boolean} [gestureSettingsTouch.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
  *     the zoom is centered at the canvas center.
  * @property {Boolean} [gestureSettingsTouch.flickEnabled=true] - Enable flick gesture
  * @property {Number} [gestureSettingsTouch.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
  * @property {Number} [gestureSettingsTouch.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
  * @property {Boolean} [gestureSettingsTouch.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
  *
  * @property {OpenSeadragon.GestureSettings} [gestureSettingsPen]
  *     Settings for gestures generated by a pen pointer device. (See {@link OpenSeadragon.GestureSettings})
  * @property {Boolean} [gestureSettingsPen.scrollToZoom=false] - Zoom on scroll gesture
  * @property {Boolean} [gestureSettingsPen.clickToZoom=true] - Zoom on click gesture
  * @property {Boolean} [gestureSettingsPen.dblClickToZoom=false] - Zoom on double-click gesture. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  * @property {Boolean} [gestureSettingsPen.pinchToZoom=false] - Zoom on pinch gesture
  * @property {Boolean} [gestureSettingsPen.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
  *     the zoom is centered at the canvas center.
  * @property {Boolean} [gestureSettingsPen.flickEnabled=false] - Enable flick gesture
  * @property {Number} [gestureSettingsPen.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
  * @property {Number} [gestureSettingsPen.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
  * @property {Boolean} [gestureSettingsPen.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
  *
  * @property {OpenSeadragon.GestureSettings} [gestureSettingsUnknown]
  *     Settings for gestures generated by unknown pointer devices. (See {@link OpenSeadragon.GestureSettings})
  * @property {Boolean} [gestureSettingsUnknown.scrollToZoom=true] - Zoom on scroll gesture
  * @property {Boolean} [gestureSettingsUnknown.clickToZoom=false] - Zoom on click gesture
  * @property {Boolean} [gestureSettingsUnknown.dblClickToZoom=true] - Zoom on double-click gesture. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  * @property {Boolean} [gestureSettingsUnknown.pinchToZoom=true] - Zoom on pinch gesture
  * @property {Boolean} [gestureSettingsUnknown.zoomToRefPoint=true] - If zoomToRefPoint is true, the zoom is centered at the pointer position. Otherwise,
  *     the zoom is centered at the canvas center.
  * @property {Boolean} [gestureSettingsUnknown.flickEnabled=true] - Enable flick gesture
  * @property {Number} [gestureSettingsUnknown.flickMinSpeed=120] - If flickEnabled is true, the minimum speed to initiate a flick gesture (pixels-per-second)
  * @property {Number} [gestureSettingsUnknown.flickMomentum=0.25] - If flickEnabled is true, the momentum factor for the flick gesture
  * @property {Boolean} [gestureSettingsUnknown.pinchRotate=false] - If pinchRotate is true, the user will have the ability to rotate the image using their fingers.
  *
  * @property {Number} [zoomPerClick=2.0]
  *     The "zoom distance" per mouse click or touch tap. <em><strong>Note:</strong> Setting this to 1.0 effectively disables the click-to-zoom feature (also see gestureSettings[Mouse|Touch|Pen].clickToZoom/dblClickToZoom).</em>
  *
  * @property {Number} [zoomPerScroll=1.2]
  *     The "zoom distance" per mouse scroll or touch pinch. <em><strong>Note:</strong> Setting this to 1.0 effectively disables the mouse-wheel zoom feature (also see gestureSettings[Mouse|Touch|Pen].scrollToZoom}).</em>
  *
  * @property {Number} [zoomPerSecond=1.0]
  *     The number of seconds to animate a single zoom event over.
  *
  * @property {Boolean} [showNavigator=false]
  *     Set to true to make the navigator minimap appear.
  *
  * @property {String} [navigatorId=navigator-GENERATED DATE]
  *     The ID of a div to hold the navigator minimap.
  *     If an ID is specified, the navigatorPosition, navigatorSizeRatio, navigatorMaintainSizeRatio, navigator[Top|Left|Height|Width] and navigatorAutoFade options will be ignored.
  *     If an ID is not specified, a div element will be generated and placed on top of the main image.
  *
  * @property {String} [navigatorPosition='TOP_RIGHT']
  *     Valid values are 'TOP_LEFT', 'TOP_RIGHT', 'BOTTOM_LEFT', 'BOTTOM_RIGHT', or 'ABSOLUTE'.<br>
  *     If 'ABSOLUTE' is specified, then navigator[Top|Left|Height|Width] determines the size and position of the navigator minimap in the viewer, and navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.<br>
  *     For 'TOP_LEFT', 'TOP_RIGHT', 'BOTTOM_LEFT', and 'BOTTOM_RIGHT', the navigatorSizeRatio or navigator[Height|Width] values determine the size of the navigator minimap.
  *
  * @property {Number} [navigatorSizeRatio=0.2]
  *     Ratio of navigator size to viewer size. Ignored if navigator[Height|Width] are specified.
  *
  * @property {Boolean} [navigatorMaintainSizeRatio=false]
  *     If true, the navigator minimap is resized (using navigatorSizeRatio) when the viewer size changes.
  *
  * @property {Number|String} [navigatorTop=null]
  *     Specifies the location of the navigator minimap (see navigatorPosition).
  *
  * @property {Number|String} [navigatorLeft=null]
  *     Specifies the location of the navigator minimap (see navigatorPosition).
  *
  * @property {Number|String} [navigatorHeight=null]
  *     Specifies the size of the navigator minimap (see navigatorPosition).
  *     If specified, navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.
  *
  * @property {Number|String} [navigatorWidth=null]
  *     Specifies the size of the navigator minimap (see navigatorPosition).
  *     If specified, navigatorSizeRatio and navigatorMaintainSizeRatio are ignored.
  *
  * @property {Boolean} [navigatorAutoResize=true]
  *     Set to false to prevent polling for navigator size changes. Useful for providing custom resize behavior.
  *     Setting to false can also improve performance when the navigator is configured to a fixed size.
  *
  * @property {Boolean} [navigatorAutoFade=true]
  *     If the user stops interacting with the viewport, fade the navigator minimap.
  *     Setting to false will make the navigator minimap always visible.
  *
  * @property {Boolean} [navigatorRotate=true]
  *     If true, the navigator will be rotated together with the viewer.
  *
  * @property {String} [navigatorBackground='#000']
  *     Specifies the background color of the navigator minimap
  *
  * @property {Number} [navigatorOpacity=0.8]
  *     Specifies the opacity of the navigator minimap.
  *
  * @property {String} [navigatorBorderColor='#555']
  *     Specifies the border color of the navigator minimap
  *
  * @property {String} [navigatorDisplayRegionColor='#900']
  *     Specifies the border color of the display region rectangle of the navigator minimap
  *
  * @property {Number} [controlsFadeDelay=2000]
  *     The number of milliseconds to wait once the user has stopped interacting
  *     with the interface before beginning to fade the controls. Assumes
  *     showNavigationControl and autoHideControls are both true.
  *
  * @property {Number} [controlsFadeLength=1500]
  *     The number of milliseconds to animate the controls fading out.
  *
  * @property {Number} [maxImageCacheCount=200]
  *     The max number of images we should keep in memory (per drawer).
  *
  * @property {Number} [timeout=30000]
  *     The max number of milliseconds that an image job may take to complete.
  *
  * @property {Boolean} [useCanvas=true]
  *     Set to false to not use an HTML canvas element for image rendering even if canvas is supported.
  *
  * @property {Number} [minPixelRatio=0.5]
  *     The higher the minPixelRatio, the lower the quality of the image that
  *     is considered sufficient to stop rendering a given zoom level.  For
  *     example, if you are targeting mobile devices with less bandwidth you may
  *     try setting this to 1.5 or higher.
  *
  * @property {Boolean} [mouseNavEnabled=true]
  *     Is the user able to interact with the image via mouse or touch. Default
  *     interactions include draging the image in a plane, and zooming in toward
  *     and away from the image.
  *
  * @property {Boolean} [showNavigationControl=true]
  *     Set to false to prevent the appearance of the default navigation controls.<br>
  *     Note that if set to false, the customs buttons set by the options
  *     zoomInButton, zoomOutButton etc, are rendered inactive.
  *
  * @property {OpenSeadragon.ControlAnchor} [navigationControlAnchor=TOP_LEFT]
  *     Placement of the default navigation controls.
  *     To set the placement of the sequence controls, see the
  *     sequenceControlAnchor option.
  *
  * @property {Boolean} [showZoomControl=true]
  *     If true then + and - buttons to zoom in and out are displayed.<br>
  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
  *     this setting when set to false.
  *
  * @property {Boolean} [showHomeControl=true]
  *     If true then the 'Go home' button is displayed to go back to the original
  *     zoom and pan.<br>
  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
  *     this setting when set to false.
  *
  * @property {Boolean} [showFullPageControl=true]
  *     If true then the 'Toggle full page' button is displayed to switch
  *     between full page and normal mode.<br>
  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
  *     this setting when set to false.
  *
  * @property {Boolean} [showRotationControl=false]
  *     If true then the rotate left/right controls will be displayed as part of the
  *     standard controls. This is also subject to the browser support for rotate
  *     (e.g. viewer.drawer.canRotate()).<br>
  *     Note: {@link OpenSeadragon.Options.showNavigationControl} is overriding
  *     this setting when set to false.
  *
  * @property {Boolean} [showFlipControl=false]
  *     If true then the flip controls will be displayed as part of the
  *     standard controls.
  *
  * @property {Boolean} [showSequenceControl=true]
  *     If sequenceMode is true, then provide buttons for navigating forward and
  *     backward through the images.
  *
  * @property {OpenSeadragon.ControlAnchor} [sequenceControlAnchor=TOP_LEFT]
  *     Placement of the default sequence controls.
  *
  * @property {Boolean} [navPrevNextWrap=false]
  *     If true then the 'previous' button will wrap to the last image when
  *     viewing the first image and the 'next' button will wrap to the first
  *     image when viewing the last image.
  *
  * @property {String} zoomInButton
  *     Set the id of the custom 'Zoom in' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} zoomOutButton
  *     Set the id of the custom 'Zoom out' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} homeButton
  *     Set the id of the custom 'Go home' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} fullPageButton
  *     Set the id of the custom 'Toggle full page' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} rotateLeftButton
  *     Set the id of the custom 'Rotate left' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} rotateRightButton
  *     Set the id of the custom 'Rotate right' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} previousButton
  *     Set the id of the custom 'Previous page' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {String} nextButton
  *     Set the id of the custom 'Next page' button to use.
  *     This is useful to have a custom button anywhere in the web page.<br>
  *     To only change the button images, consider using
  *     {@link OpenSeadragon.Options.navImages}
  *
  * @property {Boolean} [sequenceMode=false]
  *     Set to true to have the viewer treat your tilesources as a sequence of images to
  *     be opened one at a time rather than all at once.
  *
  * @property {Number} [initialPage=0]
  *     If sequenceMode is true, display this page initially.
  *
  * @property {Boolean} [preserveViewport=false]
  *     If sequenceMode is true, then normally navigating through each image resets the
  *     viewport to 'home' position.  If preserveViewport is set to true, then the viewport
  *     position is preserved when navigating between images in the sequence.
  *
  * @property {Boolean} [preserveOverlays=false]
  *     If sequenceMode is true, then normally navigating through each image
  *     resets the overlays.
  *     If preserveOverlays is set to true, then the overlays added with {@link OpenSeadragon.Viewer#addOverlay}
  *     are preserved when navigating between images in the sequence.
  *     Note: setting preserveOverlays overrides any overlays specified in the global
  *     "overlays" option for the Viewer. It's also not compatible with specifying
  *     per-tileSource overlays via the options, as those overlays will persist
  *     even after the tileSource is closed.
  *
  * @property {Boolean} [showReferenceStrip=false]
  *     If sequenceMode is true, then display a scrolling strip of image thumbnails for
  *     navigating through the images.
  *
  * @property {String} [referenceStripScroll='horizontal']
  *
  * @property {Element} [referenceStripElement=null]
  *
  * @property {Number} [referenceStripHeight=null]
  *
  * @property {Number} [referenceStripWidth=null]
  *
  * @property {String} [referenceStripPosition='BOTTOM_LEFT']
  *
  * @property {Number} [referenceStripSizeRatio=0.2]
  *
  * @property {Boolean} [collectionMode=false]
  *     Set to true to have the viewer arrange your TiledImages in a grid or line.
  *
  * @property {Number} [collectionRows=3]
  *     If collectionMode is true, specifies how many rows the grid should have. Use 1 to make a line.
  *     If collectionLayout is 'vertical', specifies how many columns instead.
  *
  * @property {Number} [collectionColumns=0]
  *     If collectionMode is true, specifies how many columns the grid should have. Use 1 to make a line.
  *     If collectionLayout is 'vertical', specifies how many rows instead. Ignored if collectionRows is not set to a falsy value.
  *
  * @property {String} [collectionLayout='horizontal']
  *     If collectionMode is true, specifies whether to arrange vertically or horizontally.
  *
  * @property {Number} [collectionTileSize=800]
  *     If collectionMode is true, specifies the size, in viewport coordinates, for each TiledImage to fit into.
  *     The TiledImage will be centered within a square of the specified size.
  *
  * @property {Number} [collectionTileMargin=80]
  *     If collectionMode is true, specifies the margin, in viewport coordinates, between each TiledImage.
  *
  * @property {String|Boolean} [crossOriginPolicy=false]
  *     Valid values are 'Anonymous', 'use-credentials', and false. If false, canvas requests will
  *     not use CORS, and the canvas will be tainted.
  *
  * @property {Boolean} [ajaxWithCredentials=false]
  *     Whether to set the withCredentials XHR flag for AJAX requests.
  *     Note that this can be overridden at the {@link OpenSeadragon.TileSource} level.
  *
  * @property {Boolean} [loadTilesWithAjax=false]
  *     Whether to load tile data using AJAX requests.
  *     Note that this can be overridden at the {@link OpenSeadragon.TileSource} level.
  *
  * @property {Object} [ajaxHeaders={}]
  *     A set of headers to include when making AJAX requests for tile sources or tiles.
  *
  *//**
  * Settings for gestures generated by a pointer device.
  *
  * @typedef {Object} GestureSettings
  * @memberof OpenSeadragon
  *
  * @property {Boolean} scrollToZoom
  *     Set to false to disable zooming on scroll gestures.
  *
  * @property {Boolean} clickToZoom
  *     Set to false to disable zooming on click gestures.
  *
  * @property {Boolean} dblClickToZoom
  *     Set to false to disable zooming on double-click gestures. Note: If set to true
  *     then clickToZoom should be set to false to prevent multiple zooms.
  *
  * @property {Boolean} pinchToZoom
  *     Set to false to disable zooming on pinch gestures.
  *
  * @property {Boolean} flickEnabled
  *     Set to false to disable the kinetic panning effect (flick) at the end of a drag gesture.
  *
  * @property {Number} flickMinSpeed
  *     If flickEnabled is true, the minimum speed (in pixels-per-second) required to cause the kinetic panning effect (flick) at the end of a drag gesture.
  *
  * @property {Number} flickMomentum
  *     If flickEnabled is true, a constant multiplied by the velocity to determine the distance of the kinetic panning effect (flick) at the end of a drag gesture.
  *     A larger value will make the flick feel "lighter", while a smaller value will make the flick feel "heavier".
  *     Note: springStiffness and animationTime also affect the "spring" used to stop the flick animation.
  *
  *//**
  * The names for the image resources used for the image navigation buttons.
  *
  * @typedef {Object} NavImages
  * @memberof OpenSeadragon
  *
  * @property {Object} zoomIn - Images for the zoom-in button.
  * @property {String} zoomIn.REST
  * @property {String} zoomIn.GROUP
  * @property {String} zoomIn.HOVER
  * @property {String} zoomIn.DOWN
  *
  * @property {Object} zoomOut - Images for the zoom-out button.
  * @property {String} zoomOut.REST
  * @property {String} zoomOut.GROUP
  * @property {String} zoomOut.HOVER
  * @property {String} zoomOut.DOWN
  *
  * @property {Object} home - Images for the home button.
  * @property {String} home.REST
  * @property {String} home.GROUP
  * @property {String} home.HOVER
  * @property {String} home.DOWN
  *
  * @property {Object} fullpage - Images for the full-page button.
  * @property {String} fullpage.REST
  * @property {String} fullpage.GROUP
  * @property {String} fullpage.HOVER
  * @property {String} fullpage.DOWN
  *
  * @property {Object} rotateleft - Images for the rotate left button.
  * @property {String} rotateleft.REST
  * @property {String} rotateleft.GROUP
  * @property {String} rotateleft.HOVER
  * @property {String} rotateleft.DOWN
  *
  * @property {Object} rotateright - Images for the rotate right button.
  * @property {String} rotateright.REST
  * @property {String} rotateright.GROUP
  * @property {String} rotateright.HOVER
  * @property {String} rotateright.DOWN
  *
  * @property {Object} flip - Images for the flip button.
  * @property {String} flip.REST
  * @property {String} flip.GROUP
  * @property {String} flip.HOVER
  * @property {String} flip.DOWN
  *
  * @property {Object} previous - Images for the previous button.
  * @property {String} previous.REST
  * @property {String} previous.GROUP
  * @property {String} previous.HOVER
  * @property {String} previous.DOWN
  *
  * @property {Object} next - Images for the next button.
  * @property {String} next.REST
  * @property {String} next.GROUP
  * @property {String} next.HOVER
  * @property {String} next.DOWN
  *
  *//* eslint-disable no-redeclare */function OpenSeadragon(options){return new OpenSeadragon.Viewer(options);}(function($){/**
     * The OpenSeadragon version.
     *
     * @member {Object} OpenSeadragon.version
     * @property {String} versionStr - The version number as a string ('major.minor.revision').
     * @property {Number} major - The major version number.
     * @property {Number} minor - The minor version number.
     * @property {Number} revision - The revision number.
     * @since 1.0.0
     */$.version={versionStr:'2.4.2',major:parseInt('2',10),minor:parseInt('4',10),revision:parseInt('2',10)};/**
     * Taken from jquery 1.6.1
     * [[Class]] -> type pairs
     * @private
     */var class2type={'[object Boolean]':'boolean','[object Number]':'number','[object String]':'string','[object Function]':'function','[object Array]':'array','[object Date]':'date','[object RegExp]':'regexp','[object Object]':'object'},// Save a reference to some core methods
toString=Object.prototype.toString,hasOwn=Object.prototype.hasOwnProperty;/**
     * Taken from jQuery 1.6.1
     * @function isFunction
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */$.isFunction=function(obj){return $.type(obj)==="function";};/**
     * Taken from jQuery 1.6.1
     * @function isArray
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */$.isArray=Array.isArray||function(obj){return $.type(obj)==="array";};/**
     * A crude way of determining if an object is a window.
     * Taken from jQuery 1.6.1
     * @function isWindow
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */$.isWindow=function(obj){return obj&&typeof obj==="object"&&"setInterval"in obj;};/**
     * Taken from jQuery 1.6.1
     * @function type
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */$.type=function(obj){return obj===null||obj===undefined?String(obj):class2type[toString.call(obj)]||"object";};/**
     * Taken from jQuery 1.6.1
     * @function isPlainObject
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */$.isPlainObject=function(obj){// Must be an Object.
// Because of IE, we also have to check the presence of the constructor property.
// Make sure that DOM nodes and window objects don't pass through, as well
if(!obj||OpenSeadragon.type(obj)!=="object"||obj.nodeType||$.isWindow(obj)){return false;}// Not own constructor property must be Object
if(obj.constructor&&!hasOwn.call(obj,"constructor")&&!hasOwn.call(obj.constructor.prototype,"isPrototypeOf")){return false;}// Own properties are enumerated firstly, so to speed up,
// if last one is own, then all properties are own.
var lastKey;for(var key in obj){lastKey=key;}return lastKey===undefined||hasOwn.call(obj,lastKey);};/**
     * Taken from jQuery 1.6.1
     * @function isEmptyObject
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */$.isEmptyObject=function(obj){for(var name in obj){return false;}return true;};/**
     * Shim around Object.freeze. Does nothing if Object.freeze is not supported.
     * @param {Object} obj The object to freeze.
     * @return {Object} obj The frozen object.
     */$.freezeObject=function(obj){if(Object.freeze){$.freezeObject=Object.freeze;}else{$.freezeObject=function(obj){return obj;};}return $.freezeObject(obj);};/**
     * True if the browser supports the HTML5 canvas element
     * @member {Boolean} supportsCanvas
     * @memberof OpenSeadragon
     */$.supportsCanvas=function(){var canvasElement=document.createElement('canvas');return!!($.isFunction(canvasElement.getContext)&&canvasElement.getContext('2d'));}();/**
     * Test whether the submitted canvas is tainted or not.
     * @argument {Canvas} canvas The canvas to test.
     * @returns {Boolean} True if the canvas is tainted.
     */$.isCanvasTainted=function(canvas){var isTainted=false;try{// We test if the canvas is tainted by retrieving data from it.
// An exception will be raised if the canvas is tainted.
canvas.getContext('2d').getImageData(0,0,1,1);}catch(e){isTainted=true;}return isTainted;};/**
     * A ratio comparing the device screen's pixel density to the canvas's backing store pixel density,
     * clamped to a minimum of 1. Defaults to 1 if canvas isn't supported by the browser.
     * @member {Number} pixelDensityRatio
     * @memberof OpenSeadragon
     */$.pixelDensityRatio=function(){if($.supportsCanvas){var context=document.createElement('canvas').getContext('2d');var devicePixelRatio=window.devicePixelRatio||1;var backingStoreRatio=context.webkitBackingStorePixelRatio||context.mozBackingStorePixelRatio||context.msBackingStorePixelRatio||context.oBackingStorePixelRatio||context.backingStorePixelRatio||1;return Math.max(devicePixelRatio,1)/backingStoreRatio;}else{return 1;}}();})(OpenSeadragon);/**
 *  This closure defines all static methods available to the OpenSeadragon
 *  namespace.  Many, if not most, are taked directly from jQuery for use
 *  to simplify and reduce common programming patterns.  More static methods
 *  from jQuery may eventually make their way into this though we are
 *  attempting to avoid an explicit dependency on jQuery only because
 *  OpenSeadragon is a broadly useful code base and would be made less broad
 *  by requiring jQuery fully.
 *
 *  Some static methods have also been refactored from the original OpenSeadragon
 *  project.
 */(function($){/**
     * Taken from jQuery 1.6.1
     * @function extend
     * @memberof OpenSeadragon
     * @see {@link http://www.jquery.com/ jQuery}
     */$.extend=function(){var options,name,src,copy,copyIsArray,clone,target=arguments[0]||{},length=arguments.length,deep=false,i=1;// Handle a deep copy situation
if(typeof target==="boolean"){deep=target;target=arguments[1]||{};// skip the boolean and the target
i=2;}// Handle case when target is a string or something (possible in deep copy)
if(typeof target!=="object"&&!OpenSeadragon.isFunction(target)){target={};}// extend jQuery itself if only one argument is passed
if(length===i){target=this;--i;}for(;i<length;i++){// Only deal with non-null/undefined values
options=arguments[i];if(options!==null||options!==undefined){// Extend the base object
for(name in options){src=target[name];copy=options[name];// Prevent never-ending loop
if(target===copy){continue;}// Recurse if we're merging plain objects or arrays
if(deep&&copy&&(OpenSeadragon.isPlainObject(copy)||(copyIsArray=OpenSeadragon.isArray(copy)))){if(copyIsArray){copyIsArray=false;clone=src&&OpenSeadragon.isArray(src)?src:[];}else{clone=src&&OpenSeadragon.isPlainObject(src)?src:{};}// Never move original objects, clone them
target[name]=OpenSeadragon.extend(deep,clone,copy);// Don't bring in undefined values
}else if(copy!==undefined){target[name]=copy;}}}}// Return the modified object
return target;};var isIOSDevice=function(){if(typeof navigator!=='object'){return false;}var userAgent=navigator.userAgent;if(typeof userAgent!=='string'){return false;}return userAgent.indexOf('iPhone')!==-1||userAgent.indexOf('iPad')!==-1||userAgent.indexOf('iPod')!==-1;};$.extend($,/** @lends OpenSeadragon */{/**
         * The default values for the optional settings documented at {@link OpenSeadragon.Options}.
         * @static
         * @type {Object}
         */DEFAULT_SETTINGS:{//DATA SOURCE DETAILS
xmlPath:null,tileSources:null,tileHost:null,initialPage:0,crossOriginPolicy:false,ajaxWithCredentials:false,loadTilesWithAjax:false,ajaxHeaders:{},//PAN AND ZOOM SETTINGS AND CONSTRAINTS
panHorizontal:true,panVertical:true,constrainDuringPan:false,wrapHorizontal:false,wrapVertical:false,visibilityRatio:0.5,//-> how much of the viewer can be negative space
minPixelRatio:0.5,//->closer to 0 draws tiles meant for a higher zoom at this zoom
defaultZoomLevel:0,minZoomLevel:null,maxZoomLevel:null,homeFillsViewer:false,//UI RESPONSIVENESS AND FEEL
clickTimeThreshold:300,clickDistThreshold:5,dblClickTimeThreshold:300,dblClickDistThreshold:20,springStiffness:6.5,animationTime:1.2,gestureSettingsMouse:{scrollToZoom:true,clickToZoom:true,dblClickToZoom:false,pinchToZoom:false,zoomToRefPoint:true,flickEnabled:false,flickMinSpeed:120,flickMomentum:0.25,pinchRotate:false},gestureSettingsTouch:{scrollToZoom:false,clickToZoom:false,dblClickToZoom:true,pinchToZoom:true,zoomToRefPoint:true,flickEnabled:true,flickMinSpeed:120,flickMomentum:0.25,pinchRotate:false},gestureSettingsPen:{scrollToZoom:false,clickToZoom:true,dblClickToZoom:false,pinchToZoom:false,zoomToRefPoint:true,flickEnabled:false,flickMinSpeed:120,flickMomentum:0.25,pinchRotate:false},gestureSettingsUnknown:{scrollToZoom:false,clickToZoom:false,dblClickToZoom:true,pinchToZoom:true,zoomToRefPoint:true,flickEnabled:true,flickMinSpeed:120,flickMomentum:0.25,pinchRotate:false},zoomPerClick:2,zoomPerScroll:1.2,zoomPerSecond:1.0,blendTime:0,alwaysBlend:false,autoHideControls:true,immediateRender:false,minZoomImageRatio:0.9,//-> closer to 0 allows zoom out to infinity
maxZoomPixelRatio:1.1,//-> higher allows 'over zoom' into pixels
smoothTileEdgesMinZoom:1.1,//-> higher than maxZoomPixelRatio disables it
iOSDevice:isIOSDevice(),pixelsPerWheelLine:40,pixelsPerArrowPress:40,autoResize:true,preserveImageSizeOnResize:false,// requires autoResize=true
minScrollDeltaTime:50,rotationIncrement:90,//DEFAULT CONTROL SETTINGS
showSequenceControl:true,//SEQUENCE
sequenceControlAnchor:null,//SEQUENCE
preserveViewport:false,//SEQUENCE
preserveOverlays:false,//SEQUENCE
navPrevNextWrap:false,//SEQUENCE
showNavigationControl:true,//ZOOM/HOME/FULL/ROTATION
navigationControlAnchor:null,//ZOOM/HOME/FULL/ROTATION
showZoomControl:true,//ZOOM
showHomeControl:true,//HOME
showFullPageControl:true,//FULL
showRotationControl:false,//ROTATION
showFlipControl:false,//FLIP
controlsFadeDelay:2000,//ZOOM/HOME/FULL/SEQUENCE
controlsFadeLength:1500,//ZOOM/HOME/FULL/SEQUENCE
mouseNavEnabled:true,//GENERAL MOUSE INTERACTIVITY
//VIEWPORT NAVIGATOR SETTINGS
showNavigator:false,navigatorId:null,navigatorPosition:null,navigatorSizeRatio:0.2,navigatorMaintainSizeRatio:false,navigatorTop:null,navigatorLeft:null,navigatorHeight:null,navigatorWidth:null,navigatorAutoResize:true,navigatorAutoFade:true,navigatorRotate:true,navigatorBackground:'#000',navigatorOpacity:0.8,navigatorBorderColor:'#555',navigatorDisplayRegionColor:'#900',// INITIAL ROTATION
degrees:0,// INITIAL FLIP STATE
flipped:false,// APPEARANCE
opacity:1,preload:false,compositeOperation:null,imageSmoothingEnabled:true,placeholderFillStyle:null,//REFERENCE STRIP SETTINGS
showReferenceStrip:false,referenceStripScroll:'horizontal',referenceStripElement:null,referenceStripHeight:null,referenceStripWidth:null,referenceStripPosition:'BOTTOM_LEFT',referenceStripSizeRatio:0.2,//COLLECTION VISUALIZATION SETTINGS
collectionRows:3,//or columns depending on layout
collectionColumns:0,//columns in horizontal layout, rows in vertical layout
collectionLayout:'horizontal',//vertical
collectionMode:false,collectionTileSize:800,collectionTileMargin:80,//PERFORMANCE SETTINGS
imageLoaderLimit:0,maxImageCacheCount:200,timeout:30000,useCanvas:true,// Use canvas element for drawing if available
//INTERFACE RESOURCE SETTINGS
prefixUrl:"/images/",navImages:{zoomIn:{REST:'zoomin_rest.png',GROUP:'zoomin_grouphover.png',HOVER:'zoomin_hover.png',DOWN:'zoomin_pressed.png'},zoomOut:{REST:'zoomout_rest.png',GROUP:'zoomout_grouphover.png',HOVER:'zoomout_hover.png',DOWN:'zoomout_pressed.png'},home:{REST:'home_rest.png',GROUP:'home_grouphover.png',HOVER:'home_hover.png',DOWN:'home_pressed.png'},fullpage:{REST:'fullpage_rest.png',GROUP:'fullpage_grouphover.png',HOVER:'fullpage_hover.png',DOWN:'fullpage_pressed.png'},rotateleft:{REST:'rotateleft_rest.png',GROUP:'rotateleft_grouphover.png',HOVER:'rotateleft_hover.png',DOWN:'rotateleft_pressed.png'},rotateright:{REST:'rotateright_rest.png',GROUP:'rotateright_grouphover.png',HOVER:'rotateright_hover.png',DOWN:'rotateright_pressed.png'},flip:{// Flip icon designed by Yaroslav Samoylov from the Noun Project and modified by Nelson Campos ncampos@criteriamarathon.com, https://thenounproject.com/term/flip/136289/
REST:'flip_rest.png',GROUP:'flip_grouphover.png',HOVER:'flip_hover.png',DOWN:'flip_pressed.png'},previous:{REST:'previous_rest.png',GROUP:'previous_grouphover.png',HOVER:'previous_hover.png',DOWN:'previous_pressed.png'},next:{REST:'next_rest.png',GROUP:'next_grouphover.png',HOVER:'next_hover.png',DOWN:'next_pressed.png'}},//DEVELOPER SETTINGS
debugMode:false,debugGridColor:['#437AB2','#1B9E77','#D95F02','#7570B3','#E7298A','#66A61E','#E6AB02','#A6761D','#666666']},/**
         * TODO: get rid of this.  I can't see how it's required at all.  Looks
         *       like an early legacy code artifact.
         * @static
         * @ignore
         */SIGNAL:"----seadragon----",/**
         * Returns a function which invokes the method as if it were a method belonging to the object.
         * @function
         * @param {Object} object
         * @param {Function} method
         * @returns {Function}
         */delegate:function(object,method){return function(){var args=arguments;if(args===undefined){args=[];}return method.apply(object,args);};},/**
         * An enumeration of Browser vendors.
         * @static
         * @type {Object}
         * @property {Number} UNKNOWN
         * @property {Number} IE
         * @property {Number} FIREFOX
         * @property {Number} SAFARI
         * @property {Number} CHROME
         * @property {Number} OPERA
         */BROWSERS:{UNKNOWN:0,IE:1,FIREFOX:2,SAFARI:3,CHROME:4,OPERA:5},/**
         * Returns a DOM Element for the given id or element.
         * @function
         * @param {String|Element} element Accepts an id or element.
         * @returns {Element} The element with the given id, null, or the element itself.
         */getElement:function(element){if(typeof element=="string"){element=document.getElementById(element);}return element;},/**
         * Determines the position of the upper-left corner of the element.
         * @function
         * @param {Element|String} element - the element we want the position for.
         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element.
         */getElementPosition:function(element){var result=new $.Point(),isFixed,offsetParent;element=$.getElement(element);isFixed=$.getElementStyle(element).position=="fixed";offsetParent=getOffsetParent(element,isFixed);while(offsetParent){result.x+=element.offsetLeft;result.y+=element.offsetTop;if(isFixed){result=result.plus($.getPageScroll());}element=offsetParent;isFixed=$.getElementStyle(element).position=="fixed";offsetParent=getOffsetParent(element,isFixed);}return result;},/**
         * Determines the position of the upper-left corner of the element adjusted for current page and/or element scroll.
         * @function
         * @param {Element|String} element - the element we want the position for.
         * @returns {OpenSeadragon.Point} - the position of the upper left corner of the element adjusted for current page and/or element scroll.
         */getElementOffset:function(element){element=$.getElement(element);var doc=element&&element.ownerDocument,docElement,win,boundingRect={top:0,left:0};if(!doc){return new $.Point();}docElement=doc.documentElement;if(typeof element.getBoundingClientRect!==typeof undefined){boundingRect=element.getBoundingClientRect();}win=doc==doc.window?doc:doc.nodeType===9?doc.defaultView||doc.parentWindow:false;return new $.Point(boundingRect.left+(win.pageXOffset||docElement.scrollLeft)-(docElement.clientLeft||0),boundingRect.top+(win.pageYOffset||docElement.scrollTop)-(docElement.clientTop||0));},/**
         * Determines the height and width of the given element.
         * @function
         * @param {Element|String} element
         * @returns {OpenSeadragon.Point}
         */getElementSize:function(element){element=$.getElement(element);return new $.Point(element.clientWidth,element.clientHeight);},/**
         * Returns the CSSStyle object for the given element.
         * @function
         * @param {Element|String} element
         * @returns {CSSStyle}
         */getElementStyle:document.documentElement.currentStyle?function(element){element=$.getElement(element);return element.currentStyle;}:function(element){element=$.getElement(element);return window.getComputedStyle(element,"");},/**
         * Returns the property with the correct vendor prefix appended.
         * @param {String} property the property name
         * @returns {String} the property with the correct prefix or null if not
         * supported.
         */getCssPropertyWithVendorPrefix:function(property){var memo={};$.getCssPropertyWithVendorPrefix=function(property){if(memo[property]!==undefined){return memo[property];}var style=document.createElement('div').style;var result=null;if(style[property]!==undefined){result=property;}else{var prefixes=['Webkit','Moz','MS','O','webkit','moz','ms','o'];var suffix=$.capitalizeFirstLetter(property);for(var i=0;i<prefixes.length;i++){var prop=prefixes[i]+suffix;if(style[prop]!==undefined){result=prop;break;}}}memo[property]=result;return result;};return $.getCssPropertyWithVendorPrefix(property);},/**
         * Capitalizes the first letter of a string
         * @param {String} string
         * @returns {String} The string with the first letter capitalized
         */capitalizeFirstLetter:function(string){return string.charAt(0).toUpperCase()+string.slice(1);},/**
         * Compute the modulo of a number but makes sure to always return
         * a positive value.
         * @param {Number} number the number to computes the modulo of
         * @param {Number} modulo the modulo
         * @returns {Number} the result of the modulo of number
         */positiveModulo:function(number,modulo){var result=number%modulo;if(result<0){result+=modulo;}return result;},/**
         * Determines if a point is within the bounding rectangle of the given element (hit-test).
         * @function
         * @param {Element|String} element
         * @param {OpenSeadragon.Point} point
         * @returns {Boolean}
         */pointInElement:function(element,point){element=$.getElement(element);var offset=$.getElementOffset(element),size=$.getElementSize(element);return point.x>=offset.x&&point.x<offset.x+size.x&&point.y<offset.y+size.y&&point.y>=offset.y;},/**
         * Gets the latest event, really only useful internally since its
         * specific to IE behavior.
         * @function
         * @param {Event} [event]
         * @returns {Event}
         * @deprecated For internal use only
         * @private
         */getEvent:function(event){if(event){$.getEvent=function(event){return event;};}else{$.getEvent=function(){return window.event;};}return $.getEvent(event);},/**
         * Gets the position of the mouse on the screen for a given event.
         * @function
         * @param {Event} [event]
         * @returns {OpenSeadragon.Point}
         */getMousePosition:function(event){if(typeof event.pageX=="number"){$.getMousePosition=function(event){var result=new $.Point();event=$.getEvent(event);result.x=event.pageX;result.y=event.pageY;return result;};}else if(typeof event.clientX=="number"){$.getMousePosition=function(event){var result=new $.Point();event=$.getEvent(event);result.x=event.clientX+document.body.scrollLeft+document.documentElement.scrollLeft;result.y=event.clientY+document.body.scrollTop+document.documentElement.scrollTop;return result;};}else{throw new Error("Unknown event mouse position, no known technique.");}return $.getMousePosition(event);},/**
         * Determines the page's current scroll position.
         * @function
         * @returns {OpenSeadragon.Point}
         */getPageScroll:function(){var docElement=document.documentElement||{},body=document.body||{};if(typeof window.pageXOffset=="number"){$.getPageScroll=function(){return new $.Point(window.pageXOffset,window.pageYOffset);};}else if(body.scrollLeft||body.scrollTop){$.getPageScroll=function(){return new $.Point(document.body.scrollLeft,document.body.scrollTop);};}else if(docElement.scrollLeft||docElement.scrollTop){$.getPageScroll=function(){return new $.Point(document.documentElement.scrollLeft,document.documentElement.scrollTop);};}else{// We can't reassign the function yet, as there was no scroll.
return new $.Point(0,0);}return $.getPageScroll();},/**
         * Set the page scroll position.
         * @function
         * @returns {OpenSeadragon.Point}
         */setPageScroll:function(scroll){if(typeof window.scrollTo!=="undefined"){$.setPageScroll=function(scroll){window.scrollTo(scroll.x,scroll.y);};}else{var originalScroll=$.getPageScroll();if(originalScroll.x===scroll.x&&originalScroll.y===scroll.y){// We are already correctly positioned and there
// is no way to detect the correct method.
return;}document.body.scrollLeft=scroll.x;document.body.scrollTop=scroll.y;var currentScroll=$.getPageScroll();if(currentScroll.x!==originalScroll.x&&currentScroll.y!==originalScroll.y){$.setPageScroll=function(scroll){document.body.scrollLeft=scroll.x;document.body.scrollTop=scroll.y;};return;}document.documentElement.scrollLeft=scroll.x;document.documentElement.scrollTop=scroll.y;currentScroll=$.getPageScroll();if(currentScroll.x!==originalScroll.x&&currentScroll.y!==originalScroll.y){$.setPageScroll=function(scroll){document.documentElement.scrollLeft=scroll.x;document.documentElement.scrollTop=scroll.y;};return;}// We can't find anything working, so we do nothing.
$.setPageScroll=function(scroll){};}return $.setPageScroll(scroll);},/**
         * Determines the size of the browsers window.
         * @function
         * @returns {OpenSeadragon.Point}
         */getWindowSize:function(){var docElement=document.documentElement||{},body=document.body||{};if(typeof window.innerWidth=='number'){$.getWindowSize=function(){return new $.Point(window.innerWidth,window.innerHeight);};}else if(docElement.clientWidth||docElement.clientHeight){$.getWindowSize=function(){return new $.Point(document.documentElement.clientWidth,document.documentElement.clientHeight);};}else if(body.clientWidth||body.clientHeight){$.getWindowSize=function(){return new $.Point(document.body.clientWidth,document.body.clientHeight);};}else{throw new Error("Unknown window size, no known technique.");}return $.getWindowSize();},/**
         * Wraps the given element in a nest of divs so that the element can
         * be easily centered using CSS tables
         * @function
         * @param {Element|String} element
         * @returns {Element} outermost wrapper element
         */makeCenteredNode:function(element){// Convert a possible ID to an actual HTMLElement
element=$.getElement(element);/*
                CSS tables require you to have a display:table/row/cell hierarchy so we need to create
                three nested wrapper divs:
             */var wrappers=[$.makeNeutralElement('div'),$.makeNeutralElement('div'),$.makeNeutralElement('div')];// It feels like we should be able to pass style dicts to makeNeutralElement:
$.extend(wrappers[0].style,{display:"table",height:"100%",width:"100%"});$.extend(wrappers[1].style,{display:"table-row"});$.extend(wrappers[2].style,{display:"table-cell",verticalAlign:"middle",textAlign:"center"});wrappers[0].appendChild(wrappers[1]);wrappers[1].appendChild(wrappers[2]);wrappers[2].appendChild(element);return wrappers[0];},/**
         * Creates an easily positionable element of the given type that therefor
         * serves as an excellent container element.
         * @function
         * @param {String} tagName
         * @returns {Element}
         */makeNeutralElement:function(tagName){var element=document.createElement(tagName),style=element.style;style.background="transparent none";style.border="none";style.margin="0px";style.padding="0px";style.position="static";return element;},/**
         * Returns the current milliseconds, using Date.now() if available
         * @function
         */now:function(){if(Date.now){$.now=Date.now;}else{$.now=function(){return new Date().getTime();};}return $.now();},/**
         * Ensures an image is loaded correctly to support alpha transparency.
         * Generally only IE has issues doing this correctly for formats like
         * png.
         * @function
         * @param {String} src
         * @returns {Element}
         */makeTransparentImage:function(src){$.makeTransparentImage=function(src){var img=$.makeNeutralElement("img");img.src=src;return img;};if($.Browser.vendor==$.BROWSERS.IE&&$.Browser.version<7){$.makeTransparentImage=function(src){var img=$.makeNeutralElement("img"),element=null;element=$.makeNeutralElement("span");element.style.display="inline-block";img.onload=function(){element.style.width=element.style.width||img.width+"px";element.style.height=element.style.height||img.height+"px";img.onload=null;img=null;// to prevent memory leaks in IE
};img.src=src;element.style.filter="progid:DXImageTransform.Microsoft.AlphaImageLoader(src='"+src+"', sizingMethod='scale')";return element;};}return $.makeTransparentImage(src);},/**
         * Sets the opacity of the specified element.
         * @function
         * @param {Element|String} element
         * @param {Number} opacity
         * @param {Boolean} [usesAlpha]
         */setElementOpacity:function(element,opacity,usesAlpha){var ieOpacity,ieFilter;element=$.getElement(element);if(usesAlpha&&!$.Browser.alpha){opacity=Math.round(opacity);}if($.Browser.opacity){element.style.opacity=opacity<1?opacity:"";}else{if(opacity<1){ieOpacity=Math.round(100*opacity);ieFilter="alpha(opacity="+ieOpacity+")";element.style.filter=ieFilter;}else{element.style.filter="";}}},/**
         * Sets the specified element's touch-action style attribute to 'none'.
         * @function
         * @param {Element|String} element
         */setElementTouchActionNone:function(element){element=$.getElement(element);if(typeof element.style.touchAction!=='undefined'){element.style.touchAction='none';}else if(typeof element.style.msTouchAction!=='undefined'){element.style.msTouchAction='none';}},/**
         * Add the specified CSS class to the element if not present.
         * @function
         * @param {Element|String} element
         * @param {String} className
         */addClass:function(element,className){element=$.getElement(element);if(!element.className){element.className=className;}else if((' '+element.className+' ').indexOf(' '+className+' ')===-1){element.className+=' '+className;}},/**
         * Find the first index at which an element is found in an array or -1
         * if not present.
         *
         * Code taken and adapted from
         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility
         *
         * @function
         * @param {Array} array The array from which to find the element
         * @param {Object} searchElement The element to find
         * @param {Number} [fromIndex=0] Index to start research.
         * @returns {Number} The index of the element in the array.
         */indexOf:function(array,searchElement,fromIndex){if(Array.prototype.indexOf){this.indexOf=function(array,searchElement,fromIndex){return array.indexOf(searchElement,fromIndex);};}else{this.indexOf=function(array,searchElement,fromIndex){var i,pivot=fromIndex?fromIndex:0,length;if(!array){throw new TypeError();}length=array.length;if(length===0||pivot>=length){return-1;}if(pivot<0){pivot=length-Math.abs(pivot);}for(i=pivot;i<length;i++){if(array[i]===searchElement){return i;}}return-1;};}return this.indexOf(array,searchElement,fromIndex);},/**
         * Remove the specified CSS class from the element.
         * @function
         * @param {Element|String} element
         * @param {String} className
         */removeClass:function(element,className){var oldClasses,newClasses=[],i;element=$.getElement(element);oldClasses=element.className.split(/\s+/);for(i=0;i<oldClasses.length;i++){if(oldClasses[i]&&oldClasses[i]!==className){newClasses.push(oldClasses[i]);}}element.className=newClasses.join(' ');},/**
         * Adds an event listener for the given element, eventName and handler.
         * @function
         * @param {Element|String} element
         * @param {String} eventName
         * @param {Function} handler
         * @param {Boolean} [useCapture]
         */addEvent:function(){if(window.addEventListener){return function(element,eventName,handler,useCapture){element=$.getElement(element);element.addEventListener(eventName,handler,useCapture);};}else if(window.attachEvent){return function(element,eventName,handler,useCapture){element=$.getElement(element);element.attachEvent('on'+eventName,handler);};}else{throw new Error("No known event model.");}}(),/**
         * Remove a given event listener for the given element, event type and
         * handler.
         * @function
         * @param {Element|String} element
         * @param {String} eventName
         * @param {Function} handler
         * @param {Boolean} [useCapture]
         */removeEvent:function(){if(window.removeEventListener){return function(element,eventName,handler,useCapture){element=$.getElement(element);element.removeEventListener(eventName,handler,useCapture);};}else if(window.detachEvent){return function(element,eventName,handler,useCapture){element=$.getElement(element);element.detachEvent('on'+eventName,handler);};}else{throw new Error("No known event model.");}}(),/**
         * Cancels the default browser behavior had the event propagated all
         * the way up the DOM to the window object.
         * @function
         * @param {Event} [event]
         */cancelEvent:function(event){event=$.getEvent(event);if(event.preventDefault){$.cancelEvent=function(event){// W3C for preventing default
event.preventDefault();};}else{$.cancelEvent=function(event){event=$.getEvent(event);// legacy for preventing default
event.cancel=true;// IE for preventing default
event.returnValue=false;};}$.cancelEvent(event);},/**
         * Stops the propagation of the event up the DOM.
         * @function
         * @param {Event} [event]
         */stopEvent:function(event){event=$.getEvent(event);if(event.stopPropagation){// W3C for stopping propagation
$.stopEvent=function(event){event.stopPropagation();};}else{// IE for stopping propagation
$.stopEvent=function(event){event=$.getEvent(event);event.cancelBubble=true;};}$.stopEvent(event);},/**
         * Similar to OpenSeadragon.delegate, but it does not immediately call
         * the method on the object, returning a function which can be called
         * repeatedly to delegate the method. It also allows additional arguments
         * to be passed during construction which will be added during each
         * invocation, and each invocation can add additional arguments as well.
         *
         * @function
         * @param {Object} object
         * @param {Function} method
         * @param [args] any additional arguments are passed as arguments to the
         *  created callback
         * @returns {Function}
         */createCallback:function(object,method){//TODO: This pattern is painful to use and debug.  It's much cleaner
//      to use pinning plus anonymous functions.  Get rid of this
//      pattern!
var initialArgs=[],i;for(i=2;i<arguments.length;i++){initialArgs.push(arguments[i]);}return function(){var args=initialArgs.concat([]),i;for(i=0;i<arguments.length;i++){args.push(arguments[i]);}return method.apply(object,args);};},/**
         * Retrieves the value of a url parameter from the window.location string.
         * @function
         * @param {String} key
         * @returns {String} The value of the url parameter or null if no param matches.
         */getUrlParameter:function(key){// eslint-disable-next-line no-use-before-define
var value=URLPARAMS[key];return value?value:null;},/**
         * Retrieves the protocol used by the url. The url can either be absolute
         * or relative.
         * @function
         * @private
         * @param {String} url The url to retrieve the protocol from.
         * @return {String} The protocol (http:, https:, file:, ftp: ...)
         */getUrlProtocol:function(url){var match=url.match(/^([a-z]+:)\/\//i);if(match===null){// Relative URL, retrive the protocol from window.location
return window.location.protocol;}return match[1].toLowerCase();},/**
         * Create an XHR object
         * @private
         * @param {type} [local] If set to true, the XHR will be file: protocol
         * compatible if possible (but may raise a warning in the browser).
         * @returns {XMLHttpRequest}
         */createAjaxRequest:function(local){// IE11 does not support window.ActiveXObject so we just try to
// create one to see if it is supported.
// See: http://msdn.microsoft.com/en-us/library/ie/dn423948%28v=vs.85%29.aspx
var supportActiveX;try{/* global ActiveXObject:true */supportActiveX=!!new ActiveXObject("Microsoft.XMLHTTP");}catch(e){supportActiveX=false;}if(supportActiveX){if(window.XMLHttpRequest){$.createAjaxRequest=function(local){if(local){return new ActiveXObject("Microsoft.XMLHTTP");}return new XMLHttpRequest();};}else{$.createAjaxRequest=function(){return new ActiveXObject("Microsoft.XMLHTTP");};}}else if(window.XMLHttpRequest){$.createAjaxRequest=function(){return new XMLHttpRequest();};}else{throw new Error("Browser doesn't support XMLHttpRequest.");}return $.createAjaxRequest(local);},/**
         * Makes an AJAX request.
         * @param {Object} options
         * @param {String} options.url - the url to request
         * @param {Function} options.success - a function to call on a successful response
         * @param {Function} options.error - a function to call on when an error occurs
         * @param {Object} options.headers - headers to add to the AJAX request
         * @param {String} options.responseType - the response type of the the AJAX request
         * @param {Boolean} [options.withCredentials=false] - whether to set the XHR's withCredentials
         * @throws {Error}
         * @returns {XMLHttpRequest}
         */makeAjaxRequest:function(url,onSuccess,onError){var withCredentials;var headers;var responseType;// Note that our preferred API is that you pass in a single object; the named
// arguments are for legacy support.
if($.isPlainObject(url)){onSuccess=url.success;onError=url.error;withCredentials=url.withCredentials;headers=url.headers;responseType=url.responseType||null;url=url.url;}var protocol=$.getUrlProtocol(url);var request=$.createAjaxRequest(protocol==="file:");if(!$.isFunction(onSuccess)){throw new Error("makeAjaxRequest requires a success callback");}request.onreadystatechange=function(){// 4 = DONE (https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#Properties)
if(request.readyState==4){request.onreadystatechange=function(){};// With protocols other than http/https, a successful request status is in
// the 200's on Firefox and 0 on other browsers
if(request.status>=200&&request.status<300||request.status===0&&protocol!=="http:"&&protocol!=="https:"){onSuccess(request);}else{$.console.log("AJAX request returned %d: %s",request.status,url);if($.isFunction(onError)){onError(request);}}}};try{request.open("GET",url,true);if(responseType){request.responseType=responseType;}if(headers){for(var headerName in headers){if(Object.prototype.hasOwnProperty.call(headers,headerName)&&headers[headerName]){request.setRequestHeader(headerName,headers[headerName]);}}}if(withCredentials){request.withCredentials=true;}request.send(null);}catch(e){var msg=e.message;/*
                    IE < 10 does not support CORS and an XHR request to a different origin will fail as soon
                    as send() is called. This is particularly easy to miss during development and appear in
                    production if you use a CDN or domain sharding and the security policy is likely to break
                    exception handlers since any attempt to access a property of the request object will
                    raise an access denied TypeError inside the catch block.

                    To be friendlier, we'll check for this specific error and add a documentation pointer
                    to point developers in the right direction. We test the exception number because IE's
                    error messages are localized.
                */var oldIE=$.Browser.vendor==$.BROWSERS.IE&&$.Browser.version<10;if(oldIE&&typeof e.number!="undefined"&&e.number==-2147024891){msg+="\nSee http://msdn.microsoft.com/en-us/library/ms537505(v=vs.85).aspx#xdomain";}$.console.log("%s while making AJAX request: %s",e.name,msg);request.onreadystatechange=function(){};if(window.XDomainRequest){// IE9 or IE8 might as well try to use XDomainRequest
var xdr=new window.XDomainRequest();if(xdr){xdr.onload=function(e){if($.isFunction(onSuccess)){onSuccess({// Faking an xhr object
responseText:xdr.responseText,status:200,// XDomainRequest doesn't support status codes, so we just fake one! :/
statusText:'OK'});}};xdr.onerror=function(e){if($.isFunction(onError)){onError({// Faking an xhr object
responseText:xdr.responseText,status:444,// 444 No Response
statusText:'An error happened. Due to an XDomainRequest deficiency we can not extract any information about this error. Upgrade your browser.'});}};try{xdr.open('GET',url);xdr.send();}catch(e2){if($.isFunction(onError)){onError(request,e);}}}}else{if($.isFunction(onError)){onError(request,e);}}}return request;},/**
         * Taken from jQuery 1.6.1
         * @function
         * @param {Object} options
         * @param {String} options.url
         * @param {Function} options.callback
         * @param {String} [options.param='callback'] The name of the url parameter
         *      to request the jsonp provider with.
         * @param {String} [options.callbackName=] The name of the callback to
         *      request the jsonp provider with.
         */jsonp:function(options){var script,url=options.url,head=document.head||document.getElementsByTagName("head")[0]||document.documentElement,jsonpCallback=options.callbackName||'openseadragon'+$.now(),previous=window[jsonpCallback],replace="$1"+jsonpCallback+"$2",callbackParam=options.param||'callback',callback=options.callback;url=url.replace(/(\=)\?(&|$)|\?\?/i,replace);// Add callback manually
url+=(/\?/.test(url)?"&":"?")+callbackParam+"="+jsonpCallback;// Install callback
window[jsonpCallback]=function(response){if(!previous){try{delete window[jsonpCallback];}catch(e){//swallow
}}else{window[jsonpCallback]=previous;}if(callback&&$.isFunction(callback)){callback(response);}};script=document.createElement("script");//TODO: having an issue with async info requests
if(undefined!==options.async||false!==options.async){script.async="async";}if(options.scriptCharset){script.charset=options.scriptCharset;}script.src=url;// Attach handlers for all browsers
script.onload=script.onreadystatechange=function(_,isAbort){if(isAbort||!script.readyState||/loaded|complete/.test(script.readyState)){// Handle memory leak in IE
script.onload=script.onreadystatechange=null;// Remove the script
if(head&&script.parentNode){head.removeChild(script);}// Dereference the script
script=undefined;}};// Use insertBefore instead of appendChild  to circumvent an IE6 bug.
// This arises when a base node is used (#2709 and #4378).
head.insertBefore(script,head.firstChild);},/**
         * Fully deprecated. Will throw an error.
         * @function
         * @deprecated use {@link OpenSeadragon.Viewer#open}
         */createFromDZI:function(){throw"OpenSeadragon.createFromDZI is deprecated, use Viewer.open.";},/**
         * Parses an XML string into a DOM Document.
         * @function
         * @param {String} string
         * @returns {Document}
         */parseXml:function(string){if(window.DOMParser){$.parseXml=function(string){var xmlDoc=null,parser;parser=new DOMParser();xmlDoc=parser.parseFromString(string,"text/xml");return xmlDoc;};}else if(window.ActiveXObject){$.parseXml=function(string){var xmlDoc=null;xmlDoc=new ActiveXObject("Microsoft.XMLDOM");xmlDoc.async=false;xmlDoc.loadXML(string);return xmlDoc;};}else{throw new Error("Browser doesn't support XML DOM.");}return $.parseXml(string);},/**
         * Parses a JSON string into a Javascript object.
         * @function
         * @param {String} string
         * @returns {Object}
         */parseJSON:function(string){if(window.JSON&&window.JSON.parse){$.parseJSON=window.JSON.parse;}else{// Should only be used by IE8 in non standards mode
$.parseJSON=function(string){/*jshint evil:true*///eslint-disable-next-line no-eval
return eval('('+string+')');};}return $.parseJSON(string);},/**
         * Reports whether the image format is supported for tiling in this
         * version.
         * @function
         * @param {String} [extension]
         * @returns {Boolean}
         */imageFormatSupported:function(extension){extension=extension?extension:"";// eslint-disable-next-line no-use-before-define
return!!FILEFORMATS[extension.toLowerCase()];}});//TODO: $.console is often used inside a try/catch block which generally
//      prevents allowings errors to occur with detection until a debugger
//      is attached.  Although I've been guilty of the same anti-pattern
//      I eventually was convinced that errors should naturally propagate in
//      all but the most special cases.
/**
     * A convenient alias for console when available, and a simple null
     * function when console is unavailable.
     * @static
     * @private
     */var nullfunction=function(msg){//document.location.hash = msg;
};$.console=window.console||{log:nullfunction,debug:nullfunction,info:nullfunction,warn:nullfunction,error:nullfunction,assert:nullfunction};/**
     * The current browser vendor, version, and related information regarding detected features.
     * @member {Object} Browser
     * @memberof OpenSeadragon
     * @static
     * @type {Object}
     * @property {OpenSeadragon.BROWSERS} vendor - One of the {@link OpenSeadragon.BROWSERS} enumeration values.
     * @property {Number} version
     * @property {Boolean} alpha - Does the browser support image alpha transparency.
     */$.Browser={vendor:$.BROWSERS.UNKNOWN,version:0,alpha:true};var FILEFORMATS={"bmp":false,"jpeg":true,"jpg":true,"png":true,"tif":false,"wdp":false},URLPARAMS={};(function(){//A small auto-executing routine to determine the browser vendor,
//version and supporting feature sets.
var ver=navigator.appVersion,ua=navigator.userAgent,regex;//console.error( 'appName: ' + navigator.appName );
//console.error( 'appVersion: ' + navigator.appVersion );
//console.error( 'userAgent: ' + navigator.userAgent );
switch(navigator.appName){case"Microsoft Internet Explorer":if(!!window.attachEvent&&!!window.ActiveXObject){$.Browser.vendor=$.BROWSERS.IE;$.Browser.version=parseFloat(ua.substring(ua.indexOf("MSIE")+5,ua.indexOf(";",ua.indexOf("MSIE"))));}break;case"Netscape":if(window.addEventListener){if(ua.indexOf("Firefox")>=0){$.Browser.vendor=$.BROWSERS.FIREFOX;$.Browser.version=parseFloat(ua.substring(ua.indexOf("Firefox")+8));}else if(ua.indexOf("Safari")>=0){$.Browser.vendor=ua.indexOf("Chrome")>=0?$.BROWSERS.CHROME:$.BROWSERS.SAFARI;$.Browser.version=parseFloat(ua.substring(ua.substring(0,ua.indexOf("Safari")).lastIndexOf("/")+1,ua.indexOf("Safari")));}else{regex=new RegExp("Trident/.*rv:([0-9]{1,}[.0-9]{0,})");if(regex.exec(ua)!==null){$.Browser.vendor=$.BROWSERS.IE;$.Browser.version=parseFloat(RegExp.$1);}}}break;case"Opera":$.Browser.vendor=$.BROWSERS.OPERA;$.Browser.version=parseFloat(ver);break;}// ignore '?' portion of query string
var query=window.location.search.substring(1),parts=query.split('&'),part,sep,i;for(i=0;i<parts.length;i++){part=parts[i];sep=part.indexOf('=');if(sep>0){var key=part.substring(0,sep),value=part.substring(sep+1);try{URLPARAMS[key]=decodeURIComponent(value);}catch(e){$.console.error("Ignoring malformed URL parameter: %s=%s",key,value);}}}//determine if this browser supports image alpha transparency
$.Browser.alpha=!($.Browser.vendor==$.BROWSERS.IE&&$.Browser.version<9||$.Browser.vendor==$.BROWSERS.CHROME&&$.Browser.version<2);//determine if this browser supports element.style.opacity
$.Browser.opacity=!($.Browser.vendor==$.BROWSERS.IE&&$.Browser.version<9);})();// Adding support for HTML5's requestAnimationFrame as suggested by acdha.
// Implementation taken from matt synder's post here:
// http://mattsnider.com/cross-browser-and-legacy-supported-requestframeanimation/
(function(w){// most browsers have an implementation
var requestAnimationFrame=w.requestAnimationFrame||w.mozRequestAnimationFrame||w.webkitRequestAnimationFrame||w.msRequestAnimationFrame;var cancelAnimationFrame=w.cancelAnimationFrame||w.mozCancelAnimationFrame||w.webkitCancelAnimationFrame||w.msCancelAnimationFrame;// polyfill, when necessary
if(requestAnimationFrame&&cancelAnimationFrame){// We can't assign these window methods directly to $ because they
// expect their "this" to be "window", so we call them in wrappers.
$.requestAnimationFrame=function(){return requestAnimationFrame.apply(w,arguments);};$.cancelAnimationFrame=function(){return cancelAnimationFrame.apply(w,arguments);};}else{var aAnimQueue=[],processing=[],iRequestId=0,iIntervalId;// create a mock requestAnimationFrame function
$.requestAnimationFrame=function(callback){aAnimQueue.push([++iRequestId,callback]);if(!iIntervalId){iIntervalId=setInterval(function(){if(aAnimQueue.length){var time=$.now();// Process all of the currently outstanding frame
// requests, but none that get added during the
// processing.
// Swap the arrays so we don't have to create a new
// array every frame.
var temp=processing;processing=aAnimQueue;aAnimQueue=temp;while(processing.length){processing.shift()[1](time);}}else{// don't continue the interval, if unnecessary
clearInterval(iIntervalId);iIntervalId=undefined;}},1000/50);// estimating support for 50 frames per second
}return iRequestId;};// create a mock cancelAnimationFrame function
$.cancelAnimationFrame=function(requestId){// find the request ID and remove it
var i,j;for(i=0,j=aAnimQueue.length;i<j;i+=1){if(aAnimQueue[i][0]===requestId){aAnimQueue.splice(i,1);return;}}// If it's not in the queue, it may be in the set we're currently
// processing (if cancelAnimationFrame is called from within a
// requestAnimationFrame callback).
for(i=0,j=processing.length;i<j;i+=1){if(processing[i][0]===requestId){processing.splice(i,1);return;}}};}})(window);/**
     * @private
     * @inner
     * @function
     * @param {Element} element
     * @param {Boolean} [isFixed]
     * @returns {Element}
     */function getOffsetParent(element,isFixed){if(isFixed&&element!=document.body){return document.body;}else{return element.offsetParent;}}})(OpenSeadragon);// Universal Module Definition, supports CommonJS, AMD and simple script tag
(function(root,factory){if(typeof define==='function'&&define.amd){// expose as amd module
define([],factory);}else if(typeof module==='object'&&module.exports){// expose as commonjs module
module.exports=factory();}else{// expose as window.OpenSeadragon
root.OpenSeadragon=factory();}})(this,function(){return OpenSeadragon;});/*
 * OpenSeadragon - full-screen support functions
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
     * Determine native full screen support we can get from the browser.
     * @member fullScreenApi
     * @memberof OpenSeadragon
     * @type {object}
     * @property {Boolean} supportsFullScreen Return true if full screen API is supported.
     * @property {Function} isFullScreen Return true if currently in full screen mode.
     * @property {Function} getFullScreenElement Return the element currently in full screen mode.
     * @property {Function} requestFullScreen Make a request to go in full screen mode.
     * @property {Function} exitFullScreen Make a request to exit full screen mode.
     * @property {Function} cancelFullScreen Deprecated, use exitFullScreen instead.
     * @property {String} fullScreenEventName Event fired when the full screen mode change.
     * @property {String} fullScreenErrorEventName Event fired when a request to go
     * in full screen mode failed.
     */var fullScreenApi={supportsFullScreen:false,isFullScreen:function(){return false;},getFullScreenElement:function(){return null;},requestFullScreen:function(){},exitFullScreen:function(){},cancelFullScreen:function(){},fullScreenEventName:'',fullScreenErrorEventName:''};// check for native support
if(document.exitFullscreen){// W3C standard
fullScreenApi.supportsFullScreen=true;fullScreenApi.getFullScreenElement=function(){return document.fullscreenElement;};fullScreenApi.requestFullScreen=function(element){return element.requestFullscreen();};fullScreenApi.exitFullScreen=function(){document.exitFullscreen();};fullScreenApi.fullScreenEventName="fullscreenchange";fullScreenApi.fullScreenErrorEventName="fullscreenerror";}else if(document.msExitFullscreen){// IE 11
fullScreenApi.supportsFullScreen=true;fullScreenApi.getFullScreenElement=function(){return document.msFullscreenElement;};fullScreenApi.requestFullScreen=function(element){return element.msRequestFullscreen();};fullScreenApi.exitFullScreen=function(){document.msExitFullscreen();};fullScreenApi.fullScreenEventName="MSFullscreenChange";fullScreenApi.fullScreenErrorEventName="MSFullscreenError";}else if(document.webkitExitFullscreen){// Recent webkit
fullScreenApi.supportsFullScreen=true;fullScreenApi.getFullScreenElement=function(){return document.webkitFullscreenElement;};fullScreenApi.requestFullScreen=function(element){return element.webkitRequestFullscreen();};fullScreenApi.exitFullScreen=function(){document.webkitExitFullscreen();};fullScreenApi.fullScreenEventName="webkitfullscreenchange";fullScreenApi.fullScreenErrorEventName="webkitfullscreenerror";}else if(document.webkitCancelFullScreen){// Old webkit
fullScreenApi.supportsFullScreen=true;fullScreenApi.getFullScreenElement=function(){return document.webkitCurrentFullScreenElement;};fullScreenApi.requestFullScreen=function(element){return element.webkitRequestFullScreen();};fullScreenApi.exitFullScreen=function(){document.webkitCancelFullScreen();};fullScreenApi.fullScreenEventName="webkitfullscreenchange";fullScreenApi.fullScreenErrorEventName="webkitfullscreenerror";}else if(document.mozCancelFullScreen){// Firefox
fullScreenApi.supportsFullScreen=true;fullScreenApi.getFullScreenElement=function(){return document.mozFullScreenElement;};fullScreenApi.requestFullScreen=function(element){return element.mozRequestFullScreen();};fullScreenApi.exitFullScreen=function(){document.mozCancelFullScreen();};fullScreenApi.fullScreenEventName="mozfullscreenchange";fullScreenApi.fullScreenErrorEventName="mozfullscreenerror";}fullScreenApi.isFullScreen=function(){return fullScreenApi.getFullScreenElement()!==null;};fullScreenApi.cancelFullScreen=function(){$.console.error("cancelFullScreen is deprecated. Use exitFullScreen instead.");fullScreenApi.exitFullScreen();};// export api
$.extend($,fullScreenApi);})(OpenSeadragon);/*
 * OpenSeadragon - EventSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * Event handler method signature used by all OpenSeadragon events.
 *
 * @callback EventHandler
 * @memberof OpenSeadragon
 * @param {Object} event - See individual events for event-specific properties.
 *//**
 * @class EventSource
 * @classdesc For use by classes which want to support custom, non-browser events.
 *
 * @memberof OpenSeadragon
 */$.EventSource=function(){this.events={};};/** @lends OpenSeadragon.EventSource.prototype */$.EventSource.prototype={/**
     * Add an event handler to be triggered only once (or a given number of times)
     * for a given event.
     * @function
     * @param {String} eventName - Name of event to register.
     * @param {OpenSeadragon.EventHandler} handler - Function to call when event
     * is triggered.
     * @param {Object} [userData=null] - Arbitrary object to be passed unchanged
     * to the handler.
     * @param {Number} [times=1] - The number of times to handle the event
     * before removing it.
     */addOnceHandler:function(eventName,handler,userData,times){var self=this;times=times||1;var count=0;var onceHandler=function(event){count++;if(count===times){self.removeHandler(eventName,onceHandler);}handler(event);};this.addHandler(eventName,onceHandler,userData);},/**
     * Add an event handler for a given event.
     * @function
     * @param {String} eventName - Name of event to register.
     * @param {OpenSeadragon.EventHandler} handler - Function to call when event is triggered.
     * @param {Object} [userData=null] - Arbitrary object to be passed unchanged to the handler.
     */addHandler:function(eventName,handler,userData){var events=this.events[eventName];if(!events){this.events[eventName]=events=[];}if(handler&&$.isFunction(handler)){events[events.length]={handler:handler,userData:userData||null};}},/**
     * Remove a specific event handler for a given event.
     * @function
     * @param {String} eventName - Name of event for which the handler is to be removed.
     * @param {OpenSeadragon.EventHandler} handler - Function to be removed.
     */removeHandler:function(eventName,handler){var events=this.events[eventName],handlers=[],i;if(!events){return;}if($.isArray(events)){for(i=0;i<events.length;i++){if(events[i].handler!==handler){handlers.push(events[i]);}}this.events[eventName]=handlers;}},/**
     * Remove all event handlers for a given event type. If no type is given all
     * event handlers for every event type are removed.
     * @function
     * @param {String} eventName - Name of event for which all handlers are to be removed.
     */removeAllHandlers:function(eventName){if(eventName){this.events[eventName]=[];}else{for(var eventType in this.events){this.events[eventType]=[];}}},/**
     * Get a function which iterates the list of all handlers registered for a given event, calling the handler for each.
     * @function
     * @param {String} eventName - Name of event to get handlers for.
     */getHandler:function(eventName){var events=this.events[eventName];if(!events||!events.length){return null;}events=events.length===1?[events[0]]:Array.apply(null,events);return function(source,args){var i,length=events.length;for(i=0;i<length;i++){if(events[i]){args.eventSource=source;args.userData=events[i].userData;events[i].handler(args);}}};},/**
     * Trigger an event, optionally passing additional information.
     * @function
     * @param {String} eventName - Name of event to register.
     * @param {Object} eventArgs - Event-specific data.
     */raiseEvent:function(eventName,eventArgs){//uncomment if you want to get a log of all events
//$.console.log( eventName );
var handler=this.getHandler(eventName);if(handler){if(!eventArgs){eventArgs={};}handler(this,eventArgs);}}};})(OpenSeadragon);/*
 * OpenSeadragon - MouseTracker
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){// All MouseTracker instances
var MOUSETRACKERS=[];// dictionary from hash to private properties
var THIS={};/**
     * @class MouseTracker
     * @classdesc Provides simplified handling of common pointer device (mouse, touch, pen, etc.) gestures
     *            and keyboard events on a specified element.
     * @memberof OpenSeadragon
     * @param {Object} options
     *      Allows configurable properties to be entirely specified by passing
     *      an options object to the constructor.  The constructor also supports
     *      the original positional arguments 'element', 'clickTimeThreshold',
     *      and 'clickDistThreshold' in that order.
     * @param {Element|String} options.element
     *      A reference to an element or an element id for which the pointer/key
     *      events will be monitored.
     * @param {Boolean} [options.startDisabled=false]
     *      If true, event tracking on the element will not start until
     *      {@link OpenSeadragon.MouseTracker.setTracking|setTracking} is called.
     * @param {Number} options.clickTimeThreshold
     *      The number of milliseconds within which a pointer down-up event combination
     *      will be treated as a click gesture.
     * @param {Number} options.clickDistThreshold
     *      The maximum distance allowed between a pointer down event and a pointer up event
     *      to be treated as a click gesture.
     * @param {Number} options.dblClickTimeThreshold
     *      The number of milliseconds within which two pointer down-up event combinations
     *      will be treated as a double-click gesture.
     * @param {Number} options.dblClickDistThreshold
     *      The maximum distance allowed between two pointer click events
     *      to be treated as a click gesture.
     * @param {Number} [options.stopDelay=50]
     *      The number of milliseconds without pointer move before the stop
     *      event is fired.
     * @param {OpenSeadragon.EventHandler} [options.enterHandler=null]
     *      An optional handler for pointer enter.
     * @param {OpenSeadragon.EventHandler} [options.exitHandler=null]
     *      An optional handler for pointer exit.
     * @param {OpenSeadragon.EventHandler} [options.pressHandler=null]
     *      An optional handler for pointer press.
     * @param {OpenSeadragon.EventHandler} [options.nonPrimaryPressHandler=null]
     *      An optional handler for pointer non-primary button press.
     * @param {OpenSeadragon.EventHandler} [options.releaseHandler=null]
     *      An optional handler for pointer release.
     * @param {OpenSeadragon.EventHandler} [options.nonPrimaryReleaseHandler=null]
     *      An optional handler for pointer non-primary button release.
     * @param {OpenSeadragon.EventHandler} [options.moveHandler=null]
     *      An optional handler for pointer move.
     * @param {OpenSeadragon.EventHandler} [options.scrollHandler=null]
     *      An optional handler for mouse wheel scroll.
     * @param {OpenSeadragon.EventHandler} [options.clickHandler=null]
     *      An optional handler for pointer click.
     * @param {OpenSeadragon.EventHandler} [options.dblClickHandler=null]
     *      An optional handler for pointer double-click.
     * @param {OpenSeadragon.EventHandler} [options.dragHandler=null]
     *      An optional handler for the drag gesture.
     * @param {OpenSeadragon.EventHandler} [options.dragEndHandler=null]
     *      An optional handler for after a drag gesture.
     * @param {OpenSeadragon.EventHandler} [options.pinchHandler=null]
     *      An optional handler for the pinch gesture.
     * @param {OpenSeadragon.EventHandler} [options.keyDownHandler=null]
     *      An optional handler for keydown.
     * @param {OpenSeadragon.EventHandler} [options.keyUpHandler=null]
     *      An optional handler for keyup.
     * @param {OpenSeadragon.EventHandler} [options.keyHandler=null]
     *      An optional handler for keypress.
     * @param {OpenSeadragon.EventHandler} [options.focusHandler=null]
     *      An optional handler for focus.
     * @param {OpenSeadragon.EventHandler} [options.blurHandler=null]
     *      An optional handler for blur.
     * @param {Object} [options.userData=null]
     *      Arbitrary object to be passed unchanged to any attached handler methods.
     */$.MouseTracker=function(options){MOUSETRACKERS.push(this);var args=arguments;if(!$.isPlainObject(options)){options={element:args[0],clickTimeThreshold:args[1],clickDistThreshold:args[2]};}this.hash=Math.random();// An unique hash for this tracker.
/**
         * The element for which pointer events are being monitored.
         * @member {Element} element
         * @memberof OpenSeadragon.MouseTracker#
         */this.element=$.getElement(options.element);/**
         * The number of milliseconds within which a pointer down-up event combination
         * will be treated as a click gesture.
         * @member {Number} clickTimeThreshold
         * @memberof OpenSeadragon.MouseTracker#
         */this.clickTimeThreshold=options.clickTimeThreshold||$.DEFAULT_SETTINGS.clickTimeThreshold;/**
         * The maximum distance allowed between a pointer down event and a pointer up event
         * to be treated as a click gesture.
         * @member {Number} clickDistThreshold
         * @memberof OpenSeadragon.MouseTracker#
         */this.clickDistThreshold=options.clickDistThreshold||$.DEFAULT_SETTINGS.clickDistThreshold;/**
         * The number of milliseconds within which two pointer down-up event combinations
         * will be treated as a double-click gesture.
         * @member {Number} dblClickTimeThreshold
         * @memberof OpenSeadragon.MouseTracker#
         */this.dblClickTimeThreshold=options.dblClickTimeThreshold||$.DEFAULT_SETTINGS.dblClickTimeThreshold;/**
         * The maximum distance allowed between two pointer click events
         * to be treated as a click gesture.
         * @member {Number} clickDistThreshold
         * @memberof OpenSeadragon.MouseTracker#
         */this.dblClickDistThreshold=options.dblClickDistThreshold||$.DEFAULT_SETTINGS.dblClickDistThreshold;/*eslint-disable no-multi-spaces*/this.userData=options.userData||null;this.stopDelay=options.stopDelay||50;this.enterHandler=options.enterHandler||null;this.exitHandler=options.exitHandler||null;this.pressHandler=options.pressHandler||null;this.nonPrimaryPressHandler=options.nonPrimaryPressHandler||null;this.releaseHandler=options.releaseHandler||null;this.nonPrimaryReleaseHandler=options.nonPrimaryReleaseHandler||null;this.moveHandler=options.moveHandler||null;this.scrollHandler=options.scrollHandler||null;this.clickHandler=options.clickHandler||null;this.dblClickHandler=options.dblClickHandler||null;this.dragHandler=options.dragHandler||null;this.dragEndHandler=options.dragEndHandler||null;this.pinchHandler=options.pinchHandler||null;this.stopHandler=options.stopHandler||null;this.keyDownHandler=options.keyDownHandler||null;this.keyUpHandler=options.keyUpHandler||null;this.keyHandler=options.keyHandler||null;this.focusHandler=options.focusHandler||null;this.blurHandler=options.blurHandler||null;/*eslint-enable no-multi-spaces*///Store private properties in a scope sealed hash map
var _this=this;/**
         * @private
         * @property {Boolean} tracking
         *      Are we currently tracking pointer events for this element.
         */THIS[this.hash]={click:function(event){onClick(_this,event);},dblclick:function(event){onDblClick(_this,event);},keydown:function(event){onKeyDown(_this,event);},keyup:function(event){onKeyUp(_this,event);},keypress:function(event){onKeyPress(_this,event);},focus:function(event){onFocus(_this,event);},blur:function(event){onBlur(_this,event);},wheel:function(event){onWheel(_this,event);},mousewheel:function(event){onMouseWheel(_this,event);},DOMMouseScroll:function(event){onMouseWheel(_this,event);},MozMousePixelScroll:function(event){onMouseWheel(_this,event);},mouseenter:function(event){onMouseEnter(_this,event);},// Used on IE8 only
mouseleave:function(event){onMouseLeave(_this,event);},// Used on IE8 only
mouseover:function(event){onMouseOver(_this,event);},mouseout:function(event){onMouseOut(_this,event);},mousedown:function(event){onMouseDown(_this,event);},mouseup:function(event){onMouseUp(_this,event);},mouseupcaptured:function(event){onMouseUpCaptured(_this,event);},mousemove:function(event){onMouseMove(_this,event);},mousemovecaptured:function(event){onMouseMoveCaptured(_this,event);},touchstart:function(event){onTouchStart(_this,event);},touchend:function(event){onTouchEnd(_this,event);},touchendcaptured:function(event){onTouchEndCaptured(_this,event);},touchmove:function(event){onTouchMove(_this,event);},touchmovecaptured:function(event){onTouchMoveCaptured(_this,event);},touchcancel:function(event){onTouchCancel(_this,event);},gesturestart:function(event){onGestureStart(_this,event);},gesturechange:function(event){onGestureChange(_this,event);},pointerover:function(event){onPointerOver(_this,event);},MSPointerOver:function(event){onPointerOver(_this,event);},pointerout:function(event){onPointerOut(_this,event);},MSPointerOut:function(event){onPointerOut(_this,event);},pointerdown:function(event){onPointerDown(_this,event);},MSPointerDown:function(event){onPointerDown(_this,event);},pointerup:function(event){onPointerUp(_this,event);},MSPointerUp:function(event){onPointerUp(_this,event);},pointermove:function(event){onPointerMove(_this,event);},MSPointerMove:function(event){onPointerMove(_this,event);},pointercancel:function(event){onPointerCancel(_this,event);},MSPointerCancel:function(event){onPointerCancel(_this,event);},pointerupcaptured:function(event){onPointerUpCaptured(_this,event);},pointermovecaptured:function(event){onPointerMoveCaptured(_this,event);},tracking:false,// Active pointers lists. Array of GesturePointList objects, one for each pointer device type.
// GesturePointList objects are added each time a pointer is tracked by a new pointer device type (see getActivePointersListByType()).
// Active pointers are any pointer being tracked for this element which are in the hit-test area
//     of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
activePointersLists:[],// Tracking for double-click gesture
lastClickPos:null,dblClickTimeOut:null,// Tracking for pinch gesture
pinchGPoints:[],lastPinchDist:0,currentPinchDist:0,lastPinchCenter:null,currentPinchCenter:null};if(!options.startDisabled){this.setTracking(true);}};/** @lends OpenSeadragon.MouseTracker.prototype */$.MouseTracker.prototype={/**
         * Clean up any events or objects created by the tracker.
         * @function
         */destroy:function(){var i;stopTracking(this);this.element=null;for(i=0;i<MOUSETRACKERS.length;i++){if(MOUSETRACKERS[i]===this){MOUSETRACKERS.splice(i,1);break;}}THIS[this.hash]=null;delete THIS[this.hash];},/**
         * Are we currently tracking events on this element.
         * @deprecated Just use this.tracking
         * @function
         * @returns {Boolean} Are we currently tracking events on this element.
         */isTracking:function(){return THIS[this.hash].tracking;},/**
         * Enable or disable whether or not we are tracking events on this element.
         * @function
         * @param {Boolean} track True to start tracking, false to stop tracking.
         * @returns {OpenSeadragon.MouseTracker} Chainable.
         */setTracking:function(track){if(track){startTracking(this);}else{stopTracking(this);}//chain
return this;},/**
         * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for all but the given pointer device type.
         * @function
         * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
         * @returns {Array.<OpenSeadragon.MouseTracker.GesturePointList>}
         */getActivePointersListsExceptType:function(type){var delegate=THIS[this.hash];var listArray=[];for(var i=0;i<delegate.activePointersLists.length;++i){if(delegate.activePointersLists[i].type!==type){listArray.push(delegate.activePointersLists[i]);}}return listArray;},/**
         * Returns the {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} for the given pointer device type,
         * creating and caching a new {@link OpenSeadragon.MouseTracker.GesturePointList|GesturePointList} if one doesn't already exist for the type.
         * @function
         * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
         * @returns {OpenSeadragon.MouseTracker.GesturePointList}
         */getActivePointersListByType:function(type){var delegate=THIS[this.hash],i,len=delegate.activePointersLists.length,list;for(i=0;i<len;i++){if(delegate.activePointersLists[i].type===type){return delegate.activePointersLists[i];}}list=new $.MouseTracker.GesturePointList(type);delegate.activePointersLists.push(list);return list;},/**
         * Returns the total number of pointers currently active on the tracked element.
         * @function
         * @returns {Number}
         */getActivePointerCount:function(){var delegate=THIS[this.hash],i,len=delegate.activePointersLists.length,count=0;for(i=0;i<len;i++){count+=delegate.activePointersLists[i].getLength();}return count;},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Number} event.pointers
         *      Number of pointers (all types) active in the tracked element.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.buttonDownAny
         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */enterHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Number} event.pointers
         *      Number of pointers (all types) active in the tracked element.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.buttonDownAny
         *      Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */exitHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */pressHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.button
         *      Button which caused the event.
         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */nonPrimaryPressHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.insideElementPressed
         *      True if the left mouse button is currently being pressed and was
         *      initiated inside the tracked element, otherwise false.
         * @param {Boolean} event.insideElementReleased
         *      True if the cursor inside the tracked element when the button was released.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */releaseHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.button
         *      Button which caused the event.
         *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */nonPrimaryReleaseHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */moveHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.scroll
         *      The scroll delta for the event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead. Touch devices no longer generate scroll event.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */scrollHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Boolean} event.quick
         *      True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for ignoring drag events.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */clickHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */dblClickHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {OpenSeadragon.Point} event.delta
         *      The x,y components of the difference between the current position and the last drag event position.  Useful for ignoring or weighting the events.
         * @param {Number} event.speed
         *     Current computed speed, in pixels per second.
         * @param {Number} event.direction
         *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */dragHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.speed
         *     Speed at the end of a drag gesture, in pixels per second.
         * @param {Number} event.direction
         *     Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */dragEndHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} event.gesturePoints
         *      Gesture points associated with the gesture. Velocity data can be found here.
         * @param {OpenSeadragon.Point} event.lastCenter
         *      The previous center point of the two pinch contact points relative to the tracked element.
         * @param {OpenSeadragon.Point} event.center
         *      The center point of the two pinch contact points relative to the tracked element.
         * @param {Number} event.lastDistance
         *      The previous distance between the two pinch contact points in CSS pixels.
         * @param {Number} event.distance
         *      The distance between the two pinch contact points in CSS pixels.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */pinchHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {String} event.pointerType
         *     "mouse", "touch", "pen", etc.
         * @param {OpenSeadragon.Point} event.position
         *      The position of the event relative to the tracked element.
         * @param {Number} event.buttons
         *      Current buttons pressed.
         *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @param {Boolean} event.isTouchEvent
         *      True if the original event is a touch event, otherwise false. <span style="color:red;">Deprecated. Use pointerType and/or originalEvent instead.</span>
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */stopHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Number} event.keyCode
         *      The key code that was pressed.
         * @param {Boolean} event.ctrl
         *      True if the ctrl key was pressed during this event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.alt
         *      True if the alt key was pressed during this event.
         * @param {Boolean} event.meta
         *      True if the meta key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */keyDownHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Number} event.keyCode
         *      The key code that was pressed.
         * @param {Boolean} event.ctrl
         *      True if the ctrl key was pressed during this event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.alt
         *      True if the alt key was pressed during this event.
         * @param {Boolean} event.meta
         *      True if the meta key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */keyUpHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Number} event.keyCode
         *      The key code that was pressed.
         * @param {Boolean} event.ctrl
         *      True if the ctrl key was pressed during this event.
         * @param {Boolean} event.shift
         *      True if the shift key was pressed during this event.
         * @param {Boolean} event.alt
         *      True if the alt key was pressed during this event.
         * @param {Boolean} event.meta
         *      True if the meta key was pressed during this event.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */keyHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */focusHandler:function(){},/**
         * Implement or assign implementation to these handlers during or after
         * calling the constructor.
         * @function
         * @param {Object} event
         * @param {OpenSeadragon.MouseTracker} event.eventSource
         *      A reference to the tracker instance.
         * @param {Object} event.originalEvent
         *      The original event object.
         * @param {Boolean} event.preventDefaultAction
         *      Set to true to prevent the tracker subscriber from performing its default action (subscriber implementation dependent). Default: false.
         * @param {Object} event.userData
         *      Arbitrary user-defined object.
         */blurHandler:function(){}};/**
     * Resets all active mousetrakers. (Added to patch issue #697 "Mouse up outside map will cause "canvas-drag" event to stick")
     *
     * @private
     * @member resetAllMouseTrackers
     * @memberof OpenSeadragon.MouseTracker
     */$.MouseTracker.resetAllMouseTrackers=function(){for(var i=0;i<MOUSETRACKERS.length;i++){if(MOUSETRACKERS[i].isTracking()){MOUSETRACKERS[i].setTracking(false);MOUSETRACKERS[i].setTracking(true);}}};/**
     * Provides continuous computation of velocity (speed and direction) of active pointers.
     * This is a singleton, used by all MouseTracker instances, as it is unlikely there will ever be more than
     * two active gesture pointers at a time.
     *
     * @private
     * @member gesturePointVelocityTracker
     * @memberof OpenSeadragon.MouseTracker
     */$.MouseTracker.gesturePointVelocityTracker=function(){var trackerPoints=[],intervalId=0,lastTime=0;// Generates a unique identifier for a tracked gesture point
var _generateGuid=function(tracker,gPoint){return tracker.hash.toString()+gPoint.type+gPoint.id.toString();};// Interval timer callback. Computes velocity for all tracked gesture points.
var _doTracking=function(){var i,len=trackerPoints.length,trackPoint,gPoint,now=$.now(),elapsedTime,distance,speed;elapsedTime=now-lastTime;lastTime=now;for(i=0;i<len;i++){trackPoint=trackerPoints[i];gPoint=trackPoint.gPoint;// Math.atan2 gives us just what we need for a velocity vector, as we can simply
//   use cos()/sin() to extract the x/y velocity components.
gPoint.direction=Math.atan2(gPoint.currentPos.y-trackPoint.lastPos.y,gPoint.currentPos.x-trackPoint.lastPos.x);// speed = distance / elapsed time
distance=trackPoint.lastPos.distanceTo(gPoint.currentPos);trackPoint.lastPos=gPoint.currentPos;speed=1000*distance/(elapsedTime+1);// Simple biased average, favors the most recent speed computation. Smooths out erratic gestures a bit.
gPoint.speed=0.75*speed+0.25*gPoint.speed;}};// Public. Add a gesture point to be tracked
var addPoint=function(tracker,gPoint){var guid=_generateGuid(tracker,gPoint);trackerPoints.push({guid:guid,gPoint:gPoint,lastPos:gPoint.currentPos});// Only fire up the interval timer when there's gesture pointers to track
if(trackerPoints.length===1){lastTime=$.now();intervalId=window.setInterval(_doTracking,50);}};// Public. Stop tracking a gesture point
var removePoint=function(tracker,gPoint){var guid=_generateGuid(tracker,gPoint),i,len=trackerPoints.length;for(i=0;i<len;i++){if(trackerPoints[i].guid===guid){trackerPoints.splice(i,1);// Only run the interval timer if theres gesture pointers to track
len--;if(len===0){window.clearInterval(intervalId);}break;}}};return{addPoint:addPoint,removePoint:removePoint};}();///////////////////////////////////////////////////////////////////////////////
// Pointer event model and feature detection
///////////////////////////////////////////////////////////////////////////////
$.MouseTracker.captureElement=document;/**
     * Detect available mouse wheel event name.
     */$.MouseTracker.wheelEventName=$.Browser.vendor==$.BROWSERS.IE&&$.Browser.version>8||'onwheel'in document.createElement('div')?'wheel':// Modern browsers support 'wheel'
document.onmousewheel!==undefined?'mousewheel':// Webkit and IE support at least 'mousewheel'
'DOMMouseScroll';// Assume old Firefox
/**
     * Detect legacy mouse capture support.
     */$.MouseTracker.supportsMouseCapture=function(){var divElement=document.createElement('div');return $.isFunction(divElement.setCapture)&&$.isFunction(divElement.releaseCapture);}();/**
     * Detect browser pointer device event model(s) and build appropriate list of events to subscribe to.
     */$.MouseTracker.subscribeEvents=["click","dblclick","keydown","keyup","keypress","focus","blur",$.MouseTracker.wheelEventName];if($.MouseTracker.wheelEventName=="DOMMouseScroll"){// Older Firefox
$.MouseTracker.subscribeEvents.push("MozMousePixelScroll");}// Note: window.navigator.pointerEnable is deprecated on IE 11 and not part of W3C spec.
if(window.PointerEvent&&(window.navigator.pointerEnabled||$.Browser.vendor!==$.BROWSERS.IE)){// IE11 and other W3C Pointer Event implementations (see http://www.w3.org/TR/pointerevents)
$.MouseTracker.havePointerEvents=true;$.MouseTracker.subscribeEvents.push("pointerover","pointerout","pointerdown","pointerup","pointermove","pointercancel");$.MouseTracker.unprefixedPointerEvents=true;if(navigator.maxTouchPoints){$.MouseTracker.maxTouchPoints=navigator.maxTouchPoints;}else{$.MouseTracker.maxTouchPoints=0;}$.MouseTracker.haveMouseEnter=false;}else if(window.MSPointerEvent&&window.navigator.msPointerEnabled){// IE10
$.MouseTracker.havePointerEvents=true;$.MouseTracker.subscribeEvents.push("MSPointerOver","MSPointerOut","MSPointerDown","MSPointerUp","MSPointerMove","MSPointerCancel");$.MouseTracker.unprefixedPointerEvents=false;if(navigator.msMaxTouchPoints){$.MouseTracker.maxTouchPoints=navigator.msMaxTouchPoints;}else{$.MouseTracker.maxTouchPoints=0;}$.MouseTracker.haveMouseEnter=false;}else{// Legacy W3C mouse events
$.MouseTracker.havePointerEvents=false;if($.Browser.vendor===$.BROWSERS.IE&&$.Browser.version<9){$.MouseTracker.subscribeEvents.push("mouseenter","mouseleave");$.MouseTracker.haveMouseEnter=true;}else{$.MouseTracker.subscribeEvents.push("mouseover","mouseout");$.MouseTracker.haveMouseEnter=false;}$.MouseTracker.subscribeEvents.push("mousedown","mouseup","mousemove");if('ontouchstart'in window){// iOS, Android, and other W3c Touch Event implementations
//    (see http://www.w3.org/TR/touch-events/)
//    (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
//    (see https://developer.apple.com/library/safari/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
$.MouseTracker.subscribeEvents.push("touchstart","touchend","touchmove","touchcancel");}if('ongesturestart'in window){// iOS (see https://developer.apple.com/library/ios/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html)
//   Subscribe to these to prevent default gesture handling
$.MouseTracker.subscribeEvents.push("gesturestart","gesturechange");}$.MouseTracker.mousePointerId="legacy-mouse";$.MouseTracker.maxTouchPoints=10;}///////////////////////////////////////////////////////////////////////////////
// Classes and typedefs
///////////////////////////////////////////////////////////////////////////////
/**
     * Represents a point of contact on the screen made by a mouse cursor, pen, touch, or other pointer device.
     *
     * @typedef {Object} GesturePoint
     * @memberof OpenSeadragon.MouseTracker
     *
     * @property {Number} id
     *     Identifier unique from all other active GesturePoints for a given pointer device.
     * @property {String} type
     *     The pointer device type: "mouse", "touch", "pen", etc.
     * @property {Boolean} captured
     *     True if events for the gesture point are captured to the tracked element.
     * @property {Boolean} isPrimary
     *     True if the gesture point is a master pointer amongst the set of active pointers for each pointer type. True for mouse and primary (first) touch/pen pointers.
     * @property {Boolean} insideElementPressed
     *     True if button pressed or contact point initiated inside the screen area of the tracked element.
     * @property {Boolean} insideElement
     *     True if pointer or contact point is currently inside the bounds of the tracked element.
     * @property {Number} speed
     *     Current computed speed, in pixels per second.
     * @property {Number} direction
     *     Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
     * @property {OpenSeadragon.Point} contactPos
     *     The initial pointer contact position, relative to the page including any scrolling. Only valid if the pointer has contact (pressed, touch contact, pen contact).
     * @property {Number} contactTime
     *     The initial pointer contact time, in milliseconds. Only valid if the pointer has contact (pressed, touch contact, pen contact).
     * @property {OpenSeadragon.Point} lastPos
     *     The last pointer position, relative to the page including any scrolling.
     * @property {Number} lastTime
     *     The last pointer contact time, in milliseconds.
     * @property {OpenSeadragon.Point} currentPos
     *     The current pointer position, relative to the page including any scrolling.
     * @property {Number} currentTime
     *     The current pointer contact time, in milliseconds.
     *//**
     * @class GesturePointList
     * @classdesc Provides an abstraction for a set of active {@link OpenSeadragon.MouseTracker.GesturePoint|GesturePoint} objects for a given pointer device type.
     *            Active pointers are any pointer being tracked for this element which are in the hit-test area
     *            of the element (for hover-capable devices) and/or have contact or a button press initiated in the element.
     * @memberof OpenSeadragon.MouseTracker
     * @param {String} type - The pointer device type: "mouse", "touch", "pen", etc.
     */$.MouseTracker.GesturePointList=function(type){this._gPoints=[];/**
         * The pointer device type: "mouse", "touch", "pen", etc.
         * @member {String} type
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */this.type=type;/**
         * Current buttons pressed for the device.
         * Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
         * @member {Number} buttons
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */this.buttons=0;/**
         * Current number of contact points (touch points, mouse down, etc.) for the device.
         * @member {Number} contacts
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */this.contacts=0;/**
         * Current number of clicks for the device. Used for multiple click gesture tracking.
         * @member {Number} clicks
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */this.clicks=0;/**
         * Current number of captured pointers for the device.
         * @member {Number} captureCount
         * @memberof OpenSeadragon.MouseTracker.GesturePointList#
         */this.captureCount=0;};/** @lends OpenSeadragon.MouseTracker.GesturePointList.prototype */$.MouseTracker.GesturePointList.prototype={/**
         * @function
         * @returns {Number} Number of gesture points in the list.
         */getLength:function(){return this._gPoints.length;},/**
         * @function
         * @returns {Array.<OpenSeadragon.MouseTracker.GesturePoint>} The list of gesture points in the list as an array (read-only).
         */asArray:function(){return this._gPoints;},/**
         * @function
         * @param {OpenSeadragon.MouseTracker.GesturePoint} gesturePoint - A gesture point to add to the list.
         * @returns {Number} Number of gesture points in the list.
         */add:function(gp){return this._gPoints.push(gp);},/**
         * @function
         * @param {Number} id - The id of the gesture point to remove from the list.
         * @returns {Number} Number of gesture points in the list.
         */removeById:function(id){var i,len=this._gPoints.length;for(i=0;i<len;i++){if(this._gPoints[i].id===id){this._gPoints.splice(i,1);break;}}return this._gPoints.length;},/**
         * @function
         * @param {Number} index - The index of the gesture point to retrieve from the list.
         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point at the given index, or null if not found.
         */getByIndex:function(index){if(index<this._gPoints.length){return this._gPoints[index];}return null;},/**
         * @function
         * @param {Number} id - The id of the gesture point to retrieve from the list.
         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The gesture point with the given id, or null if not found.
         */getById:function(id){var i,len=this._gPoints.length;for(i=0;i<len;i++){if(this._gPoints[i].id===id){return this._gPoints[i];}}return null;},/**
         * @function
         * @returns {OpenSeadragon.MouseTracker.GesturePoint|null} The primary gesture point in the list, or null if not found.
         */getPrimary:function(id){var i,len=this._gPoints.length;for(i=0;i<len;i++){if(this._gPoints[i].isPrimary){return this._gPoints[i];}}return null;},/**
         * Increment this pointer's contact count.
         * It will evaluate whether this pointer type is allowed to have multiple contacts.
         * @function
         */addContact:function(){++this.contacts;if(this.contacts>1&&(this.type==="mouse"||this.type==="pen")){this.contacts=1;}},/**
         * Decrement this pointer's contact count.
         * It will make sure the count does not go below 0.
         * @function
         */removeContact:function(){--this.contacts;if(this.contacts<0){this.contacts=0;}}};///////////////////////////////////////////////////////////////////////////////
// Utility functions
///////////////////////////////////////////////////////////////////////////////
/**
     * Removes all tracked pointers.
     * @private
     * @inner
     */function clearTrackedPointers(tracker){var delegate=THIS[tracker.hash],i,pointerListCount=delegate.activePointersLists.length;for(i=0;i<pointerListCount;i++){if(delegate.activePointersLists[i].captureCount>0){$.removeEvent($.MouseTracker.captureElement,'mousemove',delegate.mousemovecaptured,true);$.removeEvent($.MouseTracker.captureElement,'mouseup',delegate.mouseupcaptured,true);$.removeEvent($.MouseTracker.captureElement,$.MouseTracker.unprefixedPointerEvents?'pointermove':'MSPointerMove',delegate.pointermovecaptured,true);$.removeEvent($.MouseTracker.captureElement,$.MouseTracker.unprefixedPointerEvents?'pointerup':'MSPointerUp',delegate.pointerupcaptured,true);$.removeEvent($.MouseTracker.captureElement,'touchmove',delegate.touchmovecaptured,true);$.removeEvent($.MouseTracker.captureElement,'touchend',delegate.touchendcaptured,true);delegate.activePointersLists[i].captureCount=0;}}for(i=0;i<pointerListCount;i++){delegate.activePointersLists.pop();}}/**
     * Starts tracking pointer events on the tracked element.
     * @private
     * @inner
     */function startTracking(tracker){var delegate=THIS[tracker.hash],event,i;if(!delegate.tracking){for(i=0;i<$.MouseTracker.subscribeEvents.length;i++){event=$.MouseTracker.subscribeEvents[i];$.addEvent(tracker.element,event,delegate[event],false);}clearTrackedPointers(tracker);delegate.tracking=true;}}/**
     * Stops tracking pointer events on the tracked element.
     * @private
     * @inner
     */function stopTracking(tracker){var delegate=THIS[tracker.hash],event,i;if(delegate.tracking){for(i=0;i<$.MouseTracker.subscribeEvents.length;i++){event=$.MouseTracker.subscribeEvents[i];$.removeEvent(tracker.element,event,delegate[event],false);}clearTrackedPointers(tracker);delegate.tracking=false;}}/**
     * @private
     * @inner
     */function getCaptureEventParams(tracker,pointerType){var delegate=THIS[tracker.hash];if(pointerType==='pointerevent'){return{upName:$.MouseTracker.unprefixedPointerEvents?'pointerup':'MSPointerUp',upHandler:delegate.pointerupcaptured,moveName:$.MouseTracker.unprefixedPointerEvents?'pointermove':'MSPointerMove',moveHandler:delegate.pointermovecaptured};}else if(pointerType==='mouse'){return{upName:'mouseup',upHandler:delegate.mouseupcaptured,moveName:'mousemove',moveHandler:delegate.mousemovecaptured};}else if(pointerType==='touch'){return{upName:'touchend',upHandler:delegate.touchendcaptured,moveName:'touchmove',moveHandler:delegate.touchmovecaptured};}else{throw new Error("MouseTracker.getCaptureEventParams: Unknown pointer type.");}}/**
     * Begin capturing pointer events to the tracked element.
     * @private
     * @inner
     */function capturePointer(tracker,pointerType,pointerCount){var pointsList=tracker.getActivePointersListByType(pointerType),eventParams;pointsList.captureCount+=pointerCount||1;if(pointsList.captureCount===1){if($.Browser.vendor===$.BROWSERS.IE&&$.Browser.version<9){tracker.element.setCapture(true);}else{eventParams=getCaptureEventParams(tracker,$.MouseTracker.havePointerEvents?'pointerevent':pointerType);// We emulate mouse capture by hanging listeners on the document object.
//    (Note we listen on the capture phase so the captured handlers will get called first)
// eslint-disable-next-line no-use-before-define
if(isInIframe&&canAccessEvents(window.top)){$.addEvent(window.top,eventParams.upName,eventParams.upHandler,true);}$.addEvent($.MouseTracker.captureElement,eventParams.upName,eventParams.upHandler,true);$.addEvent($.MouseTracker.captureElement,eventParams.moveName,eventParams.moveHandler,true);}}}/**
     * Stop capturing pointer events to the tracked element.
     * @private
     * @inner
     */function releasePointer(tracker,pointerType,pointerCount){var pointsList=tracker.getActivePointersListByType(pointerType),eventParams;pointsList.captureCount-=pointerCount||1;if(pointsList.captureCount===0){if($.Browser.vendor===$.BROWSERS.IE&&$.Browser.version<9){tracker.element.releaseCapture();}else{eventParams=getCaptureEventParams(tracker,$.MouseTracker.havePointerEvents?'pointerevent':pointerType);// We emulate mouse capture by hanging listeners on the document object.
//    (Note we listen on the capture phase so the captured handlers will get called first)
// eslint-disable-next-line no-use-before-define
if(isInIframe&&canAccessEvents(window.top)){$.removeEvent(window.top,eventParams.upName,eventParams.upHandler,true);}$.removeEvent($.MouseTracker.captureElement,eventParams.moveName,eventParams.moveHandler,true);$.removeEvent($.MouseTracker.captureElement,eventParams.upName,eventParams.upHandler,true);}}}/**
     * Gets a W3C Pointer Events model compatible pointer type string from a DOM pointer event.
     * IE10 used a long integer value, but the W3C specification (and IE11+) use a string "mouse", "touch", "pen", etc.
     * @private
     * @inner
     */function getPointerType(event){var pointerTypeStr;if($.MouseTracker.unprefixedPointerEvents){pointerTypeStr=event.pointerType;}else{// IE10
//  MSPOINTER_TYPE_TOUCH: 0x00000002
//  MSPOINTER_TYPE_PEN:   0x00000003
//  MSPOINTER_TYPE_MOUSE: 0x00000004
switch(event.pointerType){case 0x00000002:pointerTypeStr='touch';break;case 0x00000003:pointerTypeStr='pen';break;case 0x00000004:pointerTypeStr='mouse';break;default:pointerTypeStr='';}}return pointerTypeStr;}/**
     * @private
     * @inner
     */function getMouseAbsolute(event){return $.getMousePosition(event);}/**
     * @private
     * @inner
     */function getMouseRelative(event,element){return getPointRelativeToAbsolute(getMouseAbsolute(event),element);}/**
     * @private
     * @inner
     */function getPointRelativeToAbsolute(point,element){var offset=$.getElementOffset(element);return point.minus(offset);}/**
     * @private
     * @inner
     */function getCenterPoint(point1,point2){return new $.Point((point1.x+point2.x)/2,(point1.y+point2.y)/2);}///////////////////////////////////////////////////////////////////////////////
// Device-specific DOM event handlers
///////////////////////////////////////////////////////////////////////////////
/**
     * @private
     * @inner
     */function onClick(tracker,event){if(tracker.clickHandler){$.cancelEvent(event);}}/**
     * @private
     * @inner
     */function onDblClick(tracker,event){if(tracker.dblClickHandler){$.cancelEvent(event);}}/**
     * @private
     * @inner
     */function onKeyDown(tracker,event){//$.console.log( "keydown %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
var propagate;if(tracker.keyDownHandler){event=$.getEvent(event);propagate=tracker.keyDownHandler({eventSource:tracker,keyCode:event.keyCode?event.keyCode:event.charCode,ctrl:event.ctrlKey,shift:event.shiftKey,alt:event.altKey,meta:event.metaKey,originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(!propagate){$.cancelEvent(event);}}}/**
     * @private
     * @inner
     */function onKeyUp(tracker,event){//$.console.log( "keyup %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
var propagate;if(tracker.keyUpHandler){event=$.getEvent(event);propagate=tracker.keyUpHandler({eventSource:tracker,keyCode:event.keyCode?event.keyCode:event.charCode,ctrl:event.ctrlKey,shift:event.shiftKey,alt:event.altKey,meta:event.metaKey,originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(!propagate){$.cancelEvent(event);}}}/**
     * @private
     * @inner
     */function onKeyPress(tracker,event){//$.console.log( "keypress %s %s %s %s %s", event.keyCode, event.charCode, event.ctrlKey, event.shiftKey, event.altKey );
var propagate;if(tracker.keyHandler){event=$.getEvent(event);propagate=tracker.keyHandler({eventSource:tracker,keyCode:event.keyCode?event.keyCode:event.charCode,ctrl:event.ctrlKey,shift:event.shiftKey,alt:event.altKey,meta:event.metaKey,originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(!propagate){$.cancelEvent(event);}}}/**
     * @private
     * @inner
     */function onFocus(tracker,event){//console.log( "focus %s", event );
var propagate;if(tracker.focusHandler){event=$.getEvent(event);propagate=tracker.focusHandler({eventSource:tracker,originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}}/**
     * @private
     * @inner
     */function onBlur(tracker,event){//console.log( "blur %s", event );
var propagate;if(tracker.blurHandler){event=$.getEvent(event);propagate=tracker.blurHandler({eventSource:tracker,originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}}/**
     * Handler for 'wheel' events
     *
     * @private
     * @inner
     */function onWheel(tracker,event){handleWheelEvent(tracker,event,event);}/**
     * Handler for 'mousewheel', 'DOMMouseScroll', and 'MozMousePixelScroll' events
     *
     * @private
     * @inner
     */function onMouseWheel(tracker,event){event=$.getEvent(event);// Simulate a 'wheel' event
var simulatedEvent={target:event.target||event.srcElement,type:"wheel",shiftKey:event.shiftKey||false,clientX:event.clientX,clientY:event.clientY,pageX:event.pageX?event.pageX:event.clientX,pageY:event.pageY?event.pageY:event.clientY,deltaMode:event.type=="MozMousePixelScroll"?0:1,// 0=pixel, 1=line, 2=page
deltaX:0,deltaZ:0};// Calculate deltaY
if($.MouseTracker.wheelEventName=="mousewheel"){simulatedEvent.deltaY=-event.wheelDelta/$.DEFAULT_SETTINGS.pixelsPerWheelLine;}else{simulatedEvent.deltaY=event.detail;}handleWheelEvent(tracker,simulatedEvent,event);}/**
     * Handles 'wheel' events.
     * The event may be simulated by the legacy mouse wheel event handler (onMouseWheel()).
     *
     * @private
     * @inner
     */function handleWheelEvent(tracker,event,originalEvent){var nDelta=0,propagate;// The nDelta variable is gated to provide smooth z-index scrolling
//   since the mouse wheel allows for substantial deltas meant for rapid
//   y-index scrolling.
// event.deltaMode: 0=pixel, 1=line, 2=page
// TODO: Deltas in pixel mode should be accumulated then a scroll value computed after $.DEFAULT_SETTINGS.pixelsPerWheelLine threshold reached
nDelta=event.deltaY<0?1:-1;if(tracker.scrollHandler){propagate=tracker.scrollHandler({eventSource:tracker,pointerType:'mouse',position:getMouseRelative(event,tracker.element),scroll:nDelta,shift:event.shiftKey,isTouchEvent:false,originalEvent:originalEvent,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(originalEvent);}}}/**
     * @private
     * @inner
     */function isParentChild(parent,child){if(parent===child){return false;}while(child&&child!==parent){child=child.parentNode;}return child===parent;}/**
     * Only used on IE 8
     *
     * @private
     * @inner
     */function onMouseEnter(tracker,event){event=$.getEvent(event);handleMouseEnter(tracker,event);}/**
     * @private
     * @inner
     */function onMouseOver(tracker,event){event=$.getEvent(event);if(event.currentTarget===event.relatedTarget||isParentChild(event.currentTarget,event.relatedTarget)){return;}handleMouseEnter(tracker,event);}/**
     * @private
     * @inner
     */function handleMouseEnter(tracker,event){var gPoint={id:$.MouseTracker.mousePointerId,type:'mouse',isPrimary:true,currentPos:getMouseAbsolute(event),currentTime:$.now()};updatePointersEnter(tracker,event,[gPoint]);}/**
     * Only used on IE 8
     *
     * @private
     * @inner
     */function onMouseLeave(tracker,event){event=$.getEvent(event);handleMouseExit(tracker,event);}/**
     * @private
     * @inner
     */function onMouseOut(tracker,event){event=$.getEvent(event);if(event.currentTarget===event.relatedTarget||isParentChild(event.currentTarget,event.relatedTarget)){return;}handleMouseExit(tracker,event);}/**
     * @private
     * @inner
     */function handleMouseExit(tracker,event){var gPoint={id:$.MouseTracker.mousePointerId,type:'mouse',isPrimary:true,currentPos:getMouseAbsolute(event),currentTime:$.now()};updatePointersExit(tracker,event,[gPoint]);}/**
     * Returns a W3C DOM level 3 standard button value given an event.button property:
     *   -1 == none, 0 == primary/left, 1 == middle, 2 == secondary/right, 3 == X1/back, 4 == X2/forward, 5 == eraser (pen)
     * @private
     * @inner
     */function getStandardizedButton(button){if($.Browser.vendor===$.BROWSERS.IE&&$.Browser.version<9){// On IE 8, 0 == none, 1 == left, 2 == right, 3 == left and right, 4 == middle, 5 == left and middle, 6 == right and middle, 7 == all three
// TODO: Support chorded (multiple) button presses on IE 8?
if(button===1){return 0;}else if(button===2){return 2;}else if(button===4){return 1;}else{return-1;}}else{return button;}}/**
     * @private
     * @inner
     */function onMouseDown(tracker,event){var gPoint;event=$.getEvent(event);gPoint={id:$.MouseTracker.mousePointerId,type:'mouse',isPrimary:true,currentPos:getMouseAbsolute(event),currentTime:$.now()};if(updatePointersDown(tracker,event,[gPoint],getStandardizedButton(event.button))){$.stopEvent(event);capturePointer(tracker,'mouse');}if(tracker.clickHandler||tracker.dblClickHandler||tracker.pressHandler||tracker.dragHandler||tracker.dragEndHandler){$.cancelEvent(event);}}/**
     * @private
     * @inner
     */function onMouseUp(tracker,event){handleMouseUp(tracker,event);}/**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onMouseUp is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */function onMouseUpCaptured(tracker,event){handleMouseUp(tracker,event);$.stopEvent(event);}/**
     * @private
     * @inner
     */function handleMouseUp(tracker,event){var gPoint;event=$.getEvent(event);gPoint={id:$.MouseTracker.mousePointerId,type:'mouse',isPrimary:true,currentPos:getMouseAbsolute(event),currentTime:$.now()};if(updatePointersUp(tracker,event,[gPoint],getStandardizedButton(event.button))){releasePointer(tracker,'mouse');}}/**
     * @private
     * @inner
     */function onMouseMove(tracker,event){handleMouseMove(tracker,event);}/**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onMouseMove is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */function onMouseMoveCaptured(tracker,event){handleMouseMove(tracker,event);$.stopEvent(event);}/**
     * @private
     * @inner
     */function handleMouseMove(tracker,event){var gPoint;event=$.getEvent(event);gPoint={id:$.MouseTracker.mousePointerId,type:'mouse',isPrimary:true,currentPos:getMouseAbsolute(event),currentTime:$.now()};updatePointersMove(tracker,event,[gPoint]);}/**
     * @private
     * @inner
     */function abortContacts(tracker,event,pointsList){var i,gPointCount=pointsList.getLength(),abortGPoints=[];// Check contact count for hoverable pointer types before aborting
if(pointsList.type==='touch'||pointsList.contacts>0){for(i=0;i<gPointCount;i++){abortGPoints.push(pointsList.getByIndex(i));}if(abortGPoints.length>0){// simulate touchend/mouseup
updatePointersUp(tracker,event,abortGPoints,0);// 0 means primary button press/release or touch contact
// release pointer capture
pointsList.captureCount=1;releasePointer(tracker,pointsList.type);// simulate touchleave/mouseout
updatePointersExit(tracker,event,abortGPoints);}}}/**
     * @private
     * @inner
     */function onTouchStart(tracker,event){var time,i,j,touchCount=event.changedTouches.length,gPoints=[],parentGPoints,pointsList=tracker.getActivePointersListByType('touch');time=$.now();if(pointsList.getLength()>event.touches.length-touchCount){$.console.warn('Tracked touch contact count doesn\'t match event.touches.length. Removing all tracked touch pointers.');abortContacts(tracker,event,pointsList);}for(i=0;i<touchCount;i++){gPoints.push({id:event.changedTouches[i].identifier,type:'touch',// isPrimary not set - let the updatePointers functions determine it
currentPos:getMouseAbsolute(event.changedTouches[i]),currentTime:time});}// simulate touchenter on our tracked element
updatePointersEnter(tracker,event,gPoints);// simulate touchenter on our tracked element's tracked ancestor elements
for(i=0;i<MOUSETRACKERS.length;i++){if(MOUSETRACKERS[i]!==tracker&&MOUSETRACKERS[i].isTracking()&&isParentChild(MOUSETRACKERS[i].element,tracker.element)){parentGPoints=[];for(j=0;j<touchCount;j++){parentGPoints.push({id:event.changedTouches[j].identifier,type:'touch',// isPrimary not set - let the updatePointers functions determine it
currentPos:getMouseAbsolute(event.changedTouches[j]),currentTime:time});}updatePointersEnter(MOUSETRACKERS[i],event,parentGPoints);}}if(updatePointersDown(tracker,event,gPoints,0)){// 0 means primary button press/release or touch contact
$.stopEvent(event);capturePointer(tracker,'touch',touchCount);}$.cancelEvent(event);}/**
     * @private
     * @inner
     */function onTouchEnd(tracker,event){handleTouchEnd(tracker,event);}/**
     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
     * onTouchEnd is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */function onTouchEndCaptured(tracker,event){handleTouchEnd(tracker,event);$.stopEvent(event);}/**
     * @private
     * @inner
     */function handleTouchEnd(tracker,event){var time,i,j,touchCount=event.changedTouches.length,gPoints=[],parentGPoints;time=$.now();for(i=0;i<touchCount;i++){gPoints.push({id:event.changedTouches[i].identifier,type:'touch',// isPrimary not set - let the updatePointers functions determine it
currentPos:getMouseAbsolute(event.changedTouches[i]),currentTime:time});}if(updatePointersUp(tracker,event,gPoints,0)){releasePointer(tracker,'touch',touchCount);}// simulate touchleave on our tracked element
updatePointersExit(tracker,event,gPoints);// simulate touchleave on our tracked element's tracked ancestor elements
for(i=0;i<MOUSETRACKERS.length;i++){if(MOUSETRACKERS[i]!==tracker&&MOUSETRACKERS[i].isTracking()&&isParentChild(MOUSETRACKERS[i].element,tracker.element)){parentGPoints=[];for(j=0;j<touchCount;j++){parentGPoints.push({id:event.changedTouches[j].identifier,type:'touch',// isPrimary not set - let the updatePointers functions determine it
currentPos:getMouseAbsolute(event.changedTouches[j]),currentTime:time});}updatePointersExit(MOUSETRACKERS[i],event,parentGPoints);}}$.cancelEvent(event);}/**
     * @private
     * @inner
     */function onTouchMove(tracker,event){handleTouchMove(tracker,event);}/**
     * This handler is attached to the window object (on the capture phase) to emulate pointer capture.
     * onTouchMove is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */function onTouchMoveCaptured(tracker,event){handleTouchMove(tracker,event);$.stopEvent(event);}/**
     * @private
     * @inner
     */function handleTouchMove(tracker,event){var i,touchCount=event.changedTouches.length,gPoints=[];for(i=0;i<touchCount;i++){gPoints.push({id:event.changedTouches[i].identifier,type:'touch',// isPrimary not set - let the updatePointers functions determine it
currentPos:getMouseAbsolute(event.changedTouches[i]),currentTime:$.now()});}updatePointersMove(tracker,event,gPoints);$.cancelEvent(event);}/**
     * @private
     * @inner
     */function onTouchCancel(tracker,event){var pointsList=tracker.getActivePointersListByType('touch');abortContacts(tracker,event,pointsList);}/**
     * @private
     * @inner
     */function onGestureStart(tracker,event){event.stopPropagation();event.preventDefault();return false;}/**
     * @private
     * @inner
     */function onGestureChange(tracker,event){event.stopPropagation();event.preventDefault();return false;}/**
     * @private
     * @inner
     */function onPointerOver(tracker,event){var gPoint;if(event.currentTarget===event.relatedTarget||isParentChild(event.currentTarget,event.relatedTarget)){return;}gPoint={id:event.pointerId,type:getPointerType(event),isPrimary:event.isPrimary,currentPos:getMouseAbsolute(event),currentTime:$.now()};updatePointersEnter(tracker,event,[gPoint]);}/**
     * @private
     * @inner
     */function onPointerOut(tracker,event){var gPoint;if(event.currentTarget===event.relatedTarget||isParentChild(event.currentTarget,event.relatedTarget)){return;}gPoint={id:event.pointerId,type:getPointerType(event),isPrimary:event.isPrimary,currentPos:getMouseAbsolute(event),currentTime:$.now()};updatePointersExit(tracker,event,[gPoint]);}/**
     * @private
     * @inner
     */function onPointerDown(tracker,event){var gPoint;gPoint={id:event.pointerId,type:getPointerType(event),isPrimary:event.isPrimary,currentPos:getMouseAbsolute(event),currentTime:$.now()};if(updatePointersDown(tracker,event,[gPoint],event.button)){$.stopEvent(event);capturePointer(tracker,gPoint.type);}if(tracker.clickHandler||tracker.dblClickHandler||tracker.pressHandler||tracker.dragHandler||tracker.dragEndHandler||tracker.pinchHandler){$.cancelEvent(event);}}/**
     * @private
     * @inner
     */function onPointerUp(tracker,event){handlePointerUp(tracker,event);}/**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onPointerUp is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */function onPointerUpCaptured(tracker,event){var pointsList=tracker.getActivePointersListByType(getPointerType(event));if(pointsList.getById(event.pointerId)){handlePointerUp(tracker,event);}$.stopEvent(event);}/**
     * @private
     * @inner
     */function handlePointerUp(tracker,event){var gPoint;gPoint={id:event.pointerId,type:getPointerType(event),isPrimary:event.isPrimary,currentPos:getMouseAbsolute(event),currentTime:$.now()};if(updatePointersUp(tracker,event,[gPoint],event.button)){releasePointer(tracker,gPoint.type);}}/**
     * @private
     * @inner
     */function onPointerMove(tracker,event){handlePointerMove(tracker,event);}/**
     * This handler is attached to the window object (on the capture phase) to emulate mouse capture.
     * onPointerMove is still attached to the tracked element, so stop propagation to avoid processing twice.
     *
     * @private
     * @inner
     */function onPointerMoveCaptured(tracker,event){var pointsList=tracker.getActivePointersListByType(getPointerType(event));if(pointsList.getById(event.pointerId)){handlePointerMove(tracker,event);}$.stopEvent(event);}/**
     * @private
     * @inner
     */function handlePointerMove(tracker,event){// Pointer changed coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
var gPoint;gPoint={id:event.pointerId,type:getPointerType(event),isPrimary:event.isPrimary,currentPos:getMouseAbsolute(event),currentTime:$.now()};updatePointersMove(tracker,event,[gPoint]);}/**
     * @private
     * @inner
     */function onPointerCancel(tracker,event){var gPoint;gPoint={id:event.pointerId,type:getPointerType(event)};updatePointersCancel(tracker,event,[gPoint]);}///////////////////////////////////////////////////////////////////////////////
// Device-agnostic DOM event handlers
///////////////////////////////////////////////////////////////////////////////
/**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker.GesturePointList} pointsList
     *     The GesturePointList to track the pointer in.
     * @param {OpenSeadragon.MouseTracker.GesturePoint} gPoint
     *      Gesture point to track.
     * @returns {Number} Number of gesture points in pointsList.
     */function startTrackingPointer(pointsList,gPoint){// If isPrimary is not known for the pointer then set it according to our rules:
//    true if the first pointer in the gesture, otherwise false
if(!Object.prototype.hasOwnProperty.call(gPoint,'isPrimary')){if(pointsList.getLength()===0){gPoint.isPrimary=true;}else{gPoint.isPrimary=false;}}gPoint.speed=0;gPoint.direction=0;gPoint.contactPos=gPoint.currentPos;gPoint.contactTime=gPoint.currentTime;gPoint.lastPos=gPoint.currentPos;gPoint.lastTime=gPoint.currentTime;return pointsList.add(gPoint);}/**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker.GesturePointList} pointsList
     *     The GesturePointList to stop tracking the pointer on.
     * @param {OpenSeadragon.MouseTracker.GesturePoint} gPoint
     *      Gesture point to stop tracking.
     * @returns {Number} Number of gesture points in pointsList.
     */function stopTrackingPointer(pointsList,gPoint){var listLength,primaryPoint;if(pointsList.getById(gPoint.id)){listLength=pointsList.removeById(gPoint.id);// If isPrimary is not known for the pointer and we just removed the primary pointer from the list then we need to set another pointer as primary
if(!Object.prototype.hasOwnProperty.call(gPoint,'isPrimary')){primaryPoint=pointsList.getPrimary();if(!primaryPoint){primaryPoint=pointsList.getByIndex(0);if(primaryPoint){primaryPoint.isPrimary=true;}}}}else{listLength=pointsList.getLength();}return listLength;}/**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     */function updatePointersEnter(tracker,event,gPoints){var pointsList=tracker.getActivePointersListByType(gPoints[0].type),i,gPointCount=gPoints.length,curGPoint,updateGPoint,propagate;for(i=0;i<gPointCount;i++){curGPoint=gPoints[i];updateGPoint=pointsList.getById(curGPoint.id);if(updateGPoint){// Already tracking the pointer...update it
updateGPoint.insideElement=true;updateGPoint.lastPos=updateGPoint.currentPos;updateGPoint.lastTime=updateGPoint.currentTime;updateGPoint.currentPos=curGPoint.currentPos;updateGPoint.currentTime=curGPoint.currentTime;curGPoint=updateGPoint;}else{// Initialize for tracking and add to the tracking list
curGPoint.captured=false;curGPoint.insideElementPressed=false;curGPoint.insideElement=true;startTrackingPointer(pointsList,curGPoint);}// Enter
if(tracker.enterHandler){propagate=tracker.enterHandler({eventSource:tracker,pointerType:curGPoint.type,position:getPointRelativeToAbsolute(curGPoint.currentPos,tracker.element),buttons:pointsList.buttons,pointers:tracker.getActivePointerCount(),insideElementPressed:curGPoint.insideElementPressed,buttonDownAny:pointsList.buttons!==0,isTouchEvent:curGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}}}/**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     */function updatePointersExit(tracker,event,gPoints){var pointsList=tracker.getActivePointersListByType(gPoints[0].type),i,gPointCount=gPoints.length,curGPoint,updateGPoint,propagate;for(i=0;i<gPointCount;i++){curGPoint=gPoints[i];updateGPoint=pointsList.getById(curGPoint.id);if(updateGPoint){// Already tracking the pointer. If captured then update it, else stop tracking it
if(updateGPoint.captured){updateGPoint.insideElement=false;updateGPoint.lastPos=updateGPoint.currentPos;updateGPoint.lastTime=updateGPoint.currentTime;updateGPoint.currentPos=curGPoint.currentPos;updateGPoint.currentTime=curGPoint.currentTime;}else{stopTrackingPointer(pointsList,updateGPoint);}curGPoint=updateGPoint;}// Exit
if(tracker.exitHandler){propagate=tracker.exitHandler({eventSource:tracker,pointerType:curGPoint.type,position:curGPoint.currentPos&&getPointRelativeToAbsolute(curGPoint.currentPos,tracker.element),buttons:pointsList.buttons,pointers:tracker.getActivePointerCount(),insideElementPressed:updateGPoint?updateGPoint.insideElementPressed:false,buttonDownAny:pointsList.buttons!==0,isTouchEvent:curGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}}}/**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     * @param {Number} buttonChanged
     *      The button involved in the event: -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
     *      Note on chorded button presses (a button pressed when another button is already pressed): In the W3C Pointer Events model,
     *      only one pointerdown/pointerup event combo is fired. Chorded button state changes instead fire pointermove events.
     *
     * @returns {Boolean} True if pointers should be captured to the tracked element, otherwise false.
     */function updatePointersDown(tracker,event,gPoints,buttonChanged){var delegate=THIS[tracker.hash],propagate,pointsList=tracker.getActivePointersListByType(gPoints[0].type),i,gPointCount=gPoints.length,curGPoint,updateGPoint;if(typeof event.buttons!=='undefined'){pointsList.buttons=event.buttons;}else{if($.Browser.vendor===$.BROWSERS.IE&&$.Browser.version<9){if(buttonChanged===0){// Primary
pointsList.buttons+=1;}else if(buttonChanged===1){// Aux
pointsList.buttons+=4;}else if(buttonChanged===2){// Secondary
pointsList.buttons+=2;}else if(buttonChanged===3){// X1 (Back)
pointsList.buttons+=8;}else if(buttonChanged===4){// X2 (Forward)
pointsList.buttons+=16;}else if(buttonChanged===5){// Pen Eraser
pointsList.buttons+=32;}}else{if(buttonChanged===0){// Primary
pointsList.buttons|=1;}else if(buttonChanged===1){// Aux
pointsList.buttons|=4;}else if(buttonChanged===2){// Secondary
pointsList.buttons|=2;}else if(buttonChanged===3){// X1 (Back)
pointsList.buttons|=8;}else if(buttonChanged===4){// X2 (Forward)
pointsList.buttons|=16;}else if(buttonChanged===5){// Pen Eraser
pointsList.buttons|=32;}}}// Some pointers may steal control from another pointer without firing the appropriate release events
// e.g. Touching a screen while click-dragging with certain mice.
var otherPointsLists=tracker.getActivePointersListsExceptType(gPoints[0].type);for(i=0;i<otherPointsLists.length;i++){//If another pointer has contact, simulate the release
abortContacts(tracker,event,otherPointsLists[i]);// No-op if no active pointer
}// Only capture and track primary button, pen, and touch contacts
if(buttonChanged!==0){// Aux Press
if(tracker.nonPrimaryPressHandler){propagate=tracker.nonPrimaryPressHandler({eventSource:tracker,pointerType:gPoints[0].type,position:getPointRelativeToAbsolute(gPoints[0].currentPos,tracker.element),button:buttonChanged,buttons:pointsList.buttons,isTouchEvent:gPoints[0].type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}return false;}for(i=0;i<gPointCount;i++){curGPoint=gPoints[i];updateGPoint=pointsList.getById(curGPoint.id);if(updateGPoint){// Already tracking the pointer...update it
updateGPoint.captured=true;updateGPoint.insideElementPressed=true;updateGPoint.insideElement=true;updateGPoint.contactPos=curGPoint.currentPos;updateGPoint.contactTime=curGPoint.currentTime;updateGPoint.lastPos=updateGPoint.currentPos;updateGPoint.lastTime=updateGPoint.currentTime;updateGPoint.currentPos=curGPoint.currentPos;updateGPoint.currentTime=curGPoint.currentTime;curGPoint=updateGPoint;}else{// Initialize for tracking and add to the tracking list (no pointerover or pointermove event occurred before this)
curGPoint.captured=true;curGPoint.insideElementPressed=true;curGPoint.insideElement=true;startTrackingPointer(pointsList,curGPoint);}pointsList.addContact();//$.console.log('contacts++ ', pointsList.contacts);
if(tracker.dragHandler||tracker.dragEndHandler||tracker.pinchHandler){$.MouseTracker.gesturePointVelocityTracker.addPoint(tracker,curGPoint);}if(pointsList.contacts===1){// Press
if(tracker.pressHandler){propagate=tracker.pressHandler({eventSource:tracker,pointerType:curGPoint.type,position:getPointRelativeToAbsolute(curGPoint.contactPos,tracker.element),buttons:pointsList.buttons,isTouchEvent:curGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}}else if(pointsList.contacts===2){if(tracker.pinchHandler&&curGPoint.type==='touch'){// Initialize for pinch
delegate.pinchGPoints=pointsList.asArray();delegate.lastPinchDist=delegate.currentPinchDist=delegate.pinchGPoints[0].currentPos.distanceTo(delegate.pinchGPoints[1].currentPos);delegate.lastPinchCenter=delegate.currentPinchCenter=getCenterPoint(delegate.pinchGPoints[0].currentPos,delegate.pinchGPoints[1].currentPos);}}}return true;}/**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     * @param {Number} buttonChanged
     *      The button involved in the event: -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
     *      Note on chorded button presses (a button pressed when another button is already pressed): In the W3C Pointer Events model,
     *      only one pointerdown/pointerup event combo is fired. Chorded button state changes instead fire pointermove events.
     *
     * @returns {Boolean} True if pointer capture should be released from the tracked element, otherwise false.
     */function updatePointersUp(tracker,event,gPoints,buttonChanged){var delegate=THIS[tracker.hash],pointsList=tracker.getActivePointersListByType(gPoints[0].type),propagate,releasePoint,releaseTime,i,gPointCount=gPoints.length,curGPoint,updateGPoint,releaseCapture=false,wasCaptured=false,quick;if(typeof event.buttons!=='undefined'){pointsList.buttons=event.buttons;}else{if($.Browser.vendor===$.BROWSERS.IE&&$.Browser.version<9){if(buttonChanged===0){// Primary
pointsList.buttons-=1;}else if(buttonChanged===1){// Aux
pointsList.buttons-=4;}else if(buttonChanged===2){// Secondary
pointsList.buttons-=2;}else if(buttonChanged===3){// X1 (Back)
pointsList.buttons-=8;}else if(buttonChanged===4){// X2 (Forward)
pointsList.buttons-=16;}else if(buttonChanged===5){// Pen Eraser
pointsList.buttons-=32;}}else{if(buttonChanged===0){// Primary
pointsList.buttons^=~1;}else if(buttonChanged===1){// Aux
pointsList.buttons^=~4;}else if(buttonChanged===2){// Secondary
pointsList.buttons^=~2;}else if(buttonChanged===3){// X1 (Back)
pointsList.buttons^=~8;}else if(buttonChanged===4){// X2 (Forward)
pointsList.buttons^=~16;}else if(buttonChanged===5){// Pen Eraser
pointsList.buttons^=~32;}}}// Only capture and track primary button, pen, and touch contacts
if(buttonChanged!==0){// Aux Release
if(tracker.nonPrimaryReleaseHandler){propagate=tracker.nonPrimaryReleaseHandler({eventSource:tracker,pointerType:gPoints[0].type,position:getPointRelativeToAbsolute(gPoints[0].currentPos,tracker.element),button:buttonChanged,buttons:pointsList.buttons,isTouchEvent:gPoints[0].type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}// A primary mouse button may have been released while the non-primary button was down
var otherPointsList=tracker.getActivePointersListByType("mouse");// Stop tracking the mouse; see https://github.com/openseadragon/openseadragon/pull/1223
abortContacts(tracker,event,otherPointsList);// No-op if no active pointer
return false;}// OS-specific gestures (e.g. swipe up with four fingers in iPadOS 13)
if(typeof gPoints[0].currentPos==="undefined"){abortContacts(tracker,event,pointsList);return false;}for(i=0;i<gPointCount;i++){curGPoint=gPoints[i];updateGPoint=pointsList.getById(curGPoint.id);if(updateGPoint){// Update the pointer, stop tracking it if not still in this element
if(updateGPoint.captured){updateGPoint.captured=false;releaseCapture=true;wasCaptured=true;}updateGPoint.lastPos=updateGPoint.currentPos;updateGPoint.lastTime=updateGPoint.currentTime;updateGPoint.currentPos=curGPoint.currentPos;updateGPoint.currentTime=curGPoint.currentTime;if(!updateGPoint.insideElement){stopTrackingPointer(pointsList,updateGPoint);}releasePoint=updateGPoint.currentPos;releaseTime=updateGPoint.currentTime;if(wasCaptured){// Pointer was activated in our element but could have been removed in any element since events are captured to our element
pointsList.removeContact();//$.console.log('contacts-- ', pointsList.contacts);
if(tracker.dragHandler||tracker.dragEndHandler||tracker.pinchHandler){$.MouseTracker.gesturePointVelocityTracker.removePoint(tracker,updateGPoint);}if(pointsList.contacts===0){// Release (pressed in our element)
if(tracker.releaseHandler){propagate=tracker.releaseHandler({eventSource:tracker,pointerType:updateGPoint.type,position:getPointRelativeToAbsolute(releasePoint,tracker.element),buttons:pointsList.buttons,insideElementPressed:updateGPoint.insideElementPressed,insideElementReleased:updateGPoint.insideElement,isTouchEvent:updateGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}// Drag End
if(tracker.dragEndHandler&&!updateGPoint.currentPos.equals(updateGPoint.contactPos)){propagate=tracker.dragEndHandler({eventSource:tracker,pointerType:updateGPoint.type,position:getPointRelativeToAbsolute(updateGPoint.currentPos,tracker.element),speed:updateGPoint.speed,direction:updateGPoint.direction,shift:event.shiftKey,isTouchEvent:updateGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}// Click / Double-Click
if((tracker.clickHandler||tracker.dblClickHandler)&&updateGPoint.insideElement){quick=releaseTime-updateGPoint.contactTime<=tracker.clickTimeThreshold&&updateGPoint.contactPos.distanceTo(releasePoint)<=tracker.clickDistThreshold;// Click
if(tracker.clickHandler){propagate=tracker.clickHandler({eventSource:tracker,pointerType:updateGPoint.type,position:getPointRelativeToAbsolute(updateGPoint.currentPos,tracker.element),quick:quick,shift:event.shiftKey,isTouchEvent:updateGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}// Double-Click
if(tracker.dblClickHandler&&quick){pointsList.clicks++;if(pointsList.clicks===1){delegate.lastClickPos=releasePoint;/*jshint loopfunc:true*/delegate.dblClickTimeOut=setTimeout(function(){pointsList.clicks=0;},tracker.dblClickTimeThreshold);/*jshint loopfunc:false*/}else if(pointsList.clicks===2){clearTimeout(delegate.dblClickTimeOut);pointsList.clicks=0;if(delegate.lastClickPos.distanceTo(releasePoint)<=tracker.dblClickDistThreshold){propagate=tracker.dblClickHandler({eventSource:tracker,pointerType:updateGPoint.type,position:getPointRelativeToAbsolute(updateGPoint.currentPos,tracker.element),shift:event.shiftKey,isTouchEvent:updateGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}delegate.lastClickPos=null;}}}}else if(pointsList.contacts===2){if(tracker.pinchHandler&&updateGPoint.type==='touch'){// Reset for pinch
delegate.pinchGPoints=pointsList.asArray();delegate.lastPinchDist=delegate.currentPinchDist=delegate.pinchGPoints[0].currentPos.distanceTo(delegate.pinchGPoints[1].currentPos);delegate.lastPinchCenter=delegate.currentPinchCenter=getCenterPoint(delegate.pinchGPoints[0].currentPos,delegate.pinchGPoints[1].currentPos);}}}else{// Pointer was activated in another element but removed in our element
// Release (pressed in another element)
if(tracker.releaseHandler){propagate=tracker.releaseHandler({eventSource:tracker,pointerType:updateGPoint.type,position:getPointRelativeToAbsolute(releasePoint,tracker.element),buttons:pointsList.buttons,insideElementPressed:updateGPoint.insideElementPressed,insideElementReleased:updateGPoint.insideElement,isTouchEvent:updateGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}}}}return releaseCapture;}/**
     * Call when pointer(s) change coordinates, button state, pressure, tilt, or contact geometry (e.g. width and height)
     *
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     */function updatePointersMove(tracker,event,gPoints){var delegate=THIS[tracker.hash],pointsList=tracker.getActivePointersListByType(gPoints[0].type),i,gPointCount=gPoints.length,curGPoint,updateGPoint,gPointArray,delta,propagate;if(typeof event.buttons!=='undefined'){pointsList.buttons=event.buttons;}for(i=0;i<gPointCount;i++){curGPoint=gPoints[i];updateGPoint=pointsList.getById(curGPoint.id);if(updateGPoint){// Already tracking the pointer...update it
if(Object.prototype.hasOwnProperty.call(curGPoint,'isPrimary')){updateGPoint.isPrimary=curGPoint.isPrimary;}updateGPoint.lastPos=updateGPoint.currentPos;updateGPoint.lastTime=updateGPoint.currentTime;updateGPoint.currentPos=curGPoint.currentPos;updateGPoint.currentTime=curGPoint.currentTime;}else{// Initialize for tracking and add to the tracking list (no pointerover or pointerdown event occurred before this)
curGPoint.captured=false;curGPoint.insideElementPressed=false;curGPoint.insideElement=true;startTrackingPointer(pointsList,curGPoint);}}// Stop (mouse only)
if(tracker.stopHandler&&gPoints[0].type==='mouse'){clearTimeout(tracker.stopTimeOut);tracker.stopTimeOut=setTimeout(function(){handlePointerStop(tracker,event,gPoints[0].type);},tracker.stopDelay);}if(pointsList.contacts===0){// Move (no contacts: hovering mouse or other hover-capable device)
if(tracker.moveHandler){propagate=tracker.moveHandler({eventSource:tracker,pointerType:gPoints[0].type,position:getPointRelativeToAbsolute(gPoints[0].currentPos,tracker.element),buttons:pointsList.buttons,isTouchEvent:gPoints[0].type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}}else if(pointsList.contacts===1){// Move (1 contact)
if(tracker.moveHandler){updateGPoint=pointsList.asArray()[0];propagate=tracker.moveHandler({eventSource:tracker,pointerType:updateGPoint.type,position:getPointRelativeToAbsolute(updateGPoint.currentPos,tracker.element),buttons:pointsList.buttons,isTouchEvent:updateGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}// Drag
if(tracker.dragHandler){updateGPoint=pointsList.asArray()[0];delta=updateGPoint.currentPos.minus(updateGPoint.lastPos);propagate=tracker.dragHandler({eventSource:tracker,pointerType:updateGPoint.type,position:getPointRelativeToAbsolute(updateGPoint.currentPos,tracker.element),buttons:pointsList.buttons,delta:delta,speed:updateGPoint.speed,direction:updateGPoint.direction,shift:event.shiftKey,isTouchEvent:updateGPoint.type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}}else if(pointsList.contacts===2){// Move (2 contacts, use center)
if(tracker.moveHandler){gPointArray=pointsList.asArray();propagate=tracker.moveHandler({eventSource:tracker,pointerType:gPointArray[0].type,position:getPointRelativeToAbsolute(getCenterPoint(gPointArray[0].currentPos,gPointArray[1].currentPos),tracker.element),buttons:pointsList.buttons,isTouchEvent:gPointArray[0].type==='touch',originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}// Pinch
if(tracker.pinchHandler&&gPoints[0].type==='touch'){delta=delegate.pinchGPoints[0].currentPos.distanceTo(delegate.pinchGPoints[1].currentPos);if(delta!=delegate.currentPinchDist){delegate.lastPinchDist=delegate.currentPinchDist;delegate.currentPinchDist=delta;delegate.lastPinchCenter=delegate.currentPinchCenter;delegate.currentPinchCenter=getCenterPoint(delegate.pinchGPoints[0].currentPos,delegate.pinchGPoints[1].currentPos);propagate=tracker.pinchHandler({eventSource:tracker,pointerType:'touch',gesturePoints:delegate.pinchGPoints,lastCenter:getPointRelativeToAbsolute(delegate.lastPinchCenter,tracker.element),center:getPointRelativeToAbsolute(delegate.currentPinchCenter,tracker.element),lastDistance:delegate.lastPinchDist,distance:delegate.currentPinchDist,shift:event.shiftKey,originalEvent:event,preventDefaultAction:false,userData:tracker.userData});if(propagate===false){$.cancelEvent(event);}}}}}/**
     * @function
     * @private
     * @inner
     * @param {OpenSeadragon.MouseTracker} tracker
     *     A reference to the MouseTracker instance.
     * @param {Object} event
     *     A reference to the originating DOM event.
     * @param {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gPoints
     *      Gesture points associated with the event.
     */function updatePointersCancel(tracker,event,gPoints){updatePointersUp(tracker,event,gPoints,0);updatePointersExit(tracker,event,gPoints);}/**
     * @private
     * @inner
     */function handlePointerStop(tracker,originalMoveEvent,pointerType){if(tracker.stopHandler){tracker.stopHandler({eventSource:tracker,pointerType:pointerType,position:getMouseRelative(originalMoveEvent,tracker.element),buttons:tracker.getActivePointersListByType(pointerType).buttons,isTouchEvent:pointerType==='touch',originalEvent:originalMoveEvent,preventDefaultAction:false,userData:tracker.userData});}}/**
     * True if inside an iframe, otherwise false.
     * @member {Boolean} isInIframe
     * @private
     * @inner
     */var isInIframe=function(){try{return window.self!==window.top;}catch(e){return true;}}();/**
     * @function
     * @private
     * @inner
     * @returns {Boolean} True if the target has access rights to events, otherwise false.
     */function canAccessEvents(target){try{return target.addEventListener&&target.removeEventListener;}catch(e){return false;}}})(OpenSeadragon);/*
 * OpenSeadragon - Control
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * An enumeration of supported locations where controls can be anchored.
 * The anchoring is always relative to the container.
 * @member ControlAnchor
 * @memberof OpenSeadragon
 * @static
 * @type {Object}
 * @property {Number} NONE
 * @property {Number} TOP_LEFT
 * @property {Number} TOP_RIGHT
 * @property {Number} BOTTOM_LEFT
 * @property {Number} BOTTOM_RIGHT
 * @property {Number} ABSOLUTE
 */$.ControlAnchor={NONE:0,TOP_LEFT:1,TOP_RIGHT:2,BOTTOM_RIGHT:3,BOTTOM_LEFT:4,ABSOLUTE:5};/**
 * @class Control
 * @classdesc A Control represents any interface element which is meant to allow the user
 * to interact with the zoomable interface. Any control can be anchored to any
 * element.
 *
 * @memberof OpenSeadragon
 * @param {Element} element - the control element to be anchored in the container.
 * @param {Object } options - All required and optional settings for configuring a control element.
 * @param {OpenSeadragon.ControlAnchor} [options.anchor=OpenSeadragon.ControlAnchor.NONE] - the position of the control
 *  relative to the container.
 * @param {Boolean} [options.attachToViewer=true] - Whether the control should be added directly to the viewer, or
 *  directly to the container
 * @param {Boolean} [options.autoFade=true] - Whether the control should have the autofade behavior
 * @param {Element} container - the element to control will be anchored too.
 */$.Control=function(element,options,container){var parent=element.parentNode;if(typeof options==='number'){$.console.error("Passing an anchor directly into the OpenSeadragon.Control constructor is deprecated; "+"please use an options object instead.  "+"Support for this deprecated variant is scheduled for removal in December 2013");options={anchor:options};}options.attachToViewer=typeof options.attachToViewer==='undefined'?true:options.attachToViewer;/**
     * True if the control should have autofade behavior.
     * @member {Boolean} autoFade
     * @memberof OpenSeadragon.Control#
     */this.autoFade=typeof options.autoFade==='undefined'?true:options.autoFade;/**
     * The element providing the user interface with some type of control (e.g. a zoom-in button).
     * @member {Element} element
     * @memberof OpenSeadragon.Control#
     */this.element=element;/**
     * The position of the Control relative to its container.
     * @member {OpenSeadragon.ControlAnchor} anchor
     * @memberof OpenSeadragon.Control#
     */this.anchor=options.anchor;/**
     * The Control's containing element.
     * @member {Element} container
     * @memberof OpenSeadragon.Control#
     */this.container=container;/**
     * A neutral element surrounding the control element.
     * @member {Element} wrapper
     * @memberof OpenSeadragon.Control#
     */if(this.anchor==$.ControlAnchor.ABSOLUTE){this.wrapper=$.makeNeutralElement("div");this.wrapper.style.position="absolute";this.wrapper.style.top=typeof options.top=="number"?options.top+'px':options.top;this.wrapper.style.left=typeof options.left=="number"?options.left+'px':options.left;this.wrapper.style.height=typeof options.height=="number"?options.height+'px':options.height;this.wrapper.style.width=typeof options.width=="number"?options.width+'px':options.width;this.wrapper.style.margin="0px";this.wrapper.style.padding="0px";this.element.style.position="relative";this.element.style.top="0px";this.element.style.left="0px";this.element.style.height="100%";this.element.style.width="100%";}else{this.wrapper=$.makeNeutralElement("div");this.wrapper.style.display="inline-block";if(this.anchor==$.ControlAnchor.NONE){// IE6 fix
this.wrapper.style.width=this.wrapper.style.height="100%";}}this.wrapper.appendChild(this.element);if(options.attachToViewer){if(this.anchor==$.ControlAnchor.TOP_RIGHT||this.anchor==$.ControlAnchor.BOTTOM_RIGHT){this.container.insertBefore(this.wrapper,this.container.firstChild);}else{this.container.appendChild(this.wrapper);}}else{parent.appendChild(this.wrapper);}};/** @lends OpenSeadragon.Control.prototype */$.Control.prototype={/**
     * Removes the control from the container.
     * @function
     */destroy:function(){this.wrapper.removeChild(this.element);this.container.removeChild(this.wrapper);},/**
     * Determines if the control is currently visible.
     * @function
     * @return {Boolean} true if currently visible, false otherwise.
     */isVisible:function(){return this.wrapper.style.display!="none";},/**
     * Toggles the visibility of the control.
     * @function
     * @param {Boolean} visible - true to make visible, false to hide.
     */setVisible:function(visible){this.wrapper.style.display=visible?this.anchor==$.ControlAnchor.ABSOLUTE?'block':'inline-block':"none";},/**
     * Sets the opacity level for the control.
     * @function
     * @param {Number} opactiy - a value between 1 and 0 inclusively.
     */setOpacity:function(opacity){if(this.element[$.SIGNAL]&&$.Browser.vendor==$.BROWSERS.IE){$.setElementOpacity(this.element,opacity,true);}else{$.setElementOpacity(this.wrapper,opacity,true);}}};})(OpenSeadragon);/*
 * OpenSeadragon - ControlDock
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
     * @class ControlDock
     * @classdesc Provides a container element (a &lt;form&gt; element) with support for the layout of control elements.
     *
     * @memberof OpenSeadragon
     */$.ControlDock=function(options){var layouts=['topleft','topright','bottomright','bottomleft'],layout,i;$.extend(true,this,{id:'controldock-'+$.now()+'-'+Math.floor(Math.random()*1000000),container:$.makeNeutralElement('div'),controls:[]},options);// Disable the form's submit; otherwise button clicks and return keys
// can trigger it.
this.container.onsubmit=function(){return false;};if(this.element){this.element=$.getElement(this.element);this.element.appendChild(this.container);this.element.style.position='relative';this.container.style.width='100%';this.container.style.height='100%';}for(i=0;i<layouts.length;i++){layout=layouts[i];this.controls[layout]=$.makeNeutralElement("div");this.controls[layout].style.position='absolute';if(layout.match('left')){this.controls[layout].style.left='0px';}if(layout.match('right')){this.controls[layout].style.right='0px';}if(layout.match('top')){this.controls[layout].style.top='0px';}if(layout.match('bottom')){this.controls[layout].style.bottom='0px';}}this.container.appendChild(this.controls.topleft);this.container.appendChild(this.controls.topright);this.container.appendChild(this.controls.bottomright);this.container.appendChild(this.controls.bottomleft);};/** @lends OpenSeadragon.ControlDock.prototype */$.ControlDock.prototype={/**
         * @function
         */addControl:function(element,controlOptions){element=$.getElement(element);var div=null;if(getControlIndex(this,element)>=0){return;// they're trying to add a duplicate control
}switch(controlOptions.anchor){case $.ControlAnchor.TOP_RIGHT:div=this.controls.topright;element.style.position="relative";element.style.paddingRight="0px";element.style.paddingTop="0px";break;case $.ControlAnchor.BOTTOM_RIGHT:div=this.controls.bottomright;element.style.position="relative";element.style.paddingRight="0px";element.style.paddingBottom="0px";break;case $.ControlAnchor.BOTTOM_LEFT:div=this.controls.bottomleft;element.style.position="relative";element.style.paddingLeft="0px";element.style.paddingBottom="0px";break;case $.ControlAnchor.TOP_LEFT:div=this.controls.topleft;element.style.position="relative";element.style.paddingLeft="0px";element.style.paddingTop="0px";break;case $.ControlAnchor.ABSOLUTE:div=this.container;element.style.margin="0px";element.style.padding="0px";break;default:case $.ControlAnchor.NONE:div=this.container;element.style.margin="0px";element.style.padding="0px";break;}this.controls.push(new $.Control(element,controlOptions,div));element.style.display="inline-block";},/**
         * @function
         * @return {OpenSeadragon.ControlDock} Chainable.
         */removeControl:function(element){element=$.getElement(element);var i=getControlIndex(this,element);if(i>=0){this.controls[i].destroy();this.controls.splice(i,1);}return this;},/**
         * @function
         * @return {OpenSeadragon.ControlDock} Chainable.
         */clearControls:function(){while(this.controls.length>0){this.controls.pop().destroy();}return this;},/**
         * @function
         * @return {Boolean}
         */areControlsEnabled:function(){var i;for(i=this.controls.length-1;i>=0;i--){if(this.controls[i].isVisible()){return true;}}return false;},/**
         * @function
         * @return {OpenSeadragon.ControlDock} Chainable.
         */setControlsEnabled:function(enabled){var i;for(i=this.controls.length-1;i>=0;i--){this.controls[i].setVisible(enabled);}return this;}};///////////////////////////////////////////////////////////////////////////////
// Utility methods
///////////////////////////////////////////////////////////////////////////////
function getControlIndex(dock,element){var controls=dock.controls,i;for(i=controls.length-1;i>=0;i--){if(controls[i].element==element){return i;}}return-1;}})(OpenSeadragon);/*
 * OpenSeadragon - Placement
 *
 * Copyright (C) 2010-2016 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
     * An enumeration of positions to anchor an element.
     * @member Placement
     * @memberOf OpenSeadragon
     * @static
     * @readonly
     * @property {OpenSeadragon.Placement} CENTER
     * @property {OpenSeadragon.Placement} TOP_LEFT
     * @property {OpenSeadragon.Placement} TOP
     * @property {OpenSeadragon.Placement} TOP_RIGHT
     * @property {OpenSeadragon.Placement} RIGHT
     * @property {OpenSeadragon.Placement} BOTTOM_RIGHT
     * @property {OpenSeadragon.Placement} BOTTOM
     * @property {OpenSeadragon.Placement} BOTTOM_LEFT
     * @property {OpenSeadragon.Placement} LEFT
     */$.Placement=$.freezeObject({CENTER:0,TOP_LEFT:1,TOP:2,TOP_RIGHT:3,RIGHT:4,BOTTOM_RIGHT:5,BOTTOM:6,BOTTOM_LEFT:7,LEFT:8,properties:{0:{isLeft:false,isHorizontallyCentered:true,isRight:false,isTop:false,isVerticallyCentered:true,isBottom:false},1:{isLeft:true,isHorizontallyCentered:false,isRight:false,isTop:true,isVerticallyCentered:false,isBottom:false},2:{isLeft:false,isHorizontallyCentered:true,isRight:false,isTop:true,isVerticallyCentered:false,isBottom:false},3:{isLeft:false,isHorizontallyCentered:false,isRight:true,isTop:true,isVerticallyCentered:false,isBottom:false},4:{isLeft:false,isHorizontallyCentered:false,isRight:true,isTop:false,isVerticallyCentered:true,isBottom:false},5:{isLeft:false,isHorizontallyCentered:false,isRight:true,isTop:false,isVerticallyCentered:false,isBottom:true},6:{isLeft:false,isHorizontallyCentered:true,isRight:false,isTop:false,isVerticallyCentered:false,isBottom:true},7:{isLeft:true,isHorizontallyCentered:false,isRight:false,isTop:false,isVerticallyCentered:false,isBottom:true},8:{isLeft:true,isHorizontallyCentered:false,isRight:false,isTop:false,isVerticallyCentered:true,isBottom:false}}});})(OpenSeadragon);/*
 * OpenSeadragon - Viewer
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){// dictionary from hash to private properties
var THIS={};var nextHash=1;/**
 *
 * The main point of entry into creating a zoomable image on the page.<br>
 * <br>
 * We have provided an idiomatic javascript constructor which takes
 * a single object, but still support the legacy positional arguments.<br>
 * <br>
 * The options below are given in order that they appeared in the constructor
 * as arguments and we translate a positional call into an idiomatic call.<br>
 * <br>
 * To create a viewer, you can use either of this methods:<br>
 * <ul>
 * <li><code>var viewer = new OpenSeadragon.Viewer(options);</code></li>
 * <li><code>var viewer = OpenSeadragon(options);</code></li>
 * </ul>
 * @class Viewer
 * @classdesc The main OpenSeadragon viewer class.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @extends OpenSeadragon.ControlDock
 * @param {OpenSeadragon.Options} options - Viewer options.
 *
 **/$.Viewer=function(options){var args=arguments,_this=this,i;//backward compatibility for positional args while preferring more
//idiomatic javascript options object as the only argument
if(!$.isPlainObject(options)){options={id:args[0],xmlPath:args.length>1?args[1]:undefined,prefixUrl:args.length>2?args[2]:undefined,controls:args.length>3?args[3]:undefined,overlays:args.length>4?args[4]:undefined};}//options.config and the general config argument are deprecated
//in favor of the more direct specification of optional settings
//being pass directly on the options object
if(options.config){$.extend(true,options,options.config);delete options.config;}//Public properties
//Allow the options object to override global defaults
$.extend(true,this,{//internal state and dom identifiers
id:options.id,hash:options.hash||nextHash++,/**
         * Index for page to be shown first next time open() is called (only used in sequenceMode).
         * @member {Number} initialPage
         * @memberof OpenSeadragon.Viewer#
         */initialPage:0,//dom nodes
/**
         * The parent element of this Viewer instance, passed in when the Viewer was created.
         * @member {Element} element
         * @memberof OpenSeadragon.Viewer#
         */element:null,/**
         * A &lt;div&gt; element (provided by {@link OpenSeadragon.ControlDock}), the base element of this Viewer instance.<br><br>
         * Child element of {@link OpenSeadragon.Viewer#element}.
         * @member {Element} container
         * @memberof OpenSeadragon.Viewer#
         */container:null,/**
         * A &lt;div&gt; element, the element where user-input events are handled for panning and zooming.<br><br>
         * Child element of {@link OpenSeadragon.Viewer#container},
         * positioned on top of {@link OpenSeadragon.Viewer#keyboardCommandArea}.<br><br>
         * The parent of {@link OpenSeadragon.Drawer#canvas} instances.
         * @member {Element} canvas
         * @memberof OpenSeadragon.Viewer#
         */canvas:null,// Overlays list. An overlay allows to add html on top of the viewer.
overlays:[],// Container inside the canvas where overlays are drawn.
overlaysContainer:null,//private state properties
previousBody:[],//This was originally initialized in the constructor and so could never
//have anything in it.  now it can because we allow it to be specified
//in the options and is only empty by default if not specified. Also
//this array was returned from get_controls which I find confusing
//since this object has a controls property which is treated in other
//functions like clearControls.  I'm removing the accessors.
customControls:[],//These are originally not part options but declared as members
//in initialize.  It's still considered idiomatic to put them here
//source is here for backwards compatibility. It is not an official
//part of the API and should not be relied upon.
source:null,/**
         * Handles rendering of tiles in the viewer. Created for each TileSource opened.
         * @member {OpenSeadragon.Drawer} drawer
         * @memberof OpenSeadragon.Viewer#
         */drawer:null,/**
         * Keeps track of all of the tiled images in the scene.
         * @member {OpenSeadragon.World} world
         * @memberof OpenSeadragon.Viewer#
         */world:null,/**
         * Handles coordinate-related functionality - zoom, pan, rotation, etc. Created for each TileSource opened.
         * @member {OpenSeadragon.Viewport} viewport
         * @memberof OpenSeadragon.Viewer#
         */viewport:null,/**
         * @member {OpenSeadragon.Navigator} navigator
         * @memberof OpenSeadragon.Viewer#
         */navigator:null,//A collection viewport is a separate viewport used to provide
//simultaneous rendering of sets of tiles
collectionViewport:null,collectionDrawer:null,//UI image resources
//TODO: rename navImages to uiImages
navImages:null,//interface button controls
buttons:null,//TODO: this is defunct so safely remove it
profiler:null},$.DEFAULT_SETTINGS,options);if(typeof this.hash==="undefined"){throw new Error("A hash must be defined, either by specifying options.id or options.hash.");}if(typeof THIS[this.hash]!=="undefined"){// We don't want to throw an error here, as the user might have discarded
// the previous viewer with the same hash and now want to recreate it.
$.console.warn("Hash "+this.hash+" has already been used.");}//Private state properties
THIS[this.hash]={"fsBoundsDelta":new $.Point(1,1),"prevContainerSize":null,"animating":false,"forceRedraw":false,"mouseInside":false,"group":null,// whether we should be continuously zooming
"zooming":false,// how much we should be continuously zooming by
"zoomFactor":null,"lastZoomTime":null,"fullPage":false,"onfullscreenchange":null};this._sequenceIndex=0;this._firstOpen=true;this._updateRequestId=null;this._loadQueue=[];this.currentOverlays=[];this._lastScrollTime=$.now();// variable used to help normalize the scroll event speed of different devices
//Inherit some behaviors and properties
$.EventSource.call(this);this.addHandler('open-failed',function(event){var msg=$.getString("Errors.OpenFailed",event.eventSource,event.message);_this._showMessage(msg);});$.ControlDock.call(this,options);//Deal with tile sources
if(this.xmlPath){//Deprecated option.  Now it is preferred to use the tileSources option
this.tileSources=[this.xmlPath];}this.element=this.element||document.getElementById(this.id);this.canvas=$.makeNeutralElement("div");this.canvas.className="openseadragon-canvas";(function(style){style.width="100%";style.height="100%";style.overflow="hidden";style.position="absolute";style.top="0px";style.left="0px";})(this.canvas.style);$.setElementTouchActionNone(this.canvas);if(options.tabIndex!==""){this.canvas.tabIndex=options.tabIndex===undefined?0:options.tabIndex;}//the container is created through applying the ControlDock constructor above
this.container.className="openseadragon-container";(function(style){style.width="100%";style.height="100%";style.position="relative";style.overflow="hidden";style.left="0px";style.top="0px";style.textAlign="left";// needed to protect against
})(this.container.style);this.container.insertBefore(this.canvas,this.container.firstChild);this.element.appendChild(this.container);//Used for toggling between fullscreen and default container size
//TODO: these can be closure private and shared across Viewer
//      instances.
this.bodyWidth=document.body.style.width;this.bodyHeight=document.body.style.height;this.bodyOverflow=document.body.style.overflow;this.docOverflow=document.documentElement.style.overflow;this.innerTracker=new $.MouseTracker({element:this.canvas,startDisabled:!this.mouseNavEnabled,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,dblClickTimeThreshold:this.dblClickTimeThreshold,dblClickDistThreshold:this.dblClickDistThreshold,keyDownHandler:$.delegate(this,onCanvasKeyDown),keyHandler:$.delegate(this,onCanvasKeyPress),clickHandler:$.delegate(this,onCanvasClick),dblClickHandler:$.delegate(this,onCanvasDblClick),dragHandler:$.delegate(this,onCanvasDrag),dragEndHandler:$.delegate(this,onCanvasDragEnd),enterHandler:$.delegate(this,onCanvasEnter),exitHandler:$.delegate(this,onCanvasExit),pressHandler:$.delegate(this,onCanvasPress),releaseHandler:$.delegate(this,onCanvasRelease),nonPrimaryPressHandler:$.delegate(this,onCanvasNonPrimaryPress),nonPrimaryReleaseHandler:$.delegate(this,onCanvasNonPrimaryRelease),scrollHandler:$.delegate(this,onCanvasScroll),pinchHandler:$.delegate(this,onCanvasPinch)});this.outerTracker=new $.MouseTracker({element:this.container,startDisabled:!this.mouseNavEnabled,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,dblClickTimeThreshold:this.dblClickTimeThreshold,dblClickDistThreshold:this.dblClickDistThreshold,enterHandler:$.delegate(this,onContainerEnter),exitHandler:$.delegate(this,onContainerExit)});if(this.toolbar){this.toolbar=new $.ControlDock({element:this.toolbar});}this.bindStandardControls();THIS[this.hash].prevContainerSize=_getSafeElemSize(this.container);// Create the world
this.world=new $.World({viewer:this});this.world.addHandler('add-item',function(event){// For backwards compatibility, we maintain the source property
_this.source=_this.world.getItemAt(0).source;THIS[_this.hash].forceRedraw=true;if(!_this._updateRequestId){_this._updateRequestId=scheduleUpdate(_this,updateMulti);}});this.world.addHandler('remove-item',function(event){// For backwards compatibility, we maintain the source property
if(_this.world.getItemCount()){_this.source=_this.world.getItemAt(0).source;}else{_this.source=null;}THIS[_this.hash].forceRedraw=true;});this.world.addHandler('metrics-change',function(event){if(_this.viewport){_this.viewport._setContentBounds(_this.world.getHomeBounds(),_this.world.getContentFactor());}});this.world.addHandler('item-index-change',function(event){// For backwards compatibility, we maintain the source property
_this.source=_this.world.getItemAt(0).source;});// Create the viewport
this.viewport=new $.Viewport({containerSize:THIS[this.hash].prevContainerSize,springStiffness:this.springStiffness,animationTime:this.animationTime,minZoomImageRatio:this.minZoomImageRatio,maxZoomPixelRatio:this.maxZoomPixelRatio,visibilityRatio:this.visibilityRatio,wrapHorizontal:this.wrapHorizontal,wrapVertical:this.wrapVertical,defaultZoomLevel:this.defaultZoomLevel,minZoomLevel:this.minZoomLevel,maxZoomLevel:this.maxZoomLevel,viewer:this,degrees:this.degrees,flipped:this.flipped,navigatorRotate:this.navigatorRotate,homeFillsViewer:this.homeFillsViewer,margins:this.viewportMargins});this.viewport._setContentBounds(this.world.getHomeBounds(),this.world.getContentFactor());// Create the image loader
this.imageLoader=new $.ImageLoader({jobLimit:this.imageLoaderLimit,timeout:options.timeout});// Create the tile cache
this.tileCache=new $.TileCache({maxImageCacheCount:this.maxImageCacheCount});// Create the drawer
this.drawer=new $.Drawer({viewer:this,viewport:this.viewport,element:this.canvas,debugGridColor:this.debugGridColor});// Overlay container
this.overlaysContainer=$.makeNeutralElement("div");this.canvas.appendChild(this.overlaysContainer);// Now that we have a drawer, see if it supports rotate. If not we need to remove the rotate buttons
if(!this.drawer.canRotate()){// Disable/remove the rotate left/right buttons since they aren't supported
if(this.rotateLeft){i=this.buttons.buttons.indexOf(this.rotateLeft);this.buttons.buttons.splice(i,1);this.buttons.element.removeChild(this.rotateLeft.element);}if(this.rotateRight){i=this.buttons.buttons.indexOf(this.rotateRight);this.buttons.buttons.splice(i,1);this.buttons.element.removeChild(this.rotateRight.element);}}//Instantiate a navigator if configured
if(this.showNavigator){this.navigator=new $.Navigator({id:this.navigatorId,position:this.navigatorPosition,sizeRatio:this.navigatorSizeRatio,maintainSizeRatio:this.navigatorMaintainSizeRatio,top:this.navigatorTop,left:this.navigatorLeft,width:this.navigatorWidth,height:this.navigatorHeight,autoResize:this.navigatorAutoResize,autoFade:this.navigatorAutoFade,prefixUrl:this.prefixUrl,viewer:this,navigatorRotate:this.navigatorRotate,background:this.navigatorBackground,opacity:this.navigatorOpacity,borderColor:this.navigatorBorderColor,displayRegionColor:this.navigatorDisplayRegionColor,crossOriginPolicy:this.crossOriginPolicy});}// Sequence mode
if(this.sequenceMode){this.bindSequenceControls();}// Open initial tilesources
if(this.tileSources){this.open(this.tileSources);}// Add custom controls
for(i=0;i<this.customControls.length;i++){this.addControl(this.customControls[i].id,{anchor:this.customControls[i].anchor});}// Initial fade out
$.requestAnimationFrame(function(){beginControlsAutoHide(_this);});// Initial canvas options
if(this.imageSmoothingEnabled!==undefined&&!this.imageSmoothingEnabled){this.drawer.setImageSmoothingEnabled(this.imageSmoothingEnabled);}};$.extend($.Viewer.prototype,$.EventSource.prototype,$.ControlDock.prototype,/** @lends OpenSeadragon.Viewer.prototype */{/**
     * @function
     * @return {Boolean}
     */isOpen:function(){return!!this.world.getItemCount();},// deprecated
openDzi:function(dzi){$.console.error("[Viewer.openDzi] this function is deprecated; use Viewer.open() instead.");return this.open(dzi);},// deprecated
openTileSource:function(tileSource){$.console.error("[Viewer.openTileSource] this function is deprecated; use Viewer.open() instead.");return this.open(tileSource);},/**
     * Open tiled images into the viewer, closing any others.
     * To get the TiledImage instance created by open, add an event listener for
     * {@link OpenSeadragon.Viewer.html#.event:open}, which when fired can be used to get access
     * to the instance, i.e., viewer.world.getItemAt(0).
     * @function
     * @param {Array|String|Object|Function} tileSources - This can be a TiledImage
     * specifier, a TileSource specifier, or an array of either. A TiledImage specifier
     * is the same as the options parameter for {@link OpenSeadragon.Viewer#addTiledImage},
     * except for the index property; images are added in sequence.
     * A TileSource specifier is anything you could pass as the tileSource property
     * of the options parameter for {@link OpenSeadragon.Viewer#addTiledImage}.
     * @param {Number} initialPage - If sequenceMode is true, display this page initially
     * for the given tileSources. If specified, will overwrite the Viewer's existing initialPage property.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:open
     * @fires OpenSeadragon.Viewer.event:open-failed
     */open:function(tileSources,initialPage){var _this=this;this.close();if(!tileSources){return;}if(this.sequenceMode&&$.isArray(tileSources)){if(this.referenceStrip){this.referenceStrip.destroy();this.referenceStrip=null;}if(typeof initialPage!='undefined'&&!isNaN(initialPage)){this.initialPage=initialPage;}this.tileSources=tileSources;this._sequenceIndex=Math.max(0,Math.min(this.tileSources.length-1,this.initialPage));if(this.tileSources.length){this.open(this.tileSources[this._sequenceIndex]);if(this.showReferenceStrip){this.addReferenceStrip();}}this._updateSequenceButtons(this._sequenceIndex);return;}if(!$.isArray(tileSources)){tileSources=[tileSources];}if(!tileSources.length){return;}this._opening=true;var expected=tileSources.length;var successes=0;var failures=0;var failEvent;var checkCompletion=function(){if(successes+failures===expected){if(successes){if(_this._firstOpen||!_this.preserveViewport){_this.viewport.goHome(true);_this.viewport.update();}_this._firstOpen=false;var source=tileSources[0];if(source.tileSource){source=source.tileSource;}// Global overlays
if(_this.overlays&&!_this.preserveOverlays){for(var i=0;i<_this.overlays.length;i++){_this.currentOverlays[i]=getOverlayObject(_this,_this.overlays[i]);}}_this._drawOverlays();_this._opening=false;/**
                     * Raised when the viewer has opened and loaded one or more TileSources.
                     *
                     * @event open
                     * @memberof OpenSeadragon.Viewer
                     * @type {object}
                     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
                     * @property {OpenSeadragon.TileSource} source - The tile source that was opened.
                     * @property {?Object} userData - Arbitrary subscriber-defined object.
                     */// TODO: what if there are multiple sources?
_this.raiseEvent('open',{source:source});}else{_this._opening=false;/**
                     * Raised when an error occurs loading a TileSource.
                     *
                     * @event open-failed
                     * @memberof OpenSeadragon.Viewer
                     * @type {object}
                     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
                     * @property {String} message - Information about what failed.
                     * @property {String} source - The tile source that failed.
                     * @property {?Object} userData - Arbitrary subscriber-defined object.
                     */_this.raiseEvent('open-failed',failEvent);}}};var doOne=function(options){if(!$.isPlainObject(options)||!options.tileSource){options={tileSource:options};}if(options.index!==undefined){$.console.error('[Viewer.open] setting indexes here is not supported; use addTiledImage instead');delete options.index;}if(options.collectionImmediately===undefined){options.collectionImmediately=true;}var originalSuccess=options.success;options.success=function(event){successes++;// TODO: now that options has other things besides tileSource, the overlays
// should probably be at the options level, not the tileSource level.
if(options.tileSource.overlays){for(var i=0;i<options.tileSource.overlays.length;i++){_this.addOverlay(options.tileSource.overlays[i]);}}if(originalSuccess){originalSuccess(event);}checkCompletion();};var originalError=options.error;options.error=function(event){failures++;if(!failEvent){failEvent=event;}if(originalError){originalError(event);}checkCompletion();};_this.addTiledImage(options);};// TileSources
for(var i=0;i<tileSources.length;i++){doOne(tileSources[i]);}return this;},/**
     * @function
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:close
     */close:function(){if(!THIS[this.hash]){//this viewer has already been destroyed: returning immediately
return this;}this._opening=false;if(this.navigator){this.navigator.close();}if(!this.preserveOverlays){this.clearOverlays();this.overlaysContainer.innerHTML="";}THIS[this.hash].animating=false;this.world.removeAll();this.imageLoader.clear();/**
         * Raised when the viewer is closed (see {@link OpenSeadragon.Viewer#close}).
         *
         * @event close
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('close');return this;},/**
     * Function to destroy the viewer and clean up everything created by OpenSeadragon.
     *
     * Example:
     * var viewer = OpenSeadragon({
     *   [...]
     * });
     *
     * //when you are done with the viewer:
     * viewer.destroy();
     * viewer = null; //important
     *
     * @function
     */destroy:function(){if(!THIS[this.hash]){//this viewer has already been destroyed: returning immediately
return;}this.close();this.clearOverlays();this.overlaysContainer.innerHTML="";//TODO: implement this...
//this.unbindSequenceControls()
//this.unbindStandardControls()
if(this.referenceStrip){this.referenceStrip.destroy();this.referenceStrip=null;}if(this._updateRequestId!==null){$.cancelAnimationFrame(this._updateRequestId);this._updateRequestId=null;}if(this.drawer){this.drawer.destroy();}this.removeAllHandlers();// Go through top element (passed to us) and remove all children
// Use removeChild to make sure it handles SVG or any non-html
// also it performs better - http://jsperf.com/innerhtml-vs-removechild/15
if(this.element){while(this.element.firstChild){this.element.removeChild(this.element.firstChild);}}// destroy the mouse trackers
if(this.innerTracker){this.innerTracker.destroy();}if(this.outerTracker){this.outerTracker.destroy();}THIS[this.hash]=null;delete THIS[this.hash];// clear all our references to dom objects
this.canvas=null;this.container=null;// clear our reference to the main element - they will need to pass it in again, creating a new viewer
this.element=null;},/**
     * @function
     * @return {Boolean}
     */isMouseNavEnabled:function(){return this.innerTracker.isTracking();},/**
     * @function
     * @param {Boolean} enabled - true to enable, false to disable
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:mouse-enabled
     */setMouseNavEnabled:function(enabled){this.innerTracker.setTracking(enabled);this.outerTracker.setTracking(enabled);/**
         * Raised when mouse/touch navigation is enabled or disabled (see {@link OpenSeadragon.Viewer#setMouseNavEnabled}).
         *
         * @event mouse-enabled
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} enabled
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('mouse-enabled',{enabled:enabled});return this;},/**
     * @function
     * @return {Boolean}
     */areControlsEnabled:function(){var enabled=this.controls.length,i;for(i=0;i<this.controls.length;i++){enabled=enabled&&this.controls[i].isVisible();}return enabled;},/**
     * Shows or hides the controls (e.g. the default navigation buttons).
     *
     * @function
     * @param {Boolean} true to show, false to hide.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:controls-enabled
     */setControlsEnabled:function(enabled){if(enabled){abortControlsAutoHide(this);}else{beginControlsAutoHide(this);}/**
         * Raised when the navigation controls are shown or hidden (see {@link OpenSeadragon.Viewer#setControlsEnabled}).
         *
         * @event controls-enabled
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} enabled
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('controls-enabled',{enabled:enabled});return this;},/**
     * Turns debugging mode on or off for this viewer.
     *
     * @function
     * @param {Boolean} true to turn debug on, false to turn debug off.
     */setDebugMode:function(debugMode){for(var i=0;i<this.world.getItemCount();i++){this.world.getItemAt(i).debugMode=debugMode;}this.debugMode=debugMode;this.forceRedraw();},/**
     * @function
     * @return {Boolean}
     */isFullPage:function(){return THIS[this.hash].fullPage;},/**
     * Toggle full page mode.
     * @function
     * @param {Boolean} fullPage
     *      If true, enter full page mode.  If false, exit full page mode.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:pre-full-page
     * @fires OpenSeadragon.Viewer.event:full-page
     */setFullPage:function(fullPage){var body=document.body,bodyStyle=body.style,docStyle=document.documentElement.style,_this=this,nodes,i;//don't bother modifying the DOM if we are already in full page mode.
if(fullPage==this.isFullPage()){return this;}var fullPageEventArgs={fullPage:fullPage,preventDefaultAction:false};/**
         * Raised when the viewer is about to change to/from full-page mode (see {@link OpenSeadragon.Viewer#setFullPage}).
         *
         * @event pre-full-page
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} fullPage - True if entering full-page mode, false if exiting full-page mode.
         * @property {Boolean} preventDefaultAction - Set to true to prevent full-page mode change. Default: false.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('pre-full-page',fullPageEventArgs);if(fullPageEventArgs.preventDefaultAction){return this;}if(fullPage){this.elementSize=$.getElementSize(this.element);this.pageScroll=$.getPageScroll();this.elementMargin=this.element.style.margin;this.element.style.margin="0";this.elementPadding=this.element.style.padding;this.element.style.padding="0";this.bodyMargin=bodyStyle.margin;this.docMargin=docStyle.margin;bodyStyle.margin="0";docStyle.margin="0";this.bodyPadding=bodyStyle.padding;this.docPadding=docStyle.padding;bodyStyle.padding="0";docStyle.padding="0";this.bodyWidth=bodyStyle.width;this.docWidth=docStyle.width;bodyStyle.width="100%";docStyle.width="100%";this.bodyHeight=bodyStyle.height;this.docHeight=docStyle.height;bodyStyle.height="100%";docStyle.height="100%";//when entering full screen on the ipad it wasn't sufficient to leave
//the body intact as only only the top half of the screen would
//respond to touch events on the canvas, while the bottom half treated
//them as touch events on the document body.  Thus we remove and store
//the bodies elements and replace them when we leave full screen.
this.previousBody=[];THIS[this.hash].prevElementParent=this.element.parentNode;THIS[this.hash].prevNextSibling=this.element.nextSibling;THIS[this.hash].prevElementWidth=this.element.style.width;THIS[this.hash].prevElementHeight=this.element.style.height;nodes=body.childNodes.length;for(i=0;i<nodes;i++){this.previousBody.push(body.childNodes[0]);body.removeChild(body.childNodes[0]);}//If we've got a toolbar, we need to enable the user to use css to
//preserve it in fullpage mode
if(this.toolbar&&this.toolbar.element){//save a reference to the parent so we can put it back
//in the long run we need a better strategy
this.toolbar.parentNode=this.toolbar.element.parentNode;this.toolbar.nextSibling=this.toolbar.element.nextSibling;body.appendChild(this.toolbar.element);//Make sure the user has some ability to style the toolbar based
//on the mode
$.addClass(this.toolbar.element,'fullpage');}$.addClass(this.element,'fullpage');body.appendChild(this.element);this.element.style.height=$.getWindowSize().y+'px';this.element.style.width=$.getWindowSize().x+'px';if(this.toolbar&&this.toolbar.element){this.element.style.height=$.getElementSize(this.element).y-$.getElementSize(this.toolbar.element).y+'px';}THIS[this.hash].fullPage=true;// mouse will be inside container now
$.delegate(this,onContainerEnter)({});}else{this.element.style.margin=this.elementMargin;this.element.style.padding=this.elementPadding;bodyStyle.margin=this.bodyMargin;docStyle.margin=this.docMargin;bodyStyle.padding=this.bodyPadding;docStyle.padding=this.docPadding;bodyStyle.width=this.bodyWidth;docStyle.width=this.docWidth;bodyStyle.height=this.bodyHeight;docStyle.height=this.docHeight;body.removeChild(this.element);nodes=this.previousBody.length;for(i=0;i<nodes;i++){body.appendChild(this.previousBody.shift());}$.removeClass(this.element,'fullpage');THIS[this.hash].prevElementParent.insertBefore(this.element,THIS[this.hash].prevNextSibling);//If we've got a toolbar, we need to enable the user to use css to
//reset it to its original state
if(this.toolbar&&this.toolbar.element){body.removeChild(this.toolbar.element);//Make sure the user has some ability to style the toolbar based
//on the mode
$.removeClass(this.toolbar.element,'fullpage');this.toolbar.parentNode.insertBefore(this.toolbar.element,this.toolbar.nextSibling);delete this.toolbar.parentNode;delete this.toolbar.nextSibling;}this.element.style.width=THIS[this.hash].prevElementWidth;this.element.style.height=THIS[this.hash].prevElementHeight;// After exiting fullPage or fullScreen, it can take some time
// before the browser can actually set the scroll.
var restoreScrollCounter=0;var restoreScroll=function(){$.setPageScroll(_this.pageScroll);var pageScroll=$.getPageScroll();restoreScrollCounter++;if(restoreScrollCounter<10&&(pageScroll.x!==_this.pageScroll.x||pageScroll.y!==_this.pageScroll.y)){$.requestAnimationFrame(restoreScroll);}};$.requestAnimationFrame(restoreScroll);THIS[this.hash].fullPage=false;// mouse will likely be outside now
$.delegate(this,onContainerExit)({});}if(this.navigator&&this.viewport){this.navigator.update(this.viewport);}/**
         * Raised when the viewer has changed to/from full-page mode (see {@link OpenSeadragon.Viewer#setFullPage}).
         *
         * @event full-page
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} fullPage - True if changed to full-page mode, false if exited full-page mode.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('full-page',{fullPage:fullPage});return this;},/**
     * Toggle full screen mode if supported. Toggle full page mode otherwise.
     * @function
     * @param {Boolean} fullScreen
     *      If true, enter full screen mode.  If false, exit full screen mode.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:pre-full-screen
     * @fires OpenSeadragon.Viewer.event:full-screen
     */setFullScreen:function(fullScreen){var _this=this;if(!$.supportsFullScreen){return this.setFullPage(fullScreen);}if($.isFullScreen()===fullScreen){return this;}var fullScreeEventArgs={fullScreen:fullScreen,preventDefaultAction:false};/**
         * Raised when the viewer is about to change to/from full-screen mode (see {@link OpenSeadragon.Viewer#setFullScreen}).
         * Note: the pre-full-screen event is not raised when the user is exiting
         * full-screen mode by pressing the Esc key. In that case, consider using
         * the full-screen, pre-full-page or full-page events.
         *
         * @event pre-full-screen
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} fullScreen - True if entering full-screen mode, false if exiting full-screen mode.
         * @property {Boolean} preventDefaultAction - Set to true to prevent full-screen mode change. Default: false.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('pre-full-screen',fullScreeEventArgs);if(fullScreeEventArgs.preventDefaultAction){return this;}if(fullScreen){this.setFullPage(true);// If the full page mode is not actually entered, we need to prevent
// the full screen mode.
if(!this.isFullPage()){return this;}this.fullPageStyleWidth=this.element.style.width;this.fullPageStyleHeight=this.element.style.height;this.element.style.width='100%';this.element.style.height='100%';var onFullScreenChange=function(){var isFullScreen=$.isFullScreen();if(!isFullScreen){$.removeEvent(document,$.fullScreenEventName,onFullScreenChange);$.removeEvent(document,$.fullScreenErrorEventName,onFullScreenChange);_this.setFullPage(false);if(_this.isFullPage()){_this.element.style.width=_this.fullPageStyleWidth;_this.element.style.height=_this.fullPageStyleHeight;}}if(_this.navigator&&_this.viewport){//09/08/2018 - Fabroh : Fix issue #1504 : Ensure to get the navigator updated on fullscreen out with custom location with a timeout
setTimeout(function(){_this.navigator.update(_this.viewport);});}/**
                 * Raised when the viewer has changed to/from full-screen mode (see {@link OpenSeadragon.Viewer#setFullScreen}).
                 *
                 * @event full-screen
                 * @memberof OpenSeadragon.Viewer
                 * @type {object}
                 * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
                 * @property {Boolean} fullScreen - True if changed to full-screen mode, false if exited full-screen mode.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */_this.raiseEvent('full-screen',{fullScreen:isFullScreen});};$.addEvent(document,$.fullScreenEventName,onFullScreenChange);$.addEvent(document,$.fullScreenErrorEventName,onFullScreenChange);$.requestFullScreen(document.body);}else{$.exitFullScreen();}return this;},/**
     * @function
     * @return {Boolean}
     */isVisible:function(){return this.container.style.visibility!="hidden";},/**
     * @function
     * @param {Boolean} visible
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:visible
     */setVisible:function(visible){this.container.style.visibility=visible?"":"hidden";/**
         * Raised when the viewer is shown or hidden (see {@link OpenSeadragon.Viewer#setVisible}).
         *
         * @event visible
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Boolean} visible
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('visible',{visible:visible});return this;},/**
     * Add a tiled image to the viewer.
     * options.tileSource can be anything that {@link OpenSeadragon.Viewer#open}
     *  supports except arrays of images.
     * Note that you can specify options.width or options.height, but not both.
     * The other dimension will be calculated according to the item's aspect ratio.
     * If collectionMode is on (see {@link OpenSeadragon.Options}), the new image is
     * automatically arranged with the others.
     * @function
     * @param {Object} options
     * @param {String|Object|Function} options.tileSource - The TileSource specifier.
     * A String implies a url used to determine the tileSource implementation
     *      based on the file extension of url. JSONP is implied by *.js,
     *      otherwise the url is retrieved as text and the resulting text is
     *      introspected to determine if its json, xml, or text and parsed.
     * An Object implies an inline configuration which has a single
     *      property sufficient for being able to determine tileSource
     *      implementation. If the object has a property which is a function
     *      named 'getTileUrl', it is treated as a custom TileSource.
     * @param {Number} [options.index] The index of the item. Added on top of
     * all other items if not specified.
     * @param {Boolean} [options.replace=false] If true, the item at options.index will be
     * removed and the new item is added in its place. options.tileSource will be
     * interpreted and fetched if necessary before the old item is removed to avoid leaving
     * a gap in the world.
     * @param {Number} [options.x=0] The X position for the image in viewport coordinates.
     * @param {Number} [options.y=0] The Y position for the image in viewport coordinates.
     * @param {Number} [options.width=1] The width for the image in viewport coordinates.
     * @param {Number} [options.height] The height for the image in viewport coordinates.
     * @param {OpenSeadragon.Rect} [options.fitBounds] The bounds in viewport coordinates
     * to fit the image into. If specified, x, y, width and height get ignored.
     * @param {OpenSeadragon.Placement} [options.fitBoundsPlacement=OpenSeadragon.Placement.CENTER]
     * How to anchor the image in the bounds if options.fitBounds is set.
     * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
     * (portions of the image outside of this area will not be visible). Only works on
     * browsers that support the HTML5 canvas.
     * @param {Number} [options.opacity=1] Proportional opacity of the tiled images (1=opaque, 0=hidden)
     * @param {Boolean} [options.preload=false]  Default switch for loading hidden images (true loads, false blocks)
     * @param {Number} [options.degrees=0] Initial rotation of the tiled image around
     * its top left corner in degrees.
     * @param {String} [options.compositeOperation] How the image is composited onto other images.
     * @param {String} [options.crossOriginPolicy] The crossOriginPolicy for this specific image,
     * overriding viewer.crossOriginPolicy.
     * @param {Boolean} [options.ajaxWithCredentials] Whether to set withCredentials on tile AJAX
     * @param {Boolean} [options.loadTilesWithAjax]
     *      Whether to load tile data using AJAX requests.
     *      Defaults to the setting in {@link OpenSeadragon.Options}.
     * @param {Object} [options.ajaxHeaders]
     *      A set of headers to include when making tile AJAX requests.
     *      Note that these headers will be merged over any headers specified in {@link OpenSeadragon.Options}.
     *      Specifying a falsy value for a header will clear its existing value set at the Viewer level (if any).
     * requests.
     * @param {Function} [options.success] A function that gets called when the image is
     * successfully added. It's passed the event object which contains a single property:
     * "item", which is the resulting instance of TiledImage.
     * @param {Function} [options.error] A function that gets called if the image is
     * unable to be added. It's passed the error event object, which contains "message"
     * and "source" properties.
     * @param {Boolean} [options.collectionImmediately=false] If collectionMode is on,
     * specifies whether to snap to the new arrangement immediately or to animate to it.
     * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
     * @fires OpenSeadragon.World.event:add-item
     * @fires OpenSeadragon.Viewer.event:add-item-failed
     */addTiledImage:function(options){$.console.assert(options,"[Viewer.addTiledImage] options is required");$.console.assert(options.tileSource,"[Viewer.addTiledImage] options.tileSource is required");$.console.assert(!options.replace||options.index>-1&&options.index<this.world.getItemCount(),"[Viewer.addTiledImage] if options.replace is used, options.index must be a valid index in Viewer.world");var _this=this;if(options.replace){options.replaceItem=_this.world.getItemAt(options.index);}this._hideMessage();if(options.placeholderFillStyle===undefined){options.placeholderFillStyle=this.placeholderFillStyle;}if(options.opacity===undefined){options.opacity=this.opacity;}if(options.preload===undefined){options.preload=this.preload;}if(options.compositeOperation===undefined){options.compositeOperation=this.compositeOperation;}if(options.crossOriginPolicy===undefined){options.crossOriginPolicy=options.tileSource.crossOriginPolicy!==undefined?options.tileSource.crossOriginPolicy:this.crossOriginPolicy;}if(options.ajaxWithCredentials===undefined){options.ajaxWithCredentials=this.ajaxWithCredentials;}if(options.loadTilesWithAjax===undefined){options.loadTilesWithAjax=this.loadTilesWithAjax;}if(options.ajaxHeaders===undefined||options.ajaxHeaders===null){options.ajaxHeaders=this.ajaxHeaders;}else if($.isPlainObject(options.ajaxHeaders)&&$.isPlainObject(this.ajaxHeaders)){options.ajaxHeaders=$.extend({},this.ajaxHeaders,options.ajaxHeaders);}var myQueueItem={options:options};function raiseAddItemFailed(event){for(var i=0;i<_this._loadQueue.length;i++){if(_this._loadQueue[i]===myQueueItem){_this._loadQueue.splice(i,1);break;}}if(_this._loadQueue.length===0){refreshWorld(myQueueItem);}/**
             * Raised when an error occurs while adding a item.
             * @event add-item-failed
             * @memberOf OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
             * @property {String} message
             * @property {String} source
             * @property {Object} options The options passed to the addTiledImage method.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */_this.raiseEvent('add-item-failed',event);if(options.error){options.error(event);}}function refreshWorld(theItem){if(_this.collectionMode){_this.world.arrange({immediately:theItem.options.collectionImmediately,rows:_this.collectionRows,columns:_this.collectionColumns,layout:_this.collectionLayout,tileSize:_this.collectionTileSize,tileMargin:_this.collectionTileMargin});_this.world.setAutoRefigureSizes(true);}}if($.isArray(options.tileSource)){setTimeout(function(){raiseAddItemFailed({message:"[Viewer.addTiledImage] Sequences can not be added; add them one at a time instead.",source:options.tileSource,options:options});});return;}this._loadQueue.push(myQueueItem);function processReadyItems(){var queueItem,tiledImage,optionsClone;while(_this._loadQueue.length){queueItem=_this._loadQueue[0];if(!queueItem.tileSource){break;}_this._loadQueue.splice(0,1);if(queueItem.options.replace){var newIndex=_this.world.getIndexOfItem(queueItem.options.replaceItem);if(newIndex!=-1){queueItem.options.index=newIndex;}_this.world.removeItem(queueItem.options.replaceItem);}tiledImage=new $.TiledImage({viewer:_this,source:queueItem.tileSource,viewport:_this.viewport,drawer:_this.drawer,tileCache:_this.tileCache,imageLoader:_this.imageLoader,x:queueItem.options.x,y:queueItem.options.y,width:queueItem.options.width,height:queueItem.options.height,fitBounds:queueItem.options.fitBounds,fitBoundsPlacement:queueItem.options.fitBoundsPlacement,clip:queueItem.options.clip,placeholderFillStyle:queueItem.options.placeholderFillStyle,opacity:queueItem.options.opacity,preload:queueItem.options.preload,degrees:queueItem.options.degrees,compositeOperation:queueItem.options.compositeOperation,springStiffness:_this.springStiffness,animationTime:_this.animationTime,minZoomImageRatio:_this.minZoomImageRatio,wrapHorizontal:_this.wrapHorizontal,wrapVertical:_this.wrapVertical,immediateRender:_this.immediateRender,blendTime:_this.blendTime,alwaysBlend:_this.alwaysBlend,minPixelRatio:_this.minPixelRatio,smoothTileEdgesMinZoom:_this.smoothTileEdgesMinZoom,iOSDevice:_this.iOSDevice,crossOriginPolicy:queueItem.options.crossOriginPolicy,ajaxWithCredentials:queueItem.options.ajaxWithCredentials,loadTilesWithAjax:queueItem.options.loadTilesWithAjax,ajaxHeaders:queueItem.options.ajaxHeaders,debugMode:_this.debugMode});if(_this.collectionMode){_this.world.setAutoRefigureSizes(false);}_this.world.addItem(tiledImage,{index:queueItem.options.index});if(_this._loadQueue.length===0){//this restores the autoRefigureSizes flag to true.
refreshWorld(queueItem);}if(_this.world.getItemCount()===1&&!_this.preserveViewport){_this.viewport.goHome(true);}if(_this.navigator){optionsClone=$.extend({},queueItem.options,{replace:false,// navigator already removed the layer, nothing to replace
originalTiledImage:tiledImage,tileSource:queueItem.tileSource});_this.navigator.addTiledImage(optionsClone);}if(queueItem.options.success){queueItem.options.success({item:tiledImage});}}}getTileSourceImplementation(this,options.tileSource,options,function(tileSource){myQueueItem.tileSource=tileSource;// add everybody at the front of the queue that's ready to go
processReadyItems();},function(event){event.options=options;raiseAddItemFailed(event);// add everybody at the front of the queue that's ready to go
processReadyItems();});},/**
     * Add a simple image to the viewer.
     * The options are the same as the ones in {@link OpenSeadragon.Viewer#addTiledImage}
     * except for options.tileSource which is replaced by options.url.
     * @function
     * @param {Object} options - See {@link OpenSeadragon.Viewer#addTiledImage}
     * for all the options
     * @param {String} options.url - The URL of the image to add.
     * @fires OpenSeadragon.World.event:add-item
     * @fires OpenSeadragon.Viewer.event:add-item-failed
     */addSimpleImage:function(options){$.console.assert(options,"[Viewer.addSimpleImage] options is required");$.console.assert(options.url,"[Viewer.addSimpleImage] options.url is required");var opts=$.extend({},options,{tileSource:{type:'image',url:options.url}});delete opts.url;this.addTiledImage(opts);},// deprecated
addLayer:function(options){var _this=this;$.console.error("[Viewer.addLayer] this function is deprecated; use Viewer.addTiledImage() instead.");var optionsClone=$.extend({},options,{success:function(event){_this.raiseEvent("add-layer",{options:options,drawer:event.item});},error:function(event){_this.raiseEvent("add-layer-failed",event);}});this.addTiledImage(optionsClone);return this;},// deprecated
getLayerAtLevel:function(level){$.console.error("[Viewer.getLayerAtLevel] this function is deprecated; use World.getItemAt() instead.");return this.world.getItemAt(level);},// deprecated
getLevelOfLayer:function(drawer){$.console.error("[Viewer.getLevelOfLayer] this function is deprecated; use World.getIndexOfItem() instead.");return this.world.getIndexOfItem(drawer);},// deprecated
getLayersCount:function(){$.console.error("[Viewer.getLayersCount] this function is deprecated; use World.getItemCount() instead.");return this.world.getItemCount();},// deprecated
setLayerLevel:function(drawer,level){$.console.error("[Viewer.setLayerLevel] this function is deprecated; use World.setItemIndex() instead.");return this.world.setItemIndex(drawer,level);},// deprecated
removeLayer:function(drawer){$.console.error("[Viewer.removeLayer] this function is deprecated; use World.removeItem() instead.");return this.world.removeItem(drawer);},/**
     * Force the viewer to redraw its contents.
     * @returns {OpenSeadragon.Viewer} Chainable.
     */forceRedraw:function(){THIS[this.hash].forceRedraw=true;return this;},/**
     * @function
     * @return {OpenSeadragon.Viewer} Chainable.
     */bindSequenceControls:function(){//////////////////////////////////////////////////////////////////////////
// Image Sequence Controls
//////////////////////////////////////////////////////////////////////////
var onFocusHandler=$.delegate(this,onFocus),onBlurHandler=$.delegate(this,onBlur),onNextHandler=$.delegate(this,onNext),onPreviousHandler=$.delegate(this,onPrevious),navImages=this.navImages,useGroup=true;if(this.showSequenceControl){if(this.previousButton||this.nextButton){//if we are binding to custom buttons then layout and
//grouping is the responsibility of the page author
useGroup=false;}this.previousButton=new $.Button({element:this.previousButton?$.getElement(this.previousButton):null,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,tooltip:$.getString("Tooltips.PreviousPage"),srcRest:resolveUrl(this.prefixUrl,navImages.previous.REST),srcGroup:resolveUrl(this.prefixUrl,navImages.previous.GROUP),srcHover:resolveUrl(this.prefixUrl,navImages.previous.HOVER),srcDown:resolveUrl(this.prefixUrl,navImages.previous.DOWN),onRelease:onPreviousHandler,onFocus:onFocusHandler,onBlur:onBlurHandler});this.nextButton=new $.Button({element:this.nextButton?$.getElement(this.nextButton):null,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,tooltip:$.getString("Tooltips.NextPage"),srcRest:resolveUrl(this.prefixUrl,navImages.next.REST),srcGroup:resolveUrl(this.prefixUrl,navImages.next.GROUP),srcHover:resolveUrl(this.prefixUrl,navImages.next.HOVER),srcDown:resolveUrl(this.prefixUrl,navImages.next.DOWN),onRelease:onNextHandler,onFocus:onFocusHandler,onBlur:onBlurHandler});if(!this.navPrevNextWrap){this.previousButton.disable();}if(!this.tileSources||!this.tileSources.length){this.nextButton.disable();}if(useGroup){this.paging=new $.ButtonGroup({buttons:[this.previousButton,this.nextButton],clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold});this.pagingControl=this.paging.element;if(this.toolbar){this.toolbar.addControl(this.pagingControl,{anchor:$.ControlAnchor.BOTTOM_RIGHT});}else{this.addControl(this.pagingControl,{anchor:this.sequenceControlAnchor||$.ControlAnchor.TOP_LEFT});}}}return this;},/**
     * @function
     * @return {OpenSeadragon.Viewer} Chainable.
     */bindStandardControls:function(){//////////////////////////////////////////////////////////////////////////
// Navigation Controls
//////////////////////////////////////////////////////////////////////////
var beginZoomingInHandler=$.delegate(this,beginZoomingIn),endZoomingHandler=$.delegate(this,endZooming),doSingleZoomInHandler=$.delegate(this,doSingleZoomIn),beginZoomingOutHandler=$.delegate(this,beginZoomingOut),doSingleZoomOutHandler=$.delegate(this,doSingleZoomOut),onHomeHandler=$.delegate(this,onHome),onFullScreenHandler=$.delegate(this,onFullScreen),onRotateLeftHandler=$.delegate(this,onRotateLeft),onRotateRightHandler=$.delegate(this,onRotateRight),onFlipHandler=$.delegate(this,onFlip),onFocusHandler=$.delegate(this,onFocus),onBlurHandler=$.delegate(this,onBlur),navImages=this.navImages,buttons=[],useGroup=true;if(this.showNavigationControl){if(this.zoomInButton||this.zoomOutButton||this.homeButton||this.fullPageButton||this.rotateLeftButton||this.rotateRightButton||this.flipButton){//if we are binding to custom buttons then layout and
//grouping is the responsibility of the page author
useGroup=false;}if(this.showZoomControl){buttons.push(this.zoomInButton=new $.Button({element:this.zoomInButton?$.getElement(this.zoomInButton):null,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,tooltip:$.getString("Tooltips.ZoomIn"),srcRest:resolveUrl(this.prefixUrl,navImages.zoomIn.REST),srcGroup:resolveUrl(this.prefixUrl,navImages.zoomIn.GROUP),srcHover:resolveUrl(this.prefixUrl,navImages.zoomIn.HOVER),srcDown:resolveUrl(this.prefixUrl,navImages.zoomIn.DOWN),onPress:beginZoomingInHandler,onRelease:endZoomingHandler,onClick:doSingleZoomInHandler,onEnter:beginZoomingInHandler,onExit:endZoomingHandler,onFocus:onFocusHandler,onBlur:onBlurHandler}));buttons.push(this.zoomOutButton=new $.Button({element:this.zoomOutButton?$.getElement(this.zoomOutButton):null,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,tooltip:$.getString("Tooltips.ZoomOut"),srcRest:resolveUrl(this.prefixUrl,navImages.zoomOut.REST),srcGroup:resolveUrl(this.prefixUrl,navImages.zoomOut.GROUP),srcHover:resolveUrl(this.prefixUrl,navImages.zoomOut.HOVER),srcDown:resolveUrl(this.prefixUrl,navImages.zoomOut.DOWN),onPress:beginZoomingOutHandler,onRelease:endZoomingHandler,onClick:doSingleZoomOutHandler,onEnter:beginZoomingOutHandler,onExit:endZoomingHandler,onFocus:onFocusHandler,onBlur:onBlurHandler}));}if(this.showHomeControl){buttons.push(this.homeButton=new $.Button({element:this.homeButton?$.getElement(this.homeButton):null,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,tooltip:$.getString("Tooltips.Home"),srcRest:resolveUrl(this.prefixUrl,navImages.home.REST),srcGroup:resolveUrl(this.prefixUrl,navImages.home.GROUP),srcHover:resolveUrl(this.prefixUrl,navImages.home.HOVER),srcDown:resolveUrl(this.prefixUrl,navImages.home.DOWN),onRelease:onHomeHandler,onFocus:onFocusHandler,onBlur:onBlurHandler}));}if(this.showFullPageControl){buttons.push(this.fullPageButton=new $.Button({element:this.fullPageButton?$.getElement(this.fullPageButton):null,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,tooltip:$.getString("Tooltips.FullPage"),srcRest:resolveUrl(this.prefixUrl,navImages.fullpage.REST),srcGroup:resolveUrl(this.prefixUrl,navImages.fullpage.GROUP),srcHover:resolveUrl(this.prefixUrl,navImages.fullpage.HOVER),srcDown:resolveUrl(this.prefixUrl,navImages.fullpage.DOWN),onRelease:onFullScreenHandler,onFocus:onFocusHandler,onBlur:onBlurHandler}));}if(this.showRotationControl){buttons.push(this.rotateLeftButton=new $.Button({element:this.rotateLeftButton?$.getElement(this.rotateLeftButton):null,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,tooltip:$.getString("Tooltips.RotateLeft"),srcRest:resolveUrl(this.prefixUrl,navImages.rotateleft.REST),srcGroup:resolveUrl(this.prefixUrl,navImages.rotateleft.GROUP),srcHover:resolveUrl(this.prefixUrl,navImages.rotateleft.HOVER),srcDown:resolveUrl(this.prefixUrl,navImages.rotateleft.DOWN),onRelease:onRotateLeftHandler,onFocus:onFocusHandler,onBlur:onBlurHandler}));buttons.push(this.rotateRightButton=new $.Button({element:this.rotateRightButton?$.getElement(this.rotateRightButton):null,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,tooltip:$.getString("Tooltips.RotateRight"),srcRest:resolveUrl(this.prefixUrl,navImages.rotateright.REST),srcGroup:resolveUrl(this.prefixUrl,navImages.rotateright.GROUP),srcHover:resolveUrl(this.prefixUrl,navImages.rotateright.HOVER),srcDown:resolveUrl(this.prefixUrl,navImages.rotateright.DOWN),onRelease:onRotateRightHandler,onFocus:onFocusHandler,onBlur:onBlurHandler}));}if(this.showFlipControl){buttons.push(this.flipButton=new $.Button({element:this.flipButton?$.getElement(this.flipButton):null,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,tooltip:$.getString("Tooltips.Flip"),srcRest:resolveUrl(this.prefixUrl,navImages.flip.REST),srcGroup:resolveUrl(this.prefixUrl,navImages.flip.GROUP),srcHover:resolveUrl(this.prefixUrl,navImages.flip.HOVER),srcDown:resolveUrl(this.prefixUrl,navImages.flip.DOWN),onRelease:onFlipHandler,onFocus:onFocusHandler,onBlur:onBlurHandler}));}if(useGroup){this.buttons=new $.ButtonGroup({buttons:buttons,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold});this.navControl=this.buttons.element;this.addHandler('open',$.delegate(this,lightUp));if(this.toolbar){this.toolbar.addControl(this.navControl,{anchor:this.navigationControlAnchor||$.ControlAnchor.TOP_LEFT});}else{this.addControl(this.navControl,{anchor:this.navigationControlAnchor||$.ControlAnchor.TOP_LEFT});}}}return this;},/**
     * Gets the active page of a sequence
     * @function
     * @return {Number}
     */currentPage:function(){return this._sequenceIndex;},/**
     * @function
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:page
     */goToPage:function(page){if(this.tileSources&&page>=0&&page<this.tileSources.length){this._sequenceIndex=page;this._updateSequenceButtons(page);this.open(this.tileSources[page]);if(this.referenceStrip){this.referenceStrip.setFocus(page);}/**
             * Raised when the page is changed on a viewer configured with multiple image sources (see {@link OpenSeadragon.Viewer#goToPage}).
             *
             * @event page
             * @memberof OpenSeadragon.Viewer
             * @type {Object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
             * @property {Number} page - The page index.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.raiseEvent('page',{page:page});}return this;},/**
     * Adds an html element as an overlay to the current viewport.  Useful for
     * highlighting words or areas of interest on an image or other zoomable
     * interface. The overlays added via this method are removed when the viewport
     * is closed which include when changing page.
     * @method
     * @param {Element|String|Object} element - A reference to an element or an id for
     *      the element which will be overlaid. Or an Object specifying the configuration for the overlay.
     *      If using an object, see {@link OpenSeadragon.Overlay} for a list of
     *      all available options.
     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
     *      rectangle which will be overlaid. This is a viewport relative location.
     * @param {OpenSeadragon.Placement} [placement=OpenSeadragon.Placement.TOP_LEFT] - The position of the
     *      viewport which the location coordinates will be treated as relative
     *      to.
     * @param {function} [onDraw] - If supplied the callback is called when the overlay
     *      needs to be drawn. It it the responsibility of the callback to do any drawing/positioning.
     *      It is passed position, size and element.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:add-overlay
     */addOverlay:function(element,location,placement,onDraw){var options;if($.isPlainObject(element)){options=element;}else{options={element:element,location:location,placement:placement,onDraw:onDraw};}element=$.getElement(options.element);if(getOverlayIndex(this.currentOverlays,element)>=0){// they're trying to add a duplicate overlay
return this;}var overlay=getOverlayObject(this,options);this.currentOverlays.push(overlay);overlay.drawHTML(this.overlaysContainer,this.viewport);/**
         * Raised when an overlay is added to the viewer (see {@link OpenSeadragon.Viewer#addOverlay}).
         *
         * @event add-overlay
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Element} element - The overlay element.
         * @property {OpenSeadragon.Point|OpenSeadragon.Rect} location
         * @property {OpenSeadragon.Placement} placement
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('add-overlay',{element:element,location:options.location,placement:options.placement});return this;},/**
     * Updates the overlay represented by the reference to the element or
     * element id moving it to the new location, relative to the new placement.
     * @method
     * @param {Element|String} element - A reference to an element or an id for
     *      the element which is overlaid.
     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} location - The point or
     *      rectangle which will be overlaid. This is a viewport relative location.
     * @param {OpenSeadragon.Placement} [placement=OpenSeadragon.Placement.TOP_LEFT] - The position of the
     *      viewport which the location coordinates will be treated as relative
     *      to.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:update-overlay
     */updateOverlay:function(element,location,placement){var i;element=$.getElement(element);i=getOverlayIndex(this.currentOverlays,element);if(i>=0){this.currentOverlays[i].update(location,placement);THIS[this.hash].forceRedraw=true;/**
             * Raised when an overlay's location or placement changes
             * (see {@link OpenSeadragon.Viewer#updateOverlay}).
             *
             * @event update-overlay
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the
             * Viewer which raised the event.
             * @property {Element} element
             * @property {OpenSeadragon.Point|OpenSeadragon.Rect} location
             * @property {OpenSeadragon.Placement} placement
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.raiseEvent('update-overlay',{element:element,location:location,placement:placement});}return this;},/**
     * Removes an overlay identified by the reference element or element id
     * and schedules an update.
     * @method
     * @param {Element|String} element - A reference to the element or an
     *      element id which represent the ovelay content to be removed.
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:remove-overlay
     */removeOverlay:function(element){var i;element=$.getElement(element);i=getOverlayIndex(this.currentOverlays,element);if(i>=0){this.currentOverlays[i].destroy();this.currentOverlays.splice(i,1);THIS[this.hash].forceRedraw=true;/**
             * Raised when an overlay is removed from the viewer
             * (see {@link OpenSeadragon.Viewer#removeOverlay}).
             *
             * @event remove-overlay
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the
             * Viewer which raised the event.
             * @property {Element} element - The overlay element.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.raiseEvent('remove-overlay',{element:element});}return this;},/**
     * Removes all currently configured Overlays from this Viewer and schedules
     * an update.
     * @method
     * @return {OpenSeadragon.Viewer} Chainable.
     * @fires OpenSeadragon.Viewer.event:clear-overlay
     */clearOverlays:function(){while(this.currentOverlays.length>0){this.currentOverlays.pop().destroy();}THIS[this.hash].forceRedraw=true;/**
         * Raised when all overlays are removed from the viewer (see {@link OpenSeadragon.Drawer#clearOverlays}).
         *
         * @event clear-overlay
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('clear-overlay',{});return this;},/**
     * Finds an overlay identified by the reference element or element id
     * and returns it as an object, return null if not found.
     * @method
     * @param {Element|String} element - A reference to the element or an
     *      element id which represents the overlay content.
     * @return {OpenSeadragon.Overlay} the matching overlay or null if none found.
     */getOverlayById:function(element){var i;element=$.getElement(element);i=getOverlayIndex(this.currentOverlays,element);if(i>=0){return this.currentOverlays[i];}else{return null;}},/**
     * Updates the sequence buttons.
     * @function OpenSeadragon.Viewer.prototype._updateSequenceButtons
     * @private
     * @param {Number} Sequence Value
     */_updateSequenceButtons:function(page){if(this.nextButton){if(!this.tileSources||this.tileSources.length-1===page){//Disable next button
if(!this.navPrevNextWrap){this.nextButton.disable();}}else{this.nextButton.enable();}}if(this.previousButton){if(page>0){//Enable previous button
this.previousButton.enable();}else{if(!this.navPrevNextWrap){this.previousButton.disable();}}}},/**
     * Display a message in the viewport
     * @function OpenSeadragon.Viewer.prototype._showMessage
     * @private
     * @param {String} text message
     */_showMessage:function(message){this._hideMessage();var div=$.makeNeutralElement("div");div.appendChild(document.createTextNode(message));this.messageDiv=$.makeCenteredNode(div);$.addClass(this.messageDiv,"openseadragon-message");this.container.appendChild(this.messageDiv);},/**
     * Hide any currently displayed viewport message
     * @function OpenSeadragon.Viewer.prototype._hideMessage
     * @private
     */_hideMessage:function(){var div=this.messageDiv;if(div){div.parentNode.removeChild(div);delete this.messageDiv;}},/**
     * Gets this viewer's gesture settings for the given pointer device type.
     * @method
     * @param {String} type - The pointer device type to get the gesture settings for ("mouse", "touch", "pen", etc.).
     * @return {OpenSeadragon.GestureSettings}
     */gestureSettingsByDeviceType:function(type){switch(type){case'mouse':return this.gestureSettingsMouse;case'touch':return this.gestureSettingsTouch;case'pen':return this.gestureSettingsPen;default:return this.gestureSettingsUnknown;}},// private
_drawOverlays:function(){var i,length=this.currentOverlays.length;for(i=0;i<length;i++){this.currentOverlays[i].drawHTML(this.overlaysContainer,this.viewport);}},/**
     * Cancel the "in flight" images.
     */_cancelPendingImages:function(){this._loadQueue=[];},/**
     * Removes the reference strip and disables displaying it.
     * @function
     */removeReferenceStrip:function(){this.showReferenceStrip=false;if(this.referenceStrip){this.referenceStrip.destroy();this.referenceStrip=null;}},/**
     * Enables and displays the reference strip based on the currently set tileSources.
     * Works only when the Viewer has sequenceMode set to true.
     * @function
     */addReferenceStrip:function(){this.showReferenceStrip=true;if(this.sequenceMode){if(this.referenceStrip){return;}if(this.tileSources.length&&this.tileSources.length>1){this.referenceStrip=new $.ReferenceStrip({id:this.referenceStripElement,position:this.referenceStripPosition,sizeRatio:this.referenceStripSizeRatio,scroll:this.referenceStripScroll,height:this.referenceStripHeight,width:this.referenceStripWidth,tileSources:this.tileSources,prefixUrl:this.prefixUrl,useCanvas:this.useCanvas,viewer:this});this.referenceStrip.setFocus(this._sequenceIndex);}}else{$.console.warn('Attempting to display a reference strip while "sequenceMode" is off.');}}});/**
 * _getSafeElemSize is like getElementSize(), but refuses to return 0 for x or y,
 * which was causing some calling operations to return NaN.
 * @returns {Point}
 * @private
 */function _getSafeElemSize(oElement){oElement=$.getElement(oElement);return new $.Point(oElement.clientWidth===0?1:oElement.clientWidth,oElement.clientHeight===0?1:oElement.clientHeight);}/**
 * @function
 * @private
 */function getTileSourceImplementation(viewer,tileSource,imgOptions,successCallback,failCallback){var _this=viewer;//allow plain xml strings or json strings to be parsed here
if($.type(tileSource)=='string'){//xml should start with "<" and end with ">"
if(tileSource.match(/^\s*<.*>\s*$/)){tileSource=$.parseXml(tileSource);//json should start with "{" or "[" and end with "}" or "]"
}else if(tileSource.match(/^\s*[\{\[].*[\}\]]\s*$/)){try{var tileSourceJ=$.parseJSON(tileSource);tileSource=tileSourceJ;}catch(e){//tileSource = tileSource;
}}}function waitUntilReady(tileSource,originalTileSource){if(tileSource.ready){successCallback(tileSource);}else{tileSource.addHandler('ready',function(){successCallback(tileSource);});tileSource.addHandler('open-failed',function(event){failCallback({message:event.message,source:originalTileSource});});}}setTimeout(function(){if($.type(tileSource)=='string'){//If its still a string it means it must be a url at this point
tileSource=new $.TileSource({url:tileSource,crossOriginPolicy:imgOptions.crossOriginPolicy!==undefined?imgOptions.crossOriginPolicy:viewer.crossOriginPolicy,ajaxWithCredentials:viewer.ajaxWithCredentials,ajaxHeaders:viewer.ajaxHeaders,useCanvas:viewer.useCanvas,success:function(event){successCallback(event.tileSource);}});tileSource.addHandler('open-failed',function(event){failCallback(event);});}else if($.isPlainObject(tileSource)||tileSource.nodeType){if(tileSource.crossOriginPolicy===undefined&&(imgOptions.crossOriginPolicy!==undefined||viewer.crossOriginPolicy!==undefined)){tileSource.crossOriginPolicy=imgOptions.crossOriginPolicy!==undefined?imgOptions.crossOriginPolicy:viewer.crossOriginPolicy;}if(tileSource.ajaxWithCredentials===undefined){tileSource.ajaxWithCredentials=viewer.ajaxWithCredentials;}if(tileSource.useCanvas===undefined){tileSource.useCanvas=viewer.useCanvas;}if($.isFunction(tileSource.getTileUrl)){//Custom tile source
var customTileSource=new $.TileSource(tileSource);customTileSource.getTileUrl=tileSource.getTileUrl;successCallback(customTileSource);}else{//inline configuration
var $TileSource=$.TileSource.determineType(_this,tileSource);if(!$TileSource){failCallback({message:"Unable to load TileSource",source:tileSource});return;}var options=$TileSource.prototype.configure.apply(_this,[tileSource]);waitUntilReady(new $TileSource(options),tileSource);}}else{//can assume it's already a tile source implementation
waitUntilReady(tileSource,tileSource);}});}function getOverlayObject(viewer,overlay){if(overlay instanceof $.Overlay){return overlay;}var element=null;if(overlay.element){element=$.getElement(overlay.element);}else{var id=overlay.id?overlay.id:"openseadragon-overlay-"+Math.floor(Math.random()*10000000);element=$.getElement(overlay.id);if(!element){element=document.createElement("a");element.href="#/overlay/"+id;}element.id=id;$.addClass(element,overlay.className?overlay.className:"openseadragon-overlay");}var location=overlay.location;var width=overlay.width;var height=overlay.height;if(!location){var x=overlay.x;var y=overlay.y;if(overlay.px!==undefined){var rect=viewer.viewport.imageToViewportRectangle(new $.Rect(overlay.px,overlay.py,width||0,height||0));x=rect.x;y=rect.y;width=width!==undefined?rect.width:undefined;height=height!==undefined?rect.height:undefined;}location=new $.Point(x,y);}var placement=overlay.placement;if(placement&&$.type(placement)==="string"){placement=$.Placement[overlay.placement.toUpperCase()];}return new $.Overlay({element:element,location:location,placement:placement,onDraw:overlay.onDraw,checkResize:overlay.checkResize,width:width,height:height,rotationMode:overlay.rotationMode});}/**
 * @private
 * @inner
 * Determines the index of the given overlay in the given overlays array.
 */function getOverlayIndex(overlays,element){var i;for(i=overlays.length-1;i>=0;i--){if(overlays[i].element===element){return i;}}return-1;}///////////////////////////////////////////////////////////////////////////////
// Schedulers provide the general engine for animation
///////////////////////////////////////////////////////////////////////////////
function scheduleUpdate(viewer,updateFunc){return $.requestAnimationFrame(function(){updateFunc(viewer);});}//provides a sequence in the fade animation
function scheduleControlsFade(viewer){$.requestAnimationFrame(function(){updateControlsFade(viewer);});}//initiates an animation to hide the controls
function beginControlsAutoHide(viewer){if(!viewer.autoHideControls){return;}viewer.controlsShouldFade=true;viewer.controlsFadeBeginTime=$.now()+viewer.controlsFadeDelay;window.setTimeout(function(){scheduleControlsFade(viewer);},viewer.controlsFadeDelay);}//determines if fade animation is done or continues the animation
function updateControlsFade(viewer){var currentTime,deltaTime,opacity,i;if(viewer.controlsShouldFade){currentTime=$.now();deltaTime=currentTime-viewer.controlsFadeBeginTime;opacity=1.0-deltaTime/viewer.controlsFadeLength;opacity=Math.min(1.0,opacity);opacity=Math.max(0.0,opacity);for(i=viewer.controls.length-1;i>=0;i--){if(viewer.controls[i].autoFade){viewer.controls[i].setOpacity(opacity);}}if(opacity>0){// fade again
scheduleControlsFade(viewer);}}}//stop the fade animation on the controls and show them
function abortControlsAutoHide(viewer){var i;viewer.controlsShouldFade=false;for(i=viewer.controls.length-1;i>=0;i--){viewer.controls[i].setOpacity(1.0);}}///////////////////////////////////////////////////////////////////////////////
// Default view event handlers.
///////////////////////////////////////////////////////////////////////////////
function onFocus(){abortControlsAutoHide(this);}function onBlur(){beginControlsAutoHide(this);}function onCanvasKeyDown(event){var canvasKeyDownEventArgs={originalEvent:event.originalEvent,preventDefaultAction:event.preventDefaultAction,preventVerticalPan:event.preventVerticalPan,preventHorizontalPan:event.preventHorizontalPan};/**
     * Raised when a keyboard key is pressed and the focus is on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-key
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default keyboard behaviour. Default: false.
     * @property {Boolean} preventVerticalPan - Set to true to prevent keyboard vertical panning. Default: false.
     * @property {Boolean} preventHorizontalPan - Set to true to prevent keyboard horizontal panning. Default: false.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-key',canvasKeyDownEventArgs);if(!canvasKeyDownEventArgs.preventDefaultAction&&!event.ctrl&&!event.alt&&!event.meta){switch(event.keyCode){case 38://up arrow
if(!canvasKeyDownEventArgs.preventVerticalPan){if(event.shift){this.viewport.zoomBy(1.1);}else{this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0,-this.pixelsPerArrowPress)));}this.viewport.applyConstraints();}return false;case 40://down arrow
if(!canvasKeyDownEventArgs.preventVerticalPan){if(event.shift){this.viewport.zoomBy(0.9);}else{this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0,this.pixelsPerArrowPress)));}this.viewport.applyConstraints();}return false;case 37://left arrow
if(!canvasKeyDownEventArgs.preventHorizontalPan){this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(-this.pixelsPerArrowPress,0)));this.viewport.applyConstraints();}return false;case 39://right arrow
if(!canvasKeyDownEventArgs.preventHorizontalPan){this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(this.pixelsPerArrowPress,0)));this.viewport.applyConstraints();}return false;default://console.log( 'navigator keycode %s', event.keyCode );
return true;}}else{return true;}}function onCanvasKeyPress(event){var canvasKeyPressEventArgs={originalEvent:event.originalEvent,preventDefaultAction:event.preventDefaultAction,preventVerticalPan:event.preventVerticalPan,preventHorizontalPan:event.preventHorizontalPan};// This event is documented in onCanvasKeyDown
this.raiseEvent('canvas-key',canvasKeyPressEventArgs);if(!canvasKeyPressEventArgs.preventDefaultAction&&!event.ctrl&&!event.alt&&!event.meta){switch(event.keyCode){case 43://=|+
case 61://=|+
this.viewport.zoomBy(1.1);this.viewport.applyConstraints();return false;case 45://-|_
this.viewport.zoomBy(0.9);this.viewport.applyConstraints();return false;case 48://0|)
this.viewport.goHome();this.viewport.applyConstraints();return false;case 119://w
case 87://W
if(!canvasKeyPressEventArgs.preventVerticalPan){if(event.shift){this.viewport.zoomBy(1.1);}else{this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0,-40)));}this.viewport.applyConstraints();}return false;case 115://s
case 83://S
if(!canvasKeyPressEventArgs.preventVerticalPan){if(event.shift){this.viewport.zoomBy(0.9);}else{this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(0,40)));}this.viewport.applyConstraints();}return false;case 97://a
if(!canvasKeyPressEventArgs.preventHorizontalPan){this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(-40,0)));this.viewport.applyConstraints();}return false;case 100://d
if(!canvasKeyPressEventArgs.preventHorizontalPan){this.viewport.panBy(this.viewport.deltaPointsFromPixels(new $.Point(40,0)));this.viewport.applyConstraints();}return false;case 114://r - clockwise rotation
if(this.viewport.flipped){this.viewport.setRotation($.positiveModulo(this.viewport.degrees-this.rotationIncrement,360));}else{this.viewport.setRotation($.positiveModulo(this.viewport.degrees+this.rotationIncrement,360));}this.viewport.applyConstraints();return false;case 82://R - counterclockwise  rotation
if(this.viewport.flipped){this.viewport.setRotation($.positiveModulo(this.viewport.degrees+this.rotationIncrement,360));}else{this.viewport.setRotation($.positiveModulo(this.viewport.degrees-this.rotationIncrement,360));}this.viewport.applyConstraints();return false;case 102://f
this.viewport.toggleFlip();return false;default:// console.log( 'navigator keycode %s', event.keyCode );
return true;}}else{return true;}}function onCanvasClick(event){var gestureSettings;var haveKeyboardFocus=document.activeElement==this.canvas;// If we don't have keyboard focus, request it.
if(!haveKeyboardFocus){this.canvas.focus();}if(this.viewport.flipped){event.position.x=this.viewport.getContainerSize().x-event.position.x;}var canvasClickEventArgs={tracker:event.eventSource,position:event.position,quick:event.quick,shift:event.shift,originalEvent:event.originalEvent,preventDefaultAction:event.preventDefaultAction};/**
     * Raised when a mouse press/release or touch/remove occurs on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-click
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Boolean} quick - True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for differentiating between clicks and drags.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default click to zoom behaviour. Default: false.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-click',canvasClickEventArgs);if(!canvasClickEventArgs.preventDefaultAction&&this.viewport&&event.quick){gestureSettings=this.gestureSettingsByDeviceType(event.pointerType);if(gestureSettings.clickToZoom){this.viewport.zoomBy(event.shift?1.0/this.zoomPerClick:this.zoomPerClick,gestureSettings.zoomToRefPoint?this.viewport.pointFromPixel(event.position,true):null);this.viewport.applyConstraints();}}}function onCanvasDblClick(event){var gestureSettings;var canvasDblClickEventArgs={tracker:event.eventSource,position:event.position,shift:event.shift,originalEvent:event.originalEvent,preventDefaultAction:event.preventDefaultAction};/**
     * Raised when a double mouse press/release or touch/remove occurs on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-double-click
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default double tap to zoom behaviour. Default: false.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-double-click',canvasDblClickEventArgs);if(!canvasDblClickEventArgs.preventDefaultAction&&this.viewport){gestureSettings=this.gestureSettingsByDeviceType(event.pointerType);if(gestureSettings.dblClickToZoom){this.viewport.zoomBy(event.shift?1.0/this.zoomPerClick:this.zoomPerClick,gestureSettings.zoomToRefPoint?this.viewport.pointFromPixel(event.position,true):null);this.viewport.applyConstraints();}}}function onCanvasDrag(event){var gestureSettings;var canvasDragEventArgs={tracker:event.eventSource,position:event.position,delta:event.delta,speed:event.speed,direction:event.direction,shift:event.shift,originalEvent:event.originalEvent,preventDefaultAction:event.preventDefaultAction};/**
     * Raised when a mouse or touch drag operation occurs on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-drag
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {OpenSeadragon.Point} delta - The x,y components of the difference between start drag and end drag.
     * @property {Number} speed - Current computed speed, in pixels per second.
     * @property {Number} direction - Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default drag behaviour. Default: false.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-drag',canvasDragEventArgs);if(!canvasDragEventArgs.preventDefaultAction&&this.viewport){gestureSettings=this.gestureSettingsByDeviceType(event.pointerType);if(!this.panHorizontal){event.delta.x=0;}if(!this.panVertical){event.delta.y=0;}if(this.viewport.flipped){event.delta.x=-event.delta.x;}if(this.constrainDuringPan){var delta=this.viewport.deltaPointsFromPixels(event.delta.negate());this.viewport.centerSpringX.target.value+=delta.x;this.viewport.centerSpringY.target.value+=delta.y;var bounds=this.viewport.getBounds();var constrainedBounds=this.viewport.getConstrainedBounds();this.viewport.centerSpringX.target.value-=delta.x;this.viewport.centerSpringY.target.value-=delta.y;if(bounds.x!=constrainedBounds.x){event.delta.x=0;}if(bounds.y!=constrainedBounds.y){event.delta.y=0;}}this.viewport.panBy(this.viewport.deltaPointsFromPixels(event.delta.negate()),gestureSettings.flickEnabled&&!this.constrainDuringPan);}}function onCanvasDragEnd(event){if(!event.preventDefaultAction&&this.viewport){var gestureSettings=this.gestureSettingsByDeviceType(event.pointerType);if(gestureSettings.flickEnabled&&event.speed>=gestureSettings.flickMinSpeed){var amplitudeX=0;if(this.panHorizontal){amplitudeX=gestureSettings.flickMomentum*event.speed*Math.cos(event.direction);}var amplitudeY=0;if(this.panVertical){amplitudeY=gestureSettings.flickMomentum*event.speed*Math.sin(event.direction);}var center=this.viewport.pixelFromPoint(this.viewport.getCenter(true));var target=this.viewport.pointFromPixel(new $.Point(center.x-amplitudeX,center.y-amplitudeY));this.viewport.panTo(target,false);}this.viewport.applyConstraints();}/**
     * Raised when a mouse or touch drag operation ends on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-drag-end
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} speed - Speed at the end of a drag gesture, in pixels per second.
     * @property {Number} direction - Direction at the end of a drag gesture, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-drag-end',{tracker:event.eventSource,position:event.position,speed:event.speed,direction:event.direction,shift:event.shift,originalEvent:event.originalEvent});}function onCanvasEnter(event){/**
     * Raised when a pointer enters the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-enter
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-enter',{tracker:event.eventSource,pointerType:event.pointerType,position:event.position,buttons:event.buttons,pointers:event.pointers,insideElementPressed:event.insideElementPressed,buttonDownAny:event.buttonDownAny,originalEvent:event.originalEvent});}function onCanvasExit(event){if(window.location!=window.parent.location){$.MouseTracker.resetAllMouseTrackers();}/**
     * Raised when a pointer leaves the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-exit
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-exit',{tracker:event.eventSource,pointerType:event.pointerType,position:event.position,buttons:event.buttons,pointers:event.pointers,insideElementPressed:event.insideElementPressed,buttonDownAny:event.buttonDownAny,originalEvent:event.originalEvent});}function onCanvasPress(event){/**
     * Raised when the primary mouse button is pressed or touch starts on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-press
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} insideElementReleased - True if the cursor still inside the tracked element when the button was released.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-press',{tracker:event.eventSource,pointerType:event.pointerType,position:event.position,insideElementPressed:event.insideElementPressed,insideElementReleased:event.insideElementReleased,originalEvent:event.originalEvent});}function onCanvasRelease(event){/**
     * Raised when the primary mouse button is released or touch ends on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-release
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} insideElementReleased - True if the cursor still inside the tracked element when the button was released.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-release',{tracker:event.eventSource,pointerType:event.pointerType,position:event.position,insideElementPressed:event.insideElementPressed,insideElementReleased:event.insideElementReleased,originalEvent:event.originalEvent});}function onCanvasNonPrimaryPress(event){/**
     * Raised when any non-primary pointer button is pressed on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-nonprimary-press
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {Number} button - Button which caused the event.
     *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
     * @property {Number} buttons - Current buttons pressed.
     *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-nonprimary-press',{tracker:event.eventSource,position:event.position,pointerType:event.pointerType,button:event.button,buttons:event.buttons,originalEvent:event.originalEvent});}function onCanvasNonPrimaryRelease(event){/**
     * Raised when any non-primary pointer button is released on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-nonprimary-release
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {String} pointerType - "mouse", "touch", "pen", etc.
     * @property {Number} button - Button which caused the event.
     *      -1: none, 0: primary/left, 1: aux/middle, 2: secondary/right, 3: X1/back, 4: X2/forward, 5: pen eraser.
     * @property {Number} buttons - Current buttons pressed.
     *      Combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-nonprimary-release',{tracker:event.eventSource,position:event.position,pointerType:event.pointerType,button:event.button,buttons:event.buttons,originalEvent:event.originalEvent});}function onCanvasPinch(event){var gestureSettings,centerPt,lastCenterPt,panByPt;if(!event.preventDefaultAction&&this.viewport){gestureSettings=this.gestureSettingsByDeviceType(event.pointerType);if(gestureSettings.pinchToZoom){centerPt=this.viewport.pointFromPixel(event.center,true);lastCenterPt=this.viewport.pointFromPixel(event.lastCenter,true);panByPt=lastCenterPt.minus(centerPt);if(!this.panHorizontal){panByPt.x=0;}if(!this.panVertical){panByPt.y=0;}this.viewport.zoomBy(event.distance/event.lastDistance,centerPt,true);if(gestureSettings.zoomToRefPoint){this.viewport.panBy(panByPt,true);}this.viewport.applyConstraints();}if(gestureSettings.pinchRotate){// Pinch rotate
var angle1=Math.atan2(event.gesturePoints[0].currentPos.y-event.gesturePoints[1].currentPos.y,event.gesturePoints[0].currentPos.x-event.gesturePoints[1].currentPos.x);var angle2=Math.atan2(event.gesturePoints[0].lastPos.y-event.gesturePoints[1].lastPos.y,event.gesturePoints[0].lastPos.x-event.gesturePoints[1].lastPos.x);this.viewport.setRotation(this.viewport.getRotation()+(angle1-angle2)*(180/Math.PI));}}/**
     * Raised when a pinch event occurs on the {@link OpenSeadragon.Viewer#canvas} element.
     *
     * @event canvas-pinch
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {Array.<OpenSeadragon.MouseTracker.GesturePoint>} gesturePoints - Gesture points associated with the gesture. Velocity data can be found here.
     * @property {OpenSeadragon.Point} lastCenter - The previous center point of the two pinch contact points relative to the tracked element.
     * @property {OpenSeadragon.Point} center - The center point of the two pinch contact points relative to the tracked element.
     * @property {Number} lastDistance - The previous distance between the two pinch contact points in CSS pixels.
     * @property {Number} distance - The distance between the two pinch contact points in CSS pixels.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('canvas-pinch',{tracker:event.eventSource,gesturePoints:event.gesturePoints,lastCenter:event.lastCenter,center:event.center,lastDistance:event.lastDistance,distance:event.distance,shift:event.shift,originalEvent:event.originalEvent});//cancels event
return false;}function onCanvasScroll(event){var gestureSettings,factor,thisScrollTime,deltaScrollTime;/* Certain scroll devices fire the scroll event way too fast so we are injecting a simple adjustment to keep things
     * partially normalized. If we have already fired an event within the last 'minScrollDelta' milliseconds we skip
     * this one and wait for the next event. */thisScrollTime=$.now();deltaScrollTime=thisScrollTime-this._lastScrollTime;if(deltaScrollTime>this.minScrollDeltaTime){this._lastScrollTime=thisScrollTime;if(this.viewport.flipped){event.position.x=this.viewport.getContainerSize().x-event.position.x;}if(!event.preventDefaultAction&&this.viewport){gestureSettings=this.gestureSettingsByDeviceType(event.pointerType);if(gestureSettings.scrollToZoom){factor=Math.pow(this.zoomPerScroll,event.scroll);this.viewport.zoomBy(factor,gestureSettings.zoomToRefPoint?this.viewport.pointFromPixel(event.position,true):null);this.viewport.applyConstraints();}}/**
         * Raised when a scroll event occurs on the {@link OpenSeadragon.Viewer#canvas} element (mouse wheel).
         *
         * @event canvas-scroll
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
         * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
         * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
         * @property {Number} scroll - The scroll delta for the event.
         * @property {Boolean} shift - True if the shift key was pressed during this event.
         * @property {Object} originalEvent - The original DOM event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('canvas-scroll',{tracker:event.eventSource,position:event.position,scroll:event.scroll,shift:event.shift,originalEvent:event.originalEvent});if(gestureSettings&&gestureSettings.scrollToZoom){//cancels event
return false;}}else{gestureSettings=this.gestureSettingsByDeviceType(event.pointerType);if(gestureSettings&&gestureSettings.scrollToZoom){return false;// We are swallowing this event
}}}function onContainerEnter(event){THIS[this.hash].mouseInside=true;abortControlsAutoHide(this);/**
     * Raised when the cursor enters the {@link OpenSeadragon.Viewer#container} element.
     *
     * @event container-enter
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('container-enter',{tracker:event.eventSource,position:event.position,buttons:event.buttons,pointers:event.pointers,insideElementPressed:event.insideElementPressed,buttonDownAny:event.buttonDownAny,originalEvent:event.originalEvent});}function onContainerExit(event){if(event.pointers<1){THIS[this.hash].mouseInside=false;if(!THIS[this.hash].animating){beginControlsAutoHide(this);}}/**
     * Raised when the cursor leaves the {@link OpenSeadragon.Viewer#container} element.
     *
     * @event container-exit
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} buttons - Current buttons pressed. A combination of bit flags 0: none, 1: primary (or touch contact), 2: secondary, 4: aux (often middle), 8: X1 (often back), 16: X2 (often forward), 32: pen eraser.
     * @property {Number} pointers - Number of pointers (all types) active in the tracked element.
     * @property {Boolean} insideElementPressed - True if the left mouse button is currently being pressed and was initiated inside the tracked element, otherwise false.
     * @property {Boolean} buttonDownAny - Was the button down anywhere in the screen during the event. <span style="color:red;">Deprecated. Use buttons instead.</span>
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.raiseEvent('container-exit',{tracker:event.eventSource,position:event.position,buttons:event.buttons,pointers:event.pointers,insideElementPressed:event.insideElementPressed,buttonDownAny:event.buttonDownAny,originalEvent:event.originalEvent});}///////////////////////////////////////////////////////////////////////////////
// Page update routines ( aka Views - for future reference )
///////////////////////////////////////////////////////////////////////////////
function updateMulti(viewer){updateOnce(viewer);// Request the next frame, unless we've been closed
if(viewer.isOpen()){viewer._updateRequestId=scheduleUpdate(viewer,updateMulti);}else{viewer._updateRequestId=false;}}function updateOnce(viewer){//viewer.profiler.beginUpdate();
if(viewer._opening){return;}if(viewer.autoResize){var containerSize=_getSafeElemSize(viewer.container);var prevContainerSize=THIS[viewer.hash].prevContainerSize;if(!containerSize.equals(prevContainerSize)){var viewport=viewer.viewport;if(viewer.preserveImageSizeOnResize){var resizeRatio=prevContainerSize.x/containerSize.x;var zoom=viewport.getZoom()*resizeRatio;var center=viewport.getCenter();viewport.resize(containerSize,false);viewport.zoomTo(zoom,null,true);viewport.panTo(center,true);}else{// maintain image position
var oldBounds=viewport.getBounds();viewport.resize(containerSize,true);viewport.fitBoundsWithConstraints(oldBounds,true);}THIS[viewer.hash].prevContainerSize=containerSize;THIS[viewer.hash].forceRedraw=true;}}var viewportChange=viewer.viewport.update();var animated=viewer.world.update()||viewportChange;if(viewportChange){/**
         * Raised when any spring animation update occurs (zoom, pan, etc.),
         * before the viewer has drawn the new location.
         *
         * @event viewport-change
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */viewer.raiseEvent('viewport-change');}if(viewer.referenceStrip){animated=viewer.referenceStrip.update(viewer.viewport)||animated;}if(!THIS[viewer.hash].animating&&animated){/**
         * Raised when any spring animation starts (zoom, pan, etc.).
         *
         * @event animation-start
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */viewer.raiseEvent("animation-start");abortControlsAutoHide(viewer);}if(animated||THIS[viewer.hash].forceRedraw||viewer.world.needsDraw()){drawWorld(viewer);viewer._drawOverlays();if(viewer.navigator){viewer.navigator.update(viewer.viewport);}THIS[viewer.hash].forceRedraw=false;if(animated){/**
             * Raised when any spring animation update occurs (zoom, pan, etc.),
             * after the viewer has drawn the new location.
             *
             * @event animation
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */viewer.raiseEvent("animation");}}if(THIS[viewer.hash].animating&&!animated){/**
         * Raised when any spring animation ends (zoom, pan, etc.).
         *
         * @event animation-finish
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */viewer.raiseEvent("animation-finish");if(!THIS[viewer.hash].mouseInside){beginControlsAutoHide(viewer);}}THIS[viewer.hash].animating=animated;//viewer.profiler.endUpdate();
}function drawWorld(viewer){viewer.imageLoader.clear();viewer.drawer.clear();viewer.world.draw();/**
     * <em>- Needs documentation -</em>
     *
     * @event update-viewport
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */viewer.raiseEvent('update-viewport',{});}///////////////////////////////////////////////////////////////////////////////
// Navigation Controls
///////////////////////////////////////////////////////////////////////////////
function resolveUrl(prefix,url){return prefix?prefix+url:url;}function beginZoomingIn(){THIS[this.hash].lastZoomTime=$.now();THIS[this.hash].zoomFactor=this.zoomPerSecond;THIS[this.hash].zooming=true;scheduleZoom(this);}function beginZoomingOut(){THIS[this.hash].lastZoomTime=$.now();THIS[this.hash].zoomFactor=1.0/this.zoomPerSecond;THIS[this.hash].zooming=true;scheduleZoom(this);}function endZooming(){THIS[this.hash].zooming=false;}function scheduleZoom(viewer){$.requestAnimationFrame($.delegate(viewer,doZoom));}function doZoom(){var currentTime,deltaTime,adjustedFactor;if(THIS[this.hash].zooming&&this.viewport){currentTime=$.now();deltaTime=currentTime-THIS[this.hash].lastZoomTime;adjustedFactor=Math.pow(THIS[this.hash].zoomFactor,deltaTime/1000);this.viewport.zoomBy(adjustedFactor);this.viewport.applyConstraints();THIS[this.hash].lastZoomTime=currentTime;scheduleZoom(this);}}function doSingleZoomIn(){if(this.viewport){THIS[this.hash].zooming=false;this.viewport.zoomBy(this.zoomPerClick/1.0);this.viewport.applyConstraints();}}function doSingleZoomOut(){if(this.viewport){THIS[this.hash].zooming=false;this.viewport.zoomBy(1.0/this.zoomPerClick);this.viewport.applyConstraints();}}function lightUp(){this.buttons.emulateEnter();this.buttons.emulateExit();}function onHome(){if(this.viewport){this.viewport.goHome();}}function onFullScreen(){if(this.isFullPage()&&!$.isFullScreen()){// Is fullPage but not fullScreen
this.setFullPage(false);}else{this.setFullScreen(!this.isFullPage());}// correct for no mouseout event on change
if(this.buttons){this.buttons.emulateExit();}this.fullPageButton.element.focus();if(this.viewport){this.viewport.applyConstraints();}}function onRotateLeft(){if(this.viewport){var currRotation=this.viewport.getRotation();if(this.viewport.flipped){currRotation=$.positiveModulo(currRotation+this.rotationIncrement,360);}else{currRotation=$.positiveModulo(currRotation-this.rotationIncrement,360);}this.viewport.setRotation(currRotation);}}function onRotateRight(){if(this.viewport){var currRotation=this.viewport.getRotation();if(this.viewport.flipped){currRotation=$.positiveModulo(currRotation-this.rotationIncrement,360);}else{currRotation=$.positiveModulo(currRotation+this.rotationIncrement,360);}this.viewport.setRotation(currRotation);}}/**
 * Note: When pressed flip control button
 */function onFlip(){this.viewport.toggleFlip();}function onPrevious(){var previous=this._sequenceIndex-1;if(this.navPrevNextWrap&&previous<0){previous+=this.tileSources.length;}this.goToPage(previous);}function onNext(){var next=this._sequenceIndex+1;if(this.navPrevNextWrap&&next>=this.tileSources.length){next=0;}this.goToPage(next);}})(OpenSeadragon);/*
 * OpenSeadragon - Navigator
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class Navigator
 * @classdesc The Navigator provides a small view of the current image as fixed
 * while representing the viewport as a moving box serving as a frame
 * of reference in the larger viewport as to which portion of the image
 * is currently being examined.  The navigator's viewport can be interacted
 * with using the keyboard or the mouse.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.Viewer
 * @extends OpenSeadragon.EventSource
 * @param {Object} options
 */$.Navigator=function(options){var viewer=options.viewer,_this=this,viewerSize,navigatorSize;//We may need to create a new element and id if they did not
//provide the id for the existing element
if(!options.id){options.id='navigator-'+$.now();this.element=$.makeNeutralElement("div");options.controlOptions={anchor:$.ControlAnchor.TOP_RIGHT,attachToViewer:true,autoFade:options.autoFade};if(options.position){if('BOTTOM_RIGHT'==options.position){options.controlOptions.anchor=$.ControlAnchor.BOTTOM_RIGHT;}else if('BOTTOM_LEFT'==options.position){options.controlOptions.anchor=$.ControlAnchor.BOTTOM_LEFT;}else if('TOP_RIGHT'==options.position){options.controlOptions.anchor=$.ControlAnchor.TOP_RIGHT;}else if('TOP_LEFT'==options.position){options.controlOptions.anchor=$.ControlAnchor.TOP_LEFT;}else if('ABSOLUTE'==options.position){options.controlOptions.anchor=$.ControlAnchor.ABSOLUTE;options.controlOptions.top=options.top;options.controlOptions.left=options.left;options.controlOptions.height=options.height;options.controlOptions.width=options.width;}}}else{this.element=document.getElementById(options.id);options.controlOptions={anchor:$.ControlAnchor.NONE,attachToViewer:false,autoFade:false};}this.element.id=options.id;this.element.className+=' navigator';options=$.extend(true,{sizeRatio:$.DEFAULT_SETTINGS.navigatorSizeRatio},options,{element:this.element,tabIndex:-1,// No keyboard navigation, omit from tab order
//These need to be overridden to prevent recursion since
//the navigator is a viewer and a viewer has a navigator
showNavigator:false,mouseNavEnabled:false,showNavigationControl:false,showSequenceControl:false,immediateRender:true,blendTime:0,animationTime:0,autoResize:options.autoResize,// prevent resizing the navigator from adding unwanted space around the image
minZoomImageRatio:1.0,background:options.background,opacity:options.opacity,borderColor:options.borderColor,displayRegionColor:options.displayRegionColor});options.minPixelRatio=this.minPixelRatio=viewer.minPixelRatio;$.setElementTouchActionNone(this.element);this.borderWidth=2;//At some browser magnification levels the display regions lines up correctly, but at some there appears to
//be a one pixel gap.
this.fudge=new $.Point(1,1);this.totalBorderWidths=new $.Point(this.borderWidth*2,this.borderWidth*2).minus(this.fudge);if(options.controlOptions.anchor!=$.ControlAnchor.NONE){(function(style,borderWidth){style.margin='0px';style.border=borderWidth+'px solid '+options.borderColor;style.padding='0px';style.background=options.background;style.opacity=options.opacity;style.overflow='hidden';})(this.element.style,this.borderWidth);}this.displayRegion=$.makeNeutralElement("div");this.displayRegion.id=this.element.id+'-displayregion';this.displayRegion.className='displayregion';(function(style,borderWidth){style.position='relative';style.top='0px';style.left='0px';style.fontSize='0px';style.overflow='hidden';style.border=borderWidth+'px solid '+options.displayRegionColor;style.margin='0px';style.padding='0px';//TODO: IE doesn't like this property being set
//try{ style.outline  = '2px auto #909'; }catch(e){/*ignore*/}
style.background='transparent';// We use square bracket notation on the statement below, because float is a keyword.
// This is important for the Google Closure compiler, if nothing else.
/*jshint sub:true */style['float']='left';//Webkit
style.cssFloat='left';//Firefox
style.styleFloat='left';//IE
style.zIndex=999999999;style.cursor='default';})(this.displayRegion.style,this.borderWidth);this.displayRegionContainer=$.makeNeutralElement("div");this.displayRegionContainer.id=this.element.id+'-displayregioncontainer';this.displayRegionContainer.className="displayregioncontainer";this.displayRegionContainer.style.width="100%";this.displayRegionContainer.style.height="100%";viewer.addControl(this.element,options.controlOptions);this._resizeWithViewer=options.controlOptions.anchor!=$.ControlAnchor.ABSOLUTE&&options.controlOptions.anchor!=$.ControlAnchor.NONE;if(options.width&&options.height){this.setWidth(options.width);this.setHeight(options.height);}else if(this._resizeWithViewer){viewerSize=$.getElementSize(viewer.element);this.element.style.height=Math.round(viewerSize.y*options.sizeRatio)+'px';this.element.style.width=Math.round(viewerSize.x*options.sizeRatio)+'px';this.oldViewerSize=viewerSize;navigatorSize=$.getElementSize(this.element);this.elementArea=navigatorSize.x*navigatorSize.y;}this.oldContainerSize=new $.Point(0,0);$.Viewer.apply(this,[options]);this.displayRegionContainer.appendChild(this.displayRegion);this.element.getElementsByTagName('div')[0].appendChild(this.displayRegionContainer);function rotate(degrees){_setTransformRotate(_this.displayRegionContainer,degrees);_setTransformRotate(_this.displayRegion,-degrees);_this.viewport.setRotation(degrees);}if(options.navigatorRotate){var degrees=options.viewer.viewport?options.viewer.viewport.getRotation():options.viewer.degrees||0;rotate(degrees);options.viewer.addHandler("rotate",function(args){rotate(args.degrees);});}// Remove the base class' (Viewer's) innerTracker and replace it with our own
this.innerTracker.destroy();this.innerTracker=new $.MouseTracker({element:this.element,dragHandler:$.delegate(this,onCanvasDrag),clickHandler:$.delegate(this,onCanvasClick),releaseHandler:$.delegate(this,onCanvasRelease),scrollHandler:$.delegate(this,onCanvasScroll)});this.addHandler("reset-size",function(){if(_this.viewport){_this.viewport.goHome(true);}});viewer.world.addHandler("item-index-change",function(event){window.setTimeout(function(){var item=_this.world.getItemAt(event.previousIndex);_this.world.setItemIndex(item,event.newIndex);},1);});viewer.world.addHandler("remove-item",function(event){var theirItem=event.item;var myItem=_this._getMatchingItem(theirItem);if(myItem){_this.world.removeItem(myItem);}});this.update(viewer.viewport);};$.extend($.Navigator.prototype,$.EventSource.prototype,$.Viewer.prototype,/** @lends OpenSeadragon.Navigator.prototype */{/**
     * Used to notify the navigator when its size has changed.
     * Especially useful when {@link OpenSeadragon.Options}.navigatorAutoResize is set to false and the navigator is resizable.
     * @function
     */updateSize:function(){if(this.viewport){var containerSize=new $.Point(this.container.clientWidth===0?1:this.container.clientWidth,this.container.clientHeight===0?1:this.container.clientHeight);if(!containerSize.equals(this.oldContainerSize)){this.viewport.resize(containerSize,true);this.viewport.goHome(true);this.oldContainerSize=containerSize;this.drawer.clear();this.world.draw();}}},/**
     * Explicitly sets the width of the navigator, in web coordinates. Disables automatic resizing.
     * @param {Number|String} width - the new width, either a number of pixels or a CSS string, such as "100%"
     */setWidth:function(width){this.width=width;this.element.style.width=typeof width=="number"?width+'px':width;this._resizeWithViewer=false;},/**
     * Explicitly sets the height of the navigator, in web coordinates. Disables automatic resizing.
     * @param {Number|String} height - the new height, either a number of pixels or a CSS string, such as "100%"
     */setHeight:function(height){this.height=height;this.element.style.height=typeof height=="number"?height+'px':height;this._resizeWithViewer=false;},/**
      * Flip navigator element
      * @param {Boolean} state - Flip state to set.
      */setFlip:function(state){this.viewport.setFlip(state);this.setDisplayTransform(this.viewer.viewport.getFlip()?"scale(-1,1)":"scale(1,1)");return this;},setDisplayTransform:function(rule){setElementTransform(this.displayRegion,rule);setElementTransform(this.canvas,rule);setElementTransform(this.element,rule);},/**
     * Used to update the navigator minimap's viewport rectangle when a change in the viewer's viewport occurs.
     * @function
     * @param {OpenSeadragon.Viewport} The viewport this navigator is tracking.
     */update:function(viewport){var viewerSize,newWidth,newHeight,bounds,topleft,bottomright;viewerSize=$.getElementSize(this.viewer.element);if(this._resizeWithViewer&&viewerSize.x&&viewerSize.y&&!viewerSize.equals(this.oldViewerSize)){this.oldViewerSize=viewerSize;if(this.maintainSizeRatio||!this.elementArea){newWidth=viewerSize.x*this.sizeRatio;newHeight=viewerSize.y*this.sizeRatio;}else{newWidth=Math.sqrt(this.elementArea*(viewerSize.x/viewerSize.y));newHeight=this.elementArea/newWidth;}this.element.style.width=Math.round(newWidth)+'px';this.element.style.height=Math.round(newHeight)+'px';if(!this.elementArea){this.elementArea=newWidth*newHeight;}this.updateSize();}if(viewport&&this.viewport){bounds=viewport.getBoundsNoRotate(true);topleft=this.viewport.pixelFromPointNoRotate(bounds.getTopLeft(),false);bottomright=this.viewport.pixelFromPointNoRotate(bounds.getBottomRight(),false).minus(this.totalBorderWidths);//update style for navigator-box
var style=this.displayRegion.style;style.display=this.world.getItemCount()?'block':'none';style.top=Math.round(topleft.y)+'px';style.left=Math.round(topleft.x)+'px';var width=Math.abs(topleft.x-bottomright.x);var height=Math.abs(topleft.y-bottomright.y);// make sure width and height are non-negative so IE doesn't throw
style.width=Math.round(Math.max(width,0))+'px';style.height=Math.round(Math.max(height,0))+'px';}},// overrides Viewer.addTiledImage
addTiledImage:function(options){var _this=this;var original=options.originalTiledImage;delete options.original;var optionsClone=$.extend({},options,{success:function(event){var myItem=event.item;myItem._originalForNavigator=original;_this._matchBounds(myItem,original,true);function matchBounds(){_this._matchBounds(myItem,original);}function matchOpacity(){_this._matchOpacity(myItem,original);}function matchCompositeOperation(){_this._matchCompositeOperation(myItem,original);}original.addHandler('bounds-change',matchBounds);original.addHandler('clip-change',matchBounds);original.addHandler('opacity-change',matchOpacity);original.addHandler('composite-operation-change',matchCompositeOperation);}});return $.Viewer.prototype.addTiledImage.apply(this,[optionsClone]);},// private
_getMatchingItem:function(theirItem){var count=this.world.getItemCount();var item;for(var i=0;i<count;i++){item=this.world.getItemAt(i);if(item._originalForNavigator===theirItem){return item;}}return null;},// private
_matchBounds:function(myItem,theirItem,immediately){var bounds=theirItem.getBoundsNoRotate();myItem.setPosition(bounds.getTopLeft(),immediately);myItem.setWidth(bounds.width,immediately);myItem.setRotation(theirItem.getRotation(),immediately);myItem.setClip(theirItem.getClip());},// private
_matchOpacity:function(myItem,theirItem){myItem.setOpacity(theirItem.opacity);},// private
_matchCompositeOperation:function(myItem,theirItem){myItem.setCompositeOperation(theirItem.compositeOperation);}});/**
 * @private
 * @inner
 * @function
 */function onCanvasClick(event){var canvasClickEventArgs={tracker:event.eventSource,position:event.position,quick:event.quick,shift:event.shift,originalEvent:event.originalEvent,preventDefaultAction:event.preventDefaultAction};/**
   * Raised when a click event occurs on the {@link OpenSeadragon.Viewer#navigator} element.
   *
   * @event navigator-click
   * @memberof OpenSeadragon.Viewer
   * @type {object}
   * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
   * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
   * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
   * @property {Boolean} quick - True only if the clickDistThreshold and clickTimeThreshold are both passed. Useful for differentiating between clicks and drags.
   * @property {Boolean} shift - True if the shift key was pressed during this event.
   * @property {Object} originalEvent - The original DOM event.
   * @property {?Object} userData - Arbitrary subscriber-defined object.
   * @property {Boolean} preventDefaultAction - Set to true to prevent default click to zoom behaviour. Default: false.
   */this.viewer.raiseEvent('navigator-click',canvasClickEventArgs);if(!canvasClickEventArgs.preventDefaultAction&&event.quick&&this.viewer.viewport&&(this.panVertical||this.panHorizontal)){if(this.viewer.viewport.flipped){event.position.x=this.viewport.getContainerSize().x-event.position.x;}var target=this.viewport.pointFromPixel(event.position);if(!this.panVertical){// perform only horizonal pan
target.y=this.viewer.viewport.getCenter(true).y;}else if(!this.panHorizontal){// perform only vertical pan
target.x=this.viewer.viewport.getCenter(true).x;}this.viewer.viewport.panTo(target);this.viewer.viewport.applyConstraints();}}/**
 * @private
 * @inner
 * @function
 */function onCanvasDrag(event){var canvasDragEventArgs={tracker:event.eventSource,position:event.position,delta:event.delta,speed:event.speed,direction:event.direction,shift:event.shift,originalEvent:event.originalEvent,preventDefaultAction:event.preventDefaultAction};/**
     * Raised when a drag event occurs on the {@link OpenSeadragon.Viewer#navigator} element.
     *
     * @event navigator-drag
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {OpenSeadragon.Point} delta - The x,y components of the difference between start drag and end drag.
     * @property {Number} speed - Current computed speed, in pixels per second.
     * @property {Number} direction - Current computed direction, expressed as an angle counterclockwise relative to the positive X axis (-pi to pi, in radians). Only valid if speed > 0.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     * @property {Boolean} preventDefaultAction - Set to true to prevent default click to zoom behaviour. Default: false.
     */this.viewer.raiseEvent('navigator-drag',canvasDragEventArgs);if(!canvasDragEventArgs.preventDefaultAction&&this.viewer.viewport){if(!this.panHorizontal){event.delta.x=0;}if(!this.panVertical){event.delta.y=0;}if(this.viewer.viewport.flipped){event.delta.x=-event.delta.x;}this.viewer.viewport.panBy(this.viewport.deltaPointsFromPixels(event.delta));if(this.viewer.constrainDuringPan){this.viewer.viewport.applyConstraints();}}}/**
 * @private
 * @inner
 * @function
 */function onCanvasRelease(event){if(event.insideElementPressed&&this.viewer.viewport){this.viewer.viewport.applyConstraints();}}/**
 * @private
 * @inner
 * @function
 */function onCanvasScroll(event){/**
     * Raised when a scroll event occurs on the {@link OpenSeadragon.Viewer#navigator} element (mouse wheel, touch pinch, etc.).
     *
     * @event navigator-scroll
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
     * @property {OpenSeadragon.MouseTracker} tracker - A reference to the MouseTracker which originated this event.
     * @property {OpenSeadragon.Point} position - The position of the event relative to the tracked element.
     * @property {Number} scroll - The scroll delta for the event.
     * @property {Boolean} shift - True if the shift key was pressed during this event.
     * @property {Object} originalEvent - The original DOM event.
     * @property {?Object} userData - Arbitrary subscriber-defined object.
     */this.viewer.raiseEvent('navigator-scroll',{tracker:event.eventSource,position:event.position,scroll:event.scroll,shift:event.shift,originalEvent:event.originalEvent});//don't scroll the page up and down if the user is scrolling
//in the navigator
return false;}/**
    * @function
    * @private
    * @param {Object} element
    * @param {Number} degrees
    */function _setTransformRotate(element,degrees){setElementTransform(element,"rotate("+degrees+"deg)");}function setElementTransform(element,rule){element.style.webkitTransform=rule;element.style.mozTransform=rule;element.style.msTransform=rule;element.style.oTransform=rule;element.style.transform=rule;}})(OpenSeadragon);/*
 * OpenSeadragon - getString/setString
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){//TODO: I guess this is where the i18n needs to be reimplemented.  I'll look
//      into existing patterns for i18n in javascript but i think that mimicking
//      pythons gettext might be a reasonable approach.
var I18N={Errors:{Dzc:"Sorry, we don't support Deep Zoom Collections!",Dzi:"Hmm, this doesn't appear to be a valid Deep Zoom Image.",Xml:"Hmm, this doesn't appear to be a valid Deep Zoom Image.",ImageFormat:"Sorry, we don't support {0}-based Deep Zoom Images.",Security:"It looks like a security restriction stopped us from "+"loading this Deep Zoom Image.",Status:"This space unintentionally left blank ({0} {1}).",OpenFailed:"Unable to open {0}: {1}"},Tooltips:{FullPage:"Toggle full page",Home:"Go home",ZoomIn:"Zoom in",ZoomOut:"Zoom out",NextPage:"Next page",PreviousPage:"Previous page",RotateLeft:"Rotate left",RotateRight:"Rotate right",Flip:"Flip Horizontally"}};$.extend($,/** @lends OpenSeadragon */{/**
     * @function
     * @param {String} property
     */getString:function(prop){var props=prop.split('.'),string=null,args=arguments,container=I18N,i;for(i=0;i<props.length-1;i++){// in case not a subproperty
container=container[props[i]]||{};}string=container[props[i]];if(typeof string!="string"){$.console.log("Untranslated source string:",prop);string="";// FIXME: this breaks gettext()-style convention, which would return source
}return string.replace(/\{\d+\}/g,function(capture){var i=parseInt(capture.match(/\d+/),10)+1;return i<args.length?args[i]:"";});},/**
     * @function
     * @param {String} property
     * @param {*} value
     */setString:function(prop,value){var props=prop.split('.'),container=I18N,i;for(i=0;i<props.length-1;i++){if(!container[props[i]]){container[props[i]]={};}container=container[props[i]];}container[props[i]]=value;}});})(OpenSeadragon);/*
 * OpenSeadragon - Point
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class Point
 * @classdesc A Point is really used as a 2-dimensional vector, equally useful for
 * representing a point on a plane, or the height and width of a plane
 * not requiring any other frame of reference.
 *
 * @memberof OpenSeadragon
 * @param {Number} [x] The vector component 'x'. Defaults to the origin at 0.
 * @param {Number} [y] The vector component 'y'. Defaults to the origin at 0.
 */$.Point=function(x,y){/**
     * The vector component 'x'.
     * @member {Number} x
     * @memberof OpenSeadragon.Point#
     */this.x=typeof x=="number"?x:0;/**
     * The vector component 'y'.
     * @member {Number} y
     * @memberof OpenSeadragon.Point#
     */this.y=typeof y=="number"?y:0;};/** @lends OpenSeadragon.Point.prototype */$.Point.prototype={/**
     * @function
     * @returns {OpenSeadragon.Point} a duplicate of this Point
     */clone:function(){return new $.Point(this.x,this.y);},/**
     * Add another Point to this point and return a new Point.
     * @function
     * @param {OpenSeadragon.Point} point The point to add vector components.
     * @returns {OpenSeadragon.Point} A new point representing the sum of the
     *  vector components
     */plus:function(point){return new $.Point(this.x+point.x,this.y+point.y);},/**
     * Subtract another Point to this point and return a new Point.
     * @function
     * @param {OpenSeadragon.Point} point The point to subtract vector components.
     * @returns {OpenSeadragon.Point} A new point representing the subtraction of the
     *  vector components
     */minus:function(point){return new $.Point(this.x-point.x,this.y-point.y);},/**
     * Multiply this point by a factor and return a new Point.
     * @function
     * @param {Number} factor The factor to multiply vector components.
     * @returns {OpenSeadragon.Point} A new point representing the multiplication
     *  of the vector components by the factor
     */times:function(factor){return new $.Point(this.x*factor,this.y*factor);},/**
     * Divide this point by a factor and return a new Point.
     * @function
     * @param {Number} factor The factor to divide vector components.
     * @returns {OpenSeadragon.Point} A new point representing the division of the
     *  vector components by the factor
     */divide:function(factor){return new $.Point(this.x/factor,this.y/factor);},/**
     * Compute the opposite of this point and return a new Point.
     * @function
     * @returns {OpenSeadragon.Point} A new point representing the opposite of the
     *  vector components
     */negate:function(){return new $.Point(-this.x,-this.y);},/**
     * Compute the distance between this point and another point.
     * @function
     * @param {OpenSeadragon.Point} point The point to compute the distance with.
     * @returns {Number} The distance between the 2 points
     */distanceTo:function(point){return Math.sqrt(Math.pow(this.x-point.x,2)+Math.pow(this.y-point.y,2));},/**
     * Compute the squared distance between this point and another point.
     * Useful for optimizing things like comparing distances.
     * @function
     * @param {OpenSeadragon.Point} point The point to compute the squared distance with.
     * @returns {Number} The squared distance between the 2 points
     */squaredDistanceTo:function(point){return Math.pow(this.x-point.x,2)+Math.pow(this.y-point.y,2);},/**
     * Apply a function to each coordinate of this point and return a new point.
     * @function
     * @param {function} func The function to apply to each coordinate.
     * @returns {OpenSeadragon.Point} A new point with the coordinates computed
     * by the specified function
     */apply:function(func){return new $.Point(func(this.x),func(this.y));},/**
     * Check if this point is equal to another one.
     * @function
     * @param {OpenSeadragon.Point} point The point to compare this point with.
     * @returns {Boolean} true if they are equal, false otherwise.
     */equals:function(point){return point instanceof $.Point&&this.x===point.x&&this.y===point.y;},/**
     * Rotates the point around the specified pivot
     * From http://stackoverflow.com/questions/4465931/rotate-rectangle-around-a-point
     * @function
     * @param {Number} degress to rotate around the pivot.
     * @param {OpenSeadragon.Point} [pivot=(0,0)] Point around which to rotate.
     * Defaults to the origin.
     * @returns {OpenSeadragon.Point}. A new point representing the point rotated around the specified pivot
     */rotate:function(degrees,pivot){pivot=pivot||new $.Point(0,0);var cos;var sin;// Avoid float computations when possible
if(degrees%90===0){var d=$.positiveModulo(degrees,360);switch(d){case 0:cos=1;sin=0;break;case 90:cos=0;sin=1;break;case 180:cos=-1;sin=0;break;case 270:cos=0;sin=-1;break;}}else{var angle=degrees*Math.PI/180.0;cos=Math.cos(angle);sin=Math.sin(angle);}var x=cos*(this.x-pivot.x)-sin*(this.y-pivot.y)+pivot.x;var y=sin*(this.x-pivot.x)+cos*(this.y-pivot.y)+pivot.y;return new $.Point(x,y);},/**
     * Convert this point to a string in the format (x,y) where x and y are
     * rounded to the nearest integer.
     * @function
     * @returns {String} A string representation of this point.
     */toString:function(){return"("+Math.round(this.x*100)/100+","+Math.round(this.y*100)/100+")";}};})(OpenSeadragon);/*
 * OpenSeadragon - TileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class TileSource
 * @classdesc The TileSource contains the most basic implementation required to create a
 * smooth transition between layers in an image pyramid. It has only a single key
 * interface that must be implemented to complete its key functionality:
 * 'getTileUrl'.  It also has several optional interfaces that can be
 * implemented if a new TileSource wishes to support configuration via a simple
 * object or array ('configure') and if the tile source supports or requires
 * configuration via retrieval of a document on the network ala AJAX or JSONP,
 * ('getImageInfo').
 * <br/>
 * By default the image pyramid is split into N layers where the image's longest
 * side in M (in pixels), where N is the smallest integer which satisfies
 *      <strong>2^(N+1) >= M</strong>.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @param {Object} options
 *      You can either specify a URL, or literally define the TileSource (by specifying
 *      width, height, tileSize, tileOverlap, minLevel, and maxLevel). For the former,
 *      the extending class is expected to implement 'getImageInfo' and 'configure'.
 *      For the latter, the construction is assumed to occur through
 *      the extending classes implementation of 'configure'.
 * @param {String} [options.url]
 *      The URL for the data necessary for this TileSource.
 * @param {String} [options.referenceStripThumbnailUrl]
 *      The URL for a thumbnail image to be used by the reference strip
 * @param {Function} [options.success]
 *      A function to be called upon successful creation.
 * @param {Boolean} [options.ajaxWithCredentials]
 *      If this TileSource needs to make an AJAX call, this specifies whether to set
 *      the XHR's withCredentials (for accessing secure data).
 * @param {Object} [options.ajaxHeaders]
 *      A set of headers to include in AJAX requests.
 * @param {Number} [options.width]
 *      Width of the source image at max resolution in pixels.
 * @param {Number} [options.height]
 *      Height of the source image at max resolution in pixels.
 * @param {Number} [options.tileSize]
 *      The size of the tiles to assumed to make up each pyramid layer in pixels.
 *      Tile size determines the point at which the image pyramid must be
 *      divided into a matrix of smaller images.
 *      Use options.tileWidth and options.tileHeight to support non-square tiles.
 * @param {Number} [options.tileWidth]
 *      The width of the tiles to assumed to make up each pyramid layer in pixels.
 * @param {Number} [options.tileHeight]
 *      The height of the tiles to assumed to make up each pyramid layer in pixels.
 * @param {Number} [options.tileOverlap]
 *      The number of pixels each tile is expected to overlap touching tiles.
 * @param {Number} [options.minLevel]
 *      The minimum level to attempt to load.
 * @param {Number} [options.maxLevel]
 *      The maximum level to attempt to load.
 */$.TileSource=function(width,height,tileSize,tileOverlap,minLevel,maxLevel){var _this=this;var args=arguments,options,i;if($.isPlainObject(width)){options=width;}else{options={width:args[0],height:args[1],tileSize:args[2],tileOverlap:args[3],minLevel:args[4],maxLevel:args[5]};}//Tile sources supply some events, namely 'ready' when they must be configured
//by asynchronously fetching their configuration data.
$.EventSource.call(this);//we allow options to override anything we don't treat as
//required via idiomatic options or which is functionally
//set depending on the state of the readiness of this tile
//source
$.extend(true,this,options);if(!this.success){//Any functions that are passed as arguments are bound to the ready callback
for(i=0;i<arguments.length;i++){if($.isFunction(arguments[i])){this.success=arguments[i];//only one callback per constructor
break;}}}if(this.success){this.addHandler('ready',function(event){_this.success(event);});}/**
     * Ratio of width to height
     * @member {Number} aspectRatio
     * @memberof OpenSeadragon.TileSource#
     *//**
     * Vector storing x and y dimensions ( width and height respectively ).
     * @member {OpenSeadragon.Point} dimensions
     * @memberof OpenSeadragon.TileSource#
     *//**
     * The overlap in pixels each tile shares with its adjacent neighbors.
     * @member {Number} tileOverlap
     * @memberof OpenSeadragon.TileSource#
     *//**
     * The minimum pyramid level this tile source supports or should attempt to load.
     * @member {Number} minLevel
     * @memberof OpenSeadragon.TileSource#
     *//**
     * The maximum pyramid level this tile source supports or should attempt to load.
     * @member {Number} maxLevel
     * @memberof OpenSeadragon.TileSource#
     *//**
     *
     * @member {Boolean} ready
     * @memberof OpenSeadragon.TileSource#
     */if('string'==$.type(arguments[0])){this.url=arguments[0];}if(this.url){//in case the getImageInfo method is overridden and/or implies an
//async mechanism set some safe defaults first
this.aspectRatio=1;this.dimensions=new $.Point(10,10);this._tileWidth=0;this._tileHeight=0;this.tileOverlap=0;this.minLevel=0;this.maxLevel=0;this.ready=false;//configuration via url implies the extending class
//implements and 'configure'
this.getImageInfo(this.url);}else{//explicit configuration via positional args in constructor
//or the more idiomatic 'options' object
this.ready=true;this.aspectRatio=options.width&&options.height?options.width/options.height:1;this.dimensions=new $.Point(options.width,options.height);if(this.tileSize){this._tileWidth=this._tileHeight=this.tileSize;delete this.tileSize;}else{if(this.tileWidth){// We were passed tileWidth in options, but we want to rename it
// with a leading underscore to make clear that it is not safe to directly modify it
this._tileWidth=this.tileWidth;delete this.tileWidth;}else{this._tileWidth=0;}if(this.tileHeight){// See note above about renaming this.tileWidth
this._tileHeight=this.tileHeight;delete this.tileHeight;}else{this._tileHeight=0;}}this.tileOverlap=options.tileOverlap?options.tileOverlap:0;this.minLevel=options.minLevel?options.minLevel:0;this.maxLevel=undefined!==options.maxLevel&&null!==options.maxLevel?options.maxLevel:options.width&&options.height?Math.ceil(Math.log(Math.max(options.width,options.height))/Math.log(2)):0;if(this.success&&$.isFunction(this.success)){this.success(this);}}};/** @lends OpenSeadragon.TileSource.prototype */$.TileSource.prototype={getTileSize:function(level){$.console.error("[TileSource.getTileSize] is deprecated. "+"Use TileSource.getTileWidth() and TileSource.getTileHeight() instead");return this._tileWidth;},/**
     * Return the tileWidth for a given level.
     * Subclasses should override this if tileWidth can be different at different levels
     *   such as in IIIFTileSource.  Code should use this function rather than reading
     *   from ._tileWidth directly.
     * @function
     * @param {Number} level
     */getTileWidth:function(level){if(!this._tileWidth){return this.getTileSize(level);}return this._tileWidth;},/**
     * Return the tileHeight for a given level.
     * Subclasses should override this if tileHeight can be different at different levels
     *   such as in IIIFTileSource.  Code should use this function rather than reading
     *   from ._tileHeight directly.
     * @function
     * @param {Number} level
     */getTileHeight:function(level){if(!this._tileHeight){return this.getTileSize(level);}return this._tileHeight;},/**
     * @function
     * @param {Number} level
     */getLevelScale:function(level){// see https://github.com/openseadragon/openseadragon/issues/22
// we use the tilesources implementation of getLevelScale to generate
// a memoized re-implementation
var levelScaleCache={},i;for(i=0;i<=this.maxLevel;i++){levelScaleCache[i]=1/Math.pow(2,this.maxLevel-i);}this.getLevelScale=function(_level){return levelScaleCache[_level];};return this.getLevelScale(level);},/**
     * @function
     * @param {Number} level
     */getNumTiles:function(level){var scale=this.getLevelScale(level),x=Math.ceil(scale*this.dimensions.x/this.getTileWidth(level)),y=Math.ceil(scale*this.dimensions.y/this.getTileHeight(level));return new $.Point(x,y);},/**
     * @function
     * @param {Number} level
     */getPixelRatio:function(level){var imageSizeScaled=this.dimensions.times(this.getLevelScale(level)),rx=1.0/imageSizeScaled.x,ry=1.0/imageSizeScaled.y;return new $.Point(rx,ry);},/**
     * @function
     * @returns {Number} The highest level in this tile source that can be contained in a single tile.
     */getClosestLevel:function(){var i,tiles;for(i=this.minLevel+1;i<=this.maxLevel;i++){tiles=this.getNumTiles(i);if(tiles.x>1||tiles.y>1){break;}}return i-1;},/**
     * @function
     * @param {Number} level
     * @param {OpenSeadragon.Point} point
     */getTileAtPoint:function(level,point){var validPoint=point.x>=0&&point.x<=1&&point.y>=0&&point.y<=1/this.aspectRatio;$.console.assert(validPoint,"[TileSource.getTileAtPoint] must be called with a valid point.");var widthScaled=this.dimensions.x*this.getLevelScale(level);var pixelX=point.x*widthScaled;var pixelY=point.y*widthScaled;var x=Math.floor(pixelX/this.getTileWidth(level));var y=Math.floor(pixelY/this.getTileHeight(level));// When point.x == 1 or point.y == 1 / this.aspectRatio we want to
// return the last tile of the row/column
if(point.x>=1){x=this.getNumTiles(level).x-1;}var EPSILON=1e-15;if(point.y>=1/this.aspectRatio-EPSILON){y=this.getNumTiles(level).y-1;}return new $.Point(x,y);},/**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     * @param {Boolean} [isSource=false] Whether to return the source bounds of the tile.
     * @returns {OpenSeadragon.Rect} Either where this tile fits (in normalized coordinates) or the
     * portion of the tile to use as the source of the drawing operation (in pixels), depending on
     * the isSource parameter.
     */getTileBounds:function(level,x,y,isSource){var dimensionsScaled=this.dimensions.times(this.getLevelScale(level)),tileWidth=this.getTileWidth(level),tileHeight=this.getTileHeight(level),px=x===0?0:tileWidth*x-this.tileOverlap,py=y===0?0:tileHeight*y-this.tileOverlap,sx=tileWidth+(x===0?1:2)*this.tileOverlap,sy=tileHeight+(y===0?1:2)*this.tileOverlap,scale=1.0/dimensionsScaled.x;sx=Math.min(sx,dimensionsScaled.x-px);sy=Math.min(sy,dimensionsScaled.y-py);if(isSource){return new $.Rect(0,0,sx,sy);}return new $.Rect(px*scale,py*scale,sx*scale,sy*scale);},/**
     * Responsible for retrieving, and caching the
     * image metadata pertinent to this TileSources implementation.
     * @function
     * @param {String} url
     * @throws {Error}
     */getImageInfo:function(url){var _this=this,callbackName,callback,readySource,options,urlParts,filename,lastDot;if(url){urlParts=url.split('/');filename=urlParts[urlParts.length-1];lastDot=filename.lastIndexOf('.');if(lastDot>-1){urlParts[urlParts.length-1]=filename.slice(0,lastDot);}}callback=function(data){if(typeof data==="string"){data=$.parseXml(data);}var $TileSource=$.TileSource.determineType(_this,data,url);if(!$TileSource){/**
                 * Raised when an error occurs loading a TileSource.
                 *
                 * @event open-failed
                 * @memberof OpenSeadragon.TileSource
                 * @type {object}
                 * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
                 * @property {String} message
                 * @property {String} source
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */_this.raiseEvent('open-failed',{message:"Unable to load TileSource",source:url});return;}options=$TileSource.prototype.configure.apply(_this,[data,url]);if(options.ajaxWithCredentials===undefined){options.ajaxWithCredentials=_this.ajaxWithCredentials;}readySource=new $TileSource(options);_this.ready=true;/**
             * Raised when a TileSource is opened and initialized.
             *
             * @event ready
             * @memberof OpenSeadragon.TileSource
             * @type {object}
             * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
             * @property {Object} tileSource
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */_this.raiseEvent('ready',{tileSource:readySource});};if(url.match(/\.js$/)){//TODO: Its not very flexible to require tile sources to end jsonp
//      request for info  with a url that ends with '.js' but for
//      now it's the only way I see to distinguish uniformly.
callbackName=url.split('/').pop().replace('.js','');$.jsonp({url:url,async:false,callbackName:callbackName,callback:callback});}else{// request info via xhr asynchronously.
$.makeAjaxRequest({url:url,withCredentials:this.ajaxWithCredentials,headers:this.ajaxHeaders,success:function(xhr){var data=processResponse(xhr);callback(data);},error:function(xhr,exc){var msg;/*
                        IE < 10 will block XHR requests to different origins. Any property access on the request
                        object will raise an exception which we'll attempt to handle by formatting the original
                        exception rather than the second one raised when we try to access xhr.status
                     */try{msg="HTTP "+xhr.status+" attempting to load TileSource";}catch(e){var formattedExc;if(typeof exc=="undefined"||!exc.toString){formattedExc="Unknown error";}else{formattedExc=exc.toString();}msg=formattedExc+" attempting to load TileSource";}/***
                     * Raised when an error occurs loading a TileSource.
                     *
                     * @event open-failed
                     * @memberof OpenSeadragon.TileSource
                     * @type {object}
                     * @property {OpenSeadragon.TileSource} eventSource - A reference to the TileSource which raised the event.
                     * @property {String} message
                     * @property {String} source
                     * @property {?Object} userData - Arbitrary subscriber-defined object.
                     */_this.raiseEvent('open-failed',{message:msg,source:url});}});}},/**
     * Responsible determining if a the particular TileSource supports the
     * data format ( and allowed to apply logic against the url the data was
     * loaded from, if any ). Overriding implementations are expected to do
     * something smart with data and / or url to determine support.  Also
     * understand that iteration order of TileSources is not guarunteed so
     * please make sure your data or url is expressive enough to ensure a simple
     * and sufficient mechanisim for clear determination.
     * @function
     * @param {String|Object|Array|Document} data
     * @param {String} url - the url the data was loaded
     *      from if any.
     * @return {Boolean}
     */supports:function(data,url){return false;},/**
     * Responsible for parsing and configuring the
     * image metadata pertinent to this TileSources implementation.
     * This method is not implemented by this class other than to throw an Error
     * announcing you have to implement it.  Because of the variety of tile
     * server technologies, and various specifications for building image
     * pyramids, this method is here to allow easy integration.
     * @function
     * @param {String|Object|Array|Document} data
     * @param {String} url - the url the data was loaded
     *      from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     * @throws {Error}
     */configure:function(data,url){throw new Error("Method not implemented.");},/**
     * Responsible for retrieving the url which will return an image for the
     * region specified by the given x, y, and level components.
     * This method is not implemented by this class other than to throw an Error
     * announcing you have to implement it.  Because of the variety of tile
     * server technologies, and various specifications for building image
     * pyramids, this method is here to allow easy integration.
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     * @throws {Error}
     */getTileUrl:function(level,x,y){throw new Error("Method not implemented.");},/**
     * Responsible for retrieving the headers which will be attached to the image request for the
     * region specified by the given x, y, and level components.
     * This option is only relevant if {@link OpenSeadragon.Options}.loadTilesWithAjax is set to true.
     * The headers returned here will override headers specified at the Viewer or TiledImage level.
     * Specifying a falsy value for a header will clear its existing value set at the Viewer or
     * TiledImage level (if any).
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     * @returns {Object}
     */getTileAjaxHeaders:function(level,x,y){return{};},/**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */tileExists:function(level,x,y){var numTiles=this.getNumTiles(level);return level>=this.minLevel&&level<=this.maxLevel&&x>=0&&y>=0&&x<numTiles.x&&y<numTiles.y;}};$.extend(true,$.TileSource.prototype,$.EventSource.prototype);/**
 * Decides whether to try to process the response as xml, json, or hand back
 * the text
 * @private
 * @inner
 * @function
 * @param {XMLHttpRequest} xhr - the completed network request
 */function processResponse(xhr){var responseText=xhr.responseText,status=xhr.status,statusText,data;if(!xhr){throw new Error($.getString("Errors.Security"));}else if(xhr.status!==200&&xhr.status!==0){status=xhr.status;statusText=status==404?"Not Found":xhr.statusText;throw new Error($.getString("Errors.Status",status,statusText));}if(responseText.match(/\s*<.*/)){try{data=xhr.responseXML&&xhr.responseXML.documentElement?xhr.responseXML:$.parseXml(responseText);}catch(e){data=xhr.responseText;}}else if(responseText.match(/\s*[\{\[].*/)){try{data=$.parseJSON(responseText);}catch(e){data=responseText;}}else{data=responseText;}return data;}/**
 * Determines the TileSource Implementation by introspection of OpenSeadragon
 * namespace, calling each TileSource implementation of 'isType'
 * @private
 * @inner
 * @function
 * @param {Object|Array|Document} data - the tile source configuration object
 * @param {String} url - the url where the tile source configuration object was
 *      loaded from, if any.
 */$.TileSource.determineType=function(tileSource,data,url){var property;for(property in OpenSeadragon){if(property.match(/.+TileSource$/)&&$.isFunction(OpenSeadragon[property])&&$.isFunction(OpenSeadragon[property].prototype.supports)&&OpenSeadragon[property].prototype.supports.call(tileSource,data,url)){return OpenSeadragon[property];}}$.console.error("No TileSource was able to open %s %s",url,data);};})(OpenSeadragon);/*
 * OpenSeadragon - DziTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class DziTileSource
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @param {Number|Object} width - the pixel width of the image or the idiomatic
 *      options object which is used instead of positional arguments.
 * @param {Number} height
 * @param {Number} tileSize
 * @param {Number} tileOverlap
 * @param {String} tilesUrl
 * @param {String} fileFormat
 * @param {OpenSeadragon.DisplayRect[]} displayRects
 * @property {String} tilesUrl
 * @property {String} fileFormat
 * @property {OpenSeadragon.DisplayRect[]} displayRects
 */$.DziTileSource=function(width,height,tileSize,tileOverlap,tilesUrl,fileFormat,displayRects,minLevel,maxLevel){var i,rect,level,options;if($.isPlainObject(width)){options=width;}else{options={width:arguments[0],height:arguments[1],tileSize:arguments[2],tileOverlap:arguments[3],tilesUrl:arguments[4],fileFormat:arguments[5],displayRects:arguments[6],minLevel:arguments[7],maxLevel:arguments[8]};}this._levelRects={};this.tilesUrl=options.tilesUrl;this.fileFormat=options.fileFormat;this.displayRects=options.displayRects;if(this.displayRects){for(i=this.displayRects.length-1;i>=0;i--){rect=this.displayRects[i];for(level=rect.minLevel;level<=rect.maxLevel;level++){if(!this._levelRects[level]){this._levelRects[level]=[];}this._levelRects[level].push(rect);}}}$.TileSource.apply(this,[options]);};$.extend($.DziTileSource.prototype,$.TileSource.prototype,/** @lends OpenSeadragon.DziTileSource.prototype */{/**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */supports:function(data,url){var ns;if(data.Image){ns=data.Image.xmlns;}else if(data.documentElement){if("Image"==data.documentElement.localName||"Image"==data.documentElement.tagName){ns=data.documentElement.namespaceURI;}}ns=(ns||'').toLowerCase();return ns.indexOf('schemas.microsoft.com/deepzoom/2008')!==-1||ns.indexOf('schemas.microsoft.com/deepzoom/2009')!==-1;},/**
     *
     * @function
     * @param {Object|XMLDocument} data - the raw configuration
     * @param {String} url - the url the data was retrieved from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     */configure:function(data,url){var options;if(!$.isPlainObject(data)){options=configureFromXML(this,data);}else{options=configureFromObject(this,data);}if(url&&!options.tilesUrl){options.tilesUrl=url.replace(/([^\/]+?)(\.(dzi|xml|js)?(\?[^\/]*)?)?\/?$/,'$1_files/');if(url.search(/\.(dzi|xml|js)\?/)!=-1){options.queryParams=url.match(/\?.*/);}else{options.queryParams='';}}return options;},/**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */getTileUrl:function(level,x,y){return[this.tilesUrl,level,'/',x,'_',y,'.',this.fileFormat,this.queryParams].join('');},/**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */tileExists:function(level,x,y){var rects=this._levelRects[level],rect,scale,xMin,yMin,xMax,yMax,i;if(this.minLevel&&level<this.minLevel||this.maxLevel&&level>this.maxLevel){return false;}if(!rects||!rects.length){return true;}for(i=rects.length-1;i>=0;i--){rect=rects[i];if(level<rect.minLevel||level>rect.maxLevel){continue;}scale=this.getLevelScale(level);xMin=rect.x*scale;yMin=rect.y*scale;xMax=xMin+rect.width*scale;yMax=yMin+rect.height*scale;xMin=Math.floor(xMin/this._tileWidth);yMin=Math.floor(yMin/this._tileWidth);// DZI tiles are square, so we just use _tileWidth
xMax=Math.ceil(xMax/this._tileWidth);yMax=Math.ceil(yMax/this._tileWidth);if(xMin<=x&&x<xMax&&yMin<=y&&y<yMax){return true;}}return false;}});/**
 * @private
 * @inner
 * @function
 */function configureFromXML(tileSource,xmlDoc){if(!xmlDoc||!xmlDoc.documentElement){throw new Error($.getString("Errors.Xml"));}var root=xmlDoc.documentElement,rootName=root.localName||root.tagName,ns=xmlDoc.documentElement.namespaceURI,configuration=null,displayRects=[],dispRectNodes,dispRectNode,rectNode,sizeNode,i;if(rootName=="Image"){try{sizeNode=root.getElementsByTagName("Size")[0];if(sizeNode===undefined){sizeNode=root.getElementsByTagNameNS(ns,"Size")[0];}configuration={Image:{xmlns:"http://schemas.microsoft.com/deepzoom/2008",Url:root.getAttribute("Url"),Format:root.getAttribute("Format"),DisplayRect:null,Overlap:parseInt(root.getAttribute("Overlap"),10),TileSize:parseInt(root.getAttribute("TileSize"),10),Size:{Height:parseInt(sizeNode.getAttribute("Height"),10),Width:parseInt(sizeNode.getAttribute("Width"),10)}}};if(!$.imageFormatSupported(configuration.Image.Format)){throw new Error($.getString("Errors.ImageFormat",configuration.Image.Format.toUpperCase()));}dispRectNodes=root.getElementsByTagName("DisplayRect");if(dispRectNodes===undefined){dispRectNodes=root.getElementsByTagNameNS(ns,"DisplayRect")[0];}for(i=0;i<dispRectNodes.length;i++){dispRectNode=dispRectNodes[i];rectNode=dispRectNode.getElementsByTagName("Rect")[0];if(rectNode===undefined){rectNode=dispRectNode.getElementsByTagNameNS(ns,"Rect")[0];}displayRects.push({Rect:{X:parseInt(rectNode.getAttribute("X"),10),Y:parseInt(rectNode.getAttribute("Y"),10),Width:parseInt(rectNode.getAttribute("Width"),10),Height:parseInt(rectNode.getAttribute("Height"),10),MinLevel:parseInt(dispRectNode.getAttribute("MinLevel"),10),MaxLevel:parseInt(dispRectNode.getAttribute("MaxLevel"),10)}});}if(displayRects.length){configuration.Image.DisplayRect=displayRects;}return configureFromObject(tileSource,configuration);}catch(e){throw e instanceof Error?e:new Error($.getString("Errors.Dzi"));}}else if(rootName=="Collection"){throw new Error($.getString("Errors.Dzc"));}else if(rootName=="Error"){var messageNode=root.getElementsByTagName("Message")[0];var message=messageNode.firstChild.nodeValue;throw new Error(message);}throw new Error($.getString("Errors.Dzi"));}/**
 * @private
 * @inner
 * @function
 */function configureFromObject(tileSource,configuration){var imageData=configuration.Image,tilesUrl=imageData.Url,fileFormat=imageData.Format,sizeData=imageData.Size,dispRectData=imageData.DisplayRect||[],width=parseInt(sizeData.Width,10),height=parseInt(sizeData.Height,10),tileSize=parseInt(imageData.TileSize,10),tileOverlap=parseInt(imageData.Overlap,10),displayRects=[],rectData,i;//TODO: need to figure out out to better handle image format compatibility
//      which actually includes additional file formats like xml and pdf
//      and plain text for various tilesource implementations to avoid low
//      level errors.
//
//      For now, just don't perform the check.
//
/*if ( !imageFormatSupported( fileFormat ) ) {
        throw new Error(
            $.getString( "Errors.ImageFormat", fileFormat.toUpperCase() )
        );
    }*/for(i=0;i<dispRectData.length;i++){rectData=dispRectData[i].Rect;displayRects.push(new $.DisplayRect(parseInt(rectData.X,10),parseInt(rectData.Y,10),parseInt(rectData.Width,10),parseInt(rectData.Height,10),parseInt(rectData.MinLevel,10),parseInt(rectData.MaxLevel,10)));}return $.extend(true,{width:width,/* width *required */height:height,/* height *required */tileSize:tileSize,/* tileSize *required */tileOverlap:tileOverlap,/* tileOverlap *required */minLevel:null,/* minLevel */maxLevel:null,/* maxLevel */tilesUrl:tilesUrl,/* tilesUrl */fileFormat:fileFormat,/* fileFormat */displayRects:displayRects/* displayRects */},configuration);}})(OpenSeadragon);/*
 * OpenSeadragon - IIIFTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class IIIFTileSource
 * @classdesc A client implementation of the International Image Interoperability Framework
 * Format: Image API 1.0 - 2.1
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @see http://iiif.io/api/image/
 * @param {String} [options.tileFormat='jpg']
 *      The extension that will be used when requiring tiles.
 */$.IIIFTileSource=function(options){/* eslint-disable camelcase */$.extend(true,this,options);if(!(this.height&&this.width&&this['@id'])){throw new Error('IIIF required parameters not provided.');}options.tileSizePerScaleFactor={};this.tileFormat=this.tileFormat||'jpg';this.version=options.version;// N.B. 2.0 renamed scale_factors to scaleFactors
if(this.tile_width&&this.tile_height){options.tileWidth=this.tile_width;options.tileHeight=this.tile_height;}else if(this.tile_width){options.tileSize=this.tile_width;}else if(this.tile_height){options.tileSize=this.tile_height;}else if(this.tiles){// Version 2.0 forwards
if(this.tiles.length==1){options.tileWidth=this.tiles[0].width;// Use height if provided, otherwise assume square tiles and use width.
options.tileHeight=this.tiles[0].height||this.tiles[0].width;this.scale_factors=this.tiles[0].scaleFactors;}else{// Multiple tile sizes at different levels
this.scale_factors=[];for(var t=0;t<this.tiles.length;t++){for(var sf=0;sf<this.tiles[t].scaleFactors.length;sf++){var scaleFactor=this.tiles[t].scaleFactors[sf];this.scale_factors.push(scaleFactor);options.tileSizePerScaleFactor[scaleFactor]={width:this.tiles[t].width,height:this.tiles[t].height||this.tiles[t].width};}}}}else if(canBeTiled(options)){// use the largest of tileOptions that is smaller than the short dimension
var shortDim=Math.min(this.height,this.width),tileOptions=[256,512,1024],smallerTiles=[];for(var c=0;c<tileOptions.length;c++){if(tileOptions[c]<=shortDim){smallerTiles.push(tileOptions[c]);}}if(smallerTiles.length>0){options.tileSize=Math.max.apply(null,smallerTiles);}else{// If we're smaller than 256, just use the short side.
options.tileSize=shortDim;}}else if(this.sizes&&this.sizes.length>0){// This info.json can't be tiled, but we can still construct a legacy pyramid from the sizes array.
// In this mode, IIIFTileSource will call functions from the abstract baseTileSource or the
// LegacyTileSource instead of performing IIIF tiling.
this.emulateLegacyImagePyramid=true;options.levels=constructLevels(this);// use the largest available size to define tiles
$.extend(true,options,{width:options.levels[options.levels.length-1].width,height:options.levels[options.levels.length-1].height,tileSize:Math.max(options.height,options.width),tileOverlap:0,minLevel:0,maxLevel:options.levels.length-1});this.levels=options.levels;}else{$.console.error("Nothing in the info.json to construct image pyramids from");}if(!options.maxLevel&&!this.emulateLegacyImagePyramid){if(!this.scale_factors){options.maxLevel=Number(Math.ceil(Math.log(Math.max(this.width,this.height),2)));}else{var maxScaleFactor=Math.max.apply(null,this.scale_factors);options.maxLevel=Math.round(Math.log(maxScaleFactor)*Math.LOG2E);}}$.TileSource.apply(this,[options]);};$.extend($.IIIFTileSource.prototype,$.TileSource.prototype,/** @lends OpenSeadragon.IIIFTileSource.prototype */{/**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */supports:function(data,url){// Version 2.0 and forwards
if(data.protocol&&data.protocol=='http://iiif.io/api/image'){return true;// Version 1.1
}else if(data['@context']&&(data['@context']=="http://library.stanford.edu/iiif/image-api/1.1/context.json"||data['@context']=="http://iiif.io/api/image/1/context.json")){// N.B. the iiif.io context is wrong, but where the representation lives so likely to be used
return true;// Version 1.0
}else if(data.profile&&data.profile.indexOf("http://library.stanford.edu/iiif/image-api/compliance.html")===0){return true;}else if(data.identifier&&data.width&&data.height){return true;}else if(data.documentElement&&"info"==data.documentElement.tagName&&"http://library.stanford.edu/iiif/image-api/ns/"==data.documentElement.namespaceURI){return true;// Not IIIF
}else{return false;}},/**
     *
     * @function
     * @param {Object} data - the raw configuration
     * @example <caption>IIIF 1.1 Info Looks like this</caption>
     * {
     *   "@context" : "http://library.stanford.edu/iiif/image-api/1.1/context.json",
     *   "@id" : "http://iiif.example.com/prefix/1E34750D-38DB-4825-A38A-B60A345E591C",
     *   "width" : 6000,
     *   "height" : 4000,
     *   "scale_factors" : [ 1, 2, 4 ],
     *   "tile_width" : 1024,
     *   "tile_height" : 1024,
     *   "formats" : [ "jpg", "png" ],
     *   "qualities" : [ "native", "grey" ],
     *   "profile" : "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0"
     * }
     */configure:function(data,url){// Try to deduce our version and fake it upwards if needed
if(!$.isPlainObject(data)){var options=configureFromXml10(data);options['@context']="http://iiif.io/api/image/1.0/context.json";options['@id']=url.replace('/info.xml','');options.version=1;return options;}else{if(!data['@context']){data['@context']='http://iiif.io/api/image/1.0/context.json';data['@id']=url.replace('/info.json','');data.version=1;}else{var context=data['@context'];if(Array.isArray(context)){for(var i=0;i<context.length;i++){if(typeof context[i]==='string'&&(/^http:\/\/iiif\.io\/api\/image\/[1-3]\/context\.json$/.test(context[i])||context[i]==='http://library.stanford.edu/iiif/image-api/1.1/context.json')){context=context[i];break;}}}switch(context){case'http://iiif.io/api/image/1/context.json':case'http://library.stanford.edu/iiif/image-api/1.1/context.json':data.version=1;break;case'http://iiif.io/api/image/2/context.json':data.version=2;break;case'http://iiif.io/api/image/3/context.json':data.version=3;break;default:$.console.error('Data has a @context property which contains no known IIIF context URI.');}}if(!data['@id']&&data['id']){data['@id']=data['id'];}if(data.preferredFormats){for(var f=0;f<data.preferredFormats.length;f++){if(OpenSeadragon.imageFormatSupported(data.preferredFormats[f])){data.tileFormat=data.preferredFormats[f];break;}}}return data;}},/**
     * Return the tileWidth for the given level.
     * @function
     * @param {Number} level
     */getTileWidth:function(level){if(this.emulateLegacyImagePyramid){return $.TileSource.prototype.getTileWidth.call(this,level);}var scaleFactor=Math.pow(2,this.maxLevel-level);if(this.tileSizePerScaleFactor&&this.tileSizePerScaleFactor[scaleFactor]){return this.tileSizePerScaleFactor[scaleFactor].width;}return this._tileWidth;},/**
     * Return the tileHeight for the given level.
     * @function
     * @param {Number} level
     */getTileHeight:function(level){if(this.emulateLegacyImagePyramid){return $.TileSource.prototype.getTileHeight.call(this,level);}var scaleFactor=Math.pow(2,this.maxLevel-level);if(this.tileSizePerScaleFactor&&this.tileSizePerScaleFactor[scaleFactor]){return this.tileSizePerScaleFactor[scaleFactor].height;}return this._tileHeight;},/**
     * @function
     * @param {Number} level
     */getLevelScale:function(level){if(this.emulateLegacyImagePyramid){var levelScale=NaN;if(this.levels.length>0&&level>=this.minLevel&&level<=this.maxLevel){levelScale=this.levels[level].width/this.levels[this.maxLevel].width;}return levelScale;}return $.TileSource.prototype.getLevelScale.call(this,level);},/**
     * @function
     * @param {Number} level
     */getNumTiles:function(level){if(this.emulateLegacyImagePyramid){var scale=this.getLevelScale(level);if(scale){return new $.Point(1,1);}else{return new $.Point(0,0);}}return $.TileSource.prototype.getNumTiles.call(this,level);},/**
     * @function
     * @param {Number} level
     * @param {OpenSeadragon.Point} point
     */getTileAtPoint:function(level,point){if(this.emulateLegacyImagePyramid){return new $.Point(0,0);}return $.TileSource.prototype.getTileAtPoint.call(this,level,point);},/**
     * Responsible for retrieving the url which will return an image for the
     * region specified by the given x, y, and level components.
     * @function
     * @param {Number} level - z index
     * @param {Number} x
     * @param {Number} y
     * @throws {Error}
     */getTileUrl:function(level,x,y){if(this.emulateLegacyImagePyramid){var url=null;if(this.levels.length>0&&level>=this.minLevel&&level<=this.maxLevel){url=this.levels[level].url;}return url;}//# constants
var IIIF_ROTATION='0',//## get the scale (level as a decimal)
scale=Math.pow(0.5,this.maxLevel-level),//# image dimensions at this level
levelWidth=Math.ceil(this.width*scale),levelHeight=Math.ceil(this.height*scale),//## iiif region
tileWidth,tileHeight,iiifTileSizeWidth,iiifTileSizeHeight,iiifRegion,iiifTileX,iiifTileY,iiifTileW,iiifTileH,iiifSize,iiifSizeW,iiifSizeH,iiifQuality,uri;tileWidth=this.getTileWidth(level);tileHeight=this.getTileHeight(level);iiifTileSizeWidth=Math.ceil(tileWidth/scale);iiifTileSizeHeight=Math.ceil(tileHeight/scale);if(this.version===1){iiifQuality="native."+this.tileFormat;}else{iiifQuality="default."+this.tileFormat;}if(levelWidth<tileWidth&&levelHeight<tileHeight){if(this.version===2&&levelWidth===this.width){iiifSize="max";}else if(this.version===3&&levelWidth===this.width&&levelHeight===this.height){iiifSize="max";}else if(this.version===3){iiifSize=levelWidth+","+levelHeight;}else{iiifSize=levelWidth+",";}iiifRegion='full';}else{iiifTileX=x*iiifTileSizeWidth;iiifTileY=y*iiifTileSizeHeight;iiifTileW=Math.min(iiifTileSizeWidth,this.width-iiifTileX);iiifTileH=Math.min(iiifTileSizeHeight,this.height-iiifTileY);if(x===0&&y===0&&iiifTileW===this.width&&iiifTileH===this.height){iiifRegion="full";}else{iiifRegion=[iiifTileX,iiifTileY,iiifTileW,iiifTileH].join(',');}iiifSizeW=Math.ceil(iiifTileW*scale);iiifSizeH=Math.ceil(iiifTileH*scale);if(this.version===2&&iiifSizeW===this.width){iiifSize="max";}else if(this.version===3&&iiifSizeW===this.width&&iiifSizeH===this.height){iiifSize="max";}else if(this.version===3){iiifSize=iiifSizeW+","+iiifSizeH;}else{iiifSize=iiifSizeW+",";}}uri=[this['@id'],iiifRegion,iiifSize,IIIF_ROTATION,iiifQuality].join('/');return uri;},__testonly__:{canBeTiled:canBeTiled,constructLevels:constructLevels}});/**
     * Determine whether arbitrary tile requests can be made against a service with the given profile
     * @function
     * @param {array} profile - IIIF profile array
     * @throws {Error}
     */function canBeTiled(options){var level0Profiles=["http://library.stanford.edu/iiif/image-api/compliance.html#level0","http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0","http://iiif.io/api/image/2/level0.json","level0","https://iiif.io/api/image/3/level0.json"];var profileLevel=Array.isArray(options.profile)?options.profile[0]:options.profile;var isLevel0=level0Profiles.indexOf(profileLevel)!==-1;var hasCanoncicalSizeFeature=false;if(options.version===2&&options.profile.length>1&&options.profile[1].supports){hasCanoncicalSizeFeature=options.profile[1].supports.indexOf("sizeByW")!==-1;}if(options.version===3&&options.extraFeatures){hasCanoncicalSizeFeature=options.extraFeatures.indexOf("sizeByWh")!==-1;}return!isLevel0||hasCanoncicalSizeFeature;}/**
     * Build the legacy pyramid URLs (one tile per level)
     * @function
     * @param {object} options - infoJson
     * @throws {Error}
     */function constructLevels(options){var levels=[];for(var i=0;i<options.sizes.length;i++){levels.push({url:options['@id']+'/full/'+options.sizes[i].width+','+(options.version===3?options.sizes[i].height:'')+'/0/default.'+options.tileFormat,width:options.sizes[i].width,height:options.sizes[i].height});}return levels.sort(function(a,b){return a.width-b.width;});}function configureFromXml10(xmlDoc){//parse the xml
if(!xmlDoc||!xmlDoc.documentElement){throw new Error($.getString("Errors.Xml"));}var root=xmlDoc.documentElement,rootName=root.tagName,configuration=null;if(rootName=="info"){try{configuration={};parseXML10(root,configuration);return configuration;}catch(e){throw e instanceof Error?e:new Error($.getString("Errors.IIIF"));}}throw new Error($.getString("Errors.IIIF"));}function parseXML10(node,configuration,property){var i,value;if(node.nodeType==3&&property){//text node
value=node.nodeValue.trim();if(value.match(/^\d*$/)){value=Number(value);}if(!configuration[property]){configuration[property]=value;}else{if(!$.isArray(configuration[property])){configuration[property]=[configuration[property]];}configuration[property].push(value);}}else if(node.nodeType==1){for(i=0;i<node.childNodes.length;i++){parseXML10(node.childNodes[i],configuration,node.nodeName);}}}})(OpenSeadragon);/*
 * OpenSeadragon - OsmTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *//*
 * Derived from the OSM tile source in Rainer Simon's seajax-utils project
 * <http://github.com/rsimon/seajax-utils>.  Rainer Simon has contributed
 * the included code to the OpenSeadragon project under the New BSD license;
 * see <https://github.com/openseadragon/openseadragon/issues/58>.
 */(function($){/**
 * @class OsmTileSource
 * @classdesc A tilesource implementation for OpenStreetMap.<br><br>
 *
 * Note 1. Zoomlevels. Deep Zoom and OSM define zoom levels differently. In  Deep
 * Zoom, level 0 equals an image of 1x1 pixels. In OSM, level 0 equals an image of
 * 256x256 levels (see http://gasi.ch/blog/inside-deep-zoom-2). I.e. there is a
 * difference of log2(256)=8 levels.<br><br>
 *
 * Note 2. Image dimension. According to the OSM Wiki
 * (http://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#Zoom_levels)
 * the highest Mapnik zoom level has 256.144x256.144 tiles, with a 256x256
 * pixel size. I.e. the Deep Zoom image dimension is 65.572.864x65.572.864
 * pixels.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @param {Number|Object} width - the pixel width of the image or the idiomatic
 *      options object which is used instead of positional arguments.
 * @param {Number} height
 * @param {Number} tileSize
 * @param {Number} tileOverlap
 * @param {String} tilesUrl
 */$.OsmTileSource=function(width,height,tileSize,tileOverlap,tilesUrl){var options;if($.isPlainObject(width)){options=width;}else{options={width:arguments[0],height:arguments[1],tileSize:arguments[2],tileOverlap:arguments[3],tilesUrl:arguments[4]};}//apply default setting for standard public OpenStreatMaps service
//but allow them to be specified so fliks can host there own instance
//or apply against other services supportting the same standard
if(!options.width||!options.height){options.width=65572864;options.height=65572864;}if(!options.tileSize){options.tileSize=256;options.tileOverlap=0;}if(!options.tilesUrl){options.tilesUrl="http://tile.openstreetmap.org/";}options.minLevel=8;$.TileSource.apply(this,[options]);};$.extend($.OsmTileSource.prototype,$.TileSource.prototype,/** @lends OpenSeadragon.OsmTileSource.prototype */{/**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */supports:function(data,url){return data.type&&"openstreetmaps"==data.type;},/**
     *
     * @function
     * @param {Object} data - the raw configuration
     * @param {String} url - the url the data was retrieved from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     */configure:function(data,url){return data;},/**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */getTileUrl:function(level,x,y){return this.tilesUrl+(level-8)+"/"+x+"/"+y+".png";}});})(OpenSeadragon);/*
 * OpenSeadragon - TmsTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *//*
 * Derived from the TMS tile source in Rainer Simon's seajax-utils project
 * <http://github.com/rsimon/seajax-utils>.  Rainer Simon has contributed
 * the included code to the OpenSeadragon project under the New BSD license;
 * see <https://github.com/openseadragon/openseadragon/issues/58>.
 */(function($){/**
 * @class TmsTileSource
 * @classdesc A tilesource implementation for Tiled Map Services (TMS).
 * TMS tile scheme ( [ as supported by OpenLayers ] is described here
 * ( http://openlayers.org/dev/examples/tms.html ).
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @param {Number|Object} width - the pixel width of the image or the idiomatic
 *      options object which is used instead of positional arguments.
 * @param {Number} height
 * @param {Number} tileSize
 * @param {Number} tileOverlap
 * @param {String} tilesUrl
 */$.TmsTileSource=function(width,height,tileSize,tileOverlap,tilesUrl){var options;if($.isPlainObject(width)){options=width;}else{options={width:arguments[0],height:arguments[1],tileSize:arguments[2],tileOverlap:arguments[3],tilesUrl:arguments[4]};}// TMS has integer multiples of 256 for width/height and adds buffer
// if necessary -> account for this!
var bufferedWidth=Math.ceil(options.width/256)*256,bufferedHeight=Math.ceil(options.height/256)*256,max;// Compute number of zoomlevels in this tileset
if(bufferedWidth>bufferedHeight){max=bufferedWidth/256;}else{max=bufferedHeight/256;}options.maxLevel=Math.ceil(Math.log(max)/Math.log(2))-1;options.tileSize=256;options.width=bufferedWidth;options.height=bufferedHeight;$.TileSource.apply(this,[options]);};$.extend($.TmsTileSource.prototype,$.TileSource.prototype,/** @lends OpenSeadragon.TmsTileSource.prototype */{/**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */supports:function(data,url){return data.type&&"tiledmapservice"==data.type;},/**
     *
     * @function
     * @param {Object} data - the raw configuration
     * @param {String} url - the url the data was retrieved from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     */configure:function(data,url){return data;},/**
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     */getTileUrl:function(level,x,y){// Convert from Deep Zoom definition to TMS zoom definition
var yTiles=this.getNumTiles(level).y-1;return this.tilesUrl+level+"/"+x+"/"+(yTiles-y)+".png";}});})(OpenSeadragon);(function($){/**
     * @class ZoomifyTileSource
     * @classdesc A tilesource implementation for the zoomify format.
     *
     * A description of the format can be found here:
     * https://ecommons.cornell.edu/bitstream/handle/1813/5410/Introducing_Zoomify_Image.pdf
     *
     * There are two ways of creating a zoomify tilesource for openseadragon
     *
     * 1) Supplying all necessary information in the tilesource object. A minimal example object for this method looks like this:
     *
     * {
     *      type: "zoomifytileservice",
     *      width: 1000,
     *      height: 1000,
     *      tilesUrl: "/test/data/zoomify/"
     * }
     *
     * The tileSize is currently hardcoded to 256 (the usual Zoomify default). The tileUrl must the path to the image _directory_.
     *
     * 2) Loading image metadata from xml file: (CURRENTLY NOT SUPPORTED)
     *
     * When creating zoomify formatted images one "xml" like file with name ImageProperties.xml
     * will be created as well. Here is an example of such a file:
     *
     * <IMAGE_PROPERTIES WIDTH="1000" HEIGHT="1000" NUMTILES="21" NUMIMAGES="1" VERSION="1.8" TILESIZE="256" />
     *
     * To use this xml file as metadata source you must supply the path to the ImageProperties.xml file and leave out all other parameters:
     * As stated above, this method of loading a zoomify tilesource is currently not supported
     *
     * {
     *      type: "zoomifytileservice",
     *      tilesUrl: "/test/data/zoomify/ImageProperties.xml"
     * }

    *
    * @memberof OpenSeadragon
     * @extends OpenSeadragon.TileSource
     * @param {Number} width - the pixel width of the image.
     * @param {Number} height
     * @param {Number} tileSize
     * @param {String} tilesUrl
     */$.ZoomifyTileSource=function(options){options.tileSize=256;var currentImageSize={x:options.width,y:options.height};options.imageSizes=[{x:options.width,y:options.height}];options.gridSize=[this._getGridSize(options.width,options.height,options.tileSize)];while(parseInt(currentImageSize.x,10)>options.tileSize||parseInt(currentImageSize.y,10)>options.tileSize){currentImageSize.x=Math.floor(currentImageSize.x/2);currentImageSize.y=Math.floor(currentImageSize.y/2);options.imageSizes.push({x:currentImageSize.x,y:currentImageSize.y});options.gridSize.push(this._getGridSize(currentImageSize.x,currentImageSize.y,options.tileSize));}options.imageSizes.reverse();options.gridSize.reverse();options.minLevel=0;options.maxLevel=options.gridSize.length-1;OpenSeadragon.TileSource.apply(this,[options]);};$.extend($.ZoomifyTileSource.prototype,$.TileSource.prototype,/** @lends OpenSeadragon.ZoomifyTileSource.prototype */{//private
_getGridSize:function(width,height,tileSize){return{x:Math.ceil(width/tileSize),y:Math.ceil(height/tileSize)};},//private
_calculateAbsoluteTileNumber:function(level,x,y){var num=0;var size={};//Sum up all tiles below the level we want the number of tiles
for(var z=0;z<level;z++){size=this.gridSize[z];num+=size.x*size.y;}//Add the tiles of the level
size=this.gridSize[level];num+=size.x*y+x;return num;},/**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */supports:function(data,url){return data.type&&"zoomifytileservice"==data.type;},/**
         *
         * @function
         * @param {Object} data - the raw configuration
         * @param {String} url - the url the data was retrieved from if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */configure:function(data,url){return data;},/**
         * @function
         * @param {Number} level
         * @param {Number} x
         * @param {Number} y
         */getTileUrl:function(level,x,y){//console.log(level);
var result=0;var num=this._calculateAbsoluteTileNumber(level,x,y);result=Math.floor(num/256);return this.tilesUrl+'TileGroup'+result+'/'+level+'-'+x+'-'+y+'.jpg';}});})(OpenSeadragon);/*
 * OpenSeadragon - LegacyTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class LegacyTileSource
 * @classdesc The LegacyTileSource allows simple, traditional image pyramids to be loaded
 * into an OpenSeadragon Viewer.  Basically, this translates to the historically
 * common practice of starting with a 'master' image, maybe a tiff for example,
 * and generating a set of 'service' images like one or more thumbnails, a medium
 * resolution image and a high resolution image in standard web formats like
 * png or jpg.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.TileSource
 * @param {Array} levels An array of file descriptions, each is an object with
 *      a 'url', a 'width', and a 'height'.  Overriding classes can expect more
 *      properties but these properties are sufficient for this implementation.
 *      Additionally, the levels are required to be listed in order from
 *      smallest to largest.
 * @property {Number} aspectRatio
 * @property {Number} dimensions
 * @property {Number} tileSize
 * @property {Number} tileOverlap
 * @property {Number} minLevel
 * @property {Number} maxLevel
 * @property {Array}  levels
 */$.LegacyTileSource=function(levels){var options,width,height;if($.isArray(levels)){options={type:'legacy-image-pyramid',levels:levels};}//clean up the levels to make sure we support all formats
options.levels=filterFiles(options.levels);if(options.levels.length>0){width=options.levels[options.levels.length-1].width;height=options.levels[options.levels.length-1].height;}else{width=0;height=0;$.console.error("No supported image formats found");}$.extend(true,options,{width:width,height:height,tileSize:Math.max(height,width),tileOverlap:0,minLevel:0,maxLevel:options.levels.length>0?options.levels.length-1:0});$.TileSource.apply(this,[options]);this.levels=options.levels;};$.extend($.LegacyTileSource.prototype,$.TileSource.prototype,/** @lends OpenSeadragon.LegacyTileSource.prototype */{/**
     * Determine if the data and/or url imply the image service is supported by
     * this tile source.
     * @function
     * @param {Object|Array} data
     * @param {String} optional - url
     */supports:function(data,url){return data.type&&"legacy-image-pyramid"==data.type||data.documentElement&&"legacy-image-pyramid"==data.documentElement.getAttribute('type');},/**
     *
     * @function
     * @param {Object|XMLDocument} configuration - the raw configuration
     * @param {String} dataUrl - the url the data was retrieved from if any.
     * @return {Object} options - A dictionary of keyword arguments sufficient
     *      to configure this tile sources constructor.
     */configure:function(configuration,dataUrl){var options;if(!$.isPlainObject(configuration)){options=configureFromXML(this,configuration);}else{options=configureFromObject(this,configuration);}return options;},/**
     * @function
     * @param {Number} level
     */getLevelScale:function(level){var levelScale=NaN;if(this.levels.length>0&&level>=this.minLevel&&level<=this.maxLevel){levelScale=this.levels[level].width/this.levels[this.maxLevel].width;}return levelScale;},/**
     * @function
     * @param {Number} level
     */getNumTiles:function(level){var scale=this.getLevelScale(level);if(scale){return new $.Point(1,1);}else{return new $.Point(0,0);}},/**
     * This method is not implemented by this class other than to throw an Error
     * announcing you have to implement it.  Because of the variety of tile
     * server technologies, and various specifications for building image
     * pyramids, this method is here to allow easy integration.
     * @function
     * @param {Number} level
     * @param {Number} x
     * @param {Number} y
     * @throws {Error}
     */getTileUrl:function(level,x,y){var url=null;if(this.levels.length>0&&level>=this.minLevel&&level<=this.maxLevel){url=this.levels[level].url;}return url;}});/**
 * This method removes any files from the Array which don't conform to our
 * basic requirements for a 'level' in the LegacyTileSource.
 * @private
 * @inner
 * @function
 */function filterFiles(files){var filtered=[],file,i;for(i=0;i<files.length;i++){file=files[i];if(file.height&&file.width&&file.url){//This is sufficient to serve as a level
filtered.push({url:file.url,width:Number(file.width),height:Number(file.height)});}else{$.console.error('Unsupported image format: %s',file.url?file.url:'<no URL>');}}return filtered.sort(function(a,b){return a.height-b.height;});}/**
 * @private
 * @inner
 * @function
 */function configureFromXML(tileSource,xmlDoc){if(!xmlDoc||!xmlDoc.documentElement){throw new Error($.getString("Errors.Xml"));}var root=xmlDoc.documentElement,rootName=root.tagName,conf=null,levels=[],level,i;if(rootName=="image"){try{conf={type:root.getAttribute("type"),levels:[]};levels=root.getElementsByTagName("level");for(i=0;i<levels.length;i++){level=levels[i];conf.levels.push({url:level.getAttribute("url"),width:parseInt(level.getAttribute("width"),10),height:parseInt(level.getAttribute("height"),10)});}return configureFromObject(tileSource,conf);}catch(e){throw e instanceof Error?e:new Error('Unknown error parsing Legacy Image Pyramid XML.');}}else if(rootName=="collection"){throw new Error('Legacy Image Pyramid Collections not yet supported.');}else if(rootName=="error"){throw new Error('Error: '+xmlDoc);}throw new Error('Unknown element '+rootName);}/**
 * @private
 * @inner
 * @function
 */function configureFromObject(tileSource,configuration){return configuration.levels;}})(OpenSeadragon);/*
 * OpenSeadragon - ImageTileSource
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
     * @class ImageTileSource
     * @classdesc The ImageTileSource allows a simple image to be loaded
     * into an OpenSeadragon Viewer.
     * There are 2 ways to open an ImageTileSource:
     * 1. viewer.open({type: 'image', url: fooUrl});
     * 2. viewer.open(new OpenSeadragon.ImageTileSource({url: fooUrl}));
     *
     * With the first syntax, the crossOriginPolicy, ajaxWithCredentials and
     * useCanvas options are inherited from the viewer if they are not
     * specified directly in the options object.
     *
     * @memberof OpenSeadragon
     * @extends OpenSeadragon.TileSource
     * @param {Object} options Options object.
     * @param {String} options.url URL of the image
     * @param {Boolean} [options.buildPyramid=true] If set to true (default), a
     * pyramid will be built internally to provide a better downsampling.
     * @param {String|Boolean} [options.crossOriginPolicy=false] Valid values are
     * 'Anonymous', 'use-credentials', and false. If false, image requests will
     * not use CORS preventing internal pyramid building for images from other
     * domains.
     * @param {String|Boolean} [options.ajaxWithCredentials=false] Whether to set
     * the withCredentials XHR flag for AJAX requests (when loading tile sources).
     * @param {Boolean} [options.useCanvas=true] Set to false to prevent any use
     * of the canvas API.
     */$.ImageTileSource=function(options){options=$.extend({buildPyramid:true,crossOriginPolicy:false,ajaxWithCredentials:false,useCanvas:true},options);$.TileSource.apply(this,[options]);};$.extend($.ImageTileSource.prototype,$.TileSource.prototype,/** @lends OpenSeadragon.ImageTileSource.prototype */{/**
         * Determine if the data and/or url imply the image service is supported by
         * this tile source.
         * @function
         * @param {Object|Array} data
         * @param {String} optional - url
         */supports:function(data,url){return data.type&&data.type==="image";},/**
         *
         * @function
         * @param {Object} options - the options
         * @param {String} dataUrl - the url the image was retrieved from, if any.
         * @return {Object} options - A dictionary of keyword arguments sufficient
         *      to configure this tile sources constructor.
         */configure:function(options,dataUrl){return options;},/**
         * Responsible for retrieving, and caching the
         * image metadata pertinent to this TileSources implementation.
         * @function
         * @param {String} url
         * @throws {Error}
         */getImageInfo:function(url){var image=this._image=new Image();var _this=this;if(this.crossOriginPolicy){image.crossOrigin=this.crossOriginPolicy;}if(this.ajaxWithCredentials){image.useCredentials=this.ajaxWithCredentials;}$.addEvent(image,'load',function(){/* IE8 fix since it has no naturalWidth and naturalHeight */_this.width=Object.prototype.hasOwnProperty.call(image,'naturalWidth')?image.naturalWidth:image.width;_this.height=Object.prototype.hasOwnProperty.call(image,'naturalHeight')?image.naturalHeight:image.height;_this.aspectRatio=_this.width/_this.height;_this.dimensions=new $.Point(_this.width,_this.height);_this._tileWidth=_this.width;_this._tileHeight=_this.height;_this.tileOverlap=0;_this.minLevel=0;_this.levels=_this._buildLevels();_this.maxLevel=_this.levels.length-1;_this.ready=true;// Note: this event is documented elsewhere, in TileSource
_this.raiseEvent('ready',{tileSource:_this});});$.addEvent(image,'error',function(){// Note: this event is documented elsewhere, in TileSource
_this.raiseEvent('open-failed',{message:"Error loading image at "+url,source:url});});image.src=url;},/**
         * @function
         * @param {Number} level
         */getLevelScale:function(level){var levelScale=NaN;if(level>=this.minLevel&&level<=this.maxLevel){levelScale=this.levels[level].width/this.levels[this.maxLevel].width;}return levelScale;},/**
         * @function
         * @param {Number} level
         */getNumTiles:function(level){var scale=this.getLevelScale(level);if(scale){return new $.Point(1,1);}else{return new $.Point(0,0);}},/**
         * Retrieves a tile url
         * @function
         * @param {Number} level Level of the tile
         * @param {Number} x x coordinate of the tile
         * @param {Number} y y coordinate of the tile
         */getTileUrl:function(level,x,y){var url=null;if(level>=this.minLevel&&level<=this.maxLevel){url=this.levels[level].url;}return url;},/**
         * Retrieves a tile context 2D
         * @function
         * @param {Number} level Level of the tile
         * @param {Number} x x coordinate of the tile
         * @param {Number} y y coordinate of the tile
         */getContext2D:function(level,x,y){var context=null;if(level>=this.minLevel&&level<=this.maxLevel){context=this.levels[level].context2D;}return context;},// private
//
// Builds the different levels of the pyramid if possible
// (i.e. if canvas API enabled and no canvas tainting issue).
_buildLevels:function(){var levels=[{url:this._image.src,/* IE8 fix since it has no naturalWidth and naturalHeight */width:Object.prototype.hasOwnProperty.call(this._image,'naturalWidth')?this._image.naturalWidth:this._image.width,height:Object.prototype.hasOwnProperty.call(this._image,'naturalHeight')?this._image.naturalHeight:this._image.height}];if(!this.buildPyramid||!$.supportsCanvas||!this.useCanvas){// We don't need the image anymore. Allows it to be GC.
delete this._image;return levels;}/* IE8 fix since it has no naturalWidth and naturalHeight */var currentWidth=Object.prototype.hasOwnProperty.call(this._image,'naturalWidth')?this._image.naturalWidth:this._image.width;var currentHeight=Object.prototype.hasOwnProperty.call(this._image,'naturalHeight')?this._image.naturalHeight:this._image.height;var bigCanvas=document.createElement("canvas");var bigContext=bigCanvas.getContext("2d");bigCanvas.width=currentWidth;bigCanvas.height=currentHeight;bigContext.drawImage(this._image,0,0,currentWidth,currentHeight);// We cache the context of the highest level because the browser
// is a lot faster at downsampling something it already has
// downsampled before.
levels[0].context2D=bigContext;// We don't need the image anymore. Allows it to be GC.
delete this._image;if($.isCanvasTainted(bigCanvas)){// If the canvas is tainted, we can't compute the pyramid.
return levels;}// We build smaller levels until either width or height becomes
// 1 pixel wide.
while(currentWidth>=2&&currentHeight>=2){currentWidth=Math.floor(currentWidth/2);currentHeight=Math.floor(currentHeight/2);var smallCanvas=document.createElement("canvas");var smallContext=smallCanvas.getContext("2d");smallCanvas.width=currentWidth;smallCanvas.height=currentHeight;smallContext.drawImage(bigCanvas,0,0,currentWidth,currentHeight);levels.splice(0,0,{context2D:smallContext,width:currentWidth,height:currentHeight});bigCanvas=smallCanvas;bigContext=smallContext;}return levels;}});})(OpenSeadragon);/*
 * OpenSeadragon - TileSourceCollection
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){// deprecated
$.TileSourceCollection=function(tileSize,tileSources,rows,layout){$.console.error('TileSourceCollection is deprecated; use World instead');};})(OpenSeadragon);/*
 * OpenSeadragon - Button
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * An enumeration of button states
 * @member ButtonState
 * @memberof OpenSeadragon
 * @static
 * @type {Object}
 * @property {Number} REST
 * @property {Number} GROUP
 * @property {Number} HOVER
 * @property {Number} DOWN
 */$.ButtonState={REST:0,GROUP:1,HOVER:2,DOWN:3};/**
 * @class Button
 * @classdesc Manages events, hover states for individual buttons, tool-tips, as well
 * as fading the buttons out when the user has not interacted with them
 * for a specified period.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @param {Object} options
 * @param {Element} [options.element=null] Element to use as the button. If not specified, an HTML &lt;div&gt; element is created.
 * @param {String} [options.tooltip=null] Provides context help for the button when the
 *  user hovers over it.
 * @param {String} [options.srcRest=null] URL of image to use in 'rest' state.
 * @param {String} [options.srcGroup=null] URL of image to use in 'up' state.
 * @param {String} [options.srcHover=null] URL of image to use in 'hover' state.
 * @param {String} [options.srcDown=null] URL of image to use in 'down' state.
 * @param {Number} [options.fadeDelay=0] How long to wait before fading.
 * @param {Number} [options.fadeLength=2000] How long should it take to fade the button.
 * @param {OpenSeadragon.EventHandler} [options.onPress=null] Event handler callback for {@link OpenSeadragon.Button.event:press}.
 * @param {OpenSeadragon.EventHandler} [options.onRelease=null] Event handler callback for {@link OpenSeadragon.Button.event:release}.
 * @param {OpenSeadragon.EventHandler} [options.onClick=null] Event handler callback for {@link OpenSeadragon.Button.event:click}.
 * @param {OpenSeadragon.EventHandler} [options.onEnter=null] Event handler callback for {@link OpenSeadragon.Button.event:enter}.
 * @param {OpenSeadragon.EventHandler} [options.onExit=null] Event handler callback for {@link OpenSeadragon.Button.event:exit}.
 * @param {OpenSeadragon.EventHandler} [options.onFocus=null] Event handler callback for {@link OpenSeadragon.Button.event:focus}.
 * @param {OpenSeadragon.EventHandler} [options.onBlur=null] Event handler callback for {@link OpenSeadragon.Button.event:blur}.
 */$.Button=function(options){var _this=this;$.EventSource.call(this);$.extend(true,this,{tooltip:null,srcRest:null,srcGroup:null,srcHover:null,srcDown:null,clickTimeThreshold:$.DEFAULT_SETTINGS.clickTimeThreshold,clickDistThreshold:$.DEFAULT_SETTINGS.clickDistThreshold,/**
         * How long to wait before fading.
         * @member {Number} fadeDelay
         * @memberof OpenSeadragon.Button#
         */fadeDelay:0,/**
         * How long should it take to fade the button.
         * @member {Number} fadeLength
         * @memberof OpenSeadragon.Button#
         */fadeLength:2000,onPress:null,onRelease:null,onClick:null,onEnter:null,onExit:null,onFocus:null,onBlur:null},options);/**
     * The button element.
     * @member {Element} element
     * @memberof OpenSeadragon.Button#
     */this.element=options.element||$.makeNeutralElement("div");//if the user has specified the element to bind the control to explicitly
//then do not add the default control images
if(!options.element){this.imgRest=$.makeTransparentImage(this.srcRest);this.imgGroup=$.makeTransparentImage(this.srcGroup);this.imgHover=$.makeTransparentImage(this.srcHover);this.imgDown=$.makeTransparentImage(this.srcDown);this.imgRest.alt=this.imgGroup.alt=this.imgHover.alt=this.imgDown.alt=this.tooltip;this.element.style.position="relative";$.setElementTouchActionNone(this.element);this.imgGroup.style.position=this.imgHover.style.position=this.imgDown.style.position="absolute";this.imgGroup.style.top=this.imgHover.style.top=this.imgDown.style.top="0px";this.imgGroup.style.left=this.imgHover.style.left=this.imgDown.style.left="0px";this.imgHover.style.visibility=this.imgDown.style.visibility="hidden";if($.Browser.vendor==$.BROWSERS.FIREFOX&&$.Browser.version<3){this.imgGroup.style.top=this.imgHover.style.top=this.imgDown.style.top="";}this.element.appendChild(this.imgRest);this.element.appendChild(this.imgGroup);this.element.appendChild(this.imgHover);this.element.appendChild(this.imgDown);}this.addHandler("press",this.onPress);this.addHandler("release",this.onRelease);this.addHandler("click",this.onClick);this.addHandler("enter",this.onEnter);this.addHandler("exit",this.onExit);this.addHandler("focus",this.onFocus);this.addHandler("blur",this.onBlur);/**
     * The button's current state.
     * @member {OpenSeadragon.ButtonState} currentState
     * @memberof OpenSeadragon.Button#
     */this.currentState=$.ButtonState.GROUP;// When the button last began to fade.
this.fadeBeginTime=null;// Whether this button should fade after user stops interacting with the viewport.
this.shouldFade=false;this.element.style.display="inline-block";this.element.style.position="relative";this.element.title=this.tooltip;/**
     * Tracks mouse/touch/key events on the button.
     * @member {OpenSeadragon.MouseTracker} tracker
     * @memberof OpenSeadragon.Button#
     */this.tracker=new $.MouseTracker({element:this.element,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,enterHandler:function(event){if(event.insideElementPressed){inTo(_this,$.ButtonState.DOWN);/**
                 * Raised when the cursor enters the Button element.
                 *
                 * @event enter
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */_this.raiseEvent("enter",{originalEvent:event.originalEvent});}else if(!event.buttonDownAny){inTo(_this,$.ButtonState.HOVER);}},focusHandler:function(event){this.enterHandler(event);/**
             * Raised when the Button element receives focus.
             *
             * @event focus
             * @memberof OpenSeadragon.Button
             * @type {object}
             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
             * @property {Object} originalEvent - The original DOM event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */_this.raiseEvent("focus",{originalEvent:event.originalEvent});},exitHandler:function(event){outTo(_this,$.ButtonState.GROUP);if(event.insideElementPressed){/**
                 * Raised when the cursor leaves the Button element.
                 *
                 * @event exit
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */_this.raiseEvent("exit",{originalEvent:event.originalEvent});}},blurHandler:function(event){this.exitHandler(event);/**
             * Raised when the Button element loses focus.
             *
             * @event blur
             * @memberof OpenSeadragon.Button
             * @type {object}
             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
             * @property {Object} originalEvent - The original DOM event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */_this.raiseEvent("blur",{originalEvent:event.originalEvent});},pressHandler:function(event){inTo(_this,$.ButtonState.DOWN);/**
             * Raised when a mouse button is pressed or touch occurs in the Button element.
             *
             * @event press
             * @memberof OpenSeadragon.Button
             * @type {object}
             * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
             * @property {Object} originalEvent - The original DOM event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */_this.raiseEvent("press",{originalEvent:event.originalEvent});},releaseHandler:function(event){if(event.insideElementPressed&&event.insideElementReleased){outTo(_this,$.ButtonState.HOVER);/**
                 * Raised when the mouse button is released or touch ends in the Button element.
                 *
                 * @event release
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */_this.raiseEvent("release",{originalEvent:event.originalEvent});}else if(event.insideElementPressed){outTo(_this,$.ButtonState.GROUP);}else{inTo(_this,$.ButtonState.HOVER);}},clickHandler:function(event){if(event.quick){/**
                 * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
                 *
                 * @event click
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */_this.raiseEvent("click",{originalEvent:event.originalEvent});}},keyHandler:function(event){//console.log( "%s : handling key %s!", _this.tooltip, event.keyCode);
if(13===event.keyCode){/***
                 * Raised when a mouse button is pressed and released or touch is initiated and ended in the Button element within the time and distance threshold.
                 *
                 * @event click
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */_this.raiseEvent("click",{originalEvent:event.originalEvent});/***
                 * Raised when the mouse button is released or touch ends in the Button element.
                 *
                 * @event release
                 * @memberof OpenSeadragon.Button
                 * @type {object}
                 * @property {OpenSeadragon.Button} eventSource - A reference to the Button which raised the event.
                 * @property {Object} originalEvent - The original DOM event.
                 * @property {?Object} userData - Arbitrary subscriber-defined object.
                 */_this.raiseEvent("release",{originalEvent:event.originalEvent});return false;}return true;}});outTo(this,$.ButtonState.REST);};$.extend($.Button.prototype,$.EventSource.prototype,/** @lends OpenSeadragon.Button.prototype */{/**
     * TODO: Determine what this function is intended to do and if it's actually
     * useful as an API point.
     * @function
     */notifyGroupEnter:function(){inTo(this,$.ButtonState.GROUP);},/**
     * TODO: Determine what this function is intended to do and if it's actually
     * useful as an API point.
     * @function
     */notifyGroupExit:function(){outTo(this,$.ButtonState.REST);},/**
     * @function
     */disable:function(){this.notifyGroupExit();this.element.disabled=true;$.setElementOpacity(this.element,0.2,true);},/**
     * @function
     */enable:function(){this.element.disabled=false;$.setElementOpacity(this.element,1.0,true);this.notifyGroupEnter();}});function scheduleFade(button){$.requestAnimationFrame(function(){updateFade(button);});}function updateFade(button){var currentTime,deltaTime,opacity;if(button.shouldFade){currentTime=$.now();deltaTime=currentTime-button.fadeBeginTime;opacity=1.0-deltaTime/button.fadeLength;opacity=Math.min(1.0,opacity);opacity=Math.max(0.0,opacity);if(button.imgGroup){$.setElementOpacity(button.imgGroup,opacity,true);}if(opacity>0){// fade again
scheduleFade(button);}}}function beginFading(button){button.shouldFade=true;button.fadeBeginTime=$.now()+button.fadeDelay;window.setTimeout(function(){scheduleFade(button);},button.fadeDelay);}function stopFading(button){button.shouldFade=false;if(button.imgGroup){$.setElementOpacity(button.imgGroup,1.0,true);}}function inTo(button,newState){if(button.element.disabled){return;}if(newState>=$.ButtonState.GROUP&&button.currentState==$.ButtonState.REST){stopFading(button);button.currentState=$.ButtonState.GROUP;}if(newState>=$.ButtonState.HOVER&&button.currentState==$.ButtonState.GROUP){if(button.imgHover){button.imgHover.style.visibility="";}button.currentState=$.ButtonState.HOVER;}if(newState>=$.ButtonState.DOWN&&button.currentState==$.ButtonState.HOVER){if(button.imgDown){button.imgDown.style.visibility="";}button.currentState=$.ButtonState.DOWN;}}function outTo(button,newState){if(button.element.disabled){return;}if(newState<=$.ButtonState.HOVER&&button.currentState==$.ButtonState.DOWN){if(button.imgDown){button.imgDown.style.visibility="hidden";}button.currentState=$.ButtonState.HOVER;}if(newState<=$.ButtonState.GROUP&&button.currentState==$.ButtonState.HOVER){if(button.imgHover){button.imgHover.style.visibility="hidden";}button.currentState=$.ButtonState.GROUP;}if(newState<=$.ButtonState.REST&&button.currentState==$.ButtonState.GROUP){beginFading(button);button.currentState=$.ButtonState.REST;}}})(OpenSeadragon);/*
 * OpenSeadragon - ButtonGroup
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class ButtonGroup
 * @classdesc Manages events on groups of buttons.
 *
 * @memberof OpenSeadragon
 * @param {Object} options - A dictionary of settings applied against the entire group of buttons.
 * @param {Array} options.buttons Array of buttons
 * @param {Element} [options.element] Element to use as the container
 **/$.ButtonGroup=function(options){$.extend(true,this,{/**
         * An array containing the buttons themselves.
         * @member {Array} buttons
         * @memberof OpenSeadragon.ButtonGroup#
         */buttons:[],clickTimeThreshold:$.DEFAULT_SETTINGS.clickTimeThreshold,clickDistThreshold:$.DEFAULT_SETTINGS.clickDistThreshold,labelText:""},options);// copy the button elements  TODO: Why?
var buttons=this.buttons.concat([]),_this=this,i;/**
     * The shared container for the buttons.
     * @member {Element} element
     * @memberof OpenSeadragon.ButtonGroup#
     */this.element=options.element||$.makeNeutralElement("div");// TODO What if there IS an options.group specified?
if(!options.group){this.element.style.display="inline-block";//this.label   = $.makeNeutralElement( "label" );
//TODO: support labels for ButtonGroups
//this.label.innerHTML = this.labelText;
//this.element.appendChild( this.label );
for(i=0;i<buttons.length;i++){this.element.appendChild(buttons[i].element);}}$.setElementTouchActionNone(this.element);/**
     * Tracks mouse/touch/key events across the group of buttons.
     * @member {OpenSeadragon.MouseTracker} tracker
     * @memberof OpenSeadragon.ButtonGroup#
     */this.tracker=new $.MouseTracker({element:this.element,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,enterHandler:function(event){var i;for(i=0;i<_this.buttons.length;i++){_this.buttons[i].notifyGroupEnter();}},exitHandler:function(event){var i;if(!event.insideElementPressed){for(i=0;i<_this.buttons.length;i++){_this.buttons[i].notifyGroupExit();}}}});};/** @lends OpenSeadragon.ButtonGroup.prototype */$.ButtonGroup.prototype={/**
     * TODO: Figure out why this is used on the public API and if a more useful
     * api can be created.
     * @function
     * @private
     */emulateEnter:function(){this.tracker.enterHandler({eventSource:this.tracker});},/**
     * TODO: Figure out why this is used on the public API and if a more useful
     * api can be created.
     * @function
     * @private
     */emulateExit:function(){this.tracker.exitHandler({eventSource:this.tracker});}};})(OpenSeadragon);/*
 * OpenSeadragon - Rect
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class Rect
 * @classdesc A Rectangle is described by it top left coordinates (x, y), width,
 * height and degrees of rotation around (x, y).
 * Note that the coordinate system used is the one commonly used with images:
 * x increases when going to the right
 * y increases when going to the bottom
 * degrees increases clockwise with 0 being the horizontal
 *
 * The constructor normalizes the rectangle to always have 0 <= degrees < 90
 *
 * @memberof OpenSeadragon
 * @param {Number} [x=0] The vector component 'x'.
 * @param {Number} [y=0] The vector component 'y'.
 * @param {Number} [width=0] The vector component 'width'.
 * @param {Number} [height=0] The vector component 'height'.
 * @param {Number} [degrees=0] Rotation of the rectangle around (x,y) in degrees.
 */$.Rect=function(x,y,width,height,degrees){/**
     * The vector component 'x'.
     * @member {Number} x
     * @memberof OpenSeadragon.Rect#
     */this.x=typeof x==="number"?x:0;/**
     * The vector component 'y'.
     * @member {Number} y
     * @memberof OpenSeadragon.Rect#
     */this.y=typeof y==="number"?y:0;/**
     * The vector component 'width'.
     * @member {Number} width
     * @memberof OpenSeadragon.Rect#
     */this.width=typeof width==="number"?width:0;/**
     * The vector component 'height'.
     * @member {Number} height
     * @memberof OpenSeadragon.Rect#
     */this.height=typeof height==="number"?height:0;/**
     * The rotation of the rectangle, in degrees.
     * @member {Number} degrees
     * @memberof OpenSeadragon.Rect#
     */this.degrees=typeof degrees==="number"?degrees:0;// Normalizes the rectangle.
this.degrees=$.positiveModulo(this.degrees,360);var newTopLeft,newWidth;if(this.degrees>=270){newTopLeft=this.getTopRight();this.x=newTopLeft.x;this.y=newTopLeft.y;newWidth=this.height;this.height=this.width;this.width=newWidth;this.degrees-=270;}else if(this.degrees>=180){newTopLeft=this.getBottomRight();this.x=newTopLeft.x;this.y=newTopLeft.y;this.degrees-=180;}else if(this.degrees>=90){newTopLeft=this.getBottomLeft();this.x=newTopLeft.x;this.y=newTopLeft.y;newWidth=this.height;this.height=this.width;this.width=newWidth;this.degrees-=90;}};/**
 * Builds a rectangle having the 3 specified points as summits.
 * @static
 * @memberof OpenSeadragon.Rect
 * @param {OpenSeadragon.Point} topLeft
 * @param {OpenSeadragon.Point} topRight
 * @param {OpenSeadragon.Point} bottomLeft
 * @returns {OpenSeadragon.Rect}
 */$.Rect.fromSummits=function(topLeft,topRight,bottomLeft){var width=topLeft.distanceTo(topRight);var height=topLeft.distanceTo(bottomLeft);var diff=topRight.minus(topLeft);var radians=Math.atan(diff.y/diff.x);if(diff.x<0){radians+=Math.PI;}else if(diff.y<0){radians+=2*Math.PI;}return new $.Rect(topLeft.x,topLeft.y,width,height,radians/Math.PI*180);};/** @lends OpenSeadragon.Rect.prototype */$.Rect.prototype={/**
     * @function
     * @returns {OpenSeadragon.Rect} a duplicate of this Rect
     */clone:function(){return new $.Rect(this.x,this.y,this.width,this.height,this.degrees);},/**
     * The aspect ratio is simply the ratio of width to height.
     * @function
     * @returns {Number} The ratio of width to height.
     */getAspectRatio:function(){return this.width/this.height;},/**
     * Provides the coordinates of the upper-left corner of the rectangle as a
     * point.
     * @function
     * @returns {OpenSeadragon.Point} The coordinate of the upper-left corner of
     *  the rectangle.
     */getTopLeft:function(){return new $.Point(this.x,this.y);},/**
     * Provides the coordinates of the bottom-right corner of the rectangle as a
     * point.
     * @function
     * @returns {OpenSeadragon.Point} The coordinate of the bottom-right corner of
     *  the rectangle.
     */getBottomRight:function(){return new $.Point(this.x+this.width,this.y+this.height).rotate(this.degrees,this.getTopLeft());},/**
     * Provides the coordinates of the top-right corner of the rectangle as a
     * point.
     * @function
     * @returns {OpenSeadragon.Point} The coordinate of the top-right corner of
     *  the rectangle.
     */getTopRight:function(){return new $.Point(this.x+this.width,this.y).rotate(this.degrees,this.getTopLeft());},/**
     * Provides the coordinates of the bottom-left corner of the rectangle as a
     * point.
     * @function
     * @returns {OpenSeadragon.Point} The coordinate of the bottom-left corner of
     *  the rectangle.
     */getBottomLeft:function(){return new $.Point(this.x,this.y+this.height).rotate(this.degrees,this.getTopLeft());},/**
     * Computes the center of the rectangle.
     * @function
     * @returns {OpenSeadragon.Point} The center of the rectangle as represented
     *  as represented by a 2-dimensional vector (x,y)
     */getCenter:function(){return new $.Point(this.x+this.width/2.0,this.y+this.height/2.0).rotate(this.degrees,this.getTopLeft());},/**
     * Returns the width and height component as a vector OpenSeadragon.Point
     * @function
     * @returns {OpenSeadragon.Point} The 2 dimensional vector representing the
     *  the width and height of the rectangle.
     */getSize:function(){return new $.Point(this.width,this.height);},/**
     * Determines if two Rectangles have equivalent components.
     * @function
     * @param {OpenSeadragon.Rect} rectangle The Rectangle to compare to.
     * @return {Boolean} 'true' if all components are equal, otherwise 'false'.
     */equals:function(other){return other instanceof $.Rect&&this.x===other.x&&this.y===other.y&&this.width===other.width&&this.height===other.height&&this.degrees===other.degrees;},/**
    * Multiply all dimensions (except degrees) in this Rect by a factor and
    * return a new Rect.
    * @function
    * @param {Number} factor The factor to multiply vector components.
    * @returns {OpenSeadragon.Rect} A new rect representing the multiplication
    *  of the vector components by the factor
    */times:function(factor){return new $.Rect(this.x*factor,this.y*factor,this.width*factor,this.height*factor,this.degrees);},/**
    * Translate/move this Rect by a vector and return new Rect.
    * @function
    * @param {OpenSeadragon.Point} delta The translation vector.
    * @returns {OpenSeadragon.Rect} A new rect with altered position
    */translate:function(delta){return new $.Rect(this.x+delta.x,this.y+delta.y,this.width,this.height,this.degrees);},/**
     * Returns the smallest rectangle that will contain this and the given
     * rectangle bounding boxes.
     * @param {OpenSeadragon.Rect} rect
     * @return {OpenSeadragon.Rect} The new rectangle.
     */union:function(rect){var thisBoundingBox=this.getBoundingBox();var otherBoundingBox=rect.getBoundingBox();var left=Math.min(thisBoundingBox.x,otherBoundingBox.x);var top=Math.min(thisBoundingBox.y,otherBoundingBox.y);var right=Math.max(thisBoundingBox.x+thisBoundingBox.width,otherBoundingBox.x+otherBoundingBox.width);var bottom=Math.max(thisBoundingBox.y+thisBoundingBox.height,otherBoundingBox.y+otherBoundingBox.height);return new $.Rect(left,top,right-left,bottom-top);},/**
     * Returns the bounding box of the intersection of this rectangle with the
     * given rectangle.
     * @param {OpenSeadragon.Rect} rect
     * @return {OpenSeadragon.Rect} the bounding box of the intersection
     * or null if the rectangles don't intersect.
     */intersection:function(rect){// Simplified version of Weiler Atherton clipping algorithm
// https://en.wikipedia.org/wiki/Weiler%E2%80%93Atherton_clipping_algorithm
// Because we just want the bounding box of the intersection,
// we can just compute the bounding box of:
// 1. all the summits of this which are inside rect
// 2. all the summits of rect which are inside this
// 3. all the intersections of rect and this
var EPSILON=0.0000000001;var intersectionPoints=[];var thisTopLeft=this.getTopLeft();if(rect.containsPoint(thisTopLeft,EPSILON)){intersectionPoints.push(thisTopLeft);}var thisTopRight=this.getTopRight();if(rect.containsPoint(thisTopRight,EPSILON)){intersectionPoints.push(thisTopRight);}var thisBottomLeft=this.getBottomLeft();if(rect.containsPoint(thisBottomLeft,EPSILON)){intersectionPoints.push(thisBottomLeft);}var thisBottomRight=this.getBottomRight();if(rect.containsPoint(thisBottomRight,EPSILON)){intersectionPoints.push(thisBottomRight);}var rectTopLeft=rect.getTopLeft();if(this.containsPoint(rectTopLeft,EPSILON)){intersectionPoints.push(rectTopLeft);}var rectTopRight=rect.getTopRight();if(this.containsPoint(rectTopRight,EPSILON)){intersectionPoints.push(rectTopRight);}var rectBottomLeft=rect.getBottomLeft();if(this.containsPoint(rectBottomLeft,EPSILON)){intersectionPoints.push(rectBottomLeft);}var rectBottomRight=rect.getBottomRight();if(this.containsPoint(rectBottomRight,EPSILON)){intersectionPoints.push(rectBottomRight);}var thisSegments=this._getSegments();var rectSegments=rect._getSegments();for(var i=0;i<thisSegments.length;i++){var thisSegment=thisSegments[i];for(var j=0;j<rectSegments.length;j++){var rectSegment=rectSegments[j];var intersect=getIntersection(thisSegment[0],thisSegment[1],rectSegment[0],rectSegment[1]);if(intersect){intersectionPoints.push(intersect);}}}// Get intersection point of segments [a,b] and [c,d]
function getIntersection(a,b,c,d){// http://stackoverflow.com/a/1968345/1440403
var abVector=b.minus(a);var cdVector=d.minus(c);var denom=-cdVector.x*abVector.y+abVector.x*cdVector.y;if(denom===0){return null;}var s=(abVector.x*(a.y-c.y)-abVector.y*(a.x-c.x))/denom;var t=(cdVector.x*(a.y-c.y)-cdVector.y*(a.x-c.x))/denom;if(-EPSILON<=s&&s<=1-EPSILON&&-EPSILON<=t&&t<=1-EPSILON){return new $.Point(a.x+t*abVector.x,a.y+t*abVector.y);}return null;}if(intersectionPoints.length===0){return null;}var minX=intersectionPoints[0].x;var maxX=intersectionPoints[0].x;var minY=intersectionPoints[0].y;var maxY=intersectionPoints[0].y;for(var k=1;k<intersectionPoints.length;k++){var point=intersectionPoints[k];if(point.x<minX){minX=point.x;}if(point.x>maxX){maxX=point.x;}if(point.y<minY){minY=point.y;}if(point.y>maxY){maxY=point.y;}}return new $.Rect(minX,minY,maxX-minX,maxY-minY);},// private
_getSegments:function(){var topLeft=this.getTopLeft();var topRight=this.getTopRight();var bottomLeft=this.getBottomLeft();var bottomRight=this.getBottomRight();return[[topLeft,topRight],[topRight,bottomRight],[bottomRight,bottomLeft],[bottomLeft,topLeft]];},/**
     * Rotates a rectangle around a point.
     * @function
     * @param {Number} degrees The angle in degrees to rotate.
     * @param {OpenSeadragon.Point} [pivot] The point about which to rotate.
     * Defaults to the center of the rectangle.
     * @return {OpenSeadragon.Rect}
     */rotate:function(degrees,pivot){degrees=$.positiveModulo(degrees,360);if(degrees===0){return this.clone();}pivot=pivot||this.getCenter();var newTopLeft=this.getTopLeft().rotate(degrees,pivot);var newTopRight=this.getTopRight().rotate(degrees,pivot);var diff=newTopRight.minus(newTopLeft);// Handle floating point error
diff=diff.apply(function(x){var EPSILON=1e-15;return Math.abs(x)<EPSILON?0:x;});var radians=Math.atan(diff.y/diff.x);if(diff.x<0){radians+=Math.PI;}else if(diff.y<0){radians+=2*Math.PI;}return new $.Rect(newTopLeft.x,newTopLeft.y,this.width,this.height,radians/Math.PI*180);},/**
     * Retrieves the smallest horizontal (degrees=0) rectangle which contains
     * this rectangle.
     * @returns {OpenSeadragon.Rect}
     */getBoundingBox:function(){if(this.degrees===0){return this.clone();}var topLeft=this.getTopLeft();var topRight=this.getTopRight();var bottomLeft=this.getBottomLeft();var bottomRight=this.getBottomRight();var minX=Math.min(topLeft.x,topRight.x,bottomLeft.x,bottomRight.x);var maxX=Math.max(topLeft.x,topRight.x,bottomLeft.x,bottomRight.x);var minY=Math.min(topLeft.y,topRight.y,bottomLeft.y,bottomRight.y);var maxY=Math.max(topLeft.y,topRight.y,bottomLeft.y,bottomRight.y);return new $.Rect(minX,minY,maxX-minX,maxY-minY);},/**
     * Retrieves the smallest horizontal (degrees=0) rectangle which contains
     * this rectangle and has integers x, y, width and height
     * @returns {OpenSeadragon.Rect}
     */getIntegerBoundingBox:function(){var boundingBox=this.getBoundingBox();var x=Math.floor(boundingBox.x);var y=Math.floor(boundingBox.y);var width=Math.ceil(boundingBox.width+boundingBox.x-x);var height=Math.ceil(boundingBox.height+boundingBox.y-y);return new $.Rect(x,y,width,height);},/**
     * Determines whether a point is inside this rectangle (edge included).
     * @function
     * @param {OpenSeadragon.Point} point
     * @param {Number} [epsilon=0] the margin of error allowed
     * @returns {Boolean} true if the point is inside this rectangle, false
     * otherwise.
     */containsPoint:function(point,epsilon){epsilon=epsilon||0;// See http://stackoverflow.com/a/2752754/1440403 for explanation
var topLeft=this.getTopLeft();var topRight=this.getTopRight();var bottomLeft=this.getBottomLeft();var topDiff=topRight.minus(topLeft);var leftDiff=bottomLeft.minus(topLeft);return(point.x-topLeft.x)*topDiff.x+(point.y-topLeft.y)*topDiff.y>=-epsilon&&(point.x-topRight.x)*topDiff.x+(point.y-topRight.y)*topDiff.y<=epsilon&&(point.x-topLeft.x)*leftDiff.x+(point.y-topLeft.y)*leftDiff.y>=-epsilon&&(point.x-bottomLeft.x)*leftDiff.x+(point.y-bottomLeft.y)*leftDiff.y<=epsilon;},/**
     * Provides a string representation of the rectangle which is useful for
     * debugging.
     * @function
     * @returns {String} A string representation of the rectangle.
     */toString:function(){return"["+Math.round(this.x*100)/100+", "+Math.round(this.y*100)/100+", "+Math.round(this.width*100)/100+"x"+Math.round(this.height*100)/100+", "+Math.round(this.degrees*100)/100+"deg"+"]";}};})(OpenSeadragon);/*
 * OpenSeadragon - ReferenceStrip
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){// dictionary from id to private properties
var THIS={};/**
 *  The CollectionDrawer is a reimplementation if the Drawer API that
 *  focuses on allowing a viewport to be redefined as a collection
 *  of smaller viewports, defined by a clear number of rows and / or
 *  columns of which each item in the matrix of viewports has its own
 *  source.
 *
 *  This idea is a reexpression of the idea of dzi collections
 *  which allows a clearer algorithm to reuse the tile sources already
 *  supported by OpenSeadragon, in heterogenious or homogenious
 *  sequences just like mixed groups already supported by the viewer
 *  for the purpose of image sequnces.
 *
 *  TODO:   The difficult part of this feature is figuring out how to express
 *          this functionality as a combination of the functionality already
 *          provided by Drawer, Viewport, TileSource, and Navigator.  It may
 *          require better abstraction at those points in order to efficiently
 *          reuse those paradigms.
 *//**
 * @class ReferenceStrip
 * @memberof OpenSeadragon
 * @param {Object} options
 */$.ReferenceStrip=function(options){var _this=this,viewer=options.viewer,viewerSize=$.getElementSize(viewer.element),element,style,i;//We may need to create a new element and id if they did not
//provide the id for the existing element
if(!options.id){options.id='referencestrip-'+$.now();this.element=$.makeNeutralElement("div");this.element.id=options.id;this.element.className='referencestrip';}options=$.extend(true,{sizeRatio:$.DEFAULT_SETTINGS.referenceStripSizeRatio,position:$.DEFAULT_SETTINGS.referenceStripPosition,scroll:$.DEFAULT_SETTINGS.referenceStripScroll,clickTimeThreshold:$.DEFAULT_SETTINGS.clickTimeThreshold},options,{//required overrides
element:this.element,//These need to be overridden to prevent recursion since
//the navigator is a viewer and a viewer has a navigator
showNavigator:false,mouseNavEnabled:false,showNavigationControl:false,showSequenceControl:false});$.extend(this,options);//Private state properties
THIS[this.id]={"animating":false};this.minPixelRatio=this.viewer.minPixelRatio;style=this.element.style;style.marginTop='0px';style.marginRight='0px';style.marginBottom='0px';style.marginLeft='0px';style.left='0px';style.bottom='0px';style.border='0px';style.background='#000';style.position='relative';$.setElementTouchActionNone(this.element);$.setElementOpacity(this.element,0.8);this.viewer=viewer;this.innerTracker=new $.MouseTracker({element:this.element,dragHandler:$.delegate(this,onStripDrag),scrollHandler:$.delegate(this,onStripScroll),enterHandler:$.delegate(this,onStripEnter),exitHandler:$.delegate(this,onStripExit),keyDownHandler:$.delegate(this,onKeyDown),keyHandler:$.delegate(this,onKeyPress)});//Controls the position and orientation of the reference strip and sets the
//appropriate width and height
if(options.width&&options.height){this.element.style.width=options.width+'px';this.element.style.height=options.height+'px';viewer.addControl(this.element,{anchor:$.ControlAnchor.BOTTOM_LEFT});}else{if("horizontal"==options.scroll){this.element.style.width=viewerSize.x*options.sizeRatio*viewer.tileSources.length+12*viewer.tileSources.length+'px';this.element.style.height=viewerSize.y*options.sizeRatio+'px';viewer.addControl(this.element,{anchor:$.ControlAnchor.BOTTOM_LEFT});}else{this.element.style.height=viewerSize.y*options.sizeRatio*viewer.tileSources.length+12*viewer.tileSources.length+'px';this.element.style.width=viewerSize.x*options.sizeRatio+'px';viewer.addControl(this.element,{anchor:$.ControlAnchor.TOP_LEFT});}}this.panelWidth=viewerSize.x*this.sizeRatio+8;this.panelHeight=viewerSize.y*this.sizeRatio+8;this.panels=[];this.miniViewers={};/*jshint loopfunc:true*/for(i=0;i<viewer.tileSources.length;i++){element=$.makeNeutralElement('div');element.id=this.element.id+"-"+i;element.style.width=_this.panelWidth+'px';element.style.height=_this.panelHeight+'px';element.style.display='inline';element.style.float='left';//Webkit
element.style.cssFloat='left';//Firefox
element.style.styleFloat='left';//IE
element.style.padding='2px';$.setElementTouchActionNone(element);element.innerTracker=new $.MouseTracker({element:element,clickTimeThreshold:this.clickTimeThreshold,clickDistThreshold:this.clickDistThreshold,pressHandler:function(event){event.eventSource.dragging=$.now();},releaseHandler:function(event){var tracker=event.eventSource,id=tracker.element.id,page=Number(id.split('-')[2]),now=$.now();if(event.insideElementPressed&&event.insideElementReleased&&tracker.dragging&&now-tracker.dragging<tracker.clickTimeThreshold){tracker.dragging=null;viewer.goToPage(page);}}});this.element.appendChild(element);element.activePanel=false;this.panels.push(element);}loadPanels(this,this.scroll=='vertical'?viewerSize.y:viewerSize.x,0);this.setFocus(0);};$.extend($.ReferenceStrip.prototype,$.EventSource.prototype,$.Viewer.prototype,/** @lends OpenSeadragon.ReferenceStrip.prototype */{/**
     * @function
     */setFocus:function(page){var element=this.element.querySelector('#'+this.element.id+'-'+page),viewerSize=$.getElementSize(this.viewer.canvas),scrollWidth=Number(this.element.style.width.replace('px','')),scrollHeight=Number(this.element.style.height.replace('px','')),offsetLeft=-Number(this.element.style.marginLeft.replace('px','')),offsetTop=-Number(this.element.style.marginTop.replace('px','')),offset;if(this.currentSelected!==element){if(this.currentSelected){this.currentSelected.style.background='#000';}this.currentSelected=element;this.currentSelected.style.background='#999';if('horizontal'==this.scroll){//right left
offset=Number(page)*(this.panelWidth+3);if(offset>offsetLeft+viewerSize.x-this.panelWidth){offset=Math.min(offset,scrollWidth-viewerSize.x);this.element.style.marginLeft=-offset+'px';loadPanels(this,viewerSize.x,-offset);}else if(offset<offsetLeft){offset=Math.max(0,offset-viewerSize.x/2);this.element.style.marginLeft=-offset+'px';loadPanels(this,viewerSize.x,-offset);}}else{offset=Number(page)*(this.panelHeight+3);if(offset>offsetTop+viewerSize.y-this.panelHeight){offset=Math.min(offset,scrollHeight-viewerSize.y);this.element.style.marginTop=-offset+'px';loadPanels(this,viewerSize.y,-offset);}else if(offset<offsetTop){offset=Math.max(0,offset-viewerSize.y/2);this.element.style.marginTop=-offset+'px';loadPanels(this,viewerSize.y,-offset);}}this.currentPage=page;onStripEnter.call(this,{eventSource:this.innerTracker});}},/**
     * @function
     */update:function(){if(THIS[this.id].animating){$.console.log('image reference strip update');return true;}return false;},// Overrides Viewer.destroy
destroy:function(){if(this.miniViewers){for(var key in this.miniViewers){this.miniViewers[key].destroy();}}if(this.element){this.element.parentNode.removeChild(this.element);}}});/**
 * @private
 * @inner
 * @function
 */function onStripDrag(event){var offsetLeft=Number(this.element.style.marginLeft.replace('px','')),offsetTop=Number(this.element.style.marginTop.replace('px','')),scrollWidth=Number(this.element.style.width.replace('px','')),scrollHeight=Number(this.element.style.height.replace('px','')),viewerSize=$.getElementSize(this.viewer.canvas);this.dragging=true;if(this.element){if('horizontal'==this.scroll){if(-event.delta.x>0){//forward
if(offsetLeft>-(scrollWidth-viewerSize.x)){this.element.style.marginLeft=offsetLeft+event.delta.x*2+'px';loadPanels(this,viewerSize.x,offsetLeft+event.delta.x*2);}}else if(-event.delta.x<0){//reverse
if(offsetLeft<0){this.element.style.marginLeft=offsetLeft+event.delta.x*2+'px';loadPanels(this,viewerSize.x,offsetLeft+event.delta.x*2);}}}else{if(-event.delta.y>0){//forward
if(offsetTop>-(scrollHeight-viewerSize.y)){this.element.style.marginTop=offsetTop+event.delta.y*2+'px';loadPanels(this,viewerSize.y,offsetTop+event.delta.y*2);}}else if(-event.delta.y<0){//reverse
if(offsetTop<0){this.element.style.marginTop=offsetTop+event.delta.y*2+'px';loadPanels(this,viewerSize.y,offsetTop+event.delta.y*2);}}}}return false;}/**
 * @private
 * @inner
 * @function
 */function onStripScroll(event){var offsetLeft=Number(this.element.style.marginLeft.replace('px','')),offsetTop=Number(this.element.style.marginTop.replace('px','')),scrollWidth=Number(this.element.style.width.replace('px','')),scrollHeight=Number(this.element.style.height.replace('px','')),viewerSize=$.getElementSize(this.viewer.canvas);if(this.element){if('horizontal'==this.scroll){if(event.scroll>0){//forward
if(offsetLeft>-(scrollWidth-viewerSize.x)){this.element.style.marginLeft=offsetLeft-event.scroll*60+'px';loadPanels(this,viewerSize.x,offsetLeft-event.scroll*60);}}else if(event.scroll<0){//reverse
if(offsetLeft<0){this.element.style.marginLeft=offsetLeft-event.scroll*60+'px';loadPanels(this,viewerSize.x,offsetLeft-event.scroll*60);}}}else{if(event.scroll<0){//scroll up
if(offsetTop>viewerSize.y-scrollHeight){this.element.style.marginTop=offsetTop+event.scroll*60+'px';loadPanels(this,viewerSize.y,offsetTop+event.scroll*60);}}else if(event.scroll>0){//scroll dowm
if(offsetTop<0){this.element.style.marginTop=offsetTop+event.scroll*60+'px';loadPanels(this,viewerSize.y,offsetTop+event.scroll*60);}}}}//cancels event
return false;}function loadPanels(strip,viewerSize,scroll){var panelSize,activePanelsStart,activePanelsEnd,miniViewer,style,i,element;if('horizontal'==strip.scroll){panelSize=strip.panelWidth;}else{panelSize=strip.panelHeight;}activePanelsStart=Math.ceil(viewerSize/panelSize)+5;activePanelsEnd=Math.ceil((Math.abs(scroll)+viewerSize)/panelSize)+1;activePanelsStart=activePanelsEnd-activePanelsStart;activePanelsStart=activePanelsStart<0?0:activePanelsStart;for(i=activePanelsStart;i<activePanelsEnd&&i<strip.panels.length;i++){element=strip.panels[i];if(!element.activePanel){var miniTileSource;var originalTileSource=strip.viewer.tileSources[i];if(originalTileSource.referenceStripThumbnailUrl){miniTileSource={type:'image',url:originalTileSource.referenceStripThumbnailUrl};}else{miniTileSource=originalTileSource;}miniViewer=new $.Viewer({id:element.id,tileSources:[miniTileSource],element:element,navigatorSizeRatio:strip.sizeRatio,showNavigator:false,mouseNavEnabled:false,showNavigationControl:false,showSequenceControl:false,immediateRender:true,blendTime:0,animationTime:0,loadTilesWithAjax:strip.viewer.loadTilesWithAjax,ajaxHeaders:strip.viewer.ajaxHeaders,useCanvas:strip.useCanvas});miniViewer.displayRegion=$.makeNeutralElement("div");miniViewer.displayRegion.id=element.id+'-displayregion';miniViewer.displayRegion.className='displayregion';style=miniViewer.displayRegion.style;style.position='relative';style.top='0px';style.left='0px';style.fontSize='0px';style.overflow='hidden';style.float='left';//Webkit
style.cssFloat='left';//Firefox
style.styleFloat='left';//IE
style.zIndex=999999999;style.cursor='default';style.width=strip.panelWidth-4+'px';style.height=strip.panelHeight-4+'px';// TODO: What is this for? Future keyboard navigation support?
miniViewer.displayRegion.innerTracker=new $.MouseTracker({element:miniViewer.displayRegion,startDisabled:true});element.getElementsByTagName('div')[0].appendChild(miniViewer.displayRegion);strip.miniViewers[element.id]=miniViewer;element.activePanel=true;}}}/**
 * @private
 * @inner
 * @function
 */function onStripEnter(event){var element=event.eventSource.element;//$.setElementOpacity(element, 0.8);
//element.style.border = '1px solid #555';
//element.style.background = '#000';
if('horizontal'==this.scroll){//element.style.paddingTop = "0px";
element.style.marginBottom="0px";}else{//element.style.paddingRight = "0px";
element.style.marginLeft="0px";}return false;}/**
 * @private
 * @inner
 * @function
 */function onStripExit(event){var element=event.eventSource.element;if('horizontal'==this.scroll){//element.style.paddingTop = "10px";
element.style.marginBottom="-"+$.getElementSize(element).y/2+"px";}else{//element.style.paddingRight = "10px";
element.style.marginLeft="-"+$.getElementSize(element).x/2+"px";}return false;}/**
 * @private
 * @inner
 * @function
 */function onKeyDown(event){//console.log( event.keyCode );
if(!event.preventDefaultAction&&!event.ctrl&&!event.alt&&!event.meta){switch(event.keyCode){case 38://up arrow
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:1,shift:null});return false;case 40://down arrow
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:-1,shift:null});return false;case 37://left arrow
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:-1,shift:null});return false;case 39://right arrow
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:1,shift:null});return false;default://console.log( 'navigator keycode %s', event.keyCode );
return true;}}else{return true;}}/**
 * @private
 * @inner
 * @function
 */function onKeyPress(event){//console.log( event.keyCode );
if(!event.preventDefaultAction&&!event.ctrl&&!event.alt&&!event.meta){switch(event.keyCode){case 61://=|+
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:1,shift:null});return false;case 45://-|_
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:-1,shift:null});return false;case 48://0|)
case 119://w
case 87://W
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:1,shift:null});return false;case 115://s
case 83://S
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:-1,shift:null});return false;case 97://a
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:-1,shift:null});return false;case 100://d
onStripScroll.call(this,{eventSource:this.tracker,position:null,scroll:1,shift:null});return false;default://console.log( 'navigator keycode %s', event.keyCode );
return true;}}else{return true;}}})(OpenSeadragon);/*
 * OpenSeadragon - DisplayRect
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class DisplayRect
 * @classdesc A display rectangle is very similar to {@link OpenSeadragon.Rect} but adds two
 * fields, 'minLevel' and 'maxLevel' which denote the supported zoom levels
 * for this rectangle.
 *
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.Rect
 * @param {Number} x The vector component 'x'.
 * @param {Number} y The vector component 'y'.
 * @param {Number} width The vector component 'height'.
 * @param {Number} height The vector component 'width'.
 * @param {Number} minLevel The lowest zoom level supported.
 * @param {Number} maxLevel The highest zoom level supported.
 */$.DisplayRect=function(x,y,width,height,minLevel,maxLevel){$.Rect.apply(this,[x,y,width,height]);/**
     * The lowest zoom level supported.
     * @member {Number} minLevel
     * @memberof OpenSeadragon.DisplayRect#
     */this.minLevel=minLevel;/**
     * The highest zoom level supported.
     * @member {Number} maxLevel
     * @memberof OpenSeadragon.DisplayRect#
     */this.maxLevel=maxLevel;};$.extend($.DisplayRect.prototype,$.Rect.prototype);})(OpenSeadragon);/*
 * OpenSeadragon - Spring
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class Spring
 * @memberof OpenSeadragon
 * @param {Object} options - Spring configuration settings.
 * @param {Number} options.springStiffness - Spring stiffness. Must be greater than zero.
 * The closer to zero, the closer to linear animation.
 * @param {Number} options.animationTime - Animation duration per spring, in seconds.
 * Must be zero or greater.
 * @param {Number} [options.initial=0] - Initial value of spring.
 * @param {Boolean} [options.exponential=false] - Whether this spring represents
 * an exponential scale (such as zoom) and should be animated accordingly. Note that
 * exponential springs must have non-zero values.
 */$.Spring=function(options){var args=arguments;if(typeof options!='object'){//allows backward compatible use of ( initialValue, config ) as
//constructor parameters
options={initial:args.length&&typeof args[0]=="number"?args[0]:undefined,/**
             * Spring stiffness.
             * @member {Number} springStiffness
             * @memberof OpenSeadragon.Spring#
             */springStiffness:args.length>1?args[1].springStiffness:5.0,/**
             * Animation duration per spring.
             * @member {Number} animationTime
             * @memberof OpenSeadragon.Spring#
             */animationTime:args.length>1?args[1].animationTime:1.5};}$.console.assert(typeof options.springStiffness==="number"&&options.springStiffness!==0,"[OpenSeadragon.Spring] options.springStiffness must be a non-zero number");$.console.assert(typeof options.animationTime==="number"&&options.animationTime>=0,"[OpenSeadragon.Spring] options.animationTime must be a number greater than or equal to 0");if(options.exponential){this._exponential=true;delete options.exponential;}$.extend(true,this,options);/**
     * @member {Object} current
     * @memberof OpenSeadragon.Spring#
     * @property {Number} value
     * @property {Number} time
     */this.current={value:typeof this.initial=="number"?this.initial:this._exponential?0:1,time:$.now()// always work in milliseconds
};$.console.assert(!this._exponential||this.current.value!==0,"[OpenSeadragon.Spring] value must be non-zero for exponential springs");/**
     * @member {Object} start
     * @memberof OpenSeadragon.Spring#
     * @property {Number} value
     * @property {Number} time
     */this.start={value:this.current.value,time:this.current.time};/**
     * @member {Object} target
     * @memberof OpenSeadragon.Spring#
     * @property {Number} value
     * @property {Number} time
     */this.target={value:this.current.value,time:this.current.time};if(this._exponential){this.start._logValue=Math.log(this.start.value);this.target._logValue=Math.log(this.target.value);this.current._logValue=Math.log(this.current.value);}};/** @lends OpenSeadragon.Spring.prototype */$.Spring.prototype={/**
     * @function
     * @param {Number} target
     */resetTo:function(target){$.console.assert(!this._exponential||target!==0,"[OpenSeadragon.Spring.resetTo] target must be non-zero for exponential springs");this.start.value=this.target.value=this.current.value=target;this.start.time=this.target.time=this.current.time=$.now();if(this._exponential){this.start._logValue=Math.log(this.start.value);this.target._logValue=Math.log(this.target.value);this.current._logValue=Math.log(this.current.value);}},/**
     * @function
     * @param {Number} target
     */springTo:function(target){$.console.assert(!this._exponential||target!==0,"[OpenSeadragon.Spring.springTo] target must be non-zero for exponential springs");this.start.value=this.current.value;this.start.time=this.current.time;this.target.value=target;this.target.time=this.start.time+1000*this.animationTime;if(this._exponential){this.start._logValue=Math.log(this.start.value);this.target._logValue=Math.log(this.target.value);}},/**
     * @function
     * @param {Number} delta
     */shiftBy:function(delta){this.start.value+=delta;this.target.value+=delta;if(this._exponential){$.console.assert(this.target.value!==0&&this.start.value!==0,"[OpenSeadragon.Spring.shiftBy] spring value must be non-zero for exponential springs");this.start._logValue=Math.log(this.start.value);this.target._logValue=Math.log(this.target.value);}},setExponential:function(value){this._exponential=value;if(this._exponential){$.console.assert(this.current.value!==0&&this.target.value!==0&&this.start.value!==0,"[OpenSeadragon.Spring.setExponential] spring value must be non-zero for exponential springs");this.start._logValue=Math.log(this.start.value);this.target._logValue=Math.log(this.target.value);this.current._logValue=Math.log(this.current.value);}},/**
     * @function
     * @returns true if the value got updated, false otherwise
     */update:function(){this.current.time=$.now();var startValue,targetValue;if(this._exponential){startValue=this.start._logValue;targetValue=this.target._logValue;}else{startValue=this.start.value;targetValue=this.target.value;}var currentValue=this.current.time>=this.target.time?targetValue:startValue+(targetValue-startValue)*transform(this.springStiffness,(this.current.time-this.start.time)/(this.target.time-this.start.time));var oldValue=this.current.value;if(this._exponential){this.current.value=Math.exp(currentValue);}else{this.current.value=currentValue;}return oldValue!=this.current.value;},/**
     * Returns whether the spring is at the target value
     * @function
     * @returns {Boolean} True if at target value, false otherwise
     */isAtTargetValue:function(){return this.current.value===this.target.value;}};/**
 * @private
 */function transform(stiffness,x){return(1.0-Math.exp(stiffness*-x))/(1.0-Math.exp(-stiffness));}})(OpenSeadragon);/*
 * OpenSeadragon - ImageLoader
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors

 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @private
 * @class ImageJob
 * @classdesc Handles downloading of a single image.
 * @param {Object} options - Options for this ImageJob.
 * @param {String} [options.src] - URL of image to download.
 * @param {String} [options.loadWithAjax] - Whether to load this image with AJAX.
 * @param {String} [options.ajaxHeaders] - Headers to add to the image request if using AJAX.
 * @param {String} [options.crossOriginPolicy] - CORS policy to use for downloads
 * @param {Function} [options.callback] - Called once image has been downloaded.
 * @param {Function} [options.abort] - Called when this image job is aborted.
 * @param {Number} [options.timeout] - The max number of milliseconds that this image job may take to complete.
 */function ImageJob(options){$.extend(true,this,{timeout:$.DEFAULT_SETTINGS.timeout,jobId:null},options);/**
     * Image object which will contain downloaded image.
     * @member {Image} image
     * @memberof OpenSeadragon.ImageJob#
     */this.image=null;}ImageJob.prototype={errorMsg:null,/**
     * Starts the image job.
     * @method
     */start:function(){var self=this;var selfAbort=this.abort;this.image=new Image();this.image.onload=function(){self.finish(true);};this.image.onabort=this.image.onerror=function(){self.errorMsg="Image load aborted";self.finish(false);};this.jobId=window.setTimeout(function(){self.errorMsg="Image load exceeded timeout ("+self.timeout+" ms)";self.finish(false);},this.timeout);// Load the tile with an AJAX request if the loadWithAjax option is
// set. Otherwise load the image by setting the source proprety of the image object.
if(this.loadWithAjax){this.request=$.makeAjaxRequest({url:this.src,withCredentials:this.ajaxWithCredentials,headers:this.ajaxHeaders,responseType:"arraybuffer",success:function(request){var blb;// Make the raw data into a blob.
// BlobBuilder fallback adapted from
// http://stackoverflow.com/questions/15293694/blob-constructor-browser-compatibility
try{blb=new window.Blob([request.response]);}catch(e){var BlobBuilder=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder;if(e.name==='TypeError'&&BlobBuilder){var bb=new BlobBuilder();bb.append(request.response);blb=bb.getBlob();}}// If the blob is empty for some reason consider the image load a failure.
if(blb.size===0){self.errorMsg="Empty image response.";self.finish(false);}// Create a URL for the blob data and make it the source of the image object.
// This will still trigger Image.onload to indicate a successful tile load.
var url=(window.URL||window.webkitURL).createObjectURL(blb);self.image.src=url;},error:function(request){self.errorMsg="Image load aborted - XHR error";self.finish(false);}});// Provide a function to properly abort the request.
this.abort=function(){self.request.abort();// Call the existing abort function if available
if(typeof selfAbort==="function"){selfAbort();}};}else{if(this.crossOriginPolicy!==false){this.image.crossOrigin=this.crossOriginPolicy;}this.image.src=this.src;}},finish:function(successful){this.image.onload=this.image.onerror=this.image.onabort=null;if(!successful){this.image=null;}if(this.jobId){window.clearTimeout(this.jobId);}this.callback(this);}};/**
 * @class ImageLoader
 * @memberof OpenSeadragon
 * @classdesc Handles downloading of a set of images using asynchronous queue pattern.
 * You generally won't have to interact with the ImageLoader directly.
 * @param {Object} options - Options for this ImageLoader.
 * @param {Number} [options.jobLimit] - The number of concurrent image requests. See imageLoaderLimit in {@link OpenSeadragon.Options} for details.
 * @param {Number} [options.timeout] - The max number of milliseconds that an image job may take to complete.
 */$.ImageLoader=function(options){$.extend(true,this,{jobLimit:$.DEFAULT_SETTINGS.imageLoaderLimit,timeout:$.DEFAULT_SETTINGS.timeout,jobQueue:[],jobsInProgress:0},options);};/** @lends OpenSeadragon.ImageLoader.prototype */$.ImageLoader.prototype={/**
     * Add an unloaded image to the loader queue.
     * @method
     * @param {Object} options - Options for this job.
     * @param {String} [options.src] - URL of image to download.
     * @param {String} [options.loadWithAjax] - Whether to load this image with AJAX.
     * @param {String} [options.ajaxHeaders] - Headers to add to the image request if using AJAX.
     * @param {String|Boolean} [options.crossOriginPolicy] - CORS policy to use for downloads
     * @param {Boolean} [options.ajaxWithCredentials] - Whether to set withCredentials on AJAX
     * requests.
     * @param {Function} [options.callback] - Called once image has been downloaded.
     * @param {Function} [options.abort] - Called when this image job is aborted.
     */addJob:function(options){var _this=this,complete=function(job){completeJob(_this,job,options.callback);},jobOptions={src:options.src,loadWithAjax:options.loadWithAjax,ajaxHeaders:options.loadWithAjax?options.ajaxHeaders:null,crossOriginPolicy:options.crossOriginPolicy,ajaxWithCredentials:options.ajaxWithCredentials,callback:complete,abort:options.abort,timeout:this.timeout},newJob=new ImageJob(jobOptions);if(!this.jobLimit||this.jobsInProgress<this.jobLimit){newJob.start();this.jobsInProgress++;}else{this.jobQueue.push(newJob);}},/**
     * Clear any unstarted image loading jobs from the queue.
     * @method
     */clear:function(){for(var i=0;i<this.jobQueue.length;i++){var job=this.jobQueue[i];if(typeof job.abort==="function"){job.abort();}}this.jobQueue=[];}};/**
 * Cleans up ImageJob once completed.
 * @method
 * @private
 * @param loader - ImageLoader used to start job.
 * @param job - The ImageJob that has completed.
 * @param callback - Called once cleanup is finished.
 */function completeJob(loader,job,callback){var nextJob;loader.jobsInProgress--;if((!loader.jobLimit||loader.jobsInProgress<loader.jobLimit)&&loader.jobQueue.length>0){nextJob=loader.jobQueue.shift();nextJob.start();loader.jobsInProgress++;}callback(job.image,job.errorMsg,job.request);}})(OpenSeadragon);/*
 * OpenSeadragon - Tile
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class Tile
 * @memberof OpenSeadragon
 * @param {Number} level The zoom level this tile belongs to.
 * @param {Number} x The vector component 'x'.
 * @param {Number} y The vector component 'y'.
 * @param {OpenSeadragon.Rect} bounds Where this tile fits, in normalized
 *      coordinates.
 * @param {Boolean} exists Is this tile a part of a sparse image? ( Also has
 *      this tile failed to load? )
 * @param {String} url The URL of this tile's image.
 * @param {CanvasRenderingContext2D} context2D The context2D of this tile if it
 * is provided directly by the tile source.
 * @param {Boolean} loadWithAjax Whether this tile image should be loaded with an AJAX request .
 * @param {Object} ajaxHeaders The headers to send with this tile's AJAX request (if applicable).
 * @param {OpenSeadragon.Rect} sourceBounds The portion of the tile to use as the source of the
 * drawing operation, in pixels. Note that this only works when drawing with canvas; when drawing
 * with HTML the entire tile is always used.
 */$.Tile=function(level,x,y,bounds,exists,url,context2D,loadWithAjax,ajaxHeaders,sourceBounds){/**
     * The zoom level this tile belongs to.
     * @member {Number} level
     * @memberof OpenSeadragon.Tile#
     */this.level=level;/**
     * The vector component 'x'.
     * @member {Number} x
     * @memberof OpenSeadragon.Tile#
     */this.x=x;/**
     * The vector component 'y'.
     * @member {Number} y
     * @memberof OpenSeadragon.Tile#
     */this.y=y;/**
     * Where this tile fits, in normalized coordinates
     * @member {OpenSeadragon.Rect} bounds
     * @memberof OpenSeadragon.Tile#
     */this.bounds=bounds;/**
    * The portion of the tile to use as the source of the drawing operation, in pixels. Note that
    * this only works when drawing with canvas; when drawing with HTML the entire tile is always used.
    * @member {OpenSeadragon.Rect} sourceBounds
    * @memberof OpenSeadragon.Tile#
    */this.sourceBounds=sourceBounds;/**
     * Is this tile a part of a sparse image? Also has this tile failed to load?
     * @member {Boolean} exists
     * @memberof OpenSeadragon.Tile#
     */this.exists=exists;/**
     * The URL of this tile's image.
     * @member {String} url
     * @memberof OpenSeadragon.Tile#
     */this.url=url;/**
     * The context2D of this tile if it is provided directly by the tile source.
     * @member {CanvasRenderingContext2D} context2D
     * @memberOf OpenSeadragon.Tile#
     */this.context2D=context2D;/**
     * Whether to load this tile's image with an AJAX request.
     * @member {Boolean} loadWithAjax
     * @memberof OpenSeadragon.Tile#
     */this.loadWithAjax=loadWithAjax;/**
     * The headers to be used in requesting this tile's image.
     * Only used if loadWithAjax is set to true.
     * @member {Object} ajaxHeaders
     * @memberof OpenSeadragon.Tile#
     */this.ajaxHeaders=ajaxHeaders;/**
     * The unique cache key for this tile.
     * @member {String} cacheKey
     * @memberof OpenSeadragon.Tile#
     */if(this.ajaxHeaders){this.cacheKey=this.url+"+"+JSON.stringify(this.ajaxHeaders);}else{this.cacheKey=this.url;}/**
     * Is this tile loaded?
     * @member {Boolean} loaded
     * @memberof OpenSeadragon.Tile#
     */this.loaded=false;/**
     * Is this tile loading?
     * @member {Boolean} loading
     * @memberof OpenSeadragon.Tile#
     */this.loading=false;/**
     * The HTML div element for this tile
     * @member {Element} element
     * @memberof OpenSeadragon.Tile#
     */this.element=null;/**
     * The HTML img element for this tile.
     * @member {Element} imgElement
     * @memberof OpenSeadragon.Tile#
     */this.imgElement=null;/**
     * The Image object for this tile.
     * @member {Object} image
     * @memberof OpenSeadragon.Tile#
     */this.image=null;/**
     * The alias of this.element.style.
     * @member {String} style
     * @memberof OpenSeadragon.Tile#
     */this.style=null;/**
     * This tile's position on screen, in pixels.
     * @member {OpenSeadragon.Point} position
     * @memberof OpenSeadragon.Tile#
     */this.position=null;/**
     * This tile's size on screen, in pixels.
     * @member {OpenSeadragon.Point} size
     * @memberof OpenSeadragon.Tile#
     */this.size=null;/**
     * The start time of this tile's blending.
     * @member {Number} blendStart
     * @memberof OpenSeadragon.Tile#
     */this.blendStart=null;/**
     * The current opacity this tile should be.
     * @member {Number} opacity
     * @memberof OpenSeadragon.Tile#
     */this.opacity=null;/**
     * The squared distance of this tile to the viewport center.
     * Use for comparing tiles.
     * @private
     * @member {Number} squaredDistance
     * @memberof OpenSeadragon.Tile#
     */this.squaredDistance=null;/**
     * The visibility score of this tile.
     * @member {Number} visibility
     * @memberof OpenSeadragon.Tile#
     */this.visibility=null;/**
     * Whether this tile is currently being drawn.
     * @member {Boolean} beingDrawn
     * @memberof OpenSeadragon.Tile#
     */this.beingDrawn=false;/**
     * Timestamp the tile was last touched.
     * @member {Number} lastTouchTime
     * @memberof OpenSeadragon.Tile#
     */this.lastTouchTime=0;/**
     * Whether this tile is in the right-most column for its level.
     * @member {Boolean} isRightMost
     * @memberof OpenSeadragon.Tile#
     */this.isRightMost=false;/**
     * Whether this tile is in the bottom-most row for its level.
     * @member {Boolean} isBottomMost
     * @memberof OpenSeadragon.Tile#
     */this.isBottomMost=false;};/** @lends OpenSeadragon.Tile.prototype */$.Tile.prototype={/**
     * Provides a string representation of this tiles level and (x,y)
     * components.
     * @function
     * @returns {String}
     */toString:function(){return this.level+"/"+this.x+"_"+this.y;},// private
_hasTransparencyChannel:function(){return!!this.context2D||this.url.match('.png');},/**
     * Renders the tile in an html container.
     * @function
     * @param {Element} container
     */drawHTML:function(container){if(!this.cacheImageRecord){$.console.warn('[Tile.drawHTML] attempting to draw tile %s when it\'s not cached',this.toString());return;}if(!this.loaded){$.console.warn("Attempting to draw tile %s when it's not yet loaded.",this.toString());return;}//EXPERIMENTAL - trying to figure out how to scale the container
//               content during animation of the container size.
if(!this.element){this.element=$.makeNeutralElement("div");this.imgElement=this.cacheImageRecord.getImage().cloneNode();this.imgElement.style.msInterpolationMode="nearest-neighbor";this.imgElement.style.width="100%";this.imgElement.style.height="100%";this.style=this.element.style;this.style.position="absolute";}if(this.element.parentNode!=container){container.appendChild(this.element);}if(this.imgElement.parentNode!=this.element){this.element.appendChild(this.imgElement);}this.style.top=this.position.y+"px";this.style.left=this.position.x+"px";this.style.height=this.size.y+"px";this.style.width=this.size.x+"px";$.setElementOpacity(this.element,this.opacity);},/**
     * Renders the tile in a canvas-based context.
     * @function
     * @param {Canvas} context
     * @param {Function} drawingHandler - Method for firing the drawing event.
     * drawingHandler({context, tile, rendered})
     * where <code>rendered</code> is the context with the pre-drawn image.
     * @param {Number} [scale=1] - Apply a scale to position and size
     * @param {OpenSeadragon.Point} [translate] - A translation vector
     */drawCanvas:function(context,drawingHandler,scale,translate){var position=this.position.times($.pixelDensityRatio),size=this.size.times($.pixelDensityRatio),rendered;if(!this.context2D&&!this.cacheImageRecord){$.console.warn('[Tile.drawCanvas] attempting to draw tile %s when it\'s not cached',this.toString());return;}rendered=this.context2D||this.cacheImageRecord.getRenderedContext();if(!this.loaded||!rendered){$.console.warn("Attempting to draw tile %s when it's not yet loaded.",this.toString());return;}context.save();context.globalAlpha=this.opacity;if(typeof scale==='number'&&scale!==1){// draw tile at a different scale
position=position.times(scale);size=size.times(scale);}if(translate instanceof $.Point){// shift tile position slightly
position=position.plus(translate);}//if we are supposed to be rendering fully opaque rectangle,
//ie its done fading or fading is turned off, and if we are drawing
//an image with an alpha channel, then the only way
//to avoid seeing the tile underneath is to clear the rectangle
if(context.globalAlpha===1&&this._hasTransparencyChannel()){//clearing only the inside of the rectangle occupied
//by the png prevents edge flikering
context.clearRect(position.x,position.y,size.x,size.y);}// This gives the application a chance to make image manipulation
// changes as we are rendering the image
drawingHandler({context:context,tile:this,rendered:rendered});var sourceWidth,sourceHeight;if(this.sourceBounds){sourceWidth=Math.min(this.sourceBounds.width,rendered.canvas.width);sourceHeight=Math.min(this.sourceBounds.height,rendered.canvas.height);}else{sourceWidth=rendered.canvas.width;sourceHeight=rendered.canvas.height;}context.drawImage(rendered.canvas,0,0,sourceWidth,sourceHeight,position.x,position.y,size.x,size.y);context.restore();},/**
     * Get the ratio between current and original size.
     * @function
     * @return {Float}
     */getScaleForEdgeSmoothing:function(){var context;if(this.cacheImageRecord){context=this.cacheImageRecord.getRenderedContext();}else if(this.context2D){context=this.context2D;}else{$.console.warn('[Tile.drawCanvas] attempting to get tile scale %s when tile\'s not cached',this.toString());return 1;}return context.canvas.width/(this.size.x*$.pixelDensityRatio);},/**
     * Get a translation vector that when applied to the tile position produces integer coordinates.
     * Needed to avoid swimming and twitching.
     * @function
     * @param {Number} [scale=1] - Scale to be applied to position.
     * @return {OpenSeadragon.Point}
     */getTranslationForEdgeSmoothing:function(scale,canvasSize,sketchCanvasSize){// The translation vector must have positive values, otherwise the image goes a bit off
// the sketch canvas to the top and left and we must use negative coordinates to repaint it
// to the main canvas. In that case, some browsers throw:
// INDEX_SIZE_ERR: DOM Exception 1: Index or size was negative, or greater than the allowed value.
var x=Math.max(1,Math.ceil((sketchCanvasSize.x-canvasSize.x)/2));var y=Math.max(1,Math.ceil((sketchCanvasSize.y-canvasSize.y)/2));return new $.Point(x,y).minus(this.position.times($.pixelDensityRatio).times(scale||1).apply(function(x){return x%1;}));},/**
     * Removes tile from its container.
     * @function
     */unload:function(){if(this.imgElement&&this.imgElement.parentNode){this.imgElement.parentNode.removeChild(this.imgElement);}if(this.element&&this.element.parentNode){this.element.parentNode.removeChild(this.element);}this.element=null;this.imgElement=null;this.loaded=false;this.loading=false;}};})(OpenSeadragon);/*
 * OpenSeadragon - Overlay
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
     * An enumeration of positions that an overlay may be assigned relative to
     * the viewport.
     * It is identical to OpenSeadragon.Placement but is kept for backward
     * compatibility.
     * @member OverlayPlacement
     * @memberof OpenSeadragon
     * @see OpenSeadragon.Placement
     * @static
     * @readonly
     * @type {Object}
     * @property {Number} CENTER
     * @property {Number} TOP_LEFT
     * @property {Number} TOP
     * @property {Number} TOP_RIGHT
     * @property {Number} RIGHT
     * @property {Number} BOTTOM_RIGHT
     * @property {Number} BOTTOM
     * @property {Number} BOTTOM_LEFT
     * @property {Number} LEFT
     */$.OverlayPlacement=$.Placement;/**
     * An enumeration of possible ways to handle overlays rotation
     * @member OverlayRotationMode
     * @memberOf OpenSeadragon
     * @static
     * @readonly
     * @property {Number} NO_ROTATION The overlay ignore the viewport rotation.
     * @property {Number} EXACT The overlay use CSS 3 transforms to rotate with
     * the viewport. If the overlay contains text, it will get rotated as well.
     * @property {Number} BOUNDING_BOX The overlay adjusts for rotation by
     * taking the size of the bounding box of the rotated bounds.
     * Only valid for overlays with Rect location and scalable in both directions.
     */$.OverlayRotationMode=$.freezeObject({NO_ROTATION:1,EXACT:2,BOUNDING_BOX:3});/**
     * @class Overlay
     * @classdesc Provides a way to float an HTML element on top of the viewer element.
     *
     * @memberof OpenSeadragon
     * @param {Object} options
     * @param {Element} options.element
     * @param {OpenSeadragon.Point|OpenSeadragon.Rect} options.location - The
     * location of the overlay on the image. If a {@link OpenSeadragon.Point}
     * is specified, the overlay will be located at this location with respect
     * to the placement option. If a {@link OpenSeadragon.Rect} is specified,
     * the overlay will be placed at this location with the corresponding width
     * and height and placement TOP_LEFT.
     * @param {OpenSeadragon.Placement} [options.placement=OpenSeadragon.Placement.TOP_LEFT]
     * Defines what part of the overlay should be at the specified options.location
     * @param {OpenSeadragon.Overlay.OnDrawCallback} [options.onDraw]
     * @param {Boolean} [options.checkResize=true] Set to false to avoid to
     * check the size of the overlay every time it is drawn in the directions
     * which are not scaled. It will improve performances but will cause a
     * misalignment if the overlay size changes.
     * @param {Number} [options.width] The width of the overlay in viewport
     * coordinates. If specified, the width of the overlay will be adjusted when
     * the zoom changes.
     * @param {Number} [options.height] The height of the overlay in viewport
     * coordinates. If specified, the height of the overlay will be adjusted when
     * the zoom changes.
     * @param {Boolean} [options.rotationMode=OpenSeadragon.OverlayRotationMode.EXACT]
     * How to handle the rotation of the viewport.
     */$.Overlay=function(element,location,placement){/**
         * onDraw callback signature used by {@link OpenSeadragon.Overlay}.
         *
         * @callback OnDrawCallback
         * @memberof OpenSeadragon.Overlay
         * @param {OpenSeadragon.Point} position
         * @param {OpenSeadragon.Point} size
         * @param {Element} element
         */var options;if($.isPlainObject(element)){options=element;}else{options={element:element,location:location,placement:placement};}this.element=options.element;this.style=options.element.style;this._init(options);};/** @lends OpenSeadragon.Overlay.prototype */$.Overlay.prototype={// private
_init:function(options){this.location=options.location;this.placement=options.placement===undefined?$.Placement.TOP_LEFT:options.placement;this.onDraw=options.onDraw;this.checkResize=options.checkResize===undefined?true:options.checkResize;// When this.width is not null, the overlay get scaled horizontally
this.width=options.width===undefined?null:options.width;// When this.height is not null, the overlay get scaled vertically
this.height=options.height===undefined?null:options.height;this.rotationMode=options.rotationMode||$.OverlayRotationMode.EXACT;// Having a rect as location is a syntactic sugar
if(this.location instanceof $.Rect){this.width=this.location.width;this.height=this.location.height;this.location=this.location.getTopLeft();this.placement=$.Placement.TOP_LEFT;}// Deprecated properties kept for backward compatibility.
this.scales=this.width!==null&&this.height!==null;this.bounds=new $.Rect(this.location.x,this.location.y,this.width,this.height);this.position=this.location;},/**
         * Internal function to adjust the position of an overlay
         * depending on it size and placement.
         * @function
         * @param {OpenSeadragon.Point} position
         * @param {OpenSeadragon.Point} size
         */adjust:function(position,size){var properties=$.Placement.properties[this.placement];if(!properties){return;}if(properties.isHorizontallyCentered){position.x-=size.x/2;}else if(properties.isRight){position.x-=size.x;}if(properties.isVerticallyCentered){position.y-=size.y/2;}else if(properties.isBottom){position.y-=size.y;}},/**
         * @function
         */destroy:function(){var element=this.element;var style=this.style;if(element.parentNode){element.parentNode.removeChild(element);//this should allow us to preserve overlays when required between
//pages
if(element.prevElementParent){style.display='none';//element.prevElementParent.insertBefore(
//    element,
//    element.prevNextSibling
//);
document.body.appendChild(element);}}// clear the onDraw callback
this.onDraw=null;style.top="";style.left="";style.position="";if(this.width!==null){style.width="";}if(this.height!==null){style.height="";}var transformOriginProp=$.getCssPropertyWithVendorPrefix('transformOrigin');var transformProp=$.getCssPropertyWithVendorPrefix('transform');if(transformOriginProp&&transformProp){style[transformOriginProp]="";style[transformProp]="";}},/**
         * @function
         * @param {Element} container
         */drawHTML:function(container,viewport){var element=this.element;if(element.parentNode!==container){//save the source parent for later if we need it
element.prevElementParent=element.parentNode;element.prevNextSibling=element.nextSibling;container.appendChild(element);// have to set position before calculating size, fix #1116
this.style.position="absolute";// this.size is used by overlays which don't get scaled in at
// least one direction when this.checkResize is set to false.
this.size=$.getElementSize(element);}var positionAndSize=this._getOverlayPositionAndSize(viewport);var position=positionAndSize.position;var size=this.size=positionAndSize.size;var rotate=positionAndSize.rotate;// call the onDraw callback if it exists to allow one to overwrite
// the drawing/positioning/sizing of the overlay
if(this.onDraw){this.onDraw(position,size,this.element);}else{var style=this.style;style.left=position.x+"px";style.top=position.y+"px";if(this.width!==null){style.width=size.x+"px";}if(this.height!==null){style.height=size.y+"px";}var transformOriginProp=$.getCssPropertyWithVendorPrefix('transformOrigin');var transformProp=$.getCssPropertyWithVendorPrefix('transform');if(transformOriginProp&&transformProp){if(rotate){style[transformOriginProp]=this._getTransformOrigin();style[transformProp]="rotate("+rotate+"deg)";}else{style[transformOriginProp]="";style[transformProp]="";}}if(style.display!=='none'){style.display='block';}}},// private
_getOverlayPositionAndSize:function(viewport){var position=viewport.pixelFromPoint(this.location,true);var size=this._getSizeInPixels(viewport);this.adjust(position,size);var rotate=0;if(viewport.degrees&&this.rotationMode!==$.OverlayRotationMode.NO_ROTATION){// BOUNDING_BOX is only valid if both directions get scaled.
// Get replaced by EXACT otherwise.
if(this.rotationMode===$.OverlayRotationMode.BOUNDING_BOX&&this.width!==null&&this.height!==null){var rect=new $.Rect(position.x,position.y,size.x,size.y);var boundingBox=this._getBoundingBox(rect,viewport.degrees);position=boundingBox.getTopLeft();size=boundingBox.getSize();}else{rotate=viewport.degrees;}}return{position:position,size:size,rotate:rotate};},// private
_getSizeInPixels:function(viewport){var width=this.size.x;var height=this.size.y;if(this.width!==null||this.height!==null){var scaledSize=viewport.deltaPixelsFromPointsNoRotate(new $.Point(this.width||0,this.height||0),true);if(this.width!==null){width=scaledSize.x;}if(this.height!==null){height=scaledSize.y;}}if(this.checkResize&&(this.width===null||this.height===null)){var eltSize=this.size=$.getElementSize(this.element);if(this.width===null){width=eltSize.x;}if(this.height===null){height=eltSize.y;}}return new $.Point(width,height);},// private
_getBoundingBox:function(rect,degrees){var refPoint=this._getPlacementPoint(rect);return rect.rotate(degrees,refPoint).getBoundingBox();},// private
_getPlacementPoint:function(rect){var result=new $.Point(rect.x,rect.y);var properties=$.Placement.properties[this.placement];if(properties){if(properties.isHorizontallyCentered){result.x+=rect.width/2;}else if(properties.isRight){result.x+=rect.width;}if(properties.isVerticallyCentered){result.y+=rect.height/2;}else if(properties.isBottom){result.y+=rect.height;}}return result;},// private
_getTransformOrigin:function(){var result="";var properties=$.Placement.properties[this.placement];if(!properties){return result;}if(properties.isLeft){result="left";}else if(properties.isRight){result="right";}if(properties.isTop){result+=" top";}else if(properties.isBottom){result+=" bottom";}return result;},/**
         * Changes the overlay settings.
         * @function
         * @param {OpenSeadragon.Point|OpenSeadragon.Rect|Object} location
         * If an object is specified, the options are the same than the constructor
         * except for the element which can not be changed.
         * @param {OpenSeadragon.Placement} placement
         */update:function(location,placement){var options=$.isPlainObject(location)?location:{location:location,placement:placement};this._init({location:options.location||this.location,placement:options.placement!==undefined?options.placement:this.placement,onDraw:options.onDraw||this.onDraw,checkResize:options.checkResize||this.checkResize,width:options.width!==undefined?options.width:this.width,height:options.height!==undefined?options.height:this.height,rotationMode:options.rotationMode||this.rotationMode});},/**
         * Returns the current bounds of the overlay in viewport coordinates
         * @function
         * @param {OpenSeadragon.Viewport} viewport the viewport
         * @returns {OpenSeadragon.Rect} overlay bounds
         */getBounds:function(viewport){$.console.assert(viewport,'A viewport must now be passed to Overlay.getBounds.');var width=this.width;var height=this.height;if(width===null||height===null){var size=viewport.deltaPointsFromPixelsNoRotate(this.size,true);if(width===null){width=size.x;}if(height===null){height=size.y;}}var location=this.location.clone();this.adjust(location,new $.Point(width,height));return this._adjustBoundsForRotation(viewport,new $.Rect(location.x,location.y,width,height));},// private
_adjustBoundsForRotation:function(viewport,bounds){if(!viewport||viewport.degrees===0||this.rotationMode===$.OverlayRotationMode.EXACT){return bounds;}if(this.rotationMode===$.OverlayRotationMode.BOUNDING_BOX){// If overlay not fully scalable, BOUNDING_BOX falls back to EXACT
if(this.width===null||this.height===null){return bounds;}// It is easier to just compute the position and size and
// convert to viewport coordinates.
var positionAndSize=this._getOverlayPositionAndSize(viewport);return viewport.viewerElementToViewportRectangle(new $.Rect(positionAndSize.position.x,positionAndSize.position.y,positionAndSize.size.x,positionAndSize.size.y));}// NO_ROTATION case
return bounds.rotate(-viewport.degrees,this._getPlacementPoint(bounds));}};})(OpenSeadragon);/*
 * OpenSeadragon - Drawer
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class Drawer
 * @memberof OpenSeadragon
 * @classdesc Handles rendering of tiles for an {@link OpenSeadragon.Viewer}.
 * @param {Object} options - Options for this Drawer.
 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this Drawer.
 * @param {OpenSeadragon.Viewport} options.viewport - Reference to Viewer viewport.
 * @param {Element} options.element - Parent element.
 * @param {Number} [options.debugGridColor] - See debugGridColor in {@link OpenSeadragon.Options} for details.
 */$.Drawer=function(options){$.console.assert(options.viewer,"[Drawer] options.viewer is required");//backward compatibility for positional args while preferring more
//idiomatic javascript options object as the only argument
var args=arguments;if(!$.isPlainObject(options)){options={source:args[0],// Reference to Viewer tile source.
viewport:args[1],// Reference to Viewer viewport.
element:args[2]// Parent element.
};}$.console.assert(options.viewport,"[Drawer] options.viewport is required");$.console.assert(options.element,"[Drawer] options.element is required");if(options.source){$.console.error("[Drawer] options.source is no longer accepted; use TiledImage instead");}this.viewer=options.viewer;this.viewport=options.viewport;this.debugGridColor=typeof options.debugGridColor==='string'?[options.debugGridColor]:options.debugGridColor||$.DEFAULT_SETTINGS.debugGridColor;if(options.opacity){$.console.error("[Drawer] options.opacity is no longer accepted; set the opacity on the TiledImage instead");}this.useCanvas=$.supportsCanvas&&(this.viewer?this.viewer.useCanvas:true);/**
     * The parent element of this Drawer instance, passed in when the Drawer was created.
     * The parent of {@link OpenSeadragon.Drawer#canvas}.
     * @member {Element} container
     * @memberof OpenSeadragon.Drawer#
     */this.container=$.getElement(options.element);/**
     * A &lt;canvas&gt; element if the browser supports them, otherwise a &lt;div&gt; element.
     * Child element of {@link OpenSeadragon.Drawer#container}.
     * @member {Element} canvas
     * @memberof OpenSeadragon.Drawer#
     */this.canvas=$.makeNeutralElement(this.useCanvas?"canvas":"div");/**
     * 2d drawing context for {@link OpenSeadragon.Drawer#canvas} if it's a &lt;canvas&gt; element, otherwise null.
     * @member {Object} context
     * @memberof OpenSeadragon.Drawer#
     */this.context=this.useCanvas?this.canvas.getContext("2d"):null;/**
     * Sketch canvas used to temporarily draw tiles which cannot be drawn directly
     * to the main canvas due to opacity. Lazily initialized.
     */this.sketchCanvas=null;this.sketchContext=null;/**
     * @member {Element} element
     * @memberof OpenSeadragon.Drawer#
     * @deprecated Alias for {@link OpenSeadragon.Drawer#container}.
     */this.element=this.container;// We force our container to ltr because our drawing math doesn't work in rtl.
// This issue only affects our canvas renderer, but we do it always for consistency.
// Note that this means overlays you want to be rtl need to be explicitly set to rtl.
this.container.dir='ltr';// check canvas available width and height, set canvas width and height such that the canvas backing store is set to the proper pixel density
if(this.useCanvas){var viewportSize=this._calculateCanvasSize();this.canvas.width=viewportSize.x;this.canvas.height=viewportSize.y;}this.canvas.style.width="100%";this.canvas.style.height="100%";this.canvas.style.position="absolute";$.setElementOpacity(this.canvas,this.opacity,true);// explicit left-align
this.container.style.textAlign="left";this.container.appendChild(this.canvas);// Image smoothing for canvas rendering (only if canvas is used).
// Canvas default is "true", so this will only be changed if user specified "false".
this._imageSmoothingEnabled=true;};/** @lends OpenSeadragon.Drawer.prototype */$.Drawer.prototype={// deprecated
addOverlay:function(element,location,placement,onDraw){$.console.error("drawer.addOverlay is deprecated. Use viewer.addOverlay instead.");this.viewer.addOverlay(element,location,placement,onDraw);return this;},// deprecated
updateOverlay:function(element,location,placement){$.console.error("drawer.updateOverlay is deprecated. Use viewer.updateOverlay instead.");this.viewer.updateOverlay(element,location,placement);return this;},// deprecated
removeOverlay:function(element){$.console.error("drawer.removeOverlay is deprecated. Use viewer.removeOverlay instead.");this.viewer.removeOverlay(element);return this;},// deprecated
clearOverlays:function(){$.console.error("drawer.clearOverlays is deprecated. Use viewer.clearOverlays instead.");this.viewer.clearOverlays();return this;},/**
     * This function converts the given point from to the drawer coordinate by
     * multiplying it with the pixel density.
     * This function does not take rotation into account, thus assuming provided
     * point is at 0 degree.
     * @param {OpenSeadragon.Point} point - the pixel point to convert
     */viewportCoordToDrawerCoord:function(point){var vpPoint=this.viewport.pixelFromPointNoRotate(point,true);return new $.Point(vpPoint.x*$.pixelDensityRatio,vpPoint.y*$.pixelDensityRatio);},/**
     * This function will create multiple polygon paths on the drawing context by provided polygons,
     * then clip the context to the paths.
     * @param {(OpenSeadragon.Point[])[]} polygons - an array of polygons. A polygon is an array of OpenSeadragon.Point
     * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
     */clipWithPolygons:function(polygons,useSketch){if(!this.useCanvas){return;}var context=this._getContext(useSketch);context.beginPath();polygons.forEach(function(polygon){polygon.forEach(function(coord,i){context[i===0?'moveTo':'lineTo'](coord.x,coord.y);});});context.clip();},/**
     * Set the opacity of the drawer.
     * @param {Number} opacity
     * @return {OpenSeadragon.Drawer} Chainable.
     */setOpacity:function(opacity){$.console.error("drawer.setOpacity is deprecated. Use tiledImage.setOpacity instead.");var world=this.viewer.world;for(var i=0;i<world.getItemCount();i++){world.getItemAt(i).setOpacity(opacity);}return this;},/**
     * Get the opacity of the drawer.
     * @returns {Number}
     */getOpacity:function(){$.console.error("drawer.getOpacity is deprecated. Use tiledImage.getOpacity instead.");var world=this.viewer.world;var maxOpacity=0;for(var i=0;i<world.getItemCount();i++){var opacity=world.getItemAt(i).getOpacity();if(opacity>maxOpacity){maxOpacity=opacity;}}return maxOpacity;},// deprecated
needsUpdate:function(){$.console.error("[Drawer.needsUpdate] this function is deprecated. Use World.needsDraw instead.");return this.viewer.world.needsDraw();},// deprecated
numTilesLoaded:function(){$.console.error("[Drawer.numTilesLoaded] this function is deprecated. Use TileCache.numTilesLoaded instead.");return this.viewer.tileCache.numTilesLoaded();},// deprecated
reset:function(){$.console.error("[Drawer.reset] this function is deprecated. Use World.resetItems instead.");this.viewer.world.resetItems();return this;},// deprecated
update:function(){$.console.error("[Drawer.update] this function is deprecated. Use Drawer.clear and World.draw instead.");this.clear();this.viewer.world.draw();return this;},/**
     * @return {Boolean} True if rotation is supported.
     */canRotate:function(){return this.useCanvas;},/**
     * Destroy the drawer (unload current loaded tiles)
     */destroy:function(){//force unloading of current canvas (1x1 will be gc later, trick not necessarily needed)
this.canvas.width=1;this.canvas.height=1;this.sketchCanvas=null;this.sketchContext=null;},/**
     * Clears the Drawer so it's ready to draw another frame.
     */clear:function(){this.canvas.innerHTML="";if(this.useCanvas){var viewportSize=this._calculateCanvasSize();if(this.canvas.width!=viewportSize.x||this.canvas.height!=viewportSize.y){this.canvas.width=viewportSize.x;this.canvas.height=viewportSize.y;this._updateImageSmoothingEnabled(this.context);if(this.sketchCanvas!==null){var sketchCanvasSize=this._calculateSketchCanvasSize();this.sketchCanvas.width=sketchCanvasSize.x;this.sketchCanvas.height=sketchCanvasSize.y;this._updateImageSmoothingEnabled(this.sketchContext);}}this._clear();}},_clear:function(useSketch,bounds){if(!this.useCanvas){return;}var context=this._getContext(useSketch);if(bounds){context.clearRect(bounds.x,bounds.y,bounds.width,bounds.height);}else{var canvas=context.canvas;context.clearRect(0,0,canvas.width,canvas.height);}},/**
     * Scale from OpenSeadragon viewer rectangle to drawer rectangle
     * (ignoring rotation)
     * @param {OpenSeadragon.Rect} rectangle - The rectangle in viewport coordinate system.
     * @return {OpenSeadragon.Rect} Rectangle in drawer coordinate system.
     */viewportToDrawerRectangle:function(rectangle){var topLeft=this.viewport.pixelFromPointNoRotate(rectangle.getTopLeft(),true);var size=this.viewport.deltaPixelsFromPointsNoRotate(rectangle.getSize(),true);return new $.Rect(topLeft.x*$.pixelDensityRatio,topLeft.y*$.pixelDensityRatio,size.x*$.pixelDensityRatio,size.y*$.pixelDensityRatio);},/**
     * Draws the given tile.
     * @param {OpenSeadragon.Tile} tile - The tile to draw.
     * @param {Function} drawingHandler - Method for firing the drawing event if using canvas.
     * drawingHandler({context, tile, rendered})
     * @param {Boolean} useSketch - Whether to use the sketch canvas or not.
     * where <code>rendered</code> is the context with the pre-drawn image.
     * @param {Float} [scale=1] - Apply a scale to tile position and size. Defaults to 1.
     * @param {OpenSeadragon.Point} [translate] A translation vector to offset tile position
     */drawTile:function(tile,drawingHandler,useSketch,scale,translate){$.console.assert(tile,'[Drawer.drawTile] tile is required');$.console.assert(drawingHandler,'[Drawer.drawTile] drawingHandler is required');if(this.useCanvas){var context=this._getContext(useSketch);scale=scale||1;tile.drawCanvas(context,drawingHandler,scale,translate);}else{tile.drawHTML(this.canvas);}},_getContext:function(useSketch){var context=this.context;if(useSketch){if(this.sketchCanvas===null){this.sketchCanvas=document.createElement("canvas");var sketchCanvasSize=this._calculateSketchCanvasSize();this.sketchCanvas.width=sketchCanvasSize.x;this.sketchCanvas.height=sketchCanvasSize.y;this.sketchContext=this.sketchCanvas.getContext("2d");// If the viewport is not currently rotated, the sketchCanvas
// will have the same size as the main canvas. However, if
// the viewport get rotated later on, we will need to resize it.
if(this.viewport.getRotation()===0){var self=this;this.viewer.addHandler('rotate',function resizeSketchCanvas(){if(self.viewport.getRotation()===0){return;}self.viewer.removeHandler('rotate',resizeSketchCanvas);var sketchCanvasSize=self._calculateSketchCanvasSize();self.sketchCanvas.width=sketchCanvasSize.x;self.sketchCanvas.height=sketchCanvasSize.y;});}this._updateImageSmoothingEnabled(this.sketchContext);}context=this.sketchContext;}return context;},// private
saveContext:function(useSketch){if(!this.useCanvas){return;}this._getContext(useSketch).save();},// private
restoreContext:function(useSketch){if(!this.useCanvas){return;}this._getContext(useSketch).restore();},// private
setClip:function(rect,useSketch){if(!this.useCanvas){return;}var context=this._getContext(useSketch);context.beginPath();context.rect(rect.x,rect.y,rect.width,rect.height);context.clip();},// private
drawRectangle:function(rect,fillStyle,useSketch){if(!this.useCanvas){return;}var context=this._getContext(useSketch);context.save();context.fillStyle=fillStyle;context.fillRect(rect.x,rect.y,rect.width,rect.height);context.restore();},/**
     * Blends the sketch canvas in the main canvas.
     * @param {Object} options The options
     * @param {Float} options.opacity The opacity of the blending.
     * @param {Float} [options.scale=1] The scale at which tiles were drawn on
     * the sketch. Default is 1.
     * Use scale to draw at a lower scale and then enlarge onto the main canvas.
     * @param {OpenSeadragon.Point} [options.translate] A translation vector
     * that was used to draw the tiles
     * @param {String} [options.compositeOperation] - How the image is
     * composited onto other images; see compositeOperation in
     * {@link OpenSeadragon.Options} for possible values.
     * @param {OpenSeadragon.Rect} [options.bounds] The part of the sketch
     * canvas to blend in the main canvas. If specified, options.scale and
     * options.translate get ignored.
     */blendSketch:function(opacity,scale,translate,compositeOperation){var options=opacity;if(!$.isPlainObject(options)){options={opacity:opacity,scale:scale,translate:translate,compositeOperation:compositeOperation};}if(!this.useCanvas||!this.sketchCanvas){return;}opacity=options.opacity;compositeOperation=options.compositeOperation;var bounds=options.bounds;this.context.save();this.context.globalAlpha=opacity;if(compositeOperation){this.context.globalCompositeOperation=compositeOperation;}if(bounds){// Internet Explorer, Microsoft Edge, and Safari have problems
// when you call context.drawImage with negative x or y
// or x + width or y + height greater than the canvas width or height respectively.
if(bounds.x<0){bounds.width+=bounds.x;bounds.x=0;}if(bounds.x+bounds.width>this.canvas.width){bounds.width=this.canvas.width-bounds.x;}if(bounds.y<0){bounds.height+=bounds.y;bounds.y=0;}if(bounds.y+bounds.height>this.canvas.height){bounds.height=this.canvas.height-bounds.y;}this.context.drawImage(this.sketchCanvas,bounds.x,bounds.y,bounds.width,bounds.height,bounds.x,bounds.y,bounds.width,bounds.height);}else{scale=options.scale||1;translate=options.translate;var position=translate instanceof $.Point?translate:new $.Point(0,0);var widthExt=0;var heightExt=0;if(translate){var widthDiff=this.sketchCanvas.width-this.canvas.width;var heightDiff=this.sketchCanvas.height-this.canvas.height;widthExt=Math.round(widthDiff/2);heightExt=Math.round(heightDiff/2);}this.context.drawImage(this.sketchCanvas,position.x-widthExt*scale,position.y-heightExt*scale,(this.canvas.width+2*widthExt)*scale,(this.canvas.height+2*heightExt)*scale,-widthExt,-heightExt,this.canvas.width+2*widthExt,this.canvas.height+2*heightExt);}this.context.restore();},// private
drawDebugInfo:function(tile,count,i,tiledImage){if(!this.useCanvas){return;}var colorIndex=this.viewer.world.getIndexOfItem(tiledImage)%this.debugGridColor.length;var context=this.context;context.save();context.lineWidth=2*$.pixelDensityRatio;context.font='small-caps bold '+13*$.pixelDensityRatio+'px arial';context.strokeStyle=this.debugGridColor[colorIndex];context.fillStyle=this.debugGridColor[colorIndex];if(this.viewport.degrees!==0){this._offsetForRotation({degrees:this.viewport.degrees});}if(tiledImage.getRotation(true)%360!==0){this._offsetForRotation({degrees:tiledImage.getRotation(true),point:tiledImage.viewport.pixelFromPointNoRotate(tiledImage._getRotationPoint(true),true)});}if(tiledImage.viewport.degrees===0&&tiledImage.getRotation(true)%360===0){if(tiledImage._drawer.viewer.viewport.getFlip()){tiledImage._drawer._flip();}}context.strokeRect(tile.position.x*$.pixelDensityRatio,tile.position.y*$.pixelDensityRatio,tile.size.x*$.pixelDensityRatio,tile.size.y*$.pixelDensityRatio);var tileCenterX=(tile.position.x+tile.size.x/2)*$.pixelDensityRatio;var tileCenterY=(tile.position.y+tile.size.y/2)*$.pixelDensityRatio;// Rotate the text the right way around.
context.translate(tileCenterX,tileCenterY);context.rotate(Math.PI/180*-this.viewport.degrees);context.translate(-tileCenterX,-tileCenterY);if(tile.x===0&&tile.y===0){context.fillText("Zoom: "+this.viewport.getZoom(),tile.position.x*$.pixelDensityRatio,(tile.position.y-30)*$.pixelDensityRatio);context.fillText("Pan: "+this.viewport.getBounds().toString(),tile.position.x*$.pixelDensityRatio,(tile.position.y-20)*$.pixelDensityRatio);}context.fillText("Level: "+tile.level,(tile.position.x+10)*$.pixelDensityRatio,(tile.position.y+20)*$.pixelDensityRatio);context.fillText("Column: "+tile.x,(tile.position.x+10)*$.pixelDensityRatio,(tile.position.y+30)*$.pixelDensityRatio);context.fillText("Row: "+tile.y,(tile.position.x+10)*$.pixelDensityRatio,(tile.position.y+40)*$.pixelDensityRatio);context.fillText("Order: "+i+" of "+count,(tile.position.x+10)*$.pixelDensityRatio,(tile.position.y+50)*$.pixelDensityRatio);context.fillText("Size: "+tile.size.toString(),(tile.position.x+10)*$.pixelDensityRatio,(tile.position.y+60)*$.pixelDensityRatio);context.fillText("Position: "+tile.position.toString(),(tile.position.x+10)*$.pixelDensityRatio,(tile.position.y+70)*$.pixelDensityRatio);if(this.viewport.degrees!==0){this._restoreRotationChanges();}if(tiledImage.getRotation(true)%360!==0){this._restoreRotationChanges();}if(tiledImage.viewport.degrees===0&&tiledImage.getRotation(true)%360===0){if(tiledImage._drawer.viewer.viewport.getFlip()){tiledImage._drawer._flip();}}context.restore();},// private
debugRect:function(rect){if(this.useCanvas){var context=this.context;context.save();context.lineWidth=2*$.pixelDensityRatio;context.strokeStyle=this.debugGridColor[0];context.fillStyle=this.debugGridColor[0];context.strokeRect(rect.x*$.pixelDensityRatio,rect.y*$.pixelDensityRatio,rect.width*$.pixelDensityRatio,rect.height*$.pixelDensityRatio);context.restore();}},/**
     * Turns image smoothing on or off for this viewer. Note: Ignored in some (especially older) browsers that do not support this property.
     *
     * @function
     * @param {Boolean} [imageSmoothingEnabled] - Whether or not the image is
     * drawn smoothly on the canvas; see imageSmoothingEnabled in
     * {@link OpenSeadragon.Options} for more explanation.
     */setImageSmoothingEnabled:function(imageSmoothingEnabled){if(this.useCanvas){this._imageSmoothingEnabled=imageSmoothingEnabled;this._updateImageSmoothingEnabled(this.context);this.viewer.forceRedraw();}},// private
_updateImageSmoothingEnabled:function(context){context.msImageSmoothingEnabled=this._imageSmoothingEnabled;context.imageSmoothingEnabled=this._imageSmoothingEnabled;},/**
     * Get the canvas size
     * @param {Boolean} sketch If set to true return the size of the sketch canvas
     * @returns {OpenSeadragon.Point} The size of the canvas
     */getCanvasSize:function(sketch){var canvas=this._getContext(sketch).canvas;return new $.Point(canvas.width,canvas.height);},getCanvasCenter:function(){return new $.Point(this.canvas.width/2,this.canvas.height/2);},// private
_offsetForRotation:function(options){var point=options.point?options.point.times($.pixelDensityRatio):this.getCanvasCenter();var context=this._getContext(options.useSketch);context.save();context.translate(point.x,point.y);if(this.viewer.viewport.flipped){context.rotate(Math.PI/180*-options.degrees);context.scale(-1,1);}else{context.rotate(Math.PI/180*options.degrees);}context.translate(-point.x,-point.y);},// private
_flip:function(options){options=options||{};var point=options.point?options.point.times($.pixelDensityRatio):this.getCanvasCenter();var context=this._getContext(options.useSketch);context.translate(point.x,0);context.scale(-1,1);context.translate(-point.x,0);},// private
_restoreRotationChanges:function(useSketch){var context=this._getContext(useSketch);context.restore();},// private
_calculateCanvasSize:function(){var pixelDensityRatio=$.pixelDensityRatio;var viewportSize=this.viewport.getContainerSize();return{// canvas width and height are integers
x:Math.round(viewportSize.x*pixelDensityRatio),y:Math.round(viewportSize.y*pixelDensityRatio)};},// private
_calculateSketchCanvasSize:function(){var canvasSize=this._calculateCanvasSize();if(this.viewport.getRotation()===0){return canvasSize;}// If the viewport is rotated, we need a larger sketch canvas in order
// to support edge smoothing.
var sketchCanvasSize=Math.ceil(Math.sqrt(canvasSize.x*canvasSize.x+canvasSize.y*canvasSize.y));return{x:sketchCanvasSize,y:sketchCanvasSize};}};})(OpenSeadragon);/*
 * OpenSeadragon - Viewport
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class Viewport
 * @memberof OpenSeadragon
 * @classdesc Handles coordinate-related functionality (zoom, pan, rotation, etc.)
 * for an {@link OpenSeadragon.Viewer}.
 * @param {Object} options - Options for this Viewport.
 * @param {Object} [options.margins] - See viewportMargins in {@link OpenSeadragon.Options}.
 * @param {Number} [options.springStiffness] - See springStiffness in {@link OpenSeadragon.Options}.
 * @param {Number} [options.animationTime] - See animationTime in {@link OpenSeadragon.Options}.
 * @param {Number} [options.minZoomImageRatio] - See minZoomImageRatio in {@link OpenSeadragon.Options}.
 * @param {Number} [options.maxZoomPixelRatio] - See maxZoomPixelRatio in {@link OpenSeadragon.Options}.
 * @param {Number} [options.visibilityRatio] - See visibilityRatio in {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.wrapHorizontal] - See wrapHorizontal in {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.wrapVertical] - See wrapVertical in {@link OpenSeadragon.Options}.
 * @param {Number} [options.defaultZoomLevel] - See defaultZoomLevel in {@link OpenSeadragon.Options}.
 * @param {Number} [options.minZoomLevel] - See minZoomLevel in {@link OpenSeadragon.Options}.
 * @param {Number} [options.maxZoomLevel] - See maxZoomLevel in {@link OpenSeadragon.Options}.
 * @param {Number} [options.degrees] - See degrees in {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.homeFillsViewer] - See homeFillsViewer in {@link OpenSeadragon.Options}.
 */$.Viewport=function(options){//backward compatibility for positional args while preferring more
//idiomatic javascript options object as the only argument
var args=arguments;if(args.length&&args[0]instanceof $.Point){options={containerSize:args[0],contentSize:args[1],config:args[2]};}//options.config and the general config argument are deprecated
//in favor of the more direct specification of optional settings
//being passed directly on the options object
if(options.config){$.extend(true,options,options.config);delete options.config;}this._margins=$.extend({left:0,top:0,right:0,bottom:0},options.margins||{});delete options.margins;$.extend(true,this,{//required settings
containerSize:null,contentSize:null,//internal state properties
zoomPoint:null,viewer:null,//configurable options
springStiffness:$.DEFAULT_SETTINGS.springStiffness,animationTime:$.DEFAULT_SETTINGS.animationTime,minZoomImageRatio:$.DEFAULT_SETTINGS.minZoomImageRatio,maxZoomPixelRatio:$.DEFAULT_SETTINGS.maxZoomPixelRatio,visibilityRatio:$.DEFAULT_SETTINGS.visibilityRatio,wrapHorizontal:$.DEFAULT_SETTINGS.wrapHorizontal,wrapVertical:$.DEFAULT_SETTINGS.wrapVertical,defaultZoomLevel:$.DEFAULT_SETTINGS.defaultZoomLevel,minZoomLevel:$.DEFAULT_SETTINGS.minZoomLevel,maxZoomLevel:$.DEFAULT_SETTINGS.maxZoomLevel,degrees:$.DEFAULT_SETTINGS.degrees,flipped:$.DEFAULT_SETTINGS.flipped,homeFillsViewer:$.DEFAULT_SETTINGS.homeFillsViewer},options);this._updateContainerInnerSize();this.centerSpringX=new $.Spring({initial:0,springStiffness:this.springStiffness,animationTime:this.animationTime});this.centerSpringY=new $.Spring({initial:0,springStiffness:this.springStiffness,animationTime:this.animationTime});this.zoomSpring=new $.Spring({exponential:true,initial:1,springStiffness:this.springStiffness,animationTime:this.animationTime});this._oldCenterX=this.centerSpringX.current.value;this._oldCenterY=this.centerSpringY.current.value;this._oldZoom=this.zoomSpring.current.value;this._setContentBounds(new $.Rect(0,0,1,1),1);this.goHome(true);this.update();};/** @lends OpenSeadragon.Viewport.prototype */$.Viewport.prototype={/**
     * Updates the viewport's home bounds and constraints for the given content size.
     * @function
     * @param {OpenSeadragon.Point} contentSize - size of the content in content units
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:reset-size
     */resetContentSize:function(contentSize){$.console.assert(contentSize,"[Viewport.resetContentSize] contentSize is required");$.console.assert(contentSize instanceof $.Point,"[Viewport.resetContentSize] contentSize must be an OpenSeadragon.Point");$.console.assert(contentSize.x>0,"[Viewport.resetContentSize] contentSize.x must be greater than 0");$.console.assert(contentSize.y>0,"[Viewport.resetContentSize] contentSize.y must be greater than 0");this._setContentBounds(new $.Rect(0,0,1,contentSize.y/contentSize.x),contentSize.x);return this;},// deprecated
setHomeBounds:function(bounds,contentFactor){$.console.error("[Viewport.setHomeBounds] this function is deprecated; The content bounds should not be set manually.");this._setContentBounds(bounds,contentFactor);},// Set the viewport's content bounds
// @param {OpenSeadragon.Rect} bounds - the new bounds in viewport coordinates
// without rotation
// @param {Number} contentFactor - how many content units per viewport unit
// @fires OpenSeadragon.Viewer.event:reset-size
// @private
_setContentBounds:function(bounds,contentFactor){$.console.assert(bounds,"[Viewport._setContentBounds] bounds is required");$.console.assert(bounds instanceof $.Rect,"[Viewport._setContentBounds] bounds must be an OpenSeadragon.Rect");$.console.assert(bounds.width>0,"[Viewport._setContentBounds] bounds.width must be greater than 0");$.console.assert(bounds.height>0,"[Viewport._setContentBounds] bounds.height must be greater than 0");this._contentBoundsNoRotate=bounds.clone();this._contentSizeNoRotate=this._contentBoundsNoRotate.getSize().times(contentFactor);this._contentBounds=bounds.rotate(this.degrees).getBoundingBox();this._contentSize=this._contentBounds.getSize().times(contentFactor);this._contentAspectRatio=this._contentSize.x/this._contentSize.y;if(this.viewer){/**
             * Raised when the viewer's content size or home bounds are reset
             * (see {@link OpenSeadragon.Viewport#resetContentSize}).
             *
             * @event reset-size
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {OpenSeadragon.Point} contentSize
             * @property {OpenSeadragon.Rect} contentBounds - Content bounds.
             * @property {OpenSeadragon.Rect} homeBounds - Content bounds.
             * Deprecated use contentBounds instead.
             * @property {Number} contentFactor
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.viewer.raiseEvent('reset-size',{contentSize:this._contentSizeNoRotate.clone(),contentFactor:contentFactor,homeBounds:this._contentBoundsNoRotate.clone(),contentBounds:this._contentBounds.clone()});}},/**
     * Returns the home zoom in "viewport zoom" value.
     * @function
     * @returns {Number} The home zoom in "viewport zoom".
     */getHomeZoom:function(){if(this.defaultZoomLevel){return this.defaultZoomLevel;}var aspectFactor=this._contentAspectRatio/this.getAspectRatio();var output;if(this.homeFillsViewer){// fill the viewer and clip the image
output=aspectFactor>=1?aspectFactor:1;}else{output=aspectFactor>=1?1:aspectFactor;}return output/this._contentBounds.width;},/**
     * Returns the home bounds in viewport coordinates.
     * @function
     * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
     */getHomeBounds:function(){return this.getHomeBoundsNoRotate().rotate(-this.getRotation());},/**
     * Returns the home bounds in viewport coordinates.
     * This method ignores the viewport rotation. Use
     * {@link OpenSeadragon.Viewport#getHomeBounds} to take it into account.
     * @function
     * @returns {OpenSeadragon.Rect} The home bounds in vewport coordinates.
     */getHomeBoundsNoRotate:function(){var center=this._contentBounds.getCenter();var width=1.0/this.getHomeZoom();var height=width/this.getAspectRatio();return new $.Rect(center.x-width/2.0,center.y-height/2.0,width,height);},/**
     * @function
     * @param {Boolean} immediately
     * @fires OpenSeadragon.Viewer.event:home
     */goHome:function(immediately){if(this.viewer){/**
             * Raised when the "home" operation occurs (see {@link OpenSeadragon.Viewport#goHome}).
             *
             * @event home
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {Boolean} immediately
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.viewer.raiseEvent('home',{immediately:immediately});}return this.fitBounds(this.getHomeBounds(),immediately);},/**
     * @function
     */getMinZoom:function(){var homeZoom=this.getHomeZoom(),zoom=this.minZoomLevel?this.minZoomLevel:this.minZoomImageRatio*homeZoom;return zoom;},/**
     * @function
     */getMaxZoom:function(){var zoom=this.maxZoomLevel;if(!zoom){zoom=this._contentSize.x*this.maxZoomPixelRatio/this._containerInnerSize.x;zoom/=this._contentBounds.width;}return Math.max(zoom,this.getHomeZoom());},/**
     * @function
     */getAspectRatio:function(){return this._containerInnerSize.x/this._containerInnerSize.y;},/**
     * @function
     * @returns {OpenSeadragon.Point} The size of the container, in screen coordinates.
     */getContainerSize:function(){return new $.Point(this.containerSize.x,this.containerSize.y);},/**
     * The margins push the "home" region in from the sides by the specified amounts.
     * @function
     * @returns {Object} Properties (Numbers, in screen coordinates): left, top, right, bottom.
     */getMargins:function(){return $.extend({},this._margins);// Make a copy so we are not returning our original
},/**
     * The margins push the "home" region in from the sides by the specified amounts.
     * @function
     * @param {Object} margins - Properties (Numbers, in screen coordinates): left, top, right, bottom.
     */setMargins:function(margins){$.console.assert($.type(margins)==='object','[Viewport.setMargins] margins must be an object');this._margins=$.extend({left:0,top:0,right:0,bottom:0},margins);this._updateContainerInnerSize();if(this.viewer){this.viewer.forceRedraw();}},/**
     * Returns the bounds of the visible area in viewport coordinates.
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
     */getBounds:function(current){return this.getBoundsNoRotate(current).rotate(-this.getRotation());},/**
     * Returns the bounds of the visible area in viewport coordinates.
     * This method ignores the viewport rotation. Use
     * {@link OpenSeadragon.Viewport#getBounds} to take it into account.
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to, in viewport coordinates.
     */getBoundsNoRotate:function(current){var center=this.getCenter(current);var width=1.0/this.getZoom(current);var height=width/this.getAspectRatio();return new $.Rect(center.x-width/2.0,center.y-height/2.0,width,height);},/**
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
     * including the space taken by margins, in viewport coordinates.
     */getBoundsWithMargins:function(current){return this.getBoundsNoRotateWithMargins(current).rotate(-this.getRotation(),this.getCenter(current));},/**
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @returns {OpenSeadragon.Rect} The location you are zoomed/panned to,
     * including the space taken by margins, in viewport coordinates.
     */getBoundsNoRotateWithMargins:function(current){var bounds=this.getBoundsNoRotate(current);var factor=this._containerInnerSize.x*this.getZoom(current);bounds.x-=this._margins.left/factor;bounds.y-=this._margins.top/factor;bounds.width+=(this._margins.left+this._margins.right)/factor;bounds.height+=(this._margins.top+this._margins.bottom)/factor;return bounds;},/**
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     */getCenter:function(current){var centerCurrent=new $.Point(this.centerSpringX.current.value,this.centerSpringY.current.value),centerTarget=new $.Point(this.centerSpringX.target.value,this.centerSpringY.target.value),oldZoomPixel,zoom,width,height,bounds,newZoomPixel,deltaZoomPixels,deltaZoomPoints;if(current){return centerCurrent;}else if(!this.zoomPoint){return centerTarget;}oldZoomPixel=this.pixelFromPoint(this.zoomPoint,true);zoom=this.getZoom();width=1.0/zoom;height=width/this.getAspectRatio();bounds=new $.Rect(centerCurrent.x-width/2.0,centerCurrent.y-height/2.0,width,height);newZoomPixel=this._pixelFromPoint(this.zoomPoint,bounds);deltaZoomPixels=newZoomPixel.minus(oldZoomPixel);deltaZoomPoints=deltaZoomPixels.divide(this._containerInnerSize.x*zoom);return centerTarget.plus(deltaZoomPoints);},/**
     * @function
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     */getZoom:function(current){if(current){return this.zoomSpring.current.value;}else{return this.zoomSpring.target.value;}},// private
_applyZoomConstraints:function(zoom){return Math.max(Math.min(zoom,this.getMaxZoom()),this.getMinZoom());},/**
     * @function
     * @private
     * @param {OpenSeadragon.Rect} bounds
     * @return {OpenSeadragon.Rect} constrained bounds.
     */_applyBoundaryConstraints:function(bounds){var newBounds=new $.Rect(bounds.x,bounds.y,bounds.width,bounds.height);if(this.wrapHorizontal){//do nothing
}else{var horizontalThreshold=this.visibilityRatio*newBounds.width;var boundsRight=newBounds.x+newBounds.width;var contentRight=this._contentBoundsNoRotate.x+this._contentBoundsNoRotate.width;var leftDx=this._contentBoundsNoRotate.x-boundsRight+horizontalThreshold;var rightDx=contentRight-newBounds.x-horizontalThreshold;if(horizontalThreshold>this._contentBoundsNoRotate.width){newBounds.x+=(leftDx+rightDx)/2;}else if(rightDx<0){newBounds.x+=rightDx;}else if(leftDx>0){newBounds.x+=leftDx;}}if(this.wrapVertical){//do nothing
}else{var verticalThreshold=this.visibilityRatio*newBounds.height;var boundsBottom=newBounds.y+newBounds.height;var contentBottom=this._contentBoundsNoRotate.y+this._contentBoundsNoRotate.height;var topDy=this._contentBoundsNoRotate.y-boundsBottom+verticalThreshold;var bottomDy=contentBottom-newBounds.y-verticalThreshold;if(verticalThreshold>this._contentBoundsNoRotate.height){newBounds.y+=(topDy+bottomDy)/2;}else if(bottomDy<0){newBounds.y+=bottomDy;}else if(topDy>0){newBounds.y+=topDy;}}return newBounds;},/**
     * @function
     * @private
     * @param {Boolean} [immediately=false] - whether the function that triggered this event was
     * called with the "immediately" flag
     */_raiseConstraintsEvent:function(immediately){if(this.viewer){/**
             * Raised when the viewport constraints are applied (see {@link OpenSeadragon.Viewport#applyConstraints}).
             *
             * @event constrain
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {Boolean} immediately - whether the function that triggered this event was
             * called with the "immediately" flag
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.viewer.raiseEvent('constrain',{immediately:immediately});}},/**
     * Enforces the minZoom, maxZoom and visibilityRatio constraints by
     * zooming and panning to the closest acceptable zoom and location.
     * @function
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:constrain
     */applyConstraints:function(immediately){var actualZoom=this.getZoom();var constrainedZoom=this._applyZoomConstraints(actualZoom);if(actualZoom!==constrainedZoom){this.zoomTo(constrainedZoom,this.zoomPoint,immediately);}var bounds=this.getBoundsNoRotate();var constrainedBounds=this._applyBoundaryConstraints(bounds);this._raiseConstraintsEvent(immediately);if(bounds.x!==constrainedBounds.x||bounds.y!==constrainedBounds.y||immediately){this.fitBounds(constrainedBounds.rotate(-this.getRotation()),immediately);}return this;},/**
     * Equivalent to {@link OpenSeadragon.Viewport#applyConstraints}
     * @function
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:constrain
     */ensureVisible:function(immediately){return this.applyConstraints(immediately);},/**
     * @function
     * @private
     * @param {OpenSeadragon.Rect} bounds
     * @param {Object} options (immediately=false, constraints=false)
     * @return {OpenSeadragon.Viewport} Chainable.
     */_fitBounds:function(bounds,options){options=options||{};var immediately=options.immediately||false;var constraints=options.constraints||false;var aspect=this.getAspectRatio();var center=bounds.getCenter();// Compute width and height of bounding box.
var newBounds=new $.Rect(bounds.x,bounds.y,bounds.width,bounds.height,bounds.degrees+this.getRotation()).getBoundingBox();if(newBounds.getAspectRatio()>=aspect){newBounds.height=newBounds.width/aspect;}else{newBounds.width=newBounds.height*aspect;}// Compute x and y from width, height and center position
newBounds.x=center.x-newBounds.width/2;newBounds.y=center.y-newBounds.height/2;var newZoom=1.0/newBounds.width;if(constraints){var newBoundsAspectRatio=newBounds.getAspectRatio();var newConstrainedZoom=this._applyZoomConstraints(newZoom);if(newZoom!==newConstrainedZoom){newZoom=newConstrainedZoom;newBounds.width=1.0/newZoom;newBounds.x=center.x-newBounds.width/2;newBounds.height=newBounds.width/newBoundsAspectRatio;newBounds.y=center.y-newBounds.height/2;}newBounds=this._applyBoundaryConstraints(newBounds);center=newBounds.getCenter();this._raiseConstraintsEvent(immediately);}if(immediately){this.panTo(center,true);return this.zoomTo(newZoom,null,true);}this.panTo(this.getCenter(true),true);this.zoomTo(this.getZoom(true),null,true);var oldBounds=this.getBounds();var oldZoom=this.getZoom();if(oldZoom===0||Math.abs(newZoom/oldZoom-1)<0.00000001){this.zoomTo(newZoom,true);return this.panTo(center,immediately);}newBounds=newBounds.rotate(-this.getRotation());var referencePoint=newBounds.getTopLeft().times(newZoom).minus(oldBounds.getTopLeft().times(oldZoom)).divide(newZoom-oldZoom);return this.zoomTo(newZoom,referencePoint,immediately);},/**
     * Makes the viewport zoom and pan so that the specified bounds take
     * as much space as possible in the viewport.
     * Note: this method ignores the constraints (minZoom, maxZoom and
     * visibilityRatio).
     * Use {@link OpenSeadragon.Viewport#fitBoundsWithConstraints} to enforce
     * them.
     * @function
     * @param {OpenSeadragon.Rect} bounds
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     */fitBounds:function(bounds,immediately){return this._fitBounds(bounds,{immediately:immediately,constraints:false});},/**
     * Makes the viewport zoom and pan so that the specified bounds take
     * as much space as possible in the viewport while enforcing the constraints
     * (minZoom, maxZoom and visibilityRatio).
     * Note: because this method enforces the constraints, part of the
     * provided bounds may end up outside of the viewport.
     * Use {@link OpenSeadragon.Viewport#fitBounds} to ignore them.
     * @function
     * @param {OpenSeadragon.Rect} bounds
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     */fitBoundsWithConstraints:function(bounds,immediately){return this._fitBounds(bounds,{immediately:immediately,constraints:true});},/**
     * Zooms so the image just fills the viewer vertically.
     * @param {Boolean} immediately
     * @return {OpenSeadragon.Viewport} Chainable.
     */fitVertically:function(immediately){var box=new $.Rect(this._contentBounds.x+this._contentBounds.width/2,this._contentBounds.y,0,this._contentBounds.height);return this.fitBounds(box,immediately);},/**
     * Zooms so the image just fills the viewer horizontally.
     * @param {Boolean} immediately
     * @return {OpenSeadragon.Viewport} Chainable.
     */fitHorizontally:function(immediately){var box=new $.Rect(this._contentBounds.x,this._contentBounds.y+this._contentBounds.height/2,this._contentBounds.width,0);return this.fitBounds(box,immediately);},/**
     * Returns bounds taking constraints into account
     * Added to improve constrained panning
     * @param {Boolean} current - Pass true for the current location; defaults to false (target location).
     * @return {OpenSeadragon.Viewport} Chainable.
     */getConstrainedBounds:function(current){var bounds,constrainedBounds;bounds=this.getBounds(current);constrainedBounds=this._applyBoundaryConstraints(bounds);return constrainedBounds;},/**
     * @function
     * @param {OpenSeadragon.Point} delta
     * @param {Boolean} immediately
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:pan
     */panBy:function(delta,immediately){var center=new $.Point(this.centerSpringX.target.value,this.centerSpringY.target.value);return this.panTo(center.plus(delta),immediately);},/**
     * @function
     * @param {OpenSeadragon.Point} center
     * @param {Boolean} immediately
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:pan
     */panTo:function(center,immediately){if(immediately){this.centerSpringX.resetTo(center.x);this.centerSpringY.resetTo(center.y);}else{this.centerSpringX.springTo(center.x);this.centerSpringY.springTo(center.y);}if(this.viewer){/**
             * Raised when the viewport is panned (see {@link OpenSeadragon.Viewport#panBy} and {@link OpenSeadragon.Viewport#panTo}).
             *
             * @event pan
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {OpenSeadragon.Point} center
             * @property {Boolean} immediately
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.viewer.raiseEvent('pan',{center:center,immediately:immediately});}return this;},/**
     * @function
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:zoom
     */zoomBy:function(factor,refPoint,immediately){return this.zoomTo(this.zoomSpring.target.value*factor,refPoint,immediately);},/**
     * Zooms to the specified zoom level
     * @function
     * @param {Number} zoom The zoom level to zoom to.
     * @param {OpenSeadragon.Point} [refPoint] The point which will stay at
     * the same screen location. Defaults to the viewport center.
     * @param {Boolean} [immediately=false]
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:zoom
     */zoomTo:function(zoom,refPoint,immediately){var _this=this;this.zoomPoint=refPoint instanceof $.Point&&!isNaN(refPoint.x)&&!isNaN(refPoint.y)?refPoint:null;if(immediately){this._adjustCenterSpringsForZoomPoint(function(){_this.zoomSpring.resetTo(zoom);});}else{this.zoomSpring.springTo(zoom);}if(this.viewer){/**
             * Raised when the viewport zoom level changes (see {@link OpenSeadragon.Viewport#zoomBy} and {@link OpenSeadragon.Viewport#zoomTo}).
             *
             * @event zoom
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {Number} zoom
             * @property {OpenSeadragon.Point} refPoint
             * @property {Boolean} immediately
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.viewer.raiseEvent('zoom',{zoom:zoom,refPoint:refPoint,immediately:immediately});}return this;},/**
     * Rotates this viewport to the angle specified.
     * @function
     * @param {Number} degrees The degrees to set the rotation to.
     * @return {OpenSeadragon.Viewport} Chainable.
     */setRotation:function(degrees){if(!this.viewer||!this.viewer.drawer.canRotate()){return this;}this.degrees=$.positiveModulo(degrees,360);this._setContentBounds(this.viewer.world.getHomeBounds(),this.viewer.world.getContentFactor());this.viewer.forceRedraw();/**
         * Raised when rotation has been changed.
         *
         * @event rotate
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {Number} degrees - The number of degrees the rotation was set to.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.viewer.raiseEvent('rotate',{"degrees":degrees});return this;},/**
     * Gets the current rotation in degrees.
     * @function
     * @return {Number} The current rotation in degrees.
     */getRotation:function(){return this.degrees;},/**
     * @function
     * @return {OpenSeadragon.Viewport} Chainable.
     * @fires OpenSeadragon.Viewer.event:resize
     */resize:function(newContainerSize,maintain){var oldBounds=this.getBoundsNoRotate(),newBounds=oldBounds,widthDeltaFactor;this.containerSize.x=newContainerSize.x;this.containerSize.y=newContainerSize.y;this._updateContainerInnerSize();if(maintain){// TODO: widthDeltaFactor will always be 1; probably not what's intended
widthDeltaFactor=newContainerSize.x/this.containerSize.x;newBounds.width=oldBounds.width*widthDeltaFactor;newBounds.height=newBounds.width/this.getAspectRatio();}if(this.viewer){/**
             * Raised when the viewer is resized (see {@link OpenSeadragon.Viewport#resize}).
             *
             * @event resize
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised this event.
             * @property {OpenSeadragon.Point} newContainerSize
             * @property {Boolean} maintain
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.viewer.raiseEvent('resize',{newContainerSize:newContainerSize,maintain:maintain});}return this.fitBounds(newBounds,true);},// private
_updateContainerInnerSize:function(){this._containerInnerSize=new $.Point(Math.max(1,this.containerSize.x-(this._margins.left+this._margins.right)),Math.max(1,this.containerSize.y-(this._margins.top+this._margins.bottom)));},/**
     * Update the zoom and center (X and Y) springs.
     * @function
     * @returns {Boolean} True if any change has been made, false otherwise.
     */update:function(){var _this=this;this._adjustCenterSpringsForZoomPoint(function(){_this.zoomSpring.update();});this.centerSpringX.update();this.centerSpringY.update();var changed=this.centerSpringX.current.value!==this._oldCenterX||this.centerSpringY.current.value!==this._oldCenterY||this.zoomSpring.current.value!==this._oldZoom;this._oldCenterX=this.centerSpringX.current.value;this._oldCenterY=this.centerSpringY.current.value;this._oldZoom=this.zoomSpring.current.value;return changed;},_adjustCenterSpringsForZoomPoint:function(zoomSpringHandler){if(this.zoomPoint){var oldZoomPixel=this.pixelFromPoint(this.zoomPoint,true);zoomSpringHandler();var newZoomPixel=this.pixelFromPoint(this.zoomPoint,true);var deltaZoomPixels=newZoomPixel.minus(oldZoomPixel);var deltaZoomPoints=this.deltaPointsFromPixels(deltaZoomPixels,true);this.centerSpringX.shiftBy(deltaZoomPoints.x);this.centerSpringY.shiftBy(deltaZoomPoints.y);if(this.zoomSpring.isAtTargetValue()){this.zoomPoint=null;}}else{zoomSpringHandler();}},/**
     * Convert a delta (translation vector) from viewport coordinates to pixels
     * coordinates. This method does not take rotation into account.
     * Consider using deltaPixelsFromPoints if you need to account for rotation.
     * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */deltaPixelsFromPointsNoRotate:function(deltaPoints,current){return deltaPoints.times(this._containerInnerSize.x*this.getZoom(current));},/**
     * Convert a delta (translation vector) from viewport coordinates to pixels
     * coordinates.
     * @param {OpenSeadragon.Point} deltaPoints - The translation vector to convert.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */deltaPixelsFromPoints:function(deltaPoints,current){return this.deltaPixelsFromPointsNoRotate(deltaPoints.rotate(this.getRotation()),current);},/**
     * Convert a delta (translation vector) from pixels coordinates to viewport
     * coordinates. This method does not take rotation into account.
     * Consider using deltaPointsFromPixels if you need to account for rotation.
     * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */deltaPointsFromPixelsNoRotate:function(deltaPixels,current){return deltaPixels.divide(this._containerInnerSize.x*this.getZoom(current));},/**
     * Convert a delta (translation vector) from pixels coordinates to viewport
     * coordinates.
     * @param {OpenSeadragon.Point} deltaPixels - The translation vector to convert.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */deltaPointsFromPixels:function(deltaPixels,current){return this.deltaPointsFromPixelsNoRotate(deltaPixels,current).rotate(-this.getRotation());},/**
     * Convert viewport coordinates to pixels coordinates.
     * This method does not take rotation into account.
     * Consider using pixelFromPoint if you need to account for rotation.
     * @param {OpenSeadragon.Point} point the viewport coordinates
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */pixelFromPointNoRotate:function(point,current){return this._pixelFromPointNoRotate(point,this.getBoundsNoRotate(current));},/**
     * Convert viewport coordinates to pixel coordinates.
     * @param {OpenSeadragon.Point} point the viewport coordinates
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */pixelFromPoint:function(point,current){return this._pixelFromPoint(point,this.getBoundsNoRotate(current));},// private
_pixelFromPointNoRotate:function(point,bounds){return point.minus(bounds.getTopLeft()).times(this._containerInnerSize.x/bounds.width).plus(new $.Point(this._margins.left,this._margins.top));},// private
_pixelFromPoint:function(point,bounds){return this._pixelFromPointNoRotate(point.rotate(this.getRotation(),this.getCenter(true)),bounds);},/**
     * Convert pixel coordinates to viewport coordinates.
     * This method does not take rotation into account.
     * Consider using pointFromPixel if you need to account for rotation.
     * @param {OpenSeadragon.Point} pixel Pixel coordinates
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */pointFromPixelNoRotate:function(pixel,current){var bounds=this.getBoundsNoRotate(current);return pixel.minus(new $.Point(this._margins.left,this._margins.top)).divide(this._containerInnerSize.x/bounds.width).plus(bounds.getTopLeft());},/**
     * Convert pixel coordinates to viewport coordinates.
     * @param {OpenSeadragon.Point} pixel Pixel coordinates
     * @param {Boolean} [current=false] - Pass true for the current location;
     * defaults to false (target location).
     * @returns {OpenSeadragon.Point}
     */pointFromPixel:function(pixel,current){return this.pointFromPixelNoRotate(pixel,current).rotate(-this.getRotation(),this.getCenter(true));},// private
_viewportToImageDelta:function(viewerX,viewerY){var scale=this._contentBoundsNoRotate.width;return new $.Point(viewerX*this._contentSizeNoRotate.x/scale,viewerY*this._contentSizeNoRotate.x/scale);},/**
     * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
     * This method can be called either by passing X,Y coordinates or an
     * OpenSeadragon.Point
     * Note: not accurate with multi-image; use TiledImage.viewportToImageCoordinates instead.
     * @function
     * @param {(OpenSeadragon.Point|Number)} viewerX either a point or the X
     * coordinate in viewport coordinate system.
     * @param {Number} [viewerY] Y coordinate in viewport coordinate system.
     * @return {OpenSeadragon.Point} a point representing the coordinates in the image.
     */viewportToImageCoordinates:function(viewerX,viewerY){if(viewerX instanceof $.Point){//they passed a point instead of individual components
return this.viewportToImageCoordinates(viewerX.x,viewerX.y);}if(this.viewer){var count=this.viewer.world.getItemCount();if(count>1){$.console.error('[Viewport.viewportToImageCoordinates] is not accurate '+'with multi-image; use TiledImage.viewportToImageCoordinates instead.');}else if(count===1){// It is better to use TiledImage.viewportToImageCoordinates
// because this._contentBoundsNoRotate can not be relied on
// with clipping.
var item=this.viewer.world.getItemAt(0);return item.viewportToImageCoordinates(viewerX,viewerY,true);}}return this._viewportToImageDelta(viewerX-this._contentBoundsNoRotate.x,viewerY-this._contentBoundsNoRotate.y);},// private
_imageToViewportDelta:function(imageX,imageY){var scale=this._contentBoundsNoRotate.width;return new $.Point(imageX/this._contentSizeNoRotate.x*scale,imageY/this._contentSizeNoRotate.x*scale);},/**
     * Translates from image coordinate system to OpenSeadragon viewer coordinate system
     * This method can be called either by passing X,Y coordinates or an
     * OpenSeadragon.Point
     * Note: not accurate with multi-image; use TiledImage.imageToViewportCoordinates instead.
     * @function
     * @param {(OpenSeadragon.Point | Number)} imageX the point or the
     * X coordinate in image coordinate system.
     * @param {Number} [imageY] Y coordinate in image coordinate system.
     * @return {OpenSeadragon.Point} a point representing the coordinates in the viewport.
     */imageToViewportCoordinates:function(imageX,imageY){if(imageX instanceof $.Point){//they passed a point instead of individual components
return this.imageToViewportCoordinates(imageX.x,imageX.y);}if(this.viewer){var count=this.viewer.world.getItemCount();if(count>1){$.console.error('[Viewport.imageToViewportCoordinates] is not accurate '+'with multi-image; use TiledImage.imageToViewportCoordinates instead.');}else if(count===1){// It is better to use TiledImage.viewportToImageCoordinates
// because this._contentBoundsNoRotate can not be relied on
// with clipping.
var item=this.viewer.world.getItemAt(0);return item.imageToViewportCoordinates(imageX,imageY,true);}}var point=this._imageToViewportDelta(imageX,imageY);point.x+=this._contentBoundsNoRotate.x;point.y+=this._contentBoundsNoRotate.y;return point;},/**
     * Translates from a rectangle which describes a portion of the image in
     * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
     * This method can be called either by passing X,Y,width,height or an
     * OpenSeadragon.Rect
     * Note: not accurate with multi-image; use TiledImage.imageToViewportRectangle instead.
     * @function
     * @param {(OpenSeadragon.Rect | Number)} imageX the rectangle or the X
     * coordinate of the top left corner of the rectangle in image coordinate system.
     * @param {Number} [imageY] the Y coordinate of the top left corner of the rectangle
     * in image coordinate system.
     * @param {Number} [pixelWidth] the width in pixel of the rectangle.
     * @param {Number} [pixelHeight] the height in pixel of the rectangle.
     * @returns {OpenSeadragon.Rect} This image's bounds in viewport coordinates
     */imageToViewportRectangle:function(imageX,imageY,pixelWidth,pixelHeight){var rect=imageX;if(!(rect instanceof $.Rect)){//they passed individual components instead of a rectangle
rect=new $.Rect(imageX,imageY,pixelWidth,pixelHeight);}if(this.viewer){var count=this.viewer.world.getItemCount();if(count>1){$.console.error('[Viewport.imageToViewportRectangle] is not accurate '+'with multi-image; use TiledImage.imageToViewportRectangle instead.');}else if(count===1){// It is better to use TiledImage.imageToViewportRectangle
// because this._contentBoundsNoRotate can not be relied on
// with clipping.
var item=this.viewer.world.getItemAt(0);return item.imageToViewportRectangle(imageX,imageY,pixelWidth,pixelHeight,true);}}var coordA=this.imageToViewportCoordinates(rect.x,rect.y);var coordB=this._imageToViewportDelta(rect.width,rect.height);return new $.Rect(coordA.x,coordA.y,coordB.x,coordB.y,rect.degrees);},/**
     * Translates from a rectangle which describes a portion of
     * the viewport in point coordinates to image rectangle coordinates.
     * This method can be called either by passing X,Y,width,height or an
     * OpenSeadragon.Rect
     * Note: not accurate with multi-image; use TiledImage.viewportToImageRectangle instead.
     * @function
     * @param {(OpenSeadragon.Rect | Number)} viewerX either a rectangle or
     * the X coordinate of the top left corner of the rectangle in viewport
     * coordinate system.
     * @param {Number} [viewerY] the Y coordinate of the top left corner of the rectangle
     * in viewport coordinate system.
     * @param {Number} [pointWidth] the width of the rectangle in viewport coordinate system.
     * @param {Number} [pointHeight] the height of the rectangle in viewport coordinate system.
     */viewportToImageRectangle:function(viewerX,viewerY,pointWidth,pointHeight){var rect=viewerX;if(!(rect instanceof $.Rect)){//they passed individual components instead of a rectangle
rect=new $.Rect(viewerX,viewerY,pointWidth,pointHeight);}if(this.viewer){var count=this.viewer.world.getItemCount();if(count>1){$.console.error('[Viewport.viewportToImageRectangle] is not accurate '+'with multi-image; use TiledImage.viewportToImageRectangle instead.');}else if(count===1){// It is better to use TiledImage.viewportToImageCoordinates
// because this._contentBoundsNoRotate can not be relied on
// with clipping.
var item=this.viewer.world.getItemAt(0);return item.viewportToImageRectangle(viewerX,viewerY,pointWidth,pointHeight,true);}}var coordA=this.viewportToImageCoordinates(rect.x,rect.y);var coordB=this._viewportToImageDelta(rect.width,rect.height);return new $.Rect(coordA.x,coordA.y,coordB.x,coordB.y,rect.degrees);},/**
     * Convert pixel coordinates relative to the viewer element to image
     * coordinates.
     * Note: not accurate with multi-image.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */viewerElementToImageCoordinates:function(pixel){var point=this.pointFromPixel(pixel,true);return this.viewportToImageCoordinates(point);},/**
     * Convert pixel coordinates relative to the image to
     * viewer element coordinates.
     * Note: not accurate with multi-image.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */imageToViewerElementCoordinates:function(pixel){var point=this.imageToViewportCoordinates(pixel);return this.pixelFromPoint(point,true);},/**
     * Convert pixel coordinates relative to the window to image coordinates.
     * Note: not accurate with multi-image.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */windowToImageCoordinates:function(pixel){$.console.assert(this.viewer,"[Viewport.windowToImageCoordinates] the viewport must have a viewer.");var viewerCoordinates=pixel.minus($.getElementPosition(this.viewer.element));return this.viewerElementToImageCoordinates(viewerCoordinates);},/**
     * Convert image coordinates to pixel coordinates relative to the window.
     * Note: not accurate with multi-image.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */imageToWindowCoordinates:function(pixel){$.console.assert(this.viewer,"[Viewport.imageToWindowCoordinates] the viewport must have a viewer.");var viewerCoordinates=this.imageToViewerElementCoordinates(pixel);return viewerCoordinates.plus($.getElementPosition(this.viewer.element));},/**
     * Convert pixel coordinates relative to the viewer element to viewport
     * coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */viewerElementToViewportCoordinates:function(pixel){return this.pointFromPixel(pixel,true);},/**
     * Convert viewport coordinates to pixel coordinates relative to the
     * viewer element.
     * @param {OpenSeadragon.Point} point
     * @returns {OpenSeadragon.Point}
     */viewportToViewerElementCoordinates:function(point){return this.pixelFromPoint(point,true);},/**
     * Convert a rectangle in pixel coordinates relative to the viewer element
     * to viewport coordinates.
     * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
     * @returns {OpenSeadragon.Rect} the converted rectangle
     */viewerElementToViewportRectangle:function(rectangle){return $.Rect.fromSummits(this.pointFromPixel(rectangle.getTopLeft(),true),this.pointFromPixel(rectangle.getTopRight(),true),this.pointFromPixel(rectangle.getBottomLeft(),true));},/**
     * Convert a rectangle in viewport coordinates to pixel coordinates relative
     * to the viewer element.
     * @param {OpenSeadragon.Rect} rectangle the rectangle to convert
     * @returns {OpenSeadragon.Rect} the converted rectangle
     */viewportToViewerElementRectangle:function(rectangle){return $.Rect.fromSummits(this.pixelFromPoint(rectangle.getTopLeft(),true),this.pixelFromPoint(rectangle.getTopRight(),true),this.pixelFromPoint(rectangle.getBottomLeft(),true));},/**
     * Convert pixel coordinates relative to the window to viewport coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */windowToViewportCoordinates:function(pixel){$.console.assert(this.viewer,"[Viewport.windowToViewportCoordinates] the viewport must have a viewer.");var viewerCoordinates=pixel.minus($.getElementPosition(this.viewer.element));return this.viewerElementToViewportCoordinates(viewerCoordinates);},/**
     * Convert viewport coordinates to pixel coordinates relative to the window.
     * @param {OpenSeadragon.Point} point
     * @returns {OpenSeadragon.Point}
     */viewportToWindowCoordinates:function(point){$.console.assert(this.viewer,"[Viewport.viewportToWindowCoordinates] the viewport must have a viewer.");var viewerCoordinates=this.viewportToViewerElementCoordinates(point);return viewerCoordinates.plus($.getElementPosition(this.viewer.element));},/**
     * Convert a viewport zoom to an image zoom.
     * Image zoom: ratio of the original image size to displayed image size.
     * 1 means original image size, 0.5 half size...
     * Viewport zoom: ratio of the displayed image's width to viewport's width.
     * 1 means identical width, 2 means image's width is twice the viewport's width...
     * Note: not accurate with multi-image.
     * @function
     * @param {Number} viewportZoom The viewport zoom
     * target zoom.
     * @returns {Number} imageZoom The image zoom
     */viewportToImageZoom:function(viewportZoom){if(this.viewer){var count=this.viewer.world.getItemCount();if(count>1){$.console.error('[Viewport.viewportToImageZoom] is not '+'accurate with multi-image.');}else if(count===1){// It is better to use TiledImage.viewportToImageZoom
// because this._contentBoundsNoRotate can not be relied on
// with clipping.
var item=this.viewer.world.getItemAt(0);return item.viewportToImageZoom(viewportZoom);}}var imageWidth=this._contentSizeNoRotate.x;var containerWidth=this._containerInnerSize.x;var scale=this._contentBoundsNoRotate.width;var viewportToImageZoomRatio=containerWidth/imageWidth*scale;return viewportZoom*viewportToImageZoomRatio;},/**
     * Convert an image zoom to a viewport zoom.
     * Image zoom: ratio of the original image size to displayed image size.
     * 1 means original image size, 0.5 half size...
     * Viewport zoom: ratio of the displayed image's width to viewport's width.
     * 1 means identical width, 2 means image's width is twice the viewport's width...
     * Note: not accurate with multi-image.
     * @function
     * @param {Number} imageZoom The image zoom
     * target zoom.
     * @returns {Number} viewportZoom The viewport zoom
     */imageToViewportZoom:function(imageZoom){if(this.viewer){var count=this.viewer.world.getItemCount();if(count>1){$.console.error('[Viewport.imageToViewportZoom] is not accurate '+'with multi-image.');}else if(count===1){// It is better to use TiledImage.imageToViewportZoom
// because this._contentBoundsNoRotate can not be relied on
// with clipping.
var item=this.viewer.world.getItemAt(0);return item.imageToViewportZoom(imageZoom);}}var imageWidth=this._contentSizeNoRotate.x;var containerWidth=this._containerInnerSize.x;var scale=this._contentBoundsNoRotate.width;var viewportToImageZoomRatio=imageWidth/containerWidth/scale;return imageZoom*viewportToImageZoomRatio;},/**
     * Toggles flip state and demands a new drawing on navigator and viewer objects.
     * @function
     * @return {OpenSeadragon.Viewport} Chainable.
     */toggleFlip:function(){this.setFlip(!this.getFlip());return this;},/**
     * Get flip state stored on viewport.
     * @function
     * @return {Boolean} Flip state.
     */getFlip:function(){return this.flipped;},/**
     * Sets flip state according to the state input argument.
     * @function
     * @param {Boolean} state - Flip state to set.
     * @return {OpenSeadragon.Viewport} Chainable.
     */setFlip:function(state){if(this.flipped===state){return this;}this.flipped=state;if(this.viewer.navigator){this.viewer.navigator.setFlip(this.getFlip());}this.viewer.forceRedraw();/**
       * Raised when flip state has been changed.
       *
       * @event flip
       * @memberof OpenSeadragon.Viewer
       * @type {object}
       * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
       * @property {Number} flipped - The flip state after this change.
       * @property {?Object} userData - Arbitrary subscriber-defined object.
       */this.viewer.raiseEvent('flip',{"flipped":state});return this;}};})(OpenSeadragon);/*
 * OpenSeadragon - TiledImage
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * You shouldn't have to create a TiledImage instance directly; get it asynchronously by
 * using {@link OpenSeadragon.Viewer#open} or {@link OpenSeadragon.Viewer#addTiledImage} instead.
 * @class TiledImage
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @classdesc Handles rendering of tiles for an {@link OpenSeadragon.Viewer}.
 * A new instance is created for each TileSource opened.
 * @param {Object} options - Configuration for this TiledImage.
 * @param {OpenSeadragon.TileSource} options.source - The TileSource that defines this TiledImage.
 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this TiledImage.
 * @param {OpenSeadragon.TileCache} options.tileCache - The TileCache for this TiledImage to use.
 * @param {OpenSeadragon.Drawer} options.drawer - The Drawer for this TiledImage to draw onto.
 * @param {OpenSeadragon.ImageLoader} options.imageLoader - The ImageLoader for this TiledImage to use.
 * @param {Number} [options.x=0] - Left position, in viewport coordinates.
 * @param {Number} [options.y=0] - Top position, in viewport coordinates.
 * @param {Number} [options.width=1] - Width, in viewport coordinates.
 * @param {Number} [options.height] - Height, in viewport coordinates.
 * @param {OpenSeadragon.Rect} [options.fitBounds] The bounds in viewport coordinates
 * to fit the image into. If specified, x, y, width and height get ignored.
 * @param {OpenSeadragon.Placement} [options.fitBoundsPlacement=OpenSeadragon.Placement.CENTER]
 * How to anchor the image in the bounds if options.fitBounds is set.
 * @param {OpenSeadragon.Rect} [options.clip] - An area, in image pixels, to clip to
 * (portions of the image outside of this area will not be visible). Only works on
 * browsers that support the HTML5 canvas.
 * @param {Number} [options.springStiffness] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.animationTime] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.minZoomImageRatio] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.wrapHorizontal] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.wrapVertical] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.immediateRender] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.blendTime] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.alwaysBlend] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.minPixelRatio] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.smoothTileEdgesMinZoom] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.iOSDevice] - See {@link OpenSeadragon.Options}.
 * @param {Number} [options.opacity=1] - Set to draw at proportional opacity. If zero, images will not draw.
 * @param {Boolean} [options.preload=false] - Set true to load even when the image is hidden by zero opacity.
 * @param {String} [options.compositeOperation] - How the image is composited onto other images; see compositeOperation in {@link OpenSeadragon.Options} for possible values.
 * @param {Boolean} [options.debugMode] - See {@link OpenSeadragon.Options}.
 * @param {String|CanvasGradient|CanvasPattern|Function} [options.placeholderFillStyle] - See {@link OpenSeadragon.Options}.
 * @param {String|Boolean} [options.crossOriginPolicy] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.ajaxWithCredentials] - See {@link OpenSeadragon.Options}.
 * @param {Boolean} [options.loadTilesWithAjax]
 *      Whether to load tile data using AJAX requests.
 *      Defaults to the setting in {@link OpenSeadragon.Options}.
 * @param {Object} [options.ajaxHeaders={}]
 *      A set of headers to include when making tile AJAX requests.
 */$.TiledImage=function(options){var _this=this;/**
     * The {@link OpenSeadragon.TileSource} that defines this TiledImage.
     * @member {OpenSeadragon.TileSource} source
     * @memberof OpenSeadragon.TiledImage#
     */$.console.assert(options.tileCache,"[TiledImage] options.tileCache is required");$.console.assert(options.drawer,"[TiledImage] options.drawer is required");$.console.assert(options.viewer,"[TiledImage] options.viewer is required");$.console.assert(options.imageLoader,"[TiledImage] options.imageLoader is required");$.console.assert(options.source,"[TiledImage] options.source is required");$.console.assert(!options.clip||options.clip instanceof $.Rect,"[TiledImage] options.clip must be an OpenSeadragon.Rect if present");$.EventSource.call(this);this._tileCache=options.tileCache;delete options.tileCache;this._drawer=options.drawer;delete options.drawer;this._imageLoader=options.imageLoader;delete options.imageLoader;if(options.clip instanceof $.Rect){this._clip=options.clip.clone();}delete options.clip;var x=options.x||0;delete options.x;var y=options.y||0;delete options.y;// Ratio of zoomable image height to width.
this.normHeight=options.source.dimensions.y/options.source.dimensions.x;this.contentAspectX=options.source.dimensions.x/options.source.dimensions.y;var scale=1;if(options.width){scale=options.width;delete options.width;if(options.height){$.console.error("specifying both width and height to a tiledImage is not supported");delete options.height;}}else if(options.height){scale=options.height/this.normHeight;delete options.height;}var fitBounds=options.fitBounds;delete options.fitBounds;var fitBoundsPlacement=options.fitBoundsPlacement||OpenSeadragon.Placement.CENTER;delete options.fitBoundsPlacement;var degrees=options.degrees||0;delete options.degrees;$.extend(true,this,{//internal state properties
viewer:null,tilesMatrix:{},// A '3d' dictionary [level][x][y] --> Tile.
coverage:{},// A '3d' dictionary [level][x][y] --> Boolean; shows what areas have been drawn.
loadingCoverage:{},// A '3d' dictionary [level][x][y] --> Boolean; shows what areas are loaded or are being loaded/blended.
lastDrawn:[],// An unordered list of Tiles drawn last frame.
lastResetTime:0,// Last time for which the tiledImage was reset.
_midDraw:false,// Is the tiledImage currently updating the viewport?
_needsDraw:true,// Does the tiledImage need to update the viewport again?
_hasOpaqueTile:false,// Do we have even one fully opaque tile?
_tilesLoading:0,// The number of pending tile requests.
//configurable settings
springStiffness:$.DEFAULT_SETTINGS.springStiffness,animationTime:$.DEFAULT_SETTINGS.animationTime,minZoomImageRatio:$.DEFAULT_SETTINGS.minZoomImageRatio,wrapHorizontal:$.DEFAULT_SETTINGS.wrapHorizontal,wrapVertical:$.DEFAULT_SETTINGS.wrapVertical,immediateRender:$.DEFAULT_SETTINGS.immediateRender,blendTime:$.DEFAULT_SETTINGS.blendTime,alwaysBlend:$.DEFAULT_SETTINGS.alwaysBlend,minPixelRatio:$.DEFAULT_SETTINGS.minPixelRatio,smoothTileEdgesMinZoom:$.DEFAULT_SETTINGS.smoothTileEdgesMinZoom,iOSDevice:$.DEFAULT_SETTINGS.iOSDevice,debugMode:$.DEFAULT_SETTINGS.debugMode,crossOriginPolicy:$.DEFAULT_SETTINGS.crossOriginPolicy,ajaxWithCredentials:$.DEFAULT_SETTINGS.ajaxWithCredentials,placeholderFillStyle:$.DEFAULT_SETTINGS.placeholderFillStyle,opacity:$.DEFAULT_SETTINGS.opacity,preload:$.DEFAULT_SETTINGS.preload,compositeOperation:$.DEFAULT_SETTINGS.compositeOperation},options);this._preload=this.preload;delete this.preload;this._fullyLoaded=false;this._xSpring=new $.Spring({initial:x,springStiffness:this.springStiffness,animationTime:this.animationTime});this._ySpring=new $.Spring({initial:y,springStiffness:this.springStiffness,animationTime:this.animationTime});this._scaleSpring=new $.Spring({initial:scale,springStiffness:this.springStiffness,animationTime:this.animationTime});this._degreesSpring=new $.Spring({initial:degrees,springStiffness:this.springStiffness,animationTime:this.animationTime});this._updateForScale();if(fitBounds){this.fitBounds(fitBounds,fitBoundsPlacement,true);}// We need a callback to give image manipulation a chance to happen
this._drawingHandler=function(args){/**
       * This event is fired just before the tile is drawn giving the application a chance to alter the image.
       *
       * NOTE: This event is only fired when the drawer is using a &lt;canvas&gt;.
       *
       * @event tile-drawing
       * @memberof OpenSeadragon.Viewer
       * @type {object}
       * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
       * @property {OpenSeadragon.Tile} tile - The Tile being drawn.
       * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
       * @property {OpenSeadragon.Tile} context - The HTML canvas context being drawn into.
       * @property {OpenSeadragon.Tile} rendered - The HTML canvas context containing the tile imagery.
       * @property {?Object} userData - Arbitrary subscriber-defined object.
       */_this.viewer.raiseEvent('tile-drawing',$.extend({tiledImage:_this},args));};};$.extend($.TiledImage.prototype,$.EventSource.prototype,/** @lends OpenSeadragon.TiledImage.prototype */{/**
     * @returns {Boolean} Whether the TiledImage needs to be drawn.
     */needsDraw:function(){return this._needsDraw;},/**
     * @returns {Boolean} Whether all tiles necessary for this TiledImage to draw at the current view have been loaded.
     */getFullyLoaded:function(){return this._fullyLoaded;},// private
_setFullyLoaded:function(flag){if(flag===this._fullyLoaded){return;}this._fullyLoaded=flag;/**
         * Fired when the TiledImage's "fully loaded" flag (whether all tiles necessary for this TiledImage
         * to draw at the current view have been loaded) changes.
         *
         * @event fully-loaded-change
         * @memberof OpenSeadragon.TiledImage
         * @type {object}
         * @property {Boolean} fullyLoaded - The new "fully loaded" value.
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('fully-loaded-change',{fullyLoaded:this._fullyLoaded});},/**
     * Clears all tiles and triggers an update on the next call to
     * {@link OpenSeadragon.TiledImage#update}.
     */reset:function(){this._tileCache.clearTilesFor(this);this.lastResetTime=$.now();this._needsDraw=true;},/**
     * Updates the TiledImage's bounds, animating if needed.
     * @returns {Boolean} Whether the TiledImage animated.
     */update:function(){var xUpdated=this._xSpring.update();var yUpdated=this._ySpring.update();var scaleUpdated=this._scaleSpring.update();var degreesUpdated=this._degreesSpring.update();if(xUpdated||yUpdated||scaleUpdated||degreesUpdated){this._updateForScale();this._needsDraw=true;return true;}return false;},/**
     * Draws the TiledImage to its Drawer.
     */draw:function(){if(this.opacity!==0||this._preload){this._midDraw=true;this._updateViewport();this._midDraw=false;}// Images with opacity 0 should not need to be drawn in future. this._needsDraw = false is set in this._updateViewport() for other images.
else{this._needsDraw=false;}},/**
     * Destroy the TiledImage (unload current loaded tiles).
     */destroy:function(){this.reset();},/**
     * Get this TiledImage's bounds in viewport coordinates.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * false for target location.
     * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
     */getBounds:function(current){return this.getBoundsNoRotate(current).rotate(this.getRotation(current),this._getRotationPoint(current));},/**
     * Get this TiledImage's bounds in viewport coordinates without taking
     * rotation into account.
     * @param {Boolean} [current=false] - Pass true for the current location;
     * false for target location.
     * @returns {OpenSeadragon.Rect} This TiledImage's bounds in viewport coordinates.
     */getBoundsNoRotate:function(current){return current?new $.Rect(this._xSpring.current.value,this._ySpring.current.value,this._worldWidthCurrent,this._worldHeightCurrent):new $.Rect(this._xSpring.target.value,this._ySpring.target.value,this._worldWidthTarget,this._worldHeightTarget);},// deprecated
getWorldBounds:function(){$.console.error('[TiledImage.getWorldBounds] is deprecated; use TiledImage.getBounds instead');return this.getBounds();},/**
     * Get the bounds of the displayed part of the tiled image.
     * @param {Boolean} [current=false] Pass true for the current location,
     * false for the target location.
     * @returns {$.Rect} The clipped bounds in viewport coordinates.
     */getClippedBounds:function(current){var bounds=this.getBoundsNoRotate(current);if(this._clip){var worldWidth=current?this._worldWidthCurrent:this._worldWidthTarget;var ratio=worldWidth/this.source.dimensions.x;var clip=this._clip.times(ratio);bounds=new $.Rect(bounds.x+clip.x,bounds.y+clip.y,clip.width,clip.height);}return bounds.rotate(this.getRotation(current),this._getRotationPoint(current));},/**
     * @returns {OpenSeadragon.Point} This TiledImage's content size, in original pixels.
     */getContentSize:function(){return new $.Point(this.source.dimensions.x,this.source.dimensions.y);},// private
_viewportToImageDelta:function(viewerX,viewerY,current){var scale=current?this._scaleSpring.current.value:this._scaleSpring.target.value;return new $.Point(viewerX*(this.source.dimensions.x/scale),viewerY*(this.source.dimensions.y*this.contentAspectX/scale));},/**
     * Translates from OpenSeadragon viewer coordinate system to image coordinate system.
     * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
     * @param {Number|OpenSeadragon.Point} viewerX - The X coordinate or point in viewport coordinate system.
     * @param {Number} [viewerY] - The Y coordinate in viewport coordinate system.
     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
     * @return {OpenSeadragon.Point} A point representing the coordinates in the image.
     */viewportToImageCoordinates:function(viewerX,viewerY,current){var point;if(viewerX instanceof $.Point){//they passed a point instead of individual components
current=viewerY;point=viewerX;}else{point=new $.Point(viewerX,viewerY);}point=point.rotate(-this.getRotation(current),this._getRotationPoint(current));return current?this._viewportToImageDelta(point.x-this._xSpring.current.value,point.y-this._ySpring.current.value):this._viewportToImageDelta(point.x-this._xSpring.target.value,point.y-this._ySpring.target.value);},// private
_imageToViewportDelta:function(imageX,imageY,current){var scale=current?this._scaleSpring.current.value:this._scaleSpring.target.value;return new $.Point(imageX/this.source.dimensions.x*scale,imageY/this.source.dimensions.y/this.contentAspectX*scale);},/**
     * Translates from image coordinate system to OpenSeadragon viewer coordinate system
     * This method can be called either by passing X,Y coordinates or an {@link OpenSeadragon.Point}.
     * @param {Number|OpenSeadragon.Point} imageX - The X coordinate or point in image coordinate system.
     * @param {Number} [imageY] - The Y coordinate in image coordinate system.
     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
     * @return {OpenSeadragon.Point} A point representing the coordinates in the viewport.
     */imageToViewportCoordinates:function(imageX,imageY,current){if(imageX instanceof $.Point){//they passed a point instead of individual components
current=imageY;imageY=imageX.y;imageX=imageX.x;}var point=this._imageToViewportDelta(imageX,imageY);if(current){point.x+=this._xSpring.current.value;point.y+=this._ySpring.current.value;}else{point.x+=this._xSpring.target.value;point.y+=this._ySpring.target.value;}return point.rotate(this.getRotation(current),this._getRotationPoint(current));},/**
     * Translates from a rectangle which describes a portion of the image in
     * pixel coordinates to OpenSeadragon viewport rectangle coordinates.
     * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
     * @param {Number|OpenSeadragon.Rect} imageX - The left coordinate or rectangle in image coordinate system.
     * @param {Number} [imageY] - The top coordinate in image coordinate system.
     * @param {Number} [pixelWidth] - The width in pixel of the rectangle.
     * @param {Number} [pixelHeight] - The height in pixel of the rectangle.
     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
     * @return {OpenSeadragon.Rect} A rect representing the coordinates in the viewport.
     */imageToViewportRectangle:function(imageX,imageY,pixelWidth,pixelHeight,current){var rect=imageX;if(rect instanceof $.Rect){//they passed a rect instead of individual components
current=imageY;}else{rect=new $.Rect(imageX,imageY,pixelWidth,pixelHeight);}var coordA=this.imageToViewportCoordinates(rect.getTopLeft(),current);var coordB=this._imageToViewportDelta(rect.width,rect.height,current);return new $.Rect(coordA.x,coordA.y,coordB.x,coordB.y,rect.degrees+this.getRotation(current));},/**
     * Translates from a rectangle which describes a portion of
     * the viewport in point coordinates to image rectangle coordinates.
     * This method can be called either by passing X,Y,width,height or an {@link OpenSeadragon.Rect}.
     * @param {Number|OpenSeadragon.Rect} viewerX - The left coordinate or rectangle in viewport coordinate system.
     * @param {Number} [viewerY] - The top coordinate in viewport coordinate system.
     * @param {Number} [pointWidth] - The width in viewport coordinate system.
     * @param {Number} [pointHeight] - The height in viewport coordinate system.
     * @param {Boolean} [current=false] - Pass true to use the current location; false for target location.
     * @return {OpenSeadragon.Rect} A rect representing the coordinates in the image.
     */viewportToImageRectangle:function(viewerX,viewerY,pointWidth,pointHeight,current){var rect=viewerX;if(viewerX instanceof $.Rect){//they passed a rect instead of individual components
current=viewerY;}else{rect=new $.Rect(viewerX,viewerY,pointWidth,pointHeight);}var coordA=this.viewportToImageCoordinates(rect.getTopLeft(),current);var coordB=this._viewportToImageDelta(rect.width,rect.height,current);return new $.Rect(coordA.x,coordA.y,coordB.x,coordB.y,rect.degrees-this.getRotation(current));},/**
     * Convert pixel coordinates relative to the viewer element to image
     * coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */viewerElementToImageCoordinates:function(pixel){var point=this.viewport.pointFromPixel(pixel,true);return this.viewportToImageCoordinates(point);},/**
     * Convert pixel coordinates relative to the image to
     * viewer element coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */imageToViewerElementCoordinates:function(pixel){var point=this.imageToViewportCoordinates(pixel);return this.viewport.pixelFromPoint(point,true);},/**
     * Convert pixel coordinates relative to the window to image coordinates.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */windowToImageCoordinates:function(pixel){var viewerCoordinates=pixel.minus(OpenSeadragon.getElementPosition(this.viewer.element));return this.viewerElementToImageCoordinates(viewerCoordinates);},/**
     * Convert image coordinates to pixel coordinates relative to the window.
     * @param {OpenSeadragon.Point} pixel
     * @returns {OpenSeadragon.Point}
     */imageToWindowCoordinates:function(pixel){var viewerCoordinates=this.imageToViewerElementCoordinates(pixel);return viewerCoordinates.plus(OpenSeadragon.getElementPosition(this.viewer.element));},// private
// Convert rectangle in viewport coordinates to this tiled image point
// coordinates (x in [0, 1] and y in [0, aspectRatio])
_viewportToTiledImageRectangle:function(rect){var scale=this._scaleSpring.current.value;rect=rect.rotate(-this.getRotation(true),this._getRotationPoint(true));return new $.Rect((rect.x-this._xSpring.current.value)/scale,(rect.y-this._ySpring.current.value)/scale,rect.width/scale,rect.height/scale,rect.degrees);},/**
     * Convert a viewport zoom to an image zoom.
     * Image zoom: ratio of the original image size to displayed image size.
     * 1 means original image size, 0.5 half size...
     * Viewport zoom: ratio of the displayed image's width to viewport's width.
     * 1 means identical width, 2 means image's width is twice the viewport's width...
     * @function
     * @param {Number} viewportZoom The viewport zoom
     * @returns {Number} imageZoom The image zoom
     */viewportToImageZoom:function(viewportZoom){var ratio=this._scaleSpring.current.value*this.viewport._containerInnerSize.x/this.source.dimensions.x;return ratio*viewportZoom;},/**
     * Convert an image zoom to a viewport zoom.
     * Image zoom: ratio of the original image size to displayed image size.
     * 1 means original image size, 0.5 half size...
     * Viewport zoom: ratio of the displayed image's width to viewport's width.
     * 1 means identical width, 2 means image's width is twice the viewport's width...
     * Note: not accurate with multi-image.
     * @function
     * @param {Number} imageZoom The image zoom
     * @returns {Number} viewportZoom The viewport zoom
     */imageToViewportZoom:function(imageZoom){var ratio=this._scaleSpring.current.value*this.viewport._containerInnerSize.x/this.source.dimensions.x;return imageZoom/ratio;},/**
     * Sets the TiledImage's position in the world.
     * @param {OpenSeadragon.Point} position - The new position, in viewport coordinates.
     * @param {Boolean} [immediately=false] - Whether to animate to the new position or snap immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */setPosition:function(position,immediately){var sameTarget=this._xSpring.target.value===position.x&&this._ySpring.target.value===position.y;if(immediately){if(sameTarget&&this._xSpring.current.value===position.x&&this._ySpring.current.value===position.y){return;}this._xSpring.resetTo(position.x);this._ySpring.resetTo(position.y);this._needsDraw=true;}else{if(sameTarget){return;}this._xSpring.springTo(position.x);this._ySpring.springTo(position.y);this._needsDraw=true;}if(!sameTarget){this._raiseBoundsChange();}},/**
     * Sets the TiledImage's width in the world, adjusting the height to match based on aspect ratio.
     * @param {Number} width - The new width, in viewport coordinates.
     * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */setWidth:function(width,immediately){this._setScale(width,immediately);},/**
     * Sets the TiledImage's height in the world, adjusting the width to match based on aspect ratio.
     * @param {Number} height - The new height, in viewport coordinates.
     * @param {Boolean} [immediately=false] - Whether to animate to the new size or snap immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */setHeight:function(height,immediately){this._setScale(height/this.normHeight,immediately);},/**
     * Sets an array of polygons to crop the TiledImage during draw tiles.
     * The render function will use the default non-zero winding rule.
     * @param Polygons represented in an array of point object in image coordinates.
     * Example format: [
     *  [{x: 197, y:172}, {x: 226, y:172}, {x: 226, y:198}, {x: 197, y:198}], // First polygon
     *  [{x: 328, y:200}, {x: 330, y:199}, {x: 332, y:201}, {x: 329, y:202}]  // Second polygon
     *  [{x: 321, y:201}, {x: 356, y:205}, {x: 341, y:250}] // Third polygon
     * ]
     */setCroppingPolygons:function(polygons){var isXYObject=function(obj){return obj instanceof $.Point||typeof obj.x==='number'&&typeof obj.y==='number';};var objectToSimpleXYObject=function(objs){return objs.map(function(obj){try{if(isXYObject(obj)){return{x:obj.x,y:obj.y};}else{throw new Error();}}catch(e){throw new Error('A Provided cropping polygon point is not supported');}});};try{if(!$.isArray(polygons)){throw new Error('Provided cropping polygon is not an array');}this._croppingPolygons=polygons.map(function(polygon){return objectToSimpleXYObject(polygon);});}catch(e){$.console.error('[TiledImage.setCroppingPolygons] Cropping polygon format not supported');$.console.error(e);this._croppingPolygons=null;}},/**
     * Resets the cropping polygons, thus next render will remove all cropping
     * polygon effects.
     */resetCroppingPolygons:function(){this._croppingPolygons=null;},/**
     * Positions and scales the TiledImage to fit in the specified bounds.
     * Note: this method fires OpenSeadragon.TiledImage.event:bounds-change
     * twice
     * @param {OpenSeadragon.Rect} bounds The bounds to fit the image into.
     * @param {OpenSeadragon.Placement} [anchor=OpenSeadragon.Placement.CENTER]
     * How to anchor the image in the bounds.
     * @param {Boolean} [immediately=false] Whether to animate to the new size
     * or snap immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */fitBounds:function(bounds,anchor,immediately){anchor=anchor||$.Placement.CENTER;var anchorProperties=$.Placement.properties[anchor];var aspectRatio=this.contentAspectX;var xOffset=0;var yOffset=0;var displayedWidthRatio=1;var displayedHeightRatio=1;if(this._clip){aspectRatio=this._clip.getAspectRatio();displayedWidthRatio=this._clip.width/this.source.dimensions.x;displayedHeightRatio=this._clip.height/this.source.dimensions.y;if(bounds.getAspectRatio()>aspectRatio){xOffset=this._clip.x/this._clip.height*bounds.height;yOffset=this._clip.y/this._clip.height*bounds.height;}else{xOffset=this._clip.x/this._clip.width*bounds.width;yOffset=this._clip.y/this._clip.width*bounds.width;}}if(bounds.getAspectRatio()>aspectRatio){// We will have margins on the X axis
var height=bounds.height/displayedHeightRatio;var marginLeft=0;if(anchorProperties.isHorizontallyCentered){marginLeft=(bounds.width-bounds.height*aspectRatio)/2;}else if(anchorProperties.isRight){marginLeft=bounds.width-bounds.height*aspectRatio;}this.setPosition(new $.Point(bounds.x-xOffset+marginLeft,bounds.y-yOffset),immediately);this.setHeight(height,immediately);}else{// We will have margins on the Y axis
var width=bounds.width/displayedWidthRatio;var marginTop=0;if(anchorProperties.isVerticallyCentered){marginTop=(bounds.height-bounds.width/aspectRatio)/2;}else if(anchorProperties.isBottom){marginTop=bounds.height-bounds.width/aspectRatio;}this.setPosition(new $.Point(bounds.x-xOffset,bounds.y-yOffset+marginTop),immediately);this.setWidth(width,immediately);}},/**
     * @returns {OpenSeadragon.Rect|null} The TiledImage's current clip rectangle,
     * in image pixels, or null if none.
     */getClip:function(){if(this._clip){return this._clip.clone();}return null;},/**
     * @param {OpenSeadragon.Rect|null} newClip - An area, in image pixels, to clip to
     * (portions of the image outside of this area will not be visible). Only works on
     * browsers that support the HTML5 canvas.
     * @fires OpenSeadragon.TiledImage.event:clip-change
     */setClip:function(newClip){$.console.assert(!newClip||newClip instanceof $.Rect,"[TiledImage.setClip] newClip must be an OpenSeadragon.Rect or null");if(newClip instanceof $.Rect){this._clip=newClip.clone();}else{this._clip=null;}this._needsDraw=true;/**
         * Raised when the TiledImage's clip is changed.
         * @event clip-change
         * @memberOf OpenSeadragon.TiledImage
         * @type {object}
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
         * TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('clip-change');},/**
     * @returns {Number} The TiledImage's current opacity.
     */getOpacity:function(){return this.opacity;},/**
     * @param {Number} opacity Opacity the tiled image should be drawn at.
     * @fires OpenSeadragon.TiledImage.event:opacity-change
     */setOpacity:function(opacity){if(opacity===this.opacity){return;}this.opacity=opacity;this._needsDraw=true;/**
         * Raised when the TiledImage's opacity is changed.
         * @event opacity-change
         * @memberOf OpenSeadragon.TiledImage
         * @type {object}
         * @property {Number} opacity - The new opacity value.
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
         * TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('opacity-change',{opacity:this.opacity});},/**
     * @returns {Boolean} whether the tiledImage can load its tiles even when it has zero opacity.
     */getPreload:function(){return this._preload;},/**
     * Set true to load even when hidden. Set false to block loading when hidden.
     */setPreload:function(preload){this._preload=!!preload;this._needsDraw=true;},/**
     * Get the rotation of this tiled image in degrees.
     * @param {Boolean} [current=false] True for current rotation, false for target.
     * @returns {Number} the rotation of this tiled image in degrees.
     */getRotation:function(current){return current?this._degreesSpring.current.value:this._degreesSpring.target.value;},/**
     * Set the current rotation of this tiled image in degrees.
     * @param {Number} degrees the rotation in degrees.
     * @param {Boolean} [immediately=false] Whether to animate to the new angle
     * or rotate immediately.
     * @fires OpenSeadragon.TiledImage.event:bounds-change
     */setRotation:function(degrees,immediately){if(this._degreesSpring.target.value===degrees&&this._degreesSpring.isAtTargetValue()){return;}if(immediately){this._degreesSpring.resetTo(degrees);}else{this._degreesSpring.springTo(degrees);}this._needsDraw=true;this._raiseBoundsChange();},/**
     * Get the point around which this tiled image is rotated
     * @private
     * @param {Boolean} current True for current rotation point, false for target.
     * @returns {OpenSeadragon.Point}
     */_getRotationPoint:function(current){return this.getBoundsNoRotate(current).getCenter();},/**
     * @returns {String} The TiledImage's current compositeOperation.
     */getCompositeOperation:function(){return this.compositeOperation;},/**
     * @param {String} compositeOperation the tiled image should be drawn with this globalCompositeOperation.
     * @fires OpenSeadragon.TiledImage.event:composite-operation-change
     */setCompositeOperation:function(compositeOperation){if(compositeOperation===this.compositeOperation){return;}this.compositeOperation=compositeOperation;this._needsDraw=true;/**
         * Raised when the TiledImage's opacity is changed.
         * @event composite-operation-change
         * @memberOf OpenSeadragon.TiledImage
         * @type {object}
         * @property {String} compositeOperation - The new compositeOperation value.
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
         * TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('composite-operation-change',{compositeOperation:this.compositeOperation});},// private
_setScale:function(scale,immediately){var sameTarget=this._scaleSpring.target.value===scale;if(immediately){if(sameTarget&&this._scaleSpring.current.value===scale){return;}this._scaleSpring.resetTo(scale);this._updateForScale();this._needsDraw=true;}else{if(sameTarget){return;}this._scaleSpring.springTo(scale);this._updateForScale();this._needsDraw=true;}if(!sameTarget){this._raiseBoundsChange();}},// private
_updateForScale:function(){this._worldWidthTarget=this._scaleSpring.target.value;this._worldHeightTarget=this.normHeight*this._scaleSpring.target.value;this._worldWidthCurrent=this._scaleSpring.current.value;this._worldHeightCurrent=this.normHeight*this._scaleSpring.current.value;},// private
_raiseBoundsChange:function(){/**
         * Raised when the TiledImage's bounds are changed.
         * Note that this event is triggered only when the animation target is changed;
         * not for every frame of animation.
         * @event bounds-change
         * @memberOf OpenSeadragon.TiledImage
         * @type {object}
         * @property {OpenSeadragon.TiledImage} eventSource - A reference to the
         * TiledImage which raised the event.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('bounds-change');},// private
_isBottomItem:function(){return this.viewer.world.getItemAt(0)===this;},// private
_getLevelsInterval:function(){var lowestLevel=Math.max(this.source.minLevel,Math.floor(Math.log(this.minZoomImageRatio)/Math.log(2)));var currentZeroRatio=this.viewport.deltaPixelsFromPointsNoRotate(this.source.getPixelRatio(0),true).x*this._scaleSpring.current.value;var highestLevel=Math.min(Math.abs(this.source.maxLevel),Math.abs(Math.floor(Math.log(currentZeroRatio/this.minPixelRatio)/Math.log(2))));// Calculations for the interval of levels to draw
// can return invalid intervals; fix that here if necessary
highestLevel=Math.max(highestLevel,this.source.minLevel||0);lowestLevel=Math.min(lowestLevel,highestLevel);return{lowestLevel:lowestLevel,highestLevel:highestLevel};},/**
     * @private
     * @inner
     * Pretty much every other line in this needs to be documented so it's clear
     * how each piece of this routine contributes to the drawing process.  That's
     * why there are so many TODO's inside this function.
     */_updateViewport:function(){this._needsDraw=false;this._tilesLoading=0;this.loadingCoverage={};// Reset tile's internal drawn state
while(this.lastDrawn.length>0){var tile=this.lastDrawn.pop();tile.beingDrawn=false;}var viewport=this.viewport;var drawArea=this._viewportToTiledImageRectangle(viewport.getBoundsWithMargins(true));if(!this.wrapHorizontal&&!this.wrapVertical){var tiledImageBounds=this._viewportToTiledImageRectangle(this.getClippedBounds(true));drawArea=drawArea.intersection(tiledImageBounds);if(drawArea===null){return;}}var levelsInterval=this._getLevelsInterval();var lowestLevel=levelsInterval.lowestLevel;var highestLevel=levelsInterval.highestLevel;var bestTile=null;var haveDrawn=false;var currentTime=$.now();// Update any level that will be drawn
for(var level=highestLevel;level>=lowestLevel;level--){var drawLevel=false;//Avoid calculations for draw if we have already drawn this
var currentRenderPixelRatio=viewport.deltaPixelsFromPointsNoRotate(this.source.getPixelRatio(level),true).x*this._scaleSpring.current.value;if(level===lowestLevel||!haveDrawn&&currentRenderPixelRatio>=this.minPixelRatio){drawLevel=true;haveDrawn=true;}else if(!haveDrawn){continue;}//Perform calculations for draw if we haven't drawn this
var targetRenderPixelRatio=viewport.deltaPixelsFromPointsNoRotate(this.source.getPixelRatio(level),false).x*this._scaleSpring.current.value;var targetZeroRatio=viewport.deltaPixelsFromPointsNoRotate(this.source.getPixelRatio(Math.max(this.source.getClosestLevel(),0)),false).x*this._scaleSpring.current.value;var optimalRatio=this.immediateRender?1:targetZeroRatio;var levelOpacity=Math.min(1,(currentRenderPixelRatio-0.5)/0.5);var levelVisibility=optimalRatio/Math.abs(optimalRatio-targetRenderPixelRatio);// Update the level and keep track of 'best' tile to load
bestTile=updateLevel(this,haveDrawn,drawLevel,level,levelOpacity,levelVisibility,drawArea,currentTime,bestTile);// Stop the loop if lower-res tiles would all be covered by
// already drawn tiles
if(providesCoverage(this.coverage,level)){break;}}// Perform the actual drawing
drawTiles(this,this.lastDrawn);// Load the new 'best' tile
if(bestTile&&!bestTile.context2D){loadTile(this,bestTile,currentTime);this._needsDraw=true;this._setFullyLoaded(false);}else{this._setFullyLoaded(this._tilesLoading===0);}},// private
_getCornerTiles:function(level,topLeftBound,bottomRightBound){var leftX;var rightX;if(this.wrapHorizontal){leftX=$.positiveModulo(topLeftBound.x,1);rightX=$.positiveModulo(bottomRightBound.x,1);}else{leftX=Math.max(0,topLeftBound.x);rightX=Math.min(1,bottomRightBound.x);}var topY;var bottomY;var aspectRatio=1/this.source.aspectRatio;if(this.wrapVertical){topY=$.positiveModulo(topLeftBound.y,aspectRatio);bottomY=$.positiveModulo(bottomRightBound.y,aspectRatio);}else{topY=Math.max(0,topLeftBound.y);bottomY=Math.min(aspectRatio,bottomRightBound.y);}var topLeftTile=this.source.getTileAtPoint(level,new $.Point(leftX,topY));var bottomRightTile=this.source.getTileAtPoint(level,new $.Point(rightX,bottomY));var numTiles=this.source.getNumTiles(level);if(this.wrapHorizontal){topLeftTile.x+=numTiles.x*Math.floor(topLeftBound.x);bottomRightTile.x+=numTiles.x*Math.floor(bottomRightBound.x);}if(this.wrapVertical){topLeftTile.y+=numTiles.y*Math.floor(topLeftBound.y/aspectRatio);bottomRightTile.y+=numTiles.y*Math.floor(bottomRightBound.y/aspectRatio);}return{topLeft:topLeftTile,bottomRight:bottomRightTile};}});/**
 * @private
 * @inner
 * Updates all tiles at a given resolution level.
 * @param {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
 * @param {Boolean} haveDrawn
 * @param {Boolean} drawLevel
 * @param {Number} level
 * @param {Number} levelOpacity
 * @param {Number} levelVisibility
 * @param {OpenSeadragon.Point} viewportTL - The index of the most top-left visible tile.
 * @param {OpenSeadragon.Point} viewportBR - The index of the most bottom-right visible tile.
 * @param {Number} currentTime
 * @param {OpenSeadragon.Tile} best - The current "best" tile to draw.
 */function updateLevel(tiledImage,haveDrawn,drawLevel,level,levelOpacity,levelVisibility,drawArea,currentTime,best){var topLeftBound=drawArea.getBoundingBox().getTopLeft();var bottomRightBound=drawArea.getBoundingBox().getBottomRight();if(tiledImage.viewer){/**
         * <em>- Needs documentation -</em>
         *
         * @event update-level
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
         * @property {Object} havedrawn
         * @property {Object} level
         * @property {Object} opacity
         * @property {Object} visibility
         * @property {OpenSeadragon.Rect} drawArea
         * @property {Object} topleft deprecated, use drawArea instead
         * @property {Object} bottomright deprecated, use drawArea instead
         * @property {Object} currenttime
         * @property {Object} best
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */tiledImage.viewer.raiseEvent('update-level',{tiledImage:tiledImage,havedrawn:haveDrawn,level:level,opacity:levelOpacity,visibility:levelVisibility,drawArea:drawArea,topleft:topLeftBound,bottomright:bottomRightBound,currenttime:currentTime,best:best});}resetCoverage(tiledImage.coverage,level);resetCoverage(tiledImage.loadingCoverage,level);//OK, a new drawing so do your calculations
var cornerTiles=tiledImage._getCornerTiles(level,topLeftBound,bottomRightBound);var topLeftTile=cornerTiles.topLeft;var bottomRightTile=cornerTiles.bottomRight;var numberOfTiles=tiledImage.source.getNumTiles(level);var viewportCenter=tiledImage.viewport.pixelFromPoint(tiledImage.viewport.getCenter());for(var x=topLeftTile.x;x<=bottomRightTile.x;x++){for(var y=topLeftTile.y;y<=bottomRightTile.y;y++){// Optimisation disabled with wrapping because getTileBounds does not
// work correctly with x and y outside of the number of tiles
if(!tiledImage.wrapHorizontal&&!tiledImage.wrapVertical){var tileBounds=tiledImage.source.getTileBounds(level,x,y);if(drawArea.intersection(tileBounds)===null){// This tile is outside of the viewport, no need to draw it
continue;}}best=updateTile(tiledImage,drawLevel,haveDrawn,x,y,level,levelOpacity,levelVisibility,viewportCenter,numberOfTiles,currentTime,best);}}return best;}/**
 * @private
 * @inner
 * Update a single tile at a particular resolution level.
 * @param {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
 * @param {Boolean} haveDrawn
 * @param {Boolean} drawLevel
 * @param {Number} x
 * @param {Number} y
 * @param {Number} level
 * @param {Number} levelOpacity
 * @param {Number} levelVisibility
 * @param {OpenSeadragon.Point} viewportCenter
 * @param {Number} numberOfTiles
 * @param {Number} currentTime
 * @param {OpenSeadragon.Tile} best - The current "best" tile to draw.
 */function updateTile(tiledImage,haveDrawn,drawLevel,x,y,level,levelOpacity,levelVisibility,viewportCenter,numberOfTiles,currentTime,best){var tile=getTile(x,y,level,tiledImage,tiledImage.source,tiledImage.tilesMatrix,currentTime,numberOfTiles,tiledImage._worldWidthCurrent,tiledImage._worldHeightCurrent),drawTile=drawLevel;if(tiledImage.viewer){/**
         * <em>- Needs documentation -</em>
         *
         * @event update-tile
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
         * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
         * @property {OpenSeadragon.Tile} tile
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */tiledImage.viewer.raiseEvent('update-tile',{tiledImage:tiledImage,tile:tile});}setCoverage(tiledImage.coverage,level,x,y,false);var loadingCoverage=tile.loaded||tile.loading||isCovered(tiledImage.loadingCoverage,level,x,y);setCoverage(tiledImage.loadingCoverage,level,x,y,loadingCoverage);if(!tile.exists){return best;}if(haveDrawn&&!drawTile){if(isCovered(tiledImage.coverage,level,x,y)){setCoverage(tiledImage.coverage,level,x,y,true);}else{drawTile=true;}}if(!drawTile){return best;}positionTile(tile,tiledImage.source.tileOverlap,tiledImage.viewport,viewportCenter,levelVisibility,tiledImage);if(!tile.loaded){if(tile.context2D){setTileLoaded(tiledImage,tile);}else{var imageRecord=tiledImage._tileCache.getImageRecord(tile.cacheKey);if(imageRecord){var image=imageRecord.getImage();setTileLoaded(tiledImage,tile,image);}}}if(tile.loaded){var needsDraw=blendTile(tiledImage,tile,x,y,level,levelOpacity,currentTime);if(needsDraw){tiledImage._needsDraw=true;}}else if(tile.loading){// the tile is already in the download queue
tiledImage._tilesLoading++;}else if(!loadingCoverage){best=compareTiles(best,tile);}return best;}/**
 * @private
 * @inner
 * Obtains a tile at the given location.
 * @param {Number} x
 * @param {Number} y
 * @param {Number} level
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.TileSource} tileSource
 * @param {Object} tilesMatrix - A '3d' dictionary [level][x][y] --> Tile.
 * @param {Number} time
 * @param {Number} numTiles
 * @param {Number} worldWidth
 * @param {Number} worldHeight
 * @returns {OpenSeadragon.Tile}
 */function getTile(x,y,level,tiledImage,tileSource,tilesMatrix,time,numTiles,worldWidth,worldHeight){var xMod,yMod,bounds,sourceBounds,exists,url,ajaxHeaders,context2D,tile;if(!tilesMatrix[level]){tilesMatrix[level]={};}if(!tilesMatrix[level][x]){tilesMatrix[level][x]={};}if(!tilesMatrix[level][x][y]){xMod=(numTiles.x+x%numTiles.x)%numTiles.x;yMod=(numTiles.y+y%numTiles.y)%numTiles.y;bounds=tileSource.getTileBounds(level,xMod,yMod);sourceBounds=tileSource.getTileBounds(level,xMod,yMod,true);exists=tileSource.tileExists(level,xMod,yMod);url=tileSource.getTileUrl(level,xMod,yMod);// Headers are only applicable if loadTilesWithAjax is set
if(tiledImage.loadTilesWithAjax){ajaxHeaders=tileSource.getTileAjaxHeaders(level,xMod,yMod);// Combine tile AJAX headers with tiled image AJAX headers (if applicable)
if($.isPlainObject(tiledImage.ajaxHeaders)){ajaxHeaders=$.extend({},tiledImage.ajaxHeaders,ajaxHeaders);}}else{ajaxHeaders=null;}context2D=tileSource.getContext2D?tileSource.getContext2D(level,xMod,yMod):undefined;bounds.x+=(x-xMod)/numTiles.x;bounds.y+=worldHeight/worldWidth*((y-yMod)/numTiles.y);tile=new $.Tile(level,x,y,bounds,exists,url,context2D,tiledImage.loadTilesWithAjax,ajaxHeaders,sourceBounds);if(xMod===numTiles.x-1){tile.isRightMost=true;}if(yMod===numTiles.y-1){tile.isBottomMost=true;}tilesMatrix[level][x][y]=tile;}tile=tilesMatrix[level][x][y];tile.lastTouchTime=time;return tile;}/**
 * @private
 * @inner
 * Dispatch a job to the ImageLoader to load the Image for a Tile.
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile} tile
 * @param {Number} time
 */function loadTile(tiledImage,tile,time){tile.loading=true;tiledImage._imageLoader.addJob({src:tile.url,loadWithAjax:tile.loadWithAjax,ajaxHeaders:tile.ajaxHeaders,crossOriginPolicy:tiledImage.crossOriginPolicy,ajaxWithCredentials:tiledImage.ajaxWithCredentials,callback:function(image,errorMsg,tileRequest){onTileLoad(tiledImage,tile,time,image,errorMsg,tileRequest);},abort:function(){tile.loading=false;}});}/**
 * @private
 * @inner
 * Callback fired when a Tile's Image finished downloading.
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile} tile
 * @param {Number} time
 * @param {Image} image
 * @param {String} errorMsg
 * @param {XMLHttpRequest} tileRequest
 */function onTileLoad(tiledImage,tile,time,image,errorMsg,tileRequest){if(!image){$.console.log("Tile %s failed to load: %s - error: %s",tile,tile.url,errorMsg);/**
         * Triggered when a tile fails to load.
         *
         * @event tile-load-failed
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.Tile} tile - The tile that failed to load.
         * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image the tile belongs to.
         * @property {number} time - The time in milliseconds when the tile load began.
         * @property {string} message - The error message.
         * @property {XMLHttpRequest} tileRequest - The XMLHttpRequest used to load the tile if available.
         */tiledImage.viewer.raiseEvent("tile-load-failed",{tile:tile,tiledImage:tiledImage,time:time,message:errorMsg,tileRequest:tileRequest});tile.loading=false;tile.exists=false;return;}if(time<tiledImage.lastResetTime){$.console.log("Ignoring tile %s loaded before reset: %s",tile,tile.url);tile.loading=false;return;}var finish=function(){var cutoff=tiledImage.source.getClosestLevel();setTileLoaded(tiledImage,tile,image,cutoff,tileRequest);};// Check if we're mid-update; this can happen on IE8 because image load events for
// cached images happen immediately there
if(!tiledImage._midDraw){finish();}else{// Wait until after the update, in case caching unloads any tiles
window.setTimeout(finish,1);}}/**
 * @private
 * @inner
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile} tile
 * @param {Image} image
 * @param {Number} cutoff
 */function setTileLoaded(tiledImage,tile,image,cutoff,tileRequest){var increment=0;function getCompletionCallback(){increment++;return completionCallback;}function completionCallback(){increment--;if(increment===0){tile.loading=false;tile.loaded=true;if(!tile.context2D){tiledImage._tileCache.cacheTile({image:image,tile:tile,cutoff:cutoff,tiledImage:tiledImage});}tiledImage._needsDraw=true;}}/**
     * Triggered when a tile has just been loaded in memory. That means that the
     * image has been downloaded and can be modified before being drawn to the canvas.
     *
     * @event tile-loaded
     * @memberof OpenSeadragon.Viewer
     * @type {object}
     * @property {Image} image - The image of the tile.
     * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image of the loaded tile.
     * @property {OpenSeadragon.Tile} tile - The tile which has been loaded.
     * @property {XMLHttpRequest} tiledImage - The AJAX request that loaded this tile (if applicable).
     * @property {function} getCompletionCallback - A function giving a callback to call
     * when the asynchronous processing of the image is done. The image will be
     * marked as entirely loaded when the callback has been called once for each
     * call to getCompletionCallback.
     */tiledImage.viewer.raiseEvent("tile-loaded",{tile:tile,tiledImage:tiledImage,tileRequest:tileRequest,image:image,getCompletionCallback:getCompletionCallback});// In case the completion callback is never called, we at least force it once.
getCompletionCallback()();}/**
 * @private
 * @inner
 * @param {OpenSeadragon.Tile} tile
 * @param {Boolean} overlap
 * @param {OpenSeadragon.Viewport} viewport
 * @param {OpenSeadragon.Point} viewportCenter
 * @param {Number} levelVisibility
 * @param {OpenSeadragon.TiledImage} tiledImage
 */function positionTile(tile,overlap,viewport,viewportCenter,levelVisibility,tiledImage){var boundsTL=tile.bounds.getTopLeft();boundsTL.x*=tiledImage._scaleSpring.current.value;boundsTL.y*=tiledImage._scaleSpring.current.value;boundsTL.x+=tiledImage._xSpring.current.value;boundsTL.y+=tiledImage._ySpring.current.value;var boundsSize=tile.bounds.getSize();boundsSize.x*=tiledImage._scaleSpring.current.value;boundsSize.y*=tiledImage._scaleSpring.current.value;var positionC=viewport.pixelFromPointNoRotate(boundsTL,true),positionT=viewport.pixelFromPointNoRotate(boundsTL,false),sizeC=viewport.deltaPixelsFromPointsNoRotate(boundsSize,true),sizeT=viewport.deltaPixelsFromPointsNoRotate(boundsSize,false),tileCenter=positionT.plus(sizeT.divide(2)),tileSquaredDistance=viewportCenter.squaredDistanceTo(tileCenter);if(!overlap){sizeC=sizeC.plus(new $.Point(1,1));}if(tile.isRightMost&&tiledImage.wrapHorizontal){sizeC.x+=0.75;// Otherwise Firefox and Safari show seams
}if(tile.isBottomMost&&tiledImage.wrapVertical){sizeC.y+=0.75;// Otherwise Firefox and Safari show seams
}tile.position=positionC;tile.size=sizeC;tile.squaredDistance=tileSquaredDistance;tile.visibility=levelVisibility;}/**
 * @private
 * @inner
 * Updates the opacity of a tile according to the time it has been on screen
 * to perform a fade-in.
 * Updates coverage once a tile is fully opaque.
 * Returns whether the fade-in has completed.
 *
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile} tile
 * @param {Number} x
 * @param {Number} y
 * @param {Number} level
 * @param {Number} levelOpacity
 * @param {Number} currentTime
 * @returns {Boolean}
 */function blendTile(tiledImage,tile,x,y,level,levelOpacity,currentTime){var blendTimeMillis=1000*tiledImage.blendTime,deltaTime,opacity;if(!tile.blendStart){tile.blendStart=currentTime;}deltaTime=currentTime-tile.blendStart;opacity=blendTimeMillis?Math.min(1,deltaTime/blendTimeMillis):1;if(tiledImage.alwaysBlend){opacity*=levelOpacity;}tile.opacity=opacity;tiledImage.lastDrawn.push(tile);if(opacity===1){setCoverage(tiledImage.coverage,level,x,y,true);tiledImage._hasOpaqueTile=true;}else if(deltaTime<blendTimeMillis){return true;}return false;}/**
 * @private
 * @inner
 * Returns true if the given tile provides coverage to lower-level tiles of
 * lower resolution representing the same content. If neither x nor y is
 * given, returns true if the entire visible level provides coverage.
 *
 * Note that out-of-bounds tiles provide coverage in this sense, since
 * there's no content that they would need to cover. Tiles at non-existent
 * levels that are within the image bounds, however, do not.
 *
 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
 * @param {Number} level - The resolution level of the tile.
 * @param {Number} x - The X position of the tile.
 * @param {Number} y - The Y position of the tile.
 * @returns {Boolean}
 */function providesCoverage(coverage,level,x,y){var rows,cols,i,j;if(!coverage[level]){return false;}if(x===undefined||y===undefined){rows=coverage[level];for(i in rows){if(Object.prototype.hasOwnProperty.call(rows,i)){cols=rows[i];for(j in cols){if(Object.prototype.hasOwnProperty.call(cols,j)&&!cols[j]){return false;}}}}return true;}return coverage[level][x]===undefined||coverage[level][x][y]===undefined||coverage[level][x][y]===true;}/**
 * @private
 * @inner
 * Returns true if the given tile is completely covered by higher-level
 * tiles of higher resolution representing the same content. If neither x
 * nor y is given, returns true if the entire visible level is covered.
 *
 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
 * @param {Number} level - The resolution level of the tile.
 * @param {Number} x - The X position of the tile.
 * @param {Number} y - The Y position of the tile.
 * @returns {Boolean}
 */function isCovered(coverage,level,x,y){if(x===undefined||y===undefined){return providesCoverage(coverage,level+1);}else{return providesCoverage(coverage,level+1,2*x,2*y)&&providesCoverage(coverage,level+1,2*x,2*y+1)&&providesCoverage(coverage,level+1,2*x+1,2*y)&&providesCoverage(coverage,level+1,2*x+1,2*y+1);}}/**
 * @private
 * @inner
 * Sets whether the given tile provides coverage or not.
 *
 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
 * @param {Number} level - The resolution level of the tile.
 * @param {Number} x - The X position of the tile.
 * @param {Number} y - The Y position of the tile.
 * @param {Boolean} covers - Whether the tile provides coverage.
 */function setCoverage(coverage,level,x,y,covers){if(!coverage[level]){$.console.warn("Setting coverage for a tile before its level's coverage has been reset: %s",level);return;}if(!coverage[level][x]){coverage[level][x]={};}coverage[level][x][y]=covers;}/**
 * @private
 * @inner
 * Resets coverage information for the given level. This should be called
 * after every draw routine. Note that at the beginning of the next draw
 * routine, coverage for every visible tile should be explicitly set.
 *
 * @param {Object} coverage - A '3d' dictionary [level][x][y] --> Boolean.
 * @param {Number} level - The resolution level of tiles to completely reset.
 */function resetCoverage(coverage,level){coverage[level]={};}/**
 * @private
 * @inner
 * Determines whether the 'last best' tile for the area is better than the
 * tile in question.
 *
 * @param {OpenSeadragon.Tile} previousBest
 * @param {OpenSeadragon.Tile} tile
 * @returns {OpenSeadragon.Tile} The new best tile.
 */function compareTiles(previousBest,tile){if(!previousBest){return tile;}if(tile.visibility>previousBest.visibility){return tile;}else if(tile.visibility==previousBest.visibility){if(tile.squaredDistance<previousBest.squaredDistance){return tile;}}return previousBest;}/**
 * @private
 * @inner
 * Draws a TiledImage.
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile[]} lastDrawn - An unordered list of Tiles drawn last frame.
 */function drawTiles(tiledImage,lastDrawn){if(tiledImage.opacity===0||lastDrawn.length===0&&!tiledImage.placeholderFillStyle){return;}var tile=lastDrawn[0];var useSketch;if(tile){useSketch=tiledImage.opacity<1||tiledImage.compositeOperation&&tiledImage.compositeOperation!=='source-over'||!tiledImage._isBottomItem()&&tile._hasTransparencyChannel();}var sketchScale;var sketchTranslate;var zoom=tiledImage.viewport.getZoom(true);var imageZoom=tiledImage.viewportToImageZoom(zoom);if(lastDrawn.length>1&&imageZoom>tiledImage.smoothTileEdgesMinZoom&&!tiledImage.iOSDevice&&tiledImage.getRotation(true)%360===0&&// TODO: support tile edge smoothing with tiled image rotation.
$.supportsCanvas){// When zoomed in a lot (>100%) the tile edges are visible.
// So we have to composite them at ~100% and scale them up together.
// Note: Disabled on iOS devices per default as it causes a native crash
useSketch=true;sketchScale=tile.getScaleForEdgeSmoothing();sketchTranslate=tile.getTranslationForEdgeSmoothing(sketchScale,tiledImage._drawer.getCanvasSize(false),tiledImage._drawer.getCanvasSize(true));}var bounds;if(useSketch){if(!sketchScale){// Except when edge smoothing, we only clean the part of the
// sketch canvas we are going to use for performance reasons.
bounds=tiledImage.viewport.viewportToViewerElementRectangle(tiledImage.getClippedBounds(true)).getIntegerBoundingBox();if(tiledImage._drawer.viewer.viewport.getFlip()){if(tiledImage.viewport.degrees!==0||tiledImage.getRotation(true)%360!==0){bounds.x=tiledImage._drawer.viewer.container.clientWidth-(bounds.x+bounds.width);}}bounds=bounds.times($.pixelDensityRatio);}tiledImage._drawer._clear(true,bounds);}// When scaling, we must rotate only when blending the sketch canvas to
// avoid interpolation
if(!sketchScale){if(tiledImage.viewport.degrees!==0){tiledImage._drawer._offsetForRotation({degrees:tiledImage.viewport.degrees,useSketch:useSketch});}if(tiledImage.getRotation(true)%360!==0){tiledImage._drawer._offsetForRotation({degrees:tiledImage.getRotation(true),point:tiledImage.viewport.pixelFromPointNoRotate(tiledImage._getRotationPoint(true),true),useSketch:useSketch});}if(tiledImage.viewport.degrees===0&&tiledImage.getRotation(true)%360===0){if(tiledImage._drawer.viewer.viewport.getFlip()){tiledImage._drawer._flip();}}}var usedClip=false;if(tiledImage._clip){tiledImage._drawer.saveContext(useSketch);var box=tiledImage.imageToViewportRectangle(tiledImage._clip,true);box=box.rotate(-tiledImage.getRotation(true),tiledImage._getRotationPoint(true));var clipRect=tiledImage._drawer.viewportToDrawerRectangle(box);if(sketchScale){clipRect=clipRect.times(sketchScale);}if(sketchTranslate){clipRect=clipRect.translate(sketchTranslate);}tiledImage._drawer.setClip(clipRect,useSketch);usedClip=true;}if(tiledImage._croppingPolygons){tiledImage._drawer.saveContext(useSketch);try{var polygons=tiledImage._croppingPolygons.map(function(polygon){return polygon.map(function(coord){var point=tiledImage.imageToViewportCoordinates(coord.x,coord.y,true).rotate(-tiledImage.getRotation(true),tiledImage._getRotationPoint(true));var clipPoint=tiledImage._drawer.viewportCoordToDrawerCoord(point);if(sketchScale){clipPoint=clipPoint.times(sketchScale);}return clipPoint;});});tiledImage._drawer.clipWithPolygons(polygons,useSketch);}catch(e){$.console.error(e);}usedClip=true;}if(tiledImage.placeholderFillStyle&&tiledImage._hasOpaqueTile===false){var placeholderRect=tiledImage._drawer.viewportToDrawerRectangle(tiledImage.getBounds(true));if(sketchScale){placeholderRect=placeholderRect.times(sketchScale);}if(sketchTranslate){placeholderRect=placeholderRect.translate(sketchTranslate);}var fillStyle=null;if(typeof tiledImage.placeholderFillStyle==="function"){fillStyle=tiledImage.placeholderFillStyle(tiledImage,tiledImage._drawer.context);}else{fillStyle=tiledImage.placeholderFillStyle;}tiledImage._drawer.drawRectangle(placeholderRect,fillStyle,useSketch);}for(var i=lastDrawn.length-1;i>=0;i--){tile=lastDrawn[i];tiledImage._drawer.drawTile(tile,tiledImage._drawingHandler,useSketch,sketchScale,sketchTranslate);tile.beingDrawn=true;if(tiledImage.viewer){/**
             * <em>- Needs documentation -</em>
             *
             * @event tile-drawn
             * @memberof OpenSeadragon.Viewer
             * @type {object}
             * @property {OpenSeadragon.Viewer} eventSource - A reference to the Viewer which raised the event.
             * @property {OpenSeadragon.TiledImage} tiledImage - Which TiledImage is being drawn.
             * @property {OpenSeadragon.Tile} tile
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */tiledImage.viewer.raiseEvent('tile-drawn',{tiledImage:tiledImage,tile:tile});}}if(usedClip){tiledImage._drawer.restoreContext(useSketch);}if(!sketchScale){if(tiledImage.getRotation(true)%360!==0){tiledImage._drawer._restoreRotationChanges(useSketch);}if(tiledImage.viewport.degrees!==0){tiledImage._drawer._restoreRotationChanges(useSketch);}}if(useSketch){if(sketchScale){if(tiledImage.viewport.degrees!==0){tiledImage._drawer._offsetForRotation({degrees:tiledImage.viewport.degrees,useSketch:false});}if(tiledImage.getRotation(true)%360!==0){tiledImage._drawer._offsetForRotation({degrees:tiledImage.getRotation(true),point:tiledImage.viewport.pixelFromPointNoRotate(tiledImage._getRotationPoint(true),true),useSketch:false});}}tiledImage._drawer.blendSketch({opacity:tiledImage.opacity,scale:sketchScale,translate:sketchTranslate,compositeOperation:tiledImage.compositeOperation,bounds:bounds});if(sketchScale){if(tiledImage.getRotation(true)%360!==0){tiledImage._drawer._restoreRotationChanges(false);}if(tiledImage.viewport.degrees!==0){tiledImage._drawer._restoreRotationChanges(false);}}}if(!sketchScale){if(tiledImage.viewport.degrees===0&&tiledImage.getRotation(true)%360===0){if(tiledImage._drawer.viewer.viewport.getFlip()){tiledImage._drawer._flip();}}}drawDebugInfo(tiledImage,lastDrawn);}/**
 * @private
 * @inner
 * Draws special debug information for a TiledImage if in debug mode.
 * @param {OpenSeadragon.TiledImage} tiledImage
 * @param {OpenSeadragon.Tile[]} lastDrawn - An unordered list of Tiles drawn last frame.
 */function drawDebugInfo(tiledImage,lastDrawn){if(tiledImage.debugMode){for(var i=lastDrawn.length-1;i>=0;i--){var tile=lastDrawn[i];try{tiledImage._drawer.drawDebugInfo(tile,lastDrawn.length,i,tiledImage);}catch(e){$.console.error(e);}}}}})(OpenSeadragon);/*
 * OpenSeadragon - TileCache
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){// private class
var TileRecord=function(options){$.console.assert(options,"[TileCache.cacheTile] options is required");$.console.assert(options.tile,"[TileCache.cacheTile] options.tile is required");$.console.assert(options.tiledImage,"[TileCache.cacheTile] options.tiledImage is required");this.tile=options.tile;this.tiledImage=options.tiledImage;};// private class
var ImageRecord=function(options){$.console.assert(options,"[ImageRecord] options is required");$.console.assert(options.image,"[ImageRecord] options.image is required");this._image=options.image;this._tiles=[];};ImageRecord.prototype={destroy:function(){this._image=null;this._renderedContext=null;this._tiles=null;},getImage:function(){return this._image;},getRenderedContext:function(){if(!this._renderedContext){var canvas=document.createElement('canvas');canvas.width=this._image.width;canvas.height=this._image.height;this._renderedContext=canvas.getContext('2d');this._renderedContext.drawImage(this._image,0,0);//since we are caching the prerendered image on a canvas
//allow the image to not be held in memory
this._image=null;}return this._renderedContext;},setRenderedContext:function(renderedContext){$.console.error("ImageRecord.setRenderedContext is deprecated. "+"The rendered context should be created by the ImageRecord "+"itself when calling ImageRecord.getRenderedContext.");this._renderedContext=renderedContext;},addTile:function(tile){$.console.assert(tile,'[ImageRecord.addTile] tile is required');this._tiles.push(tile);},removeTile:function(tile){for(var i=0;i<this._tiles.length;i++){if(this._tiles[i]===tile){this._tiles.splice(i,1);return;}}$.console.warn('[ImageRecord.removeTile] trying to remove unknown tile',tile);},getTileCount:function(){return this._tiles.length;}};/**
 * @class TileCache
 * @memberof OpenSeadragon
 * @classdesc Stores all the tiles displayed in a {@link OpenSeadragon.Viewer}.
 * You generally won't have to interact with the TileCache directly.
 * @param {Object} options - Configuration for this TileCache.
 * @param {Number} [options.maxImageCacheCount] - See maxImageCacheCount in
 * {@link OpenSeadragon.Options} for details.
 */$.TileCache=function(options){options=options||{};this._maxImageCacheCount=options.maxImageCacheCount||$.DEFAULT_SETTINGS.maxImageCacheCount;this._tilesLoaded=[];this._imagesLoaded=[];this._imagesLoadedCount=0;};/** @lends OpenSeadragon.TileCache.prototype */$.TileCache.prototype={/**
     * @returns {Number} The total number of tiles that have been loaded by
     * this TileCache.
     */numTilesLoaded:function(){return this._tilesLoaded.length;},/**
     * Caches the specified tile, removing an old tile if necessary to stay under the
     * maxImageCacheCount specified on construction. Note that if multiple tiles reference
     * the same image, there may be more tiles than maxImageCacheCount; the goal is to keep
     * the number of images below that number. Note, as well, that even the number of images
     * may temporarily surpass that number, but should eventually come back down to the max specified.
     * @param {Object} options - Tile info.
     * @param {OpenSeadragon.Tile} options.tile - The tile to cache.
     * @param {String} options.tile.cacheKey - The unique key used to identify this tile in the cache.
     * @param {Image} options.image - The image of the tile to cache.
     * @param {OpenSeadragon.TiledImage} options.tiledImage - The TiledImage that owns that tile.
     * @param {Number} [options.cutoff=0] - If adding this tile goes over the cache max count, this
     * function will release an old tile. The cutoff option specifies a tile level at or below which
     * tiles will not be released.
     */cacheTile:function(options){$.console.assert(options,"[TileCache.cacheTile] options is required");$.console.assert(options.tile,"[TileCache.cacheTile] options.tile is required");$.console.assert(options.tile.cacheKey,"[TileCache.cacheTile] options.tile.cacheKey is required");$.console.assert(options.tiledImage,"[TileCache.cacheTile] options.tiledImage is required");var cutoff=options.cutoff||0;var insertionIndex=this._tilesLoaded.length;var imageRecord=this._imagesLoaded[options.tile.cacheKey];if(!imageRecord){$.console.assert(options.image,"[TileCache.cacheTile] options.image is required to create an ImageRecord");imageRecord=this._imagesLoaded[options.tile.cacheKey]=new ImageRecord({image:options.image});this._imagesLoadedCount++;}imageRecord.addTile(options.tile);options.tile.cacheImageRecord=imageRecord;// Note that just because we're unloading a tile doesn't necessarily mean
// we're unloading an image. With repeated calls it should sort itself out, though.
if(this._imagesLoadedCount>this._maxImageCacheCount){var worstTile=null;var worstTileIndex=-1;var worstTileRecord=null;var prevTile,worstTime,worstLevel,prevTime,prevLevel,prevTileRecord;for(var i=this._tilesLoaded.length-1;i>=0;i--){prevTileRecord=this._tilesLoaded[i];prevTile=prevTileRecord.tile;if(prevTile.level<=cutoff||prevTile.beingDrawn){continue;}else if(!worstTile){worstTile=prevTile;worstTileIndex=i;worstTileRecord=prevTileRecord;continue;}prevTime=prevTile.lastTouchTime;worstTime=worstTile.lastTouchTime;prevLevel=prevTile.level;worstLevel=worstTile.level;if(prevTime<worstTime||prevTime==worstTime&&prevLevel>worstLevel){worstTile=prevTile;worstTileIndex=i;worstTileRecord=prevTileRecord;}}if(worstTile&&worstTileIndex>=0){this._unloadTile(worstTileRecord);insertionIndex=worstTileIndex;}}this._tilesLoaded[insertionIndex]=new TileRecord({tile:options.tile,tiledImage:options.tiledImage});},/**
     * Clears all tiles associated with the specified tiledImage.
     * @param {OpenSeadragon.TiledImage} tiledImage
     */clearTilesFor:function(tiledImage){$.console.assert(tiledImage,'[TileCache.clearTilesFor] tiledImage is required');var tileRecord;for(var i=0;i<this._tilesLoaded.length;++i){tileRecord=this._tilesLoaded[i];if(tileRecord.tiledImage===tiledImage){this._unloadTile(tileRecord);this._tilesLoaded.splice(i,1);i--;}}},// private
getImageRecord:function(cacheKey){$.console.assert(cacheKey,'[TileCache.getImageRecord] cacheKey is required');return this._imagesLoaded[cacheKey];},// private
_unloadTile:function(tileRecord){$.console.assert(tileRecord,'[TileCache._unloadTile] tileRecord is required');var tile=tileRecord.tile;var tiledImage=tileRecord.tiledImage;tile.unload();tile.cacheImageRecord=null;var imageRecord=this._imagesLoaded[tile.cacheKey];imageRecord.removeTile(tile);if(!imageRecord.getTileCount()){imageRecord.destroy();delete this._imagesLoaded[tile.cacheKey];this._imagesLoadedCount--;}/**
         * Triggered when a tile has just been unloaded from memory.
         *
         * @event tile-unloaded
         * @memberof OpenSeadragon.Viewer
         * @type {object}
         * @property {OpenSeadragon.TiledImage} tiledImage - The tiled image of the unloaded tile.
         * @property {OpenSeadragon.Tile} tile - The tile which has been unloaded.
         */tiledImage.viewer.raiseEvent("tile-unloaded",{tile:tile,tiledImage:tiledImage});}};})(OpenSeadragon);/*
 * OpenSeadragon - World
 *
 * Copyright (C) 2009 CodePlex Foundation
 * Copyright (C) 2010-2013 OpenSeadragon contributors
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 * - Redistributions of source code must retain the above copyright notice,
 *   this list of conditions and the following disclaimer.
 *
 * - Redistributions in binary form must reproduce the above copyright
 *   notice, this list of conditions and the following disclaimer in the
 *   documentation and/or other materials provided with the distribution.
 *
 * - Neither the name of CodePlex Foundation nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 * TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */(function($){/**
 * @class World
 * @memberof OpenSeadragon
 * @extends OpenSeadragon.EventSource
 * @classdesc Keeps track of all of the tiled images in the scene.
 * @param {Object} options - World options.
 * @param {OpenSeadragon.Viewer} options.viewer - The Viewer that owns this World.
 **/$.World=function(options){var _this=this;$.console.assert(options.viewer,"[World] options.viewer is required");$.EventSource.call(this);this.viewer=options.viewer;this._items=[];this._needsDraw=false;this._autoRefigureSizes=true;this._needsSizesFigured=false;this._delegatedFigureSizes=function(event){if(_this._autoRefigureSizes){_this._figureSizes();}else{_this._needsSizesFigured=true;}};this._figureSizes();};$.extend($.World.prototype,$.EventSource.prototype,/** @lends OpenSeadragon.World.prototype */{/**
     * Add the specified item.
     * @param {OpenSeadragon.TiledImage} item - The item to add.
     * @param {Number} [options.index] - Index for the item. If not specified, goes at the top.
     * @fires OpenSeadragon.World.event:add-item
     * @fires OpenSeadragon.World.event:metrics-change
     */addItem:function(item,options){$.console.assert(item,"[World.addItem] item is required");$.console.assert(item instanceof $.TiledImage,"[World.addItem] only TiledImages supported at this time");options=options||{};if(options.index!==undefined){var index=Math.max(0,Math.min(this._items.length,options.index));this._items.splice(index,0,item);}else{this._items.push(item);}if(this._autoRefigureSizes){this._figureSizes();}else{this._needsSizesFigured=true;}this._needsDraw=true;item.addHandler('bounds-change',this._delegatedFigureSizes);item.addHandler('clip-change',this._delegatedFigureSizes);/**
         * Raised when an item is added to the World.
         * @event add-item
         * @memberOf OpenSeadragon.World
         * @type {object}
         * @property {OpenSeadragon.Viewer} eventSource - A reference to the World which raised the event.
         * @property {OpenSeadragon.TiledImage} item - The item that has been added.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('add-item',{item:item});},/**
     * Get the item at the specified index.
     * @param {Number} index - The item's index.
     * @returns {OpenSeadragon.TiledImage} The item at the specified index.
     */getItemAt:function(index){$.console.assert(index!==undefined,"[World.getItemAt] index is required");return this._items[index];},/**
     * Get the index of the given item or -1 if not present.
     * @param {OpenSeadragon.TiledImage} item - The item.
     * @returns {Number} The index of the item or -1 if not present.
     */getIndexOfItem:function(item){$.console.assert(item,"[World.getIndexOfItem] item is required");return $.indexOf(this._items,item);},/**
     * @returns {Number} The number of items used.
     */getItemCount:function(){return this._items.length;},/**
     * Change the index of a item so that it appears over or under others.
     * @param {OpenSeadragon.TiledImage} item - The item to move.
     * @param {Number} index - The new index.
     * @fires OpenSeadragon.World.event:item-index-change
     */setItemIndex:function(item,index){$.console.assert(item,"[World.setItemIndex] item is required");$.console.assert(index!==undefined,"[World.setItemIndex] index is required");var oldIndex=this.getIndexOfItem(item);if(index>=this._items.length){throw new Error("Index bigger than number of layers.");}if(index===oldIndex||oldIndex===-1){return;}this._items.splice(oldIndex,1);this._items.splice(index,0,item);this._needsDraw=true;/**
         * Raised when the order of the indexes has been changed.
         * @event item-index-change
         * @memberOf OpenSeadragon.World
         * @type {object}
         * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
         * @property {OpenSeadragon.TiledImage} item - The item whose index has
         * been changed
         * @property {Number} previousIndex - The previous index of the item
         * @property {Number} newIndex - The new index of the item
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('item-index-change',{item:item,previousIndex:oldIndex,newIndex:index});},/**
     * Remove an item.
     * @param {OpenSeadragon.TiledImage} item - The item to remove.
     * @fires OpenSeadragon.World.event:remove-item
     * @fires OpenSeadragon.World.event:metrics-change
     */removeItem:function(item){$.console.assert(item,"[World.removeItem] item is required");var index=$.indexOf(this._items,item);if(index===-1){return;}item.removeHandler('bounds-change',this._delegatedFigureSizes);item.removeHandler('clip-change',this._delegatedFigureSizes);item.destroy();this._items.splice(index,1);this._figureSizes();this._needsDraw=true;this._raiseRemoveItem(item);},/**
     * Remove all items.
     * @fires OpenSeadragon.World.event:remove-item
     * @fires OpenSeadragon.World.event:metrics-change
     */removeAll:function(){// We need to make sure any pending images are canceled so the world items don't get messed up
this.viewer._cancelPendingImages();var item;var i;for(i=0;i<this._items.length;i++){item=this._items[i];item.removeHandler('bounds-change',this._delegatedFigureSizes);item.removeHandler('clip-change',this._delegatedFigureSizes);item.destroy();}var removedItems=this._items;this._items=[];this._figureSizes();this._needsDraw=true;for(i=0;i<removedItems.length;i++){item=removedItems[i];this._raiseRemoveItem(item);}},/**
     * Clears all tiles and triggers updates for all items.
     */resetItems:function(){for(var i=0;i<this._items.length;i++){this._items[i].reset();}},/**
     * Updates (i.e. animates bounds of) all items.
     */update:function(){var animated=false;for(var i=0;i<this._items.length;i++){animated=this._items[i].update()||animated;}return animated;},/**
     * Draws all items.
     */draw:function(){for(var i=0;i<this._items.length;i++){this._items[i].draw();}this._needsDraw=false;},/**
     * @returns {Boolean} true if any items need updating.
     */needsDraw:function(){for(var i=0;i<this._items.length;i++){if(this._items[i].needsDraw()){return true;}}return this._needsDraw;},/**
     * @returns {OpenSeadragon.Rect} The smallest rectangle that encloses all items, in viewport coordinates.
     */getHomeBounds:function(){return this._homeBounds.clone();},/**
     * To facilitate zoom constraints, we keep track of the pixel density of the
     * densest item in the World (i.e. the item whose content size to viewport size
     * ratio is the highest) and save it as this "content factor".
     * @returns {Number} the number of content units per viewport unit.
     */getContentFactor:function(){return this._contentFactor;},/**
     * As a performance optimization, setting this flag to false allows the bounds-change event handler
     * on tiledImages to skip calculations on the world bounds. If a lot of images are going to be positioned in
     * rapid succession, this is a good idea. When finished, setAutoRefigureSizes should be called with true
     * or the system may behave oddly.
     * @param {Boolean} [value] The value to which to set the flag.
     */setAutoRefigureSizes:function(value){this._autoRefigureSizes=value;if(value&this._needsSizesFigured){this._figureSizes();this._needsSizesFigured=false;}},/**
     * Arranges all of the TiledImages with the specified settings.
     * @param {Object} options - Specifies how to arrange.
     * @param {Boolean} [options.immediately=false] - Whether to animate to the new arrangement.
     * @param {String} [options.layout] - See collectionLayout in {@link OpenSeadragon.Options}.
     * @param {Number} [options.rows] - See collectionRows in {@link OpenSeadragon.Options}.
     * @param {Number} [options.columns] - See collectionColumns in {@link OpenSeadragon.Options}.
     * @param {Number} [options.tileSize] - See collectionTileSize in {@link OpenSeadragon.Options}.
     * @param {Number} [options.tileMargin] - See collectionTileMargin in {@link OpenSeadragon.Options}.
     * @fires OpenSeadragon.World.event:metrics-change
     */arrange:function(options){options=options||{};var immediately=options.immediately||false;var layout=options.layout||$.DEFAULT_SETTINGS.collectionLayout;var rows=options.rows||$.DEFAULT_SETTINGS.collectionRows;var columns=options.columns||$.DEFAULT_SETTINGS.collectionColumns;var tileSize=options.tileSize||$.DEFAULT_SETTINGS.collectionTileSize;var tileMargin=options.tileMargin||$.DEFAULT_SETTINGS.collectionTileMargin;var increment=tileSize+tileMargin;var wrap;if(!options.rows&&columns){wrap=columns;}else{wrap=Math.ceil(this._items.length/rows);}var x=0;var y=0;var item,box,width,height,position;this.setAutoRefigureSizes(false);for(var i=0;i<this._items.length;i++){if(i&&i%wrap===0){if(layout==='horizontal'){y+=increment;x=0;}else{x+=increment;y=0;}}item=this._items[i];box=item.getBounds();if(box.width>box.height){width=tileSize;}else{width=tileSize*(box.width/box.height);}height=width*(box.height/box.width);position=new $.Point(x+(tileSize-width)/2,y+(tileSize-height)/2);item.setPosition(position,immediately);item.setWidth(width,immediately);if(layout==='horizontal'){x+=increment;}else{y+=increment;}}this.setAutoRefigureSizes(true);},// private
_figureSizes:function(){var oldHomeBounds=this._homeBounds?this._homeBounds.clone():null;var oldContentSize=this._contentSize?this._contentSize.clone():null;var oldContentFactor=this._contentFactor||0;if(!this._items.length){this._homeBounds=new $.Rect(0,0,1,1);this._contentSize=new $.Point(1,1);this._contentFactor=1;}else{var item=this._items[0];var bounds=item.getBounds();this._contentFactor=item.getContentSize().x/bounds.width;var clippedBounds=item.getClippedBounds().getBoundingBox();var left=clippedBounds.x;var top=clippedBounds.y;var right=clippedBounds.x+clippedBounds.width;var bottom=clippedBounds.y+clippedBounds.height;for(var i=1;i<this._items.length;i++){item=this._items[i];bounds=item.getBounds();this._contentFactor=Math.max(this._contentFactor,item.getContentSize().x/bounds.width);clippedBounds=item.getClippedBounds().getBoundingBox();left=Math.min(left,clippedBounds.x);top=Math.min(top,clippedBounds.y);right=Math.max(right,clippedBounds.x+clippedBounds.width);bottom=Math.max(bottom,clippedBounds.y+clippedBounds.height);}this._homeBounds=new $.Rect(left,top,right-left,bottom-top);this._contentSize=new $.Point(this._homeBounds.width*this._contentFactor,this._homeBounds.height*this._contentFactor);}if(this._contentFactor!==oldContentFactor||!this._homeBounds.equals(oldHomeBounds)||!this._contentSize.equals(oldContentSize)){/**
             * Raised when the home bounds or content factor change.
             * @event metrics-change
             * @memberOf OpenSeadragon.World
             * @type {object}
             * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
             * @property {?Object} userData - Arbitrary subscriber-defined object.
             */this.raiseEvent('metrics-change',{});}},// private
_raiseRemoveItem:function(item){/**
         * Raised when an item is removed.
         * @event remove-item
         * @memberOf OpenSeadragon.World
         * @type {object}
         * @property {OpenSeadragon.World} eventSource - A reference to the World which raised the event.
         * @property {OpenSeadragon.TiledImage} item - The item's underlying item.
         * @property {?Object} userData - Arbitrary subscriber-defined object.
         */this.raiseEvent('remove-item',{item:item});}});})(OpenSeadragon);

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGDPRBanner = void 0;
exports.default = _default;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const createGDPRBanner = el => {
  const removeWidget = () => {
    el.remove();
  };

  // the BE has decided to check for the cookie to display
  // if (Cookies.get("widgetCookie" + el.getAttribute("id")) !== undefined) {
  // } else {
  //   // removeWidget();
  // }

  // accept button handler
  el.querySelector(".js-accept-btn").addEventListener("click", e => {
    e.preventDefault();
    const widgetID = el.getAttribute("id");
    _jsCookie.default.set("widgetCookie" + widgetID, widgetID, {
      expires: 365
    });
    removeWidget();
  });
};
exports.createGDPRBanner = createGDPRBanner;
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-gv__gdpr-banner")].forEach(createGDPRBanner);
}

},{"js-cookie":"js-cookie"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = copyAccordion;
function copyAccordion() {
  const copyAccordionBtn = document.querySelectorAll('.js-copy-accordion-text');
  if (!copyAccordionBtn) {
    return;
  }
  copyAccordionBtn.forEach(item => {
    item.addEventListener("click", e => {
      e.stopPropagation();
      e.preventDefault();
      const copyElement = item.closest(".js-accordion").querySelector(".js-accordion-content");
      let range;
      let selection;
      if (!copyElement) {
        console.error("No element to copy");
        return;
      }
      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        // correct method for text range
        range.moveToElementText(copyElement);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        // ensuring textElement is passed correctly
        range.selectNodeContents(copyElement);
        selection.removeAllRanges();
        selection.addRange(range);
      }
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Unable to copy text: ", err);
      } finally {
        if (selection) {
          item.classList.add('copied-element');
          selection.removeAllRanges();
        }
      }
    });
    item.addEventListener("mouseleave", () => {
      setTimeout(() => {
        item.classList.remove('copied-element');
      }, "500");
    });
  });
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
const initAccordionList = (el, i) => {
  // let idArray = [];
  const triggerButtons = el.querySelectorAll(".js-accordion-link");
  triggerButtons.forEach((triggerButton, i) => {
    initAccordion(triggerButton, i);
    triggerButton.addEventListener("keydown", e => {
      let index = i;
      switch (e.key) {
        case "Home":
          triggerButtons[0].focus();
          break;
        case "End":
          triggerButtons[triggerButtons.length - 1].focus();
          break;
        case "Up":
        case "ArrowUp":
          if (i === 0) {
            index = triggerButtons.length - 1;
          } else {
            index--;
          }
          triggerButtons[index].focus();
          break;
        case "Down":
        case "ArrowDown":
          if (i === triggerButtons.length - 1) {
            index = 0;
          } else {
            index++;
          }
          triggerButtons[index].focus();
          break;
        default:
      }
    });
  });
};
const initAccordion = (triggerButton, index, idArray) => {
  const editorView = document.querySelector("body.experience-editor");
  const isLessonPage = document.querySelector(".gv__base-template--lesson-3");

  // The grandparent element contains the unique ID needed for updating the anchor / hash.
  const triggerButtonGrandparent = triggerButton.parentElement.parentElement;
  const triggerButtonGrandparentID = "#" + triggerButtonGrandparent.id;
  const contentWrapper = triggerButtonGrandparent.querySelector(".js-accordion-content-wrapper");
  const content = triggerButtonGrandparent.querySelector(".js-accordion-content");
  const copyButton = triggerButtonGrandparent.querySelector(".js-copy-accordion-text");
  let expanded = false;
  let contentBuffer = setTimeout(() => {}, 1);
  triggerButtonGrandparent.setAttribute("id", `accordion-link-${index}`);
  triggerButtonGrandparent.setAttribute("aria-controls", `accordion-content-${index}`);
  contentWrapper.setAttribute("id", `accordion-content-${index}`);
  contentWrapper.setAttribute("aria-labelledby", `accordion-link-${index}`);

  // Open the accordion panel when any of the following conditions are met:
  // In the experience editor
  // No anchor / hash in URL - force open the first accordion panel
  // Anchor / hash exists in URL and it matches the ID of the current accordion panel
  if (!isLessonPage && (editorView || !window.location.hash && index === 0 || window.location.hash === triggerButtonGrandparentID)) {
    expanded = true;
    toggleContent(expanded);
  }
  if (!editorView) {
    triggerButtonGrandparent.addEventListener("click", e => {
      e.preventDefault();
      expanded = !expanded;
      toggleContent(expanded);
    });
  }
  function toggleContent(expanded) {
    const height = content.scrollHeight;
    triggerButtonGrandparent.setAttribute("aria-expanded", expanded);
    clearTimeout(contentBuffer);
    if (expanded) {
      copyButton?.removeAttribute("disabled");
      triggerButtonGrandparent.classList.add("is-open");
      contentWrapper.setAttribute("style", `height: ${height}px`);
      if (!isLessonPage) {
        contentBuffer = setTimeout(() => {
          index !== 0 && triggerButtonGrandparent.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
          contentWrapper.setAttribute("style", "height: auto");
        }, 100);
        window.location.hash = triggerButtonGrandparentID;
      }
      // idArray.push(triggerButtonGrandparentID);
    } else {
      copyButton?.setAttribute("disabled", "true");
      triggerButtonGrandparent.classList.remove("is-open");
      contentWrapper.setAttribute("style", `height: ${height}px`);

      // idArray = idArray.filter(element => element !== triggerButtonGrandparentID);

      // if (!idArray.length) {
      // Completely remove hash / anchor value from URL.
      // history.pushState("", document.title, window.location.pathname + window.location.search);
      // }
      // else {
      //   // Find the previous ID from the array,
      //   // and set it as the hash / anchor value in the URL.
      //   const previousId = idArray.at(-1);
      //   window.location.hash = previousId;
      // }

      setTimeout(() => {
        contentWrapper.setAttribute("style", "height: 0");
      }, 20);
    }
  }
};
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-accordion-list")].forEach(accordionList => {
    if (accordionList.classList.contains("gv__unit-resources")) {
      return;
    } else {
      initAccordionList(accordionList);
    }
  });
}

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _textInput = _interopRequireDefault(require("../partials/text-input.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _validation = require("../validation.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class AddCoTeacher extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const buttons = document.querySelectorAll(".js-add-co-teacher__btn");
      if (buttons) {
        buttons.forEach(button => button.addEventListener("click", this.openModal));
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      if (this.state.modalIsOpen === false) {
        const buttons = document.querySelectorAll(".js-add-co-teacher__btn");
        if (buttons) {
          buttons.forEach(button => button.setAttribute("aria-expanded", false));
        }
      }
    });
    _defineProperty(this, "onFormSubmit", e => {
      e.preventDefault();
      const {
        newEmailInput
      } = this.state;
      const blankError = this.props.dictionary.coTeacherErrorBlank;
      const input = document.querySelectorAll(".gv__co-teacher-modal .gv__text-input__field")[0];
      if (!newEmailInput.error) {
        if (!(0, _validation.validateField)("email", newEmailInput.value)) {
          newEmailInput.error = true;
          newEmailInput.errorMsg = blankError;
          this.setState({
            newEmailInput
          });
          input.focus();
        } else {
          this.createCoTeacher();
        }
      } else {
        input.focus();
      }
    });
    _defineProperty(this, "createCoTeacher", () => {
      const params = {
        teacherEmail: this.state.newEmailInput.value,
        periodId: this.props.periodId
      };
      this.setState({
        isLoading: true
      });
      fetch(`${this.props.requestUrl}/owh/teacher/AddCoTeacherToPeriod`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data && data.IsValid) {
          location.reload();
        } else {
          const {
            newEmailInput
          } = this.state;
          newEmailInput.error = true;
          newEmailInput.errorMsg = data.Errors[0];
          this.setState({
            newEmailInput,
            isLoading: false
          });
        }
      }).catch(error => {
        const {
          newEmailInput
        } = this.state;
        newEmailInput.error = true;
        newEmailInput.errorMsg = error;
        this.setState({
          newEmailInput,
          isLoading: false
        });
      });
    });
    _defineProperty(this, "openModal", e => {
      this.setState({
        modalIsOpen: true
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      const {
        newEmailInput
      } = this.state;
      newEmailInput.value = "";
      newEmailInput.error = false;
      newEmailInput.errorMsg = "";
      this.setState({
        modalIsOpen: false,
        newEmailInput
      });
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
    });
    _defineProperty(this, "handleNewTeacherInput", event => {
      let {
        newEmailInput,
        isLoading
      } = this.state;
      const value = event.target.value;
      const length = value.length;
      const blankError = this.props.dictionary.coTeacherErrorBlank;
      const invalidError = this.props.dictionary.coTeacherInvalidError;
      newEmailInput.value = value;
      newEmailInput.error = !(0, _validation.validateField)("email", value);
      if (length === 0) {
        newEmailInput.errorMsg = blankError;
        isLoading = true;
      } else if (newEmailInput.error) {
        newEmailInput.errorMsg = invalidError;
        isLoading = true;
      } else {
        isLoading = false;
      }
      this.setState({
        newEmailInput,
        isLoading
      });
    });
    this.state = {
      modalIsOpen: props.modalIsOpen || false,
      isLoading: true,
      newEmailInput: {
        value: "",
        error: false,
        errorMsg: ""
      }
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      newEmailInput,
      isLoading
    } = this.state;
    const {
      dictionary
    } = this.props;
    const {
      coTeacherEmailLabel,
      coTeacherLinkButtonLabel,
      coTeacherSubtitle,
      coTeacherTitle
    } = dictionary;
    const submitButtonClass = (0, _classnames.default)("gv__button", {
      "gv__button is-loading": isLoading
    });
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__co-teacher-modal"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      tabIndex: "-1",
      ref: this.modalTitleRef,
      className: "gv__co-teacher-modal__title gv__page-title"
    }, coTeacherTitle), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__co-teacher-modal__subtitle"
    }, coTeacherSubtitle), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this.onFormSubmit
    }, /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, newEmailInput, {
      onChange: this.handleNewTeacherInput,
      label: coTeacherEmailLabel,
      type: "email",
      requiredField: true,
      errorMsg: newEmailInput.errorMsg
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__co-teacher-modal__button-row gv__button-row"
    }, /*#__PURE__*/_react.default.createElement("button", {
      // disabled={isLoading}
      type: "submit",
      className: submitButtonClass
    }, coTeacherLinkButtonLabel)))));
  }
}
exports.default = AddCoTeacher;
_defineProperty(AddCoTeacher, "propTypes", {
  periodId: _propTypes.string,
  requestUrl: _propTypes.string,
  dictionary: _propTypes.object,
  modalIsOpen: _propTypes.bool
});

},{"../partials/text-input.jsx":156,"../validation.js":262,"classnames":"classnames","prop-types":"prop-types","react":"react","react-modal":"react-modal"}],6:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var R = _interopRequireWildcard(require("ramda"));
var _AddCoTeacher = _interopRequireDefault(require("./AddCoTeacher.jsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-co-teacher-mount");
if (el) {
  const props = {
    requestUrl: el.dataset.requestUrl || "",
    periodId: el.dataset.periodId || "",
    dictionary: JSON.parse(el.dataset.dictionary) || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_AddCoTeacher.default, props), el);
}

},{"./AddCoTeacher.jsx":5,"ramda":"ramda","react":"react","react-dom":"react-dom"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ArchivePeriod extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const buttons = document.querySelectorAll(".js-archive-period__btn");
      if (buttons && this.props.inheritCloseModal === undefined) {
        buttons.forEach(button => {
          button.addEventListener("click", this.openModal);
        });
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      const buttons = document.querySelectorAll(".js-archive-period__btn");
      if (buttons && this.props.inheritCloseModal === undefined) {
        buttons.forEach(button => button.setAttribute("aria-expanded", false));
      }
    });
    _defineProperty(this, "deletePeriod", e => {
      e.preventDefault();
      const params = {
        periodId: this.props.periodId
      };
      fetch(`${this.props.requestUrl}/owh/period/DeletePeriod`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.IsValid) {
          location.assign(data.RedirectUrl);
        } else {
          let {
            generalError
          } = this.state;
          generalError.error = true;
          generalError.errorMsg = data.Errors[0];
          this.setState({
            generalError
          });
        }
      }).catch(error => {
        console.log(error);
      });
    });
    _defineProperty(this, "openModal", e => {
      if (this.props.inheritOpenModal) {
        this.props.inheritOpenModal();
      } else {
        this.setState({
          modalIsOpen: true
        });
        e.target.setAttribute("aria-expanded", true);
      }
    });
    _defineProperty(this, "closeModal", () => {
      if (this.props.inheritCloseModal) {
        this.props.inheritCloseModal();
      } else {
        if (this.props.updateParent) {
          this.props.updateParent();
        }
        this.setState({
          modalIsOpen: false
        });
      }
    });
    _defineProperty(this, "afterOpenModal", () => {
      document.querySelectorAll(".gv__modal__close")[0].focus();
    });
    this.state = {
      modalIsOpen: props.modalIsOpen || false,
      isLoading: false,
      generalError: {
        error: false,
        errorMsg: ""
      }
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      dictionary
    } = this.props;
    const {
      generalError
    } = this.state;
    const {
      archivePeriodTitle,
      archivePeriodSubtitle,
      archivePeriodCancelLabel,
      archivePeriodButtonLabel
    } = dictionary;
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__delete-modal"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      ref: this.modalTitleRef,
      tabIndex: "-1",
      className: "gv__delete-modal__title gv__page-title"
    }, archivePeriodTitle), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__delete-modal__subtitle",
      dangerouslySetInnerHTML: {
        __html: archivePeriodSubtitle
      }
    }), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: e => this.deletePeriod(e)
    }, generalError.error && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__form__error-msg gv__form__error-msg--general has-error"
    }, generalError.errorMsg), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__delete-modal__button-row gv__button-row"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__button gv__button--secondary"
    }, archivePeriodCancelLabel), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "gv__button"
    }, archivePeriodButtonLabel)))));
  }
}
exports.default = ArchivePeriod;
_defineProperty(ArchivePeriod, "propTypes", {
  periodId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  requestUrl: _propTypes.string,
  dictionary: (0, _propTypes.shape)({
    archivePeriodTitle: _propTypes.string,
    archivePeriodSubtitle: _propTypes.string,
    archivePeriodCancelLabel: _propTypes.string,
    archivePeriodButtonLabel: _propTypes.string
  }),
  inheritCloseModal: _propTypes.func,
  inheritOpenModal: _propTypes.func,
  modalIsOpen: _propTypes.bool,
  updateParent: _propTypes.func
});

},{"prop-types":"prop-types","react":"react","react-modal":"react-modal"}],8:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _ArchivePeriodModal = _interopRequireDefault(require("./ArchivePeriodModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-archive-period-mount");
if (el) {
  const props = {
    requestUrl: el.dataset.requestUrl || "",
    periodId: el.dataset.periodId || "",
    dictionary: JSON.parse(el.dataset.dictionary) || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_ArchivePeriodModal.default, props), el);
}

},{"./ArchivePeriodModal.jsx":7,"react":"react","react-dom":"react-dom"}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _audio = require("./audio.js");
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const initPDFViewer = (el, i) => {
    const allDropdowns = el.querySelectorAll(".js-gv__pdf-viewer__dropdown");
    const downloadBtn = el.querySelector(".js-gv__pdf-viewer__download-button");
    const printButton = el.querySelector(".js-print");
    const shareBtn = el.querySelector(".js-gv__pdf-viewer__share-button");
    const audioBtn = el.querySelector(".js-gv__pdf-viewer__audio-button");
    const searchBtn = el.querySelector(".js-gv__pdf-viewer__search-button");
    const searchDropdown = el.querySelector(".js-gv__pdf-viewer__search-interaction");
    const versionSelect = el.querySelector(".js-gv__pdf-viewer__pdf-select");
    const versions = versionSelect.querySelectorAll("option");
    const directDownloadLink = el.querySelector(".js-direct-download-pdf");
    const checkBoxes = el.querySelectorAll(".js-gv__pdf-viewer__checkbox-text");
    const redirectOnDownloadBtn = el.querySelector(".js-gv__pdf-viewer__download-button-redirect") !== null;
    const articleIFrame = el.querySelector(".articleViewer");
    const audioPlayerMount = document.querySelector(".js-pdf-audio__mount");
    let focusBuffer = setTimeout(() => {}, 1);
    let styleBuffer = setTimeout(() => {}, 1);
    let audioPlayer;

    //directDownloadLink && directDownloadLink.setAttribute("href", versionSelect.value);

    if (audioPlayerMount) {
      audioPlayer = (0, _audio.initAudioPlayer)(audioPlayerMount);
    }
    if (versions.length <= 1) {
      const versionContainer = el.querySelector(".gv__pdf-viewer__pdf-source");
      versionContainer.style.display = "none";
    }
    const updateIFrameLink = e => {
      const pdfFile = e.currentTarget.value;
      articleIFrame?.setAttribute("src", pdfFile);
    };
    const closeAllDropdowns = e => {
      downloadBtn && downloadBtn.setAttribute("aria-expanded", false);
      audioBtn && audioBtn.setAttribute("aria-expanded", false);
      const dropdowns = el.querySelectorAll("[data-flyout]");
      audioPlayer && audioPlayer.pause();
      window.downloadTrigger && window.downloadTrigger.setCardType(null);
      [...dropdowns].forEach(x => x.classList.contains("is-open") ? x.classList.remove("is-open") : null);
    };
    const positionTriangle = (triangle, div, button) => {
      triangle.removeAttribute("style");
      clearTimeout(styleBuffer);
      styleBuffer = setTimeout(() => {
        const buttonLeft = button.getBoundingClientRect().left;
        const divLeft = div.getBoundingClientRect().left;
        const widthAdjuster = button.getBoundingClientRect().width / 4;
        const trianglePosition = buttonLeft - divLeft + widthAdjuster;
        triangle.style.left = `${trianglePosition}px`;
        triangle.style.right = "auto";
      }, 10);
    };
    const toggleDropdown = (e, type) => {
      const button = e.target.closest("button");
      clearTimeout(focusBuffer);
      const parent = e.target.closest(".js-gv__pdf-viewer__dropdown-container");
      const div = parent.querySelector(`[data-flyout=${type}]`);
      const triangle = parent.querySelector(".js-dropdown-triangle");
      if (div.classList.contains("is-open")) {
        closeAllDropdowns(e);
      } else {
        closeAllDropdowns(e);
        button.setAttribute("aria-expanded", true);
        div.classList.add("is-open");
        positionTriangle(triangle, div, button);
        focusBuffer = setTimeout(() => {
          div.querySelectorAll("input,button,a,.fp-middle") && div.querySelectorAll("input,button,a")[0].focus();
        }, 350);
        if (type === "download") {
          window.downloadTrigger && window.downloadTrigger.setCardType(type);
        }
      }
    };
    const toggleCheckbox = e => {
      if (e.key === "Enter") {
        e.target.previousElementSibling.checked = !e.target.previousElementSibling.checked;
      }
    };
    const closeOnShiftTab = e => {
      if (e.key === "Tab" && e.shiftKey) {
        closeAllDropdowns(e);
      }
    };
    const closeOnTab = e => {
      if (e.key === "Tab" && !e.shiftKey) {
        closeAllDropdowns(e);
      }
    };
    const redirectUnauthenticatedUser = e => {
      const redirectUrl = el.querySelector("#UnauthenticatedRedirectUrl").value;
      window.location.href = redirectUrl;
    };
    if (document.querySelectorAll(".gv__pdf-viewer__dropdown").length) {
      document.querySelector("body").addEventListener("keyup", e => {
        if (e.key === "Escape") {
          closeAllDropdowns(e);
        }
      });
    }
    if (printButton) {
      printButton.addEventListener("click", e => {
        const iwindow = window.frames["articleViewer"];
        const iprint = iwindow.document.execCommand("print", false, null);
        if (!iprint) {
          iwindow.print();
        }
      });
    }
    if (redirectOnDownloadBtn) {
      downloadBtn && downloadBtn.addEventListener("click", e => redirectUnauthenticatedUser(e));
    } else {
      downloadBtn && downloadBtn.addEventListener("click", e => toggleDropdown(e, "download"));
    }
    if (shareBtn || searchBtn || downloadBtn || audioBtn) {
      let buttons = [audioBtn, downloadBtn, searchBtn, shareBtn];
      let dropdowns = [].slice.call(allDropdowns);
      let triggers = buttons.concat(dropdowns);
      document.querySelector("body").addEventListener("click", e => {
        // have to add check for IE11
        if (e.path) {
          if (!e.path.some(x => triggers.includes(x))) {
            closeAllDropdowns(e);
          }
        }
      });
    }
    audioBtn && audioBtn.addEventListener("click", e => toggleDropdown(e, "audio"));
    versionSelect.addEventListener("change", e => {
      updateIFrameLink(e);
    });
    [...checkBoxes].forEach(checkbox => checkbox.addEventListener("keydown", e => toggleCheckbox(e)));
    [...allDropdowns].forEach(dropdown => {
      let selectable = dropdown.querySelectorAll("a, button, input");
      if (selectable.length) {
        selectable[0].addEventListener("keydown", e => closeOnShiftTab(e));
        selectable[selectable.length - 1].addEventListener("keydown", e => closeOnTab(e));
        if (selectable[selectable.length - 1].disabled) {
          // if the final button is disabled, we want to add the event listener to the last.
          selectable[selectable.length - 2].addEventListener("keydown", e => {
            // have to double check in case the status has changed
            if (selectable[selectable.length - 1].disabled) {
              closeOnTab(e);
            }
          });
        }
      }
    });
  };
  if (document.querySelector("body.experience-editor") === null) {
    [...document.querySelectorAll(".js-gv__article-viewer__mount")].forEach(initPDFViewer);
  }
}
if (document.querySelector(".js-gv__pdf-viewer__toggle-expand")) {
  document.querySelector(".js-gv__pdf-viewer__toggle-expand").addEventListener("click", ev => {
    ev.preventDefault();
    document.querySelector(".js-focus-visible").requestFullscreen();
  });
}

},{"./audio.js":26}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _Students = _interopRequireDefault(require("./Students.jsx"));
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
var _reactToggle = _interopRequireDefault(require("react-toggle"));
var fakeAssignment = _interopRequireWildcard(require("./fake-assignment-detail.json"));
var assignmentData = _interopRequireWildcard(require("./fake-assignment.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // patternlab fake data
class AssignmentDetailPage extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const select = document.querySelector(".js-assignment-detail-select");
      select.addEventListener("change", e => this.detectAssignmentChange(e));

      //get initial values
      const initialAssignmentId = select.options[select.selectedIndex].dataset.assignmentId;
      const initialAssignmentGuid = select.options[select.selectedIndex].value;
      const initialAssignmentType = select.options[select.selectedIndex].dataset.assignmentType;
      this.setState({
        assignmentId: initialAssignmentId,
        assignmentGuid: initialAssignmentGuid,
        assignmentType: initialAssignmentType
      });
    });
    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevState.assignmentGuid !== this.state.assignmentGuid) {
        if (this.state.assignmentGuid && this.state.assignmentId) {
          this.fetchAssignmentDetails();
        }
      }
    });
    _defineProperty(this, "toggleShare", () => {
      const params = {
        periodId: this.props.periodId,
        assignmentId: this.state.assignmentGuid
      };
      fetch(`${this.props.requestUrl}/owh/report/shareReport`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        this.setState({
          isShared: data.isValid
        });
      }).catch(err => {
        console.error(err);
        this.setState({
          isLoading: false
        });
      });
    });
    _defineProperty(this, "fetchAssignmentDetails", () => {
      const params = {
        PeriodId: this.props.periodId,
        AssignmentGuid: this.state.assignmentGuid
      };
      if (this.props.isPatternlab) {
        this.setState({
          isLoading: false,
          assignmentTitle: fakeAssignment.AssignmentTitle,
          inProgressCount: fakeAssignment.InProgressCount,
          completedCount: fakeAssignment.CompletedCount,
          launchPageUrl: fakeAssignment.LaunchPageUrl,
          averageScore: fakeAssignment.AverageScore,
          assignmentStatus: fakeAssignment.AssignmentStatus,
          students: fakeAssignment.Students,
          reportUrl: fakeAssignment.ReportUrl,
          isShared: fakeAssignment.IsShared
        });
      } else {
        fetch(`${this.props.requestUrl}/owh/assignment/GetAssignmentDetail`, {
          method: "POST",
          body: JSON.stringify(params),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => response.json()).then(data => {
          if (data.length === 0) {
            this.setState({
              isLoading: false
            });
            return;
          }
          this.setState({
            isLoading: false,
            assignmentTitle: data.AssignmentTitle,
            inProgressCount: data.InProgressCount,
            completedCount: data.CompletedCount,
            launchPageUrl: data.LaunchPageUrl,
            averageScore: data.AverageScore,
            assignmentStatus: data.AssignmentStatus,
            students: data.Students,
            reportUrl: data.ReportUrl,
            isShared: data.IsShared
          });
        }).catch(err => {
          console.error(err);
          this.setState({
            isLoading: false
          });
        });
      }
    });
    _defineProperty(this, "detectAssignmentChange", e => {
      const select = e.target;
      const newAssignmentId = select.options[select.selectedIndex].dataset.assignmentId;
      const newAssignmentGuid = select.options[select.selectedIndex].value;
      const newAssignmentType = select.options[select.selectedIndex].dataset.assignmentType;
      this.setState({
        assignmentId: newAssignmentId,
        assignmentGuid: newAssignmentGuid,
        assignmentType: newAssignmentType,
        isLoading: true
      });
    });
    _defineProperty(this, "handleToggleAssignment", status => {
      //     1 quiz
      // 2 survey
      // 3 investigation
      const params = {
        periodId: this.props.periodId,
        periodName: this.props.periodName,
        assignmentType: this.state.assignmentType,
        assignmentGuid: this.state.assignmentGuid,
        assignmentId: this.state.assignmentId,
        status: status
      };
      fetch(`${this.props.requestUrl}/owh/assignment/AddOrUpdateAssignment`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.Failed) {
          this.setState({
            hasFetchError: true
          });
        } else {
          this.setState({
            hasFetchError: false,
            assignmentStatus: data.Status
          });
        }
      }).catch(err => {
        console.error(err);
      });
    });
    _defineProperty(this, "renderStudents", (student, i) => {
      return /*#__PURE__*/_react.default.createElement(_Students.default, {
        key: i,
        studentName: student.StudentName,
        submittedDate: student.SubmittedDate,
        status: student.Status,
        statusText: student.StatusText,
        dictionary: this.props.dictionary,
        launchUrl: student.LaunchUrl,
        reportUrl: student.ReportUrl
      });
    });
    _defineProperty(this, "renderReopenIcon", () => {
      return /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "14",
        viewBox: "0 0 15 14",
        "aria-hidden": "true",
        role: "img"
      }, /*#__PURE__*/_react.default.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "currentColor"
      }, /*#__PURE__*/_react.default.createElement("path", {
        strokeLinecap: "square",
        d: "M13.755 2.187l-.75 2.62m-2.634-.743l2.616.752"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.815 4.429A6 6 0 001.8 4.82"
      }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
        strokeLinecap: "square",
        d: "M1.276 11.752l.706-2.632m2.646.697L1.999 9.11"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M2.195 9.416a6 6 0 0011.014-.393"
      }))));
    });
    _defineProperty(this, "renderCloseIcon", () => {
      return /*#__PURE__*/_react.default.createElement("svg", {
        "aria-hidden": "true",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "10",
        viewBox: "0 0 15 10"
      }, /*#__PURE__*/_react.default.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "currentColor"
      }, /*#__PURE__*/_react.default.createElement("path", {
        strokeLinecap: "square",
        d: "M6.5 5h8M13.023 3.023L14.95 4.95m-1.927 1.943L14.95 4.97"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10 8v2H0V0h10v2"
      })));
    });
    _defineProperty(this, "renderStatusActionButton", (status, isArchived) => {
      const {
        ReOpenLabel,
        CloseLabel
      } = this.props.dictionary;
      const label = status === 1 && !isArchived ? CloseLabel : ReOpenLabel;
      const icon = status === 1 && !isArchived ? this.renderCloseIcon() : this.renderReopenIcon();
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: () => this.handleToggleAssignment(status),
        className: "gv__button gv__button--outline gv__assignment-summary__status-button"
      }, icon, /*#__PURE__*/_react.default.createElement("span", null, label, " "));
    });
    _defineProperty(this, "renderSummaryStatus", (status, isArchived) => {
      const {
        ReOpenLabel,
        CloseLabel,
        InvestigationOpenLabel,
        InvestigationClosedLabel,
        statusLabel
      } = this.props.dictionary;
      if (status === 1 && !isArchived) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__assignment-summary__status gv__assignment-summary__status--open"
        }, statusLabel, ": ", InvestigationOpenLabel, this.renderStatusActionButton(status, isArchived));
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__assignment-summary__status gv__assignment-summary__status--closed"
        }, statusLabel, ": ", InvestigationClosedLabel, this.renderStatusActionButton(status, isArchived));
      }
    });
    _defineProperty(this, "renderShareReports", () => {
      const isShared = this.state.isShared;
      const {
        shareReportWithClassLabel
      } = this.props.dictionary;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__assignment-summary__share-reports"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__assignment-summary__share-reports-label",
        id: "shareReportsLabel"
      }, shareReportWithClassLabel), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__react-toggle"
      }, /*#__PURE__*/_react.default.createElement(_reactToggle.default, {
        onChange: () => this.toggleShare(),
        "aria-labelledby": "shareReportsLabel",
        defaultChecked: isShared || false
      })));
    });
    _defineProperty(this, "renderReportsButtons", status => {
      const {
        CompileReport,
        ViewReportLabel
      } = this.props.dictionary;
      const viewReportLink = this.state.reportUrl;
      if (this.props.isArchived === "true") {
        return /*#__PURE__*/_react.default.createElement("a", {
          href: viewReportLink,
          className: "gv__assignment-summary__report-links gv__assignment-summary__report-links--block",
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/_react.default.createElement("span", null, ViewReportLabel), " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
          classes: "gv__external-link-icon gv__assignment-summary__icon"
        }));
      } else if (status === 1) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, viewReportLink && /*#__PURE__*/_react.default.createElement("a", {
          href: viewReportLink,
          className: "gv__assignment-summary__report-links gv__assignment-summary__report-links--block",
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/_react.default.createElement("span", null, ViewReportLabel), " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
          classes: "gv__external-link-icon gv__assignment-summary__icon"
        })));
      } else if (status === 2) {
        if (this.state.assignmentType === 3) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
            type: "button",
            disabled: true,
            className: "gv__assignment-summary__report-links gv__assignment-summary__report-links--block"
          }, /*#__PURE__*/_react.default.createElement("span", null, ViewReportLabel), " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
            classes: "gv__external-link-icon gv__assignment-summary__icon"
          })), /*#__PURE__*/_react.default.createElement("span", {
            className: "gv__investigations__compiling"
          }, CompileReport, "..."));
        } else {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, viewReportLink && /*#__PURE__*/_react.default.createElement("a", {
            href: viewReportLink,
            className: "gv__assignment-summary__report-links gv__assignment-summary__report-links--block",
            target: "_blank",
            rel: "noopener noreferrer"
          }, /*#__PURE__*/_react.default.createElement("span", null, ViewReportLabel), " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
            classes: "gv__external-link-icon gv__assignment-summary__icon"
          })));
        }
      } else if (status === 3) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, viewReportLink && /*#__PURE__*/_react.default.createElement("a", {
          href: viewReportLink,
          className: "gv__assignment-summary__report-links",
          target: "_blank",
          rel: "noopener noreferrer"
        }, /*#__PURE__*/_react.default.createElement("span", null, ViewReportLabel), " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
          classes: "gv__external-link-icon gv__assignment-summary__icon"
        })));
      }
    });
    this.state = {
      assignmentId: null,
      assignmentGuid: null,
      students: [],
      assignmentTitle: null,
      assignmentType: null,
      inProgressCount: null,
      completedCount: null,
      launchPageUrl: null,
      assignmentStatus: null,
      isLoading: true,
      hasFetchError: false
    };
  }
  render() {
    const {
      assignmentTitle,
      inProgressCount,
      completedCount,
      launchPageUrl,
      assignmentStatus,
      assignmentType,
      students,
      isLoading,
      averageScore,
      isShared,
      reportUrl
    } = this.state;
    const {
      inProgressLabel,
      investigationInProgressLabel,
      submissionsLabel,
      classAverageLabel,
      viewSubmissionsLabel,
      studentHeaderLabel,
      statusHeaderLabel,
      FetchError,
      submissionDateHeaderLabel,
      reportsLabel,
      shareReportWithClassLabel,
      viewHeaderLabel
    } = this.props.dictionary;
    const displayStudents = !isLoading && students.length > 0;
    const isArchived = this.props.isArchived === "true";
    const inProgress = parseInt(this.state.assignmentType) === 3 ? investigationInProgressLabel : inProgressLabel;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement(_loading.default, {
      isLoading: isLoading
    }), !isLoading && /*#__PURE__*/_react.default.createElement("section", {
      className: "gv__assignment-summary gv__component"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__container gv__container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__title"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "gv__assignment-summary__heading"
    }, assignmentTitle)), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__bottom-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__results"
    }, this.renderSummaryStatus(assignmentStatus, isArchived), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__buttons"
    }, (launchPageUrl || reportUrl) && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__reports-label"
    }, reportsLabel), launchPageUrl && !isArchived && assignmentStatus > 0 && /*#__PURE__*/_react.default.createElement("a", {
      href: launchPageUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "gv__assignment-summary__report-links gv__assignment-summary__report-links--block"
    }, /*#__PURE__*/_react.default.createElement("span", null, " ", viewSubmissionsLabel), /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
      classes: "gv__external-link-icon gv__assignment-summary__icon"
    }), " "), this.renderReportsButtons(assignmentStatus), this.state.hasFetchError && /*#__PURE__*/_react.default.createElement("span", {
      role: "alert",
      className: "gv__form__error-msg"
    }, FetchError), reportUrl && parseInt(assignmentType) === 3 && this.renderShareReports())), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__summary"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "gv__assignment-summary__summary-heading"
    }, "Summary"), /*#__PURE__*/_react.default.createElement("ul", {
      className: "gv__assignment-summary__list"
    }, parseInt(assignmentType) !== 2 && /*#__PURE__*/_react.default.createElement("li", {
      className: "gv__assignment-summary__list-item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__circle gv__assignment-summary__circle--orange"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-summary__number"
    }, inProgressCount)), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-summary__label"
    }, " ", inProgress)), completedCount && /*#__PURE__*/_react.default.createElement("li", {
      className: "gv__assignment-summary__list-item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__circle gv__assignment-summary__circle--green"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-summary__number"
    }, completedCount)), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-summary__label"
    }, " ", submissionsLabel)), parseInt(assignmentType) === 3 && /*#__PURE__*/_react.default.createElement("li", {
      className: "gv__assignment-summary__list-item"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-summary__circle"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-summary__number"
    }, averageScore)), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-summary__label"
    }, " ", classAverageLabel)))))), displayStudents && /*#__PURE__*/_react.default.createElement("table", {
      className: "gv__student-periods__table--assignment-detail gv__student-periods__table gv__container"
    }, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
      className: "gv__student-periods__heading"
    }, /*#__PURE__*/_react.default.createElement("th", {
      scope: "col"
    }, studentHeaderLabel), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col"
    }, statusHeaderLabel), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "gv__student-periods__submission-header"
    }, submissionDateHeaderLabel), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col"
    }, viewHeaderLabel)), students.map((student, i) => this.renderStudents(student, i))))));
  }
}
exports.default = AssignmentDetailPage;
_defineProperty(AssignmentDetailPage, "propTypes", {
  periodId: _propTypes.string,
  periodName: _propTypes.string,
  requestUrl: _propTypes.string,
  dictionary: _propTypes.object,
  isArchived: _propTypes.string,
  isPatternlab: _propTypes.string
});

},{"../partials/external-link-icon.jsx":148,"../partials/loading.jsx":150,"./Students.jsx":11,"./fake-assignment-detail.json":13,"./fake-assignment.json":14,"classnames":"classnames","prop-types":"prop-types","react":"react","react-modal":"react-modal","react-toggle":"react-toggle"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Students extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "renderStatus", status => {
      const {
        statusText
      } = this.props;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__assignment-list__status"
      }, statusText);
      // if (status === 1) {
      //   // didn't start
      //   return (
      //     <div className="gv__student-periods__status gv__student-periods__status--not-submitted">
      //       <span>{statusText}</span>
      //     </div>
      //   );
      // } else if (status === 2) {
      //   // In progress
      //   return (
      //     <div className="gv__student-periods__status gv__student-periods__status--in-progress">
      //       <span>{statusText}</span>
      //     </div>
      //   );
      // } else if (status === 3) {
      //   // completed
      //   return (
      //     <div className="gv__student-periods__status gv__student-periods__status--submitted-open">
      //       <span>{statusText}</span>
      //     </div>
      //   );
      // }
    });
    this.state = {};
  }
  render() {
    const {
      studentName,
      status,
      launchUrl,
      submittedDate,
      reportUrl
    } = this.props;
    const {
      studentHeaderLabel,
      statusHeaderLabel,
      submissionDateHeaderLabel,
      ViewReportLabel,
      viewHeaderLabel
    } = this.props.dictionary;
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: ""
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__student-periods__cell",
      "data-header": studentHeaderLabel
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: launchUrl,
      className: "gv__link gv__student-periods__link"
    }, studentName)), /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__student-periods__cell gv__student-periods__cell--status",
      "data-header": statusHeaderLabel
    }, this.renderStatus(status)), /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__student-periods__cell",
      "data-header": submissionDateHeaderLabel
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__student-periods__results"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: ""
    }, submittedDate ? submittedDate : "-"))), " ", /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__student-periods__cell",
      "data-header": viewHeaderLabel
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__student-periods__view-report"
    }, reportUrl && /*#__PURE__*/_react.default.createElement("a", {
      href: reportUrl,
      className: "gv__student-periods__report-link",
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/_react.default.createElement("span", null, " ", ViewReportLabel), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__visuallyhidden"
    }, " for ", studentName), /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
      classes: "gv__external-link-icon"
    })))));
  }
}
exports.default = Students;
_defineProperty(Students, "propTypes", {
  studentName: _propTypes.string,
  submittedDate: _propTypes.string,
  status: _propTypes.number,
  statusText: _propTypes.string,
  dictionary: _propTypes.object,
  launchUrl: _propTypes.string,
  reportUrl: _propTypes.string
});

},{"../partials/external-link-icon.jsx":148,"prop-types":"prop-types","react":"react"}],12:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _AssignmentDetailPage = _interopRequireDefault(require("./AssignmentDetailPage.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-assignment-detail-mount");
if (el) {
  const props = {
    requestUrl: el.dataset.requestUrl || "",
    dictionary: JSON.parse(el.dataset.dictionary) || [],
    periodId: el.dataset.periodId,
    periodName: el.dataset.periodName,
    isArchived: el.dataset.isArchived,
    isPatternlab: el.dataset.isPatternlab
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_AssignmentDetailPage.default, props), el);
}

},{"./AssignmentDetailPage.jsx":10,"react":"react","react-dom":"react-dom"}],13:[function(require,module,exports){
module.exports={
  "AssignmentTitle": "1.0 Practice Set: History Stories",
  "InProgressCount": "0/5",
  "CompletedCount": "0/5",
  "LaunchPageUrl": "#",
  "AssignmentStatus": 2,
  "IsShared": true,
  "ReportUrl": "",
  "AverageScore": null,
  "Students": [
    {
      "StudentName": "demoahmed demo",
      "Status": 1,
      "StatusText": "Not Started",
      "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10232\u0026Period_Id=10163",
      "SubmittedDate": null,
      "ReportUrl": "#"
    },
    {
      "StudentName": "Test Student",
      "Status": 1,
      "StatusText": "Not Started",
      "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10229\u0026Period_Id=10163",
      "SubmittedDate": null,
      "ReportUrl": null
    },
    {
      "StudentName": "Test Student",
      "Status": 1,
      "StatusText": "Not Started",
      "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10230\u0026Period_Id=10163",
      "SubmittedDate": null,
      "ReportUrl": null
    },
    {
      "StudentName": "Ahmed Test",
      "Status": 1,
      "StatusText": "Not Started",
      "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10231\u0026Period_Id=10163",
      "SubmittedDate": null,
      "ReportUrl": null
    },
    {
      "StudentName": "demo 3 test 3",
      "Status": 1,
      "StatusText": "Not Started",
      "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10233\u0026Period_Id=10163",
      "SubmittedDate": null,
      "ReportUrl": null
    }
  ]
}

},{}],14:[function(require,module,exports){
module.exports={
  "data": {
    "AssignmentTitle": "1.1 Practice Set: Era 1 Overview",
    "InProgressCount": "1/6",
    "CompletedCount": "0/6",
    "LaunchPageUrl": null,
    "AssignmentStatus": 1,
    "Students": [
      {
        "StudentName": "demoahmed demo",
        "Status": 1,
        "StatusText": "Not Started",
        "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10232\u0026Period_Id=10163",
        "SubmittedDate": null,
        "ReportUrl": null
      },
      {
        "StudentName": "Test Student",
        "Status": 1,
        "StatusText": "Not Started",
        "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10229\u0026Period_Id=10163",
        "SubmittedDate": null,
        "ReportUrl": null
      },
      {
        "StudentName": "Test Student",
        "Status": 1,
        "StatusText": "Not Started",
        "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10230\u0026Period_Id=10163",
        "SubmittedDate": null,
        "ReportUrl": null
      },
      {
        "StudentName": "Test Student-New",
        "Status": 2,
        "StatusText": "Still Practicing",
        "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=20655\u0026Period_Id=10163",
        "SubmittedDate": "-",
        "ReportUrl": ""
      },
      {
        "StudentName": "Ahmed Test",
        "Status": 1,
        "StatusText": "Not Started",
        "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10231\u0026Period_Id=10163",
        "SubmittedDate": null,
        "ReportUrl": null
      },
      {
        "StudentName": "demo 3 test 3",
        "Status": 1,
        "StatusText": "Not Started",
        "LaunchUrl": "/Teacher-Dashboard/Student-Details?StudentId=10233\u0026Period_Id=10163",
        "SubmittedDate": null,
        "ReportUrl": null
      }
    ],
    "ReportUrl": "/Teacher-Dashboard/Report?Period_Id=10163\u0026AssignmentId=30243",
    "AverageScore": null
  }
}

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  children: _propTypes.node,
  isMobile: _propTypes.bool
};
const renderAssignmentCell = props => {
  const {
    isMobile,
    children,
    ...otherProps
  } = props;
  if (isMobile) {
    return /*#__PURE__*/_react.default.createElement("span", otherProps, children);
  } else {
    return /*#__PURE__*/_react.default.createElement("td", otherProps, " ", children);
  }
};
const AssignmentCell = props => {
  return renderAssignmentCell(props);
};
AssignmentCell.propTypes = propTypes;
var _default = exports.default = AssignmentCell;

},{"prop-types":"prop-types","react":"react"}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _TableWrapper = _interopRequireDefault(require("./TableWrapper.jsx"));
var _ListWrapper = _interopRequireDefault(require("./ListWrapper.jsx"));
var _AssignmentRow = _interopRequireDefault(require("./AssignmentRow.jsx"));
var assignmentsData = _interopRequireWildcard(require("./fake-assignments.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // TEMPORARY
class AssignmentList extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      this.checkIsMobile();
      const hideReports = this.props.isModal && this.props.assignmentType && this.props.assignmentType === "2";
      this.setState({
        hideReports
      });
      window.addEventListener("resize", () => this.checkIsMobile());
    });
    _defineProperty(this, "checkIsMobile", () => {
      const mobileBP = 780;
      const width = window.innerWidth;
      let isMobile = width < mobileBP ? true : false;
      this.setState({
        isMobile
      });
    });
    // TODO: make periodName/id more flexible
    _defineProperty(this, "handleToggleAssignment", (status, assignmentType, assignmentGuid, assignmentId, periodId, periodName, callback) => {
      const params = {
        periodId: periodId,
        periodName: periodName,
        assignmentType: assignmentType,
        assignmentGuid: assignmentGuid,
        assignmentId: assignmentId,
        status: status
      };
      fetch(`${this.props.requestUrl}/owh/assignment/AddOrUpdateAssignment`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.Failed) {
          this.setState({
            hasFetchError: true,
            errorModalIsOpen: true
          });
        } else {
          const {
            units
          } = this.props;
          units.forEach(unit => {
            const assignments = unit.Assignments;
            if (assignments.length) {
              assignments.forEach(assignment => {
                // oh boy this is confusing; if it's the modal, we check for period id, otherwise check for assignment guid
                if (this.props.isModal && assignment.PeriodId === periodId) {
                  assignment.Status = data.Status;
                  assignment.AssignmentId = data.AssignmentId;
                  assignment.Url = data.Url;
                  assignment.AssignmentSubmissionsUrl = data.AssignmentSubmissionsUrl;
                } else if (!this.props.isModal && assignment.AssignmentGuid === data.AssignmentGuid) {
                  assignment.Status = data.Status;
                  assignment.AssignmentId = data.AssignmentId;
                  assignment.Url = data.Url;
                  assignment.AssignmentSubmissionsUrl = data.AssignmentSubmissionsUrl;
                } else {
                  return assignment;
                }
              });
            }
          });
          const newUnits = units.map(unit => unit);
          console.log(newUnits);
          this.setState({
            units: newUnits,
            hasFetchError: false
          }, callback);
        }
      }).catch(err => {
        console.error(err);
      });
    });
    _defineProperty(this, "createId", title => {
      let newTitle;
      if (title) {
        newTitle = title.replace(" ", "");
        return newTitle;
      }
    });
    _defineProperty(this, "standardizeTitles", assignment => {
      // because the "assignment" object can also be a period in the modal, we're renaming
      //`AssignmentTitle` to be more flexible
      let newAssignment = assignment;
      if (assignment.AssignmentTitle) {
        newAssignment.Title = assignment.AssignmentTitle;
      }
      return newAssignment;
    });
    _defineProperty(this, "renderAssignment", (assignment, id, totalColumns) => {
      const {
        AssignmentType,
        AssignmentGuid
      } = assignment;
      const {
        periodId,
        periodName,
        dictionary,
        requestUrl,
        isModal
      } = this.props;
      const {
        isMobile,
        hideReports
      } = this.state;
      const isArchived = this.props.isArchived || assignment.isArchived;
      return /*#__PURE__*/_react.default.createElement(_AssignmentRow.default, {
        headingId: id,
        totalColumns: totalColumns,
        key: AssignmentGuid,
        isArchived: isArchived,
        isMobile: isMobile,
        assignment: this.standardizeTitles(assignment),
        periodId: periodId,
        periodName: periodName,
        dictionary: dictionary,
        requestUrl: requestUrl,
        handleToggleAssignment: this.handleToggleAssignment,
        hideReports: hideReports
      });
    });
    _defineProperty(this, "afterErrorModalOpen", () => {
      this.errorMsgRef.current.focus();
    });
    _defineProperty(this, "closeErrorModal", e => {
      this.setState({
        errorModalIsOpen: false
      });
    });
    _defineProperty(this, "calculateColumns", arr => {
      const totalColumns = arr.filter(x => x).length;
      return totalColumns;
    });
    this.state = {
      isMobile: false,
      hasFetchError: false
    };
    this.errorMsgRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      isMobile,
      hideReport
    } = this.state;
    const {
      units,
      isModal,
      assignmentType
    } = this.props;
    const {
      AssignmentLabel,
      ReportsLabel,
      StatusLabel,
      ActionLabel,
      FetchError
    } = this.props.dictionary;
    const totalColumns = this.calculateColumns([AssignmentLabel, ReportsLabel, StatusLabel, ActionLabel]);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-list"
    }, isMobile ? /*#__PURE__*/_react.default.createElement(_ListWrapper.default, {
      className: "gv__assignment-list__list",
      "aria-label": "All Assignments"
    }, units.map((unit, i) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: `unit-${i}`
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__assignment-list__title"
      }, unit.UnitTitle), /*#__PURE__*/_react.default.createElement("ul", {
        className: "gv__assignment-list__nested-list",
        "aria-label": unit.UnitTitle
      }, unit.Assignments.map((assignment, i) => /*#__PURE__*/_react.default.createElement("li", {
        key: `assignment-${i}`
      }, this.renderAssignment(assignment, this.createId(unit.UnitTitle), totalColumns)))));
    })) : /*#__PURE__*/_react.default.createElement(_TableWrapper.default, {
      className: "gv__assignment-list__table",
      "aria-label": "All Assignments",
      AssignmentLabel: AssignmentLabel,
      ReportsLabel: ReportsLabel,
      StatusLabel: StatusLabel,
      ActionLabel: ActionLabel
    }, units.map((unit, i) => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
        key: `unit-${i}`
      }, unit.UnitTitle && /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
        className: "gv__assignment-list__title",
        colSpan: totalColumns,
        id: this.createId(unit.UnitTitle)
      }, unit.UnitTitle)), unit.Assignments.map((assignment, i) => /*#__PURE__*/_react.default.createElement("tr", {
        className: "gv__assignment-list__row",
        key: `unit-row-${i}`
      }, this.renderAssignment(assignment, this.createId(unit.UnitTitle)))));
    })), /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.errorModalIsOpen,
      onAfterOpen: this.afterErrorModalOpen,
      onRequestClose: this.closeErrorModal,
      contentLabel: "Update Error",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content"
    }, " ", /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeErrorModal,
      className: "gv__modal__close"
    }, "close"), " ", /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__error-modal"
    }, /*#__PURE__*/_react.default.createElement("span", {
      ref: this.errorMsgRef,
      tabIndex: "-1",
      className: "gv__form__error-msg"
    }, FetchError))));
  }
}
exports.default = AssignmentList;
_defineProperty(AssignmentList, "propTypes", {
  periodId: _propTypes.string,
  periodName: _propTypes.string,
  requestUrl: _propTypes.string,
  dictionary: _propTypes.object,
  isPatternlab: _propTypes.string,
  isArchived: _propTypes.string,
  units: _propTypes.array,
  isModal: _propTypes.bool
});

},{"./AssignmentRow.jsx":17,"./ListWrapper.jsx":20,"./TableWrapper.jsx":21,"./fake-assignments.json":24,"classnames":"classnames","prop-types":"prop-types","react":"react","react-modal":"react-modal"}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _AssignmentCell = _interopRequireDefault(require("./AssignmentCell.jsx"));
var _compileIcon = _interopRequireDefault(require("../partials/compile-icon.jsx"));
var _reopenIcon = _interopRequireDefault(require("../partials/reopen-icon.jsx"));
var _eyeIcon = _interopRequireDefault(require("../partials/eye-icon.jsx"));
var _assignIcon = _interopRequireDefault(require("../partials/assign-icon.jsx"));
var _newWindowIcon = _interopRequireDefault(require("../partials/new-window-icon.jsx"));
var _closeIcon = _interopRequireDefault(require("../partials/close-icon.jsx"));
var _openIcon = _interopRequireDefault(require("../partials/open-icon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class AssignmentRow extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      this.refreshCells();
    });
    _defineProperty(this, "refreshCells", () => {
      //we're storing everything in the state so it's easier to read than keeping track of all these enumerations
      const readableAssignmentType = this.humanReadableAssignmentTypes(this.props.assignment.AssignmentType);
      this.humanReadableStatus(this.props.assignment.Status, readableAssignmentType);
    });
    _defineProperty(this, "humanReadableStatus", (status, readableAssignmentType) => {
      // status number guide - https://velirs.atlassian.net/browse/GVPXOMAHA-25
      // 0= "Assign" (never assigned before so the status would say "Unassigned")
      // 1="Close" (currently open so the stat would say "Assigned")
      // 2="Re-Open" +  no report/compiling (status would say "Closed")
      // 3="Re-Open", report is available

      const {
        AssignLabel,
        AssignedLabel,
        UnassignedLabel,
        ClosedLabel,
        CloseLabel,
        OpenLabel,
        ReOpenLabel
      } = this.props.dictionary;
      let readableAssignmentStatus;
      let readableReport;
      let readableAction;
      if (parseInt(status) === 0) {
        readableAssignmentStatus = UnassignedLabel;
        readableAction = AssignLabel;
      } else if (parseInt(status) === 1) {
        readableAssignmentStatus = AssignedLabel;
        readableAction = CloseLabel;
        if (readableAssignmentType === "quiz") {
          readableReport = "available";
        }
      } else if (parseInt(status) === 2) {
        readableAssignmentStatus = ClosedLabel;
        readableReport = readableAssignmentType === "investigations" ? "compiling" : "available";
        readableAction = readableAssignmentType === "investigations" ? ReOpenLabel : AssignLabel;
      } else if (parseInt(status) === 3) {
        readableAssignmentStatus = ClosedLabel;
        readableReport = "available";
        readableAction = ReOpenLabel;
      }
      this.setState({
        readableAssignmentStatus,
        readableReport,
        readableAction
      });
    });
    _defineProperty(this, "humanReadableAssignmentTypes", type => {
      // 1 - quiz
      // 2 - survey
      // 3 - investigations
      let readableAssignmentType;
      if (parseInt(type) === 1) {
        readableAssignmentType = "quiz";
      } else if (parseInt(type) === 2) {
        readableAssignmentType = "survey";
      } else {
        readableAssignmentType = "investigations";
      }
      this.setState({
        readableAssignmentType
      });
      return readableAssignmentType;
    });
    _defineProperty(this, "createAnalyticsString", string => {
      let newString;
      if (string) {
        newString = string.trim().replace(" ", "-").toLowerCase();
        return newString;
      }
    });
    _defineProperty(this, "renderReports", () => {
      const {
        ViewReportLabel,
        CompileReport
      } = this.props.dictionary;
      const {
        readableReport,
        readableAssignmentType
      } = this.state;
      const {
        ReportUrl
      } = this.props.assignment;
      if (readableAssignmentType !== "survey") {
        if (readableReport === "available" && ReportUrl) {
          return /*#__PURE__*/_react.default.createElement("a", {
            href: ReportUrl,
            className: "gv__assignment-list__link",
            target: "_blank",
            rel: "noopener noreferrer",
            "data-analytics": this.createAnalyticsString(ViewReportLabel),
            "data-analytics-type": this.createAnalyticsString(readableAssignmentType)
          }, /*#__PURE__*/_react.default.createElement("span", {
            className: "gv__assignment-list__reports-text"
          }, /*#__PURE__*/_react.default.createElement(_eyeIcon.default, null), " ", ViewReportLabel));
        } else if (readableReport === "compiling") {
          return /*#__PURE__*/_react.default.createElement("span", {
            className: "gv__assignment-list__reports-text"
          }, /*#__PURE__*/_react.default.createElement(_compileIcon.default, null), " ", /*#__PURE__*/_react.default.createElement("span", null, CompileReport));
        }
      }
    });
    _defineProperty(this, "renderActionIcon", action => {
      const {
        AssignLabel,
        OpenLabel,
        CloseLabel,
        ReOpenLabel
      } = this.props.dictionary;
      if (action === AssignLabel) {
        return /*#__PURE__*/_react.default.createElement(_assignIcon.default, null);
      } else if (action === OpenLabel) {
        return /*#__PURE__*/_react.default.createElement(_openIcon.default, null);
      } else if (action === ReOpenLabel) {
        return /*#__PURE__*/_react.default.createElement(_reopenIcon.default, null);
      } else if (action === CloseLabel) {
        return /*#__PURE__*/_react.default.createElement(_closeIcon.default, null);
      }
    });
    this.state = {};
  }
  render() {
    const {
      headingId,
      requestUrl,
      assignment,
      isArchived,
      isMobile
    } = this.props;
    const {
      AssignmentId,
      Title,
      AssignmentType,
      Url,
      Status,
      AssignmentSubmissionsUrl,
      ReportUrl
    } = assignment;
    const {
      ViewSubmissionsLabel,
      ViewDetailsLabel,
      UnassignedLabel
    } = this.props.dictionary;
    const {
      readableReport,
      readableAssignmentStatus,
      readableAction,
      readableAssignmentType
    } = this.state;
    const hideReports = this.props.hideReports || false;
    const assignmentGuid = assignment.AssignmentGuid || this.props.assignmentGuid;
    const periodId = this.props.periodId || assignment.PeriodId;
    const periodName = this.props.periodName || assignment.Title;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AssignmentCell.default, {
      isMobile: isMobile,
      className: "gv__assignment-list__table-cell gv__assignment-list__table-cell--assignment"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-list__name"
    }, Title), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-list__small-text"
    }, Url && /*#__PURE__*/_react.default.createElement("a", {
      href: Url,
      className: "gv__assignment-list__link"
    }, ViewDetailsLabel), AssignmentSubmissionsUrl && /*#__PURE__*/_react.default.createElement("a", {
      href: AssignmentSubmissionsUrl,
      className: "gv__assignment-list__link",
      "data-analytics": this.createAnalyticsString(ViewSubmissionsLabel),
      "data-analytics-type": this.createAnalyticsString(readableAssignmentType),
      target: "_blank"
    }, ViewSubmissionsLabel, " ", /*#__PURE__*/_react.default.createElement(_newWindowIcon.default, {
      className: "gv__assignment-list__new-window"
    })))), hideReports === false && /*#__PURE__*/_react.default.createElement(_AssignmentCell.default, {
      isMobile: isMobile,
      className: "gv__assignment-list__table-cell gv__assignment-list__table-cell--reports",
      "data-header": "Reports"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-list__reports"
    }, readableReport && this.renderReports())), /*#__PURE__*/_react.default.createElement(_AssignmentCell.default, {
      isMobile: isMobile,
      headers: `${headingId} status`,
      className: "gv__assignment-list__table-cell gv__assignment-list__table-cell--status",
      "data-header": "Status"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-list__status"
    }, readableAssignmentStatus && readableAssignmentStatus)), /*#__PURE__*/_react.default.createElement(_AssignmentCell.default, {
      isMobile: isMobile,
      headers: `${headingId} action`,
      className: "gv__assignment-list__table-cell gv__assignment-list__table-cell--action",
      "data-header": "Action"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__button gv__button--outline gv__assignment-list__button",
      "data-analytics": this.createAnalyticsString(readableAction),
      "data-analytics-type": this.createAnalyticsString(readableAssignmentType),
      onClick: () => this.props.handleToggleAssignment(Status, AssignmentType, assignmentGuid, AssignmentId, periodId, periodName, this.refreshCells)
    }, this.renderActionIcon(readableAction), " ", /*#__PURE__*/_react.default.createElement("span", null, readableAction, " "))));
  }
}
exports.default = AssignmentRow;
_defineProperty(AssignmentRow, "propTypes", {
  assignment: (0, _propTypes.shape)({
    assignmentId: _propTypes.number,
    title: _propTypes.string,
    url: _propTypes.string,
    status: _propTypes.number,
    assignmentType: _propTypes.number,
    AssignmentSubmissionsUrl: _propTypes.string
  }),
  headingId: _propTypes.string,
  isArchived: _propTypes.string,
  totalColumns: _propTypes.number,
  periodId: _propTypes.string,
  requestUrl: _propTypes.string,
  dictionary: _propTypes.object,
  handleToggleAssignment: _propTypes.func,
  isMobile: _propTypes.bool,
  hideReports: _propTypes.bool
});

},{"../partials/assign-icon.jsx":142,"../partials/close-icon.jsx":143,"../partials/compile-icon.jsx":145,"../partials/eye-icon.jsx":149,"../partials/new-window-icon.jsx":151,"../partials/open-icon.jsx":152,"../partials/reopen-icon.jsx":153,"./AssignmentCell.jsx":15,"classnames":"classnames","prop-types":"prop-types","react":"react"}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
var _AssignmentList = _interopRequireDefault(require("./AssignmentList.jsx"));
var assignmentsData = _interopRequireWildcard(require("./fake-periods.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // TEMPORARY
class AssignmentsModal extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const modalId = this.props.modalId;
      const modalTrigger = document.querySelector(`button[data-modal-id="${modalId}"]`);
      this.setState({
        modalTrigger
      });
      modalTrigger.addEventListener("click", e => this.openModal(e));
    });
    _defineProperty(this, "openModal", e => {
      this.setState({
        modalIsOpen: true
      });
      this.state.modalTrigger.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      this.setState({
        modalIsOpen: false
      });
      this.state.modalTrigger.setAttribute("aria-expanded", false);
      this.state.modalTrigger.focus();
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
      this.fetchAssignments();
    });
    _defineProperty(this, "standardizeData", data => {
      // add "assignments" object and add assignment type. because BE changed the structure of this, we have to do a lot more cheating to make it match period tabs
      let units = {};
      const newData = data.map(x => {
        x.AssignmentType = this.props.assignmentType;
        x.Title = x.PeriodTitle;
        return x;
      });
      units.Assignments = newData;
      const unitArray = new Array(units);
      return unitArray;
    });
    _defineProperty(this, "fetchAssignments", () => {
      const params = {
        AssignmentGuid: this.props.assignmentGuid,
        AssignmentType: this.props.assignmentType,
        CourseId: this.props.courseId
      };
      if (this.props.isPatternlab) {
        // for testing
        const newUnits = this.standardizeData(assignmentsData.data);
        this.setState({
          isLoading: false,
          units: newUnits
        });
      } else {
        fetch(`${this.props.requestUrl}/owh/assignment/GetAssignmentsDetailsForPeriods`, {
          method: "POST",
          body: JSON.stringify(params),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => response.json()).then(data => {
          if (data.length === 0) {
            this.setState({
              isLoading: false
            });
            return;
          }
          this.setState({
            isLoading: false,
            units: this.standardizeData(data)
          });
        }).catch(err => {
          console.error(err);
          this.setState({
            isLoading: false
          });
        });
      }
    });
    this.state = {
      units: [],
      isLoading: true,
      modalIsOpen: false
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      units,
      isLoading,
      modalIsOpen
    } = this.state;
    const {
      assignmentType,
      assignmentName,
      requestUrl,
      dictionary,
      isPatternlab,
      viewAllUrl
    } = this.props;
    const displayUnits = !isLoading && units.length > 0;
    const noneAvailable = !isLoading && units.length <= 0;
    const {
      ViewAllClassesLabel,
      NoResultsText
    } = dictionary;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      shouldCloseOnOverlayClick: true,
      contentLabel: "Investigations",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content gv__assignment-modal__content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-modal"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-modal__top"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      ref: this.modalTitleRef,
      className: "gv__assignment-modal__title",
      tabIndex: "-1"
    }, assignmentName), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close gv__assignment-modal__close"
    }, "close")), displayUnits && /*#__PURE__*/_react.default.createElement(_AssignmentList.default, {
      units: units,
      dictionary: dictionary,
      requestUrl: requestUrl,
      isPatternlab: isPatternlab,
      isModal: true,
      assignmentType: assignmentType
    }), noneAvailable && /*#__PURE__*/_react.default.createElement("p", {
      className: "gv__assignment-modal__no-results"
    }, NoResultsText || "No assignments available. Please create a new assignment by clicking the View All button")), viewAllUrl && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__assignment-modal__button-container"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: viewAllUrl,
      className: "gv__assignment-modal__view-all gv__button"
    }, ViewAllClassesLabel))));
  }
}
exports.default = AssignmentsModal;
_defineProperty(AssignmentsModal, "propTypes", {
  modalId: _propTypes.string,
  assignmentName: _propTypes.string,
  assignmentGuid: _propTypes.string,
  assignmentType: _propTypes.string,
  requestUrl: _propTypes.string,
  dictionary: _propTypes.object,
  isPatternlab: _propTypes.string,
  viewAllUrl: _propTypes.string,
  courseId: _propTypes.string
});

},{"../partials/loading.jsx":150,"./AssignmentList.jsx":16,"./fake-periods.json":25,"classnames":"classnames","prop-types":"prop-types","react":"react","react-modal":"react-modal"}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
var _AssignmentList = _interopRequireDefault(require("./AssignmentList.jsx"));
var assignmentsData = _interopRequireWildcard(require("./fake-assignments.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // TEMPORARY
class AssignmentsTab extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      this.fetchAssignments();
    });
    _defineProperty(this, "fetchAssignments", () => {
      const params = {
        periodId: this.props.periodId
      };
      if (this.props.isPatternlab) {
        // for testing
        this.setState({
          isLoading: false,
          units: assignmentsData.data
        });
      } else {
        fetch(`${this.props.requestUrl}/owh/assignment/GetAssignmentsForPeriod`, {
          method: "POST",
          body: JSON.stringify(params),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => response.json()).then(data => {
          if (data.length === 0) {
            this.setState({
              isLoading: false
            });
            return;
          }
          this.setState({
            isLoading: false,
            units: data.Data
          });
        }).catch(err => {
          console.error(err);
          this.setState({
            isLoading: false
          });
        });
      }
    });
    this.state = {
      units: [],
      isLoading: true
    };
  }
  render() {
    const {
      units,
      isLoading
    } = this.state;
    const {
      periodId,
      periodName,
      requestUrl,
      dictionary,
      isPatternlab,
      isArchived
    } = this.props;
    const displayUnits = !isLoading && units.length > 0;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement(_loading.default, {
      isLoading: isLoading
    }), displayUnits && /*#__PURE__*/_react.default.createElement(_AssignmentList.default, {
      units: units,
      dictionary: dictionary,
      requestUrl: requestUrl,
      periodId: periodId,
      periodName: periodName,
      isPatternlab: isPatternlab,
      isArchived: isArchived
    }));
  }
}
exports.default = AssignmentsTab;
_defineProperty(AssignmentsTab, "propTypes", {
  periodId: _propTypes.string,
  periodName: _propTypes.string,
  requestUrl: _propTypes.string,
  dictionary: _propTypes.object,
  isPatternlab: _propTypes.string,
  isArchived: _propTypes.string
});

},{"../partials/loading.jsx":150,"./AssignmentList.jsx":16,"./fake-assignments.json":24,"classnames":"classnames","prop-types":"prop-types","react":"react"}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  children: _propTypes.node
};
const ListWrapper = props => {
  return /*#__PURE__*/_react.default.createElement("ul", props);
};
ListWrapper.propTypes = propTypes;
var _default = exports.default = ListWrapper;

},{"prop-types":"prop-types","react":"react"}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class TableWrapper extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      children,
      AssignmentLabel,
      ReportsLabel,
      StatusLabel,
      ActionLabel,
      ...otherProps
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("table", otherProps, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
      className: "gv__assignment-list__header-row"
    }, /*#__PURE__*/_react.default.createElement("th", {
      className: "gv__assignment-list__header gv__assignment-list__header--assignment",
      scope: "col",
      id: "assignmentName"
    }, AssignmentLabel), ReportsLabel && /*#__PURE__*/_react.default.createElement("th", {
      className: "gv__assignment-list__header",
      id: "reports",
      scope: "col"
    }, ReportsLabel), /*#__PURE__*/_react.default.createElement("th", {
      className: "gv__assignment-list__header",
      id: "status",
      scope: "col"
    }, StatusLabel), /*#__PURE__*/_react.default.createElement("th", {
      className: "gv__assignment-list__header",
      id: "action",
      scope: "col"
    }, ActionLabel)), children));
  }
}
exports.default = TableWrapper;
_defineProperty(TableWrapper, "propTypes", {
  children: _propTypes.node,
  AssignmentLabel: _propTypes.string,
  ReportsLabel: _propTypes.string,
  StatusLabel: _propTypes.string,
  ActionLabel: _propTypes.string
});

},{"classnames":"classnames","prop-types":"prop-types","react":"react","react-modal":"react-modal"}],22:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _AssignmentsModal = _interopRequireDefault(require("./AssignmentsModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const modals = document.querySelectorAll(".js-manage-assignment-modal-mount");
if (modals) {
  modals.forEach(el => {
    const props = {
      requestUrl: el.dataset.requestUrl || "",
      viewAllUrl: el.dataset.viewAllUrl || "",
      assignmentGuid: el.dataset.assignmentGuid || "",
      modalId: el.dataset.modalId,
      assignmentType: el.dataset.assignmentType || "",
      assignmentName: el.dataset.assignmentName,
      dictionary: JSON.parse(el.dataset.dictionary) || [],
      isPatternlab: el.dataset.isPatternlab || null,
      isArchived: el.dataset.isArchived || null,
      courseId: el.dataset.courseId || ""
    };
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_AssignmentsModal.default, props), el);
  });
}

},{"./AssignmentsModal.jsx":18,"react":"react","react-dom":"react-dom"}],23:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _AssignmentsTab = _interopRequireDefault(require("./AssignmentsTab.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-assignment-list-mount");
if (el) {
  const props = {
    requestUrl: el.dataset.requestUrl || "",
    dictionary: JSON.parse(el.dataset.dictionary) || [],
    periodId: el.dataset.periodId,
    periodName: el.dataset.periodName,
    isPatternlab: el.dataset.isPatternlab || null,
    isArchived: el.dataset.isArchived || null
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_AssignmentsTab.default, props), el);
}

},{"./AssignmentsTab.jsx":19,"react":"react","react-dom":"react-dom"}],24:[function(require,module,exports){
module.exports={
  "data": [
    {
      "UnitTitle": "Unit 1",
      "Assignments": [
        {
          "AssignmentId": 1,
          "AssignmentTitle": "Survey 1",
          "Url": "#",
          "Status": 1,
          "AssignmentType": 2,
          "AssignmentGuid":"testGuid",
          "AssignmentSubmissionsUrl": "#"
        },
        {
          "AssignmentId": 2,
          "AssignmentTitle": "Investigation 2",
          "ReportUrl": "#2report",
          "Url": "#2",
          "Status": 3,
          "AssignmentType": 3,
          "AssignmentGuid":"testGuid",
          "AssignmentSubmissionsUrl": "#"
        },
        {
          "AssignmentId": 3,
          "AssignmentTitle": "Investigation 3",
          "Url": "#3",
          "Status": 2,
          "AssignmentType": 3,
          "AssignmentGuid":"testGuid",
          "AssignmentSubmissionsUrl": "#"
          
        },
        {
          "AssignmentId": 4,
          "AssignmentTitle": "Investigation 4",
          "Url": "#4",
          "Status": 1,
          "AssignmentType": 3,
          "AssignmentGuid":"testGuid",
          "AssignmentSubmissionsUrl": "#"
        }
      ]
    },
    {
      "UnitTitle": "Unit 2",
      "Assignments": [
        {
          "AssignmentId": 1,
          "AssignmentTitle": "Investigation 1",
          "Url": "#",
          "Status": 1,
          "AssignmentType": 3,
          "AssignmentGuid":"testGuid",
          "AssignmentSubmissionsUrl": "#"
        },
        {
          "AssignmentId": 2,
          "AssignmentTitle": "Investigation 2",
          "Url": "#2",
          "ReportUrl": "#2report",
          "Status": 3,
          "AssignmentType": 3,
          "AssignmentGuid":"testGuid",
          "AssignmentSubmissionsUrl": "#"
        },
        {
          "AssignmentId": 3,
          "AssignmentTitle": "Investigation 3",
          "Url": "#3",
          "Status": 2,
          "AssignmentType": 3,
          "AssignmentGuid":"testGuid",
          "AssignmentSubmissionsUrl": "#"
        },
        {
          "AssignmentId": 4,
          "AssignmentTitle": "Investigation 4",
          "Url": "#4",
          "Status": 0,
          "AssignmentType": 3,
          "AssignmentGuid":"testGuid",
          "AssignmentSubmissionsUrl": "#"
        }
      ]
    }
  ]
}

},{}],25:[function(require,module,exports){
module.exports={
  "data": [
    {
      "PeriodTitle": "a Brand New Class",
      "PeriodId": 20160,
      "Url": "/Teacher-Dashboard/Assignment-Details?Period_Id=20160\u0026AssignmentGuid=0307c8e2-411f-4f8e-a7a3-ae508b11954f",
      "Status": 3,
      "AssignmentType": 3,
      "AssignmentId": 60249,
      "AssignmentGuid": "0307c8e2-411f-4f8e-a7a3-ae508b11954f",
      "ReportUrl": "/owh/Report/GetAssignmentReport?Period_Id=20160\u0026Assignment_Id=60249",
      "AssignmentSubmissionsUrl": "/Launch?Period_Id=20160\u0026AssignmentId=60249\u0026AssignmentName=Is it art title 2"
    },
    {
      "PeriodTitle": "Practice Questions Test",
      "PeriodId": 175,
      "Url": "/Teacher-Dashboard/Assignment-Details?Period_Id=175\u0026AssignmentGuid=0307c8e2-411f-4f8e-a7a3-ae508b11954f",
      "Status": 1,
      "AssignmentType": 3,
      "AssignmentId": 50248,
      "AssignmentGuid": "0307c8e2-411f-4f8e-a7a3-ae508b11954f",
      "ReportUrl": "",
      "AssignmentSubmissionsUrl": "/Launch?Period_Id=175\u0026AssignmentId=50248\u0026AssignmentName=Is it art title 2"
    },
    {
      "PeriodTitle": "Student Model",
      "PeriodId": 10160,
      "Url": "/Teacher-Dashboard/Assignment-Details?Period_Id=10160\u0026AssignmentGuid=0307c8e2-411f-4f8e-a7a3-ae508b11954f",
      "Status": 1,
      "AssignmentType": 3,
      "AssignmentId": 60251,
      "AssignmentGuid": "0307c8e2-411f-4f8e-a7a3-ae508b11954f",
      "ReportUrl": "",
      "AssignmentSubmissionsUrl": "/Launch?Period_Id=10160\u0026AssignmentId=60251\u0026AssignmentName=Is it art title 2"
    }
  ]
}

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initAudioPlayer = initAudioPlayer;
//start function
function initAudioPlayer(el) {
  // fetch("https://api.flowplayer.com/platform/v3/videos?page_size=20", {
  //   method: "GET",
  //   credentials: "omit",
  //   headers: {
  //     "Content-Type": "application/json",
  //     "x-flowplayer-api-key": "91537526-5272-4b52-848a-c2136c5660e7"
  //   }
  // })
  //   .then((response) => response.json())
  //   .then((data) => {
  //     console.log({data});
  //   });

  const flowplayerConfig = {
    token: "eyJraWQiOiJuVVJHSncwNjFzUlkiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6NCxcImlkXCI6XCJuVVJHSncwNjFzUllcIn0iLCJpc3MiOiJGbG93cGxheWVyIn0.Q0ETTfgixa1OKG0QPGFkzXj7nxbwvtbwt1fdBZCf1fM5vGMP_jgBH3p5NuTuvCZnwFWvBUBEUeeLAuyqtohYEQ",
    title: el.dataset.playLabel || el.dataset.title,
    hls: {},
    src: el.dataset.audioId,
    plugins: ["audio"]
  };
  const audio = window.flowplayer(el, flowplayerConfig);
  return audio;
}

},{}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backButton;
function backButton(document, window) {
  document.querySelectorAll(".js-material-back-button").forEach((el, index) => {
    el.addEventListener("click", () => {
      window.history.back();
      if (window.localStorage.getItem("modalID")) {
        localStorage.setItem("returnedFromMaterial", "true");
      }
    });
  });
}

},{}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
const backHistory = el => {
  window.addEventListener("load", () => {
    if (window.history.length > 2) {
      el.classList.add("gv__sr-login__back-btn--show");
    } else {
      el.classList.remove("gv__sr-login__back-btn--show");
    }
  });
  el.addEventListener("click", () => {
    window.history.go(-2);
  });
};
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-login-back")].forEach(backHistory);
}

},{}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("prop-types");
var _GlobalHeader = _interopRequireDefault(require("../global-header/GlobalHeader.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {};
const CanvasHeader = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-header"
  }, /*#__PURE__*/_react.default.createElement(_GlobalHeader.default, null));
};
CanvasHeader.propTypes = propTypes;
var _default = exports.default = CanvasHeader;

},{"../global-header/GlobalHeader.jsx":93,"prop-types":"prop-types","react":"react"}],30:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _CanvasHeader = _interopRequireDefault(require("./CanvasHeader.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-canvas-header");
if (el) {
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_CanvasHeader.default, null), el);
}

},{"./CanvasHeader.jsx":29,"react":"react","react-dom":"react-dom"}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CanvasPreview = props => {
  const {
    backClick,
    previewUrl
  } = props;
  const iframeSrc = `${previewUrl}?share=embed`;
  const materialType = "image";
  const btnWrapperClasses = (0, _classnames.default)("gv__canvas-preview__btn-wrapper", {
    "gv__canvas-preview__btn-wrapper--image": materialType === "image",
    "gv__canvas-preview__btn-wrapper--video": materialType === "video"
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-preview"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-preview__btn-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: btnWrapperClasses
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "back",
    type: "button",
    className: "gv__canvas-preview__back-btn",
    onClick: backClick
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "7",
    height: "12",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "#213245",
    strokeWidth: "1.3",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.95 10.95L1 6M5.95 1L1 5.95"
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__canvas-preview__back-btn-txt"
  }, "Back")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-preview__iframe-container"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    className: "gv__canvas-preview__iframe",
    title: "Canvas OER Materials Preview",
    src: iframeSrc,
    width: "1200",
    height: "800",
    frameBorder: "0",
    allowFullScreen: "allowfullscreen"
  })));
};
CanvasPreview.propTypes = {
  backClick: _propTypes.func,
  previewUrl: _propTypes.string
};
var _default = exports.default = CanvasPreview;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],32:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _CanvasPreview = _interopRequireDefault(require("./CanvasPreview.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-canvas-preview");
if (el) {
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_CanvasPreview.default, null), el);
}

},{"./CanvasPreview.jsx":31,"react":"react","react-dom":"react-dom"}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactModal = _interopRequireDefault(require("react-modal"));
var _CanvasPreview = _interopRequireDefault(require("../canvas-preview/CanvasPreview.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CanvasSearchResult = props => {
  const {
    canvasData,
    thumbnail,
    material,
    title,
    summary,
    url,
    courseUnit,
    isPatternlab,
    previewLabel,
    embedLabel,
    actionUrl
  } = props;
  const resultThumbnail = isPatternlab ? "/OWH/assets-build/img/theme-1-image.png" : thumbnail;
  const materialBackground = isPatternlab ? "/OWH/assets-build/img/theme-1-header.png" : material.headerBackground;
  const [isModalOpen, setIsModalOpen] = (0, _react.useState)(false);
  const [courseUnitString, setCourseUnitString] = (0, _react.useState)("");
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };
  (0, _react.useEffect)(() => {
    if (courseUnit && courseUnit.length) {
      // build course unit string
      const formattedStrings = courseUnit.map(unit => {
        // replace dashes with spaces
        // replace pipe with dot
        return unit.replaceAll("-", " ").replaceAll("|", " \u2022 ");
      });
      const joinedStrings = formattedStrings.join(", ");
      setCourseUnitString(joinedStrings);
    }
  }, [courseUnit]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__image-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__type",
    style: materialBackground && {
      backgroundImage: `url(${materialBackground})`
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, material.name || "No Type")), /*#__PURE__*/_react.default.createElement("img", {
    src: resultThumbnail && resultThumbnail,
    alt: "",
    className: "gv__canvas-search-result__image"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__info-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__title"
  }, title), courseUnitString && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__units"
  }, courseUnitString), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__description"
  }, summary), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__btn-wrapper"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: openModal,
    className: "gv__canvas-search-result__preview-btn"
  }, /*#__PURE__*/_react.default.createElement("span", null, previewLabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-result__embed-form"
  }, /*#__PURE__*/_react.default.createElement("form", {
    encType: "application/x-www-form-urlencoded",
    method: "post",
    action: actionUrl && actionUrl,
    id: "embedform"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "lti_message_type",
    value: "ContentItemSelection"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "lti_version",
    value: "LTI-1p0"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "content_items",
    value: canvasData && canvasData
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__canvas-search-result__embed-btn",
    type: "submit",
    value: embedLabel
  }, /*#__PURE__*/_react.default.createElement("span", null, embedLabel)))))), /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: isModalOpen
    // onAfterOpen={afterOpenModal}
    ,
    onRequestClose: closeModal,
    contentLabel: "Materials Viewer"
    // aria-describedby={this.state.longdesc}
    ,
    bodyOpenClassName: null
    // overlayClassName="gv__modal"
    // className={"gv__modal__content"}
    ,
    overlayClassName: "gv__canvas-search-result-modal",
    className: "gv__canvas-search-result-modal__content"
  }, /*#__PURE__*/_react.default.createElement(_CanvasPreview.default, {
    backClick: closeModal,
    previewUrl: url
  })))));
};
CanvasSearchResult.propTypes = {
  canvasData: _propTypes.string,
  thumbnail: _propTypes.string,
  title: _propTypes.string,
  summary: _propTypes.string,
  url: _propTypes.string,
  material: (0, _propTypes.shape)({
    name: _propTypes.string,
    headerBackground: _propTypes.string
  }),
  isPatternlab: _propTypes.bool,
  previewLabel: _propTypes.string,
  embedLabel: _propTypes.string,
  actionUrl: _propTypes.string,
  courseUnit: _propTypes.array
};
var _default = exports.default = CanvasSearchResult;

},{"../canvas-preview/CanvasPreview.jsx":31,"prop-types":"prop-types","react":"react","react-modal":"react-modal"}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _CanvasSearchResult = _interopRequireDefault(require("./CanvasSearchResult.jsx"));
var _lodash = _interopRequireDefault(require("lodash.uniqueid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CanvasSearchResults = props => {
  const {
    isPatternlab,
    previewLabel,
    embedLabel,
    actionUrl,
    emptyResults
  } = props;
  const results = isPatternlab ? window.canvasSearchData.Results : props.results;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-results"
  }, results.length > 0 ? results.map(result => {
    return /*#__PURE__*/_react.default.createElement(_CanvasSearchResult.default, _extends({
      key: (0, _lodash.default)(result.id),
      isPatternlab: isPatternlab,
      previewLabel: previewLabel,
      embedLabel: embedLabel,
      actionUrl: actionUrl
    }, result));
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-results--none"
  }, emptyResults || "No results found"));
};
CanvasSearchResults.propTypes = {
  isPatternlab: _propTypes.bool,
  results: _propTypes.array,
  previewLabel: _propTypes.string,
  embedLabel: _propTypes.string,
  actionUrl: _propTypes.string,
  emptyResults: _propTypes.string
};
var _default = exports.default = CanvasSearchResults;

},{"./CanvasSearchResult.jsx":33,"lodash.uniqueid":"lodash.uniqueid","prop-types":"prop-types","react":"react"}],35:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _CanvasSearchResults = _interopRequireDefault(require("./CanvasSearchResults.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-canvas-search-results-mount");
if (el) {
  const props = {
    isPatternlab: el.dataset.isPatternlab ? JSON.parse(el.dataset.isPatternlab) : false
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_CanvasSearchResults.default, props), el);
}

},{"./CanvasSearchResults.jsx":34,"react":"react","react-dom":"react-dom"}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cardInteraction;
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
//global variables for managing state because I didn't think this needed to be a react app when I first made this for some reason.
let CARD_CONTAINER;
let CONTENT_OPEN;
let CONTENT_OPEN_TYPE;
let IS_MOBILE;
let CARD_TRIGGER;
const openClass = "card-is-open";
const contentOpenClass = "content-is-open";
const movedClass = "card-has-moved";
const lastCardClass = "gv__material-card__last";
const secondLastCardClass = "gv__material-card__second-last";
let styleBuffer = setTimeout(() => {}, 1);
function cardInteraction() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  // Handle card contents toggle buttons
  const toggleButtons = document.querySelectorAll(".js-gv-material-card__btn");
  if (!toggleButtons) {
    return;
  }
  [...toggleButtons].forEach((button, index) => {
    button.addEventListener("click", e => {
      const is5050ModalButton = button.classList.contains("js-manual-modal-toggle");
      e.preventDefault();
      const targetContainer = e.target.closest(".js-gv__material-card__container");
      let openCardTimeout;

      //setting global state variables
      CARD_CONTAINER = CARD_CONTAINER || targetContainer;
      CONTENT_OPEN = CONTENT_OPEN || CARD_CONTAINER.querySelector(`.${contentOpenClass}`);
      const isOpen = CARD_CONTAINER.classList.contains(openClass);
      const type = button.dataset.contentType;
      if (!is5050ModalButton) {
        clearTimeout(openCardTimeout);
        //set content type as the global if one hasn't already been set
        if (CONTENT_OPEN_TYPE === null && targetContainer.querySelector(`.${contentOpenClass}`)) {
          CONTENT_OPEN_TYPE = targetContainer.querySelector(`.${contentOpenClass}`).dataset.contentType;
        }
        if (CONTENT_OPEN) {
          CONTENT_OPEN.style.display = "none";
        }
        const materialCard = CARD_CONTAINER.querySelector(".js-material-card");
        const is5050Promo = materialCard.classList.contains("js-material-card-50-50");
        const contentIsOpen = targetContainer.querySelector(`div[data-content-type=${type}]`).classList.contains(contentOpenClass);

        // want to make sure we're not moving the card around if its content in the same flyout.
        //We only want to do this on desktop to prevent extra close animation on mobile
        if (isOpen && CONTENT_OPEN_TYPE === type && !IS_MOBILE) {
          closeCard(e, type, false);

          //if we're clicking on content that's already open, we want to completely reset the card.
          if (contentIsOpen) {
            resetPosition();
            CONTENT_OPEN && CONTENT_OPEN.removeAttribute("style");
          }
        } else {
          //check if other content on the card is open and it's not mobile to close it.
          if (CONTENT_OPEN_TYPE && !IS_MOBILE) {
            closeCard(e, CONTENT_OPEN_TYPE, false);
            // toggleButtons.setAttribute("aria-expanded", false);
          }
        }
        const id = targetContainer.getAttribute("id");
        if (!contentIsOpen) {
          //this window object is defined in the download interaction app. We need a way for the app to know when the card is open to render the new google button
          window[`openCard${id}`].setCardType(type);
          openCard(e, type);
          CARD_TRIGGER = button;
        } else {
          // if content is duplicate, reset the content open type to null
          window[`openCard${id}`].setCardType(null);
          CONTENT_OPEN_TYPE = null;
          CONTENT_OPEN && CONTENT_OPEN.removeAttribute("style");
          CARD_TRIGGER = null;
        }
      } else {
        const id = targetContainer.getAttribute("id");
        window[`openCard${id}`].setCardType(type);
        CARD_TRIGGER = button;
        const closModalButton = targetContainer.querySelector(".js-close-manual-modal");
        closModalButton.addEventListener("click", e => {
          e.preventDefault();
          closeCard(e);
        });
      }
    });
  });

  // Handle close buttons
  const closeButtons = document.querySelectorAll(".js-gv__material-card__close") || [];
  [...closeButtons].forEach((button, index) => {
    button.addEventListener("click", e => {
      e.preventDefault();
      closeCard(e);
    });
  });
  window.addEventListener("load", () => {
    closeAll();
    findMovableCards();
    IS_MOBILE = window.innerWidth < 600;
  });
  window.addEventListener("resize", () => {
    closeAll();
    findMovableCards();
    IS_MOBILE = window.innerWidth < 600;
  });

  //listen for escape key press
  if (document.querySelectorAll(".gv__material-card-flyout__section").length) {
    document.querySelector("body").addEventListener("keyup", e => {
      if (e.key === "Escape") {
        const type = e.target.closest(".gv__material-card-flyout__section") && e.target.closest(".gv__material-card-flyout__section").dataset.contentType;
        type && closeCard(e, type);
      }
    });
  }

  //add classes to cards that need to move
  function findMovableCards() {
    document.querySelectorAll(".js-gv__material-card-row").forEach(row => {
      let items = [];
      let measurements = [];
      row.querySelectorAll(".js-gv__material-card__container").forEach(div => {
        div.classList.remove(lastCardClass, secondLastCardClass);
        let leftPosition = row.offsetWidth - div.getBoundingClientRect().left;
        items.push({
          div: div,
          leftPosition: leftPosition
        });
        measurements.push(leftPosition);
      });
      const investigationCard = row.querySelector(".js-investigation");
      let investigationCardPosition = 0;
      let uniqueSet = new Set(measurements);
      let uniqueValues = [...uniqueSet].sort(function (a, b) {
        return a - b;
      });
      let lowestValue = uniqueValues[0];
      let secondLowestValue = uniqueValues[1];
      let lastClass = R.filter(R.propEq("leftPosition", lowestValue), items);
      let secondLastClass = R.filter(R.propEq("leftPosition", secondLowestValue), items);
      if (investigationCard) {
        investigationCardPosition = row.offsetWidth - investigationCard.getBoundingClientRect().left;
      }

      //only going to add the last class if there are more than 1 in the array and the lowest value isn't next to an investigation card
      if (measurements.length > 1) {
        if (investigationCardPosition && lowestValue < investigationCardPosition || investigationCardPosition === 0) {
          lastClass.forEach(obj => obj.div.classList.add(lastCardClass));
        }
      }
      if (measurements.length > 2) {
        secondLastClass.forEach(obj => {
          obj.div !== items[0].div && obj.div.classList.add(secondLastCardClass);
        });
      }
    });
  }

  //display the content after the flyout is open
  function showContent(cardContainer, type) {
    const content = cardContainer.querySelector(".gv__material-card-flyout__section[data-content-type=" + type + "]");
    const cardFlyout = cardContainer.querySelector(".js-gv__material-card__flyout");
    let selectable = content.querySelectorAll("a, button, input");
    let closeButton = content.querySelector(".js-gv__material-card__close");
    clearTimeout(styleBuffer);
    CONTENT_OPEN && CONTENT_OPEN.removeAttribute("style");
    styleBuffer = setTimeout(() => {
      content.focus();
      content.addEventListener("keydown", e => closeOnShiftTab(e));
    }, 600);
    closeButton.addEventListener("keydown", e => closeOnShiftTab(e));
    selectable[selectable.length - 1].addEventListener("keydown", e => {
      e.key === "Tab" && e.target.closest(".gv__material-card-flyout__section").focus();
    });
    if (selectable[selectable.length - 1].disabled) {
      // if the final button is disabled, we want to add the event listener to the last.
      selectable[selectable.length - 2].addEventListener("keydown", e => {
        // have to double check in case the status has changed
        if (selectable[selectable.length - 1].disabled) {
          e.target.closest(".gv__material-card-flyout__section").focus();
        }
      });
    }

    // if content is already active do nothing more
    if (content && content.classList.contains(contentOpenClass)) {
      return;
    }
    content.classList.add(contentOpenClass);
    cardContainer.classList.add(openClass);
    cardFlyout.setAttribute("aria-hidden", false);
    //update CONTENT_OPEN global variable
    CONTENT_OPEN = content;
    //if it's a card that has to move, we need to add a separate "moved" class to it so it doesn't move back when clicking between content on the same card.
    if (cardContainer.classList.contains(secondLastCardClass) || cardContainer.classList.contains(lastCardClass)) {
      cardContainer.classList.add(movedClass);
    }
  }

  //handle open click on the icons
  function openCard(e, type) {
    const target = e.target;
    target.closest(".js-gv-material-card__btn").setAttribute("aria-expanded", true);
    const cardContainer = target.closest(".js-gv__material-card__container");
    let showContentTimer;
    CONTENT_OPEN_TYPE = type;

    // remove any other open ones
    if (CARD_CONTAINER !== cardContainer) {
      closeAll();
    }
    clearTimeout(showContentTimer);
    showContentTimer = setTimeout(function () {
      showContent(cardContainer, type);
    }, 300);

    //update card container global variable
    CARD_CONTAINER = cardContainer;
  }

  //close known card so we know where to put the focus
  // transition is an optional variable for whether or not we apply position to the card
  function closeCard(e, type, transition) {
    [...toggleButtons].forEach(button => button.setAttribute("aria-expanded", false));
    clearTimeout(styleBuffer);
    const cardContainer = e.target.closest(".js-gv__material-card__container");
    const card = cardContainer.querySelector(".js-material-card");
    if (transition === false && type !== null && !IS_MOBILE) {
      cardContainer.classList.remove(openClass);
      const currentOpenContent = cardContainer.querySelector(`.${contentOpenClass}`);
      currentOpenContent && currentOpenContent.classList.remove(contentOpenClass);
    } else {
      closeAll();
      // styleBuffer = setTimeout(() => {
      cardContainer.removeAttribute("style");
      card.removeAttribute("style");
      CARD_TRIGGER.focus();
      // }, 50);
    }
    cardContainer.style.zIndex = 9;
    card.style.zIndex = 9;
  }

  //move all cards back to it's beginning position
  function resetPosition() {
    document.querySelectorAll(`.${movedClass}`).forEach(div => {
      div.classList.remove(movedClass);
    });
    [...toggleButtons].forEach(button => button.setAttribute("aria-expanded", false));
  }

  //close all cards
  function closeAll() {
    resetPosition();
    document.querySelectorAll(`.${openClass}`).forEach(div => {
      const getCurrentContainerId = div.closest(".js-gv__material-card__container") && div.closest(".js-gv__material-card__container").getAttribute("id");
      const getCurrentTargetId = document.activeElement.closest(".js-gv__material-card__container") && document.activeElement.closest(".js-gv__material-card__container").getAttribute("id");
      div.classList.remove(openClass);
      div.querySelector(".js-gv__material-card__flyout").setAttribute("aria-hidden", true);
      let selectableArr = div.querySelectorAll("a, input, button");
      selectableArr[0].removeEventListener("keyup", closeOnShiftTab);
      getCurrentContainerId === getCurrentTargetId && selectableArr[0].focus();
    });
    document.querySelectorAll(`.${contentOpenClass}`).forEach(div => {
      div.classList.remove(contentOpenClass);
    });
    document.querySelectorAll(".js-material-card, [class*='js-gv__material-card']").forEach(div => {
      div.removeAttribute("style");
    });
  }
  function closeOnShiftTab(e) {
    if (e.key === "Tab" && e.shiftKey) {
      e.preventDefault();
      closeAll();
      CARD_TRIGGER && CARD_TRIGGER.focus();
    }
  }
}

},{"ramda":"ramda"}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _d3Selection = require("d3-selection");
var _d3Scale = require("d3-scale");
var _d3Array = require("d3-array");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  create: function (config) {
    const {
      el,
      data,
      investigationId,
      label
    } = config;
    const container = (0, _d3Selection.select)(el);
    const dimensions = el.getBoundingClientRect();
    const svg = container.append("svg").attr("width", dimensions.width).attr("height", dimensions.height).attr("class", "distribution gv__report-graph__distribution-container");
    const margin = {
      top: 0,
      right: 30,
      bottom: 30,
      left: 0
    };
    const width = dimensions.width - margin.left - margin.right;
    const height = dimensions.height - margin.top - margin.bottom;
    const xScale = (0, _d3Scale.scaleLinear)().domain([0, (0, _d3Array.max)(data)]).rangeRound([0, width]);
    const yScale = (0, _d3Scale.scaleBand)().domain([0, 1, 2, 3, 4]) // matches d3Bar
    .rangeRound([height, 0]);
    const yBandwidth = 16;
    const g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")").attr("height", height);

    // title
    g.append("text").attr("class", "chart__label gv__report-graph__distribution-label").text(label);
    g.append("line").attr("stroke", "currentColor").attr("stroke-width", "1").attr("x2", "140").attr("transform", "translate(0, 2)");

    // bar enter
    const barsG = g.selectAll(".bar__bar").data(data).attr("class", (d, i) => (0, _classnames.default)("bar__bar", {
      "is-current": investigationId === i
    })).enter().append("g");

    // bar rect
    barsG.append("rect").attr("x", (d, i) => 0).attr("y", (d, i) => yScale(i) - yBandwidth / 2).attr("width", d => xScale(d)).attr("height", yBandwidth);

    // y axis labels
    barsG.append("text").text(d => d === 0 ? "" : d).attr("class", "chart__label").attr("text-anchor", "start").style("fill", "black").attr("dx", "0.3em").attr("dy", "0.32em").attr("x", (d, i) => xScale(d)).attr("y", (d, i) => yScale(i));
  }
};

},{"classnames":"classnames","d3-array":"d3-array","d3-scale":"d3-scale","d3-selection":"d3-selection"}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ramda = _interopRequireDefault(require("ramda"));
var _classnames = _interopRequireDefault(require("classnames"));
var _d3Selection = require("d3-selection");
var _d3Scale = require("d3-scale");
var _d3Axis = require("d3-axis");
var _d3Shape = require("d3-shape");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  create: function (config) {
    const {
      el,
      data,
      investigationId,
      label,
      color,
      labelledBy
    } = config;
    const container = (0, _d3Selection.select)(el);
    const dimensions = el.getBoundingClientRect();
    const tooltip = (0, _d3Selection.select)("body").append("div").attr("class", "gv__tooltip");
    const height = 120;
    const svg = container.append("svg").attr("width", dimensions.width).attr("height", height).attr("class", "gv__average-chart").attr("aria-labelledby", labelledBy);
    const cleanBarData = data;
    const margin = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 20
    };
    const width = dimensions.width - margin.left - margin.right;
    const rectangleWidth = width / 2 / cleanBarData.length;
    const findAvg = cleanBarData.map((x, i) => x.average && parseFloat(x.average).toFixed(2));
    const avgData = findAvg.filter(x => x);
    const xScale = (0, _d3Scale.scaleBand)().domain(cleanBarData.map((d, i) => i))
    // .range([0, width - (margin.left * 2)])
    .range([0, width]).paddingOuter(0).paddingInner(0).align(0);
    const yScale = (0, _d3Scale.scaleLinear)().domain([0, 5]) // 5 instead of 4 for padding
    .rangeRound([height, 0]);
    const g = svg.append("g");
    const xAxis = g.append("g").attr("class", "gv__average-chart__axis gv__average-chart__axis--x")
    // .attr("transform", `translate(${margin.left}, ${height})`);
    .attr("transform", `translate(0, ${height})`);

    // x axis label
    xAxis.call((0, _d3Axis.axisBottom)(xScale).tickFormat(i => data[i].name).tickSizeOuter(0)).selectAll(".tick text").attr("style", `transform: translateX(-${rectangleWidth / 2}px);`);
    const yAxis = g.append("g").attr("class", "gv__average-chart__axis gv__average-chart__axis--y").call((0, _d3Axis.axisLeft)(yScale).tickValues([0, 1, 2, 3, 4]).tickFormat(d => d).tickSize(0).tickSizeInner(-width).tickPadding(8)).call(g => g.select(".domain").remove()).call(g => g.selectAll(".tick:not(:first-of-type) line").attr("stroke-opacity", 0.5).attr("stroke-dasharray", "2,2"));
    const bars = g.append("g").attr("class", "gv__average-chart__bars");
    // .attr("transform", `translate(${margin.left},0)`);
    // .attr("transform", `translate(0, ${0})`);
    // .attr("transform", `translate(${width/2 - cleanBarData.length * 8}, ${0})`);

    const lines = (0, _d3Shape.line)().x((d, i) => xScale(i)).y(d => yScale(d));
    // .curve(curveMonotoneX);

    const pattern = bars.append("pattern").attr("id", "stripes").attr("patternUnits", "userSpaceOnUse").attr("width", "6").attr("height", "6").attr("patternTransform", "rotate(48)");
    pattern.append("line").attr("x1", 0).attr("x2", 0).attr("y", 0).attr("y2", "12").attr("stroke", color).attr("stroke-width", "1");

    //we're doubling the pattern because rotating makes the color appear lighter and i'm a hack
    pattern.append("line").attr("x1", 0).attr("x2", 0).attr("y", 0).attr("y2", "12").attr("stroke", color).attr("stroke-width", "1");
    bars.selectAll(".gv__average-chart__bar").data(cleanBarData).enter().append("rect").attr("class", (d, i) => (0, _classnames.default)("gv__average-chart__bar gv__average-chart__stripes", {
      "is-current": investigationId === i
    })).attr("fill", (d, i) => d.current === "true" ? d.color : "url(#stripes)").attr("tabindex", "0").attr("aria-describedby", (d, i) => d.tooltip).attr("x", (d, i) => xScale(i)).attr("y", (d, i) => yScale(d.value)).attr("width", rectangleWidth)
    // .attr("transform", `translate(${margin.left}, 0)`)
    .attr("height", d => height - yScale(d.value)).on("mousemove", function (d) {
      const boundingRect = _d3Selection.event.target.getBoundingClientRect();
      //this is kinda magic math but go with it. Unless you have a better solution then please fix it
      const leftPosition = rectangleWidth > 75 ? boundingRect.left - rectangleWidth / 5 : boundingRect.left - rectangleWidth / 2;
      tooltip.attr("role", "tooltip").style("left", `${leftPosition}px`).style("top", boundingRect.bottom + window.scrollX + 15 + "px").style("display", "inline-block").html(d.tooltip);
    }).on("focus", function (d) {
      const boundingRect = _d3Selection.event.target.getBoundingClientRect();
      tooltip.attr("role", "tooltip").style("left", boundingRect.left - rectangleWidth / 2 + "px").style("top", boundingRect.bottom + window.scrollX + 15 + "px").style("display", "inline-block").html(d.tooltip);
    }).on("mouseout", function (d) {
      tooltip.style("display", "none").style("left", "auto").style("top", "auto");
    }).on("blur", function (d) {
      tooltip.style("display", "none").style("left", "auto").style("top", "auto");
    });

    // console.log({cleanBarData})
    //     cleanBarData.map((d, i) =>  {
    //       console.log(d,i, d.value)
    // return      g
    //         .append("button")
    //         .attr("aria-label", "toggle question text")
    //       .attr("style",  `transform: translate(${xScale(i)}px, ${d && yScale(d.value)}px)`)
    //       .attr("width", rectangleWidth)
    //       // .attr("transform", `translate(${margin.left}, 0)`)
    //       .attr("height", (d) => d && height - yScale(d.value))
    //         .on("click", function (d) {
    //           const boundingRect = event.target.getBoundingClientRect();
    //           tooltip
    //             .style("left", boundingRect.left - rectangleWidth / 2 + "px")
    //             .style("top", boundingRect.bottom + window.scrollX + 15 + "px")
    //             .style("display", "inline-block")
    //             .html(d.tooltip);
    //         })}
    //     );

    //line graph if there is avgData
    avgData && g.append("path").attr("class", "gv__average-chart__line-graph").attr("d", lines(avgData)).attr("transform", `translate(${rectangleWidth / 2}, 0)`).attr("fill", "transparent").attr("stroke", "#a8a8a8");
    avgData && avgData.map((d, i) => {
      return g.append("circle").attr("class", "gv__average-chart__dot").attr("transform", `translate(${rectangleWidth / 2}, 0)`).attr("fill", color).attr("stroke", "#fff").attr("cx", xScale(parseInt(i))).attr("cy", yScale(parseFloat(d).toFixed(2))).attr("r", 5);
    });
  }
};

},{"classnames":"classnames","d3-axis":"d3-axis","d3-scale":"d3-scale","d3-selection":"d3-selection","d3-shape":"d3-shape","ramda":"ramda"}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _validation = require("./validation");
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  let requestURL = "";
  document.querySelectorAll(".js-class-fieldset").forEach(el => {
    const countryfield = el.querySelector(".js-class-fieldset-country");
    const zipInput = el.querySelector(".js-class-fieldset-zipcode");
    const nameInput = el.querySelector(".js-class-fieldset-name-input");
    const nameSelect = el.querySelector(".js-class-fieldset-name-select");
    const cityInput = el.querySelector(".js-class-fieldset-city");
    const stateSelect = el.querySelector(".js-class-fieldset-state-select");
    const stateInput = el.querySelector(".js-class-fieldset-state-input");
    const schoolIdInput = el.querySelector(".js-class-fieldset-school-id-input");
    const districtInput = el.querySelector(".js-class-fieldset-district-input");
    const schoolTypeSelect = el.querySelector(".js-class-fieldset-role");
    const schoolTypeInput = el.querySelector(".js-class-fieldset-school-type-input");
    const gradesTaught = el.querySelector(".js-stored-checkbox-values");
    const hiddenGradesTaught = el.querySelector(".js-class-fieldset-gradesTaught-field-input");
    const editButton = el.querySelector(".js-edit-button");
    const cancelButton = el.querySelector(".js-cancel-button");
    const submitButton = el.querySelector(".js-submit-school-details");

    //this value needs to be grabbed from another form, this is why we are using document instead of el
    const getGradesTaught = document.querySelector(".js-stored-checkbox-values");
    if (getGradesTaught) {
      const getGradesTaughtArray = JSON.parse(getGradesTaught.value);
      hiddenGradesTaught.setAttribute("data-saved-value", getGradesTaughtArray.join(","));
      getGradesTaught.addEventListener("change", e => {
        let updatedGradesTaught = JSON.parse(getGradesTaught.value);
        hiddenGradesTaught.setAttribute("data-saved-value", updatedGradesTaught.join(","));
      });
    }
    var populateMigratedData = el.querySelector("#Is_Migrated_User") !== null && el.querySelector("#Is_Migrated_User").value === "True";
    requestURL = el.dataset.requestUrl || requestURL;
    let countryValue = "";
    let schoolList = [];
    populateCountries();
    function enableFields(populatingMigratedData) {
      countryfield.removeAttribute("disabled");
      schoolTypeSelect.removeAttribute("disabled");
      zipInput.removeAttribute("disabled");
      nameInput.removeAttribute("disabled");
      nameInput.removeAttribute("readonly");
      cityInput.removeAttribute("disabled");
      stateInput.removeAttribute("disabled");
      if (countryfield.parentElement?.classList.contains("is-disabled")) {
        countryfield.parentElement.classList.remove("is-disabled");
      }
      if (schoolTypeSelect.parentElement?.classList.contains("is-disabled")) {
        schoolTypeSelect.parentElement.classList.remove("is-disabled");
      }
      editButton.setAttribute("disabled", " ");
    }
    function disableFields() {
      countryfield.setAttribute("disabled", " ");
      schoolTypeSelect.setAttribute("disabled", " ");
      zipInput.setAttribute("disabled", " ");
      nameInput.setAttribute("disabled", " ");
      nameInput.setAttribute("readonly", " ");
      nameInput.setAttribute("type", "text");
      cityInput.setAttribute("disabled", " ");
      if (stateInput) {
        stateInput.setAttribute("disabled", " ");
      }
      if (stateSelect) {
        stateInput.setAttribute("type", "text");
        stateInput.setAttribute("disabled", " ");
      }
      setFieldsOriginalValues();
      if (!countryfield.parentElement?.classList.contains("is-disabled")) {
        countryfield.parentElement.classList.add("is-disabled");
      }
      if (!schoolTypeSelect.parentElement?.classList.contains("is-disabled")) {
        schoolTypeSelect.parentElement.classList.add("is-disabled");
      }
      editButton.removeAttribute("disabled");
    }
    if (editButton) {
      editButton.addEventListener("click", e => {
        e.target.classList.add("hide");
        cancelButton.classList.add("show");
        submitButton.classList.remove("hide");

        //this needs to be set in any event the cancel button is used and this value needs to be reset
        const countryfieldValue = countryfield.value;
        countryfield.setAttribute("data-original-value", countryfieldValue);
        countryfield.selectedIndex = 0;
        const schoolTypeSelectValue = schoolTypeSelect.value;
        schoolTypeSelect.setAttribute("data-original-value", schoolTypeSelectValue);
        schoolTypeSelect.selectedIndex = 0;
        zipInput.value = "";
        nameInput.value = "";
        cityInput.value = "";
        stateInput.value = "";
        enableFields();
      });
    }
    if (cancelButton) {
      cancelButton.addEventListener("click", e => {
        editButton.classList.remove("hide");
        cancelButton.classList.remove("show");
        submitButton.classList.add("hide");
        if (!submitButton.disabled) {
          submitButton.setAttribute("disabled", "");
        }
        disableFields();
      });
    }
    function onSchoolTypeChange(populatingMigratedData) {
      zipInput.value = "";
      nameInput.value = "";
      stateInput.value = "";
      cityInput.value = "";
      stateInput.setAttribute("type", "input");
      nameInput.setAttribute("type", "input");
      const selectValueText = schoolTypeSelect.options[schoolTypeSelect.selectedIndex].text;

      //if the user selects the school type of Home School or Other
      if (schoolTypeSelect.value === "280560002" || schoolTypeSelect.value === "280560003") {
        cityInput.removeAttribute("readonly");
        nameInput.removeAttribute("readonly");
        nameInput.value = selectValueText === "Other / Not Applicable" ? "Other / Not Applicable" : "Home School";
        nameInput.setAttribute("type", "text");
        schoolIdInput.value = "";
        if (populatingMigratedData) {
          cityInput.value = cityInput.dataset.originalValue;
          stateInput.value = stateInput.dataset.originalValue;
        }
        if (countryfield.value === "Australia" || countryfield.value === "Canada" || countryfield.value === "United States") {
          populateProvidence(countryfield.value, populatingMigratedData);
        }
        stateInput.setAttribute("type", "hidden");
        stateInput.removeAttribute("readonly");
      } else if (selectValueText !== "" && selectValueText >= 0 && selectValueText < schoolList.length) {
        cityInput.setAttribute("readonly", true);
        stateInput.setAttribute("readonly", true);
        stateInput.setAttribute("type", "text");
        nameInput.value = schoolList[selectValueText].Name;
        zipInput.value = schoolList[selectValueText].Zip;
        cityInput.value = schoolList[selectValueText].City;
        stateInput.value = schoolList[selectValueText].State;
        schoolIdInput.value = schoolList[selectValueText].GsId;
        districtInput.value = schoolList[selectValueText].District;
        schoolTypeInput.value = schoolList[selectValueText].SchoolType;
        stateInput.setAttribute("type", "text");
        (0, _validation.forceValidation)(nameInput, el.closest("form"));
      }
    }
    if (schoolTypeSelect) {
      schoolTypeSelect.addEventListener("change", e => {
        onSchoolTypeChange(false);
      });
    }
    if (countryfield) {
      countryfield.addEventListener("change", e => {
        onCountryChange();
      });
    }
    function onCountryChange(populatingMigratedData) {
      if (submitButton) {
        submitButton.removeAttribute("disabled");
      }
      if (zipInput.closest(".js-form-required").classList.contains("has-error")) {
        zipInput.closest(".js-form-required").classList.remove("has-error");
      }
      makeFieldsReadonly();
      stateInput.setAttribute("type", "input");
      nameInput.setAttribute("type", "input");
      countryValue = countryfield.value;
      switch (countryValue) {
        case "Australia":
          zipInput.setAttribute("data-type", "zip");
          break;
        case "Canada":
          makeFieldsEditable();
          if (populatingMigratedData) {
            populateMigratedInputData();
          }
          populateProvidence(countryValue, populatingMigratedData);
          stateInput.setAttribute("type", "hidden");
          zipInput.setAttribute("data-type", "zip");
          break;
        case "United States":
          zipInput.removeAttribute("readonly");
          zipInput.setAttribute("data-type", "zip-us");
          if (populatingMigratedData) {
            zipInput.value = zipInput.dataset.originalValue;
            populateSchoolNames(populatingMigratedData);
          }
          break;
        case "":
          break;
        default:
          zipInput.setAttribute("data-type", "zip");
          makeFieldsEditable();
          if (populatingMigratedData) {
            populateMigratedInputData();
          }
      }
    }
    if (stateSelect) {
      stateSelect.addEventListener("change", e => {
        if (submitButton) {
          submitButton.removeAttribute("disabled");
        }
        stateInput.value = stateSelect.value;
        (0, _validation.forceValidation)(stateInput, el.closest("form"));
      });
    }
    if (zipInput) {
      zipInput.addEventListener("keyup", e => {
        //if no countryValue set, set one now.
        if (!countryValue || countryValue.trim() == "") {
          countryValue = countryfield.value;
        }
        populateSchoolNames();
      });
    }
    if (nameSelect) {
      nameSelect.addEventListener("change", e => {
        onNameChange();
      });
    }
    function onNameChange(populatingMigratedData) {
      if (submitButton) {
        submitButton.removeAttribute("disabled");
      }
      const nameValue = nameSelect.value;
      nameInput.value = "";
      cityInput.value = "";
      stateInput.value = "";
      schoolIdInput.value = "";
      districtInput.value = "";
      schoolTypeInput.value = "";
      if (nameValue === "") {
        return;
      }
      if (nameValue === "HOME" || nameValue === "OTHER") {
        cityInput.removeAttribute("readonly");
        nameInput.removeAttribute("readonly");
        nameInput.value = nameValue === "OTHER" ? "Other" : "Home School";
        nameInput.setAttribute("type", "text");
        schoolIdInput.value = "";
        if (populatingMigratedData) {
          cityInput.value = cityInput.dataset.originalValue;
          stateInput.value = stateInput.dataset.originalValue;
        }
        populateProvidence(countryValue, populatingMigratedData);
        stateInput.setAttribute("type", "hidden");
        stateInput.removeAttribute("readonly");
      } else if (nameValue >= 0 && nameValue < schoolList.length) {
        cityInput.setAttribute("readonly", true);
        stateInput.setAttribute("readonly", true);
        stateInput.setAttribute("type", "text");
        nameInput.value = schoolList[nameValue].Name;
        zipInput.value = schoolList[nameValue].Zip;
        cityInput.value = schoolList[nameValue].City;
        stateInput.value = schoolList[nameValue].State;
        schoolIdInput.value = schoolList[nameValue].GsId;
        districtInput.value = schoolList[nameValue].District;
        schoolTypeInput.value = schoolList[nameValue].SchoolType;
        (0, _validation.forceValidation)(nameInput, el.closest("form"));
      }
    }
    function populateSchoolNames(populatingMigratedData) {
      //RegEx to check for any letters
      var regExp = /[a-zA-Z]/g;
      /** This function (populateSchoolNames) runs on keyUp or the zip input.
       * The following if statement checks to see if any letters are used on each key up or if there are 5 or more characters 
       * If so, then forceValidation runs, if forceValidation returns false then return the function and do not call the API, 
       * if true continue the function and call the API.
       * */
      if (countryValue === "United States" && regExp.test(zipInput.value) || countryValue === "United States" && zipInput.value.length > 5) {
        if (!(0, _validation.forceValidation)(zipInput, el.closest("form"))) {
          return;
        }
      }
      if (zipInput.value.trim().length < 5 || countryValue !== "United States") {
        return;
      }
      if (schoolTypeSelect.value === "280560002" || schoolTypeSelect.value === "280560003") {
        return;
      }
      const zipValue = zipInput.value.slice(0, 5);
      fetchSchoolNames(zipValue, hiddenGradesTaught.dataset.savedValue).then(function (data) {
        schoolList = data;
        nameSelect.innerHTML = "<option></option>";
        const selectSchool = document.createElement("option");
        document.createElement("option");
        selectSchool.textContent = "Select School";
        selectSchool.value = "";
        selectSchool.setAttribute("selected", "true");
        nameSelect.append(selectSchool);
        schoolList.map((school, i) => {
          const option = document.createElement("option");
          option.textContent = school.Name;
          option.value = i;
          if (populatingMigratedData && nameInput.dataset.originalValue === option.textContent) {
            option.setAttribute("selected", "true");
          }
          nameSelect.append(option);
        });
        const otherSchool = document.createElement("option");
        otherSchool.textContent = "-- Other / Not Applicable";
        otherSchool.value = "OTHER";
        if (populatingMigratedData && nameInput.dataset.originalValue === otherSchool.textContent) {
          otherSchool.setAttribute("selected", "true");
        }
        nameSelect.append(otherSchool);
        nameInput.setAttribute("type", "hidden");
        nameInput.value = "";
        cityInput.value = "";
        stateInput.value = "";
        onNameChange(populatingMigratedData);
      });
    }
    function populateCountries() {
      fetch(`${requestURL}/owh/school/countries`).then(response => response.json()).then(function (data) {
        const selectedValue = countryfield.dataset.value;
        data.map(country => {
          const option = document.createElement("option");
          option.textContent = country.CountryName;
          option.value = country.CountryName;
          if (country.CountryName === selectedValue) {
            option.setAttribute("selected", "true");
          }
          countryfield.append(option);
        });
        if (populateMigratedData) {
          onCountryChange(true);
        }
      }).catch(error => {
        console.error("There has been a problem accessing user data.  Support personnel have been notified .");
      });
    }
    function populateProvidence(country, populatingMigratedData) {
      fetch(`${requestURL}/owh/school/StatesByCountry?country=${country}`).then(response => response.json()).then(function (data) {
        stateSelect.innerHTML = "<option></option>";
        data.map(state => {
          const option = document.createElement("option");
          option.textContent = state.StateProvince;
          option.value = state.Abbreviation;
          stateSelect.append(option);
          if (populatingMigratedData && stateInput.dataset.originalValue === option.value) {
            option.setAttribute("selected", "true");
          }
        });
      }).catch(error => {
        console.error("There has been a problem accessing user data.  Support personnel have been notified .");
      });
    }
    function populateMigratedInputData() {
      zipInput.value = zipInput.dataset.originalValue;
      nameInput.value = nameInput.dataset.originalValue;
      cityInput.value = cityInput.dataset.originalValue;
      stateInput.value = stateInput.dataset.originalValue;
    }
    function makeFieldsReadonly() {
      schoolTypeSelect.value = "";
      stateInput.setAttribute("readonly", true);
      stateInput.value = "";
      zipInput.setAttribute("readonly", true);
      zipInput.value = "";
      nameInput.setAttribute("readonly", true);
      nameInput.value = "";
      cityInput.setAttribute("readonly", true);
      cityInput.value = "";
      schoolIdInput.value = "";
      districtInput.value = "";
      schoolTypeInput.value = "";
      if (stateSelect) {
        stateSelect.setAttribute("readonly", true);
      }
    }
    function setFieldsOriginalValues() {
      zipInput.value = zipInput.dataset.originalValue;
      countryfield.value = countryfield.dataset.originalValue;
      schoolTypeSelect.value = schoolTypeSelect.dataset.originalValue;
      nameInput.value = nameInput.dataset.originalValue;
      cityInput.value = cityInput.dataset.originalValue;
      stateInput.value = stateInput.dataset.originalValue;
    }
    function makeFieldsEditable() {
      stateInput.removeAttribute("readonly");
      zipInput.removeAttribute("readonly");
      nameInput.removeAttribute("readonly");
      cityInput.removeAttribute("readonly");
      if (stateSelect) {
        stateSelect.removeAttribute("readonly");
      }
    }
  });

  // TODO remove maxResults and State
  // eslint-disable-next-line no-inner-declarations
  function fetchSchoolNames(zip, grade) {
    return fetch(`${requestURL}/owh/school/GetNearbySchools?zip=${zip}&limit=200&gradesTaught=${grade}`).then(response => response.json()).then(data => {
      if (data && data.length > 0) {
        return data.sort((a, b) => {
          if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
            return -1;
          }
          if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
            return 1;
          }
          return 0;
        });
      } else {
        return [];
      }
    }).catch(error => {
      console.error("There has been a problem accessing user data.  Support personnel have been notified .");
    });
  }
}

},{"./validation":262}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ClassCard = _interopRequireDefault(require("../partials/ClassCard.jsx"));
var _NewClassForm = _interopRequireDefault(require("../partials/NewClassForm.jsx"));
var _NewCleverClassForm = _interopRequireDefault(require("../partials/NewCleverClassForm.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _validation = require("../validation.js");
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));
var _expandChevron = _interopRequireDefault(require("../partials/expand-chevron.jsx"));
var _manualModal = require("../manualModal.js");
var courseData = _interopRequireWildcard(require("./fake-courses.json"));
var periodData = _interopRequireWildcard(require("./fake-periods.json"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
_reactModal.default.setAppElement(document.querySelector(".js-page-content-wrapper"));
class ClassListApp extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      this.fetchPeriods();
      this.fetchCourses();
      this.fetchYears();
      const addClassbtn = document.querySelectorAll(".js-add-class-btn");
      document.querySelectorAll(".js-class-list-link").forEach(link => {
        link.addEventListener("click", e => {
          e.preventDefault();
          this.openModal();
        });
      });
      addClassbtn && addClassbtn.forEach(button => {
        button.addEventListener("click", e => {
          e.preventDefault();
          this.openModal();
        });
      });
    });
    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevState.fetchedPeriods !== this.state.fetchedPeriods) {
        if (this.state.fetchedPeriods && this.state.periods.length === 0 && this.summaryContent.current) {
          if (this.summaryContent.current.querySelector(".js-manual-modal-toggle")) {
            (0, _manualModal.initModalListener)(this.summaryContent.current.querySelector(".js-manual-modal-toggle"));
          }
        }
      }
    });
    _defineProperty(this, "openModal", () => {
      this.setState({
        modalIsOpen: true
      });
      this.state.isClever && this.fetchCleverPeriods();
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
    });
    _defineProperty(this, "closeModal", () => {
      const {
        newPeriodInput
      } = this.state;
      newPeriodInput.value = "";
      newPeriodInput.error = false;
      newPeriodInput.errorMsg = "";
      this.setState({
        modalIsOpen: false,
        classCode: "",
        newPeriodInput,
        selectedCourse: ""
      });
    });
    _defineProperty(this, "fetchCourses", () => {
      const params = {};

      // for initial development
      if (this.props.teacherId) {
        params.teacherId = this.props.teacherId;
      }
      if (this.props.isPatternlab) {
        const courses = courseData.data.map(course => {
          return {
            courseName: course.CourseName,
            courseSummary: course.CourseSummary,
            courseId: course.CourseId
          };
        });
        this.setState({
          selectedCourse: courses[0].courseId,
          courses,
          selectedCourseDetails: courses[0].courseSummary
        });
      } else {
        fetch(`${this.props.requestUrl}/owh/course/getcourses?isVersion3Only=true`, {
          method: "POST",
          body: JSON.stringify(params),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => response.json()).then(data => {
          if (data.Message) {
            console.warn(data.Message);
            return;
          }
          const courses = data.map(course => {
            return {
              courseName: course.CourseName,
              courseSummary: course.CourseSummary,
              courseId: course.CourseId
            };
          });
          this.setState({
            selectedCourse: courses[0].courseId,
            courses,
            selectedCourseDetails: courses[0].courseSummary
          });
        }).catch(err => {
          console.error(err);
        });
      }
    });
    _defineProperty(this, "fetchPeriods", () => {
      const params = {};
      // for initial development
      if (this.props.teacherId) {
        params.teacherId = this.props.teacherId;
      }
      if (this.props.isPatternlab) {
        const periodSyncing = periodData.data.PeriodSyncing;
        if (periodSyncing) {
          setTimeout(() => this.fetchPeriods(), 500);
        } else {
          const periods = periodData.data.Periods.map(period => {
            return {
              teacherid: period.teacherId,
              id: period.PeriodId,
              name: period.PeriodName,
              coursePending: period.CoursePending,
              code: period.PeriodCode,
              students: period.NumberOfStudents,
              isPeriodActive: period.IsPeriodActive,
              isCleverPeriod: period.IsCleverPeriod,
              url: period.PeriodUrl,
              courseName: period.CourseName
            };
          });
          this.setState({
            isLoading: periodSyncing,
            periods,
            fetchedPeriods: true
          });
        }
      } else {
        fetch(`${this.props.requestUrl}/owh/period/getperiods`, {
          method: "POST",
          body: JSON.stringify(params),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => response.json()).then(data => {
          if (data.Message) {
            console.warn(data.Message);
            return;
          }
          const periodSyncing = data.PeriodSyncing;
          if (periodSyncing) {
            setTimeout(() => this.fetchPeriods(), 500);
          } else {
            const periods = data.Periods.map(period => {
              return {
                teacherid: period.teacherId,
                id: period.PeriodId,
                name: period.PeriodName,
                coursePending: period.CoursePending,
                code: period.PeriodCode,
                students: period.NumberOfStudents,
                isPeriodActive: period.IsPeriodActive,
                isCleverPeriod: period.IsCleverPeriod,
                url: period.PeriodUrl,
                courseName: period.CourseName
              };
            });
            this.setState({
              isLoading: periodSyncing,
              periods,
              fetchedPeriods: true
            });
          }
        }).catch(err => {
          console.error(err);
          this.setState({
            isLoading: false
          });
        });
      }
    });
    _defineProperty(this, "fetchYears", () => {
      const params = {};

      // for initial development
      if (this.props.teacherId) {
        params.UserId = this.props.teacherId;
      }
      fetch(`${this.props.requestUrl}/owh/period/GetArchivedPeriodYears`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.Message) {
          console.warn(data.Message);
          return;
        }
        const formatYears = data.sort().reverse();
        this.setState({
          years: formatYears
        });
      }).catch(err => {
        console.error(err);
      });
    });
    _defineProperty(this, "fetchCleverPeriods", () => {
      fetch(`${this.props.requestUrl}/owh/clever/GetCleverPeriods`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.Message) {
          console.warn(data.Message);
          return;
        }
        const cleverPeriods = data.map(period => {
          return {
            periodName: period.PeriodName,
            cleverId: period.CleverId,
            numberOfStudents: period.NumberOfStudents
          };
        });
        this.setState({
          cleverPeriods
        });
      }).catch(err => {
        console.error(err);
      });
    });
    _defineProperty(this, "fetchArchivedPeriods", year => {
      const params = {
        year: year
      };

      // for initial development
      if (this.props.teacherId) {
        params.UserId = this.props.teacherId;
      }
      fetch(`${this.props.requestUrl}/owh/period/GetArchivedPeriodsForTeacher`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.Message) {
          console.warn(data.Message);
          return;
        }
        const periods = data.map(period => {
          return {
            id: period.PeriodId,
            courseName: period.CourseName,
            name: period.PeriodName,
            code: period.PeriodCode,
            students: period.NumberOfStudents,
            isPeriodActive: period.IsPeriodActive,
            isCleverPeriod: period.IsCleverPeriod,
            url: period.PeriodUrl
          };
        });
        let archived = this.state.archived;
        archived[year] = periods;
        this.setState({
          archived
        });
      }).catch(err => {
        console.error(err);
      });
    });
    _defineProperty(this, "renderYears", year => {
      const isExpanded = this.state.openAccordions.includes(year);
      const headingClasses = (0, _classnames.default)("gv__archived-class__heading", {
        "is-open": isExpanded
      });
      const height = isExpanded ? "auto" : 0;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__archived-class",
        key: year
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: headingClasses
      }, /*#__PURE__*/_react.default.createElement("button", {
        id: `${year}-button`,
        "aria-controls": `${year}-id`,
        type: "button",
        className: "gv__archived-class__heading-button",
        "aria-expanded": isExpanded,
        onClick: e => this.toggleAccordion(e, year)
      }, year, /*#__PURE__*/_react.default.createElement(_expandChevron.default, {
        classes: "gv__archived-class__heading-arrow"
      }))), /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
        id: `${year}-id`,
        "aria-labelledby": `${year}-button`,
        className: "gv__archive-facets__list-wrapper",
        duration: 500,
        height: height
      }, /*#__PURE__*/_react.default.createElement(_loading.default, {
        isLoading: !isExpanded
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__class-list__items"
      }, this.state.archived[year] && isExpanded && this.renderPeriods(this.state.archived[year], true))));
    });
    _defineProperty(this, "toggleAccordion", (e, year) => {
      const newOpenAccordions = this.state.openAccordions.map(x => x);
      const archived = this.state.archived;
      if (newOpenAccordions.includes(year)) {
        const index = newOpenAccordions.indexOf(year);
        newOpenAccordions.splice(index, 1);
        const archivedIndex = archived.indexOf(archived[year]);
        archived.splice(archivedIndex, 1);
      } else {
        newOpenAccordions.push(year);
        this.fetchArchivedPeriods(year);
      }
      this.setState({
        openAccordions: newOpenAccordions,
        archived: archived
      });
    });
    _defineProperty(this, "createPeriod", () => {
      const isClever = this.state.isClever;
      const params = {
        PeriodName: this.state.newPeriodInput.value,
        CourseID: this.state.selectedCourse
      };
      if (isClever) {
        params.CleverId = this.state.cleverId;
      }
      const fetchUrl = isClever ? `${this.props.requestUrl}/owh/clever/AddCleverPeriod` : `${this.props.requestUrl}/owh/period/AddPeriod`;

      // for initial development
      if (this.props.teacherId) {
        params.teacherId = this.props.teacherId;
      }
      this.setState({
        isLoading: true
      });
      fetch(fetchUrl, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data && data.Succeeded) {
          this.setState({
            classCode: data.PeriodCode,
            joinUrl: data.JoinUrl,
            isLoading: true
          });
          this.closeModal();
          window.location = data.PeriodPageUrl;
        } else {
          const {
            newPeriodInput
          } = this.state;
          newPeriodInput.error = true;
          newPeriodInput.errorMsg = data.Message;
          this.setState({
            newPeriodInput,
            classCode: "",
            isLoading: false
          });
        }
      }).catch(error => {
        console.error(error);
        const {
          newPeriodInput
        } = this.state;
        newPeriodInput.error = true;
        newPeriodInput.errorMsg = error;
        this.setState({
          newPeriodInput,
          classCode: "",
          isLoading: false
        });
      });
    });
    _defineProperty(this, "handleNewClassInput", event => {
      const {
        newPeriodInput
      } = this.state;
      const value = event.target.value.substr(0, 45);
      const length = value.length;
      newPeriodInput.value = value;
      newPeriodInput.error = !(0, _validation.validateField)("text", newPeriodInput.value);
      newPeriodInput.warning = length > 0 && length >= 3;
      if (length > 0 && length < 3) {
        newPeriodInput.error = true;
        newPeriodInput.errorMsg = this.dashboardData.modalData.nameSizeError;
      } else if (length > 0 && length >= 3) {
        newPeriodInput.warningMsg = `${45 - length} ${this.dashboardData.modalData.characterCountLabel}`;
      }
      this.setState({
        newPeriodInput
      });
    });
    _defineProperty(this, "onFormSubmit", e => {
      e.preventDefault();
      const {
        newPeriodInput
      } = this.state;
      const {
        blankError
      } = this.dashboardData.modalData;
      if (!newPeriodInput.error) {
        if (newPeriodInput.value.length === 0) {
          newPeriodInput.error = true;
          newPeriodInput.errorMsg = blankError;
          this.setState({
            newPeriodInput
          });
          document.querySelectorAll(".gv__class-list-modal .gv__text-input__field")[0].focus();
        } else {
          this.createPeriod();
        }
      }
    });
    _defineProperty(this, "renderPeriods", (periods, isArchived) => {
      const {
        inviteStudentData,
        ViewClassLabel,
        isClever,
        dashboardClassCode,
        dashboardCourseLabel,
        InvitesStudentLabel,
        PendingSelectionLabel,
        InactiveClassLabel,
        ArchiveLabel,
        UnarchiveLabel,
        InactiveClassHelperText,
        UnarchiveClassLabel
      } = this.dashboardData;
      const {
        addCourseButtonLabel,
        courseNameLabel,
        selectCourseLabel
      } = this.dashboardData.modalData;
      const archiveModalData = this.archiveModalData;
      const courseOptions = this.state.courses.map(course => {
        return {
          label: course.courseName,
          value: course.courseId,
          detail: course.courseSummary
        };
      });
      return periods.map(period => {
        return /*#__PURE__*/_react.default.createElement(_ClassCard.default, _extends({
          InactiveClassHelperText: InactiveClassHelperText,
          archiveModalData: archiveModalData,
          dashboardCourseLabel: dashboardCourseLabel,
          dashboardClassCode: dashboardClassCode,
          key: period.id,
          isArchived: isArchived,
          inviteStudentData: inviteStudentData,
          ArchiveLabel: ArchiveLabel,
          UnarchiveLabel: UnarchiveLabel,
          ViewClassLabel: ViewClassLabel,
          courseNameLabel: courseNameLabel,
          InvitesStudentLabel: InvitesStudentLabel,
          addCourseButtonLabel: addCourseButtonLabel,
          UnarchiveClassLabel: UnarchiveClassLabel,
          selectCourseLabel: selectCourseLabel,
          PendingSelectionLabel: PendingSelectionLabel,
          InactiveClassLabel: InactiveClassLabel,
          isClever: isClever,
          courseOptions: courseOptions,
          fetchPeriods: this.fetchPeriods
        }, period));
      });
    });
    _defineProperty(this, "updateCleverId", cleverId => {
      this.setState({
        cleverId: cleverId
      });
    });
    _defineProperty(this, "updateSelectState", event => {
      const value = event.target.value;
      const filteredResults = R.filter(R.propEq("courseId", parseInt(value)), this.state.courses);
      const details = filteredResults[0].courseSummary;
      this.setState({
        selectedCourse: event.target.value,
        selectedCourseDetails: details
      });
    });
    this.dashboardData = window.teacherDashboardData;
    this.archiveModalData = window.archiveModalData;
    this.state = {
      dictionaryDone: false,
      modalIsOpen: false,
      periods: [],
      courses: [],
      archived: [],
      classCode: "",
      courseId: "",
      joinUrl: "",
      classUrl: "",
      reportUrl: "",
      isLoading: true,
      openAccordions: [],
      selectedCourse: "",
      years: [],
      isClever: this.dashboardData.isClever,
      selectedCourseDetails: "",
      newPeriodInput: {
        value: "",
        error: false,
        errorMsg: ""
      }
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
    this.summaryContent = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      newPeriodInput,
      classCode,
      periods,
      isLoading,
      isClever,
      selectedCourseDetails,
      years
    } = this.state;
    const {
      dashboardTitle,
      dashboardSummary,
      dashboardCtaText,
      modalData,
      ArchivedClassesHeading
    } = this.dashboardData;
    const hasAnyClasses = periods.length > 0 || years.length > 0;
    const modalClasses = (0, _classnames.default)("gv__modal__content", {
      "gv__class-list-modal__content--clever": isClever
    });
    const courseOptions = this.state.courses.map(course => {
      return {
        label: course.courseName,
        value: course.courseId,
        detail: course.courseSummary
      };
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-list__items"
    }, periods.length > 0 && this.renderPeriods(periods, false), /*#__PURE__*/_react.default.createElement(_loading.default, {
      isLoading: isLoading
    })), years.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-list__archived"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "gv__class-list__archived-heading"
    }, ArchivedClassesHeading || "Archived Classes"), years.map(year => this.renderYears(year)), /*#__PURE__*/_react.default.createElement(_loading.default, {
      isLoading: isLoading
    })), !isLoading && !hasAnyClasses && /*#__PURE__*/_react.default.createElement("section", {
      className: "gv__first-period"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "gv__first-period__title gv__page-title"
    }, dashboardTitle), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__first-period__summary",
      ref: this.summaryContent,
      dangerouslySetInnerHTML: {
        __html: dashboardSummary
      }
    }), !isClever && /*#__PURE__*/_react.default.createElement("button", {
      onClick: this.openModal,
      className: "gv__button gv__button--secondary"
    }, dashboardCtaText)), /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: modalClasses
    }, !isClever && classCode === "" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement(_NewClassForm.default, {
      courseOptions: courseOptions,
      newPeriodInput: newPeriodInput,
      selectedCourseDetails: this.state.selectedCourseDetails,
      isLoading: this.state.isLoading,
      modalData: this.dashboardData.modalData,
      updateSelectState: this.updateSelectState,
      handleNewClassInput: this.handleNewClassInput,
      onFormSubmit: this.onFormSubmit,
      ref: this.modalTitleRef
    })), isClever && /*#__PURE__*/_react.default.createElement(_NewCleverClassForm.default, {
      newPeriodInput: newPeriodInput,
      isLoading: this.state.isLoading,
      cleverPeriods: this.state.cleverPeriods,
      selectedCourseDetails: this.state.selectedCourseDetails,
      modalData: this.dashboardData.modalData,
      setCleverId: this.updateCleverId,
      courseOptions: courseOptions,
      onFormSubmit: this.onFormSubmit,
      handleNewClassInput: this.handleNewClassInput,
      updateSelectState: this.updateSelectState,
      ref: this.modalTitleRef,
      closeModal: this.closeModal
    })));
  }
}
exports.default = ClassListApp;
_defineProperty(ClassListApp, "propTypes", {
  requestUrl: _propTypes.string,
  teacherId: _propTypes.string,
  isPatternlab: _propTypes.string
});

},{"../manualModal.js":127,"../partials/ClassCard.jsx":134,"../partials/NewClassForm.jsx":138,"../partials/NewCleverClassForm.jsx":139,"../partials/expand-chevron.jsx":147,"../partials/loading.jsx":150,"../validation.js":262,"./fake-courses.json":42,"./fake-periods.json":43,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-animate-height":"react-animate-height","react-modal":"react-modal"}],41:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _ClassListApp = _interopRequireDefault(require("./ClassListApp.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-class-list-app");
if (el) {
  const props = {
    requestUrl: el.getAttribute("data-request-url") || "",
    teacherId: el.getAttribute("data-teacher-id") || "",
    isPatternlab: el.getAttribute("data-is-patternlab") || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_ClassListApp.default, props), el);
}

},{"./ClassListApp.jsx":40,"react":"react","react-dom":"react-dom"}],42:[function(require,module,exports){
module.exports={
  "data": [
  {
    "CourseName": "Big History",
    "CourseSummary": "This course explores the 13.8 billion year history of the Universe, our earth, and our people at the largest scale. It is recommended for middle school students but is flexible enough to level up or down.",
    "CourseId": 3
  },
  {
    "CourseName": "Origins to the Present",
    "CourseSummary": "This World History course begins with the Big Bang and early humans. It’s ideal for 10th graders but is flexible enough to level up or down.",
    "CourseId": 2
  },
  {
    "CourseName": "1750 to the Present",
    "CourseSummary": "This World History course explores modern history beginning at 1750. It is designed for 10th graders but is flexible enough to level up or down.",
    "CourseId": 1
  },
  {
    "CourseName": "Project X",
    "CourseSummary": "In this extension course, students learn to read, analyze, and use data, to make claims about some of humanity’s biggest challenges. Project X can be used as an extension to any social studies course.",
    "CourseId": 4
  },
  {
    "CourseName": "Project Score",
    "CourseSummary": "This extension course offers a variety of scaffolded, rubric-based writing activities, all of which help students prepare to write using Score, an automated essay-scoring service. Project Score can be used as an extension to any social studies course.",
    "CourseId": 5
  }
]
}
},{}],43:[function(require,module,exports){
module.exports={
  "data": {
    "PeriodSyncing": false,
    "Periods": [
      {
        "NumberOfStudents": 3,
        "PeriodUrl": "/Teacher-Dashboard/Period-Details?Period_Id=153",
        "PeriodCode": "97BTKN",
        "CourseName": "",
        "CoursePending": true,
        "IsPeriodActive": true,
        "IsCleverPeriod": false,
        "PeriodId": 153,
        "PeriodName": "A New Test Class"
      },
      {
        "NumberOfStudents": 5,
        "PeriodUrl": "/Teacher-Dashboard/Period-Details?Period_Id=10163",
        "PeriodCode": "LGRUDT",
        "CourseName": "Origins to the Present",
        "CoursePending": false,
        "IsPeriodActive": true,
        "IsCleverPeriod": false,
        "PeriodId": 10163,
        "PeriodName": "New Test Class"
      },
      {
        "NumberOfStudents": 1,
        "PeriodUrl": "/Teacher-Dashboard/Period-Details?Period_Id=144",
        "PeriodCode": "EEMPZJ",
        "CourseName": "1750 to the Present",
        "CoursePending": false,
        "IsPeriodActive": true,
        "IsCleverPeriod": false,
        "PeriodId": 144,
        "PeriodName": "Test Class Name"
      }
    ]
  }
}

},{}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _setModalCookie = require("./setModalCookie.js");
const closePromoCarousel = (el, closeButton, shouldSetCookie) => {
  if (shouldSetCookie) {
    (0, _setModalCookie.setCookie)(el);
    el.parentNode.classList.add("is-hidden");
  }
  closeButton.removeEventListener("click", closePromoCarousel);
};
const initClosePromoCarousel = el => {
  const closeButton = el.querySelector(".js-promo-carousel-close");
  const shouldSetCookie = el.classList.contains("js-set-cookie");
  closeButton.addEventListener("click", () => closePromoCarousel(el, closeButton, shouldSetCookie));
};
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  document.querySelectorAll(".js-promo-carousel") && [...document.querySelectorAll(".js-promo-carousel")].forEach(initClosePromoCarousel);
}

},{"./setModalCookie.js":199}],45:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _tabs = _interopRequireDefault(require("../partials/tabs.jsx"));
var _TabContent = _interopRequireDefault(require("./TabContent.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CommunityDrawer = props => {
  const [tabs, setTabs] = (0, _react.useState)(props.tabs);
  const [isActive, setActive] = (0, _react.useState)(null);
  const [drawerOpen, setDrawerOpen] = (0, _react.useState)(false);
  const [ariahidden, setAriaHidden] = (0, _react.useState)(false);
  const [tabOutside, setTabOutside] = (0, _react.useState)(false);
  const communityDrawer = (0, _react.useRef)();
  const toggleButton = (0, _react.useRef)();
  const toggleButtonMulti = (0, _react.useRef)();
  const didMountRef = (0, _react.useRef)(false);
  let focusBuffer = setTimeout(() => {}, 1);
  (0, _react.useEffect)(() => {
    getDefaultActive(tabs);
  }, [tabs]);
  (0, _react.useEffect)(() => {
    clearTimeout(focusBuffer);
    if (didMountRef.current) {
      if (drawerOpen) {
        setAriaHidden(false);
        if (communityDrawer.current.querySelector(".is-active")) {
          focusBuffer = setTimeout(() => {
            communityDrawer.current.querySelector(".is-active").focus();
          }, 400);
        } else {
          focusBuffer = setTimeout(() => {
            communityDrawer.current.querySelectorAll("input,a,button")[0].focus();
          }, 400);
        }
        document.querySelector("body").addEventListener("keyup", e => checkTab(e));
      } else {
        if (!tabOutside) {
          focusBuffer = setTimeout(() => {
            toggleButtonMulti.current.querySelectorAll("button")[0].focus();
          });
        }
        setAriaHidden(true);
        document.querySelector("body").removeEventListener("keyup", e => checkTab(e.key));
      }
    } else {
      didMountRef.current = true;
    }
  }, [drawerOpen]);
  const checkTab = e => {
    if (e.key === "Tab") {
      const target = e.target;
      // close drawer if tab outside
      if (!communityDrawer.current.contains(target) && !toggleButton.current.contains(target) && !toggleButtonMulti.current.contains(target)) {
        setDrawerOpen(false);
        setTabOutside(true);
      }
    } else if (e.key === "Escape") {
      setDrawerOpen(false);
      setTabOutside(true);
    }
    return;
  };
  const getDefaultActive = tabs => {
    const filteredTab = R.filter(R.propEq("active", true), tabs);
    setActive(filteredTab[0].name);
  };
  const toggleDrawer = e => {
    setDrawerOpen(!drawerOpen);
  };
  const openDrawerTab = (e, activeTab) => {
    setDrawerOpen(true);
    setActive(activeTab);
    setTabOutside(false);
  };
  const handleTabClick = selectedTab => {
    if (selectedTab.name !== isActive) {
      setActive(selectedTab.name);
    }
  };
  const renderTabContent = () => {
    return tabs.map((tab, i) => {
      const shown = tab.name === isActive;
      return /*#__PURE__*/_react.default.createElement(_TabContent.default, {
        key: i,
        classes: tab.className,
        id: tab.ariaControls,
        shown: shown,
        content: tab.content
      });
    });
  };
  const renderToggleButtons = () => {
    return tabs.map((tab, i) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i
      }, /*#__PURE__*/_react.default.createElement("button", {
        "aria-expanded": drawerOpen,
        type: "button",
        className: "gv__community-drawer__toggle-button",
        onClick: e => openDrawerTab(e, tab.name)
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: tab.icon,
        alt: ""
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__visuallyhidden"
      }, tab.name)));
    });
  };
  const toggleDrawerClasses = (0, _classnames.default)("gv__community-drawer__toggle", {
    "is-open": drawerOpen
  });
  const toggleDrawerMultiClasses = (0, _classnames.default)("gv__community-drawer__toggle gv__community-drawer__toggle--multi", {
    "is-open": drawerOpen
  });
  const drawerContainerClasses = (0, _classnames.default)("gv__community-drawer__container", {
    "is-open": drawerOpen
  });
  const drawerClasses = (0, _classnames.default)("gv__community-drawer", {
    "is-open": drawerOpen
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: drawerContainerClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: toggleDrawerClasses,
    ref: toggleButton
  }, drawerOpen && /*#__PURE__*/_react.default.createElement("button", {
    onClick: e => toggleDrawer(e),
    className: "gv__community-drawer__toggle-button",
    "aria-expanded": drawerOpen
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/owh/assets-build/img/icons/chevron-right.svg",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__visuallyhidden"
  }, "Toggle Drawer"))), /*#__PURE__*/_react.default.createElement("div", {
    className: toggleDrawerMultiClasses,
    ref: toggleButtonMulti
  }, !drawerOpen && /*#__PURE__*/_react.default.createElement("ul", {
    className: "gv__community-drawer__toggle-list"
  }, renderToggleButtons())), /*#__PURE__*/_react.default.createElement("div", {
    className: drawerClasses,
    "aria-hidden": ariahidden,
    ref: communityDrawer
  }, /*#__PURE__*/_react.default.createElement(_tabs.default, {
    handleTabClick: handleTabClick,
    tabs: tabs,
    activeTab: isActive
  }), renderTabContent()));
};
CommunityDrawer.propTypes = {
  tabs: (0, _propTypes.oneOfType)([_propTypes.array, (0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    active: _propTypes.bool,
    className: _propTypes.string.isRequired,
    icon: _propTypes.string,
    content: _propTypes.obj
  })])
};
var _default = exports.default = CommunityDrawer;

},{"../partials/tabs.jsx":155,"./TabContent.jsx":46,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react"}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TabContent = props => {
  const tabClasses = (0, _classnames.default)(`gv__tab-content ${props.classes}`, {
    "is-open": props.shown
  });
  const ariaExpanded = props.shown ? true : false;
  const ariaHidden = props.shown ? false : true;
  const tabIndex = props.shown ? -1 : 0;
  const {
    heading1,
    heading2,
    summary,
    ctaLink,
    ctaText
  } = props.content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: tabClasses,
    "aria-expanded": ariaExpanded,
    "aria-hidden": ariaHidden,
    id: props.id,
    tabIndex: tabIndex,
    role: "tabpanel"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__container"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__tab-promo__heading"
  }, /*#__PURE__*/_react.default.createElement("span", null, heading1), /*#__PURE__*/_react.default.createElement("span", null, heading2)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__rte gv__tab-promo__summary",
    dangerouslySetInnerHTML: {
      __html: summary
    }
  }), /*#__PURE__*/_react.default.createElement("a", {
    href: ctaLink,
    className: "gv__button gv__button--secondary gv__tab-promo__button",
    target: "_blank"
  }, ctaText)));
};
TabContent.propTypes = {
  classes: _propTypes.string,
  content: (0, _propTypes.shape)({
    heading1: _propTypes.string,
    heading2: _propTypes.string,
    summary: _propTypes.string,
    ctaLink: _propTypes.string,
    ctaText: _propTypes.string
  }),
  shown: _propTypes.bool,
  id: _propTypes.string
};
var _default = exports.default = TabContent;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],47:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _CommunityDrawer = _interopRequireDefault(require("./CommunityDrawer.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//This is the original version of the community drawer with the RTE. We've preserved it since some pages are still using it

const el = document.querySelector(".js-community-drawer-mount-legacy");
if (el) {
  const props = {
    tabs: JSON.parse(el.dataset.tab).tabs || []
  };
  if (props.tabs.length) {
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_CommunityDrawer.default, props), el);
  }
}

},{"./CommunityDrawer.jsx":45,"react":"react","react-dom":"react-dom"}],48:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _tabs = _interopRequireDefault(require("../partials/tabs.jsx"));
var _TabContent = _interopRequireDefault(require("./TabContent.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CommunityDrawer = props => {
  const [tabs, setTabs] = (0, _react.useState)(props.tabs);
  const [isActive, setActive] = (0, _react.useState)(null);
  const [drawerOpen, setDrawerOpen] = (0, _react.useState)(false);
  const [ariahidden, setAriaHidden] = (0, _react.useState)(false);
  const communityDrawer = (0, _react.useRef)();
  const [tabOutside, setTabOutside] = (0, _react.useState)(false);
  const toggleButton = (0, _react.useRef)();
  const toggleButtonMulti = (0, _react.useRef)();
  const didMountRef = (0, _react.useRef)(false);
  let focusBuffer = setTimeout(() => {}, 1);
  (0, _react.useEffect)(() => {
    getDefaultActive(tabs);
  }, [tabs]);
  (0, _react.useEffect)(() => {
    clearTimeout(focusBuffer);
    if (didMountRef.current) {
      if (drawerOpen) {
        setAriaHidden(false);
        if (communityDrawer.current.querySelector(".is-active")) {
          focusBuffer = setTimeout(() => {
            communityDrawer.current.querySelector(".is-active").focus();
          }, 400);
        } else {
          focusBuffer = setTimeout(() => {
            communityDrawer.current.querySelectorAll("input,a,button")[0].focus();
          }, 400);
        }
        document.querySelector("body").addEventListener("keyup", e => checkTab(e));
      } else {
        if (!tabOutside) {
          focusBuffer = setTimeout(() => {
            toggleButtonMulti.current.querySelectorAll("button")[0].focus();
          }, 400);
        }
        setAriaHidden(true);
        document.querySelector("body").removeEventListener("keyup", e => checkTab(e.key));
      }
    } else {
      didMountRef.current = true;
    }
  }, [drawerOpen]);
  const checkTab = e => {
    if (e.key === "Tab") {
      const target = e.target;
      // close drawer if tab outside
      if (!communityDrawer.current.contains(target) && !toggleButton.current.contains(target) && !toggleButtonMulti.current.contains(target)) {
        setDrawerOpen(false);
        setTabOutside(true);
      }
    } else if (e.key === "Escape") {
      setDrawerOpen(false);
      setTabOutside(true);
    }
    return;
  };
  const getDefaultActive = tabs => {
    const filteredTab = R.filter(R.propEq("active", true), tabs);
    setActive(filteredTab[0].name);
  };
  const toggleDrawer = e => {
    setDrawerOpen(!drawerOpen);
  };
  const openDrawerTab = (e, activeTab) => {
    setDrawerOpen(true);
    setActive(activeTab);
    setTabOutside(false);
  };
  const handleTabClick = selectedTab => {
    if (selectedTab.name !== isActive) {
      setActive(selectedTab.name);
    }
  };
  const renderTabContent = () => {
    return tabs.map((tab, i) => {
      const shown = tab.name === isActive;
      return /*#__PURE__*/_react.default.createElement(_TabContent.default, {
        name: tab.name,
        key: i,
        classes: tab.className,
        id: tab.ariaControls,
        shown: shown,
        content: tab.content
      });
    });
  };
  const renderToggleButtons = () => {
    return tabs.map((tab, i) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i
      }, /*#__PURE__*/_react.default.createElement("button", {
        "aria-expanded": drawerOpen,
        type: "button",
        className: "gv__community-drawer__toggle-button",
        onClick: e => openDrawerTab(e, tab.name)
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: tab.icon,
        alt: ""
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__visuallyhidden"
      }, tab.name)));
    });
  };
  const toggleDrawerClasses = (0, _classnames.default)("gv__community-drawer__toggle", {
    "is-open": drawerOpen
  });
  const toggleDrawerMultiClasses = (0, _classnames.default)("gv__community-drawer__toggle gv__community-drawer__toggle--multi", {
    "is-open": drawerOpen
  });
  const drawerContainerClasses = (0, _classnames.default)("gv__community-drawer__container", {
    "is-open": drawerOpen
  });
  const drawerClasses = (0, _classnames.default)("gv__community-drawer", {
    "is-open": drawerOpen
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: drawerContainerClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: toggleDrawerClasses,
    ref: toggleButton
  }, drawerOpen && /*#__PURE__*/_react.default.createElement("button", {
    onClick: e => toggleDrawer(e),
    className: "gv__community-drawer__toggle-button",
    "aria-expanded": drawerOpen
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/owh/assets-build/img/icons/chevron-right.svg",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__visuallyhidden"
  }, "Toggle Drawer"))), /*#__PURE__*/_react.default.createElement("div", {
    className: toggleDrawerMultiClasses,
    ref: toggleButtonMulti
  }, !drawerOpen && /*#__PURE__*/_react.default.createElement("ul", {
    className: "gv__community-drawer__toggle-list"
  }, renderToggleButtons())), /*#__PURE__*/_react.default.createElement("div", {
    className: drawerClasses,
    "aria-hidden": ariahidden,
    ref: communityDrawer
  }, /*#__PURE__*/_react.default.createElement(_tabs.default, {
    handleTabClick: handleTabClick,
    tabs: tabs,
    activeTab: isActive
  }), renderTabContent()));
};
CommunityDrawer.propTypes = {
  tabs: (0, _propTypes.oneOfType)([_propTypes.array, (0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    active: _propTypes.bool,
    className: _propTypes.string.isRequired,
    icon: _propTypes.string,
    content: _propTypes.obj
  })])
};
var _default = exports.default = CommunityDrawer;

},{"../partials/tabs.jsx":155,"./TabContent.jsx":50,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react"}],49:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FeatureListing = props => {
  const renderListing = content => {
    return content.map((x, i) => {
      const {
        title,
        titleUrl,
        content,
        replyCount,
        publishedTime
      } = x;
      const key = title.replace(" ", "-").toLowerCase();
      return /*#__PURE__*/_react.default.createElement("div", {
        key: key,
        className: "gv__tab-feature"
      }, /*#__PURE__*/_react.default.createElement("h3", {
        className: "gv__tab-feature__heading"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "gv__link",
        href: titleUrl,
        target: "_blank"
      }, title, " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
        classes: "gv__external-link-icon gv__tab-feature__external"
      }))), renderAuthorOrEvent(props.isEvent, x), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__rte gv__tab-feature__content"
      }, content), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__tab-feature__meta"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__tab-feature__replies"
      }, replyCount && replyCount), publishedTime && /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__tab-feature__published"
      }, publishedTime)));
    });
  };
  // const isEvent = true;

  const renderCalendar = () => {
    return /*#__PURE__*/_react.default.createElement("svg", {
      width: "23",
      height: "22",
      viewBox: "0 0 23 22",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("g", {
      stroke: "currentColor",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M2 3h19v17H2zM21 8.467H2m5.278-3.2V1m8.444 4.267V1"
    })));
  };
  const renderLocation = () => {
    return /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: "20px",
      viewBox: "0 0 54.757 54.757"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M27.557 12c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M40.94 5.617A19.052 19.052 0 0027.38 0a19.05 19.05 0 00-13.56 5.617c-6.703 6.702-7.536 19.312-1.804 26.952L27.38 54.757 42.721 32.6c5.755-7.671 4.922-20.281-1.781-26.983zm.159 25.814L27.38 51.243 13.639 31.4C8.44 24.468 9.185 13.08 15.235 7.031 18.479 3.787 22.792 2 27.38 2s8.901 1.787 12.146 5.031c6.05 6.049 6.795 17.437 1.573 24.4z"
    }));
  };
  const renderAuthorOrEvent = (isEvent, content) => {
    const {
      avatar,
      authorName,
      authorLink,
      authorSchool,
      eventDate,
      eventLocation
    } = content;
    if (isEvent) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__tab-feature__event-info"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__tab-feature__event-date"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__tab-feature__event-icon"
      }, renderCalendar()), " ", eventDate), " ", /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__tab-feature__event-location"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__tab-feature__event-icon"
      }, renderLocation()), eventLocation));
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__tab-feature__author"
      }, avatar && /*#__PURE__*/_react.default.createElement("img", {
        src: avatar,
        alt: authorName,
        className: "gv__tab-feature__avatar"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__tab-feature__author-info"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__tab-feature__author-name"
      }, authorName), " ", /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__tab-feature__author-school"
      }, authorSchool))));
    }
  };
  return renderListing(props.content);
};
FeatureListing.propTypes = {
  classes: _propTypes.string,
  content: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    title: _propTypes.string,
    url: _propTypes.string,
    avatar: _propTypes.string,
    authorName: _propTypes.string,
    authorLink: _propTypes.string,
    authorSchool: _propTypes.string,
    content: _propTypes.string,
    eventLocation: _propTypes.string,
    eventDate: _propTypes.string
  })),
  isEvent: _propTypes.bool,
  id: _propTypes.string
};
var _default = exports.default = FeatureListing;

},{"../partials/external-link-icon.jsx":148,"prop-types":"prop-types","react":"react"}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _TabHeading = _interopRequireDefault(require("./TabHeading.jsx"));
var _FeatureListing = _interopRequireDefault(require("./FeatureListing.jsx"));
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TabContent = props => {
  const tabClasses = (0, _classnames.default)(`gv__tab-content ${props.classes}`, {
    "is-open": props.shown
  });
  const ariaExpanded = props.shown ? true : false;
  const ariaHidden = props.shown ? false : true;
  const tabIndex = props.shown ? -1 : 0;
  const {
    heading1,
    heading2,
    startNewPostCtaUrl,
    startNewPostCtaLabel,
    viewAllCtaLink,
    viewAllCtaText,
    featureListing
  } = props.content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: tabClasses,
    "aria-expanded": ariaExpanded,
    "aria-hidden": ariaHidden,
    id: props.id,
    tabIndex: tabIndex,
    role: "tabpanel"
  }, /*#__PURE__*/_react.default.createElement(_TabHeading.default, {
    heading1: heading1,
    heading2: heading2,
    ctaLink: startNewPostCtaUrl,
    ctaText: startNewPostCtaLabel
  }), /*#__PURE__*/_react.default.createElement(_FeatureListing.default, {
    content: featureListing,
    isEvent: props.name === "Events"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__tab-content__container"
  }, viewAllCtaText && /*#__PURE__*/_react.default.createElement("a", {
    href: viewAllCtaLink,
    className: "gv__button gv__button--arrow gv__tab-promo__button",
    target: "_blank"
  }, viewAllCtaText, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__button__icon"
  }, /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
    classes: "gv__external-link-icon"
  }), " "))));
};
TabContent.propTypes = {
  classes: _propTypes.string,
  name: _propTypes.string,
  content: (0, _propTypes.shape)({
    name: _propTypes.string,
    heading1: _propTypes.string,
    heading2: _propTypes.string,
    startNewPostCtaLabel: _propTypes.string,
    startNewPostCtaUrl: _propTypes.string,
    viewAllCtaLink: _propTypes.string,
    viewAllCtaText: _propTypes.string,
    featureListing: _propTypes.array
  }),
  shown: _propTypes.bool,
  id: _propTypes.string
};
var _default = exports.default = TabContent;

},{"../partials/external-link-icon.jsx":148,"./FeatureListing.jsx":49,"./TabHeading.jsx":51,"classnames":"classnames","prop-types":"prop-types","react":"react"}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TabHeading = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__tab-heading"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__tab-heading__container"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__tab-heading__headers"
  }, /*#__PURE__*/_react.default.createElement("span", null, props.heading1), /*#__PURE__*/_react.default.createElement("span", null, props.heading2), props.ctaText && /*#__PURE__*/_react.default.createElement("a", {
    href: props.ctaLink,
    target: "_blank",
    className: "gv__button gv__button--secondary gv__button--arrow gv__tab-heading__button"
  }, props.ctaText, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__button__icon"
  }, /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
    classes: "gv__external-link-icon"
  }))))));
};
TabHeading.propTypes = {
  heading1: _propTypes.string,
  heading2: _propTypes.string,
  ctaText: _propTypes.string,
  ctaLink: _propTypes.string
};
var _default = exports.default = TabHeading;

},{"../partials/external-link-icon.jsx":148,"prop-types":"prop-types","react":"react"}],52:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _CommunityDrawer = _interopRequireDefault(require("./CommunityDrawer.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-community-drawer-mount");
if (el) {
  const props = {
    tabs: JSON.parse(el.dataset.tab).tabs || []
  };
  if (props.tabs.length) {
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_CommunityDrawer.default, props), el);
  }
}

},{"./CommunityDrawer.jsx":48,"react":"react","react-dom":"react-dom"}],53:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Copy extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleCopyURL", e => {
      e.preventDefault();
      this.copyText(this.props.urlToCopy);
      this.setState({
        urlCopied: true
      });
    });
    _defineProperty(this, "copyText", text => {
      if (!navigator.clipboard) {
        this.copyTextFallback(text);
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.setState({
          isCopied: true
        });
      });
    });
    _defineProperty(this, "copyTextFallback", text => {
      const scrollPosX = window.pageXOffset;
      const scrollPosY = window.pageYOffset;
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        window.scrollTo(scrollPosX, scrollPosY);
      } catch (err) {
        console.error("Oops, unable to copy", err);
      }
      document.body.removeChild(textArea);
    });
    this.state = {
      urlCopied: this.props.urlCopied || false
    };
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__copy-button"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__button",
      onClick: e => this.handleCopyURL(e)
    }, /*#__PURE__*/_react.default.createElement("span", null, this.props.copyText && this.props.copyText || "Copy")), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__copy-button__success"
    }, this.state.urlCopied && this.props.copySuccessText));
  }
}
exports.default = Copy;
_defineProperty(Copy, "propTypes", {
  urlToCopy: _propTypes.string,
  copyText: _propTypes.string,
  copySuccessText: _propTypes.string,
  urlCopied: _propTypes.bool
});

},{"prop-types":"prop-types","react":"react"}],54:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var R = _interopRequireWildcard(require("ramda"));
var _Copy = _interopRequireDefault(require("./Copy.jsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-copy-button-mount");
if (el) {
  const props = {
    urlToCopy: el.dataset.urlToCopy,
    copyText: el.dataset.copyText,
    copySuccessText: el.dataset.copySuccessText
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_Copy.default, props), el);
}

},{"./Copy.jsx":53,"ramda":"ramda","react":"react","react-dom":"react-dom"}],55:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  courseImg: _propTypes.string.isRequired,
  courseImgAltText: _propTypes.string.isRequired,
  courseSummary: _propTypes.string,
  courseTitle: _propTypes.string.isRequired
};
const CourseBanner = props => {
  const {
    courseTitle,
    courseImg,
    courseImgAltText,
    courseSummary
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-banner"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: courseImg,
    alt: courseImgAltText,
    className: "gv__course-banner__img",
    "data-object-fit": true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-banner__overlay"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-banner__content gv__container"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "gv__course-banner__title",
    id: "courseTitle"
  }, courseTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-banner__summary"
  }, courseSummary))));
};
CourseBanner.propTypes = propTypes;
var _default = exports.default = CourseBanner;

},{"prop-types":"prop-types","react":"react"}],56:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  lesson: (0, _propTypes.shape)({
    lessonNum: _propTypes.string.isRequired,
    lessonTitle: _propTypes.string.isRequired,
    lessonUrl: _propTypes.string.isRequired
  }),
  unitColor: _propTypes.string
};
const CourseLesson = props => {
  const {
    lesson,
    unitColor
  } = props;
  const {
    lessonUrl,
    lessonTitle,
    lessonNum
  } = lesson;
  const colorBoxStyle = {
    backgroundColor: unitColor
  };
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "gv__course-lesson"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: lessonUrl,
    className: "gv__course-lesson__content"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__course-lesson__num"
  }, lessonNum), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__course-lesson__title"
  }, lessonTitle)), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__course-lesson__color",
    style: colorBoxStyle
  }));
};
CourseLesson.propTypes = propTypes;
var _default = exports.default = CourseLesson;

},{"prop-types":"prop-types","react":"react"}],57:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CourseNavigationInfo = _interopRequireDefault(require("./CourseNavigationInfo.jsx"));
var _classNames = _interopRequireDefault(require("classNames"));
var _renderColors = require("./renderColors.js");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  units: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    unitNum: _propTypes.string.isRequired,
    unitColor: _propTypes.string.isRequired,
    unitTitle: _propTypes.string.isRequired,
    unitUrl: _propTypes.string.isRequired,
    unitDescription: _propTypes.string.isRequired,
    unitBanner: _propTypes.string.isRequired,
    unitBannerAltText: _propTypes.string.isRequired
  })).isRequired,
  activeUnit: _propTypes.object,
  refs: (0, _propTypes.arrayOf)(_propTypes.object),
  closeNavUnit: _propTypes.func,
  isDesktop: _propTypes.bool,
  clickNavHandler: _propTypes.func.isRequired,
  unitText: _propTypes.string
};
const CourseNavigation = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    units,
    clickNavHandler,
    activeUnit,
    refs,
    closeNavUnit,
    isDesktop,
    unitText
  } = props;
  const fewerUnits = units.length <= 7;
  const wrapperClasses = (0, _classNames.default)("gv__course-nav__wrapper", {
    "gv__course-nav__wrapper--short": fewerUnits
  });
  const findDuplicates = (unit, units) => {
    const unitIndex = R.findIndex(R.propEq("unitNum", unit.unitNum))(units);
    const previousUnitIndex = unitIndex - 1;
    let matches = false;
    if (previousUnitIndex > 0 && unit.taxonomy) {
      const previousUnit = units[previousUnitIndex];
      matches = unit.taxonomy[0].taxonomyColor === previousUnit.taxonomy[0].taxonomyColor;
    }
    return matches;
    // let previousUnit = null;
    // if (previousUnit) {
    //   matches = unit.taxonomy[0].taxonomyColor === previousUnit.taxonomy[0].taxonomyColor;
    // }
    // previousUnit = unit;
    // return matches;
  };

  // check if any of the taxonomies contain either a value in
  // taxonomyFirstRow or taxonomySecondRow
  const taxonomiesPresentInList = units => {
    return units.some(unit => unit.taxonomy && (unit.taxonomy[0].taxonomyFirstRow !== "" || unit.taxonomy[0].taxonomySecondRow !== ""));
  };
  const renderNavItem = (unit, i) => {
    const {
      unitDescription,
      unitNum,
      unitColor,
      lessons
    } = unit;
    const colorBoxStyle = {
      backgroundColor: unitColor
    };
    const isOpen = activeUnit === unit;
    const classes = (0, _classNames.default)("gv__course-nav", {
      "is-open": isOpen,
      "gv__course-nav__unit--short": fewerUnits
    });
    return /*#__PURE__*/_react.default.createElement("li", {
      key: i,
      className: classes,
      "aria-expanded": isOpen
    }, !isOpen && /*#__PURE__*/_react.default.createElement("button", {
      className: "gv__course-nav__btn",
      onClick: e => clickNavHandler(e, unit),
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-nav__num"
    }, unitNum), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-nav__description",
      dangerouslySetInnerHTML: {
        __html: unitDescription
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-nav__color-container"
    }, " ", (0, _renderColors.renderAllColors)(unit))), /*#__PURE__*/_react.default.createElement(_CourseNavigationInfo.default, {
      refs: refs,
      refIndex: i,
      unit: unit,
      unitText: unitText,
      lessons: lessons,
      unitColor: unitColor,
      activeUnit: activeUnit,
      isDesktop: isDesktop,
      closeNavUnit: closeNavUnit,
      shouldRenderText: findDuplicates(unit, units),
      taxonomiesPresentInList: taxonomiesPresentInList(units),
      openCourseNavigationInfo: e => clickNavHandler(e, unit)
    }));
  };
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: "gv__course-nav__nav",
    "aria-labelledby": "courseTitle",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: wrapperClasses
  }, units.map((unit, i) => renderNavItem(unit, i))));
});
CourseNavigation.propTypes = propTypes;
var _default = exports.default = CourseNavigation;

},{"./CourseNavigationInfo.jsx":58,"./renderColors.js":62,"classNames":"classNames","prop-types":"prop-types","ramda":"ramda","react":"react"}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("classNames"));
var _CourseLesson = _interopRequireDefault(require("./CourseLesson.jsx"));
var _renderColors = require("./renderColors.js");
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import useKeyboardNav from "../useKeyboardNav.js";

const propTypes = {
  activeUnit: _propTypes.object,
  closeNavUnit: _propTypes.func,
  isDesktop: _propTypes.bool,
  lessons: _propTypes.array,
  refIndex: _propTypes.number,
  refs: _propTypes.array,
  unitText: _propTypes.string,
  unit: _propTypes.object,
  closeText: _propTypes.string
};
const CourseNavigationInfo = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    activeUnit,
    closeNavUnit,
    closeText,
    isDesktop,
    lessons,
    refIndex,
    refs,
    unit,
    unitText,
    shouldRenderText,
    taxonomiesPresentInList,
    openCourseNavigationInfo
  } = props;
  const {
    unitUrl,
    unitBanner,
    unitBannerMobile,
    unitSummary,
    unitTitle,
    unitColor,
    unitNum,
    taxonomy
  } = unit || {};

  // const handleNavKeydown = useKeyboardNav({
  //   containerRef: refs[refIndex],
  //   onClose: !isDesktop ? closeNavUnit : null,
  //   closeAll: closeNavUnit,
  //   isVisible: activeUnit || unit
  // });

  // const renderThresholdsEras = () => {
  //   return (
  //     <div className="gv__course-nav__threshold-group">
  //       <div className="gv__course-nav__threshold-era">
  //         <span className="gv__course-nav__threshold-color" style={thresholdStyle}></span>
  //         <span className="gv__course-nav__threshold-name">Threshold 5: Life</span>
  //       </div>
  //     </div>
  //   );
  // };

  const overlayStyle = {
    backgroundImage: `linear-gradient(180deg, ${unitColor} 0%, #000000 100%)`
  };
  const tabIndex = unit ? "0" : "-1";
  const bottomClasses = (0, _classNames.default)("gv__course-nav__bottom", {
    "gv__course-nav__bottom--no-taxonomies": !taxonomiesPresentInList
  });
  const rendertaxonomy = () => {
    return taxonomy.map(x => {
      const {
        taxonomySummary,
        taxonomyColor,
        showColor
      } = x;
      const thresholdStyle = taxonomyColor ? {
        backgroundColor: taxonomyColor
      } : {};
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__course-nav__threshold-era",
        key: x
      }, taxonomyColor && showColor && /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__course-nav__threshold-color",
        style: thresholdStyle
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__course-nav__threshold-name"
      }, taxonomySummary));
    });
  };
  const renderTextRows = threshold => {
    const firstRow = threshold.taxonomyFirstRow ? /*#__PURE__*/_react.default.createElement("span", null, threshold.taxonomyFirstRow) : "";
    const secondRow = threshold.taxonomySecondRow ? /*#__PURE__*/_react.default.createElement("span", null, threshold.taxonomySecondRow) : "";
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, firstRow, " ", secondRow);
  };
  const escapeListener = e => {
    if (e.key === "Escape") {
      e.preventDefault();
      closeNavUnit();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-nav__info",
    tabIndex: "-1",
    onKeyDown: e => escapeListener(e)
  }, !isDesktop && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-nav__back-wrapper"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__course-nav__back",
    onClick: () => closeNavUnit(),
    tabIndex: tabIndex
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/OWH/assets-build/img/icons/x-circle-white-light.svg",
    alt: closeText
  })))), /*#__PURE__*/_react.default.createElement("a", {
    href: unitUrl && unitUrl,
    className: "gv__course-nav__link"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-nav__img-container"
  }, /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: unitBanner,
    media: "(min-width: 1200px)"
  }), /*#__PURE__*/_react.default.createElement("img", {
    alt: "",
    src: unitBanner,
    className: "gv__course-nav__img",
    "data-object-fit": true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-nav__overlay",
    style: overlayStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-nav__color-container"
  }, unit && (0, _renderColors.renderAllColors)(unit))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-nav__threshold-group"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-nav__taxonomy-container"
  }, taxonomy && rendertaxonomy())), isDesktop, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-nav__bottom-button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__course-nav__unit-num"
  }, unitText, " ", unitNum), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__course-nav__title"
  }, unitTitle), unitSummary && /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__course-nav__driving-question"
  }, unitSummary), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__button gv__button--arrow gv__course-nav__unit-button"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Unit Page "), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__button__icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/owh/assets-build/img/icons/chevron-right-white.svg",
    alt: ""
  }))))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "gv__course-lesson__list"
  }, lessons && lessons.map((lesson, i) => /*#__PURE__*/_react.default.createElement(_CourseLesson.default, {
    lesson: lesson,
    unitColor: unitColor,
    key: i
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: bottomClasses
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__course-nav__taxonomy-btn",
    onClick: e => openCourseNavigationInfo(e),
    "aria-label": `Open ${unitTitle} lesson table of contents`,
    type: "button"
  }, !shouldRenderText && taxonomy && taxonomy.map(x => {
    return renderTextRows(x);
  }), !taxonomiesPresentInList && /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__taxonomy__icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/owh/assets-build/img/icons/icon-expand-grey.svg",
    alt: ""
  })))), !isDesktop && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__course-nav__modal-overlay"
  }));
});
CourseNavigationInfo.propTypes = propTypes;
var _default = exports.default = CourseNavigationInfo;

},{"./CourseLesson.jsx":56,"./renderColors.js":62,"classNames":"classNames","prop-types":"prop-types","react":"react"}],59:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _renderColors = require("./renderColors.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  units: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    unitNum: _propTypes.string.isRequired,
    unitColor: _propTypes.string.isRequired,
    unitMobileDescription: _propTypes.string.isRequired,
    unitBanner: _propTypes.string.isRequired,
    unitBannerMobile: _propTypes.string,
    unitBannerAltText: _propTypes.string.isRequired,
    lessons: _propTypes.array
  })).isRequired,
  refs: _propTypes.array,
  unitText: _propTypes.string.isRequired,
  clickNavHandler: _propTypes.func.isRequired,
  activeUnit: (0, _propTypes.shape)({
    unitNum: _propTypes.string.isRequired,
    unitColor: _propTypes.string.isRequired,
    unitMobileDescription: _propTypes.string.isRequired,
    unitBanner: _propTypes.string.isRequired,
    unitBannerMobile: _propTypes.string,
    unitBannerAltText: _propTypes.string.isRequired,
    lessons: _propTypes.array
  })
};
const CourseNavigationRows = props => {
  const {
    units,
    unitText,
    clickNavHandler,
    refs,
    activeUnit
  } = props;
  const keyDownHandler = e => {
    const activeEl = document.activeElement;
    switch (e.key) {
      case "ArrowRight":
        activeEl.click(); // open next nav item
        break;
    }
  };
  const rendertaxonomy = taxonomy => {
    return taxonomy.map(x => {
      const {
        taxonomySummary
      } = x;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__course-nav__threshold-era",
        key: x
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__course-nav__threshold-name gv__course-nav__threshold-name--mobile"
      }, taxonomySummary));
    });
  };
  const renderUnits = (unit, i) => {
    const {
      unitNum,
      unitColor,
      unitBanner,
      unitBannerMobile,
      unitBannerAltText,
      unitMobileDescription,
      lessons,
      lessonText,
      taxonomy
    } = unit;

    // const numLessons = `${lessons.length} ${lessonText}`;

    const colorBoxStyle = {
      backgroundColor: unitColor
    };
    const isActive = activeUnit === unit;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: i,
      className: "gv__course-nav",
      ref: refs[i]
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "gv__course-nav__btn",
      "aria-expanded": isActive,
      onClick: e => clickNavHandler(e, unit),
      onKeyDown: keyDownHandler
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-nav__color-container"
    }, (0, _renderColors.renderAllColors)(unit)), /*#__PURE__*/_react.default.createElement("img", {
      src: unitBanner,
      alt: "",
      className: "gv__course-nav__img",
      "data-object-fit": true
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-nav__text"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-nav__top-text"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-nav__num"
    }, unitNum), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-nav__description",
      dangerouslySetInnerHTML: {
        __html: unitMobileDescription
      }
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-nav__mobile-era"
    }, taxonomy && rendertaxonomy(taxonomy))), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-nav__mobile-arrow"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/OWH/assets-source/img/icons/chevron-right-white.svg",
      alt: ""
    }))));
  };
  return /*#__PURE__*/_react.default.createElement("nav", {
    "aria-labelledby": "courseTitle"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "gv__course-nav__wrapper"
  }, units.map((unit, i) => renderUnits(unit, i))));
};
CourseNavigationRows.propTypes = propTypes;
var _default = exports.default = CourseNavigationRows;

},{"./renderColors.js":62,"prop-types":"prop-types","react":"react"}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jquery = _interopRequireDefault(require("jquery"));
var _classNames = _interopRequireDefault(require("classNames"));
var _getElemDistance = require("../getElemDistance.js");
var _CourseBanner = _interopRequireDefault(require("./CourseBanner.jsx"));
var _CourseNavigation = _interopRequireDefault(require("./CourseNavigation.jsx"));
var _CourseNavigationRows = _interopRequireDefault(require("./CourseNavigationRows.jsx"));
var _CourseNavigationInfo = _interopRequireDefault(require("./CourseNavigationInfo.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const App = props => {
  const section = props.section;
  const dictionary = props.dictionary;
  const [vpWidth, setVpWidth] = (0, _react.useState)(window.innerWidth);
  const [activeUnit, setActiveUnit] = (0, _react.useState)(null);
  const [isDesktop, setIsDesktop] = (0, _react.useState)(true);
  const [focusedLink, setFocusedLink] = (0, _react.useState)(null);
  const unitRefs = section.units.map(() => /*#__PURE__*/(0, _react.createRef)());
  const courseNavRef = (0, _react.useRef)();
  const timelineRef = (0, _react.useRef)();
  const mobileNavInfoRef = (0, _react.useRef)();
  const bpLarge = 1200;
  const bpSmall = 680;
  (0, _react.useEffect)(() => {
    let resizeTimer;
    setIsDesktop(vpWidth > bpLarge);
    const handleResize = () => {
      //this is to prevent a weird iOS bug in which it sometimes triggers resize on scroll
      if (vpWidth !== window.innerWidth) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          setActiveUnit(null);
          setVpWidth(window.innerWidth);
        }, 50);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, vpWidth]);
  (0, _react.useEffect)(() => {
    if (activeUnit) {
      const handleDocClick = e => {
        if (isDesktop && !e.target.closest(".is-open") && !e.target.classList.contains("gv__course-nav__btn")) {
          setActiveUnit(null);
        }
      };
      const handleKeydown = e => {
        if (e.key === "Esc" || e.key === "Escape") {
          setActiveUnit(null);
        }
      };
      document.addEventListener("click", handleDocClick, true);
      document.addEventListener("keydown", handleKeydown);
      return () => {
        document.removeEventListener("click", handleDocClick, true);
        document.removeEventListener("keydown", handleKeydown);
      };
    }
  }, [isDesktop, activeUnit]);
  (0, _react.useEffect)(() => {
    const handleDocKeyup = e => {
      if (e.key === "Tab") {
        if (!e.target.closest(".is-open")) {
          setActiveUnit(null);
          if (!isDesktop && !e.target.closest(".gv__course-nav__btn")) {
            e.preventDefault();
            focusedLink.focus();
          }
        } else {
          setFocusedLink(e.target.closest("button"));
        }
      }
    };
    if (activeUnit) {
      const currentUnit = document.querySelector(".gv__course-nav__info");
      currentUnit.focus();
    }
    document.addEventListener("keyup", handleDocKeyup);
    return () => {
      document.removeEventListener("keyup", handleDocKeyup);
    };
  }, [activeUnit, focusedLink, isDesktop]);
  const closeNavUnit = () => {
    if (!isDesktop) {
      // set focus to last active unit
      unitRefs[section.units.indexOf(activeUnit)].current.querySelector("button").focus();
    }
    setActiveUnit(null);
  };
  const scrollToOpenUnit = nav => {
    const currentScroll = window.scrollY;
    const topPosition = (0, _getElemDistance.getElemDistance)(nav) - 180;
    if (currentScroll < topPosition) {
      window.scrollTo({
        top: topPosition,
        behavior: "smooth"
      });
    }
  };
  const clickNavHandler = (e, unit) => {
    if (unit == activeUnit) {
      closeNavUnit();
    } else {
      if (!isDesktop) {
        // scroll to top of unit info on mobile when unit is selected
        const globalHeaderHeight = (0, _jquery.default)(".js-global-header").outerHeight();
        (0, _jquery.default)("html,body").animate({
          scrollTop: (0, _jquery.default)(mobileNavInfoRef.current).offset().top - globalHeaderHeight
        }, 300);
      }
      setActiveUnit(unit);
      setFocusedLink(e.target);
      if (isDesktop) {
        scrollToOpenUnit(courseNavRef.current);
      }
    }
  };
  if (isDesktop) {
    return /*#__PURE__*/_react.default.createElement("section", {
      ref: timelineRef,
      className: "gv__course-timeline"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-timeline__content"
    }, /*#__PURE__*/_react.default.createElement(_CourseBanner.default, {
      courseImg: section.courseImg,
      courseImgAltText: section.courseImgAltText,
      courseSummary: section.courseSummary,
      courseTitle: section.courseTitle
    }), /*#__PURE__*/_react.default.createElement(_CourseNavigation.default, {
      ref: courseNavRef,
      units: section.units,
      activeUnit: activeUnit,
      unitText: dictionary.unitText,
      isDesktop: isDesktop,
      clickNavHandler: clickNavHandler
    })));
  } else {
    const navInfoClasses = (0, _classNames.default)("gv__course-timeline", {
      "is-open": activeUnit
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " ", /*#__PURE__*/_react.default.createElement("section", {
      className: navInfoClasses
    }, /*#__PURE__*/_react.default.createElement(_CourseBanner.default, section), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-timeline__content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-timeline__tabs-nav"
    }, /*#__PURE__*/_react.default.createElement(_CourseNavigationRows.default, {
      units: section.units,
      unitText: dictionary.unitText,
      refs: unitRefs,
      clickNavHandler: clickNavHandler,
      activeUnit: activeUnit
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-timeline__nav-info",
      ref: mobileNavInfoRef
    }, /*#__PURE__*/_react.default.createElement(_CourseNavigationInfo.default, {
      activeUnit: activeUnit,
      isDesktop: isDesktop,
      lessons: activeUnit && activeUnit.lessons,
      refs: unitRefs,
      unit: activeUnit,
      unitText: dictionary.unitText,
      closeText: dictionary.closeText,
      closeNavUnit: closeNavUnit
    })), activeUnit && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-nav__modal-overlay"
    }))));
  }
};
var _default = exports.default = App;

},{"../getElemDistance.js":90,"./CourseBanner.jsx":55,"./CourseNavigation.jsx":57,"./CourseNavigationInfo.jsx":58,"./CourseNavigationRows.jsx":59,"classNames":"classNames","jquery":"jquery","react":"react"}],61:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _CourseTimeline = _interopRequireDefault(require("./CourseTimeline.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-course-timeline");
if (el) {
  const dictionary = JSON.parse(el.dataset.dictionary);
  const section = JSON.parse(el.dataset.sectionContent);
  const props = {
    dictionary,
    section
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_CourseTimeline.default, props), el);
}

},{"./CourseTimeline.jsx":60,"react":"react","react-dom":"react-dom"}],62:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderColorBar = exports.renderAllColors = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const renderColorBar = color => {
  const colorBoxStyle = {
    backgroundColor: color
  };
  return /*#__PURE__*/_react.default.createElement("span", {
    style: colorBoxStyle,
    className: "gv__course-nav__color"
  });
};
exports.renderColorBar = renderColorBar;
const renderAllColors = unit => {
  const {
    unitColor,
    taxonomy
  } = unit;
  if (taxonomy) {
    return taxonomy.map(x => {
      if (x.taxonomyColor) {
        return renderColorBar(x.taxonomyColor);
      } else {
        return renderColorBar(unitColor);
      }
    });
  } else {
    return renderColorBar(unitColor);
  }
};
exports.renderAllColors = renderAllColors;

},{"react":"react"}],63:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _tabs2 = _interopRequireDefault(require("../partials/tabs.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class dashboardTabs extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      this.checkForActive();
      window.addEventListener("hashchange", () => this.changeOnHashChange());
      if (!this.state.isIE11) {
        document.querySelectorAll(".js-anchor-link").forEach(x => x.addEventListener("click", e => this.anchorClick(e)));
      }
    });
    _defineProperty(this, "componentDidUpdate", () => {
      this.checkForActive();
      if (this.state.isIE11) {
        this.setFocus();
      }
    });
    _defineProperty(this, "anchorClick", e => {
      e.preventDefault();
      const link = e.target.closest("a") && e.target.closest("a").getAttribute("href");
      const tab = this.state.tabs.filter(x => x.ariaControls === link.replace("#", ""))[0];
      this.scrollToTabs(tab);
    });
    _defineProperty(this, "scrollToTabs", tab => {
      const id = `#${tab.ariaControls}`;
      const target = document.querySelector(id);
      const url = window.location.href.split("#")[0];
      if (target) {
        const boundTop = this.tabRef.current.getBoundingClientRect().top;
        history.pushState({}, document.title, url + id);
        window.scrollTo({
          top: boundTop + window.scrollY - 60,
          y: 0,
          behavior: "smooth"
        }); // minus for globalheader
        this.handleTabStateChange(tab);
        setTimeout(() => {
          target.focus({
            preventScroll: true
          });
        }, 300);
      } else {
        window.location = url + id;
      }
    });
    _defineProperty(this, "checkForHash", () => {
      const tabs = this.props.tabs;
      const hash = window.location.hash ? window.location.hash.replace("#", "") : null;

      // checking to see if hash is relevant to this component and not just a skiplink
      const isRelevant = hash && tabs.filter(tab => tab.ariaControls === hash);
      if (isRelevant && isRelevant.length > 0) {
        return hash;
      } else {
        return null;
      }
    });
    _defineProperty(this, "changeOnHashChange", () => {
      const hash = window.location.hash ? window.location.hash.replace("#", "") : null;
      const tabs = this.state.tabs;
      const hasHash = window.location.hash && tabs.filter(tab => tab.ariaControls === hash);
      if (hasHash) {
        const tab = tabs.filter(x => x.ariaControls === hash)[0];
        this.scrollToTabs(tab);
      } else {
        this.checkForActive();
      }
    });
    _defineProperty(this, "checkForActive", () => {
      const isActive = this.state.isActive;
      const tabs = this.state.tabs;
      tabs.forEach(tab => {
        let tabContent = document.querySelector(tab.className);
        if (isActive === tab.name) {
          this.show(tabContent);
        } else {
          this.hide(tabContent);
        }
      });
    });
    _defineProperty(this, "hide", tab => {
      tab.classList.remove("is-open");
      tab.setAttribute("aria-expanded", false);
      tab.setAttribute("aria-hidden", true);
      tab.setAttribute("tabindex", 0);
    });
    _defineProperty(this, "show", tab => {
      tab.classList.add("is-open");
      tab.setAttribute("aria-expanded", true);
      tab.setAttribute("aria-hidden", false);
      tab.setAttribute("tabindex", -1);
    });
    _defineProperty(this, "setFocus", () => {
      const isActive = this.state.isActive;
      const tabs = this.state.tabs;
      tabs.forEach(tab => {
        if (isActive === tab.name) {
          document.querySelector(tab.className).focus();
        }
      });
    });
    _defineProperty(this, "handleTabStateChange", selectedTab => {
      const {
        tabs
      } = this.state;
      let {
        isActive
      } = this.state;
      if (!selectedTab.active) {
        if (tabs[0].active) {
          tabs[0].active = false;
          tabs[1].active = true;
          isActive = tabs[1].name;
        } else {
          tabs[0].active = true;
          tabs[1].active = false;
          isActive = tabs[0].name;
        }
      }
      this.setState({
        tabs,
        isActive
      });
    });
    const _tabs = props.tabs;
    let active;

    // checking for hash before mounting for slower connections
    const _hash = this.checkForHash();
    if (_hash) {
      _tabs.forEach(tab => {
        if (tab.ariaControls === _hash) {
          tab.active = true;
          active = tab.name;
        } else {
          tab.active = false;
        }
      });
    } else {
      active = _tabs[0].active ? _tabs[0].name : _tabs[1].name;
    }
    this.state = {
      tabs: _tabs,
      isActive: active,
      isIE11: !!window.MSInputMethodContext && !!document.documentMode
    };
    this.tabRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      isActive,
      tabs
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_tabs2.default, {
      ref: this.tabRef,
      isIE11: this.state.isIE11,
      handleTabClick: this.scrollToTabs,
      handleTabClickIE11: this.handleTabStateChange,
      activeTab: isActive,
      tabs: tabs
    });
  }
}
exports.default = dashboardTabs;
_defineProperty(dashboardTabs, "propTypes", {
  tabs: _propTypes.array
});

},{"../partials/tabs.jsx":155,"prop-types":"prop-types","react":"react"}],64:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _DashboardTabs = _interopRequireDefault(require("./DashboardTabs.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-dashboard-tabs");
const isEE = document.querySelector("body").classList.contains("experience-editor");
if (el && !isEE) {
  const props = {
    tabs: JSON.parse(el.dataset.tab).tabs || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_DashboardTabs.default, props), el);
}

},{"./DashboardTabs.jsx":63,"react":"react","react-dom":"react-dom"}],65:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const dismissAlert = el => {
  const removeWidget = () => {
    el.remove();
  };
  // close button handler
  el.querySelector(".js-close-feedback-banner").addEventListener("click", e => {
    e.preventDefault();
    const alertId = el.getAttribute("id");
    _jsCookie.default.set("alertCookie" + alertId, alertId); //no date for session cookie
    removeWidget();
  });
};
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-gv__feedback-banner")].forEach(dismissAlert);
}

},{"js-cookie":"js-cookie"}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function DownloadAction(props) {
  const {
    files,
    hasMultipleFiles,
    isGoogleDoc,
    dataActionType,
    mediaId
  } = props;
  const [isReady, setIsReady] = (0, _react.useState)(false);
  const renderGoogleDriveLinks = () => {
    window.gapi && window.gapi.savetodrive.go();
  };
  const setDriveButton = () => {
    gapi.savetodrive.render("savetodrive-div", {
      src: hasMultipleFiles === true ? files.url.trim() : files.url.trim(),
      filename: hasMultipleFiles === true ? files["download-title"].trim() : files["download-title"].trim(),
      sitename: hasMultipleFiles === true ? files["download-title"].trim() : files["download-title"].trim()
    });
  };
  (0, _react.useEffect)(() => {
    setIsReady(true);
  }, [isReady]);
  if (isReady) {
    renderGoogleDriveLinks();
    setDriveButton();
  }
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "gv__modal__option-list"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "gv__modal__option-list-item gv__modal__option-list-item-google"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "savetodrive-div",
    "data-actioncomplete": "download",
    "data-actiontype": dataActionType,
    "data-media-id": mediaId
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "g-savetodrive-text"
  }, "to Google Drive")), /*#__PURE__*/_react.default.createElement("li", {
    className: "gv__modal__option-list-item gv__modal__option-list-item-download"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "actionable",
    "data-actioncomplete": "download",
    "data-actiontype": dataActionType,
    "data-media-id": mediaId,
    download: true,
    href: hasMultipleFiles === true ? files.url : files.url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V14H18V9H13V4H6V20H15V22H6ZM21.95 22.375L19 19.425V21.65H17V16H22.65V18H20.4L23.35 20.95L21.95 22.375Z",
    fill: "#213245"
  })), /*#__PURE__*/_react.default.createElement("span", null, "Download to My Computer"))));
}
var _default = exports.default = DownloadAction;

},{"prop-types":"prop-types","react":"react"}],67:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function DownloadFileSelection(props) {
  const {
    files,
    selectedOption,
    handleDownloadSelection,
    setSelectedOption,
    step,
    setStep,
    saveChecked,
    isGoogleDoc,
    dataActionType,
    mediaId
  } = props;
  const [checked, setChecked] = (0, _react.useState)();
  const [hasMultipleGoogleFiles, setHasMultipleGoogleFiles] = (0, _react.useState)(false);
  const [hasMultipleOnlineWordDocFiles, setHasMultipleOnlineWordDocFiles] = (0, _react.useState)(false);
  const [hasMultipleOnlinePPTFiles, setHasMultipleOnlinePPTFiles] = (0, _react.useState)(false);
  const [hasMultipleOnlineGoogleSlidesFiles, setHasMultipleOnlineGoogleSlidesFiles] = (0, _react.useState)(false);
  const [firstStepActionType, setFirstStepActionType] = (0, _react.useState)(dataActionType);
  const firstOption = (0, _react.useRef)();
  const handleKeyboard = (e, selection) => {
    switch (e.key) {
      case " ":
      case "SpaceBar":
      case "Enter":
        handleDownloadSelection(e, selection);
        setChecked(selection.title);
        e.current.focus();
      case "ArrowUp":
        if (e.target.classList.contains("dropdown-item-0")) {
          firstOption.current.focus();
        } else {
          e.current.previousSibling.focus();
        }
        break;
      case "ArrowDown":
        if (e.target.classList.contains("dropdown-item-last")) {
          firstOption.current.focus();
        } else {
          e.current.nextSibling.focus();
        }
        break;
      default:
        break;
    }
  };
  (0, _react.useEffect)(() => {
    const googleFiles = files.find(file => file.Key === "googledoc");
    if (googleFiles) {
      setHasMultipleGoogleFiles(googleFiles.files.length > 1);
    }
    const onlineWordDocFiles = files.find(file => file.Key === "onlineword");
    if (onlineWordDocFiles) {
      setHasMultipleOnlineWordDocFiles(onlineWordDocFiles.files.length > 1);
    }
    const onlinePPTFiles = files.find(file => file.Key === "onlineppt");
    if (onlinePPTFiles) {
      setHasMultipleOnlinePPTFiles(onlinePPTFiles.files.length > 1);
    }
    const onlineGoogleSlidesFiles = files.find(file => file.Key === "googleslides");
    if (onlineGoogleSlidesFiles) {
      setHasMultipleOnlineGoogleSlidesFiles(onlineGoogleSlidesFiles.files.length > 1);
    }
  }, [step]);
  const handleExternalLink = (e, target) => {
    if (target.files && target.files.length > 1 || target.files === undefined) {
      window.open(target.url);
    } else {
      window.open(target.files[0].url);
    }
  };
  const displayFiles = () => {
    if (files) {
      return files.map((target, i) => {
        const isDirectDownload = (target.Key === "googledoc" && !hasMultipleGoogleFiles || target.Key === "onlineword" && !hasMultipleOnlineWordDocFiles || target.Key === "onlineppt" && !hasMultipleOnlinePPTFiles || target.Key === "googleslides" && !hasMultipleOnlineGoogleSlidesFiles) && step === 0 || selectedOption?.Key === "googledoc" && hasMultipleGoogleFiles && step === 1 || selectedOption?.Key === "onlineword" && hasMultipleOnlineWordDocFiles && step === 1 || selectedOption?.Key === "onlineppt" && hasMultipleOnlinePPTFiles && step === 1 || selectedOption?.Key === "googleslides" && hasMultipleOnlineGoogleSlidesFiles && step === 1;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: `gv__modal__option-list-item radio-button dropdown-item-${i} ${i === files.length - 1 ? "dropdown-item-last" : ""}`,
          "data-actioncomplete": isDirectDownload || isDirectDownload && step !== 0 && dataActionType ? "download" : null,
          "data-actiontype": isDirectDownload && step === 0 ? target.Key : isDirectDownload && step !== 0 && dataActionType ? dataActionType : null,
          "data-media-id": isDirectDownload ? mediaId : null,
          key: `download-option-${i}`,
          ref: i === 0 ? firstOption : null,
          onClick: e => {
            isDirectDownload ? handleExternalLink(e, target) : handleDownloadSelection(e, target);
            setChecked(target.title);
          },
          onKeyDown: e => {
            isDirectDownload ? handleExternalLink(e, target) : handleKeyboard(e, target);
          },
          "aria-checked": checked === target.title ? "true" : "false",
          tabIndex: "0"
        }, /*#__PURE__*/_react.default.createElement("input", {
          id: `download-option-${i}`,
          type: "radio",
          name: "radio-button",
          value: `download-option-${i}`,
          defaultChecked: checked === target.title
        }), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: `download-option-${i}`
        }, target.icon && /*#__PURE__*/_react.default.createElement("img", {
          src: target.icon,
          alt: target.iconAlt || "Icon"
        }), /*#__PURE__*/_react.default.createElement("span", null, target.title)), isDirectDownload ? /*#__PURE__*/_react.default.createElement("svg", {
          className: "download-next-icon",
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.63636 2.18197C1.33512 2.18197 1.09091 2.42618 1.09091 2.72743V10.3638C1.09091 10.665 1.33512 10.9092 1.63636 10.9092H9.27273C9.57397 10.9092 9.81818 10.665 9.81818 10.3638V6.60118H10.9091V10.3638C10.9091 11.2675 10.1765 12.0002 9.27273 12.0002H1.63636C0.732625 12.0002 0 11.2675 0 10.3638V2.72743C0 1.82369 0.732625 1.09106 1.63636 1.09106H5.62601V2.18197H1.63636Z",
          fill: "#0058DC"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.6809 1.09073L5.45498 7.31666L4.68359 6.54527L10.9095 0.319336L11.6809 1.09073Z",
          fill: "#0058DC"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.9094 1.09091H8.18213V0H12.0003V3.81818H10.9094V1.09091Z",
          fill: "#0058DC"
        })) : /*#__PURE__*/_react.default.createElement("svg", {
          className: "download-next-icon",
          width: "12",
          height: "12",
          viewBox: "0 0 12 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("line", {
          x1: "0",
          y1: "5.98505",
          x2: "11.25",
          y2: "5.98505",
          stroke: "#333333",
          strokeWidth: "1.13"
        }), /*#__PURE__*/_react.default.createElement("line", {
          x1: "7.10225",
          y1: "10.1023",
          x2: "11.6023",
          y2: "5.60225",
          stroke: "#333333",
          strokeWidth: "1.125"
        }), /*#__PURE__*/_react.default.createElement("line", {
          y1: "-0.5625",
          x2: "6.36396",
          y2: "-0.5625",
          transform: "matrix(0.707107 0.707107 0.707107 -0.707107 7.5 1.5)",
          stroke: "#333333",
          strokeWidth: "1.125"
        })));
      });
    }
  };
  (0, _react.useEffect)(() => {
    setChecked(saveChecked);
  }, [saveChecked]);
  return /*#__PURE__*/_react.default.createElement("form", {
    className: "gv__modal__option-list"
  }, displayFiles());
}
var _default = exports.default = DownloadFileSelection;

},{"prop-types":"prop-types","react":"react"}],68:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactResponsive = require("react-responsive");
var _reactModal = _interopRequireDefault(require("react-modal"));
var _DownloadSelections = _interopRequireDefault(require("./DownloadSelections.jsx"));
var _NoteDisplay = _interopRequireDefault(require("./NoteDisplay.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DownloadInteractionModal = props => {
  const {
    dictionary,
    triggerButton,
    fromReact,
    showDownloadModal,
    setShowDownloadModal,
    closeModal
  } = props;
  const [step, setStep] = (0, _react.useState)(0);
  const [showVanillaJsModal, setShowVanillaJsModal] = (0, _react.useState)(false);
  const [modalTitle, setModalTitle] = (0, _react.useState)(dictionary.ModalTitle);
  const isSmallTabletorMobile = (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: 780px)"
  });
  const [noteMessage, setNoteMessage] = (0, _react.useState)(dictionary.DownloadData?.HeaderText);

  // const noteDisplay = () => {
  //   if (step > 0) {
  //     if(selectedOption === "share" && dictionary.ShareData.HeaderText) {
  //       return <NoteDisplay headerText={dictionary.ShareData.HeaderText}/>;
  //     } else if (selectedOption === "embed" && dictionary.EmbedData.HeaderText) {
  //       return <NoteDisplay headerText={dictionary.EmbedData.HeaderText}/>;
  //     } else if (selectedOption === "download" && dictionary.DownloadData.HeaderText) {
  //       return <NoteDisplay headerText={downloadNoteMessage}/>;
  //     }
  //   }
  // }

  if (!fromReact) {
    triggerButton?.addEventListener("click", e => setShowVanillaJsModal(true));
  }
  const closeVanillaJsModal = () => {
    setStep(0);
    setShowVanillaJsModal(false);

    //double check html body knows the modal is closed. 
    if (document.querySelector("body").classList.contains("gv__modal__body--modal-open")) {
      document.querySelector("body").classList.remove("gv__modal__body--modal-open");
    }
  };
  (0, _react.useEffect)(() => {
    fromReact ? setShowDownloadModal(true) : setShowVanillaJsModal(true);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: fromReact ? showDownloadModal : showVanillaJsModal,
    bodyOpenClassName: null,
    overlayClassName: "gv__modal",
    className: "gv__modal-interaction",
    onRequestClose: fromReact ? closeModal : closeVanillaJsModal,
    shouldCloseOnOverlayClick: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal-v2-body gv__modal-download"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__manual-modal__header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__manual-modal__modal-label"
  }, step > 0 && /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__manual-modal-share__back gv__back-button",
    onClick: () => setStep(step - 1)
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.6836 27.65L18.0503 20L25.6836 12.35L23.3336 10L13.3336 20L23.3336 30L25.6836 27.65Z",
    fill: "white"
  }))), /*#__PURE__*/_react.default.createElement("span", null, modalTitle)), /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__manual-modal-v2__close js-close-manual-modal",
    type: "button",
    onClick: () => fromReact ? (closeModal(), setStep(0)) : closeVanillaJsModal()
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 17L17 7M7 7L17 17L7 7Z",
    stroke: "currentColor",
    strokeWidth: "2"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__manual-modal__container"
  }, /*#__PURE__*/_react.default.createElement(_NoteDisplay.default, {
    headerText: noteMessage
  }), /*#__PURE__*/_react.default.createElement(_DownloadSelections.default, {
    step: step,
    setStep: setStep,
    downloadSelections: dictionary.DownloadData.Data.DownloadSelections,
    noteMessage: noteMessage,
    setNoteMessage: setNoteMessage,
    downloadData: dictionary.DownloadData,
    mediaId: dictionary.MediaId
  }))));
};
var _default = exports.default = DownloadInteractionModal;

},{"./DownloadSelections.jsx":69,"./NoteDisplay.jsx":70,"prop-types":"prop-types","react":"react","react-modal":"react-modal","react-responsive":"react-responsive"}],69:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactResponsive = require("react-responsive");
var _reactModal = _interopRequireDefault(require("react-modal"));
var _DownloadAction = _interopRequireDefault(require("./DownloadAction.jsx"));
var _DownloadFileSelection = _interopRequireDefault(require("./DownloadFileSelection.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DownloadSelections = props => {
  const {
    dictionary,
    downloadData,
    downloadSelections,
    step,
    setStep,
    noteMessage,
    setNoteMessage,
    mediaId
  } = props;
  const [hasMultipleSelections, setHasMultipleSelections] = (0, _react.useState)(downloadSelections.length > 1);
  const [hasMultipleFiles, setHasMultipleFiles] = (0, _react.useState)(false);
  const [isGoogleDoc, setIsGoogleDoc] = (0, _react.useState)(false);
  const [selectedOption, setSelectedOption] = (0, _react.useState)();
  const [secondSelectedOption, setSecondSelectedOption] = (0, _react.useState)();
  const [hasError, setHasError] = (0, _react.useState)(false);
  const [saveChecked, setSaveChecked] = (0, _react.useState)({
    firstSelection: "",
    secondSelection: ""
  });
  const [dataActionType, setDataActionType] = (0, _react.useState)(null);
  const [firstDataActionType, setFirstDataActionType] = (0, _react.useState)(null);
  const handleDownloadSelection = (e, option) => {
    e.stopPropagation();
    e.preventDefault();
    setSaveChecked(prevState => ({
      ...prevState,
      firstSelection: step === 0 ? option.title : prevState.firstSelection,
      secondSelection: step === 1 ? option.title : prevState.secondSelection
    }));
    if (step === 0) {
      setSelectedOption(option);
      setHasMultipleFiles(!!(option.files && option.files.length > 1));
      setDataActionType(option.title);
      setFirstDataActionType(option.title);
      setStep(prevStep => prevStep + 1);
    } else if (step === 1) {
      setSecondSelectedOption(option);
      setDataActionType(option.title);
      setStep(step + 1);
    }
    setHasError(false);
  };
  const stepDisplay = () => {
    // Handle state updates outside of the return statement
    if (step === 0) {
      if (!hasMultipleSelections) {
        if (!hasMultipleFiles) {
          // Set note message only if the state needs to change
          if (noteMessage !== downloadData.ThirdStepHeaderText) {
            setNoteMessage(downloadData.ThirdStepHeaderText);
          }
          // Return DownloadAction when no multiple files
          return /*#__PURE__*/_react.default.createElement(_DownloadAction.default, {
            files: downloadSelections[0].files[0],
            hasMultipleFiles: hasMultipleFiles,
            dataActionType: dataActionType,
            mediaId: mediaId
          });
        } else {
          if (noteMessage !== downloadData.HeaderText) {
            setNoteMessage(downloadData.HeaderText);
          }
          // Return DownloadFileSelection when there are multiple files
          return /*#__PURE__*/_react.default.createElement(_DownloadFileSelection.default, {
            files: downloadSelections[0].files,
            handleDownloadSelection: handleDownloadSelection,
            selectedOption: selectedOption,
            setSelectedOption: setSelectedOption,
            saveChecked: saveChecked.firstSelection,
            step: step,
            setStep: setStep,
            dataActionType: dataActionType,
            mediaId: mediaId
          });
        }
      } else {
        // Set message for multiple selections
        if (noteMessage !== downloadData.HeaderText) {
          setNoteMessage(downloadData.HeaderText);
        }
        // Return DownloadFileSelection for multiple selections
        return /*#__PURE__*/_react.default.createElement(_DownloadFileSelection.default, {
          files: downloadSelections,
          handleDownloadSelection: handleDownloadSelection,
          selectedOption: selectedOption,
          setSelectedOption: setSelectedOption,
          saveChecked: saveChecked.firstSelection,
          step: step,
          setStep: setStep,
          dataActionType: dataActionType,
          mediaId: mediaId
        });
      }
    }
    if (step === 1) {
      //if it has only one initial option and no multiple files
      if (downloadSelections.length === 1 && hasMultipleFiles) {
        // Set note message for single selection with multiple files
        if (noteMessage !== downloadData.ThirdStepHeaderText) {
          setNoteMessage(downloadData.ThirdStepHeaderText);
        }
        // Return DownloadAction for step 1
        return /*#__PURE__*/_react.default.createElement(_DownloadAction.default, {
          hasMultipleFiles: hasMultipleFiles,
          files: selectedOption,
          dataActionType: dataActionType,
          mediaId: mediaId
        });
      } else if (downloadSelections.length > 1 && hasMultipleFiles) {
        // Set message for multiple files in step 1
        if (noteMessage !== downloadData.SecondStepHeaderText) {
          setNoteMessage(downloadData.SecondStepHeaderText);
        }

        // Return DownloadFileSelection for step 1 with multiple files
        return /*#__PURE__*/_react.default.createElement(_DownloadFileSelection.default, {
          files: selectedOption.files,
          handleDownloadSelection: handleDownloadSelection,
          selectedOption: selectedOption,
          setSecondSelectedOption: setSecondSelectedOption,
          saveChecked: saveChecked.secondSelection,
          step: step,
          setStep: setStep,
          dataActionType: dataActionType,
          mediaId: mediaId
        });
      } else if (downloadSelections.length > 1 && !hasMultipleFiles) {
        if (noteMessage !== downloadData?.ThirdStepHeaderText) {
          setNoteMessage(downloadData?.ThirdStepHeaderText);
        }
        return /*#__PURE__*/_react.default.createElement(_DownloadAction.default, {
          hasMultipleFiles: hasMultipleFiles,
          files: selectedOption.files[0],
          dataActionType: dataActionType,
          mediaId: mediaId
        });
      }
    }
    if (step === 2) {
      if (noteMessage !== downloadData?.ThirdStepHeaderText) {
        setNoteMessage(downloadData?.ThirdStepHeaderText);
      }
      return /*#__PURE__*/_react.default.createElement(_DownloadAction.default, {
        hasMultipleFiles: hasMultipleFiles,
        files: secondSelectedOption,
        dataActionType: firstDataActionType,
        mediaId: mediaId
      });
    }
    return null; // Handle case where step is not 0 or 1
  };
  const handleError = () => {
    setHasError(true);
  };
  (0, _react.useEffect)(() => {
    if (!hasMultipleSelections) {
      if (downloadSelections[0].files.length > 1) {
        setHasMultipleFiles(true);
      }
    }
  }, [step]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__download"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__download"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__options gv__modal__options-full"
  }, stepDisplay(), hasError && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__options-error"
  }, "Please select and option to continue")));
};
var _default = exports.default = DownloadSelections;

},{"./DownloadAction.jsx":66,"./DownloadFileSelection.jsx":67,"prop-types":"prop-types","react":"react","react-modal":"react-modal","react-responsive":"react-responsive"}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function NoteDisplay(props) {
  const {
    headerText
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__manual-modal-share__note"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__manual-modal-share__note-text"
  }, headerText));
}
var _default = exports.default = NoteDisplay;

},{"prop-types":"prop-types","react":"react"}],71:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _DownloadInteractionModal = _interopRequireDefault(require("./DownloadInteractionModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// var modalAttr;

const triggerButtons = document.querySelectorAll(".js-download-modal-toggle");
const renderShare = e => {
  e.preventDefault();
  e.stopPropagation();
  var button = e.currentTarget;
  const modalId = e.currentTarget.dataset.modal;
  const expanded = e.currentTarget.setAttribute("aria-expanded", "true");
  const modal = document.querySelector(`#${modalId}`);
  const dictionary = modal.getAttribute("data-dictionary");
  var props = {
    dictionary: JSON.parse(dictionary) || null,
    triggerButton: e.currentTarget
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_DownloadInteractionModal.default, props), modal);
};
triggerButtons.forEach(button => {
  button.addEventListener("click", e => renderShare(e));
});

},{"./DownloadInteractionModal.jsx":68,"react":"react","react-dom":"react-dom"}],72:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classNames = _interopRequireDefault(require("classNames"));
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _selectInput = _interopRequireDefault(require("../partials/select-input.jsx"));
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class DownloadInteractionApp extends _react.Component {
  constructor(props) {
    super(props);

    // determine has the needed data to render
    _defineProperty(this, "componentDidMount", () => {
      // add event to open buttons to reset the component state
      // const isReady = this.hasItems && this.hasMediumData;
      const isMultiple = this.hasItems && (this.props.items.length > 1 || this.props.items[0].files.length > 1);
      const selectedFile = !isMultiple && this.props.items.length > 0 ? this.props.items[0].files[0] : null;
      const currentStep = isMultiple ? 1 : 2;
      const selectedItem = !isMultiple ? 0 : null;
      this.setState({
        isMultiple: isMultiple,
        selectedFile: selectedFile,
        currentStep: currentStep,
        selectedItem: selectedItem,
        cardType: null,
        cardId: null
      });

      // until we refactor the cards to be one app, we're making this a variable for each card it can know when the drawer is open to render the google drive icon. thanks, google

      if (this.props.containerId) {
        window[`openCard${this.props.containerId}`] = {
          cardType: null,
          getCardId: () => {
            return this.cardId;
          },
          getCardType: () => {
            return this.cardType;
          },
          setCardType: value => {
            this.cardType = value;
            return this.setState({
              cardType: value
            });
          }
        };
      } else {
        window.downloadTrigger = {
          cardType: null,
          getCardType: () => {
            return this.cardType;
          },
          setCardType: value => {
            this.cardType = value;
            return this.setState({
              cardType: value
            });
          }
        };
      }
      this.props.triggerButtons && this.props.triggerButtons.forEach(button => {
        button.addEventListener("click", () => this.reset());
      });

      // handle dependencies loading
      if (this.props.mediums) {
        const {
          mediums,
          mediumSettings
        } = this.props;

        // if (mediums.includes("googleDrive") && !window.gapi) {
        //   const googleDriveScript = document.createElement("script");
        //   googleDriveScript.setAttribute("src", "https://apis.google.com/js/api.js");
        //   googleDriveScript.setAttribute("async", true);
        //   googleDriveScript.setAttribute("id", "googledrivejs");
        //   document.body.appendChild(googleDriveScript);
        // }

        // Dropbox integration
        if (mediums.includes("dropbox") && !document.dropbox && document.querySelectorAll("#dropboxjs").length === 0) {
          const dropboxScript = document.createElement("script");
          dropboxScript.setAttribute("src", mediumSettings.dropbox.url);
          dropboxScript.setAttribute("async", mediumSettings.dropbox.async);
          dropboxScript.setAttribute("id", "dropboxjs");
          dropboxScript.setAttribute("data-app-key", mediumSettings.dropbox.appKey);
          document.body.appendChild(dropboxScript);
        }
      }
      document.querySelectorAll(".js-gv__material-card__close").forEach(button => {
        button.addEventListener("click", () => this.reset());
      });
    });
    _defineProperty(this, "componentDidUpdate", (prevProp, prevState) => {
      if (prevState.cardType !== this.state.cardType && this.state.cardType !== null) {
        setTimeout(() => {
          this.setState({
            isReady: true
          });
        }, 200);
      }
      if (this.state.isReady) {
        this.renderGoogleDriveLinks();
      }
      if (this.state.currentStep === 2) {
        // this.renderGoogleDriveLinks();
        this.handleFocus(this.step2Ref);
        if (this.state.currentStep !== prevState.currentStep) {
          this.focusTrap();
        }
        if (this.state.selectedFile) {
          this.renderGoogleDriveLinks();
        }
      }
    });
    _defineProperty(this, "handleClose", () => {
      this.reset();
      if (typeof this.props.onClose == "function") {
        this.props.onClose();
      }
    });
    _defineProperty(this, "handleDropboxDownload", (url, filename) => {
      window.Dropbox && Dropbox.save(url, filename);
    });
    _defineProperty(this, "handleFocus", ref => {
      // find focusable elements
      // const focusableElems = ref.current.querySelectorAll(".js-focusable, a, button, input");
      // focusableElems.length && focusableElems[0].focus();
      ref.current.focus();
    });
    // we're explicitly setting this for step 2 since google is rendered async
    _defineProperty(this, "focusTrap", () => {
      this.directRef.current.addEventListener("keydown", e => {
        const panel = this.containerRef.current.closest(".gv__material-card-flyout__section");
        const closeButton = panel.querySelector(".js-gv__material-card__close");
        if (e.key === "Tab") {
          e.preventDefault();
          closeButton.focus();
        }
      });
    });
    _defineProperty(this, "handleItemSelect", (index, item) => {
      // set selected item in state
      this.setState({
        selectedItem: index
      });

      // get the selected file and set to state
      let selectedFile = null;
      if (item.files.length && item.files.length === 2) {
        // if item has a single file set it as selected
        selectedFile = item.files[1];
      } else if (item.files.length && item.files.length <= 2) {
        selectedFile = item.files[0];
      } else if (item.files.length && this.state.multipleFilesIndex[index] !== 0) {
        // if item has multiple files set the current selected file in dropdown
        selectedFile = item.files[this.state.multipleFilesIndex[index]];
      }
      this.setState({
        selectedFile
      });
    });
    _defineProperty(this, "handleNextStep", () => {
      if (this.state.selectedFile) {
        this.setState(prevState => ({
          currentStep: prevState.currentStep + 1
        }));
      }
    });
    _defineProperty(this, "handleFileSelect", (e, itemIndex) => {
      const selectedFile = e.target.value;
      if (selectedFile === "0") {
        let selectedFile = null;
        this.setState({
          selectedFile
        });
        return;
      } else {
        // update indexes and selected file in state
        this.setState(prevState => {
          const {
            multipleFilesIndex
          } = prevState;
          multipleFilesIndex[itemIndex] = selectedFile;
          return {
            selectedItem: itemIndex,
            selectedFile: this.props.items[itemIndex].files[selectedFile],
            multipleFilesIndex
          };
        });
      }
    });
    _defineProperty(this, "renderItemsList", items => {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "items-list"
      }, items.map((item, itemIndex) => {
        if (item.files) {
          const filesList = item.files.map((file, fileIndex) => ({
            label: file.title,
            value: fileIndex
          }));
          const itemWrapperClasses = (0, _classNames.default)({
            "items-list__item-wrapper": true,
            "items-list__item-wrapper--selected": itemIndex === this.state.selectedItem
          });
          return /*#__PURE__*/_react.default.createElement("li", {
            key: itemIndex,
            className: itemWrapperClasses
          }, /*#__PURE__*/_react.default.createElement("button", {
            className: "items-list__item",
            onClick: e => this.handleItemSelect(itemIndex, item, e),
            type: "button"
          }, item.icon && /*#__PURE__*/_react.default.createElement("div", {
            className: "icon"
          }, /*#__PURE__*/_react.default.createElement("img", {
            src: item.icon,
            alt: item.iconAlt
          })), /*#__PURE__*/_react.default.createElement("div", {
            className: "title"
          }, item.title)), filesList.length > 2 && /*#__PURE__*/_react.default.createElement("div", {
            className: "items-list__item-options"
          }, /*#__PURE__*/_react.default.createElement(_selectInput.default, {
            onChange: e => this.handleFileSelect(e, itemIndex),
            label: this.props.dictionary && this.props.dictionary.downloadInteractionSelectLabel || "Select file",
            options: filesList,
            value: this.state.multipleFilesIndex[itemIndex],
            small: true,
            transparent: true
          })));
        }
      }));
    });
    _defineProperty(this, "renderGoogleDriveLinks", () => {
      window.gapi && window.gapi.savetodrive.go();
    });
    _defineProperty(this, "reset", () => {
      this.state.isMultiple && this.setState({
        currentStep: 1
      });
    });
    this.hasItems = this.props.items && this.props.items.length >= 1;
    this.hasMediumData = !this.props.mediums || !this.props.mediumSettings ? false : true;
    this.googleRef = /*#__PURE__*/_react.default.createRef();

    // determine if there is a single or multiple options download

    // populate the multiple files state array with initial index
    let _multipleFilesIndex = {};
    this.props.items && this.props.items.forEach((item, index) => {
      if (item.files && item.files.length > 1) {
        _multipleFilesIndex[index] = 0;
      }
    });

    // compute initial state
    this.state = {
      currentStep: null,
      isMultiple: false,
      isReady: false,
      multipleFilesIndex: _multipleFilesIndex,
      selectedFile: null,
      selectedItem: null,
      isIE11: !!window.MSInputMethodContext && !!document.documentMode
    };

    // define refs
    this.step2Ref = /*#__PURE__*/_react.default.createRef();
    this.containerRef = /*#__PURE__*/_react.default.createRef();
    this.directRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      currentStep,
      isReady,
      selectedFile
    } = this.state;
    const {
      dictionary,
      items,
      mediums,
      mediumSettings
    } = this.props;
    const classes = (0, _classNames.default)("gv__download-interaction");
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes,
      ref: this.containerRef
    }, (this.state.cardType !== null || isReady === true) && currentStep === 1 && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__download-interaction__step gv__download-interaction__step--one"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__download-interaction__instructions"
    }, dictionary && dictionary.downloadInteractionInstructions || "Select a file to download"), items && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__download-interaction__items"
    }, this.renderItemsList(items)), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__download-interaction__actions"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__button gv__button--internal",
      disabled: !selectedFile,
      onClick: e => this.handleNextStep(e)
    }, /*#__PURE__*/_react.default.createElement("span", null, dictionary && dictionary.downloadInteractionNext || "Next"), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__button__icon"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "7",
      height: "12",
      viewBox: "0 0 7 12"
    }, /*#__PURE__*/_react.default.createElement("g", {
      stroke: "currentcolor",
      strokeWidth: "1.3",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "square"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1 10.95L5.95 6M1 1l4.95 4.95"
    }))))))), currentStep === 2 && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__download-interaction__step gv__download-interaction__step--two",
      ref: this.step2Ref,
      tabIndex: "-1"
    }, mediums && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__download-interaction__mediums"
    }, mediums.includes("googleDrive") && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__medium-item gv__medium-item--google-drive",
      ref: this.googleRef
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, isReady && /*#__PURE__*/_react.default.createElement("div", {
      className: "g-savetodrive",
      "data-src": selectedFile && selectedFile.url,
      "data-filename": selectedFile && selectedFile["download-title"],
      "data-sitename": mediumSettings.googleDrive.companyName
    }), /*#__PURE__*/_react.default.createElement(_loading.default, {
      isLoading: true
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      "aria-hidden": "true"
    }, dictionary && dictionary.googleDriveLabel || "Google Drive")), mediums.includes("direct") && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__medium-item gv__medium-item--direct"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "actionable",
      ref: this.directRef,
      download: true,
      href: selectedFile && selectedFile.url
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/OWH/assets-build/img/icons/direct-download.svg",
      alt: dictionary.downloadLabel
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      "aria-hidden": "true"
    }, dictionary && dictionary.downloadLabel || "Download")))), isReady === false && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__download-interaction__message"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Sorry, there are no download options available."))));
  }
}
exports.default = DownloadInteractionApp;
_defineProperty(DownloadInteractionApp, "propTypes", {
  dictionary: _propTypes.object,
  items: _propTypes.array,
  mediums: _propTypes.array,
  mediumSettings: _propTypes.object,
  onClose: _propTypes.func,
  triggerButtons: _propTypes.object,
  containerId: _propTypes.string
});
_defineProperty(DownloadInteractionApp, "defaultProps", {
  dictionary: null,
  items: null,
  mediums: null,
  mediumSettings: null,
  onClose: null,
  triggerButtons: null,
  containerId: null
});

},{"../partials/loading.jsx":150,"../partials/select-input.jsx":154,"classNames":"classNames","prop-types":"prop-types","react":"react"}],73:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _DownloadInteractionApp = _interopRequireDefault(require("./DownloadInteractionApp.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const elements = document.querySelectorAll(".js-download-interaction");
if (elements) {
  elements.forEach(element => {
    const container = element.closest(".js-gv__material-card__container");
    const is5050Promo = element.closest(".gv__session-container--50-50") ? true : false;
    const triggerButtons = is5050Promo ? document.querySelectorAll(".js-manual-modal-toggle") : container && container.querySelectorAll(".js-gv-material-card__btn[data-content-type=download]") || document.querySelectorAll(".js-gv__reset-interaction");
    const id = container && container.getAttribute("id");
    const props = {
      containerId: id,
      items: JSON.parse(element.getAttribute("data-items")) || null,
      dictionary: JSON.parse(element.getAttribute("data-dictionary")) || null,
      mediums: JSON.parse(element.getAttribute("data-mediums")) || null,
      mediumSettings: JSON.parse(element.getAttribute("data-medium-settings")) || null,
      triggerButtons
    };
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_DownloadInteractionApp.default, props), element);
  });
}

},{"./DownloadInteractionApp.jsx":72,"react":"react","react-dom":"react-dom"}],74:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const editorView = document.querySelector("body.experience-editor");
  const initDropdownMenu = (el, i) => {
    const menu = el;
    const menuButton = el.querySelector(".js-gv__dropdown-menu__btn");
    const openClass = "is-open";
    const menuList = el.querySelector(".js-gv__dropdown-menu__list");
    const menuItems = el.querySelectorAll(".js-gv__dropdown-menu__list-item").length ? el.querySelectorAll(".js-gv__dropdown-menu__list-item") : menuList.querySelectorAll("a, input, button");
    let globalToggled = false;
    let mainBuffer = setTimeout(() => {}, 1);
    if (el.classList.contains(openClass) || editorView) {
      globalToggled = true;
      toggleContent(globalToggled);
    }

    //Focus Trap
    [...menuItems].forEach((link, index) => {
      link.addEventListener("keydown", e => {
        let target = index;
        switch (e.key) {
          case "Escape":
            toggleContent(true);
            menuButton.focus();
            break;
          case "Up":
          case "ArrowUp":
            e.preventDefault();
            if (index === 0) {
              target = menuItems.length;
            }
            menuItems[target - 1].focus();
            break;
          case "Down":
          case "ArrowDown":
            e.preventDefault();
            if (index === menuItems.length - 1) {
              target = -1;
            }
            menuItems[target + 1].focus();
            break;
          case "Tab":
            if (e.shiftKey) {
              e.preventDefault();
              toggleContent(true);
              menuButton.focus();
            }
            if (index === menuItems.length - 1) {
              e.preventDefault();
              toggleContent(true);
              menuButton.focus();
            }
            break;
          default:
        }
      });
    });

    //eventlistener if not in EE
    if (editorView === null) {
      menuButton.addEventListener("click", e => {
        e.preventDefault();
        // toggled = !toggled;
        toggleContent(globalToggled);
      });
    }
    function toggleContent(toggled) {
      clearTimeout(mainBuffer);
      if (menu.classList.contains(openClass)) {
        menu.classList.remove(openClass);
        menuList.setAttribute("aria-hidden", true);
        menuButton.setAttribute("aria-expanded", false);
        menuButton.focus();
      } else {
        const allDropdowns = document.querySelectorAll(".js-gv__dropdown-menu");
        [...allDropdowns].forEach(dropdown => dropdown.classList.contains(openClass) && dropdown.classList.remove(openClass));
        menu.classList.add(openClass);
        menuList.setAttribute("aria-hidden", false);
        menuButton.setAttribute("aria-expanded", true);
        mainBuffer = setTimeout(() => {
          menuItems[0].focus();
        }, 600);
      }
      globalToggled = !toggled;
    }
  };
  [...document.querySelectorAll(".js-gv__dropdown-menu")].forEach(initDropdownMenu);
}

},{}],75:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _textInput = _interopRequireDefault(require("../partials/text-input.jsx"));
var _selectInput = _interopRequireDefault(require("../partials/select-input.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _classnames = _interopRequireDefault(require("classnames"));
var _validation = require("../validation.js");
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class EditPeriod extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      this.fetchCourses();
      const buttons = document.querySelectorAll(".js-edit-period__btn");
      if (buttons) {
        buttons.forEach(button => button.addEventListener("click", this.openModal));
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      if (this.state.modalIsOpen === false) {
        const buttons = document.querySelectorAll(".js-edit-period__btn");
        if (buttons) {
          buttons.forEach(button => button.setAttribute("aria-expanded", false));
        }
      }
    });
    _defineProperty(this, "fetchCourses", () => {
      const params = {};
      fetch(`${this.props.requestUrl}/owh/course/getcourses`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.Message) {
          console.warn(data.Message);
          return;
        }
        const courses = data.map(course => {
          return {
            courseName: course.CourseName,
            courseSummary: course.CourseSummary,
            courseId: course.CourseId
          };
        });
        const filteredResults = R.filter(R.propEq("courseId", parseInt(this.props.dictionary.editClassCourseId)), courses);
        const details = filteredResults[0].courseSummary;
        this.setState({
          isLoading: false
        });
      }).catch(err => {
        console.error(err);
        this.setState({
          isLoading: false
        });
      });
    });
    _defineProperty(this, "onFormSubmit", e => {
      e.preventDefault();
      let {
        newClassNameInput,
        courseId,
        buttonDisabled,
        lengthError
      } = this.state;
      let input = document.querySelectorAll(".gv__edit-period-modal .gv__text-input__field")[0];
      let checkLength = newClassNameInput.value.length >= 0 && newClassNameInput.value.length < 3;
      if (newClassNameInput.value !== this.props.dictionary.editClassPeriodName || courseId !== this.props.dictionary.editClassCourseId) {
        if (!newClassNameInput.error) {
          newClassNameInput.error = !(0, _validation.validateField)("text", newClassNameInput.value) || checkLength;
          if (checkLength) {
            this.setState({
              newClassNameInput
            });
            newClassNameInput.errorMsg = lengthError;
            input.focus();
          } else if (newClassNameInput.error) {
            this.setState({
              newClassNameInput
            });
            newClassNameInput.errorMsg = this.props.dictionary.editClassBlankError;
            input.focus();
          } else {
            this.editPeriod();
          }
        } else {
          input.focus();
        }
      } else {
        input.focus();
      }
    });
    _defineProperty(this, "editPeriod", () => {
      const params = {
        PeriodId: this.props.dictionary.editClassPeriodId,
        PeriodName: this.state.newClassNameInput.value
      };
      this.setState({
        isLoading: true
      });
      fetch(`${this.props.requestUrl}/owh/period/editperiod`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data && data.Succeeded) {
          location.reload();
        } else {
          const {
            newClassNameInput
          } = this.state;
          newClassNameInput.error = true;
          newClassNameInput.errorMsg = data.Message;
          this.setState({
            newClassNameInput,
            isLoading: false
          });
        }
      }).catch(error => {
        const {
          newClassNameInput
        } = this.state;
        newClassNameInput.error = true;
        newClassNameInput.errorMsg = error;
        this.setState({
          newClassNameInput,
          isLoading: false
        });
      });
    });
    _defineProperty(this, "openModal", e => {
      this.setState({
        modalIsOpen: true
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      let {
        newClassNameInput
      } = this.state;
      newClassNameInput.value = "";
      newClassNameInput.error = false;
      newClassNameInput.errorMsg = "";
      newClassNameInput.warningMsg = "";
      this.setState({
        modalIsOpen: false,
        newClassNameInput,
        selectedCourse: "",
        courseDescription: ""
      });
    });
    _defineProperty(this, "handlePeriodNameInput", event => {
      const maxCharacters = 45;
      const {
        newClassNameInput,
        lengthError
      } = this.state;
      const value = event.target.value.substr(0, maxCharacters);
      const length = value.length;
      let checkLength = length >= 0 && length < 3;
      newClassNameInput.value = value;
      newClassNameInput.error = !(0, _validation.validateField)("text", value);
      newClassNameInput.warning = length > 0 && length >= 3;
      if (length > 0 && length < 3) {
        newClassNameInput.error = true;
        newClassNameInput.errorMsg = lengthError;
      } else if (length > 0) {
        newClassNameInput.warningMsg = `${maxCharacters - length} characters remaining`;
      } else if (newClassNameInput.error) {
        newClassNameInput.error = this.props.dictionary.editClassBlankError;
      }
      this.setState({
        newClassNameInput
      });
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
    });
    this.state = {
      modalIsOpen: props.modalIsOpen || false,
      isLoading: false,
      selectedCourse: props.dictionary.editClassCourseId,
      buttonDisabled: true,
      lengthError: "class name should be at least 3 characters long",
      //this may be moved to props laterm
      newClassNameInput: {
        value: props.dictionary.editClassPeriodName,
        error: false,
        errorMsg: this.props.dictionary.editClassBlankError,
        warningMsg: ""
      }
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      newClassNameInput
    } = this.state;
    const {
      dictionary
    } = this.props;
    const {
      editClassTitle,
      editClassPeriodNameLabel,
      editClassCourseNameLabel,
      editClassSaveButtonLabel,
      editClassPeriodId,
      editClassCourseId
    } = dictionary;
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__edit-period-modal"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      tabIndex: "-1",
      ref: this.modalTitleRef,
      className: "gv__edit-period-modal__title gv__page-title"
    }, editClassTitle), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this.onFormSubmit
    }, /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, newClassNameInput, {
      onChange: this.handlePeriodNameInput,
      label: editClassPeriodNameLabel,
      type: "text",
      errorMsg: newClassNameInput.errorMsg,
      warningMsg: newClassNameInput.warningMsg
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__edit-period-modal__button-row gv__button-row"
    }, /*#__PURE__*/_react.default.createElement("button", {
      // disabled={buttonDisabled}
      type: "submit",
      className: "gv__button"
    }, editClassSaveButtonLabel)))));
  }
}
exports.default = EditPeriod;
_defineProperty(EditPeriod, "propTypes", {
  requestUrl: _propTypes.string,
  dictionary: (0, _propTypes.shape)({
    editClassTitle: _propTypes.string,
    editClassBlankError: _propTypes.string,
    editClassPeriodNameLabel: _propTypes.string,
    editClassCourseNameLabel: _propTypes.string,
    editClassCourseId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    editClassCourseDetails: _propTypes.string,
    editClassSaveButtonLabel: _propTypes.string,
    editClassPeriodId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    editClassPeriodName: _propTypes.string
  }),
  modalIsOpen: _propTypes.bool
});

},{"../partials/select-input.jsx":154,"../partials/text-input.jsx":156,"../validation.js":262,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-modal":"react-modal"}],76:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var R = _interopRequireWildcard(require("ramda"));
var _EditPeriod = _interopRequireDefault(require("./EditPeriod.jsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-edit-period-mount");
if (el) {
  const props = {
    requestUrl: el.dataset.requestUrl || "",
    dictionary: JSON.parse(el.dataset.dictionary) || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_EditPeriod.default, props), el);
}

},{"./EditPeriod.jsx":75,"ramda":"ramda","react":"react","react-dom":"react-dom"}],77:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class DeleteStudent extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const buttons = document.querySelectorAll(".js-remove-student-button");
      if (buttons) {
        buttons.forEach(button => {
          button.addEventListener("click", this.openModal);
        });
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      const buttons = document.querySelectorAll(".js-remove-student-button");
      if (buttons) {
        buttons.forEach(button => button.setAttribute("aria-expanded", false));
      }
    });
    _defineProperty(this, "deleteStudent", e => {
      e.preventDefault();
      const params = {
        studentId: this.props.studentId,
        periodId: this.props.periodId
      };
      fetch(`${this.props.requestUrl}/owh/period/DeleteStudent`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.IsValid) {
          if (data.RedirectUrl) {
            window.location.href = data.RedirectUrl;
          } else {
            location.reload();
          }
        } else {
          let {
            generalError
          } = this.state;
          generalError.error = true;
          generalError.errorMsg = data.Errors[0];
          this.setState({
            generalError
          });
        }
      }).catch(error => {
        console.log(error);
      });
    });
    _defineProperty(this, "openModal", e => {
      this.setState({
        modalIsOpen: true
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      if (this.props.updateParent) {
        this.props.updateParent();
      }
      this.setState({
        modalIsOpen: false
      });
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
    });
    this.state = {
      modalIsOpen: props.modalIsOpen || false,
      isLoading: false,
      generalError: {
        error: false,
        errorMsg: ""
      }
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      dictionary
    } = this.props;
    const {
      generalError
    } = this.state;
    const {
      title,
      subtitle,
      confirmationButtonLabel,
      cancelLabel
    } = dictionary;
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__delete-modal"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      ref: this.modalTitleRef,
      tabIndex: "-1",
      className: "gv__delete-modal__title gv__page-title"
    }, title), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__delete-modal__subtitle",
      dangerouslySetInnerHTML: {
        __html: subtitle
      }
    }), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: e => this.deleteStudent(e)
    }, generalError.error && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__form__error-msg gv__form__error-msg--general has-error"
    }, generalError.errorMsg), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__delete-modal__button-row gv__button-row"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__button gv__button--secondary"
    }, cancelLabel), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "gv__button"
    }, confirmationButtonLabel)))));
  }
}
exports.default = DeleteStudent;
_defineProperty(DeleteStudent, "propTypes", {
  periodId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  studentId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  requestUrl: _propTypes.string,
  dictionary: (0, _propTypes.shape)({
    title: _propTypes.string,
    subtitle: _propTypes.string,
    cancelLabel: _propTypes.string,
    confirmationButtonLabel: _propTypes.string
  }),
  modalIsOpen: _propTypes.bool,
  updateParent: _propTypes.func
});

},{"prop-types":"prop-types","react":"react","react-modal":"react-modal"}],78:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _DeleteStudent = _interopRequireDefault(require("./DeleteStudent.jsx"));
var _EditStudentForm = _interopRequireDefault(require("./EditStudentForm.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
_reactModal.default.setAppElement(document.querySelector(".js-page-content-wrapper"));
class EditStudent extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const buttons = document.querySelectorAll(".js-gv__edit-students") || [];
      buttons.forEach(button => button.addEventListener("click", this.openModal));
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      if (this.state.modalIsOpen === false) {
        const buttons = document.querySelectorAll(".js-edit-student__btn");
        if (buttons) {
          buttons.forEach(button => button.setAttribute("aria-expanded", false));
        }
      }
    });
    _defineProperty(this, "openModal", e => {
      const button = e.target;
      const data = JSON.parse(button.getAttribute("data-student"));
      button.setAttribute("aria-expanded", true);
      this.setState({
        modalIsOpen: true,
        student: data
      });
    });
    _defineProperty(this, "closeModal", () => {
      this.setState({
        modalIsOpen: false
      });
    });
    _defineProperty(this, "removeStudent", () => {
      let {
        deleteModalIsOpen
      } = this.state;
      deleteModalIsOpen = !deleteModalIsOpen;
      this.setState({
        deleteModalIsOpen
      });
      this.closeModal();
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
    });
    this.state = {
      deleteModalIsOpen: false,
      modalIsOpen: props.modalIsOpen || false,
      isLoading: false,
      student: {}
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      modalIsOpen,
      deleteModalIsOpen,
      student
    } = this.state;
    const {
      dictionary,
      periodId,
      requestUrl,
      teacherId,
      deleteModal,
      isClever
    } = this.props;
    const {
      title
    } = dictionary;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "Edit Student Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__edit-student-modal"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      tabIndex: "-1",
      ref: this.modalTitleRef,
      className: "gv__edit-student-modal__title gv__page-title"
    }, title), /*#__PURE__*/_react.default.createElement(_EditStudentForm.default, {
      dictionary: dictionary,
      periodId: periodId,
      requestUrl: requestUrl,
      teacherId: teacherId,
      modalIsOpen: modalIsOpen,
      student: student,
      closeModal: this.closeModal,
      removeStudent: this.removeStudent,
      isClever: isClever
    }))), /*#__PURE__*/_react.default.createElement(_DeleteStudent.default, {
      requestUrl: this.props.requestUrl,
      modalIsOpen: deleteModalIsOpen,
      dictionary: deleteModal,
      updateParent: this.removeStudent,
      studentId: student.studentId,
      periodId: this.props.periodId
    }));
  }
}
exports.default = EditStudent;
_defineProperty(EditStudent, "propTypes", {
  dictionary: (0, _propTypes.shape)({
    title: _propTypes.string
  }),
  deleteModal: (0, _propTypes.shape)({
    title: _propTypes.string,
    subtitle: _propTypes.string,
    cancelLabel: _propTypes.string,
    confirmationButtonLabel: _propTypes.string
  }),
  periodId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  requestUrl: _propTypes.string,
  teacherId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  modalIsOpen: _propTypes.bool,
  isClever: _propTypes.bool
});

},{"./DeleteStudent.jsx":77,"./EditStudentForm.jsx":79,"prop-types":"prop-types","react":"react","react-modal":"react-modal"}],79:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _textInput = _interopRequireDefault(require("../partials/text-input.jsx"));
var _selectInput = _interopRequireDefault(require("../partials/select-input.jsx"));
var _validation = require("../validation.js");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class EditStudentForm extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      this.fetchPeriods();
      this.populateStudent(this.props.student);
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        if (this.props.modalIsOpen) {
          this.populateStudent(this.props.student);
        }
      }
    });
    _defineProperty(this, "populateStudent", student => {
      let {
        newFirstNameInput,
        newLastNameInput,
        newEmailInput
      } = this.state;
      newFirstNameInput.value = student.firstName;
      newLastNameInput.value = student.lastName;
      newEmailInput.value = student.email;
      this.setState({
        newFirstNameInput,
        newLastNameInput,
        newEmailInput
      });
    });
    _defineProperty(this, "fetchPeriods", () => {
      const params = {};

      // for initial development
      if (this.props.teacherId) {
        params.teacherId = this.props.teacherId;
      }
      fetch(`${this.props.requestUrl}/owh/period/getperiods`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.Message) {
          console.warn(data.Message);
          return;
        }
        const periods = data.Periods.map(period => {
          return {
            teacherid: period.teacherId,
            id: period.PeriodId,
            name: period.PeriodName,
            code: period.PeriodCode,
            students: period.NumberOfStudents,
            url: period.PeriodUrl,
            courseName: period.CourseName
          };
        });
        this.setState({
          isLoading: false,
          periods
        });
      }).catch(err => {
        console.error(err);
        this.setState({
          isLoading: false
        });
      });
    });
    _defineProperty(this, "onFormSubmit", e => {
      e.preventDefault();
      if (this.props.isClever) {
        this.editCleverStudents();
      } else {
        this.editStudents();
      }
    });
    _defineProperty(this, "editCleverStudents", () => {
      const {
        generalError
      } = this.state;
      let params = {
        Student_Id: this.props.student.studentId,
        First_Name: this.state.newFirstNameInput.value,
        Last_Name: this.state.newLastNameInput.value,
        PeriodId: this.props.periodId
      };
      generalError.error = false;
      this.setState({
        isLoading: true,
        generalError
      });
      fetch(`${this.props.requestUrl}/owh/student/TeacherEditCleverStudentDataModal`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data && data.IsValid) {
          location.reload();
        } else {
          generalError.error = true;
          generalError.errorMsg = data.Errors[0];
          this.setState({
            generalError,
            isLoading: false
          });
          this.studentForm.current.querySelector(".has-error input").focus();
        }
      }).catch(error => {
        generalError.error = true;
        this.setState({
          generalError,
          isLoading: false
        });
        this.studentForm.current.focus();
      });
    });
    _defineProperty(this, "editStudents", () => {
      const {
        generalError
      } = this.state;
      let params = {
        Student_Id: this.props.student.studentId,
        First_Name: this.state.newFirstNameInput.value,
        Last_Name: this.state.newLastNameInput.value,
        Old_Email: this.props.student.email,
        New_Email: this.state.newEmailInput.value,
        Old_Period_Id: this.props.periodId,
        New_Period_Id: this.state.selectedPeriod
      };
      if (this.state.setPasswordInput.value.length > 0) {
        params.New_password = this.state.setPasswordInput.value, params.New_Password2 = this.state.confirmPasswordInput.value;
      }
      generalError.error = false;
      this.setState({
        isLoading: true,
        generalError
      });
      fetch(`${this.props.requestUrl}/owh/student/TeacherEditStudentDataModal`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data && data.IsValid) {
          location.reload();
        } else {
          generalError.error = true;
          generalError.errorMsg = data.Errors[0];
          this.setState({
            generalError,
            isLoading: false
          });
          this.studentForm.current.querySelector(".has-error input").focus();
        }
      }).catch(error => {
        this.studentForm.current.querySelector(".has-error input").focus();
        generalError.error = true;
        this.setState({
          generalError,
          isLoading: false
        });
      });
    });
    _defineProperty(this, "handlePeriodInput", event => {
      const {
        selectPeriodInput
      } = this.state;
      const value = event.target.value;
      selectPeriodInput.value = value;
      this.setState({
        selectPeriodInput
      });
    });
    _defineProperty(this, "handleFirstNameChange", event => {
      const {
        newFirstNameInput
      } = this.state;
      newFirstNameInput.value = event.target.value;
      newFirstNameInput.error = !(0, _validation.validateField)("text", event.target.value);
      this.checkButtonStatus();
      this.setState({
        newFirstNameInput
      });
    });
    _defineProperty(this, "handleLastNameChange", event => {
      const {
        newLastNameInput
      } = this.state;
      newLastNameInput.value = event.target.value;
      newLastNameInput.error = !(0, _validation.validateField)("text", event.target.value);
      this.checkButtonStatus();
      this.setState({
        newLastNameInput
      });
    });
    _defineProperty(this, "handleNewPasswordInput", event => {
      const {
        setPasswordInput,
        confirmPasswordInput
      } = this.state;
      setPasswordInput.value = event.target.value;
      setPasswordInput.error = !(0, _validation.validateField)("password", event.target.value);

      //check to make sure both still match
      if (confirmPasswordInput.value) {
        confirmPasswordInput.error = !(0, _validation.validateField)("new-password", event.target.value, confirmPasswordInput.value);
        this.checkButtonStatus();
      }
      this.setState({
        setPasswordInput,
        confirmPasswordInput
      });
    });
    _defineProperty(this, "handleConfirmPasswordInput", event => {
      const {
        confirmPasswordInput
      } = this.state;
      confirmPasswordInput.value = event.target.value;
      confirmPasswordInput.error = !(0, _validation.validateField)("new-password", event.target.value, confirmPasswordInput.value);
      this.checkButtonStatus();
      this.setState({
        confirmPasswordInput
      });
    });
    _defineProperty(this, "handleEmailInput", event => {
      const {
        newEmailInput
      } = this.state;
      newEmailInput.value = event.target.value;
      newEmailInput.error = !(0, _validation.validateField)("email", event.target.value);
      this.checkButtonStatus();
      this.setState({
        newEmailInput
      });
    });
    _defineProperty(this, "checkButtonStatus", () => {
      //check if other errors exist
      const {
        newFirstNameInput,
        newLastNameInput,
        newEmailInput,
        setPasswordInput,
        confirmPasswordInput
      } = this.state;
      const allInputs = [newFirstNameInput, newLastNameInput, newEmailInput, setPasswordInput, confirmPasswordInput];
      let allError = allInputs.filter(input => input.error === true);
      if (allError.length > 0) {
        this.setState({
          buttonDisabled: true
        });
      } else {
        this.setState({
          buttonDisabled: false
        });
      }
    });
    _defineProperty(this, "handlePeriodChange", event => {
      const value = event.target.value;
      this.setState({
        selectedPeriod: value
      });
      if (event.target.value !== this.props.periodId) {
        this.setState({
          buttonDisabled: false
        });
      } else {
        this.setState({
          buttonDisabled: true
        });
      }
    });
    _defineProperty(this, "clickResetPassword", event => {
      let focusBuffer = setTimeout(() => {}, 1);
      if (this.state.resetRendered) {
        document.querySelector("input[type=password]").value = "";

        //reset values if it's closed to prevent it from resetting in error.
        const {
          confirmPasswordInput,
          setPasswordInput
        } = this.state;
        confirmPasswordInput.value = "";
        setPasswordInput.value = "";
        confirmPasswordInput.error = false;
        setPasswordInput.error = false;
        this.setState({
          setPasswordInput,
          confirmPasswordInput
        });
      } else {
        focusBuffer = setTimeout(() => {
          this.resetPassword.current.querySelector("input").focus();
        }, 30);
      }
      this.setState({
        resetRendered: !this.state.resetRendered
      });
    });
    this.state = {
      isLoading: false,
      periods: [],
      student: {},
      buttonDisabled: true,
      selectedPeriod: this.props.periodId,
      generalError: {
        error: false,
        errorMsg: this.props.dictionary.unknownError
      },
      newFirstNameInput: {
        value: "",
        error: false,
        errorMsg: this.props.dictionary.firstNameError
      },
      newLastNameInput: {
        value: "",
        error: false,
        errorMsg: this.props.dictionary.lastNameError
      },
      newEmailInput: {
        value: "",
        error: false,
        errorMsg: this.props.dictionary.emailError
      },
      setPasswordInput: {
        value: "",
        error: false,
        errorMsg: this.props.dictionary.passwordError
      },
      confirmPasswordInput: {
        value: "",
        error: false,
        errorMsg: this.props.dictionary.confirmPasswordError
      }
    };
    this.studentForm = /*#__PURE__*/_react.default.createRef();
    this.resetPassword = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      buttonDisabled,
      newFirstNameInput,
      newLastNameInput,
      newEmailInput,
      setPasswordInput,
      confirmPasswordInput,
      generalError
    } = this.state;
    const {
      dictionary,
      periodId,
      isClever
    } = this.props;
    const {
      firstNameLabel,
      lastNameLabel,
      moveStudentLabel,
      emailLabel,
      passwordLabel,
      resetPasswordLabel,
      cancelResetPasswordLabel,
      newPasswordLabel,
      confirmPasswordLabel,
      removeStudentLabel,
      saveChangesLabel,
      cancelLabel,
      passwordError
    } = dictionary;
    const submitButtonClass = (0, _classnames.default)("gv__button", {
      "gv__button is-loading": buttonDisabled
    });
    const periodOptions = this.state.periods.map(period => {
      return {
        label: period.name,
        value: period.id
      };
    });
    const resetClasses = (0, _classnames.default)("gv__form__reset-password", {
      "is-open": this.state.resetRendered
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__edit-student__form"
    }, /*#__PURE__*/_react.default.createElement("form", {
      ref: this.studentForm,
      onSubmit: this.onFormSubmit
    }, /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, newFirstNameInput, {
      onChange: this.handleFirstNameChange,
      label: firstNameLabel,
      type: "text",
      errorMsg: newFirstNameInput.errorMsg
    })), /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, newLastNameInput, {
      onChange: this.handleLastNameChange,
      label: lastNameLabel,
      type: "text",
      errorMsg: newLastNameInput.errorMsg
    })), !isClever && periodOptions.length > 0 && /*#__PURE__*/_react.default.createElement(_selectInput.default, {
      onChange: this.handlePeriodChange,
      value: periodId,
      label: moveStudentLabel,
      options: periodOptions
    }), !isClever && /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, newEmailInput, {
      onChange: this.handleEmailInput,
      label: emailLabel,
      type: "text",
      errorMsg: newEmailInput.errorMsg
    })), !isClever && /*#__PURE__*/_react.default.createElement("div", {
      className: resetClasses,
      "aria-expanded": this.state.resetRendered
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__form__reset-password-btn btn",
      onClick: () => this.clickResetPassword()
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__text-input__text gv__form__label gv__edit-student-modal__password-label"
    }, passwordLabel), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__form__reset-password-close"
    }, cancelResetPasswordLabel), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__form__reset-password-open"
    }, resetPasswordLabel)), /*#__PURE__*/_react.default.createElement("div", {
      ref: this.resetPassword,
      className: "gv__form__split-row"
    }, /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, setPasswordInput, {
      onChange: this.handleNewPasswordInput,
      label: newPasswordLabel,
      labelledBy: "passwordInstructions",
      type: "password"
    })), /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, confirmPasswordInput, {
      onChange: this.handleConfirmPasswordInput,
      label: confirmPasswordLabel,
      type: "password"
    })), /*#__PURE__*/_react.default.createElement("div", {
      "aria-atomic": "true",
      id: "passwordInstructions",
      className: "gv__form__full-width"
    }, passwordError))), generalError.error && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__form__error-msg gv__form__error-msg--general has-error",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, generalError.errorMsg), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__edit-student-modal__button-row gv__button-row"
    }, !isClever ? /*#__PURE__*/_react.default.createElement("button", {
      className: "gv__button gv__button--secondary js-remove-student-button",
      onClick: this.props.removeStudent,
      type: "button"
    }, removeStudentLabel) : /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__edit-student-modal__button-group"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "gv__edit-student-modal__cancel-button",
      onClick: this.props.closeModal,
      type: "button"
    }, cancelLabel), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: submitButtonClass,
      disabled: buttonDisabled
    }, saveChangesLabel)))));
  }
}
exports.default = EditStudentForm;
_defineProperty(EditStudentForm, "propTypes", {
  dictionary: (0, _propTypes.shape)({
    firstNameLabel: _propTypes.string,
    lastNameLabel: _propTypes.string,
    moveStudentLabel: _propTypes.string,
    emailLabel: _propTypes.string,
    passwordLabel: _propTypes.string,
    resetPasswordLabel: _propTypes.string,
    cancelPasswordLabel: _propTypes.string,
    newPasswordLabel: _propTypes.string,
    confirmPasswordLabel: _propTypes.string,
    removeStudentLabel: _propTypes.string,
    saveChangesLabel: _propTypes.string,
    cancelLabel: _propTypes.string,
    unknownError: _propTypes.string,
    firstNameError: _propTypes.string,
    lastNameError: _propTypes.string,
    emailError: _propTypes.string,
    passwordError: _propTypes.string,
    confirmPasswordError: _propTypes.string
  }),
  student: _propTypes.object,
  periodId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  requestUrl: _propTypes.string,
  teacherId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  modalIsOpen: _propTypes.bool,
  closeModal: _propTypes.func,
  removeStudent: _propTypes.func,
  isClever: _propTypes.bool
});

},{"../partials/select-input.jsx":154,"../partials/text-input.jsx":156,"../validation.js":262,"classnames":"classnames","prop-types":"prop-types","react":"react"}],80:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _EditStudent = _interopRequireDefault(require("./EditStudent.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-edit-student-modal");
// only initialize if it's not already being initialized through another react app

if (el && !el.classList.contains("js-no-initialize")) {
  const props = {
    dictionary: JSON.parse(el.dataset.dictionary) || {},
    periodId: el.dataset.periodId || "",
    requestUrl: el.dataset.requestUrl || "",
    teacherId: el.dataset.teacherId || "",
    deleteModal: JSON.parse(el.dataset.delete) || {},
    isClever: el.dataset.periodIsClever && el.dataset.periodIsClever.toLowerCase() === "true" ? true : false
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_EditStudent.default, props), el);
}

},{"./EditStudent.jsx":78,"react":"react","react-dom":"react-dom"}],81:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const EditTeacherImage = props => {
  const {
    defaultImage,
    dictionary
  } = props;
  const [newProfile, setNewProfile] = (0, _react.useState)("");
  const [preview, setPreview] = (0, _react.useState)(defaultImage);
  const [hasError, setHasError] = (0, _react.useState)(false);
  const [error, setError] = (0, _react.useState)("");
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const inputFile = (0, _react.useRef)(null);

  /**
   * Determines if the form is valid
   * @returns {Boolean} if the form is valid
   */
  const validate = () => {
    return !!newProfile;
  };

  /**
   * Submit handler.  Make a call to update the profile
   * image in the database.  Throw errors if needed
   * @param {Event} event submit event
   */
  const handleSubmit = event => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    handleError(false);
    setIsLoading(true);
    if (validate()) {
      fetch("/owh/teacher/UpdateTeacherProfileImage", {
        method: "POST",
        body: newProfile,
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        setIsLoading(false);
        if (data && data.IsValid) {
          location.reload();
        } else {
          const err = data ? data.Errors[0] : dictionary.errorGeneric;
          handleError(true, err);
        }
      }).catch(error => {
        console.log(error);
        setIsLoading(false);
        handleError(true, dictionary.errorGeneric);
      });
    } else {
      handleError(true, dictionary.errorNullImage);
      setIsLoading(false);
    }
  };

  /**
   * Display or hide errors
   * @param {Boolean} isInvalid if should display error
   * @param {String} msg Error message to display
   */
  const handleError = function (isInvalid) {
    let msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    setHasError(isInvalid);
    setError(msg);
  };

  /**
   * Triggers a click event on the upload file input
   * @param {Event} event click event
   */
  const triggerUpload = event => {
    if (inputFile && inputFile.current) {
      inputFile.current.click();
      inputFile.current.focus();
    }
  };

  /**
   * Sets a preview image of the selected file
   * @param {Event} event click event
   */
  const handleUpload = event => {
    handleError(false);
    const [file] = event.target.files;
    if (file) {
      const uploadedFile = URL.createObjectURL(file);
      setPreview(uploadedFile);
      setNewProfile(file);
    }
  };

  /**
   * Clears the image preview and any errors on form reset
   * @param {Event} event reset event
   */
  const handleReset = event => {
    setPreview(defaultImage);
    handleError(false);
  };

  /**
   * Prevents any click events while form is being submitted
   * @param {Event} event click event
   */
  const handleFileClick = event => {
    if (isLoading) {
      event.preventDefault();
    }
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    className: "gv__profile-header__form gv__form js-clear-inner-form",
    onSubmit: handleSubmit,
    onReset: handleReset,
    noValidate: true
  }, isLoading && /*#__PURE__*/_react.default.createElement("p", {
    role: "alert",
    className: "gv__visuallyhidden"
  }, "Submitting form. Please wait."), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("gv__profile-header__preview-container gv__form__item", {
      "has-error": hasError
    })
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "gv__profile-header__preview",
    src: preview,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    id: "avatarUpload",
    "aria-required": "true",
    name: "avatarImage",
    className: "gv__form__field gv__form__field--file gv__visuallyhidden ",
    accept: ".png,.jpeg,.jpg",
    onChange: handleUpload,
    onClick: handleFileClick,
    ref: inputFile,
    "aria-disabled": isLoading
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "gv__button gv__form__label",
    id: "avatarUploadLabel",
    "aria-disabled": isLoading,
    onClick: triggerUpload,
    tabIndex: "-1"
  }, dictionary.uploadLabel), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    id: "avatarError",
    className: "gv__form__error-msg",
    role: hasError ? "alert" : null
  }, error)), /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "gv__button",
    "aria-disabled": isLoading
  }, dictionary.saveLabel));
};
EditTeacherImage.propTypes = {
  defaultImage: _propTypes.string,
  dictionary: (0, _propTypes.shape)({
    saveLabel: _propTypes.string,
    uploadLabel: _propTypes.string,
    errorNullImage: _propTypes.string,
    errorGeneric: _propTypes.string
  })
};
var _default = exports.default = EditTeacherImage;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],82:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var R = _interopRequireWildcard(require("ramda"));
var _EditTeacherImage = _interopRequireDefault(require("./EditTeacherImage.jsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-edit-teacher-image-mount");
if (el) {
  const props = {
    // requestUrl: el.dataset.requestUrl || "",
    defaultImage: el.dataset.defaultImage || "",
    modalId: el.dataset.modalId || "",
    dictionary: JSON.parse(el.dataset.dictionary) || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_EditTeacherImage.default, props), el);
}

},{"./EditTeacherImage.jsx":81,"ramda":"ramda","react":"react","react-dom":"react-dom"}],83:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.editTeacherHeader = void 0;
const editTeacherHeader = el => {
  const elForm = el.querySelector(".js-form");
  const triggerBtn = el.querySelector(".js-manual-modal-toggle");
  elForm.addEventListener("submit", event => {
    const field = elForm.querySelector(".js-file-field");
    if (field && !field.value) {
      event.target.reset();
      triggerBtn.click();
    }
  });
  elForm.addEventListener("success", event => {
    const field = elForm.querySelector(".js-file-field");
    const submit = elForm.querySelector("[type='submit']");
    const avatar = el.querySelector(".gv__avatar img");
    if (field && field.value) {
      submit.removeAttribute("disabled");
      submit.classList.remove("is-loading");
      elForm.classList.remove("has-submitted");
      if (avatar) {
        const [file] = field.files;
        if (file) {
          const src = URL.createObjectURL(file);
          avatar.src = src;
          field.dataset.originalValue = src;
        }
      }
      if (triggerBtn.getAttribute("aria-expanded") === "true") {
        triggerBtn.click();
      }
    }
  });
};
exports.editTeacherHeader = editTeacherHeader;
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-edit-teacher-header")].forEach(editTeacherHeader);
}

},{}],84:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class EnterStudentMode extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const button = document.querySelector(".js-enter-student-mode__btn");
      if (button) {
        button.addEventListener("click", this.openModal);
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      if (this.state.modalIsOpen === false) {
        const button = document.querySelector(".js-enter-student-mode__btn");
        if (button) {
          button.setAttribute("aria-expanded", false);
        }
      }
    });
    _defineProperty(this, "enterStudentMode", () => {
      const antiForgeryInput = document.querySelector('input[name=__RequestVerificationToken]');
      const antiForgeryToken = antiForgeryInput ? antiForgeryInput.value : "";
      let formData = new FormData();
      formData.append('periodId', this.props.periodId);
      formData.append('__RequestVerificationToken', antiForgeryToken);
      this.setState({
        isLoading: true
      });
      fetch(`${this.props.requestUrl}/owh/user/EnterStudentMode`, {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      }).then(response => response.json()).then(data => {
        if (data && data.IsValid) {
          location.assign(data.RedirectUrl);
        } else {
          let {
            generalError
          } = this.state;
          generalError.error = true;
          generalError.errorMsg = data.Errors[0];
          this.setState({
            generalError
          });
          this.setState({
            isLoading: false
          });
        }
      }).catch(error => {
        console.log(error);
      });
    });
    _defineProperty(this, "openModal", e => {
      this.setState({
        modalIsOpen: true
      });
      this.setState({
        generalError: {
          error: false,
          errorMsg: ""
        }
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      this.setState({
        modalIsOpen: false
      });
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
    });
    this.state = {
      modalIsOpen: props.modalIsOpen || false,
      isLoading: false,
      generalError: {
        error: false,
        errorMsg: ""
      }
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      isLoading,
      generalError
    } = this.state;
    const {
      dictionary
    } = this.props;
    const {
      title,
      subtitle,
      continueButtonLabel,
      cancelButtonLabel,
      iconSrc
    } = dictionary;
    const continueButtonClass = (0, _classnames.default)("gv__button gv__enter-student-mode-modal__continue-button js-enter-student-mode__continue-button", {
      "is-loading": isLoading
    });
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "Enter Student Mode Confirmation",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content gv__modal__content--orange-top"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__enter-student-mode-modal"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: iconSrc
    }), /*#__PURE__*/_react.default.createElement("h1", {
      tabIndex: "-1",
      ref: this.modalTitleRef,
      className: "gv__enter-student-mode-modal__title"
    }, title), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__enter-student-mode-modal__subtitle"
    }, subtitle), generalError.error && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__form__error-msg gv__form__error-msg--general has-error"
    }, generalError.errorMsg), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__button-row"
    }, /*#__PURE__*/_react.default.createElement("button", {
      disabled: isLoading,
      className: continueButtonClass,
      onClick: this.enterStudentMode
    }, continueButtonLabel)), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__button-row"
    }, /*#__PURE__*/_react.default.createElement("button", {
      onClick: this.closeModal,
      className: "gv__button-row__item gv__enter-student-mode-modal__cancel-button gv__link"
    }, cancelButtonLabel))));
  }
}
exports.default = EnterStudentMode;
_defineProperty(EnterStudentMode, "propTypes", {
  periodId: _propTypes.string,
  requestUrl: _propTypes.string,
  dictionary: _propTypes.object,
  modalIsOpen: _propTypes.bool
});

},{"classnames":"classnames","prop-types":"prop-types","react":"react","react-modal":"react-modal"}],85:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _EnterStudentMode = _interopRequireDefault(require("./EnterStudentMode.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-enter-student-mode-mount");
if (el) {
  const props = {
    requestUrl: el.dataset.requestUrl || "",
    periodId: el.dataset.periodId || "",
    dictionary: JSON.parse(el.dataset.dictionary) || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_EnterStudentMode.default, props), el);
}

},{"./EnterStudentMode.jsx":84,"react":"react","react-dom":"react-dom"}],86:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const initEventListing = (el, i) => {
    const target = el.querySelector(".js-event-listing-target");
    el.addEventListener("click", e => {
      e.preventDefault();
      const linkLocation = target.getAttribute("href");
      const linkTarget = target.getAttribute("target");
      if (linkTarget === "_blank") {
        window.open(linkLocation);
      } else {
        window.location = linkLocation;
      }
    });
  };
  if (document.querySelector("body.experience-editor") === null) {
    [...document.querySelectorAll(".js-event-listing-info")].forEach(initEventListing);
  }
}

},{}],87:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
const exitStudentMode = el => {
  let requestUrl = "";
  el.querySelector(".js-exit-student-mode").addEventListener("click", e => {
    el.setAttribute("disabled", true);
    requestUrl = el.dataset.requestUrl || requestUrl;
    const antiForgeryInput = document.querySelector('input[name=__RequestVerificationToken]');
    const antiForgeryToken = antiForgeryInput ? antiForgeryInput.value : "";
    let formData = new FormData();
    formData.append('__RequestVerificationToken', antiForgeryToken);
    fetch(`${requestUrl}/owh/user/ExitStudentMode`, {
      method: "POST",
      body: formData,
      credentials: "same-origin"
    }).then(response => response.json()).then(data => {
      if (data && data.IsValid) {
        location.assign(data.RedirectUrl);
      } else {
        const error = data.Errors[0];
        //TODO show error?
        console.log(error);
      }
    }).catch(error => {
      console.log(error);
    });
  });
};
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-student-mode-banner")].forEach(exitStudentMode);
}

},{}],88:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = featuredCardsAction;
function featuredCardsAction(document, window) {
  document.querySelectorAll(".js-featured-lesson-card-target").forEach((el, index) => {
    el.addEventListener("click", e => {
      e.stopPropagation();
      e.preventDefault();
      const linkLocation = el.getAttribute("href");
      const linkTarget = el.getAttribute("target");
      if (linkTarget === "_blank") {
        window.open(linkLocation);
      } else {
        window.location = linkLocation;
      }
    });
  });
}

},{}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _validation = require("./validation.js");
// Forms with empty inputs (create profile)
// <form class="sc-form js-form" action="apiUrl">

function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-form")].forEach(elForm => {
    const elItems = elForm.querySelectorAll(".js-form-required");
    const matchItems = elForm.querySelectorAll(".js-form-match");
    const fileItems = elForm.querySelectorAll(".js-form-file");
    const errorbox = elForm.querySelectorAll(".js-error-box");
    const recaptcha = elForm.querySelector(".g-recaptcha");
    const isResetDefaults = elForm.dataset.isResetDefaults === "true";
    const multiSelectCheckboxDropdown = elForm.querySelectorAll(".js-multiselect-checkbox-dropdown");
    const checkboxInputs = elForm.querySelectorAll(".gv__checkbox-layout.js-form-checkbox");
    const checkboxDropdown = elForm.querySelectorAll(".js-multiselect-checkbox-dropdown");
    const checkboxDropdownChild = elForm.querySelectorAll(".gv__form__checkbox-dropdown");
    //Keycodes to be used for accessibility
    const SPACEBAR_KEY_CODE = [0, 32];
    const ENTER_KEY_CODE = 13;
    const DOWN_ARROW_KEY_CODE = 40;
    const UP_ARROW_KEY_CODE = 38;
    const ESCAPE_KEY_CODE = 27;
    const checkboxDropdownIds = [];
    (0, _validation.setDefaults)(elForm);
    if (isResetDefaults) {
      elForm.addEventListener("reset", event => {
        hideErrors();
        (0, _validation.resetDefaults)(elForm);
      });
    }
    var checkboxArray = [];
    const storedValues = elForm.querySelector(".js-stored-checkbox-values");
    if (storedValues !== null && storedValues.value !== "") {
      if (JSON.parse(storedValues.value).length !== 0) {
        checkboxArray = JSON.parse(storedValues.value);
      }
    }
    const setMultiSelectCheckboxDropdown = (dropdownField, defaultDropdownText) => {
      const checkboxInput = dropdownField.querySelectorAll(".js-form-checkbox input");
      checkboxInput.forEach(element => {
        if (checkboxArray.includes(element.value)) {
          element.checked = true;
          element.dataset.checked = true;
        }
        if (element.checked) {
          defaultDropdownText.remove();
          const dropdownToggleContainer = element.closest(".js-multiselect-checkbox-dropdown");
          const dropdownTokenContainer = dropdownToggleContainer.querySelector(".js-token-container");
          const checkboxLabelText = element.dataset.labeltext;
          const checkboxValue = element.value;
          const tokenElement = document.createElement("a");
          tokenElement.classList.add("checkbox-dropdown__token");
          tokenElement.tabIndex = 0;
          tokenElement.dataset.value = checkboxValue;
          tokenElement.innerText = checkboxLabelText;
          dropdownTokenContainer.appendChild(tokenElement);
        }
      });
    };
    if (multiSelectCheckboxDropdown.length > 0) {
      multiSelectCheckboxDropdown.forEach(element => {
        const defaultDropdownText = element.querySelector(".js-default-label");
        setMultiSelectCheckboxDropdown(element, defaultDropdownText);
      });
    }

    // if (storedValues !== null) {	
    //   if (storedValues.value.length !== 0) {	
    //     checkboxArray = JSON.parse(storedValues.value);	
    //   }	
    // }

    const toggleCheckboxListVisibility = e => {
      if (e.target.classList.contains("checkbox-dropdown__token")) {
        return;
      }
      const openDropDown = SPACEBAR_KEY_CODE.includes(e.keyCode) || e.keyCode === ENTER_KEY_CODE;
      const checkboxDropdownParent = e.target.closest(".gv__form__checkbox-dropdown");
      const checkboxDropdownToggle = checkboxDropdownParent.querySelector(".js-dropdown-toggle");
      const checkboxDropdownList = checkboxDropdownParent.querySelector(".js-dropdown");
      const isDropdownOpen = checkboxDropdownParent.classList.contains("js-open-dropdown");
      const downArrowToOpen = document.activeElement.classList.contains("js-dropdown-toggle") && e.keyCode === DOWN_ARROW_KEY_CODE && !isDropdownOpen;
      const upArrowToOpen = document.activeElement.classList.contains("js-dropdown-toggle") && e.keyCode === UP_ARROW_KEY_CODE && !isDropdownOpen;
      const upArrowToNavigate = document.activeElement.classList.contains("js-dropdown-toggle") && e.keyCode === UP_ARROW_KEY_CODE || isDropdownOpen;
      const closeDropdown = e.keyCode === ESCAPE_KEY_CODE;
      const downArrowToNavigate = document.activeElement.classList.contains("js-dropdown-toggle") && e.keyCode === DOWN_ARROW_KEY_CODE || isDropdownOpen;

      /* 
        To mimick select keyboard functionality. If the down or up arrow is used when the focus is on the dropdown toggle button, 
        the dropdown should open and focus on the checkbox.
      */
      if (downArrowToOpen || upArrowToOpen) {
        checkboxDropdownParent.classList.toggle("js-open-dropdown");
        checkboxDropdownToggle.setAttribute("aria-expanded", "true");
        checkboxDropdownList.querySelector(".gv__form__label").focus();
      } else if (downArrowToNavigate || upArrowToNavigate) {
        checkboxDropdownList.querySelector(".gv__form__label").focus();
      }

      /* 
        Toggle the dropdown on the following event types: click, spacebar, enter
      */
      if (e.type === "click" || openDropDown) {
        checkboxDropdownParent.classList.toggle("js-open-dropdown");
        checkboxDropdownToggle.setAttribute("aria-expanded", checkboxDropdownToggle.getAttribute("aria-expanded") === "true" ? "false" : "true");
      }

      /* 
        Close the dropdown when hitting escape
      */
      if (closeDropdown) {
        checkboxDropdownParent.classList.remove("js-open-dropdown");
        checkboxDropdownToggle.setAttribute("aria-expanded", "false");
        checkboxDropdownToggle.focus();
      }
    };
    checkboxDropdownChild.forEach(element => {
      document.addEventListener("click", function (e) {
        const checkboxContainer = element;
        const checkboxDropdownToggle = element.querySelector(".js-dropdown-toggle");
        if (!element.contains(e.target) && e.target.classList.contains("checkbox-dropdown__token")) {
          return;
        }
        if (!element.contains(e.target)) {
          checkboxContainer.classList.remove("js-open-dropdown");
          checkboxDropdownToggle.setAttribute("aria-expanded", "false");
        }
      });
    });
    checkboxDropdown.forEach(element => {
      const dropdownToggle = element.querySelector(".js-dropdown-toggle");
      dropdownToggle.addEventListener("click", e => toggleCheckboxListVisibility(e));
      dropdownToggle.addEventListener("keydown", e => toggleCheckboxListVisibility(e));
    });
    const focusNextListItem = direction => {
      const activeElementId = document.activeElement.id;
      const currentActiveElementIndex = checkboxDropdownIds.indexOf(activeElementId);
      if (direction === DOWN_ARROW_KEY_CODE) {
        const currentActiveElementIsNotLastItem = currentActiveElementIndex < checkboxDropdownIds.length - 1;
        if (currentActiveElementIsNotLastItem) {
          const nextListItemId = checkboxDropdownIds[currentActiveElementIndex + 1];
          document.querySelector(`#${nextListItemId}`).focus();
        }
      } else if (direction === UP_ARROW_KEY_CODE) {
        const currentActiveElementIsNotFirstItem = currentActiveElementIndex > 0;
        if (currentActiveElementIsNotFirstItem) {
          const nextListItemId = checkboxDropdownIds[currentActiveElementIndex - 1];
          document.querySelector(`#${nextListItemId}`).focus();
        } else {
          return;
        }
      }
    };
    const addInputToken = e => {
      const defaultDropdownText = e.target.closest(".js-multiselect-checkbox-dropdown").querySelector(".js-default-label");
      const dropdownToggleContainer = e.target.closest(".js-open-dropdown");
      const dropdownTokenContainer = dropdownToggleContainer.querySelector(".js-token-container");
      const checkboxLabelText = e.target.previousElementSibling.dataset.labeltext;
      const checkboxValue = e.target.previousElementSibling.value;
      const tokenElement = document.createElement("a");
      tokenElement.classList.add("checkbox-dropdown__token");
      tokenElement.tabIndex = 0;
      tokenElement.dataset.value = checkboxValue;
      tokenElement.innerText = checkboxLabelText;
      dropdownTokenContainer.appendChild(tokenElement);
      if (defaultDropdownText) {
        defaultDropdownText.remove();
      }
    };
    const removeInputToken = e => {
      if (e.type === "click" || e.keyCode === ENTER_KEY_CODE) {
        if (e.target.classList.contains("checkbox-dropdown__token")) {
          const inputs = elForm.querySelectorAll(".gv__checkbox-layout.js-form-checkbox input");
          e.target.remove();
          inputs.forEach(element => {
            if (element.value == e.target.dataset.value) {
              element.nextElementSibling.click();
            }
          });
        } else {
          const dropdownToggleContainer = e.target.closest(".js-multiselect-checkbox-dropdown");
          const dropdownTokenContainer = dropdownToggleContainer.querySelector(".js-token-container");
          const checkboxValue = e.target.previousElementSibling.value;
          const tokens = dropdownTokenContainer.querySelectorAll("a");
          tokens.forEach(element => {
            if (element.dataset.value === checkboxValue) {
              element.remove();
            }
          });
        }
      }
    };
    const removeAllInputTokens = element => {
      if (element.classList.contains("checkbox-dropdown__token")) {
        const inputs = elForm.querySelectorAll(".gv__checkbox-layout.js-form-checkbox input");
        element.remove();
        inputs.forEach(item => {
          if (item.value == element.dataset.value) {
            item.nextElementSibling.click();
          }
        });
      } else {
        const dropdownToggleContainer = element.closest(".js-multiselect-checkbox-dropdown");
        const dropdownTokenContainer = dropdownToggleContainer.querySelector(".js-token-container");
        const checkboxValue = element.value;
        const tokens = dropdownTokenContainer.querySelectorAll("a");
        tokens.forEach(item => {
          if (item.dataset.value === checkboxValue) {
            item.remove();
          }
        });
      }
    };
    const toggleCheckedCheckboxes = e => {
      const openDropDown = SPACEBAR_KEY_CODE.includes(e.keyCode) || e.keyCode === ENTER_KEY_CODE;
      const downArrow = e.keyCode === DOWN_ARROW_KEY_CODE;
      const upArrow = e.keyCode === UP_ARROW_KEY_CODE;
      const escape = e.keyCode == ESCAPE_KEY_CODE;
      const checkboxDropdownParent = e.target.closest(".gv__form__checkbox-dropdown");
      const checkboxDropdownToggle = checkboxDropdownParent.querySelector(".js-dropdown-toggle");
      const checkboxDropdownList = checkboxDropdownParent.querySelector(".js-dropdown");
      if (e.type === "click" || openDropDown) {
        e.preventDefault();
        const checkbox = e.target.previousElementSibling;
        const checkboxValue = checkbox.value;

        //remove all if Not Applicable checked

        if (checkboxValue === "280560009") {
          const notApplicableIndex = checkboxArray.indexOf(checkboxValue);
          if (notApplicableIndex === -1) {
            checkbox.setAttribute("checked", "");
            checkbox.setAttribute("data-checked", true);
            checkboxArray = [];
            checkboxArray.push(checkboxValue);
            storedValues.value = JSON.stringify(checkboxArray);
            addInputToken(e);
            elForm.querySelector(".js-dropdown").querySelectorAll(".js-class-fieldset-grades-taught-input").forEach(element => {
              if (element.value !== "280560009") {
                if (element.getAttribute("data-checked") === "true") {
                  removeAllInputTokens(element);
                  element.toggleAttribute("checked");
                  element.setAttribute("data-checked", false);
                }
              }
            });
          } else {
            checkbox.removeAttribute("checked", "");
            checkbox.setAttribute("data-checked", false);
            checkboxArray.splice(notApplicableIndex, 1);
            storedValues.value = JSON.stringify(checkboxArray);
            removeInputToken(e);
          }
          storedValues.dispatchEvent(new Event("change"));
          const event = new Event("triggerChange");
          storedValues.dispatchEvent(event);
        } else {
          const notApplicableOption = elForm.querySelector(".js-dropdown").querySelector('input[value="280560009"]');
          const notApplicableOptionValue = notApplicableOption.value;
          const notApplicableOptionIndex = checkboxArray.indexOf(notApplicableOptionValue);
          const notApplicableOptionLabel = notApplicableOption.closest(".js-form-checkbox").querySelector(".gv__form__label");
          var index = checkboxArray.indexOf(checkboxValue);
          if (index === -1) {
            checkboxArray.push(checkboxValue);
            storedValues.value = JSON.stringify(checkboxArray);
            addInputToken(e);
            if (notApplicableOptionIndex !== -1) {
              notApplicableOptionLabel.click();
            }
          } else {
            checkboxArray.splice(index, 1);
            storedValues.value = JSON.stringify(checkboxArray);
            removeInputToken(e);
          }
          if (storedValues.value === "[]") {
            storedValues.value = "";
          }
          storedValues.dispatchEvent(new Event("change"));
          const event = new Event("triggerChange");
          storedValues.dispatchEvent(event);
          checkbox.toggleAttribute("checked");
          if (checkbox.getAttribute("data-checked") === "true") {
            checkbox.setAttribute("data-checked", false);
          } else {
            checkbox.setAttribute("data-checked", true);
          }
        }
      } else if (downArrow) {
        focusNextListItem(DOWN_ARROW_KEY_CODE);
      } else if (upArrow) {
        focusNextListItem(UP_ARROW_KEY_CODE);
      } else if (escape) {
        e.target.closest(".gv__form__checkbox-dropdown").classList.remove("js-open-dropdown");
        e.target.closest(".gv__form__checkbox-dropdown").querySelector(".js-dropdown-toggle").focus();
        checkboxDropdownToggle.setAttribute("aria-expanded", "false");
        checkboxDropdownList.querySelector(".gv__form__label").focus();
      }
    };
    checkboxInputs.forEach(element => {
      element.addEventListener("click", e => toggleCheckedCheckboxes(e));
      element.addEventListener("keydown", e => toggleCheckedCheckboxes(e));
      checkboxDropdownIds.push(element.querySelector("label").id);
    });
    if (multiSelectCheckboxDropdown.length > 0) {
      document.querySelector(".js-token-container").addEventListener("click", function (event) {
        if (event.target.classList.contains("checkbox-dropdown__token")) {
          removeInputToken(event);
        }
      });
      document.querySelector(".js-token-container").addEventListener("keydown", function (event) {
        if (event.target.classList.contains("checkbox-dropdown__token")) {
          removeInputToken(event);
        }
      });
    }
    const hideErrors = () => {
      [...elForm.querySelectorAll(".has-error")].forEach(el => {
        el.classList.remove("has-error");
      });
      [...elForm.querySelectorAll(".js-form-general-error")].forEach(el => {
        el.classList.remove("has-error");
      });
    };

    //form sepecific handlers
    function resetButton(button) {
      button.classList.remove("is-loading");
      button.disabled = Boolean(recaptcha);
    }
    function showMessage(status, msg, el) {
      [...el].forEach(el => {
        el.querySelector(".js-error-msg").innerHTML = msg;
        el.classList.remove("is-hidden");
        if (status === "error") {
          el.setAttribute("role", "alert");
        }
      });
    }

    //handle successfull form response
    function successHandler() {
      //TODO add js-error-box code if element is in DOM
      if (!elForm.classList.contains("js-form-changes")) {
        elForm.reset();
      }
      //this was causing all forms to reload, but also not sure why it was added so just commenting out for now.
      // else {
      //   setTimeout(() => {
      //     window.location.reload();
      //   }, 5000);
      // }

      if (elForm.classList.contains("js-form-update-teacher-school-info")) {
        const countryfield = elForm.querySelector(".js-class-fieldset-country");
        const schoolType = elForm.querySelector(".js-class-fieldset-role");
        const zipInput = elForm.querySelector(".js-class-fieldset-zipcode");
        const nameInput = elForm.querySelector(".js-class-fieldset-name-input");
        const cityInput = elForm.querySelector(".js-class-fieldset-city");
        const stateSelect = elForm.querySelector(".js-class-fieldset-state-select");
        const stateInput = elForm.querySelector(".js-class-fieldset-state-input");
        const editButton = elForm.querySelector(".js-edit-button");
        const cancelButton = elForm.querySelector(".js-cancel-button");
        const submitButton = elForm.querySelector(".js-submit-school-details");
        countryfield.setAttribute("disabled", " ");
        schoolType.setAttribute("disabled", " ");
        zipInput.setAttribute("disabled", " ");
        nameInput.setAttribute("disabled", " ");
        nameInput.setAttribute("readonly", " ");
        nameInput.setAttribute("type", "text");
        cityInput.setAttribute("disabled", " ");
        stateInput.setAttribute("disabled", " ");
        stateSelect.setAttribute("disabled", " ");
        editButton.removeAttribute("disabled");
        editButton.classList.remove("hide");
        cancelButton.classList.remove("show");
        submitButton.setAttribute("disabled", "");
        submitButton.classList.add("hide");
        window.location.reload();
      }
      elForm.classList.add("has-submitted");
      elForm.querySelectorAll(".js-form-general-success").forEach(el => {
        el.classList.add("is-visible");
      });
      const successEvent = new Event("success");
      elForm.dispatchEvent(successEvent);
      if (elForm.dataset.reload) {
        location.reload();
      }
      if (errorbox.length) {
        showMessage("success", "Your changes have been successfully updated", errorbox);
      }
    }

    //handle successfull form response
    function errorHandler() {
      const submitButtons = elForm.querySelectorAll("button[type=submit]");
      [...elForm.querySelectorAll(".js-form-general-error")].forEach(el => {
        el.classList.add("has-error");
        if (el.dataset.hasText !== "true") {
          el.textContent = "Server Error. Please try again";
        }
        el.setAttribute("role", "alert");
      });
      [...submitButtons].forEach(resetButton);
      if (errorbox.length) {
        showMessage("error", "Whoops, something went wrong please try again later.", errorbox);
      }
      if (recaptcha) {
        grecaptcha.reset();
      }
    }
    [...matchItems].forEach(item => {
      const field = item.querySelector("[aria-required]");
      if (field === null) {
        return;
      }
      if (field.dataset.type === "select") {
        field.addEventListener("change", e => {
          (0, _validation.matchfields)(elForm, [item]);
        });
      } else {
        field.addEventListener("keyup", e => {
          (0, _validation.matchfields)(elForm, [item]);
        });
      }
    });
    [...fileItems].forEach(item => {
      const field = item.querySelector("input[type='file'");
      const preview = item.querySelector(".js-form-preview");
      if (field === null) {
        return;
      }
      field.addEventListener("change", e => {
        const [file] = field.files;
        if (file) {
          preview.src = URL.createObjectURL(file);
        }
      });
    });

    //form field validation
    [...elItems].forEach(item => {
      (0, _validation.validationListeners)(item, elForm);
    });
    if (!elForm.classList.contains('js-newsletter-form')) {
      (0, _validation.handleSubmit)(elForm, successHandler, errorHandler);
    }
  });
}

},{"./validation.js":262}],90:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getElemDistance = void 0;
// https://gomakethings.com/get-distances-to-the-top-of-the-document-with-native-javascript/
const getElemDistance = elem => {
  let location = 0;
  if (elem.offsetParent) {
    do {
      location += elem.offsetTop;
      elem = elem.offsetParent;
    } while (elem);
  }
  return location >= 0 ? location : 0;
};
exports.getElemDistance = getElemDistance;

},{}],91:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  navItem: _propTypes.object,
  handleClick: _propTypes.func,
  selectedAuxItem: _propTypes.object,
  isDesktop: _propTypes.bool,
  isAuthenticated: _propTypes.object
};
const AuxiliaryNav = props => {
  const {
    navItem,
    handleClick,
    isSmallMenuOpen,
    selectedAuxItem,
    isDesktop
  } = props;
  const {
    url,
    title,
    subLinks,
    target,
    useAnchorScroll
  } = navItem;
  const arrow = isSmallMenuOpen ? "/OWH/assets-build/img/icons/chevron-right.svg" : "/OWH/assets-build/img/icons/chevron-down.svg";
  const auxNavClasses = (0, _classnames.default)("gv__aux-nav", {
    "is-aux-open": selectedAuxItem && selectedAuxItem.title === title
  });
  const linkClass = (0, _classnames.default)("gv__global-header__nav-item", {
    "not-authenticated": !props.isAuthenticated,
    "js-anchor-link": useAnchorScroll
  });
  const renderButton = () => {
    return /*#__PURE__*/_react.default.createElement("button", {
      onClick: () => handleClick(navItem),
      className: "gv__global-header__nav-item gv__aux-nav__item js-has-submenu"
    }, title, /*#__PURE__*/_react.default.createElement("img", {
      src: arrow,
      alt: ""
    }));
  };
  if (!subLinks) {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: url,
      className: linkClass,
      target: target
    }, title, target === "_blank" && /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
      classes: "gv__aux-nav__external"
    }));
  } else if (isDesktop) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: auxNavClasses
    }, renderButton());
  } else {
    return renderButton();
  }
};
AuxiliaryNav.propTypes = propTypes;
var _default = exports.default = AuxiliaryNav;

},{"../partials/external-link-icon.jsx":148,"classnames":"classnames","prop-types":"prop-types","react":"react"}],92:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _usePrevious = _interopRequireDefault(require("../partials/use-previous.jsx"));
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  buttonLabel: _propTypes.string,
  buttonIcon: _propTypes.bool,
  subItems: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    title: _propTypes.string,
    url: _propTypes.string,
    isCurrent: _propTypes.bool
  })),
  // isOpen: bool,
  buttonClass: _propTypes.string,
  isDesktop: _propTypes.bool,
  isRight: _propTypes.bool,
  recheckLinks: _propTypes.func,
  isCurrent: _propTypes.bool,
  apiUrl: _propTypes.string,
  handleSmallMenuClose: _propTypes.func
};
const Dropdown = props => {
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const {
    buttonIcon,
    buttonLabel,
    subItems,
    buttonClass,
    recheckLinks,
    isCurrent,
    handleSmallMenuClose,
    setSearchIsActive,
    apiUrl
  } = props;
  const [dropdownClassnames, setDropdownClassnames] = (0, _react.useState)("gv__global-header__dropdown");
  const [dynamicItems, setDynamicItems] = (0, _react.useState)([]);
  const [isLoadingItems, setIsLoadingItems] = (0, _react.useState)(false);
  const panelRef = (0, _react.useRef)();
  const buttonRef = (0, _react.useRef)();
  const prevOpenState = (0, _usePrevious.default)(isOpen);
  const renderHelpIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.0733 12.4096C11.0013 12.5986 10.9653 12.8281 10.9653 13.0981V13.6921H12.9903V13.3006C12.9903 13.1476 13.0263 12.9946 13.0983 12.8416C13.1703 12.6886 13.3098 12.5311 13.5168 12.3691C13.8408 12.1171 14.1063 11.8876 14.3133 11.6806C14.5293 11.4646 14.7003 11.2531 14.8263 11.0461C14.9613 10.8391 15.0558 10.6321 15.1098 10.4251C15.1638 10.2091 15.1908 9.97061 15.1908 9.70961C15.1908 9.27761 15.1098 8.89511 14.9478 8.56211C14.7858 8.22911 14.5653 7.95011 14.2863 7.72511C14.0073 7.50011 13.6833 7.33361 13.3143 7.22561C12.9543 7.10861 12.5673 7.05011 12.1533 7.05011C11.2083 7.05011 10.4343 7.30211 9.83126 7.80611C9.22826 8.30111 8.87726 9.02561 8.77826 9.97961L10.8573 10.1146C10.8843 9.78161 11.0058 9.49811 11.2218 9.26411C11.4468 9.03011 11.7708 8.91311 12.1938 8.91311C12.4728 8.91311 12.7023 8.99861 12.8823 9.16961C13.0713 9.33161 13.1658 9.56111 13.1658 9.85811C13.1658 10.0111 13.1208 10.1596 13.0308 10.3036C12.9498 10.4386 12.8328 10.5871 12.6798 10.7491C12.5268 10.9021 12.3423 11.0686 12.1263 11.2486C11.9193 11.4286 11.6898 11.6401 11.4378 11.8831C11.2668 12.0451 11.1453 12.2206 11.0733 12.4096ZM10.8303 15.2041C10.7673 15.3571 10.7358 15.5191 10.7358 15.6901C10.7358 15.8611 10.7673 16.0231 10.8303 16.1761C10.8933 16.3291 10.9788 16.4641 11.0868 16.5811C11.2038 16.6891 11.3388 16.7746 11.4918 16.8376C11.6448 16.9006 11.8068 16.9321 11.9778 16.9321C12.1488 16.9321 12.3108 16.9006 12.4638 16.8376C12.6168 16.7746 12.7473 16.6891 12.8553 16.5811C12.9723 16.4641 13.0623 16.3291 13.1253 16.1761C13.1883 16.0231 13.2198 15.8611 13.2198 15.6901C13.2198 15.5191 13.1883 15.3571 13.1253 15.2041C13.0623 15.0511 12.9723 14.9206 12.8553 14.8126C12.7473 14.6956 12.6168 14.6056 12.4638 14.5426C12.3108 14.4796 12.1488 14.4481 11.9778 14.4481C11.8068 14.4481 11.6448 14.4796 11.4918 14.5426C11.3388 14.6056 11.2038 14.6956 11.0868 14.8126C10.9788 14.9206 10.8933 15.0511 10.8303 15.2041Z",
    fill: "currentColor"
  }));
  const renderArrowIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
    "aria-hidden": "true",
    role: "img",
    focusable: "false",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.3",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.95 1L6 5.95M1 1l4.95 4.95"
  })));
  (0, _react.useEffect)(() => {
    const links = panelRef.current.querySelectorAll("a");

    //we only want this to manage focus if we have a prevOpenState and isOpen doesn't match it
    if (prevOpenState !== undefined && isOpen !== prevOpenState) {
      if (isOpen) {
        setTimeout(() => {
          panelRef.current.focus();
          setDropdownClassnames("gv__global-header__dropdown gv__global-header__dropdown--is-open");
          [...links].forEach((link, index) => {
            link.addEventListener("keydown", e => {
              keyboardTrap(e, index);
            }, false);
          });
          document.addEventListener("click", detectClickOutside);
          recheckLinks && recheckLinks(true);
        }, 100);
      } else {
        document.removeEventListener("click", detectClickOutside);
        buttonRef.current.focus();
        setDropdownClassnames("gv__global-header__dropdown");
        recheckLinks && recheckLinks(true);
      }
    }
  }, [isOpen, prevOpenState, recheckLinks]);
  const getDynamicItems = () => {
    if (apiUrl && !subItems.length && !dynamicItems.length) {
      setIsLoadingItems(true);
      fetch(apiUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => res.json()).then(data => {
        setDynamicItems(data);
        setIsLoadingItems(false);
        panelRef.current.focus();
      });
    }
  };
  const detectClickOutside = e => {
    if (panelRef.current && !panelRef.current.contains(e.target) && !buttonRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };
  const closeMenu = event => {
    if (typeof handleSmallMenuClose == "function") {
      handleSmallMenuClose();
    }
  };
  const toggleMenu = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
      setSearchIsActive(false);
      getDynamicItems();
    }
  };
  const keyboardTrap = (e, index) => {
    //Focus Trap
    let target = index;
    const links = panelRef.current.querySelectorAll("a");
    switch (e.key) {
      case "Escape":
        setIsOpen(false);
        buttonRef.current.focus();
        break;
      case "Up":
      case "ArrowUp":
        e.preventDefault();
        if (index === 0) {
          target = links.length;
        }
        links[target - 1].focus();
        break;
      case "Down":
      case "ArrowDown":
        e.preventDefault();
        if (index === links.length - 1) {
          target = -1;
        }
        links[target + 1].focus();
        break;
      case "Tab":
        if (e.shiftKey) {
          e.preventDefault();
          setIsOpen(false);
          buttonRef.current.focus();
        }
        if (index === links.length - 1) {
          e.preventDefault();
          setIsOpen(false);
          buttonRef.current.focus();
        }
        break;
      default:
    }
  };
  const panelClassnames = (0, _classnames.default)("gv__global-header__dropdown-menu", {
    "gv__global-header__dropdown-menu--right": props.isRight
  });
  const arrowClass = (0, _classnames.default)("gv__global-header__dropdown-arrow", {
    "gv__global-header__dropdown-arrow--active": isOpen
  });
  const renderListItem = (item, i) => {
    const keyPrefix = `join${i}_${Math.floor(Math.random() * 10000)}`;
    if (item.subSections) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: keyPrefix,
        className: "gv__global-header__dropdown-nested-item"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__global-header__dropdown-subheading"
      }, " ", item.sectionTitle || item.title), /*#__PURE__*/_react.default.createElement("ul", {
        className: "gv__global-header__dropdown-subitems"
      }, item.subSections.map((x, i) => renderListItem(x, i))));
    } else {
      if (isOpen) {
        const {
          sectionUrl,
          url,
          LinkText,
          LinkUrl,
          sectionTitle,
          title,
          isNewWindow,
          target
        } = item;
        const targetValue = isNewWindow || target === "_blank" ? "_blank" : null;
        const textValue = sectionTitle || title || LinkText;
        return /*#__PURE__*/_react.default.createElement("li", {
          key: keyPrefix,
          className: "gv__global-header__dropdown-item"
        }, /*#__PURE__*/_react.default.createElement("a", {
          className: "gv__global-header__dropdown-link",
          target: targetValue,
          href: sectionUrl || url || LinkUrl,
          onClick: closeMenu,
          "data-hover-placeholder": textValue
        }, textValue, targetValue === "_blank" && /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
          classes: "gv__external-link-icon gv__global-header__dropdown-external"
        })));
      }
    }
  };
  const buttonClasses = (0, _classnames.default)("gv__global-header__dropdown-button gv__button", {
    [buttonClass]: buttonClass,
    "gv__global-header__dropdown-button--current": isCurrent
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: dropdownClassnames
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: buttonClasses,
    "aria-haspopup": "true",
    type: "button",
    ref: buttonRef,
    onClick: toggleMenu
  }, /*#__PURE__*/_react.default.createElement("span", null, buttonIcon ? renderHelpIcon() : buttonLabel), !buttonIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: arrowClass
  }, renderArrowIcon())), /*#__PURE__*/_react.default.createElement("ul", {
    tabIndex: "-1",
    ref: panelRef,
    "aria-hidden": !isOpen,
    className: panelClassnames,
    "aria-live": "assertive"
  }, /*#__PURE__*/_react.default.createElement(_loading.default, {
    isLoading: isLoadingItems
  }), apiUrl && !subItems.length ? dynamicItems.map((x, i) => renderListItem(x, i)) : subItems.map((x, i) => renderListItem(x, i))));
};
Dropdown.propTypes = propTypes;
var _default = exports.default = Dropdown;

},{"../partials/external-link-icon.jsx":148,"../partials/loading.jsx":150,"../partials/use-previous.jsx":157,"classnames":"classnames","prop-types":"prop-types","react":"react"}],93:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useKeyboardNav = _interopRequireDefault(require("../useKeyboardNav.js"));
var _LinkedImg = _interopRequireDefault(require("../partials/LinkedImg.jsx"));
var _AuxiliaryNav = _interopRequireDefault(require("./AuxiliaryNav.jsx"));
var _UtilityNav = _interopRequireDefault(require("./UtilityNav.jsx"));
var _PrimaryNav = _interopRequireDefault(require("./PrimaryNav.jsx"));
var _PreviewNav = _interopRequireDefault(require("./PreviewNav.jsx"));
var _HamburgerMenu = _interopRequireDefault(require("./HamburgerMenu.jsx"));
var _SmallMenuHeader = _interopRequireDefault(require("./SmallMenuHeader.jsx"));
var _NavTab = _interopRequireDefault(require("./NavTab.jsx"));
var _NotAuthenticatedNav = _interopRequireDefault(require("./new-3.0-parts/NotAuthenticatedNav.jsx"));
var _Search = _interopRequireDefault(require("./new-3.0-parts/Search.jsx"));
var _AuthenticatedDesktopNav = _interopRequireDefault(require("./new-3.0-parts/AuthenticatedDesktopNav.jsx"));
var _SkipNav = _interopRequireDefault(require("./new-3.0-parts/SkipNav.jsx"));
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

// import SearchInput from "../search-results/SearchInput.jsx";

// import Dropdown from "./Dropdown.jsx";

const App = props => {
  const data = window.globalHeaderData || window.canvasHeaderData;
  const {
    logoImgDarkBg,
    logoImgMobile,
    logoImgAlt,
    logoImgLight,
    logoUrl
  } = data.logo;
  const displaySearch = true; //data.displaySearch

  /**
   * State
   */

  const [selectedAuxItem, setSelectedAuxItem] = (0, _react.useState)(null);
  const [isSmallMenuOpen, setIsSmallMenuOpen] = (0, _react.useState)(false);
  const [isSecondaryNavOpen, setIsSecondaryNavOpen] = (0, _react.useState)(false); // mobile
  const [tertiaryNavData, setTertiaryNavData] = (0, _react.useState)(null);
  const [isTertiaryNavOpen, setIsTertiaryNavOpen] = (0, _react.useState)(false); // mobile
  const [isPrimaryNavOpen, setIsPrimaryNavOpen] = (0, _react.useState)(false);
  const [isAuthenticated, setIsAuthenticated] = (0, _react.useState)(!!data.utilityNav || !!data.isCanvasHeader);
  const [recheckLinks, setRecheckLinks] = (0, _react.useState)(false);
  const [activeTab, setActiveTab] = (0, _react.useState)(null);
  const [activeSectionTitle, setActiveSectionTitle] = (0, _react.useState)(null);
  const [tabIndex, setTabIndex] = (0, _react.useState)(1);
  const [width, setWidth] = (0, _react.useState)(window.innerWidth);
  // const [newSearchQueryInput, setSearchQueryInput] = useState({
  //   value: "",
  // });
  const [mobileSearchToggle, setMobileSearchToggle] = (0, _react.useState)(false);
  const auxNavItems = data.auxiliaryNav;
  const utilityNavData = data.utilityNav;
  const primaryNavData = data.primaryNav;
  const previewNavData = data.previewNav;
  const auxNavItemsRest = auxNavItems && auxNavItems.filter((item, i) => i !== 0); // everything but the first
  const [utilityNavOpen, setUtilityNavOpen] = (0, _react.useState)(false);
  const [isActivePreviewNav, setIsActivePreviewNav] = (0, _react.useState)(false);
  const [visibleMenu, setVisibleMenu] = (0, _react.useState)();
  const [searchIsActive, setSearchIsActive] = (0, _react.useState)(false);
  const [auxSubNavOpen, setAuxSubNavOpen] = (0, _react.useState)(false);

  /**
   * Refs
   */
  const desktopPrimaryNavToggleRef = (0, _react.useRef)();
  // const smallMenuLogoRef = useRef();
  const secondaryBackBtnRef = (0, _react.useRef)();
  const smallMenuRef = (0, _react.useRef)();
  const secondaryMenuRef = (0, _react.useRef)();
  const utilityNavRef = (0, _react.useRef)();
  const utilityMenuItemRef = (0, _react.useRef)();
  // const primaryNavMenuItemRef = useRef();
  const primaryNavRef = (0, _react.useRef)();
  const tertiaryNavRef = (0, _react.useRef)();
  const mobileQuickSearch = (0, _react.useRef)();
  // const desktopQuickSearch = useRef();
  // const mobileSearchBtn = useRef();
  const mobilePrimaryNav = (0, _react.useRef)();
  const hamburgerRef = (0, _react.useRef)();
  const PRIMARY_MENU = "primary";
  const SECONDARY_MENU = "secondary";
  const TERTIARY_MENU = "tertiary";
  const bpMedium = 781;
  let smallMenuCloseTimer;
  let utilityNavTimer;
  const [isDesktop, setIsDesktop] = (0, _react.useState)(width > bpMedium);

  /**
   * CSS Classes
   */

  // does this get used?
  // const primaryNavClasses = classNames(
  //   "gv__global-header__nav-item js-has-submenu",
  //   {
  //     "is-open": isPrimaryNavOpen,
  //   }
  // );

  const loginButtonClasses = isLoginButton => (0, _classnames.default)({
    "gv__primary-nav__course-link gv__primary-nav__course-link--btn": !isLoginButton,
    "gv__primary-nav__course-link gv__primary-nav__course-link--yellow": isLoginButton
  });
  // const arrowClass = classNames("gv__global-header__dropdown-arrow", {
  //   "gv__global-header__dropdown-arrow--active": isPrimaryNavOpen,
  // });
  const globalHeaderClass = (0, _classnames.default)("gv__global-header", {
    "gv__global-header--unauthenticated": !isAuthenticated,
    "gv__global-header--authenticated": isAuthenticated
  });

  // const smallMenuClasses = classNames("gv__global-header__small-menu", {
  //   "is-open": isSmallMenuOpen,
  //   "is-secondary-open": isSecondaryNavOpen,
  //   "is-unauthenticated": !isAuthenticated,
  //   "is-authenticated": isAuthenticated,
  // });
  // const secondaryMenuClasses = classNames("gv__global-header__secondary-menu", {
  //   "is-open": isSecondaryNavOpen,
  //   "is-tertiary-open": isTertiaryNavOpen,
  //   "is-unauthenticated": !isAuthenticated,
  //   "is-authenticated": isAuthenticated,
  // });
  // const tertiaryMenuClasses = classNames("gv__global-header__tertiary-menu", {
  //   "is-open": isTertiaryNavOpen,
  //   "is-unauthenticated": !isAuthenticated,
  //   "is-authenticated": isAuthenticated,
  // });

  //Hi, this file is a mess.
  //the core structure of the menu has changed three times since the original designs. Most recently we rolled out
  //a new unauthenticated design that is JUST different enough to necessitate slightly different behavior.
  //in the future, it'd be nice to take time to refactor this and make it less confusing
  //but for now, it is what it is.
  //useKeyboardNav sets the focus traps, however it does so by collecting all interactive items in a div, even if they're `display: none`.
  //if you have a drop down or accordion, render those child items conditionally and pass the useKeyboardNav recheckLinks: recheckLinks (a bool) so that it can recount all of the interactive elements with your newly added items.
  //AUX nav is mostly for login/logout on unauthenticated, community for authenticated view. These move around on the mobile nav depending on whether user is logged in our at. They are sourced from the same JSON object, but display completed differently and thus no longer uniformly use the AuxNav component
  //we aren't really using TertiaryNav anymore

  // Update - I've tried to Org this a little better but it's not a full refactor. It's going to take a bit to get a better refactor

  /**
   * Reused methods
   */

  const closeAuxNav = () => {
    const openAuxItemBtn = document.querySelector(".is-aux-open button");
    openAuxItemBtn.focus();
    setSelectedAuxItem(null);
    setVisibleMenu(null);
  };
  const openAuxSubNav = () => {
    setAuxSubNavOpen(true);
  };
  const closeAuxSubNav = () => {
    setAuxSubNavOpen(false);
  };
  const closePrimaryNav = (0, _react.useCallback)(() => {
    if (isAuthenticated) {
      document.querySelector("body").classList.remove("gv__global-header__open-menu");
    }
    setIsPrimaryNavOpen(false);
  });
  const closeUtilityNav = () => {
    setUtilityNavOpen(false);
    // utilityMenuItemRef.current.focus();
  };
  const closeSecondaryNav = () => {
    setSelectedAuxItem(null);
    setIsSecondaryNavOpen(false);
    setIsPrimaryNavOpen(false);
    setActiveTab(null);
    setVisibleMenu(PRIMARY_MENU);
    mobilePrimaryNav.current.focus(); //TODO: fix focus state
  };
  const closeTertiaryNav = e => {
    setTertiaryNavData(null);
    setIsTertiaryNavOpen(false);
    setVisibleMenu(SECONDARY_MENU);
  };
  const findParent = navData => {
    const parentArray = navData.sections.filter(x => x.subSections && x.subSections.find(sub => sub === activeTab));
    const parent = parentArray && parentArray[0];
    return parent;
  };

  // const toggleMobileSearch = (e) => {
  //   if (mobileSearchToggle) {
  //     setSearchQueryInput({ value: "" });
  //   }
  //   const newMobileSearchToggle = !mobileSearchToggle;
  //   setMobileSearchToggle(newMobileSearchToggle);
  // };

  /**
   * Event Handlers
   */

  const handleSmallMenuClose = (0, _react.useCallback)(() => {
    // Remove event listener(s) for keydown within submenu
    setIsSecondaryNavOpen(false);
    setSelectedAuxItem(null);
    if (!isDesktop && document.querySelector(".gv__global-header__small-menu")?.classList.contains("is-open")) {
      setIsSmallMenuOpen(false);
      closePrimaryNav();
    }
    setVisibleMenu(null);
    setIsPrimaryNavOpen(false);
    setTertiaryNavData(null);
    setIsTertiaryNavOpen(false);
    hamburgerRef.current && hamburgerRef.current.focus();
  });
  const handleAuxNavClick = auxNavItem => {
    // if clicked and already selected, unselect it
    // set focus to submenu
    if (selectedAuxItem && auxNavItem.title === selectedAuxItem.title) {
      closeAuxNav();
    } else {
      setIsPrimaryNavOpen(false);
      setSelectedAuxItem(auxNavItem);
      if (width <= bpMedium) {
        setIsSecondaryNavOpen(true);
        setVisibleMenu(SECONDARY_MENU);
      }
    }
  };
  const handleTertiaryOpen = (e, data) => {
    setTertiaryNavData(data);
    setIsTertiaryNavOpen(true);
    setVisibleMenu(TERTIARY_MENU);
  };
  const handlePreviewNavClick = (activeTab, activeTabTitle) => {
    if (isDesktop && isPrimaryNavOpen) {
      closePrimaryNav();
      setIsActivePreviewNav(false);
    } else {
      // open the menu
      if (isAuthenticated) {
        document.querySelector("body").classList.add("gv__global-header__open-menu");
      }
      setSelectedAuxItem(null);
      setIsSecondaryNavOpen(false);
      setUtilityNavOpen(false);
      setIsPrimaryNavOpen(true);
      setVisibleMenu(TERTIARY_MENU);
      setIsActivePreviewNav(true);
      if (!isDesktop) {
        activeTab && setActiveTab(activeTab);
        activeTabTitle && setActiveSectionTitle(activeTabTitle);
        setIsSecondaryNavOpen(true);
        setIsPrimaryNavOpen(true);
        setVisibleMenu(SECONDARY_MENU);
      }
    }
  };
  const handlePrimaryNavClick = activeTab => {
    if (isDesktop && isPrimaryNavOpen) {
      closePrimaryNav();
    } else {
      // open the menu
      if (isAuthenticated) {
        document.querySelector("body").classList.add("gv__global-header__open-menu");
      }
      setSelectedAuxItem(null);
      setIsSecondaryNavOpen(false);
      setUtilityNavOpen(false);
      setIsPrimaryNavOpen(true);
      setIsActivePreviewNav(false);
      setVisibleMenu(TERTIARY_MENU);
      if (!isDesktop) {
        activeTab && setActiveTab(activeTab);
        setIsSecondaryNavOpen(true);
        setIsPrimaryNavOpen(true);
        setVisibleMenu(SECONDARY_MENU);
      }
    }
  };
  const handleSecondaryNavClick = activeTab => {
    // open the menu
    if (isAuthenticated) {
      document.querySelector("body").classList.add("gv__global-header__open-menu");
    }
    setSelectedAuxItem(null);
    setIsSecondaryNavOpen(true);
    setIsTertiaryNavOpen(true);
    setUtilityNavOpen(false);
    setIsPrimaryNavOpen(true);
    setIsActivePreviewNav(false);
    setVisibleMenu(TERTIARY_MENU);
    activeTab && setActiveTab(activeTab);
  };
  const handleUtilityNavClick = el => {
    if (utilityNavOpen) {
      closeUtilityNav();
    } else {
      setUtilityNavOpen(true);
      setSelectedAuxItem(null);
      setIsSecondaryNavOpen(false);
      setIsPrimaryNavOpen(false);
      clearTimeout(utilityNavTimer);

      // utilityNavTimer = setTimeout(() => {
      //   utilityNavRef.current.querySelector("a, button").focus();
      // }, 300);
    }
  };

  // const handleUnauthenticatedHamburgerClick = () => {
  //   if (!isDesktop) {
  //     setIsSmallMenuOpen(true);
  //     clearTimeout(smallMenuCloseTimer);
  //     smallMenuCloseTimer = setTimeout(() => {
  //       hamburgerRef.current.focus();
  //     }, 300);
  //   }
  // };

  const handleTabChange = tab => {
    setActiveTab(tab);
    setTabIndex(tab && R.findIndex(R.propEq("sectionTitle", tab.sectionTitle), primaryNavData.sections));
  };
  const handleMobileKeydown = (0, _useKeyboardNav.default)({
    containerRef: smallMenuRef,
    closeAll: handleSmallMenuClose,
    onClose: handleSmallMenuClose,
    isVisible: isPrimaryNavOpen,
    recheckLinks: recheckLinks
  });
  const handleMobileSecondaryNavKeydown = (0, _useKeyboardNav.default)({
    containerRef: secondaryMenuRef,
    closeAll: handleSmallMenuClose,
    onClose: handleSmallMenuClose,
    isVisible: visibleMenu === SECONDARY_MENU,
    recheckLinks: recheckLinks
  });
  const handlePrimaryNavKeydown = (0, _useKeyboardNav.default)({
    containerRef: primaryNavRef,
    onClose: null,
    isVisible: isPrimaryNavOpen,
    closeAll: closePrimaryNav,
    activeTab: activeTab,
    tabIndex: tabIndex
  });

  // const handleResetSearch = (e) => {
  //   const newFocus = e.target.closest(".gv__search-box").querySelector("input");
  //   setSearchQueryInput({ value: "" });
  //   setIsActive(false);

  //   if (newFocus) {
  //     newFocus.focus();
  //   }
  // };

  // const handleSearchInputChange = (e) => {
  //   const value = e.target.value;
  //   setSearchQueryInput({ value: e.target.value });
  //   if (value) {
  //     setSearchIsActive(true);
  //   }
  // };

  // const handleFormSubmit = (e) => {
  //   e.preventDefault();
  //   const site = data.searchUrl;
  //   window.location = `${site}?term=${newSearchQueryInput.value}`;
  // };

  const handleSearchClick = () => setSearchIsActive(!searchIsActive);
  const handleSearchClose = () => setSearchIsActive(false);
  const handleAuthenticatedHamburgerClick = () => {
    //reset search status
    setMobileSearchToggle(false);
    setSearchIsActive(false);
    setAuxSubNavOpen(false);
    if (isPrimaryNavOpen) {
      closePrimaryNav();
      setIsPrimaryNavOpen(false);
      if (!isDesktop) {
        setIsSmallMenuOpen(false);
      }
    } else {
      if (isAuthenticated) {
        document.querySelector("body").classList.add("gv__global-header__open-menu");
      }
      setIsPrimaryNavOpen(true);
      setVisibleMenu(TERTIARY_MENU);
      if (!isDesktop) {
        setIsSmallMenuOpen(true);
        clearTimeout(smallMenuCloseTimer);
        smallMenuCloseTimer = setTimeout(() => {
          hamburgerRef.current.focus();
        }, 300);
      }
    }
  };

  /**
   * API Methods
   */

  // should this be async
  const fetchPreviewItemData = function () {
    let apiurl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return fetch(apiurl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(res => res.json());
  };

  /**
   * Render Methods
   */

  const renderMobilePreviewNavData = () => {
    return previewNavData.map((section, i) => {
      if (section.units || section.apiUrl) {
        const handleClick = section.apiUrl ? () => {
          fetchPreviewItemData(section.apiUrl).then(data => handlePreviewNavClick(data, section.sectionTitle));
        } : () => handlePreviewNavClick(section.units, section.sectionTitle);
        return /*#__PURE__*/_react.default.createElement("li", {
          key: `previewnav${i}`,
          className: "gv__primary-nav__courses-list-item gv__primary-nav__courses-list-item--preview"
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__primary-nav__course-link gv__primary-nav__course-link--preview",
          type: "button",
          "aria-current": section === activeTab,
          onClick: handleClick
        }, section.sectionTitle, /*#__PURE__*/_react.default.createElement("span", {
          className: "gv__button__icon"
        }, /*#__PURE__*/_react.default.createElement("svg", {
          role: "img",
          width: "7",
          height: "12",
          viewBox: "0 0 7 12",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("title", null), /*#__PURE__*/_react.default.createElement("g", {
          strokeWidth: "1.3",
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "square"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M1 10.95L5.95 6M1 1l4.95 4.95"
        }))))));
      } else {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: `previewnav${i}`,
          className: "gv__primary-nav__courses-list-item gv__primary-nav__courses-list-item--preview"
        }, /*#__PURE__*/_react.default.createElement("a", {
          className: "gv__primary-nav__course-link",
          href: section.sectionUrl
        }, section.sectionTitle));
      }
    });
  };

  /**
   * UseEffect
   */

  (0, _react.useEffect)(() => {
    setIsDesktop(width > bpMedium);
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setWidth(window.innerWidth);
      }, 50);
    };

    // Hide mobile menu when user clicks outside and hide dropdown
    // when user clicks outside on desktop
    const handleDocClick = e => {
      // Keep nav open if click occurs inside open menu or on toggle button
      if (utilityNavRef.current && utilityNavRef.current.contains(e.target) || e.target.closest(".is-open") || primaryNavRef.current && primaryNavRef.current.contains(e.target) || e.target.closest("button") === hamburgerRef.current || e.target.closest("button") === desktopPrimaryNavToggleRef.current) {
        return;
      }
      if (width <= bpMedium && !e.target.closest(".is-open")) {
        // outside click on mobile
        handleSmallMenuClose();
      }

      // outside click mobile/desktop
      setSelectedAuxItem(null);
      setUtilityNavOpen(false);
      closePrimaryNav();
    };
    window.addEventListener("resize", handleResize);
    document.addEventListener("mousedown", handleDocClick);
    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleDocClick);
    };
  }, [closePrimaryNav, handleSmallMenuClose, isDesktop, width]);
  (0, _react.useEffect)(() => {
    if (mobileSearchToggle) {
      mobileQuickSearch.current.querySelector("input").focus();
    }
  }, [mobileSearchToggle]);
  (0, _react.useEffect)(() => {
    if (!isDesktop) {
      setActiveTab(null);
    }
  }, [isDesktop]);
  if (isDesktop || data.isCanvasHeader) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SkipNav.default, null), /*#__PURE__*/_react.default.createElement("div", {
      className: globalHeaderClass
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__global-header__desktop-logo-container"
    }, /*#__PURE__*/_react.default.createElement(_LinkedImg.default, {
      href: logoUrl,
      img: logoImgDarkBg,
      altText: logoImgAlt,
      target: data.isCanvasHeader && "_blank"
    })), /*#__PURE__*/_react.default.createElement("nav", {
      className: "gv__global-header__nav",
      "aria-label": "primary"
    }, previewNavData && !isAuthenticated && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_NotAuthenticatedNav.default, {
      previewNavData: previewNavData,
      auxNavItems: auxNavItems,
      isDesktop: isDesktop,
      inputLabel: data.inputLabel,
      inputHint: data.inputHint,
      searchUrl: data.searchUrl,
      displaySearch: data.isCanvasHeader ? false : displaySearch,
      searchIsActive: searchIsActive,
      setSearchIsActive: setSearchIsActive,
      onClickSearch: handleSearchClick,
      handleSmallMenuClose: handleSmallMenuClose,
      utilityNavOpen: utilityNavOpen
      // onSubmitSearch={handleFormSubmit}
    })), isAuthenticated && /*#__PURE__*/_react.default.createElement(_AuthenticatedDesktopNav.default, {
      previewNavData: previewNavData,
      auxNavItems: auxNavItems,
      isDesktop: isDesktop,
      inputLabel: data.inputLabel,
      inputHint: data.inputHint,
      searchUrl: data.searchUrl,
      displaySearch: data.isCanvasHeader ? false : displaySearch,
      searchIsActive: searchIsActive,
      setSearchIsActive: setSearchIsActive,
      onClickSearch: handleSearchClick,
      utilityNavData: utilityNavData,
      userInitials: data.utilityNav != null ? data.utilityNav.initials : "",
      handleUtilityNavClick: handleUtilityNavClick,
      utilityNavOpen: utilityNavOpen,
      ref: utilityNavRef,
      utilityMenuItemRef: utilityMenuItemRef,
      isPrimaryNavOpen: isPrimaryNavOpen,
      avatarImg: data.utilityNav != null ? data.utilityNav.avatarImg : "",
      avatarImgAlt: data.utilityNav != null ? data.utilityNav.avatarImgAlt : ""
    }))), isPrimaryNavOpen && primaryNavData && /*#__PURE__*/_react.default.createElement(_PrimaryNav.default, {
      activeParent: findParent(primaryNavData),
      activeTab: activeTab,
      ref: primaryNavRef,
      onKeyDown: handlePrimaryNavKeydown,
      data: primaryNavData,
      isDesktop: isDesktop,
      handleClick: setActiveTab,
      logoImgLight: logoImgLight,
      handleTabChange: handleTabChange

      // displaySearch={displaySearch}
    }));
  } else {
    const smallMenuClasses = (0, _classnames.default)("gv__global-header__small-menu", {
      "is-open": isSmallMenuOpen,
      "is-secondary-open": isSecondaryNavOpen,
      "is-unauthenticated": !isAuthenticated,
      "is-authenticated": isAuthenticated
    });
    const secondaryMenuClasses = (0, _classnames.default)("gv__global-header__secondary-menu", {
      "is-open": isSecondaryNavOpen,
      "is-tertiary-open": isTertiaryNavOpen,
      "is-unauthenticated": !isAuthenticated,
      "is-authenticated": isAuthenticated
    });
    const tertiaryMenuClasses = (0, _classnames.default)("gv__global-header__tertiary-menu", {
      "is-open": isTertiaryNavOpen,
      "is-unauthenticated": !isAuthenticated,
      "is-authenticated": isAuthenticated
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SkipNav.default, null), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__global-header"
    }, /*#__PURE__*/_react.default.createElement(_LinkedImg.default, {
      href: logoUrl,
      img: logoImgDarkBg,
      altText: logoImgAlt,
      target: data.isCanvasHeader && "_blank"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__global-header__mobile-menu__content"
    }, displaySearch && /*#__PURE__*/_react.default.createElement(_Search.default, {
      inputLabel: data.inputLabel,
      inputHint: data.inputHint,
      searchUrl: data.searchUrl,
      isActive: searchIsActive,
      onClick: handleSearchClick,
      handleSearchClose: handleSearchClose
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "vertical-divider"
    }), /*#__PURE__*/_react.default.createElement(_HamburgerMenu.default, {
      ref: hamburgerRef,
      onClick: handleAuthenticatedHamburgerClick,
      openStatus: isSmallMenuOpen,
      inputHint: data.inputHint,
      searchUrl: data.searchUrl
    })), isSmallMenuOpen && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: smallMenuClasses,
      ref: smallMenuRef,
      role: "navigation",
      onKeyDown: handleMobileKeydown
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__global-header__small-menu__section"
    }, /*#__PURE__*/_react.default.createElement("nav", {
      className: "gv__global-header__nav",
      tabIndex: "-1",
      ref: mobilePrimaryNav,
      "aria-label": "primary"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: `gv__primary-nav__courses-list ${auxSubNavOpen ? 'sub-nav-open' : ''}`
    }, previewNavData && !auxSubNavOpen && renderMobilePreviewNavData(), !isAuthenticated && auxNavItems && auxNavItems.map((auxNavItem, i) => !auxNavItem.subLinks ? /*#__PURE__*/_react.default.createElement("li", {
      key: `auxNavItemkey${i}`,
      className: `${auxSubNavOpen ? "subnav-open" : ""} gv__primary-nav__courses-list-item`
    }, /*#__PURE__*/_react.default.createElement("a", {
      key: `nonAuthAuxNavItem${i}`,
      href: auxNavItem.url,
      className: loginButtonClasses(auxNavItems.length - 1 === i),
      target: auxNavItem.target
    }, auxNavItem.target.toLowerCase() === "_blank" ? /*#__PURE__*/_react.default.createElement("span", null, auxNavItem.title, " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
      classes: ""
    })) : /*#__PURE__*/_react.default.createElement("span", null, auxNavItem.title))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !auxSubNavOpen ? /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      key: `nonAuthAuxNavItem${i}`,
      onClick: openAuxSubNav,
      className: loginButtonClasses(auxNavItems.length - 1 === i)
    }, /*#__PURE__*/_react.default.createElement("span", null, auxNavItem.title, /*#__PURE__*/_react.default.createElement("svg", {
      className: "sub-nav-arrow",
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 16 16",
      fill: "none"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M10.2734 4.94L7.2201 8L10.2734 11.06L9.33344 12L5.33344 8L9.33344 4L10.2734 4.94Z",
      fill: "#333333"
    })))) : /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      key: `back${i}`,
      onClick: closeAuxSubNav,
      className: 'back-button gv__primary-nav__course-link'
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 16 16",
      fill: "none"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M10.2734 4.94L7.2201 8L10.2734 11.06L9.33344 12L5.33344 8L9.33344 4L10.2734 4.94Z",
      fill: "#333333"
    })), /*#__PURE__*/_react.default.createElement("span", null, "Back")), auxSubNavOpen && auxNavItem.subLinks.map(subItem => /*#__PURE__*/_react.default.createElement("li", {
      key: `nonAuthSubAuxNavItem${i}`,
      className: "gv__primary-nav__courses-list-item sub-item"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: subItem.url,
      className: "gv__primary-nav__course-link",
      target: subItem.target
    }, subItem.target.toLowerCase() === "_blank" ? /*#__PURE__*/_react.default.createElement("span", null, subItem.title, " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
      classes: ""
    })) : /*#__PURE__*/_react.default.createElement("span", null, subItem.title))))))))), isAuthenticated && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__global-header__aux-nav-mobile"
    }, primaryNavData && auxNavItems && auxNavItems.length > 0 && /*#__PURE__*/_react.default.createElement(_AuxiliaryNav.default, {
      navItem: auxNavItems[0],
      selectedAuxItem: selectedAuxItem,
      handleClick: handleAuxNavClick,
      isDesktop: isDesktop,
      isAuthenticated: primaryNavData,
      isSmallMenuOpen: isSmallMenuOpen
    }), primaryNavData && auxNavItemsRest && auxNavItemsRest.map((auxNavItem, i) => /*#__PURE__*/_react.default.createElement(_AuxiliaryNav.default, {
      navItem: auxNavItem,
      selectedAuxItem: selectedAuxItem,
      isDesktop: isDesktop,
      key: i,
      handleClick: handleAuxNavClick,
      isSmallMenuOpen: isSmallMenuOpen
    })), primaryNavData && utilityNavData && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, utilityNavData.utilityLinks && utilityNavData.utilityLinks.map((link, i) => /*#__PURE__*/_react.default.createElement("a", {
      href: link.url,
      key: i,
      className: "gv__global-header__nav-item"
    }, link.title))))), /*#__PURE__*/_react.default.createElement("div", {
      className: secondaryMenuClasses,
      ref: secondaryMenuRef,
      onKeyDown: handleMobileSecondaryNavKeydown,
      role: "navigation",
      "aria-label": "primary"
    }, isPrimaryNavOpen && primaryNavData && !isActivePreviewNav && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SmallMenuHeader.default, {
      backButtonText: data.backButtonText,
      closeNav: closeSecondaryNav,
      ref: secondaryBackBtnRef,
      handleSmallMenuClose: handleSmallMenuClose,
      shouldShowBack: true
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__primary-nav__section-title"
    }, primaryNavData.navigationTitle), /*#__PURE__*/_react.default.createElement("ul", {
      className: "gv__primary-nav__courses-list"
    }, primaryNavData.sections.map((section, i) => /*#__PURE__*/_react.default.createElement(_NavTab.default, {
      section: section,
      activeTab: activeTab,
      keyProp: `primarynavprop${i}`,
      key: `primarynav${i}`,
      handleClick: handleSecondaryNavClick
    })))), /*#__PURE__*/_react.default.createElement(_SmallMenuHeader.default, {
      backButtonText: data.backButtonText,
      closeNav: closeSecondaryNav,
      ref: secondaryBackBtnRef,
      shouldShowBack: true
    }), isPrimaryNavOpen && isActivePreviewNav && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
      className: "gv__primary-nav__courses-list gv__primary-nav__courses-list--preview"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__primary-nav__mobile-sub-nav"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__primary-nav__section-title gv__primary-nav__section-title--preview"
    }, activeSectionTitle)), activeTab && activeTab.map((section, i) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: `previewnav${i}`
    }, /*#__PURE__*/_react.default.createElement(_PreviewNav.default, {
      section: section,
      activeTab: activeTab,
      keyProp: i,
      handleClick: handlePrimaryNavClick
    })))))), /*#__PURE__*/_react.default.createElement("div", {
      className: tertiaryMenuClasses,
      ref: tertiaryNavRef,
      onKeyDown: handleMobileSecondaryNavKeydown,
      role: "navigation",
      "aria-label": "primary"
    }, /*#__PURE__*/_react.default.createElement(_SmallMenuHeader.default, {
      backButtonText: data.backButtonText,
      closeNav: closeTertiaryNav,
      ref: secondaryBackBtnRef,
      handleSmallMenuClose: handleSmallMenuClose,
      shouldShowBack: true
    }), isPrimaryNavOpen && primaryNavData && /*#__PURE__*/_react.default.createElement(_PrimaryNav.default, {
      activeTab: activeTab,
      isMobile: true,
      data: primaryNavData,
      isDesktop: isDesktop,
      handleClick: setActiveTab,
      handleTertiaryOpen: handleTertiaryOpen,
      logoImgMobile: logoImgMobile,
      recheckLinks: setRecheckLinks
    })))));
  }
};
var _default = exports.default = App;

},{"../partials/LinkedImg.jsx":137,"../partials/external-link-icon.jsx":148,"../useKeyboardNav.js":261,"./AuxiliaryNav.jsx":91,"./HamburgerMenu.jsx":94,"./NavTab.jsx":96,"./PreviewNav.jsx":97,"./PrimaryNav.jsx":98,"./SmallMenuHeader.jsx":99,"./UtilityNav.jsx":101,"./new-3.0-parts/AuthenticatedDesktopNav.jsx":103,"./new-3.0-parts/NotAuthenticatedNav.jsx":104,"./new-3.0-parts/Search.jsx":106,"./new-3.0-parts/SkipNav.jsx":107,"classnames":"classnames","ramda":"ramda","react":"react"}],94:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  onClick: _propTypes.func,
  openStatus: _propTypes.bool
};
const HamburgerMenu = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    onClick,
    openStatus
  } = props;
  return /*#__PURE__*/_react.default.createElement("button", {
    ref: ref,
    onClick: onClick,
    className: "gv__global-header__hamburger",
    "aria-label": "Open menu",
    "aria-expanded": openStatus
  }, !openStatus && /*#__PURE__*/_react.default.createElement("img", {
    src: "/OWH/assets-build/img/icons/menu.svg",
    className: "gv__global-header__hamburger-icon",
    alt: ""
  }), openStatus && /*#__PURE__*/_react.default.createElement("svg", {
    role: "img",
    "aria-labelledby": "closeTitle",
    widthxmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Close Menu"), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "#fff",
    strokeWidth: "2",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.533 1.533l14.934 14.934M16.467 1.533L1.533 16.467"
  }))));
});
HamburgerMenu.propTypes = propTypes;
var _default = exports.default = HamburgerMenu;

},{"prop-types":"prop-types","react":"react"}],95:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _TertiaryNav = _interopRequireDefault(require("./TertiaryNav.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const MobileMenu = props => {
  const {
    unit,
    i,
    primaryNav,
    recheckLinks
  } = props;
  const [height, setHeight] = (0, _react.useState)(0);
  const [expanded, setExpanded] = (0, _react.useState)();
  const toggleAccordion = () => {
    const nexExpanded = !expanded;
    setHeight(height === 0 ? "auto" : 0);
    setExpanded(nexExpanded);
  };
  const renderCloseIcon = () => {
    if (expanded) {
      return /*#__PURE__*/_react.default.createElement("svg", {
        role: "img",
        "aria-labelledby": "collapseId",
        width: "14",
        height: "3",
        viewBox: "0 0 14 3",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("title", {
        id: "collapseId"
      }, "Collapse Menu"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13.364 1.494H.636",
        stroke: "#213245",
        strokeWidth: "1.3",
        fill: "none",
        fillRule: "evenodd"
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement("svg", {
        role: "img",
        "aria-labelledby": "expandId",
        width: "14",
        height: "13",
        viewBox: "0 0 14 13",
        xmlns: "http://www.w3.org/2000/svg"
      }, " ", /*#__PURE__*/_react.default.createElement("title", {
        id: "expandId"
      }, "Expand Menu"), /*#__PURE__*/_react.default.createElement("g", {
        stroke: "#213245",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M7 .13v12.728M13.364 6.494H.636"
      })));
    }
  };
  const renderMobileMenu = (unit, i) => {
    const {
      unitNum,
      unitTitle
    } = unit;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
      key: i,
      type: "button",
      className: "gv__primary-nav__btn js-has-submenu",
      onClick: e => toggleAccordion(),
      "aria-expanded": expanded
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__primary-nav__btn-text"
    }, unitNum, ":\xA0", unitTitle), " ", /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__primary-nav__mobile-close"
    }, renderCloseIcon())), /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
      duration: 500,
      height: height,
      onAnimationEnd: recheckLinks,
      className: "gv__primary-nav__nested-menu"
    }, " ", expanded && unit && primaryNav && /*#__PURE__*/_react.default.createElement(_TertiaryNav.default, {
      data: unit,
      topLevelLinkText: primaryNav.topLevelLinkText
    })));
  };
  return renderMobileMenu(unit, i);
};

// MobileMenu.propTypes = propTypes;
var _default = exports.default = MobileMenu;

},{"./TertiaryNav.jsx":100,"classnames":"classnames","prop-types":"prop-types","react":"react","react-animate-height":"react-animate-height"}],96:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  activeParent: _propTypes.object,
  section: _propTypes.object,
  keyProp: _propTypes.string || _propTypes.number,
  setActiveTab: _propTypes.func,
  activeTab: _propTypes.object,
  isDesktop: _propTypes.bool,
  handleClick: _propTypes.func,
  isPreviewStyle: _propTypes.bool
};
const navTab = props => {
  const {
    section,
    activeParent,
    activeTab,
    handleClick,
    keyProp,
    isDesktop,
    isPreviewStyle
  } = props;
  const arrowIcon = () => {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__button__icon"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      role: "img",
      width: "7",
      height: "12",
      viewBox: "0 0 7 12",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("title", null), /*#__PURE__*/_react.default.createElement("g", {
      strokeWidth: "1.3",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "square"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1 10.95L5.95 6M1 1l4.95 4.95"
    }))));
  };
  const renderItem = (section, subheadClass, classes) => {
    if (section.sectionUrl || section.sections) {
      if (section.units || section.subSections || section.sections) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: classes,
          type: "button",
          "aria-current": section === activeTab,
          onClick: () => handleClick(section)
        }, section.sectionTitle || section.navigationTitle, !isDesktop && arrowIcon());
      } else {
        return /*#__PURE__*/_react.default.createElement("a", {
          href: section.sectionUrl || section.url,
          className: "gv__primary-nav__link"
        }, section.sectionTitle || section.title);
      }
    } else {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: subheadClass
      }, section.sectionTitle);
    }
  };
  const renderTabs = section => {
    const classes = (0, _classnames.default)("gv__primary-nav__course-link", {
      "is-active": isDesktop && section === activeTab,
      "gv__primary-nav__course-link--preview": isPreviewStyle
    });
    const subheadClass = (0, _classnames.default)("gv__primary-nav__course-subhead", {
      "gv__primary-nav__course-subhead--current": isDesktop && activeParent && activeParent === section
    });
    const itemClass = (0, _classnames.default)("gv__primary-nav__courses-list-item", {
      "gv__primary-nav__courses-list-item--preview": isPreviewStyle
    });
    const uniqueKey = keyProp + section.sectionTitle;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: uniqueKey,
      className: itemClass
    }, renderItem(section, subheadClass, classes), section.subSections && /*#__PURE__*/_react.default.createElement("ul", {
      className: "gv__primary-nav__nested-courses"
    }, section.subSections.map(section => renderTabs(section))));
  };
  return renderTabs(section);
};
navTab.propTypes = propTypes;
var _default = exports.default = navTab;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],97:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  activeParent: _propTypes.object,
  section: _propTypes.object,
  keyProp: _propTypes.number || _propTypes.string,
  setActiveTab: _propTypes.func,
  activeTab: _propTypes.object,
  isDesktop: _propTypes.bool,
  handleClick: _propTypes.func
};
// this is based on Nav Tab with style changes i hate everything
const PreviewNav = props => {
  const {
    section,
    activeParent,
    activeTab,
    handleClick,
    keyProp,
    isDesktop
  } = props;
  const arrowIcon = () => {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__button__icon"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      role: "img",
      width: "7",
      height: "12",
      viewBox: "0 0 7 12",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("title", null), /*#__PURE__*/_react.default.createElement("g", {
      strokeWidth: "1.3",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "square"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1 10.95L5.95 6M1 1l4.95 4.95"
    }))));
  };
  const renderItem = (section, classes) => {
    if (section.sectionUrl || section.LinkUrl) {
      if (section.units || section.subSections) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: classes,
          type: "button",
          "aria-current": section === activeTab,
          onClick: () => handleClick(section)
        }, section.sectionTitle, !isDesktop && arrowIcon());
      } else {
        const target = section.isNewWindow ? "_blank" : null;
        return /*#__PURE__*/_react.default.createElement("a", {
          href: section.sectionUrl || section.url || section.LinkUrl,
          target: target,
          className: "gv__primary-nav__link"
        }, section.sectionTitle || section.title || section.LinkText, section.isNewWindow && /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
          classes: "gv__global-header__dropdown-external"
        }));
      }
    } else {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__primary-nav__course-subhead gv__primary-nav__course-subhead--preview"
      }, section.sectionTitle);
    }
  };
  const renderTabs = section => {
    const classes = (0, _classnames.default)("gv__primary-nav__course-link gv__primary-nav__course-link--preview", {
      "is-active": isDesktop && section === activeTab
    });
    const uniqueKey = keyProp + section.sectionTitle;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: uniqueKey,
      className: "gv__primary-nav__preview-list"
    }, renderItem(section, classes), section.subSections && /*#__PURE__*/_react.default.createElement("ul", {
      className: "gv__primary-nav__nested-courses"
    }, section.subSections.map(section => renderTabs(section))));
  };
  return renderTabs(section);
};
PreviewNav.propTypes = propTypes;
var _default = exports.default = PreviewNav;

},{"../partials/external-link-icon.jsx":148,"classnames":"classnames","prop-types":"prop-types","react":"react"}],98:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _NavTab = _interopRequireDefault(require("./NavTab.jsx"));
var _MobileMenu = _interopRequireDefault(require("./MobileMenu.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// import NavigationPromo from "./NavigationPromo.jsx";

const propTypes = {
  activeTab: _propTypes.object,
  isDesktop: _propTypes.bool,
  handleTertiaryOpen: _propTypes.func,
  handleTabChange: _propTypes.func,
  recheckLinks: _propTypes.func,
  activeParent: _propTypes.object,
  // data: shape({
  //   topLevelLinkText: string.isRequired,
  //   sections: arrayOf(
  //     shape({
  //       sectionTitle: string,
  //       sectionUrl: string,
  //       promo: object,
  //       units: arrayOf(
  //         arrayOf(
  //           shape({
  //             unitTitle: string,
  //             unitUrl: string,
  //             lessons: arrayOf(
  //               shape({
  //                 lessonTitle: string,
  //                 lessonUrl: string,
  //               })
  //             ),
  //           })
  //         )
  //       ),
  //     })
  //   ),
  // }),
  isMobile: _propTypes.bool,
  onKeyDown: _propTypes.func
};
const PrimaryNav = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    activeTab,
    activeParent,
    isDesktop,
    onKeyDown,
    logoImgLight,
    handleTabChange,
    recheckLinks
  } = props;
  const {
    sections,
    courseHomeButtonText,
    teachingButtonText
  } = props.data || "";
  const tabContent = (0, _react.useRef)();
  const setSection = () => {
    if (sections && isDesktop) {
      let allSections = [];
      sections.forEach(x => {
        if (x.subSections) {
          x.subSections.forEach(section => {
            allSections.push(section);
          });
        } else {
          allSections.push(x);
        }
      });
      const currentSection = allSections.filter(section => section.isCurrent === true);
      if (currentSection.length > 0) {
        handleTabChange(currentSection[0]);
      } else {
        const possibleSelectableSections = allSections.filter(section => section.units.length > 0);
        handleTabChange(possibleSelectableSections[0]);
      }
    }
  };
  (0, _react.useEffect)(setSection, []);

  // useEffect(() => {
  //   props.handleTabChange && props.handleTabChange(activeTab);
  //   tabContent && tabContent.current.focus();
  // }, [activeTab]);

  const renderLessons = (lesson, i) => {
    const {
      lessonUrl,
      lessonTitle,
      lessonNum
    } = lesson;
    const num = lessonNum.split(" ")[1]; // get just the lesson number

    return /*#__PURE__*/_react.default.createElement("a", {
      href: lessonUrl,
      key: i,
      className: "gv__primary-nav__sublink"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__primary-nav__sublink-number"
    }, num), " ", lessonTitle);
  };
  const renderMenu = (unit, i) => {
    const {
      unitNum,
      unitTitle,
      lessons,
      unitUrl
    } = unit;
    return /*#__PURE__*/_react.default.createElement("nav", {
      key: i,
      className: "gv__primary-nav__links"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: unitUrl,
      className: "gv__primary-nav__link"
    }, unitNum, ": ", unitTitle), lessons.map((lesson, i) => renderLessons(lesson, i)));
  };
  const renderMenuCol = (unitArr, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "gv__primary-nav__col"
    }, isDesktop && unitArr.map((unit, i) => renderMenu(unit, i)));
  };
  const arrowIcon = () => {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__button__icon"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      role: "img",
      width: "7",
      height: "12",
      viewBox: "0 0 7 12",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("title", null), /*#__PURE__*/_react.default.createElement("g", {
      strokeWidth: "1.3",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "square"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1 10.95L5.95 6M1 1l4.95 4.95"
    }))));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav",
    ref: ref,
    onKeyDown: onKeyDown
  }, isDesktop && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav__courses"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "gv__primary-nav__courses-list"
  }, sections && sections.map((section, i) => /*#__PURE__*/_react.default.createElement(_NavTab.default, {
    key: i,
    section: section,
    activeParent: activeParent,
    activeTab: activeTab,
    keyProp: `primarynav${i}`,
    handleClick: handleTabChange,
    isDesktop: isDesktop
  }))), logoImgLight && /*#__PURE__*/_react.default.createElement("img", {
    className: "gv__primary-nav__light-logo",
    src: logoImgLight,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("div", {
    tabIndex: "-1",
    ref: tabContent,
    className: "js-gv__primary-nav__content gv__primary-nav__content"
  }, isDesktop && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, activeTab && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav__context"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav__summary-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav__summary-title"
  }, activeTab.sectionTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav__summary"
  }, activeTab.sectionSummary && activeTab.sectionSummary)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav__course-quick-links"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: activeTab.sectionUrl,
    className: "gv__primary-nav__course-quick-button gv__button gv__button--arrow"
  }, /*#__PURE__*/_react.default.createElement("span", null, courseHomeButtonText && courseHomeButtonText), arrowIcon()), activeTab.sectionTeachingLink && /*#__PURE__*/_react.default.createElement("a", {
    href: activeTab.sectionTeachingLink,
    className: "gv__primary-nav__course-quick-button gv__button gv__button--secondary gv__button--arrow"
  }, /*#__PURE__*/_react.default.createElement("span", null, teachingButtonText && teachingButtonText), arrowIcon()))), /*#__PURE__*/_react.default.createElement("nav", {
    className: "gv__primary-nav__cols"
  }, activeTab && !!activeTab.units && activeTab.units.map((unit, i) => unit.length > 0 && renderMenuCol(unit, i)))), !isDesktop && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, activeTab && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav__mobile-sub-nav"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav__section-title"
  }, activeTab.sectionTitle || activeTab.navigationTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__primary-nav__course-quick-links"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: activeTab.sectionUrl,
    className: "gv__primary-nav__course-quick-button gv__button gv__button--arrow"
  }, /*#__PURE__*/_react.default.createElement("span", null, courseHomeButtonText && courseHomeButtonText), arrowIcon()), activeTab.sectionTeachingLink && /*#__PURE__*/_react.default.createElement("a", {
    href: activeTab.sectionTeachingLink,
    className: "gv__primary-nav__course-quick-button gv__button gv__button--secondary gv__button--arrow"
  }, /*#__PURE__*/_react.default.createElement("span", null, teachingButtonText && teachingButtonText), arrowIcon()))), /*#__PURE__*/_react.default.createElement("nav", null, activeTab && !!activeTab.units && activeTab.units.map((unitArr, i) => {
    if (unitArr && unitArr.length) {
      return unitArr.map((unit, i) => /*#__PURE__*/_react.default.createElement(_MobileMenu.default, {
        unit: unit,
        recheckLinks: recheckLinks,
        primaryNav: props.data,
        key: i
      }));
    }
  })))));
});
PrimaryNav.propTypes = propTypes;
var _default = exports.default = PrimaryNav;

},{"./MobileMenu.jsx":95,"./NavTab.jsx":96,"classnames":"classnames","prop-types":"prop-types","react":"react"}],99:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _LinkedImg = _interopRequireDefault(require("../partials/LinkedImg.jsx"));
var _propTypes = require("prop-types");
var _Search = _interopRequireDefault(require("./new-3.0-parts/Search.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  handleSmallMenuClose: _propTypes.func.isRequired,
  hasLogo: _propTypes.bool,
  logoImgMobile: _propTypes.string,
  logoImgAlt: _propTypes.string,
  backButtonText: _propTypes.string,
  closeNav: _propTypes.func,
  shouldShowBack: _propTypes.bool
};
const SmallMenuHeader = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    shouldShowBack,
    backButtonText,
    closeNav
  } = props;
  const renderBackButton = () => {
    return /*#__PURE__*/_react.default.createElement("button", {
      className: "gv__global-header__small-menu__back",
      type: "button",
      ref: ref,
      onClick: closeNav
    }, /*#__PURE__*/_react.default.createElement("svg", {
      role: "img",
      "aria-labelledby": "arrowTitle",
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg",
      width: "7",
      height: "12",
      viewBox: "0 0 7 12"
    }, /*#__PURE__*/_react.default.createElement("title", {
      id: "arrowTitle"
    }), /*#__PURE__*/_react.default.createElement("g", {
      stroke: "#213245",
      strokeWidth: "1.3",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "square"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M6 1.05L1.05 6M6 11L1.05 6.05"
    }))), backButtonText);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, shouldShowBack && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__global-header__small-menu-back-container"
  }, renderBackButton()));
});
SmallMenuHeader.propTypes = propTypes;
var _default = exports.default = SmallMenuHeader;

},{"../partials/LinkedImg.jsx":137,"./new-3.0-parts/Search.jsx":106,"prop-types":"prop-types","react":"react"}],100:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  data: (0, _propTypes.shape)({
    unitNum: _propTypes.string.isRequired,
    unitTitle: _propTypes.string.isRequired,
    unitUrl: _propTypes.string.isRequired
  }).isRequired,
  topLevelLinkText: _propTypes.string.isRequired
};
const TertiaryNav = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    unitNum,
    unitTitle,
    unitUrl,
    lessons
  } = props.data;
  const {
    topLevelLinkText
  } = props;
  const renderLessons = (lesson, i) => {
    const {
      lessonNum,
      lessonTitle,
      lessonUrl
    } = lesson;
    return /*#__PURE__*/_react.default.createElement("a", {
      href: lessonUrl,
      key: i,
      className: "gv__primary-nav__link"
    }, /*#__PURE__*/_react.default.createElement("strong", null, lessonNum), ": ", lessonTitle);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("nav", null, /*#__PURE__*/_react.default.createElement("a", {
    href: unitUrl,
    className: "gv__primary-nav__link"
  }, /*#__PURE__*/_react.default.createElement("strong", null, topLevelLinkText)), lessons.map((lesson, i) => renderLessons(lesson, i))));
});
TertiaryNav.propTypes = propTypes;
var _default = exports.default = TertiaryNav;

},{"prop-types":"prop-types","react":"react"}],101:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  data: (0, _propTypes.shape)({
    firstName: _propTypes.string.isRequired,
    lastName: _propTypes.string,
    avatarImg: _propTypes.string,
    avatarImgAlt: _propTypes.string,
    schoolName: _propTypes.string,
    role: _propTypes.string,
    utilityLinks: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      title: _propTypes.string.isRequired,
      url: _propTypes.string.isRequired,
      target: _propTypes.string,
      useAnchorScroll: _propTypes.bool
    }))
  }).isRequired,
  handleClick: _propTypes.func
};
const UtilityNav = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    avatarImg,
    avatarImgAlt,
    firstName,
    lastName,
    schoolName,
    role,
    utilityLinks
  } = props.data;
  const {
    buttonRef,
    handleClick
  } = props;
  const [allLinks, setAllLinks] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    [...allLinks].forEach(x => {
      x.addEventListener("keydown", e => onKeyDown(e));
    });
  }, [allLinks]);
  (0, _react.useEffect)(() => {
    const listLinks = ref.current.querySelectorAll("a, input, button");
    setAllLinks(listLinks);
  }, []);
  const onKeyDown = e => {
    const totalLinks = allLinks.length;
    const target = e.target;
    const index = [...allLinks].indexOf(target);
    const menuButton = buttonRef;
    switch (e.key) {
      case "Escape":
        handleClick();
        menuButton.focus();
        break;
      case "Tab":
        if (e.shiftKey) {
          e.preventDefault();
          handleClick();
          menuButton.focus();
        }
        if (index === totalLinks - 1) {
          e.preventDefault();
          handleClick();
          menuButton.focus();
        }
        break;
      default:
    }
  };
  const renderLinks = (utilityLink, i) => {
    const {
      title,
      url,
      target,
      useAnchorScroll
    } = utilityLink;
    const linkClass = (0, _classnames.default)("gv__utility-nav__link", {
      "js-anchor-link": useAnchorScroll
    });
    return /*#__PURE__*/_react.default.createElement("a", {
      href: url,
      key: i,
      className: linkClass,
      target: target
    }, title, target === "_blank" && /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
      classes: "gv__aux-nav__external"
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__utility-nav",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__utility-nav__bubble-top"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M21,21H3L12,3Z"
  }))), utilityLinks && /*#__PURE__*/_react.default.createElement("nav", {
    className: "gv__utility-nav__section"
  }, utilityLinks.map((link, i) => renderLinks(link, i))));
});
UtilityNav.propTypes = propTypes;
var _default = exports.default = UtilityNav;

},{"../partials/external-link-icon.jsx":148,"classnames":"classnames","prop-types":"prop-types","react":"react"}],102:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _GlobalHeader = _interopRequireDefault(require("./GlobalHeader.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-global-header");
if (el) {
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_GlobalHeader.default, null), el);
}

},{"./GlobalHeader.jsx":93,"react":"react","react-dom":"react-dom"}],103:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _Dropdown = _interopRequireDefault(require("../Dropdown.jsx"));
var _Search = _interopRequireDefault(require("./Search.jsx"));
var _AuxiliaryNav = _interopRequireDefault(require("../AuxiliaryNav.jsx"));
var _UserIconMenu = _interopRequireDefault(require("./UserIconMenu.jsx"));
var _SavedItems = _interopRequireDefault(require("./SavedItems.jsx"));
var _UtilityNav = _interopRequireDefault(require("../UtilityNav.jsx"));
var _PrimaryNav = _interopRequireDefault(require("../PrimaryNav.jsx"));
var _externalLinkIcon = _interopRequireDefault(require("../../partials/external-link-icon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const proptypes = {
  previewNavData: _propTypes.array,
  auxNavItems: _propTypes.array,
  isDesktop: _propTypes.bool,
  inputLabel: _propTypes.string,
  inputHint: _propTypes.string,
  searchUrl: _propTypes.string,
  displaySearch: _propTypes.bool,
  onClickSearch: _propTypes.func,
  searchIsActive: _propTypes.bool,
  primaryNavData: _propTypes.object,
  utilityNavData: _propTypes.object,
  isCanvasHeader: _propTypes.bool,
  auxNavItemsRest: _propTypes.object,
  handleAuxNavClick: _propTypes.func,
  handleUtilityNavClick: _propTypes.func,
  selectedAuxItem: _propTypes.bool,
  utilityNavOpen: _propTypes.bool,
  userInitials: _propTypes.string,
  utilityMenuItemRefButtonRef: _propTypes.element,
  avatarImg: _propTypes.string,
  avatarImgAlt: _propTypes.string,
  handleSmallMenuClose: _propTypes.func
};
const AuthenticatedDesktopNav = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    previewNavData,
    auxNavItems,
    isDesktop,
    inputLabel,
    inputHint,
    searchUrl,
    displaySearch,
    searchIsActive,
    setSearchIsActive,
    primaryNavData,
    utilityNavData,
    isCanvasHeader,
    auxNavItemsRest,
    handleAuxNavClick,
    handleUtilityNavClick,
    selectedAuxItem,
    utilityNavOpen,
    userInitials,
    utilityMenuItemRefButtonRef,
    onClickSearch,
    avatarImg,
    avatarImgAlt,
    handleSmallMenuClose
  } = props;
  const utilityNavClasses = (0, _classnames.default)("gv__global-header__nav-item--utility", {
    "is-open": utilityNavOpen
  });
  const dropDownClasses = help => (0, _classnames.default)("gv__global-header__nav-item", {
    "gv__global-header__nav-item--help": help
  });
  const renderHelpIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.0733 12.4096C11.0013 12.5986 10.9653 12.8281 10.9653 13.0981V13.6921H12.9903V13.3006C12.9903 13.1476 13.0263 12.9946 13.0983 12.8416C13.1703 12.6886 13.3098 12.5311 13.5168 12.3691C13.8408 12.1171 14.1063 11.8876 14.3133 11.6806C14.5293 11.4646 14.7003 11.2531 14.8263 11.0461C14.9613 10.8391 15.0558 10.6321 15.1098 10.4251C15.1638 10.2091 15.1908 9.97061 15.1908 9.70961C15.1908 9.27761 15.1098 8.89511 14.9478 8.56211C14.7858 8.22911 14.5653 7.95011 14.2863 7.72511C14.0073 7.50011 13.6833 7.33361 13.3143 7.22561C12.9543 7.10861 12.5673 7.05011 12.1533 7.05011C11.2083 7.05011 10.4343 7.30211 9.83126 7.80611C9.22826 8.30111 8.87726 9.02561 8.77826 9.97961L10.8573 10.1146C10.8843 9.78161 11.0058 9.49811 11.2218 9.26411C11.4468 9.03011 11.7708 8.91311 12.1938 8.91311C12.4728 8.91311 12.7023 8.99861 12.8823 9.16961C13.0713 9.33161 13.1658 9.56111 13.1658 9.85811C13.1658 10.0111 13.1208 10.1596 13.0308 10.3036C12.9498 10.4386 12.8328 10.5871 12.6798 10.7491C12.5268 10.9021 12.3423 11.0686 12.1263 11.2486C11.9193 11.4286 11.6898 11.6401 11.4378 11.8831C11.2668 12.0451 11.1453 12.2206 11.0733 12.4096ZM10.8303 15.2041C10.7673 15.3571 10.7358 15.5191 10.7358 15.6901C10.7358 15.8611 10.7673 16.0231 10.8303 16.1761C10.8933 16.3291 10.9788 16.4641 11.0868 16.5811C11.2038 16.6891 11.3388 16.7746 11.4918 16.8376C11.6448 16.9006 11.8068 16.9321 11.9778 16.9321C12.1488 16.9321 12.3108 16.9006 12.4638 16.8376C12.6168 16.7746 12.7473 16.6891 12.8553 16.5811C12.9723 16.4641 13.0623 16.3291 13.1253 16.1761C13.1883 16.0231 13.2198 15.8611 13.2198 15.6901C13.2198 15.5191 13.1883 15.3571 13.1253 15.2041C13.0623 15.0511 12.9723 14.9206 12.8553 14.8126C12.7473 14.6956 12.6168 14.6056 12.4638 14.5426C12.3108 14.4796 12.1488 14.4481 11.9778 14.4481C11.8068 14.4481 11.6448 14.4796 11.4918 14.5426C11.3388 14.6056 11.2038 14.6956 11.0868 14.8126C10.9788 14.9206 10.8933 15.0511 10.8303 15.2041Z",
    fill: "currentColor"
  }));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__global-header__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__global-header__nav-left"
  }, previewNavData && previewNavData.map((x, i) => {
    const isDropdown = x.units || x.apiUrl;
    if (isDropdown) {
      return /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
        buttonLabel: x?.sectionTitle,
        subItems: x?.units || [],
        apiUrl: x?.apiUrl,
        isDesktop: isDesktop,
        isRight: false,
        buttonClass: dropDownClasses(x?.sectionTitle.toLowerCase() === "help"),
        buttonIcon: x?.sectionTitle.toLowerCase() === "help",
        isCurrent: false,
        setSearchIsActive: setSearchIsActive,
        key: `dropdown${i}`
      });
    } else {
      return /*#__PURE__*/_react.default.createElement("a", {
        key: `topLevel${i}`,
        href: x?.sectionUrl,
        className: "gv__global-header__nav-item",
        target: x?.isNewWindow ? "_blank" : null,
        rel: "noreferrer"
      }, x?.sectionTitle);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__global-header__nav-right"
  }, (primaryNavData || isCanvasHeader) && auxNavItemsRest && auxNavItemsRest.map((auxNavItem, i) => /*#__PURE__*/_react.default.createElement(_AuxiliaryNav.default, {
    navItem: auxNavItem,
    selectedAuxItem: selectedAuxItem,
    key: i,
    handleClick: handleAuxNavClick,
    isDesktop: isDesktop
  })), auxNavItems.map((navItem, ind) => navItem?.subLinks ? /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    handleSmallMenuClose: handleSmallMenuClose,
    buttonIcon: navItem?.title.toLowerCase() === "help",
    buttonLabel: navItem?.title,
    buttonClass: `gv__global-header__nav-item gv__global-header__nav-item--help ${navItem?.cssClass}`,
    subItems: navItem?.subLinks,
    isDesktop: isDesktop,
    isRight: true,
    setSearchIsActive: setSearchIsActive,
    key: `auxNavItemsDropDown${ind}`
  }) : /*#__PURE__*/_react.default.createElement("a", {
    key: `auxNavItemsButton${ind}`,
    href: navItem?.url,
    className: `${navItem?.title.toLowerCase()} gv__global-header__nav-item not-authenticated`,
    target: navItem.target
  }, navItem?.title.toLowerCase() === "help" ? renderHelpIcon() : navItem.target.toLowerCase() === "_blank" ? /*#__PURE__*/_react.default.createElement("span", null, navItem?.title, " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
    classes: ""
  })) : /*#__PURE__*/_react.default.createElement("span", null, navItem?.title))), displaySearch && /*#__PURE__*/_react.default.createElement(_Search.default, {
    inputLabel: inputLabel,
    inputHint: inputHint,
    searchUrl: searchUrl,
    isActive: searchIsActive,
    onClick: onClickSearch
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "vertical-divider"
  }), utilityNavData && /*#__PURE__*/_react.default.createElement(_UserIconMenu.default, {
    extraClasses: utilityNavClasses,
    onClick: handleUtilityNavClick,
    initials: userInitials,
    avatarImg: avatarImg,
    avatarImgAlt: avatarImgAlt
  }))), utilityNavOpen && /*#__PURE__*/_react.default.createElement(_UtilityNav.default, {
    ref: ref,
    handleClick: handleUtilityNavClick,
    data: utilityNavData,
    buttonRef: utilityMenuItemRefButtonRef
  }));
});
AuthenticatedDesktopNav.propTypes = proptypes;
var _default = exports.default = AuthenticatedDesktopNav;

},{"../../partials/external-link-icon.jsx":148,"../AuxiliaryNav.jsx":91,"../Dropdown.jsx":92,"../PrimaryNav.jsx":98,"../UtilityNav.jsx":101,"./SavedItems.jsx":105,"./Search.jsx":106,"./UserIconMenu.jsx":108,"classnames":"classnames","prop-types":"prop-types","react":"react"}],104:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _Dropdown = _interopRequireDefault(require("../Dropdown.jsx"));
var _Search = _interopRequireDefault(require("./Search.jsx"));
var _externalLinkIcon = _interopRequireDefault(require("../../partials/external-link-icon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const proptypes = {
  previewNavData: _propTypes.array,
  auxNavItems: _propTypes.array,
  isDesktop: _propTypes.bool,
  inputHint: _propTypes.object,
  searchUrl: _propTypes.object,
  displaySearch: _propTypes.bool,
  onClickSearch: _propTypes.func,
  searchIsActive: _propTypes.bool,
  handleSmallMenuClose: _propTypes.func
};
const NotAuthenticatedNav = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    previewNavData,
    auxNavItems,
    isDesktop,
    inputLabel,
    inputHint,
    searchUrl,
    displaySearch,
    searchIsActive,
    setSearchIsActive,
    handleSmallMenuClose,
    onClickSearch
  } = props;
  const loginButtonClasses = (isLoginButton, cssClassFromData) => (0, _classnames.default)(cssClassFromData, {
    "gv__global-header__nav-item not-authenticated": !isLoginButton,
    "gv__button gv__button--2 gv__button--signuplogin": isLoginButton
  });
  const renderLeftNavItems = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, previewNavData.map((x, i) => /*#__PURE__*/_react.default.createElement("a", {
    key: `topLevel${i}`,
    href: x?.sectionUrl,
    className: "gv__global-header__nav-item"
  }, x?.sectionTitle)));
  const renderHelpIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.0733 12.4096C11.0013 12.5986 10.9653 12.8281 10.9653 13.0981V13.6921H12.9903V13.3006C12.9903 13.1476 13.0263 12.9946 13.0983 12.8416C13.1703 12.6886 13.3098 12.5311 13.5168 12.3691C13.8408 12.1171 14.1063 11.8876 14.3133 11.6806C14.5293 11.4646 14.7003 11.2531 14.8263 11.0461C14.9613 10.8391 15.0558 10.6321 15.1098 10.4251C15.1638 10.2091 15.1908 9.97061 15.1908 9.70961C15.1908 9.27761 15.1098 8.89511 14.9478 8.56211C14.7858 8.22911 14.5653 7.95011 14.2863 7.72511C14.0073 7.50011 13.6833 7.33361 13.3143 7.22561C12.9543 7.10861 12.5673 7.05011 12.1533 7.05011C11.2083 7.05011 10.4343 7.30211 9.83126 7.80611C9.22826 8.30111 8.87726 9.02561 8.77826 9.97961L10.8573 10.1146C10.8843 9.78161 11.0058 9.49811 11.2218 9.26411C11.4468 9.03011 11.7708 8.91311 12.1938 8.91311C12.4728 8.91311 12.7023 8.99861 12.8823 9.16961C13.0713 9.33161 13.1658 9.56111 13.1658 9.85811C13.1658 10.0111 13.1208 10.1596 13.0308 10.3036C12.9498 10.4386 12.8328 10.5871 12.6798 10.7491C12.5268 10.9021 12.3423 11.0686 12.1263 11.2486C11.9193 11.4286 11.6898 11.6401 11.4378 11.8831C11.2668 12.0451 11.1453 12.2206 11.0733 12.4096ZM10.8303 15.2041C10.7673 15.3571 10.7358 15.5191 10.7358 15.6901C10.7358 15.8611 10.7673 16.0231 10.8303 16.1761C10.8933 16.3291 10.9788 16.4641 11.0868 16.5811C11.2038 16.6891 11.3388 16.7746 11.4918 16.8376C11.6448 16.9006 11.8068 16.9321 11.9778 16.9321C12.1488 16.9321 12.3108 16.9006 12.4638 16.8376C12.6168 16.7746 12.7473 16.6891 12.8553 16.5811C12.9723 16.4641 13.0623 16.3291 13.1253 16.1761C13.1883 16.0231 13.2198 15.8611 13.2198 15.6901C13.2198 15.5191 13.1883 15.3571 13.1253 15.2041C13.0623 15.0511 12.9723 14.9206 12.8553 14.8126C12.7473 14.6956 12.6168 14.6056 12.4638 14.5426C12.3108 14.4796 12.1488 14.4481 11.9778 14.4481C11.8068 14.4481 11.6448 14.4796 11.4918 14.5426C11.3388 14.6056 11.2038 14.6956 11.0868 14.8126C10.9788 14.9206 10.8933 15.0511 10.8303 15.2041Z",
    fill: "currentColor"
  }));
  const renderRightNavItems = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, auxNavItems.map((navItem, ind) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: `auxNavItems${ind}`
    }, navItem?.subLinks ? /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
      handleSmallMenuClose: handleSmallMenuClose,
      buttonIcon: navItem?.title.toLowerCase() === "help",
      buttonLabel: navItem?.title,
      buttonClass: `gv__global-header__nav-item gv__global-header__nav-item--help ${navItem?.cssClass}`,
      subItems: navItem?.subLinks,
      isDesktop: isDesktop,
      isRight: true,
      setSearchIsActive: setSearchIsActive,
      key: `auxNavItemsDropDown${ind}`
    }) : auxNavItems.length - 1 === ind ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, displaySearch && /*#__PURE__*/_react.default.createElement(_Search.default, {
      inputLabel: inputLabel,
      inputHint: inputHint,
      searchUrl: searchUrl,
      key: `auxNavItemsSearch${ind}`,
      isActive: searchIsActive,
      onClick: onClickSearch
    }), /*#__PURE__*/_react.default.createElement("a", {
      key: `auxNavItemsLink${ind}`,
      href: navItem?.url,
      className: loginButtonClasses(auxNavItems.length - 1 === ind, navItem?.cssClass),
      target: navItem?.target
    }, navItem?.target.toLowerCase() === "_blank" ? /*#__PURE__*/_react.default.createElement("span", null, navItem?.title, " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
      classes: ""
    })) : /*#__PURE__*/_react.default.createElement("span", null, navItem?.title))) : /*#__PURE__*/_react.default.createElement("a", {
      key: `auxNavItemsButton${ind}`,
      href: navItem?.url,
      className: `${navItem?.title.toLowerCase()} ${loginButtonClasses(auxNavItems.length - 1 === ind, navItem?.cssClass)}`,
      target: navItem?.target
    }, navItem?.title.toLowerCase() === "help" ? renderHelpIcon() : navItem?.target.toLowerCase() === "_blank" ? /*#__PURE__*/_react.default.createElement("span", null, navItem?.title, " ", /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
      classes: ""
    })) : /*#__PURE__*/_react.default.createElement("span", null, navItem?.title)))));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__global-header__container"
  }, previewNavData && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__global-header__nav-left"
  }, renderLeftNavItems()), previewNavData && auxNavItems && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__global-header__nav-right"
  }, renderRightNavItems()));
});
NotAuthenticatedNav.propTypes = proptypes;
var _default = exports.default = NotAuthenticatedNav;

},{"../../partials/external-link-icon.jsx":148,"../Dropdown.jsx":92,"./Search.jsx":106,"classnames":"classnames","prop-types":"prop-types","react":"react"}],105:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const proptypes = {
  amountOfSaved: _propTypes.number,
  savedData: _propTypes.object
};
const SavedItems = props => {
  const {
    amountOfSaved,
    savedData
  } = props;
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__button gv__global-header__saved-button gv__global-header__nav-item"
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("g", {
    "clip-path": "url(#clip0_8858_28053)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10 15L14 17L16 18V15.7639V4C16 2.89543 15.1046 2 14 2H6C4.89543 2 4 2.89543 4 4V15.7639V18L6 17L10 15ZM6 14.7639L9.10557 13.2111L10 12.7639L10.8944 13.2111L14 14.7639V4H6V14.7639Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_8858_28053"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "20",
    height: "20",
    fill: "currentColor"
  }))))), /*#__PURE__*/_react.default.createElement("span", null, amountOfSaved));
};
SavedItems.defaultProps = {
  amountOfSaved: 10
};
SavedItems.propTypes = proptypes;
var _default = exports.default = SavedItems;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],106:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SearchInput = _interopRequireDefault(require("../../search-results/SearchInput.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  inputHint: _propTypes.string,
  onClick: _propTypes.func,
  isActive: _propTypes.bool,
  onChange: _propTypes.func,
  onSubmit: _propTypes.func,
  searchUrl: _propTypes.string,
  handleSearchClose: _propTypes.func
};
const Search = props => {
  const {
    inputLabel,
    inputHint,
    isActive,
    searchUrl,
    onClick,
    handleSearchClose
  } = props;
  const [newSearchQueryInput, setSearchQueryInput] = (0, _react.useState)({
    value: ""
  });
  // const [mobileSearchToggle, setMobileSearchToggle] = useState(false);

  // const toggleMobileSearch = (e) => {
  //   if (mobileSearchToggle) {
  //     setSearchQueryInput({ value: "" });
  //   }
  //   const newMobileSearchToggle = !mobileSearchToggle;
  //   setMobileSearchToggle(newMobileSearchToggle);
  // };

  const handleFormSubmit = e => {
    e.preventDefault();
    window.location = `${searchUrl}?term=${newSearchQueryInput.value}`;
  };
  //  const handleSearchInputChange = (e) => {
  // const value = e.target.value;
  // setSearchQueryInput({ value: e.target.value });
  // if (value) {
  //   setIsActive(true);
  // }
  // };
  // const handleResetSearch = (e) => {
  //   const newFocus = e.target.closest(".gv__search-box").querySelector("input");
  //   setSearchQueryInput({ value: "" });
  //   setIsActive(false);

  //   if (newFocus) {
  //     newFocus.focus();
  //   }
  // };

  const displaySearch = () => {
    if (isActive) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quick-search"
      }, " ", /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
        onFormSubmit: handleFormSubmit,
        newSearchQueryInput: newSearchQueryInput,
        inputLabel: inputLabel,
        inputHint: inputHint,
        handleSearchClose: handleSearchClose,
        handleSearchInputChange: e => setSearchQueryInput({
          value: e.target.value
        })
        // handleResetSearch={handleResetSearch}
      }));
    }
  };
  const renderSearchIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6826 18.0586C20.1287 18.5049 20.1287 19.2283 19.6826 19.6746C19.4684 19.8918 19.1763 20.0143 18.8713 20.0149C18.5663 20.0156 18.2737 19.8943 18.0586 19.678L15.006 16.6254C14.9098 16.5296 14.7595 16.5143 14.646 16.5889C11.7067 18.5309 7.77438 17.9319 5.54655 15.2029C3.31872 12.4738 3.51905 8.5012 6.01013 6.01013C8.5012 3.51905 12.4738 3.31872 15.2029 5.54655C17.9319 7.77438 18.5309 11.7067 16.5889 14.646C16.5155 14.7606 16.5327 14.911 16.63 15.006L19.6826 18.0586ZM10.8746 6.29516C8.34986 6.29516 6.30316 8.34186 6.30316 10.8666C6.30316 12.079 6.78479 13.2418 7.6421 14.0991C8.49941 14.9564 9.66217 15.438 10.8746 15.438C13.3993 15.438 15.446 13.3913 15.446 10.8666C15.446 8.34186 13.3993 6.29516 10.8746 6.29516Z",
    fill: "currentColor"
  }));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    className: `gv__global-header__nav-item gv__global-header__nav-item--search ${isActive ? 'search-open' : ''}`,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("span", null, renderSearchIcon())), displaySearch());
};
Search.propTypes = propTypes;
var _default = exports.default = Search;

},{"../../search-results/SearchInput.jsx":196,"prop-types":"prop-types","react":"react"}],107:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SkipNav = () => /*#__PURE__*/_react.default.createElement("div", {
  className: "gv__skip-navigation"
}, /*#__PURE__*/_react.default.createElement("a", {
  href: "#gv__main",
  className: "gv__visuallyhidden gv__focusable gv__link"
}, "Skip Navigation"));
var _default = exports.default = SkipNav;

},{"react":"react"}],108:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const proptypes = {
  initials: _propTypes.string,
  onClick: _propTypes.func,
  extraClasses: _propTypes.string,
  backgroundColor: _propTypes.string,
  avatarImg: _propTypes.string,
  avatarImgAlt: _propTypes.string
};
const UserIconMenu = props => {
  const {
    onClick,
    extraClasses,
    initials,
    avatarImg,
    avatarImgAlt
  } = props;
  const userButtonClasses = (0, _classnames.default)("gv__global-header__user-button", "gv__button", extraClasses);
  const isAnonImage = avatarImg && avatarImg.includes("anonymous.gif");
  return /*#__PURE__*/_react.default.createElement("button", {
    className: userButtonClasses,
    onClick: onClick
    // ref={utilityMenuItemRef}
    ,
    "aria-label": "Open profile menu"
  }, !isAnonImage && avatarImg && avatarImgAlt ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: avatarImg,
    alt: avatarImgAlt,
    className: "gv__global-header__profile-img",
    height: "40",
    width: "40"
  })) : /*#__PURE__*/_react.default.createElement("span", null, initials));
};
UserIconMenu.propTypes = proptypes;
var _default = exports.default = UserIconMenu;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],109:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
let selectableButtons = document.querySelectorAll(".js-scroll-button");
let contentBuffer = setTimeout(() => {}, 1);
let options = {
  childList: true,
  subtree: true
};
const mCallback = mutations => {
  // loop through the mutations record to see
  // if any match what we want
  for (let mutation of mutations) {
    if (mutation.type === "childList") {
      selectableButtons = document.querySelectorAll(".js-scroll-button");
      selectableButtons.forEach(x => x.addEventListener("click", () => handleModalScroll(x)));
    }
  }
};
let observer = new MutationObserver(mCallback);
const handleModalScroll = el => {
  clearTimeout(contentBuffer);
  const modal = el.closest(".gv__manual-modal");
  if (modal) {
    modal.scrollTop = 0;
  } else {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  contentBuffer = setTimeout(() => {
    selectableButtons = document.querySelectorAll(".js-scroll-button");
  }, 200);
};
const init = el => {
  observer.observe(el, options);
  selectableButtons = document.querySelectorAll(".js-scroll-button");
  selectableButtons.forEach(x => x.addEventListener("click", () => handleModalScroll(x)));
};
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".gv__manual-modal")].forEach(init);
  [...document.querySelectorAll(".gv__survey-page")].forEach(init);
}

},{}],110:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenObj = flattenObj;
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// https://github.com/ramda/ramda/wiki/Cookbook#flatten-a-nested-object-into-dot-separated-key--value-pairs
// Flatten a nested object into dot-separated key / value pairs
function flattenObj(obj) {
  const go = obj_ => R.chain(_ref => {
    let [k, v] = _ref;
    if (typeof v == "object") {
      return R.map(_ref2 => {
        let [k_, v_] = _ref2;
        return [`${k}.${k_}`, v_];
      }, go(v));
    } else {
      return [[k, v]];
    }
  }, R.toPairs(obj_));
  return R.fromPairs(go(obj));
}

},{"ramda":"ramda"}],111:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hideTeachingTools;
const initHideTeachingTools = el => {
  let teacherResourcesSection = document.getElementById("teacher-resources");
  if (teacherResourcesSection) {
    el.classList.remove("is-hidden");
  }
};
function hideTeachingTools() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  document.querySelectorAll(".js-teaching-tools-btn") && [...document.querySelectorAll(".js-teaching-tools-btn")].forEach(initHideTeachingTools);
}

},{}],112:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unitColorUpdates;
function unitColorUpdates(document, window) {
  const hoverColorItems = document.querySelectorAll('.js-hover-color');
  if (!hoverColorItems) {
    return;
  }
  hoverColorItems.forEach((hoverColorItem, index) => {
    const unitColor = hoverColorItem?.getAttribute('data-unit-color');
    const pillBGColor = hoverColorItem?.querySelector('.js-hover-color-pill-bg');
    const underlineColor = hoverColorItem?.querySelector('.js-hover-color-underline');
    const arrowColor = hoverColorItem?.querySelector('.js-hover-color-arrow');
    if (arrowColor) {
      const arrowColorBefore = window.getComputedStyle(arrowColor, '::before');
      const arrowColorAfter = window.getComputedStyle(arrowColor, '::after');
    }
    const CTAColor = hoverColorItem?.querySelector('.js-hover-color-cta');
    hoverColorItem.addEventListener('mouseover', () => {
      pillBGColor ? pillBGColor.style.backgroundColor = unitColor : null;
      underlineColor ? underlineColor.style.borderBottom = '2px solid ' + unitColor : null;
      if (arrowColor) {
        arrowColor.style.setProperty('--before', unitColor);
        arrowColor.style.setProperty('--after', unitColor);
      }
      if (CTAColor) {
        CTAColor.style.backgroundColor = unitColor;
      }
    });
    hoverColorItem.addEventListener('mouseout', () => {
      pillBGColor ? pillBGColor.style.backgroundColor = '#fff' : null;
      underlineColor ? underlineColor.style.borderBottom = '2px solid transparent' : null;
      if (arrowColor) {
        arrowColor?.style.setProperty('--before', '#333');
        arrowColor?.style.setProperty('--after', '#333');
      }
      if (CTAColor) {
        CTAColor.style.backgroundColor = '#213245';
      }
    });
  });
}

},{}],113:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageCarousel;
var _imageViewerModal = _interopRequireDefault(require("../image-viewer-modal/image-viewer-modal.js"));
var _swiperBundleMin = _interopRequireDefault(require("swiper/swiper-bundle.min.mjs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import Swiper bundle with all modules installed

function imageCarousel() {
  const imageCarousel = document.querySelectorAll(".js-image-carousel");
  if (imageCarousel.length > 0) {
    imageCarousel.forEach(element => {
      const imageCarouselID = element.getAttribute("id");
      var thumbnailSwiper = new _swiperBundleMin.default("#" + imageCarouselID + " .thumbSwiper", {
        spaceBetween: 15,
        slidesPerView: 3,
        watchSlidesProgress: true,
        freeMode: true,
        breakpoints: {
          // when window width is >= 680px
          680: {
            spaceBetween: 5,
            slidesPerView: "auto",
            freeMode: true
          },
          780: {
            slidesPerView: 4
          }
        }
      });
      var swiper3 = new _swiperBundleMin.default("#" + imageCarouselID + " .textSwiper", {
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: element.querySelector(".swiper-button-next"),
          prevEl: element.querySelector(".swiper-button-prev")
        },
        autoHeight: true,
        thumbs: {
          swiper: thumbnailSwiper
        }
      });
      var swiper2 = new _swiperBundleMin.default("#" + imageCarouselID + " .mainSwiper", {
        loop: true,
        spaceBetween: 10,
        navigation: {
          nextEl: element.querySelector(".swiper-button-next"),
          prevEl: element.querySelector(".swiper-button-prev")
        },
        thumbs: {
          swiper: thumbnailSwiper
        },
        on: {
          realIndexChange: function () {
            const slides = this.slides;
            let slide;
            slides.forEach(currentSlide => {
              let slideIndex = currentSlide.getAttribute("data-swiper-slide-index");
              if (slideIndex === this.realIndex.toString()) {
                slide = currentSlide;
              }
            });
            let slideImageID = slide.getAttribute("data-image-id");
            const slideImage = slide.getAttribute("data-modal-image");
            const slideParent = slide.closest(".gv__image-carousel");
            const expandButton = slideParent?.querySelector(".js__image-carousel__btn-expand");
            const modalDiv = slideParent?.querySelector(".js-image-viewer-modal");
            const prefix = "js-gv__image-viewer__expand--guid";
            const classes = expandButton?.className.split(" ").filter(c => !c.startsWith(prefix));
            expandButton.className = classes.join(" ").trim();
            expandButton?.classList.add("js__image-carousel__btn-expand--guid" + slideImageID);
            modalDiv?.setAttribute("data-trigger-button", "js__image-carousel__btn-expand--guid" + slideImageID);
            modalDiv?.setAttribute("data-large-size", slideImage);
            const shareModalDivID = slide.getAttribute("data-image-id");
            const shareButtons = slideParent.querySelectorAll(".js-share-modal-toggle");
            shareButtons.forEach(button => {
              if (button.getAttribute("data-modal") === `share-modal-${shareModalDivID}`) {
                button.classList.add("active-button");
              } else {
                button.classList.remove("active-button");
              }
            });
            (0, _imageViewerModal.default)(document, window);
          }
        }
      });
    });
  }
}

},{"../image-viewer-modal/image-viewer-modal.js":116,"swiper/swiper-bundle.min.mjs":"swiper/swiper-bundle.min.mjs"}],114:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _OpenSeaDragon = _interopRequireDefault(require("./OpenSeaDragon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
document.querySelector(".js-gv__image-viewer") && _reactModal.default.setAppElement(".js-gv__image-viewer");
class ImageViewerModal extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      if (this.props.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      const buttons = document.querySelectorAll(`.${this.props.triggerButton}`);
      const clickableImage = document.querySelector(`[data-click-modal=${this.props.triggerButton}]`);
      if (buttons) {
        buttons.forEach(button => button.addEventListener("click", this.openModal));
      }
      if (clickableImage) {
        clickableImage.addEventListener("click", this.openModal);
        this.setState({
          longdesc: clickableImage.getAttribute("aria-describedby")
        });
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
    });
    _defineProperty(this, "openModal", e => {
      this.setState({
        modalIsOpen: true,
        isLoading: true
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      this.setState({
        modalIsOpen: false
      });
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.closeButton.current.focus();
    });
    _defineProperty(this, "handleImageLoading", () => {
      this.setState({
        isLoading: false
      });
    });
    this.state = {
      modalIsOpen: props.modalIsOpen || false,
      isLoading: false
    };
    this.closeButton = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      maxWidth,
      maxHeight
    } = this.props;
    const modalClass = (0, _classnames.default)("gv__modal__content--image", {
      "gv__modal__content--zoomable": this.props.deepZoom
    });
    const customHeightWidth = {
      content: {
        maxWidth: maxWidth ? maxWidth : "auto",
        maxHeight: "auto"
      }
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onAfterClose: this.afterCloseModal,
      onRequestClose: this.closeModal,
      contentLabel: "Fullscreen Image Viewer",
      "aria-describedby": this.state.longdesc,
      bodyOpenClassName: null,
      overlayClassName: "gv__modal gv__modal--zoom-overlay",
      className: modalClass,
      style: !this.props.deepZoom && customHeightWidth
    }, /*#__PURE__*/_react.default.createElement("button", {
      "aria-label": "close",
      type: "button",
      onClick: this.closeModal,
      ref: this.closeButton,
      className: "gv__modal__close gv__modal__close--zoom"
    }), /*#__PURE__*/_react.default.createElement(_loading.default, {
      isLoading: this.state.isLoading
    }), this.props.deepZoom ? /*#__PURE__*/_react.default.createElement(_OpenSeaDragon.default, {
      handleImageLoading: this.handleImageLoading,
      tileSources: this.props.deepZoom,
      tileFormat: this.props.zoomFormat,
      zoomHeight: this.props.zoomHeight,
      zoomWidth: this.props.zoomWidth,
      overlap: this.props.zoomOverlap,
      tileSize: this.props.tileSize
    }) : /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__modal--zoom-overlay-img"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: this.props.imageSrc,
      onLoad: this.handleImageLoading,
      alt: ""
    }))));
  }
}
exports.default = ImageViewerModal;
_defineProperty(ImageViewerModal, "propTypes", {
  triggerButton: _propTypes.string,
  imageSrc: _propTypes.string,
  deepZoom: _propTypes.string,
  zoomHeight: _propTypes.string,
  zoomWidth: _propTypes.string,
  zoomFormat: _propTypes.string,
  imageAlt: _propTypes.string,
  maxHeight: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  maxWidth: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  modalIsOpen: _propTypes.bool,
  zoomOverlap: _propTypes.string,
  tileSize: _propTypes.string
});

},{"../partials/loading.jsx":150,"./OpenSeaDragon.jsx":115,"classnames":"classnames","prop-types":"prop-types","react":"react","react-modal":"react-modal"}],115:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class SeadragonViewer extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "renderSectionOverlays", (sections, colorNotes) => {
      const newSection = R.map(section => R.pick(["sectionId", "coordinates"], section), sections);
      const sectionCoordinates = R.map(section => R.mergeAll([{
        id: section.sectionId
      }, {
        type: "section"
      }, section.coordinates, {
        className: "viewer-overlay"
      }]), newSection);
      const colorNoteCoordinates = R.map(notes => R.mergeAll([{
        id: notes.id
      }, {
        parentSection: notes.sectionId
      }, {
        type: "colorNotes"
      }, notes.coordinates, {
        className: "viewer-overlay"
      }]), colorNotes);
      return this.concatArrays(sectionCoordinates, colorNoteCoordinates);
    });
    _defineProperty(this, "concatArrays", (leftArr, rightArr) => {
      return leftArr.concat(rightArr);
    });
    _defineProperty(this, "initSeaDragon", minZoom => {
      const {
        tileSize,
        zoomHeight,
        zoomWidth,
        zoomOverlap
      } = this.props;
      const OpenSeadragon = require("openseadragon");
      const viewer = new OpenSeadragon({
        id: "sd-mount",
        tileSources: {
          Image: {
            xmlns: "http://schemas.microsoft.com/deepzoom/2008",
            Url: this.props.tileSources,
            Format: this.props.tileFormat || "png",
            Overlap: zoomOverlap || "1",
            TileSize: tileSize || "254",
            Size: {
              Height: zoomHeight,
              Width: zoomWidth
            }
          }
        },
        showHomeControl: false,
        showFullPageControl: false,
        zoomInButton: "zoom-in",
        zoomOutButton: "zoom-out",
        visibilityRatio: 1,
        constrainDuringPan: true,
        defaultZoomLevel: minZoom,
        maxZoomLevel: 12,
        minZoomLevel: minZoom,
        zoomPerClick: 1.1
      });

      // viewer.addHandler("tile-drawn", () =>

      viewer.addOnceHandler("open", () => {
        this.props.handleImageLoading(true);

        //openseadragon adds inline styles to these buttons and it's annoying
        this.zoomIn.current.style = "";
        this.zoomOut.current.style = "";
        let zoomScroll = new OpenSeadragon.MouseTracker({
          element: "sd-mount",
          scrollHandler: e => {
            this.setState({
              zoomLevel: viewer.viewport.getZoom(false)
            });
          }
        });
        let zoomInTracker = new OpenSeadragon.MouseTracker({
          element: "zoom-in",
          clickHandler: e => {
            this.setState({
              zoomLevel: viewer.viewport.getZoom(false)
            });
          }
        });
        let zoomOutTracker = new OpenSeadragon.MouseTracker({
          element: "zoom-out",
          clickHandler: e => {
            this.setState({
              zoomLevel: viewer.viewport.getZoom(false)
            });
          }
        });
        let goHome = new OpenSeadragon.MouseTracker({
          element: "go-home",
          clickHandler: e => {
            viewer.viewport.goHome(true);
            this.setState({
              zoomLevel: viewer.viewport.getZoom(false)
            });
          }
        });
      });
    });
    _defineProperty(this, "renderZoomOut", () => {
      return /*#__PURE__*/_react.default.createElement("button", {
        id: "zoom-out",
        "aria-label": "Zoom Out",
        ref: this.zoomOut,
        className: "gv__modal__zoom-button",
        disabled: this.state.zoomLevel.toFixed(2) === this.state.minZoom.toFixed(2),
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", null, " -"));
    });
    _defineProperty(this, "renderZoomIn", () => {
      return /*#__PURE__*/_react.default.createElement("button", {
        "aria-label": "zoom in",
        id: "zoom-in",
        ref: this.zoomIn,
        className: "gv__modal__zoom-button",
        disabled: this.state.zoomLevel.toFixed(2) === this.state.maxZoom.toFixed(2),
        type: "button"
      }, /*#__PURE__*/_react.default.createElement("span", null, "+"));
    });
    _defineProperty(this, "renderGoHome", () => {
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        "aria-label": "go home",
        id: "go-home",
        className: "gv__modal__zoom-button"
      }, /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
      }, /*#__PURE__*/_react.default.createElement("title", null, "Reset"), /*#__PURE__*/_react.default.createElement("path", {
        d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9 22V12h6v10"
      })));
    });
    this.state = {
      zoomLevel: 0.85,
      maxZoom: 12,
      minZoom: 0.85
    };
    this.seadragonMount = /*#__PURE__*/_react.default.createRef();
    this.zoomIn = /*#__PURE__*/_react.default.createRef();
    this.zoomOut = /*#__PURE__*/_react.default.createRef();
  }
  componentDidMount() {
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    this.initSeaDragon(this.state.minZoom);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      ref: this.seadragonMount,
      id: "sd-mount",
      style: {
        position: "relative",
        width: "100%"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__modal__zoom-buttons"
    }, this.renderZoomIn(), this.renderZoomOut(), this.renderGoHome()));
  }
}
_defineProperty(SeadragonViewer, "propTypes", {
  handleImageLoading: _propTypes.func,
  tileSources: _propTypes.string,
  tileFormat: _propTypes.string,
  zoomHeight: _propTypes.string,
  zoomWidth: _propTypes.string,
  zoomOverlap: _propTypes.string,
  tileSize: _propTypes.string
});
var _default = exports.default = SeadragonViewer;

},{"openseadragon":1,"prop-types":"prop-types","ramda":"ramda","react":"react"}],116:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _ImageViewerModal = _interopRequireDefault(require("./ImageViewerModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const el = document.querySelector(".js-image-viewer-modal");
  if (el) {
    const props = {
      triggerButton: el.dataset.triggerButton || "",
      imageSrc: el.dataset.largeSize || "",
      deepZoom: el.dataset.deepZoom,
      zoomFormat: el.dataset.zoomFormat || "",
      zoomWidth: el.dataset.zoomWidth || "",
      zoomHeight: el.dataset.zoomHeight || "",
      imageAlt: el.dataset.alt || "",
      maxHeight: el.dataset.maxHeight || "",
      maxWidth: el.dataset.maxWidth || "",
      zoomOverlap: el.dataset.overlap || null,
      tileSize: el.dataset.tilesize || null
    };
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_ImageViewerModal.default, props), el);
  }
}

},{"./ImageViewerModal.jsx":114,"react":"react","react-dom":"react-dom"}],117:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inPageNavigation;
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _jquery = _interopRequireDefault(require("jquery"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function inPageNavigation() {
  const newLinks = document.querySelectorAll("#js-lesson-list .gv__lesson-navigation__link");
  const stickyNav = document.querySelector("#js-lesson-list")?.closest(".js-lesson-navigation");
  const lessoDropdownText = document.querySelector(".js-lesson-text");
  const isNewLessonPage = document.querySelector("#gv__main").classList.contains("gv__base-template--lesson-3");
  const lessonDropdownName = lessoDropdownText?.querySelector(".js-lesson-name");
  const lessonDropdownNumber = lessoDropdownText?.querySelector(".js-lesson-number");
  function updateDropdownText(linkData) {
    if (!linkData.querySelector(".js-in-page-lesson-name") || !linkData.querySelector(".js-in-page-lesson-number") || !linkData) return;
    if (linkData.classList.contains("gv__lesson-navigation__link-first")) {
      lessoDropdownText.closest(".gv__lesson-navigation__menu").classList.add("first");
    } else {
      lessoDropdownText.closest(".gv__lesson-navigation__menu").classList.remove("first");
    }
    lessonDropdownName.textContent = linkData.querySelector(".js-in-page-lesson-name").textContent;
    lessonDropdownNumber.textContent = linkData.querySelector(".js-in-page-lesson-number").textContent;
  }
  newLinks.forEach((newLink, index) => {
    /* New Lesson Nav functionality */
    newLink.addEventListener("click", e => {
      document.querySelector("#js-lesson-list").classList.remove("is-open");
      stickyNav.classList.remove("is-open");
    });
  });
  const links = [...document.querySelectorAll(".js-in-page-nav-link")];
  //   .filter(
  //   link => getComputedStyle(link).display !== "none"
  // );

  const targets = [];
  if (links.length === 0) {
    return false;
  }
  let offsetNumber = 130;
  const windowWidth = window.matchMedia("(max-width: 970px)");
  if (windowWidth.matches) {
    // If media query matches
    offsetNumber = 460;
  } else {
    offsetNumber = 130;
  }
  function updateOffset(windowWidth) {
    if (windowWidth.matches) {
      // If media query matches
      offsetNumber = 460;
    } else {
      offsetNumber = 130;
    }
  }

  // Attach listener function on state changes
  windowWidth.addEventListener("change", function () {
    updateOffset(windowWidth);
  });
  function scrollToTarget(offsetVal, targetVal) {
    (0, _jquery.default)("html,body").animate({
      scrollTop: offsetVal
    }, 500, function () {
      targetVal.focus();
      window.location.hash = targetVal.id;
      window.scrollTo(0, offsetVal);
    });
  }
  if (window.location.hash) {
    const initialScrollTarget = document.querySelector(window.location.hash);
    initialScrollTarget.scrollIntoView({
      behavior: "smooth"
    });
  }
  [...links].forEach((link, index) => {
    const target = document.querySelector(link.getAttribute("href"));
    if (target) {
      target.dataset.index = index;
      targets.push(target);
      link.addEventListener("click", e => {
        e.preventDefault();
        const isFirstLink = link.classList.contains("gv__lesson-navigation__link-first") ? true : false;
        const stickyOffset = e.target.closest(".js-is-sticky-mobile");
        const stickyOffsetHeight = stickyOffset ? stickyOffset.offsetHeight : 0;

        // find the offset to the targets
        const offsetCalc = getOffset(target).top - stickyOffsetHeight - offsetNumber;
        const offset = isFirstLink ? 0 : offsetCalc; // removing a little so it's not at the top of the page

        // manually move the active
        links[activeLink].classList.add("is-active");
        links[activeLink].setAttribute("aria-current", true);
        if (isNewLessonPage) {
          updateDropdownText(links[activeLink]);
        }
        (0, _jquery.default)("body").addClass("is-scrolling");
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        }, () => {
          target.focus();
          window.location.hash = target.id;
          // window.scrollTo(0, offset);
        });
        (0, _jquery.default)("body").addClass("is-scrolling");
        scrollToTarget(offset, target);
      });
    }
  });
  let activeLink = 0;
  links[activeLink].classList.add("is-active");
  links[activeLink].setAttribute("aria-current", true);
  if (isNewLessonPage) {
    updateDropdownText(links[activeLink]);
  }
  handleScroll();
  window.addEventListener("scroll", (0, _lodash.default)(handleScroll, 500));
  function handleScroll() {
    if (!(0, _jquery.default)("body").hasClass("is-scrolling")) {
      targets.forEach(target => {
        const rect = target.getBoundingClientRect();
        const percentage = getPercentageVisible(rect);
        const isScrolledHalfway = rect.top < window.innerHeight / 2;
        const targetIndex = target.dataset.index;
        if (percentage > 0.1 && isScrolledHalfway && targetIndex !== activeLink) {
          const isMobileNavOpen = document.querySelector(".gv__lesson-navigation__items")?.classList.contains("is-open") ? true : false;
          if (!isMobileNavOpen) {
            document.querySelector(".js-in-page-nav-link.is-active").setAttribute("aria-current", false);
            document.querySelector(".js-in-page-nav-link.is-active").classList.remove("is-active");
            activeLink = targetIndex;
            links[activeLink].classList.add("is-active");
            links[activeLink].setAttribute("aria-current", "true");
          }
          if (isNewLessonPage && !isMobileNavOpen) {
            updateDropdownText(links[activeLink]);
          }
        }
      });
    }
    (0, _jquery.default)("body").removeClass("is-scrolling");
  }
  function getPercentageVisible(sectionRect) {
    const {
      top,
      bottom,
      height
    } = sectionRect;
    const hiddenBefore = Math.abs(Math.min(0, top));
    const hiddenAfter = Math.max(0, bottom - window.innerHeight);
    const percentage = Math.max(0, (height - hiddenBefore - hiddenAfter) / height);
    return percentage;
  }
  function getOffset(el) {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft
    };
  }
}

},{"jquery":"jquery","lodash.throttle":"lodash.throttle"}],118:[function(require,module,exports){
"use strict";

require("./polyfill");
var _jquery = _interopRequireDefault(require("jquery"));
var _globalHeader = _interopRequireDefault(require("./global-header/global-header.js"));
var _courseTimeline = _interopRequireDefault(require("./course-timeline/course-timeline.js"));
var _accordion = _interopRequireDefault(require("./accordion.js"));
var _videoKeyIdeasAccordion = _interopRequireDefault(require("./video-key-ideas-accordion.js"));
var _archivePeriod = _interopRequireDefault(require("./archive-period/archive-period.js"));
var _unarchivePeriod = _interopRequireDefault(require("./unarchive-period/unarchive-period.js"));
var _forms = _interopRequireDefault(require("./forms.js"));
var _classFieldset = _interopRequireDefault(require("./class-fieldset.js"));
var _classList = _interopRequireDefault(require("./class-list/class-list.js"));
var _teacherCourseListing = _interopRequireDefault(require("./teacher-course-listing/teacher-course-listing.js"));
var _communityDrawer = _interopRequireDefault(require("./community-drawer/community-drawer"));
var _communityDrawer2 = _interopRequireDefault(require("./community-drawer-legacy/community-drawer"));
var _copy = _interopRequireDefault(require("./copy/copy.js"));
var _editStudent = _interopRequireDefault(require("./edit-student/edit-student.js"));
var _editTeacherImage = _interopRequireDefault(require("./edit-teacher-image/edit-teacher-image.js"));
var _dashboardTabs = _interopRequireDefault(require("./dashboard-tabs/dashboard-tabs.js"));
var _loadingOverlay = _interopRequireDefault(require("./loading-overlay.js"));
var _learningWebinars = _interopRequireDefault(require("./professional-learning-webinars/learning-webinars.js"));
var _linkArea = _interopRequireDefault(require("./link-area.js"));
var _stickyTopNav = _interopRequireDefault(require("./sticky-top-nav.js"));
var _stickyNav = require("./sticky-nav.js");
var _simpleImageSlider = _interopRequireDefault(require("./simple-image-slider.js"));
var _simpleSlider = _interopRequireDefault(require("./simple-slider.js"));
var _materialCard = _interopRequireDefault(require("./material-card.js"));
var _eventListing = _interopRequireDefault(require("./event-listing.js"));
var _downloadInteraction = _interopRequireDefault(require("./download-interaction/download-interaction.js"));
var _shareInteraction = _interopRequireDefault(require("./share-interaction/share-interaction.js"));
var _shareInteractionModal = _interopRequireDefault(require("./share-interaction-modal/share-interaction-modal.js"));
var _teacherResourcesModal = _interopRequireDefault(require("./teacher-resources-display/teacher-resources-modal.js"));
var _downloadInteractionModal = _interopRequireDefault(require("./download-interaction-modal/download-interaction-modal.js"));
var _addCoTeacher = _interopRequireDefault(require("./add-co-teacher/add-co-teacher.js"));
var _searchResults = _interopRequireDefault(require("./search-components/search-results/search-results.js"));
var _resourceSearch = _interopRequireDefault(require("./search-components/resource-search/resource-search.jsx"));
var _inviteStudents = _interopRequireDefault(require("./invite-students/invite-students.js"));
var _dropdownMenu = _interopRequireDefault(require("./dropdown-menu.js"));
var _editPeriod = _interopRequireDefault(require("./edit-period/edit-period.js"));
var _showPassword = _interopRequireDefault(require("./showPassword.js"));
var _imageViewerModal = _interopRequireDefault(require("./image-viewer-modal/image-viewer-modal.js"));
var _assignmentPage = _interopRequireDefault(require("./assignment-detail-page/assignment-page.js"));
var _privacyPolicyModal = _interopRequireDefault(require("./privacy-policy-modal/privacy-policy-modal.js"));
var _studentDetails = _interopRequireDefault(require("./student-details/student-details.js"));
var _pdfViewer = _interopRequireDefault(require("./pdf-viewer.js"));
var _articleViewer = _interopRequireDefault(require("./article-viewer.js"));
var _video = _interopRequireDefault(require("./video.js"));
var _progressBar = _interopRequireDefault(require("./progress-bar.js"));
var _printRoster = _interopRequireDefault(require("./print-roster.js"));
var _dismissAlert = _interopRequireDefault(require("./dismissAlert.js"));
var _report = _interopRequireDefault(require("./report.js"));
var _quiz = _interopRequireDefault(require("./quiz/quiz.js"));
var _enterStudentMode = _interopRequireDefault(require("./enter-student-mode/enter-student-mode.js"));
var _exitStudentMode = _interopRequireDefault(require("./exit-student-mode.js"));
var _updateUrl = _interopRequireDefault(require("./update-url.js"));
var _vocabModal = _interopRequireDefault(require("./vocab-modal/vocab-modal.js"));
var _upcomingEvents = _interopRequireDefault(require("./upcoming-events/upcoming-events.js"));
var _registeredEvents = _interopRequireDefault(require("./registered-events/registered-events.js"));
var _initPersonalizedTabs = _interopRequireDefault(require("./initPersonalizedTabs.js"));
var _onDemandCourses = _interopRequireDefault(require("./on-demand-courses/on-demand-courses.js"));
var _suggestedCourses = _interopRequireDefault(require("./suggested-courses/suggested-courses.js"));
var _newsletterForm = _interopRequireDefault(require("./newsletter-form.js"));
var _canvasHeader = _interopRequireDefault(require("./canvas-header/canvas-header.js"));
var _canvasPreview = _interopRequireDefault(require("./canvas-preview/canvas-preview.js"));
var _canvasSearchResults = _interopRequireDefault(require("./canvas-search-results/canvas-search-results.js"));
var _inPageNavigation = _interopRequireDefault(require("./inPageNavigation.js"));
var _openCloseButton = _interopRequireDefault(require("./openCloseButton.js"));
var _lessonNavigation = _interopRequireDefault(require("./lessonNavigation.js"));
var _unitNavigation = _interopRequireDefault(require("./unitNavigation.js"));
var _hoverColorUpdates = _interopRequireDefault(require("./hoverColorUpdates.js"));
var _cardInteraction = _interopRequireDefault(require("./cardInteraction.js"));
var _sessionTracking = _interopRequireDefault(require("./sessionTracking"));
var _GDPRBanner = _interopRequireDefault(require("./GDPRBanner.js"));
var _editTeacherHeader = _interopRequireDefault(require("./editTeacherHeader"));
var _handleModalScroll = _interopRequireDefault(require("./handleModalScroll.js"));
var _scrollDetection = _interopRequireDefault(require("./scroll-detection.js"));
var _scrollDown = _interopRequireDefault(require("./scroll-down.js"));
var _manualCourseListing = _interopRequireDefault(require("./manual-course-listing.js"));
var _backHistory = _interopRequireDefault(require("./backHistory.js"));
var _imageCarousel = _interopRequireDefault(require("./image-carousel/image-carousel.js"));
var _materialItemPromo = _interopRequireDefault(require("./materialItemPromo.js"));
var _featuredCardsAction = _interopRequireDefault(require("./featuredCardsAction.js"));
var _backButton = _interopRequireDefault(require("./backButton.js"));
var _accordionCopy = _interopRequireDefault(require("./accordion-copy"));
var _manualModal = _interopRequireDefault(require("./manualModal.js"));
var _setModalCookie = _interopRequireDefault(require("./setModalCookie.js"));
var _assignmentsTab = _interopRequireDefault(require("./assignments-tab/assignments-tab.js"));
var _assignmentsModal = _interopRequireDefault(require("./assignments-tab/assignments-modal.js"));
var _setTooltip = _interopRequireDefault(require("./set-tooltip.js"));
var _hideTeachingTools = _interopRequireDefault(require("./hide-teaching-tools.js"));
var _closePromoCarousel = _interopRequireDefault(require("./closePromoCarousel.js"));
var _toastNotification = _interopRequireDefault(require("./toast-notification.js"));
var _vocabButton = _interopRequireDefault(require("./vocab/vocab-button.js"));
var _canvasSearch = _interopRequireDefault(require("./search-components/canvas-search/canvas-search.js"));
var _teacherRegistration = _interopRequireDefault(require("./teacher-registration/teacher-registration"));
var _teacherResouce = _interopRequireDefault(require("./teacher-resource/teacher-resouce.js"));
var _scrollToLinks = _interopRequireDefault(require("./scrollToLinks.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import SearchResults from "./search-results/search-results.js";

//import TeacherRegistrationForms from "./teacher-registration/form-actions.js";

// For testing loading react partial
// import Loading from "./loading-test.js";

(0, _accordion.default)(document, window);
(0, _videoKeyIdeasAccordion.default)(document, window);
(0, _simpleSlider.default)(document, window);
(0, _dropdownMenu.default)(document, window);
(0, _forms.default)(document, window);
(0, _newsletterForm.default)(document, window);
(0, _showPassword.default)(document, window);
//TeacherRegistrationForms(document, window);
(0, _classFieldset.default)(document, window);
(0, _GDPRBanner.default)(document, window);
(0, _editTeacherHeader.default)(document, window);
(0, _eventListing.default)(document, window);
(0, _materialCard.default)(document, window);
(0, _showPassword.default)(document, window);
(0, _progressBar.default)(document, window);
(0, _dismissAlert.default)(document, window);
(0, _printRoster.default)(document, window);
(0, _exitStudentMode.default)(document, window);
(0, _report.default)(document, window);
(0, _simpleImageSlider.default)(document, window);
(0, _linkArea.default)(document, window);
(0, _sessionTracking.default)(document, window);
(0, _openCloseButton.default)(document, window);
(0, _lessonNavigation.default)(document, window);
(0, _unitNavigation.default)(document, window);
(0, _hoverColorUpdates.default)(document, window);
(0, _cardInteraction.default)(document, window);
(0, _video.default)(document, window);
(0, _manualModal.default)(document, window);
(0, _handleModalScroll.default)(document, window);
(0, _pdfViewer.default)(document, window);
(0, _articleViewer.default)(document, window);
(0, _materialItemPromo.default)(document, window);
(0, _backButton.default)(document, window);
(0, _featuredCardsAction.default)(document, window);
(0, _stickyTopNav.default)(document, window);
(0, _updateUrl.default)(document, window);
(0, _hideTeachingTools.default)(document, window);
(0, _scrollDetection.default)(document, window);
(0, _scrollDown.default)(document, window);
(0, _manualCourseListing.default)(document, window);
(0, _closePromoCarousel.default)(document, window);
(0, _toastNotification.default)(document, window);
(0, _backHistory.default)(document, window);
(0, _imageViewerModal.default)(document, window);
(0, _imageCarousel.default)();
(0, _accordionCopy.default)();

// stickyNav(document, window);
document.addEventListener("DOMContentLoaded", event => {
  [...document.querySelectorAll(".js-session__sticky-nav")].forEach(_stickyNav.stickyNav);
  [...document.querySelectorAll(".js__base-template__sticky-nav")].forEach(_stickyNav.stickyNav);
  (0, _initPersonalizedTabs.default)();
  (0, _inPageNavigation.default)();
});

},{"./GDPRBanner.js":2,"./accordion-copy":3,"./accordion.js":4,"./add-co-teacher/add-co-teacher.js":6,"./archive-period/archive-period.js":8,"./article-viewer.js":9,"./assignment-detail-page/assignment-page.js":12,"./assignments-tab/assignments-modal.js":22,"./assignments-tab/assignments-tab.js":23,"./backButton.js":27,"./backHistory.js":28,"./canvas-header/canvas-header.js":30,"./canvas-preview/canvas-preview.js":32,"./canvas-search-results/canvas-search-results.js":35,"./cardInteraction.js":36,"./class-fieldset.js":39,"./class-list/class-list.js":41,"./closePromoCarousel.js":44,"./community-drawer-legacy/community-drawer":47,"./community-drawer/community-drawer":52,"./copy/copy.js":54,"./course-timeline/course-timeline.js":61,"./dashboard-tabs/dashboard-tabs.js":64,"./dismissAlert.js":65,"./download-interaction-modal/download-interaction-modal.js":71,"./download-interaction/download-interaction.js":73,"./dropdown-menu.js":74,"./edit-period/edit-period.js":76,"./edit-student/edit-student.js":80,"./edit-teacher-image/edit-teacher-image.js":82,"./editTeacherHeader":83,"./enter-student-mode/enter-student-mode.js":85,"./event-listing.js":86,"./exit-student-mode.js":87,"./featuredCardsAction.js":88,"./forms.js":89,"./global-header/global-header.js":102,"./handleModalScroll.js":109,"./hide-teaching-tools.js":111,"./hoverColorUpdates.js":112,"./image-carousel/image-carousel.js":113,"./image-viewer-modal/image-viewer-modal.js":116,"./inPageNavigation.js":117,"./initPersonalizedTabs.js":119,"./invite-students/invite-students.js":121,"./lessonNavigation.js":123,"./link-area.js":124,"./loading-overlay.js":125,"./manual-course-listing.js":126,"./manualModal.js":127,"./material-card.js":128,"./materialItemPromo.js":129,"./newsletter-form.js":130,"./on-demand-courses/on-demand-courses.js":132,"./openCloseButton.js":133,"./pdf-viewer.js":158,"./polyfill":159,"./print-roster.js":160,"./privacy-policy-modal/privacy-policy-modal.js":162,"./professional-learning-webinars/learning-webinars.js":166,"./progress-bar.js":167,"./quiz/quiz.js":170,"./registered-events/registered-events.js":174,"./report.js":175,"./scroll-detection.js":176,"./scroll-down.js":177,"./scrollToLinks.js":178,"./search-components/canvas-search/canvas-search.js":181,"./search-components/resource-search/resource-search.jsx":190,"./search-components/search-results/search-results.js":195,"./sessionTracking":197,"./set-tooltip.js":198,"./setModalCookie.js":199,"./share-interaction-modal/share-interaction-modal.js":212,"./share-interaction/share-interaction.js":214,"./showPassword.js":215,"./simple-image-slider.js":216,"./simple-slider.js":217,"./sticky-nav.js":218,"./sticky-top-nav.js":219,"./student-details/student-details.js":223,"./suggested-courses/suggested-courses.js":226,"./teacher-course-listing/teacher-course-listing.js":230,"./teacher-registration/teacher-registration":245,"./teacher-resource/teacher-resouce.js":250,"./teacher-resources-display/teacher-resources-modal.js":252,"./toast-notification.js":253,"./unarchive-period/unarchive-period.js":255,"./unitNavigation.js":256,"./upcoming-events/upcoming-events.js":259,"./update-url.js":260,"./video-key-ideas-accordion.js":263,"./video.js":265,"./vocab-modal/vocab-modal.js":268,"./vocab/vocab-button.js":270,"jquery":"jquery"}],119:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = () => {
  const isSelectedClass = "is-selected";
  document.querySelectorAll(".js-personalized-header").forEach((el, appIndex) => {
    const elTabList = el.querySelector(".js-personalized-header-controls");
    const elPanels = el.querySelectorAll(".js-personalized-header-panel");
    const elTabs = el.querySelectorAll(".js-personalized-header-tab");
    const parentIndex = appIndex + 1 * 100;
    const tabButtonSelector = ".js-personalized-header-tab-button";
    let currentTab = 0;

    // initialize tabs and panels
    elTabs.forEach(initTab);
    elPanels.forEach(initPanel);
    showThisTab(currentTab, false);
    elTabList.addEventListener("keydown", handleKeyPress);
    function changeTab(newTab) {
      let moveFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (newTab === currentTab) {
        return;
      }
      hideCurrentTab(currentTab, moveFocus);
      showThisTab(newTab, moveFocus);
    }
    function hideCurrentTab(tabIndex) {
      // reset currently selected Tab aria-selected and classes
      const activeTab = elTabs[tabIndex];
      activeTab.classList.remove(isSelectedClass);
      const activeTabButton = activeTab.querySelector(tabButtonSelector);
      activeTabButton.setAttribute("aria-selected", false);
      activeTabButton.setAttribute("tabindex", -1);
      // reset currently selected Panel classes
      const panel = elPanels[tabIndex];
      panel.classList.remove(isSelectedClass);
      panel.setAttribute("aria-hidden", true);
      panel.setAttribute("tabindex", -1);
    }
    function showThisTab(tabIndex) {
      let moveFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // set this Tab's aria-selected and classes
      elTabs[tabIndex].classList.add(isSelectedClass);
      const button = elTabs[tabIndex].querySelector(tabButtonSelector);
      button.setAttribute("aria-selected", true);
      button.setAttribute("tabindex", 0);
      if (moveFocus) {
        button.focus();
      }
      // set this Tab's panel class
      const panel = elPanels[tabIndex];
      panel.classList.add(isSelectedClass);
      panel.removeAttribute("aria-hidden");
      panel.setAttribute("tabindex", 0);
      currentTab = tabIndex;
    }
    function handleKeyPress(event, index) {
      switch (event.key) {
        case "Left":
        case "ArrowLeft":
          event.preventDefault();
          if (currentTab === 0) {
            changeTab(elTabs.length - 1);
          } else {
            changeTab(currentTab - 1);
          }
          break;
        case "Right":
        case "ArrowRight":
          event.preventDefault();
          if (currentTab === elTabs.length - 1) {
            changeTab(0);
          } else {
            changeTab(currentTab + 1);
          }
          break;
        default:
      }
    }
    function initPanel(panel, i) {
      // add ids and aria roles to panel
      // panel.setAttribute("aria-labelledby", `tab-button-${parentIndex + i}`);
      panel.setAttribute("id", `tab-content-panel-${parentIndex + i}`);
      panel.setAttribute("tabindex", -1);
      panel.setAttribute("aria-hidden", true);
    }
    function initTab(tab, i) {
      // add ids and aria roles to button
      const button = tab.querySelector(tabButtonSelector);
      // button.setAttribute("id", `tab-button-${parentIndex + i}`);
      button.setAttribute("aria-selected", false);
      button.setAttribute("tabindex", -1);
      button.setAttribute("aria-controls", `tab-content-panel-${parentIndex + i}`);
      // move all the tab to the tablist element
      elTabList.append(tab);

      // add event listeners to tab
      button.addEventListener("click", () => {
        if (currentTab !== i) {
          changeTab(i);
        }
      });
    }
  });
};
exports.default = _default;

},{}],120:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _Copy = _interopRequireDefault(require("../copy/Copy.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class InviteStudents extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const buttons = document.querySelectorAll(".js-invite-students__btn");
      if (buttons) {
        buttons.forEach(button => {
          button.addEventListener("click", this.openModal);
        });
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      const buttons = document.querySelectorAll(".js-invite-students__btn");
      if (buttons) {
        buttons.forEach(button => button.setAttribute("aria-expanded", false));
      }
    });
    _defineProperty(this, "openModal", e => {
      this.setState({
        modalIsOpen: true
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      const {
        newEmailInput
      } = this.state;
      newEmailInput.value = "";
      newEmailInput.error = false;
      newEmailInput.errorMsg = "";
      if (this.props.updateParent) {
        this.props.updateParent();
      }
      this.setState({
        modalIsOpen: false,
        urlCopied: false,
        newEmailInput
      });
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
    });
    this.state = {
      modalIsOpen: props.modalIsOpen,
      urlCopied: false,
      newEmailInput: {
        value: "",
        error: false,
        errorMsg: ""
      }
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      dictionary,
      classCode
    } = this.props;
    const {
      inviteStudentSubtitle,
      inviteStudentTitle,
      inviteStudentUrlLabel,
      inviteStudentClassCodeLabel,
      inviteStudentCopyLabel,
      inviteStudentUrl,
      inviteStudentUrlCopy,
      inviteStudentCopySuccess
    } = dictionary;
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      tabIndex: "-1",
      ref: this.modalTitleRef,
      className: "gv__invite-students__title gv__page-title"
    }, inviteStudentTitle), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students__subtitle",
      dangerouslySetInnerHTML: {
        __html: inviteStudentSubtitle
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students__class-info"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students__url"
    }, inviteStudentUrlLabel, ": ", /*#__PURE__*/_react.default.createElement("span", null, inviteStudentUrl)), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students__class-code"
    }, inviteStudentClassCodeLabel, ": ", /*#__PURE__*/_react.default.createElement("span", null, classCode)), /*#__PURE__*/_react.default.createElement(_Copy.default, {
      urlToCopy: `${inviteStudentUrlCopy}${classCode}`,
      copyText: inviteStudentCopyLabel,
      copySuccessText: inviteStudentCopySuccess,
      urlCopied: this.state.urlCopied
    }))));
  }
}
exports.default = InviteStudents;
_defineProperty(InviteStudents, "propTypes", {
  dictionary: _propTypes.object.isRequired,
  inviteStudentUrl: _propTypes.string,
  classCode: _propTypes.string,
  modalIsOpen: _propTypes.bool,
  updateParent: _propTypes.func
});

},{"../copy/Copy.jsx":53,"prop-types":"prop-types","react":"react","react-modal":"react-modal"}],121:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var R = _interopRequireWildcard(require("ramda"));
var _InviteStudents = _interopRequireDefault(require("./InviteStudents.jsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-invite-students-mount");
if (el) {
  const props = {
    dictionary: JSON.parse(el.dataset.dictionary) || "",
    classCode: el.dataset.classCode || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_InviteStudents.default, props), el);
}

},{"./InviteStudents.jsx":120,"ramda":"ramda","react":"react","react-dom":"react-dom"}],122:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _Copy = _interopRequireDefault(require("../copy/Copy.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class InviteStudents extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const buttons = document.querySelectorAll(".js-invite-students__btn");
      if (buttons) {
        buttons.forEach(button => {
          button.addEventListener("click", this.openModal);
        });
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      const buttons = document.querySelectorAll(".js-invite-students__btn");
      if (buttons) {
        buttons.forEach(button => button.setAttribute("aria-expanded", false));
      }
    });
    _defineProperty(this, "openModal", e => {
      this.setState({
        modalIsOpen: true
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      const {
        newEmailInput
      } = this.state;
      newEmailInput.value = "";
      newEmailInput.error = false;
      newEmailInput.errorMsg = "";
      if (this.props.updateParent) {
        this.props.updateParent();
      }
      this.setState({
        modalIsOpen: false,
        urlCopied: false,
        newEmailInput
      });
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
    });
    this.state = {
      modalIsOpen: props.modalIsOpen,
      urlCopied: false,
      newEmailInput: {
        value: "",
        error: false,
        errorMsg: ""
      }
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      dictionary,
      classCode
    } = this.props;
    const {
      inviteStudentSubtitle,
      inviteStudentTitle,
      inviteStudentUrlLabel,
      inviteStudentClassCodeLabel,
      inviteStudentCopyLabel,
      inviteStudentUrl,
      inviteStudentUrlCopy,
      inviteStudentCopySuccess
    } = dictionary;
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      tabIndex: "-1",
      ref: this.modalTitleRef,
      className: "gv__invite-students__title gv__page-title"
    }, inviteStudentTitle), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students__subtitle",
      dangerouslySetInnerHTML: {
        __html: inviteStudentSubtitle
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students__class-info"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students__url"
    }, inviteStudentUrlLabel, ": ", /*#__PURE__*/_react.default.createElement("span", null, inviteStudentUrl)), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__invite-students__class-code"
    }, inviteStudentClassCodeLabel, ": ", /*#__PURE__*/_react.default.createElement("span", null, classCode)), /*#__PURE__*/_react.default.createElement(_Copy.default, {
      urlToCopy: `${inviteStudentUrlCopy}${classCode}`,
      copyText: inviteStudentCopyLabel,
      copySuccessText: inviteStudentCopySuccess,
      urlCopied: this.state.urlCopied
    }))));
  }
}
exports.default = InviteStudents;
_defineProperty(InviteStudents, "propTypes", {
  dictionary: _propTypes.object.isRequired,
  inviteStudentUrl: _propTypes.string,
  classCode: _propTypes.string,
  modalIsOpen: _propTypes.bool,
  updateParent: _propTypes.func
});

},{"../copy/Copy.jsx":53,"prop-types":"prop-types","react":"react","react-modal":"react-modal"}],123:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lessonNavigation;
function lessonNavigation() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const toggleButton = document.querySelector(".js-open-close-button");
  const links = document.querySelectorAll(".js-in-page-nav-link");
  const toggleNavButton = document.querySelector(".js-toggle-lesson-navigation");
  const body = document.querySelector("body");
  const windowWidth = window.matchMedia("(max-width: 970px)");
  const addCloseNavAria = () => {
    if (lessonNav.classList.contains("close-nav")) {
      toggleNavButton.setAttribute("aria-expanded", "false");
    } else {
      toggleNavButton.setAttribute("aria-expanded", "true");
    }
  };
  /* This function is to hide/show the lesson left navigation on desktop */
  let lessonNav;
  if (toggleNavButton) {
    lessonNav = toggleNavButton.closest(".gv__lesson-navigation-3");
    toggleNavButton.addEventListener("click", e => {
      lessonNav.classList.toggle("close-nav");
      addCloseNavAria();
    });

    // when the window resizes/change oriantation we need to 
    // check if the close-nav class is on the lesson navigation
    window.addEventListener("resize", e => {
      if (windowWidth.matches && toggleNavButton) {
        lessonNav.classList.remove("close-nav");
        addCloseNavAria();
      }
    });
  }

  /* The following is for the mobile nav functionality*/
  if (!toggleButton) {
    return;
  }
  [...links].forEach((link, index) => {
    link.addEventListener("click", e => {
      e.preventDefault();
      const href = link.getAttribute("href");
      const removeClasses = () => {
        if (windowWidth.matches) {
          body.classList.remove("side-nav-open");
          document.querySelector(".js-lesson-navigation").classList.remove("is-open");
          document.querySelector("#js-lesson-list").classList.remove("is-open");
          toggleButton.setAttribute("aria-expanded", "false");
        }
      };
      if (link.classList.contains("is-active")) {
        toggleButton.click();
        removeClasses();
      } else {
        removeClasses();
        document.querySelector(href) && document.querySelector(href).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start"
        });
      }
    });
  });
}

},{}],124:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.initLinkArea = void 0;
const initLinkArea = el => {
  const getLinkEl = () => {
    if (el.classList.contains("gv__course-card__image")) {
      const courseCard = el.parentNode.parentNode;
      return courseCard.querySelector(".js-link-src");
    } else {
      return el.querySelector(".js-link-src");
    }
  };
  const linkEl = getLinkEl();
  if (linkEl) {
    const link = linkEl.getAttribute("href");
    const target = linkEl.getAttribute("target");
    el.addEventListener("click", () => {
      if (target === null) {
        window.location = link;
      }
    });
  }
};
exports.initLinkArea = initLinkArea;
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-link-area")].forEach(initLinkArea);
}

},{}],125:[function(require,module,exports){
"use strict";

var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const el = document.createElement("div");
el.classList.add("gv__loading-overlay");
document.querySelector("body").append(el);
class App extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleAnimation", e => {
      const animationTarget = document.querySelectorAll(".gv__loading-overlay__cube");
      animationTarget.forEach(x => {
        let playState;
        const isWebKit = x.style.webkitAnimationPlayState ? true : false;
        if (isWebKit) {
          playState = x.style.webkitAnimationPlayState;
        } else {
          playState = x.style.animationPlayState;
        }
        if (playState === "paused") {
          if (isWebKit) {
            x.style.webkitAnimationPlayState = "running";
          } else {
            x.style.animationPlayState = "running";
          }
        } else {
          if (isWebKit) {
            x.style.webkitAnimationPlayState = "paused";
          } else {
            x.style.animationPlayState = "paused";
          }
        }
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube-grid"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "gv__loading-overlay__pause",
      onClick: e => this.toggleAnimation(e)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__visuallyhidden"
    }, "Pause Animation")), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube gv__loading-overlay__cube--1"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube gv__loading-overlay__cube--2"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube gv__loading-overlay__cube--3"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube gv__loading-overlay__cube--4"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube gv__loading-overlay__cube--5"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube gv__loading-overlay__cube--6"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube gv__loading-overlay__cube--7"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube gv__loading-overlay__cube--8"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__loading-overlay__cube gv__loading-cube--9"
    }));
  }
}
window.showLoadingOverlay = () => {
  el.classList.add("is-visible");
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(App, null), el);
};
window.hideLoadingOverlay = () => {
  el.classList.remove("is-visible");
};

},{"react":"react","react-dom":"react-dom"}],126:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _lodash = _interopRequireDefault(require("lodash.debounce"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const initManualCourseListing = (el, i) => {
    const cardContainerEl = el.querySelector(".js-manual-course-listing-cards");
    const setOffset = (selector, itemIndex) => {
      if (cardContainerEl && cardContainerEl.children[itemIndex]) {
        const offsetEl = cardContainerEl.children[itemIndex].querySelector(selector);
        const getTotalOffset = function (parentEl, childEl) {
          let offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          if (parentEl === childEl) {
            return offset;
          } else {
            offset += childEl.offsetTop;
            return getTotalOffset(parentEl, childEl.offsetParent, offset);
          }
        };
        cardContainerEl.style.setProperty("--mcl-bg-offset", `${getTotalOffset(cardContainerEl, offsetEl)}px`);
      }
    };
    setOffset(".gv__ribbon", 1);
    window.addEventListener("resize", () => {
      if (window.innerWidth <= 780) {
        (0, _lodash.default)(() => setOffset(".gv__ribbon", 1), 10);
      }
    });
  };
  if (document.querySelector("body.experience-editor") === null) {
    [...document.querySelectorAll(".js-manual-course-listing")].forEach(initManualCourseListing);
  }
}

},{"lodash.debounce":"lodash.debounce"}],127:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.initModalListener = void 0;
var _setModalCookie = require("./setModalCookie.js");
const bodyClass = "gv__manual-modal__open";
const closeClass = "js-close-manual-modal";
const clearFormClass = "js-clear-inner-form";
const noCloseClass = "js-no-close";
const toggleModal = (e, el) => {
  e.preventDefault();
  e.stopPropagation();
  const button = e.target;
  const modalId = el.dataset.modal;
  const expanded = el.getAttribute("aria-expanded") === "true";
  const modal = document.querySelector(`#${modalId}`);
  if (expanded) {
    closeModal(modal, el);
  } else {
    openModal(modal, button, el);
  }
};
const closeModal = (modal, triggerButton) => {
  const innerForm = modal.querySelectorAll(`.${clearFormClass}`);
  const closeButton = modal.querySelectorAll(`.${closeClass}`);
  var iframe = modal.querySelector('iframe');
  //this forces videos within an iframe to pause
  if (iframe) {
    var iframeSrc = iframe.src;
    iframe.src = iframeSrc;
  }
  if (triggerButton.classList.contains('js-manual-modal-v2')) {
    // Check if the element right before triggerButton is the overlay div
    const overlayDiv = triggerButton.previousElementSibling;
    if (overlayDiv && overlayDiv.classList.contains('gv__manual-modal__overlay')) {
      // Remove the overlay div from the DOM
      overlayDiv.remove();
    }
  }
  if (innerForm && innerForm.length) innerForm.forEach(el => el.reset());
  document.querySelector("body").classList.remove(bodyClass);
  document.querySelector("html").classList.remove(bodyClass);
  triggerButton && triggerButton.setAttribute("aria-expanded", false);
  modal.classList.remove("is-open");
  closeButton && closeButton.forEach(el => {
    el.removeEventListener("click", e => toggleModal(e, triggerButton));
  });
  //triggerButton && triggerButton.focus();
  const shouldSetCookie = modal.classList.contains("js-set-cookie");
  if (shouldSetCookie) {
    (0, _setModalCookie.setCookie)(modal);
  }
};
const linkListener = modal => {
  const allLinks = modal.querySelectorAll("a");
  allLinks.forEach(link => link.addEventListener("click", () => (0, _setModalCookie.setCookie)(modal)));
};
const openModal = (modal, button, triggerButton) => {
  const allFocus = modal.querySelectorAll("input, textarea, a, button");
  const shouldSetCookie = modal.classList.contains("js-set-cookie");
  const closeButton = modal.querySelectorAll(`.${closeClass}`);
  const noClose = modal.classList.contains(noCloseClass);
  document.querySelector("body").classList.add(bodyClass);
  document.querySelector("html").classList.add(bodyClass);

  /* For 3.0 pages the overlay needs to be added and removed, as this initially was not built for mutliple overlays needed on one pages
    So no need to initially have a div with the overlay class, the triggerButton just needs the class js-manual-modal-v2
  */
  if (triggerButton.classList.contains('js-manual-modal-v2')) {
    // Create a new div element
    const overlayDiv = document.createElement('div');
    overlayDiv.className = 'gv__manual-modal__overlay';

    // Insert the div right before the triggerButton
    triggerButton.insertAdjacentElement('beforebegin', overlayDiv);
  }
  triggerButton && triggerButton.setAttribute("aria-expanded", true);
  modal.classList.add("is-open");
  modal.focus();
  if (triggerButton.classList.contains("js-has-iframe")) {
    const sourceURL = modal.querySelector('iframe').getAttribute('data-src');
    modal.querySelector('iframe').setAttribute('src', sourceURL);
  }
  closeButton && closeButton.forEach(el => {
    el.addEventListener("click", e => closeModal(modal, triggerButton));
  });
  !noClose && document.querySelectorAll(".gv__manual-modal__overlay").forEach(overlayButton => {
    overlayButton.addEventListener("click", e => {
      closeModal(modal, triggerButton);
    });
  });
  focusTrap(allFocus, modal);
  const escapeListener = e => {
    if (e.key === "Escape") {
      if (button && triggerButton) {
        closeModal(modal, button, triggerButton);
      } else {
        closeModal(modal);
      }
    }
  };
  if (shouldSetCookie) {
    linkListener(modal);
  }
  !noClose && modal.addEventListener("keyup", escapeListener);
};
const focusTrap = (allFocus, modal) => {
  const firstFocusable = allFocus[0];
  const lastFocusable = allFocus[allFocus.length - 1];
  // allFocus.forEach(x => x.addEventListener("keyup", e => resetFocus(e)));
  modal.addEventListener("keydown", e => resetFocus(e));
  const resetFocus = e => {
    if (e.shiftKey && e.keyCode == 9) {
      if (e.target === firstFocusable || e.target == modal) {
        e.preventDefault();
        lastFocusable.focus();
      }
    } else if (e.key == "Tab" && e.target === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }
  };
};
const initModalListener = el => {
  el.addEventListener("click", e => toggleModal(e, el));
};
exports.initModalListener = initModalListener;
const initModal = el => {
  openModal(el);
};
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  document.querySelectorAll(".js-manual-modal-toggle") && [...document.querySelectorAll(".js-manual-modal-toggle")].forEach(initModalListener);
  document.querySelectorAll(".js-launch-modal") && [...document.querySelectorAll(".js-launch-modal")].forEach(initModal);
}

},{"./setModalCookie.js":199}],128:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const initMaterialCard = (el, i) => {
    const triggers = el.querySelectorAll(".js-material-card-trigger");
    const target = el.querySelector(".js-material-card-target");
    if (triggers.length > 0) {
      [...triggers].forEach(x => x.addEventListener("click", e => {
        e.preventDefault();
        const linkLocation = target.getAttribute("href");
        const linkTarget = target.getAttribute("target");
        if (linkTarget === "_blank") {
          window.open(linkLocation);
        } else {
          window.location = linkLocation;
        }
      }));
    }
  };
  if (document.querySelector("body.experience-editor") === null) {
    [...document.querySelectorAll(".js-material-card")].forEach(initMaterialCard);
  }
}

},{}],129:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = materialItemPromo;
function materialItemPromo(document, window) {
  document.querySelectorAll(".js-gv__material-item-card__container").forEach((el, index) => {
    const trigger = el;
    const target = el.querySelector(".js-material-item-target");
    el.addEventListener("click", e => {
      e.preventDefault();
      const linkLocation = target.getAttribute("href");
      const linkTarget = target.getAttribute("target");
      if (linkTarget === "_blank") {
        window.open(linkLocation);
      } else {
        window.location = linkLocation;
      }
    });
  });
}

},{}],130:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _validation = require("./validation.js");
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-form.js-newsletter-form")].forEach(elForm => {
    const elItems = elForm.querySelectorAll(".js-form-required");
    const newsletterEmail = elForm.querySelector("#email");
    const newsletterFormSubmit = elForm.querySelector(".js-newsletter-form-submit");
    const newsletterError = elForm.closest(".js-response-messages").getAttribute("data-error-message");
    const newsletterSuccess = elForm.closest(".js-response-messages").getAttribute("data-success-message");
    const newsletterResponseDiv = elForm.querySelector(".js-newsletter-response-output");
    const newslatterFormInputConatiner = elForm.querySelector(".js-newsletter-form-toggle");
    const fetchURL = elForm.getAttribute("action");
    const submitNewsletterForm = () => {
      let formData = new FormData();
      const antiForgeryInput = elForm.querySelector('input[name=__RequestVerificationToken]');
      const antiForgeryToken = antiForgeryInput ? antiForgeryInput.value : "";
      formData.append('__RequestVerificationToken', antiForgeryToken);
      const emailInput = elForm.querySelector('input[name=email]');
      const emailValue = emailInput ? emailInput.value : "";
      formData.append('email', emailValue.trim());
      fetch(`${fetchURL}`, {
        method: "POST",
        body: formData,
        credentials: "same-origin"
      }).then(response => response.json()).then(data => {
        if (data.success === true) {
          newslatterFormInputConatiner.classList.add("hide");
          newsletterResponseDiv.classList.add("show-success");
          newsletterResponseDiv.textContent = newsletterSuccess;
          newsletterFormSubmit.removeAttribute("disabled");
        } else {
          newslatterFormInputConatiner.classList.add("hide");
          newsletterResponseDiv.classList.add("show-error");
          newsletterResponseDiv.textContent = newsletterError;
          newsletterFormSubmit.removeAttribute("disabled");
        }
      }).catch(error => {
        console.log(error);
      });
    };

    /* Success and Error handlers do not do much but are needed for FE validation from validation.js*/
    const successHandler = () => {
      newsletterFormSubmit.classList.add("success");
    };
    const errorHandler = () => {
      newsletterFormSubmit.classList.add("error");
    };
    newsletterFormSubmit.addEventListener("click", e => {
      e.preventDefault();
      (0, _validation.handleSubmit)(elForm, successHandler, errorHandler);
      if ((0, _validation.handleSubmit)(elForm, successHandler, errorHandler)) {
        newsletterFormSubmit.setAttribute("disabled", true);
        submitNewsletterForm();
      }
    });

    //form field validation
    [...elItems].forEach(item => {
      (0, _validation.validationListeners)(item, elForm);
    });
  });
}

},{"./validation.js":262}],131:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  courses: (0, _propTypes.shape)({
    onDemandCourseHeaders: (0, _propTypes.shape)({
      onDemandTitleText: _propTypes.string,
      column1Header: _propTypes.string,
      column2Header: _propTypes.string,
      column3Header: _propTypes.string
    }),
    endpoint: _propTypes.string
  })
};
const OnDemandCourses = props => {
  const {
    onDemandCourseHeaders,
    endpoint,
    pdTabId,
    emptyLabel
  } = props.courses;
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [onDemandListings, setOnDemandListings] = (0, _react.useState)([]);
  const [isMobile, setIsMobile] = (0, _react.useState)(window.innerWidth < 781);
  (0, _react.useEffect)(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 781);
    };
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  });
  (0, _react.useEffect)(() => {
    const url = `${endpoint}`;
    const fetchData = async url => {
      setIsLoading(true);
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        });
        if (!response.ok) {
          throw new Error(`Error! status: ${response.status}`);
        }
        const result = await response.json();
        setOnDemandListings(result.result.courses);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
        setIsLoading(false);
      }
    };
    const tab = document.getElementById(pdTabId);
    tab.addEventListener("click", () => {
      fetchData(url);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__on-demand-courses gv__component"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__container gv__on-demand-courses__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__on-demand-courses__title-wrapper"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__on-demand-courses__title"
  }, onDemandCourseHeaders.onDemandTitleText), !isLoading && /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__on-demand-courses__listing-count"
  }, `(${onDemandListings.length})` || 0)), isLoading && /*#__PURE__*/_react.default.createElement(_loading.default, {
    isLoading: isLoading
  }), !isLoading && (onDemandListings.length ? /*#__PURE__*/_react.default.createElement("table", {
    className: "gv__on-demand-courses__table"
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: "gv__on-demand-courses__headings"
  }, /*#__PURE__*/_react.default.createElement("th", {
    scope: "col",
    className: "gv__on-demand-courses__header"
  }, isMobile ? onDemandCourseHeaders.column1HeaderMobile : onDemandCourseHeaders.column1Header), /*#__PURE__*/_react.default.createElement("th", {
    scope: "col",
    className: "gv__on-demand-courses__header"
  }, isMobile ? onDemandCourseHeaders.column2HeaderMobile : onDemandCourseHeaders.column2Header), /*#__PURE__*/_react.default.createElement("th", {
    scope: "col",
    className: "gv__on-demand-courses__header"
  }, isMobile ? onDemandCourseHeaders.column3HeaderMobile : onDemandCourseHeaders.column3Header))), /*#__PURE__*/_react.default.createElement("tbody", null, onDemandListings.length && onDemandListings.map((listing, i) => {
    return /*#__PURE__*/_react.default.createElement("tr", {
      className: "gv__on-demand-courses__listing-item",
      key: i
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__on-demand-courses__listing-cell"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: listing.courseLink
    }, listing.courseName)), /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__on-demand-courses__listing-cell gv__on-demand-courses__listing-cell--progress"
    }, /*#__PURE__*/_react.default.createElement("progress", {
      id: "progress-bar",
      className: "gv__on-demand-courses__progress",
      value: `${listing.sessionsCompleted}`,
      max: `${listing.totalSessions}`
    }, "100%"), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "progress-bar"
    }, `${listing.sessionsPercent}`)), /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__on-demand-courses__listing-cell"
    }, `${listing.sessionsCompleted} / ${listing.totalSessions}`));
  }))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__on-demand-courses__no-events"
  }, emptyLabel))));
};
OnDemandCourses.propTypes = propTypes;
var _default = exports.default = OnDemandCourses;

},{"../partials/loading.jsx":150,"prop-types":"prop-types","react":"react"}],132:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _OnDemandCourses = _interopRequireDefault(require("./OnDemandCourses.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-on-demand-courses");
if (el) {
  const props = {
    courses: JSON.parse(el.dataset.courses) || {}
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_OnDemandCourses.default, props), el);
}

},{"./OnDemandCourses.jsx":131,"react":"react","react-dom":"react-dom"}],133:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = openCloseButton;
var _lodash = _interopRequireDefault(require("lodash.throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let vpWindow;
function openCloseButton() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  vpWindow = window.innerWidth;
  const buttons = document.querySelectorAll(".js-open-close-button");
  [...buttons].forEach(button => {
    const target = document.querySelector(button.dataset.target);
    const stickyNav = document.querySelector('#js-lesson-list')?.closest('.js-lesson-navigation') || document.querySelector('#js-unit-list')?.closest('.js-gv__base-template__sticky-nav');
    if (!target) {
      return;
    }
    let expanded = target.classList.contains("is-open");
    button.setAttribute("aria-expanded", expanded);
    window.addEventListener("resize", (0, _lodash.default)(checkResize, 500));
    // window.addEventListener("scroll", throttle(closeMenu, 500));

    button.addEventListener("click", e => {
      e.preventDefault();
      e.stopPropagation();
      target.classList.toggle("is-open");
      expanded = !expanded;
      button.setAttribute("aria-expanded", expanded);

      /* The side nav for the lesson page has a different html 
         above it so it needs scrollIntoView  before setting overflow hidden to the body 
         which disables the whole page to scroll */
      if (button.classList.contains('js-side-nav-btn')) {
        if (expanded) {
          button.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
          setTimeout(() => {
            document.querySelector('body').classList.add('side-nav-open');
          }, 500);
        } else {
          document.querySelector('body').classList.remove('side-nav-open');
          setTimeout(() => {
            button.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest"
            });
          }, 500);
        }
      }
      if (button.classList.contains('gv__unit-navigation__menu-button')) {
        document.querySelector('body').classList.toggle('side-nav-open');
      }
      if (stickyNav) {
        stickyNav.classList.toggle('is-open');
      }
    });
    function checkResize() {
      if (vpWindow !== window.innerWidth) {
        vpWindow = window.innerWidth;
        closeMenu();
      }
    }
    function closeMenu() {
      expanded = false;
      target.classList.remove("is-open");
      button.setAttribute("aria-expanded", false);
    }
  });
}

},{"lodash.throttle":"lodash.throttle"}],134:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _inviteStudents = _interopRequireDefault(require("../invite-students/inviteStudents.jsx"));
var _CourseSelection = _interopRequireDefault(require("./CourseSelection.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ArchivePeriodModal = _interopRequireDefault(require("../archive-period/ArchivePeriodModal.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
_reactModal.default.setAppElement(document.querySelector(".js-page-content-wrapper"));
const propTypes = {
  archiveModalData: (0, _propTypes.shape)({
    archivePeriodTitle: _propTypes.string,
    archivePeriodSubtitle: _propTypes.string,
    archivePeriodCancelLabel: _propTypes.string,
    archivePeriodButtonLabel: _propTypes.string
  }),
  fetchPeriods: _propTypes.func,
  isArchived: _propTypes.bool,
  courseOptions: _propTypes.array,
  students: _propTypes.number,
  name: _propTypes.string,
  code: _propTypes.string,
  id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  url: _propTypes.string,
  isPeriodActive: _propTypes.bool,
  isCleverPeriod: _propTypes.bool,
  isClever: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.bool]),
  coursePending: _propTypes.bool,
  courseName: _propTypes.string,
  dashboardClassCode: _propTypes.string,
  dashboardCourseLabel: _propTypes.string,
  ViewClassLabel: _propTypes.string,
  InvitesStudentLabel: _propTypes.string,
  courseNameLabel: _propTypes.string,
  UnarchiveClassLabel: _propTypes.string,
  selectCourseLabel: _propTypes.string,
  PendingSelectionLabel: _propTypes.string,
  addCourseButtonLabel: _propTypes.string,
  InactiveClassLabel: _propTypes.string,
  InactiveClassHelperText: _propTypes.string,
  inviteStudentData: (0, _propTypes.shape)({
    inviteStudentTitle: _propTypes.string,
    inviteStudentSubtitle: _propTypes.string,
    inviteStudentUrlLabel: _propTypes.string,
    inviteStudentClassCodeLabel: _propTypes.string,
    inviteStudentUrl: _propTypes.string
  })
};
class ClassCard extends _react.Component {
  constructor(props) {
    super(props);
    //for archive period modal
    _defineProperty(this, "archiveOpenModal", e => {
      this.setState({
        archiveModalIsOpen: true,
        archiveButton: e.target
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "archiveCloseModal", () => {
      this.setState({
        archiveModalIsOpen: false
      });
      this.state.archiveButton.setAttribute("aria-expanded", false);
      this.state.archiveButton.focus();
    });
    _defineProperty(this, "renderAlertIcon", () => {
      return /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
      }), /*#__PURE__*/_react.default.createElement("line", {
        x1: "12",
        y1: "9",
        x2: "12",
        y2: "13"
      }), /*#__PURE__*/_react.default.createElement("line", {
        x1: "12",
        y1: "17",
        x2: "12.01",
        y2: "17"
      }));
    });
    _defineProperty(this, "openModal", e => {
      const {
        studentsModalIsOpen,
        courseModalIsOpen
      } = this.state;
      const type = e.target.dataset.type;
      if (type === "student") {
        this.setState({
          studentsModalIsOpen: !studentsModalIsOpen,
          currentTrigger: e.target
        });
      } else if (type === "select") {
        this.setState({
          courseModalIsOpen: !courseModalIsOpen,
          currentTrigger: e.target
        });
      }
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "courseModalClose", e => {
      const courseModalIsOpen = this.state.courseModalIsOpen;
      this.setState({
        courseModalIsOpen: !courseModalIsOpen
      });
      this.state.currentTrigger.focus();
    });
    //this is because the invitestudent is used in multiple apps
    _defineProperty(this, "updateStudentsModalState", () => {
      const {
        studentsModalIsOpen
      } = this.state;
      this.setState({
        studentsModalIsOpen: !studentsModalIsOpen
      });
    });
    _defineProperty(this, "unarchiveClass", periodId => {
      const params = {
        PeriodId: periodId
      };
      fetch("/owh/period/UnarchivePeriod", {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.Message) {
          console.warn(data.Message);
          location.reload();
          return;
        }
      }).catch(err => {
        console.error(err);
        this.setState({
          isLoading: false
        });
      });
    });
    this.state = {
      studentsModalIsOpen: false,
      courseModalIsOpen: false,
      isArchived: this.props.isArchived || false,
      currentTrigger: null,
      archiveModalIsOpen: false
    };
  }
  render() {
    const {
      archiveModalData,
      fetchPeriods,
      students,
      name,
      code,
      url,
      isPeriodActive,
      isCleverPeriod,
      InactiveClassLabel,
      InactiveClassHelperText,
      dashboardCourseLabel,
      courseName,
      inviteStudentData,
      id,
      coursePending,
      ArchiveLabel,
      ViewClassLabel,
      InvitesStudentLabel,
      UnarchiveClassLabel,
      addCourseButtonLabel,
      selectCourseLabel,
      courseNameLabel,
      PendingSelectionLabel,
      courseOptions,
      isClever,
      UnarchiveLabel
    } = this.props;
    const isArchived = this.state.isArchived;
    const {
      studentsModalIsOpen
    } = this.state;
    const cardClass = (0, _classnames.default)("gv__class-card", {
      "gv__class-card--gray": isCleverPeriod && (coursePending === true || isPeriodActive === false)
    });
    const newArchivePeriodTitle = `${archiveModalData.archivePeriodTitle} ${name}`;
    let archiveDictionary = {};
    Object.assign(archiveDictionary, archiveModalData);
    archiveDictionary.archivePeriodTitle = newArchivePeriodTitle;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: cardClass
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-card__top"
    }, isCleverPeriod && !isPeriodActive && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__class-card__alert"
    }, this.renderAlertIcon(), InactiveClassLabel), (!isCleverPeriod || isCleverPeriod && isPeriodActive) && /*#__PURE__*/_react.default.createElement("div", {
      className: ""
    }, students, " Students"), (isCleverPeriod || !isCleverPeriod && isPeriodActive) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isArchived ? /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: () => this.unarchiveClass(id),
      ref: this.archiveRef,
      className: "gv__class-card__archive-button"
    }, UnarchiveLabel || "Unarchive") : /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: e => this.archiveOpenModal(e),
      ref: this.archiveRef,
      className: "js-archive-period__btn gv__class-card__archive-button"
    }, ArchiveLabel))), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-card__body"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-card__middle"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__sub-title gv__class-card__title"
    }, name), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-card__course-name gv__rte"
    }, /*#__PURE__*/_react.default.createElement("p", null, dashboardCourseLabel, ": ", coursePending ? PendingSelectionLabel : courseName)), !isCleverPeriod && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-card__summary gv__rte"
    }, /*#__PURE__*/_react.default.createElement("p", null, this.props.dashboardClassCode, ": ", /*#__PURE__*/_react.default.createElement("strong", null, code)))), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-card__bottom"
    }, isCleverPeriod && !isPeriodActive && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-card__summary gv__class-card__inactive-helper gv__rte"
    }, /*#__PURE__*/_react.default.createElement("p", null, InactiveClassHelperText))), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-card__button-row gv__button-row"
    }, coursePending && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      href: url,
      onClick: this.openModal,
      "data-type": "select",
      className: "gv__button",
      "data-clever-modal-launch": "cleverselectcourse"
    }, selectCourseLabel), courseOptions && courseOptions.length > 0 && /*#__PURE__*/_react.default.createElement(_CourseSelection.default, {
      addCourseButtonLabel: addCourseButtonLabel,
      courseOptions: courseOptions,
      modalIsOpen: this.state.courseModalIsOpen,
      closeModal: this.courseModalClose,
      courseNameLabel: courseNameLabel,
      periodId: id,
      fetchPeriods: fetchPeriods
    })), !coursePending && /*#__PURE__*/_react.default.createElement("a", {
      href: url,
      className: "gv__button"
    }, ViewClassLabel), inviteStudentData && !isArchived && !isCleverPeriod && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
      className: "gv__button gv__button--outline react-invite-students__btn",
      "aria-haspopup": "true",
      "data-type": "student",
      "aria-expanded": studentsModalIsOpen,
      onClick: this.openModal
    }, InvitesStudentLabel), /*#__PURE__*/_react.default.createElement(_inviteStudents.default, {
      dictionary: inviteStudentData,
      inviteStudentUrl: inviteStudentData.inviteStudentUrl,
      classCode: code,
      modalIsOpen: this.state.studentsModalIsOpen,
      updateParent: this.updateStudentsModalState
    })))), /*#__PURE__*/_react.default.createElement(_ArchivePeriodModal.default, {
      inheritCloseModal: this.archiveCloseModal,
      inheritOpenModal: this.archiveOpenModal,
      modalIsOpen: this.state.archiveModalIsOpen,
      requestUrl: "",
      periodId: id,
      dictionary: archiveDictionary
    }));
  }
}
exports.default = ClassCard;
ClassCard.propTypes = propTypes; // defined at the top of the file

},{"../archive-period/ArchivePeriodModal.jsx":7,"../invite-students/inviteStudents.jsx":122,"./CourseSelection.jsx":136,"classnames":"classnames","prop-types":"prop-types","react":"react","react-modal":"react-modal"}],135:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// https://blog.hackages.io/conditionally-wrap-an-element-in-react-a8b9a47fab2
const ConditionalWrapper = _ref => {
  let {
    condition,
    wrapper,
    children
  } = _ref;
  return condition ? wrapper(children) : children;
};
var _default = exports.default = ConditionalWrapper;

},{"react":"react"}],136:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _selectInput = _interopRequireDefault(require("../partials/select-input.jsx"));
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _closeOnEscape = require("../partials/close-on-escape.js");
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
_reactModal.default.setAppElement(document.querySelector(".js-page-content-wrapper"));
class CourseSelection extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      if (this.props.courseOptions.length > 0) {
        const emptyValue = {
          detail: null,
          label: "",
          value: null
        };
        const newCourses = this.props.courseOptions.map(x => x);
        newCourses.unshift(emptyValue);
        this.setState({
          courseOptions: newCourses,
          isLoading: false
        });
      }
    });
    _defineProperty(this, "onFormSubmit", e => {
      e.preventDefault();
      const params = {
        PeriodId: this.props.periodId,
        CourseId: this.state.selectedCourse
      };
      this.setState({
        isLoading: true
      });
      fetch(`/owh/period/UpdateCourseForPeriod`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data && data.IsValid) {
          this.setState({
            isLoading: false
          });
          this.props.closeModal();
          this.props.fetchPeriods();
        } else {
          this.setState({
            error: data.Message,
            isLoading: false
          });
        }
      }).catch(error => {
        console.error(error);
        this.setState({
          isLoading: false
        });
      });
    });
    _defineProperty(this, "updateSelectState", e => {
      const value = e.target.value;
      let details;
      if (value) {
        const filteredResults = R.filter(R.propEq("value", parseInt(value)), this.state.courseOptions);
        details = filteredResults[0].detail;
      } else {
        details = null;
      }
      this.setState({
        selectedCourse: value,
        selectedCourseDetails: details
      });
    });
    _defineProperty(this, "afterModalOpen", () => {
      this.modalRef.current.focus();
      document.addEventListener("click", (0, _closeOnEscape.closeOnEscape)(this.props.closeModal));
    });
    this.state = {
      courseOptions: null,
      selectedCourse: null,
      selectedCourseDetails: null,
      isLoading: true,
      error: null
    };
    const modalRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      addCourseButtonLabel,
      courseNameLabel,
      closeModal,
      id
    } = this.props;
    const {
      isLoading,
      selectedCourseDetails,
      error,
      courseOptions
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.props.modalIsOpen,
      afterOpenModal: this.afterModalOpen,
      onRequestClose: closeModal,
      contentLabel: "Course Selection",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content",
      ref: this.modalRef
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: this.onFormSubmit
    }, /*#__PURE__*/_react.default.createElement(_loading.default, {
      isLoading: isLoading
    }), courseOptions && /*#__PURE__*/_react.default.createElement(_selectInput.default, {
      onChange: this.updateSelectState,
      label: courseNameLabel,
      options: courseOptions,
      requiredField: true,
      value: ""
    }), selectedCourseDetails && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__class-list-modal__details"
    }, selectedCourseDetails), error && /*#__PURE__*/_react.default.createElement("div", {
      "aria-atomic": "true",
      className: "gv__form__error-msg gv__form__general-error js-form-general-error",
      role: "alert"
    }, error), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__button-row gv__button-row--centered"
    }, /*#__PURE__*/_react.default.createElement("button", {
      disabled: this.state.selectedCourse === null || this.state.selectedCourse === "",
      type: "submit",
      className: "gv__button",
      "data-clever-modal-complete": "cleverselectcourse"
    }, addCourseButtonLabel))));
  }
}
exports.default = CourseSelection;
_defineProperty(CourseSelection, "propTypes", {
  addCourseButtonLabel: _propTypes.string,
  courseNameLabel: _propTypes.string,
  courseOptions: _propTypes.array,
  modalIsOpen: _propTypes.bool,
  id: _propTypes.string,
  closeModal: _propTypes.func,
  fetchPeriods: _propTypes.func
});

},{"../partials/close-on-escape.js":144,"../partials/loading.jsx":150,"../partials/select-input.jsx":154,"prop-types":"prop-types","ramda":"ramda","react":"react","react-modal":"react-modal"}],137:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  img: _propTypes.string.isRequired,
  href: _propTypes.string.isRequired,
  altText: _propTypes.string.isRequired,
  target: _propTypes.string
};
const LinkedImg = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    img,
    href,
    altText,
    target
  } = props;
  return /*#__PURE__*/_react.default.createElement("a", {
    ref: ref,
    href: href,
    className: "gv__linked-img",
    target: target
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: img,
    alt: altText,
    className: "gv__linked-img__image"
  }));
});
LinkedImg.propTypes = propTypes; // defined at the top of the file
var _default = exports.default = LinkedImg;

},{"prop-types":"prop-types","react":"react"}],138:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _textInput = _interopRequireDefault(require("../partials/text-input.jsx"));
var _selectInput = _interopRequireDefault(require("../partials/select-input.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const propTypes = {
  newPeriodInput: _propTypes.object,
  selectedCourseDetails: _propTypes.string,
  isLoading: _propTypes.bool,
  modalData: _propTypes.object,
  courseOptions: _propTypes.array,
  updateSelectState: _propTypes.func,
  handleNewClassInput: _propTypes.func,
  onFormSubmit: _propTypes.func,
  defaultValue: _propTypes.string
};
const NewClassForm = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    courseOptions,
    newPeriodInput,
    selectedCourseDetails,
    isLoading,
    modalData,
    updateSelectState,
    handleNewClassInput,
    onFormSubmit,
    defaultValue = ""
  } = props;
  const {
    modalTitle,
    periodNameLabel,
    courseNameLabel,
    addButtonLabel
  } = modalData;
  const submitButtonClass = (0, _classnames.default)("gv__button", {
    "gv__button is-loading": isLoading
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__class-list-modal"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    tabIndex: "-1",
    ref: ref,
    className: "gv__class-list-modal__title"
  }, modalTitle), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: onFormSubmit
  }, /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, newPeriodInput, {
    onChange: handleNewClassInput,
    label: periodNameLabel,
    errorMsg: newPeriodInput.errorMsg,
    warning: newPeriodInput.warning,
    requiredField: true
  })), /*#__PURE__*/_react.default.createElement(_selectInput.default, {
    onChange: updateSelectState,
    label: courseNameLabel,
    options: courseOptions,
    requiredField: true,
    value: defaultValue
  }), selectedCourseDetails && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__class-list-modal__details"
  }, selectedCourseDetails), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__class-list-modal__button-row gv__button-row gv__button-row--centered"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: submitButtonClass
  }, addButtonLabel))));
});
NewClassForm.propTypes = propTypes;
var _default = exports.default = NewClassForm;

},{"../partials/select-input.jsx":154,"../partials/text-input.jsx":156,"classnames":"classnames","prop-types":"prop-types","react":"react"}],139:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _textInput = _interopRequireDefault(require("../partials/text-input.jsx"));
var _selectInput = _interopRequireDefault(require("../partials/select-input.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const propTypes = {
  newPeriodInput: _propTypes.object,
  isLoading: _propTypes.bool,
  cleverPeriods: _propTypes.object,
  selectedCourseDetails: _propTypes.string,
  modalData: _propTypes.object,
  setCleverId: _propTypes.func,
  courseOptions: _propTypes.array,
  onFormSubmit: _propTypes.func,
  handleNewClassInput: _propTypes.func,
  updateSelectState: _propTypes.func,
  defaultValue: _propTypes.bool
};
const NewCleverClassForm = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    newPeriodInput,
    isLoading,
    cleverPeriods,
    selectedCourseDetails,
    courseOptions,
    onFormSubmit,
    closeModal,
    handleNewClassInput,
    updateSelectState,
    defaultValue = ""
  } = props;
  const {
    modalTitle,
    periodNameLabel,
    courseNameLabel,
    addButtonLabel,
    classSizeLabel,
    cleverSectionLabel
  } = props.modalData;
  const submitButtonClass = (0, _classnames.default)("gv__button", {
    "gv__button is-loading": isLoading
  });
  const updateCleverId = event => {
    const setCleverId = props.setCleverId;
    const cleverId = event.target.value;
    event.target.checked && setCleverId(cleverId);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__class-list-modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__class-list-modal__title gv__class-list-modal__title--clever"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    tabIndex: "-1",
    ref: ref
  }, modalTitle), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: closeModal,
    className: "gv__modal__close"
  }, "close")), /*#__PURE__*/_react.default.createElement("form", {
    className: "gv__class-list-modal__form",
    onSubmit: onFormSubmit
  }, /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "gv__form__fieldset gv__class-list-modal__fieldset"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__class-list-modal__class-header"
  }, /*#__PURE__*/_react.default.createElement("legend", {
    className: "",
    id: "cleverSectionLabel"
  }, cleverSectionLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__class-list-modal__class-size-header"
  }, classSizeLabel)), cleverPeriods && cleverPeriods.map((period, i) => {
    const nameTrim = period.periodName.trim().replace(" ", "");
    const newId = `course${nameTrim}${i}`;
    const newLabelId = `${newId}Label`;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: newId,
      className: "gv__form__item gv__form__item--radio gv__class-list-modal__item"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "gv__form__field",
      id: newId,
      type: "radio",
      name: "describe",
      value: period.cleverId,
      "aria-labelledby": newLabelId,
      "aria-describedby": "cleverSectionLabel",
      onChange: updateCleverId,
      required: true
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "gv__form__label gv__class-list-modal__radio-label",
      id: newLabelId,
      htmlFor: newId
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__class-list-modal__period-name"
    }, period.periodName), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__class-list-modal__class-size"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__visuallyhidden"
    }, classSizeLabel, ": "), period.numberOfStudents)));
  })), /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, newPeriodInput, {
    onChange: handleNewClassInput,
    label: periodNameLabel,
    errorMsg: newPeriodInput.errorMsg,
    warning: newPeriodInput.warning,
    requiredField: true
  })), /*#__PURE__*/_react.default.createElement(_selectInput.default, {
    onChange: updateSelectState,
    label: courseNameLabel,
    options: courseOptions,
    requiredField: true,
    descriptiveField: "detail",
    value: defaultValue,
    describedBy: "selectedCourseDescription"
  }), selectedCourseDetails && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__class-list-modal__details",
    id: "selectedCourseDescription"
  }, selectedCourseDetails), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__class-list-modal__button-row gv__button-row gv__button-row--centered"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: submitButtonClass
  }, addButtonLabel))));
});
NewCleverClassForm.propTypes = propTypes;
var _default = exports.default = NewCleverClassForm;

},{"../partials/select-input.jsx":154,"../partials/text-input.jsx":156,"classnames":"classnames","prop-types":"prop-types","react":"react"}],140:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RegisterLinkIcon = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "#213245",
    strokeWidth: "1.3",
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.867 4.625V1.25h-3.4m3.4 0-1.134 1.125m0 0L6.241 9.813M12.6 9.558v5.192H1.267V3.5h5.461"
  })));
};
var _default = exports.default = RegisterLinkIcon;

},{"react":"react"}],141:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _RegisterLinkIcon = _interopRequireDefault(require("./RegisterLinkIcon.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  name: _propTypes.string,
  dateSummary: _propTypes.string,
  shortDescription: _propTypes.string,
  eventLandingUrl: _propTypes.string,
  eventLandingText: _propTypes.string,
  startDate: _propTypes.string,
  eventTopic: _propTypes.string,
  isPastEvent: _propTypes.bool,
  zoomJoinUrl: _propTypes.string
};
const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const UpcomingEventsCard = props => {
  const [convertedCalDate, setConvertedCalDate] = (0, _react.useState)("");
  const [convertedMonth, setConvertedMonth] = (0, _react.useState)("");
  const {
    eventTopic,
    name,
    dateSummary,
    shortDescription,
    eventLandingUrl,
    eventLandingText,
    startDate,
    isPastEvent,
    zoomJoinUrl
  } = props;
  (0, _react.useEffect)(() => {
    const date = startDate;
    const convertedDate = new Date(date);
    setConvertedMonth(monthNames[convertedDate.getMonth()]);
    setConvertedCalDate(convertedDate.getDate().toString());
  }, [startDate]);
  const listingClasses = (0, _classnames.default)("gv__upcoming-events__listing", {
    "gv__registered-events__listing--past slide-right": isPastEvent
  });
  const headingClasses = (0, _classnames.default)("gv__upcoming-events__listing-heading", {
    "gv__upcoming-events__listing-heading--past": isPastEvent
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: listingClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: headingClasses
  }, convertedCalDate && convertedMonth && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__listing-date"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__upcoming-events__listing-day"
  }, convertedCalDate), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__upcoming-events__listing-month"
  }, convertedMonth)), eventTopic && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__listing-type"
  }, eventTopic)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__listing-info"
  }, name && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__listing-title"
  }, name), dateSummary && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__listing-date-summary"
  }, dateSummary), shortDescription && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__listing-description",
    dangerouslySetInnerHTML: {
      __html: shortDescription
    }
  }), eventLandingUrl && eventLandingText && /*#__PURE__*/_react.default.createElement("a", {
    href: eventLandingUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "gv__upcoming-events__listing-cta"
  }, /*#__PURE__*/_react.default.createElement("span", null, eventLandingText), /*#__PURE__*/_react.default.createElement(_RegisterLinkIcon.default, null)), zoomJoinUrl && !isPastEvent && /*#__PURE__*/_react.default.createElement("a", {
    href: zoomJoinUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "gv__upcoming-events__listing-zoom-cta"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__upcoming-events__listing-zoom-cta-text"
  }, "Join Now"), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__button__icon"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    role: "img",
    width: "7",
    height: "12",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("title", null), /*#__PURE__*/_react.default.createElement("g", {
    strokeWidth: "1.3",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 10.95L5.95 6M1 1l4.95 4.95"
  })))))));
};
UpcomingEventsCard.propTypes = propTypes;
var _default = exports.default = UpcomingEventsCard;

},{"./RegisterLinkIcon.jsx":140,"classnames":"classnames","prop-types":"prop-types","react":"react"}],142:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {};
const AssignIcon = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "10",
    viewBox: "0 0 15 10"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Assign"), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    strokeLinecap: "square",
    d: "M6.5 5h8M13.023 3.023L14.95 4.95m-1.927 1.943L14.95 4.97"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 8v2H0V0h10v2"
  })));
};
AssignIcon.propTypes = propTypes;
var _default = exports.default = AssignIcon;

},{"prop-types":"prop-types","react":"react"}],143:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {};
const CloseIcon = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Close"), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 8v2H0V0h10v2"
  }), /*#__PURE__*/_react.default.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: ".8"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.879 2.938l4.242 4.124M12.121 2.938L7.879 7.062"
  }))));
};
CloseIcon.propTypes = propTypes;
var _default = exports.default = CloseIcon;

},{"prop-types":"prop-types","react":"react"}],144:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeOnEscape = void 0;
//functionToCall is what function should be called

const closeOnEscape = (e, functionToCall) => {
  if (e.key === "Escape") {
    e.preventDefault();
    functionToCall();
  }
};
exports.closeOnEscape = closeOnEscape;

},{}],145:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CompileIcon = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "10",
    viewBox: "0 0 10 10"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#213245"
  }, /*#__PURE__*/_react.default.createElement("path", {
    strokeLinecap: "square",
    d: "M6.977 4.023L5.05 5.95M3.107 4.023L5.03 5.95"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 0h2v10H0V0h2"
  })));
};
var _default = exports.default = CompileIcon;

},{"react":"react"}],146:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  classes: _propTypes.string
};
const ExpandChevronSmall = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: props.classes,
    width: "12",
    height: "8",
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.59 0L6 4.58L1.41 0L0 1.41L6 7.41L12 1.41L10.59 0Z",
    fill: "#213245"
  }));
};
ExpandChevronSmall.propTypes = propTypes; // defined at the top of the file
var _default = exports.default = ExpandChevronSmall;

},{"prop-types":"prop-types","react":"react"}],147:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  classes: _propTypes.string
};
const ExpandChevron = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: props.classes,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 407.437 407.437"
  }, /*#__PURE__*/_react.default.createElement("title", null), /*#__PURE__*/_react.default.createElement("path", {
    d: "M386.258 91.567l-182.54 181.945L21.179 91.567 0 112.815 203.718 315.87l203.719-203.055z",
    fill: "currentColor"
  }));
};
ExpandChevron.propTypes = propTypes; // defined at the top of the file
var _default = exports.default = ExpandChevron;

},{"prop-types":"prop-types","react":"react"}],148:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {};
const ExternalLinkIcon = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: `${props.classes && props.classes}`,
    "aria-label": "Opens in new tab",
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36364 1.81827C1.1126 1.81827 0.909091 2.02178 0.909091 2.27282V8.63645C0.909091 8.88749 1.1126 9.091 1.36364 9.091H7.72727C7.97831 9.091 8.18182 8.88749 8.18182 8.63645V5.50094H9.09091V8.63645C9.09091 9.38957 8.48039 10.0001 7.72727 10.0001H1.36364C0.610521 10.0001 0 9.38957 0 8.63645V2.27282C0 1.5197 0.610521 0.90918 1.36364 0.90918H4.68834V1.81827H1.36364Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73345 0.908938L4.54517 6.09722L3.90234 5.45439L9.09062 0.266113L9.73345 0.908938Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08913 0.909091H6.81641V0H9.99822V3.18182H9.08913V0.909091Z",
    fill: "currentColor"
  }));
};
ExternalLinkIcon.propTypes = propTypes; // defined at the top of the file
var _default = exports.default = ExternalLinkIcon;

},{"react":"react"}],149:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {};
const EyeIcon = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/_react.default.createElement("title", null, "View"), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 8.02C9.811-1.313 6.189-1.353 0 7.98c6.189 9.333 9.811 9.373 16 .04"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "3",
    stroke: "currentColor"
  })));
};
EyeIcon.propTypes = propTypes;
var _default = exports.default = EyeIcon;

},{"prop-types":"prop-types","react":"react"}],150:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  isLoading: _propTypes.bool
};
const toggleAnimation = e => {
  const animationTarget = document.querySelectorAll(".gv__loading-overlay__cube");
  animationTarget.forEach(x => {
    let playState;
    const isWebKit = x.style.webkitAnimationPlayState ? true : false;
    if (isWebKit) {
      playState = x.style.webkitAnimationPlayState;
    } else {
      playState = x.style.animationPlayState;
    }
    if (playState === "paused") {
      if (isWebKit) {
        x.style.webkitAnimationPlayState = "running";
      } else {
        x.style.animationPlayState = "running";
      }
    } else {
      if (isWebKit) {
        x.style.webkitAnimationPlayState = "paused";
      } else {
        x.style.animationPlayState = "paused";
      }
    }
  });
};
const Loading = props => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube-grid"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__loading-overlay__pause",
    onClick: e => toggleAnimation(e)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__visuallyhidden"
  }, "Pause Animation")), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube gv__loading-overlay__cube--1"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube gv__loading-overlay__cube--2"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube gv__loading-overlay__cube--3"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube gv__loading-overlay__cube--4"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube gv__loading-overlay__cube--5"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube gv__loading-overlay__cube--6"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube gv__loading-overlay__cube--7"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube gv__loading-overlay__cube--8"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__loading-overlay__cube gv__loading-cube--9"
  })));
};
Loading.propTypes = propTypes; // defined at the top of the file
var _default = exports.default = Loading;

},{"prop-types":"prop-types","react":"react"}],151:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const propTypes = {};
const NewWindowIcon = props => {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    title: "new window",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.867 4.625V1.25h-3.4M14.867 1.25l-1.134 1.125M13.733 2.375L6.241 9.813"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.6 9.558v5.192H1.267V3.5h5.461"
  }))));
};
NewWindowIcon.propTypes = propTypes;
var _default = exports.default = NewWindowIcon;

},{"prop-types":"prop-types","react":"react"}],152:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {};
const OpenIcon = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: "113",
    height: "35",
    viewBox: "0 0 113 35"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Open"), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    strokeLinecap: "square",
    d: "M17.5 17V9M15.523 10.477L17.45 8.55m1.943 1.927L17.47 8.55"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.5 13.5h2v10h-10v-10h2"
  }))));
};
OpenIcon.propTypes = propTypes;
var _default = exports.default = OpenIcon;

},{"prop-types":"prop-types","react":"react"}],153:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {};
const ReopenIcon = props => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "14",
    viewBox: "0 0 15 14",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("title", null, "reopen"), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    strokeLinecap: "square",
    d: "M13.755 2.187l-.75 2.62m-2.634-.743l2.616.752"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.815 4.429A6 6 0 001.8 4.82"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    strokeLinecap: "square",
    d: "M1.276 11.752l.706-2.632m2.646.697L1.999 9.11"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.195 9.416a6 6 0 0011.014-.393"
  }))));
};
ReopenIcon.propTypes = propTypes;
var _default = exports.default = ReopenIcon;

},{"prop-types":"prop-types","react":"react"}],154:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("classNames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  selected: _propTypes.bool,
  label: _propTypes.string.isRequired,
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string.isRequired,
    value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number])
  })),
  onChange: _propTypes.func.isRequired,
  small: _propTypes.bool,
  transparent: _propTypes.bool,
  describedBy: _propTypes.string,
  requiredField: _propTypes.bool
};
const SelectInput = props => {
  const renderOptions = options => {
    return options.map(option => {
      return /*#__PURE__*/_react.default.createElement("option", {
        key: option.value,
        value: option.value
      }, option.label);
    });
  };
  const {
    label,
    value,
    options,
    onChange,
    small,
    transparent,
    describedBy
  } = props;
  const isRequired = props.requiredField ? props.requiredField : false;
  const labelId = label ? label.trim().replace(" ", "-") : "";
  const errorId = labelId + "Error";
  const classes = (0, _classNames.default)("gv__select-input", "gv__form__item", {
    "gv__select-input--small": small,
    "gv__select-input--transparent": transparent
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "gv__select-input__text gv__form__label",
    id: labelId
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__select-input__input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("select", {
    "aria-labelledby": labelId,
    "aria-describedby": describedBy,
    onChange: onChange,
    defaultValue: value,
    "aria-required": isRequired,
    className: "gv__select-input__field gv__form__field"
  }, renderOptions(options))));
};
SelectInput.propTypes = propTypes; // defined at the top of the file
var _default = exports.default = SelectInput;

},{"classNames":"classNames","prop-types":"prop-types","react":"react"}],155:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  tabs: _propTypes.PropTypes.arrayOf(_propTypes.PropTypes.shape({
    name: _propTypes.string,
    active: _propTypes.bool,
    ariaControls: _propTypes.string
  })),
  activeTab: _propTypes.string,
  handleTabClick: _propTypes.func.isRequired,
  handleTabClickIE11: _propTypes.func,
  isIE11: _propTypes.bool
};
const Tabs = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const keyTrap = (e, i) => {
    const tabs = document.querySelectorAll(".gv__tabs__tab");
    const totalTabs = tabs.length - 1;
    switch (e.key) {
      case "ArrowLeft":
        e.preventDefault();
        if (i === 0) {
          tabs[totalTabs].focus();
        } else {
          tabs[i - 1].focus();
        }
        break;
      case "ArrowRight":
        e.preventDefault();
        if (i === totalTabs) {
          tabs[0].focus();
        } else {
          tabs[i + 1].focus();
        }
        break;
      default:
    }
  };
  const handleClick = selectedTab => {
    if (props.isIE11) {
      props.handleTabClickIE11(selectedTab);
    } else {
      props.handleTabClick(selectedTab);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__tabs",
    role: "tablist",
    ref: ref
  }, props.tabs.map((tab, i) => {
    const tabClass = (0, _classnames.default)("gv__tabs__tab", {
      "is-active": tab.name === props.activeTab
    });
    let name = tab.name;
    let ariaControls = tab.ariaControls;
    return /*#__PURE__*/_react.default.createElement("button", {
      key: i,
      className: tabClass,
      onClick: () => handleClick(tab),
      onKeyDown: e => keyTrap(e, i),
      type: "button",
      role: "tab",
      "aria-selected": tab.active,
      "aria-controls": ariaControls
    }, name);
  }));
});
Tabs.propTypes = propTypes; // defined at the top of the file
var _default = exports.default = Tabs;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],156:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _reactResponsive = require("react-responsive");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  label: _propTypes.string,
  labelledBy: _propTypes.string,
  type: _propTypes.string,
  value: _propTypes.string.isRequired,
  placeholder: _propTypes.string,
  hideHintOnMobile: _propTypes.bool,
  readOnly: _propTypes.bool,
  error: _propTypes.bool,
  warning: _propTypes.bool,
  errorMsg: _propTypes.string,
  warningMsg: _propTypes.string,
  hiddenLabel: _propTypes.bool,
  onKeyUp: _propTypes.func,
  onChange: _propTypes.func.isRequired,
  requiredField: _propTypes.bool,
  autoSuggest: _propTypes.bool,
  maxCharacters: _propTypes.string
};
const TextInput = props => {
  const {
    label,
    labelledBy,
    value,
    placeholder,
    hideHintOnMobile,
    onChange,
    onKeyUp,
    error = false,
    warning = false,
    errorMsg,
    warningMsg,
    type = "text",
    readOnly = false,
    autoSuggest = false,
    maxCharacters
    //handleSearchClose
  } = props;
  const [autosuggestState, setAutosuggestState] = (0, _react.useState)({
    isOpen: false,
    isLoading: false,
    suggestions: [],
    highlightedOptionIndex: -1,
    keyword: ""
  });
  const [inputValue, setInputValue] = (0, _react.useState)(value);
  const [shouldSubmit, setShouldSubmit] = (0, _react.useState)(false);
  const [typeAheadReset, setTypeAheadReset] = (0, _react.useState)(false);
  const inputEl = (0, _react.useRef)(null);
  const cssClass = error ? "has-error" : warning ? "has-warning" : "";
  const labelId = label ? label.trim().replace(/\s/g, "-") : "";
  const errorId = labelId + "Error";
  const warningId = labelId + "Warning";
  const labelClass = (0, _classnames.default)("gv__text-input__text gv__form__label", {
    gv__visuallyhidden: props.hiddenLabel
  });
  const isRequired = props.requiredField || false;
  const hasWarning = warning ? warningId : "";
  const hasError = error ? errorId : "";
  const additionalLabel = labelledBy || "";
  const containerEl = (0, _react.useRef)(null);
  const eventTypeahead = new Event("typeahead");
  const isSmallTabletorMobile = (0, _reactResponsive.useMediaQuery)({
    query: '(max-width: 780px)'
  });
  (0, _react.useEffect)(() => {
    const onTypeahead = event => {
      onChange(event);
    };
    const inputElCopy = inputEl.current;
    inputElCopy.addEventListener("typeahead", onTypeahead);
    return () => {
      inputElCopy.removeEventListener("typeahead", onTypeahead);
    };
  }, [onChange]);
  (0, _react.useEffect)(() => {
    setInputValue(value);
    if (shouldSubmit) {
      const eventSubmit = new Event("submit", {
        bubbles: true
      });
      inputEl.current.closest("form").dispatchEvent(eventSubmit);
    }
  }, [value, shouldSubmit]);
  const initAutosuggest = keyword => {
    if (!keyword) {
      setAutosuggestState({
        ...autosuggestState,
        suggestions: [],
        isLoading: false,
        isOpen: false
      });
      setTypeAheadReset(false);
      return;
    }
    getSuggestions(keyword);
    setTypeAheadReset(true);
  };
  const getSuggestions = keyword => {
    setAutosuggestState({
      ...autosuggestState,
      isLoading: true
    });
    const params = {
      q: keyword
    };

    // PATTERN LAB MOCK DATA
    // setTimeout(() => {
    //   const generateSuggestions = () => {
    //     let results = [];
    //     const count = (max) => {
    //       max = Math.floor(max);
    //       return Math.floor(Math.random() * (max - 1) + 1);
    //     };
    //     for (let i = 0; i <= count(15); i++) {
    //       results.push(`${keyword} ${Math.floor(Math.random() * 100)}`);
    //     }
    //     return results;
    //   };
    //   const suggestions = generateSuggestions();
    //   setAutosuggestState({
    //     ...autosuggestState,
    //     suggestions: suggestions,
    //     isOpen: !!suggestions.length,
    //     isLoading: false,
    //     keyword: keyword,
    //     highlightedOptionIndex: -1,
    //   });
    // }, 1000);
    // END PATTERLAB MOCK DATA

    const url = "/owh/search/suggest";

    // patternlab url
    // const url = "http://oer.gv.velir.com/owh/search/suggest";

    fetch(url, {
      method: "POST",
      body: JSON.stringify(params),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => response.json()).then(data => {
      setAutosuggestState({
        suggestions: data,
        isLoading: false,
        isOpen: !!data.length,
        keyword: keyword,
        highlightedOptionIndex: -1
      });
    });
  };
  const throttleAutosuggest = (0, _react.useCallback)((0, _lodash.default)(initAutosuggest, 300, {
    trailing: true,
    leading: false
  }), []);
  const showPlaceholder = () => {
    if (hideHintOnMobile) {
      return !isSmallTabletorMobile ? placeholder : "";
    } else {
      return placeholder;
    }
  };
  const onInput = event => {
    if (autoSuggest) {
      throttleAutosuggest(event.target.value);
    }
  };
  const updateInputEl = value => {
    setInputValue(value);
    inputEl.current.value = value;
    inputEl.current.dispatchEvent(eventTypeahead);
  };
  const handleSearchClose = () => {
    updateInputEl("");
  };
  const onSuggestionClick = event => {
    if (event.key && event.key !== "Enter") {
      return;
    }
    setValue(event.target.textContent);
    inputEl.current.focus();
    setShouldSubmit(true);
  };
  const setValue = value => {
    setAutosuggestState({
      ...autosuggestState,
      isOpen: false,
      highlightedOptionIndex: -1,
      keyword: value
    });
    updateInputEl(value);
  };
  const manageHighlight = (index, shouldClose) => {
    const {
      suggestions,
      isOpen
    } = autosuggestState;
    const newOpenState = shouldClose ? false : isOpen;
    setAutosuggestState({
      ...autosuggestState,
      highlightedOptionIndex: index,
      isOpen: newOpenState
    });
    const value = index === -1 ? inputEl.current.value : suggestions[index];
    updateInputEl(value);
  };
  const onKeyMap = event => {
    if (autoSuggest) {
      const {
        suggestions,
        highlightedOptionIndex,
        isOpen
      } = autosuggestState;
      if (!isOpen) {
        return;
      }
      switch (event.key) {
        case "ArrowUp":
          event.preventDefault();
          const newUpIndex = highlightedOptionIndex >= 0 ? highlightedOptionIndex - 1 : suggestions.length - 1;
          manageHighlight(newUpIndex);
          return;
        case "ArrowDown":
          event.preventDefault();
          const newDownIndex = highlightedOptionIndex < suggestions.length - 1 ? highlightedOptionIndex + 1 : -1;
          manageHighlight(newDownIndex);
          return;
        case "Enter":
          manageHighlight(highlightedOptionIndex, true);
          return;
        case "Escape":
          if (isOpen) {
            event.preventDefault();
            setAutosuggestState({
              ...autosuggestState,
              highlightedOptionIndex: -1,
              isOpen: false
            });
          }
          return;
        default:
          return;
      }
    }
  };
  const onBlur = event => {
    if (autoSuggest && !containerEl.current.contains(event.relatedTarget)) {
      setAutosuggestState({
        ...autosuggestState,
        isOpen: false
      });
    }
  };
  const onFocus = event => {
    if (autosuggestState.suggestions.length && event.target.value === autosuggestState.keyword) {
      setAutosuggestState({
        ...autosuggestState,
        isOpen: true
      });
    }
  };
  const resetInput = () => {
    setShouldSubmit(false);
    setInputValue("");
    setAutosuggestState({
      isOpen: false,
      isLoading: false,
      suggestions: [],
      highlightedOptionIndex: -1,
      keyword: ""
    });
    setTypeAheadReset(false);
  };
  const renderSuggestions = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)("gv__text-input__suggestions", {
        "is-open": autosuggestState.isOpen
      })
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "gv__text-input__suggestions-list",
      role: "listbox"
    }, autosuggestState.suggestions.map((item, index) => {
      const keyPrefix = "TEXT_INPUT_SUGGESTION";
      const isHighlighted = autosuggestState.highlightedOptionIndex === index;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: `${keyPrefix}_${index}`,
        role: "option",
        tabIndex: "-1",
        "aria-selected": isHighlighted,
        onClick: onSuggestionClick,
        onKeyPress: onSuggestionClick,
        className: (0, _classnames.default)("gv__text-input__suggestions-item", {
          "is-highlighted": isHighlighted
        })
      }, item);
    })));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `gv__text-input gv__form__item ${cssClass} ${autoSuggest ? "gv__text-input--autosuggest" : ""}`,
    ref: containerEl
  }, label && /*#__PURE__*/_react.default.createElement("label", {
    className: labelClass,
    id: labelId
  }, label), /*#__PURE__*/_react.default.createElement("input", {
    "aria-labelledby": `${labelId} ${additionalLabel}`,
    "aria-describedby": `${hasWarning} ${hasError}`,
    "aria-required": isRequired,
    "aria-invalid": error,
    maxLength: maxCharacters ? maxCharacters : null,
    autoComplete: "off",
    type: type,
    value: inputValue,
    placeholder: showPlaceholder(),
    readOnly: readOnly,
    onChange: onChange,
    onKeyUp: onKeyUp,
    onKeyDown: onKeyMap,
    onInput: onInput,
    onBlur: onBlur,
    onFocus: onFocus,
    ref: inputEl,
    className: "gv__text-input__field gv__form__field",
    role: autoSuggest ? "combobox" : null,
    "aria-autocomplete": autoSuggest ? "list" : null,
    "aria-activedescendant": autoSuggest ? "" : null,
    "aria-owns": autoSuggest ? "" : null,
    "aria-haspopup": autoSuggest ? "true" : null,
    "aria-expanded": autoSuggest ? `${autosuggestState.isOpen}` : null
  }), typeAheadReset && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "gv__text-input--reset",
    onClick: () => {
      resetInput();
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 14L14 2M2 2L14 14L2 2Z",
    stroke: "#CCCCCC",
    "stroke-width": "2"
  }))), renderSuggestions(), /*#__PURE__*/_react.default.createElement("span", {
    "aria-live": "assertive",
    "aria-atomic": "true",
    className: "gv__text-input__error-msg gv__form__error-msg",
    id: errorId
  }, error && errorMsg), /*#__PURE__*/_react.default.createElement("span", {
    "aria-live": "polite",
    "aria-atomic": "true",
    className: "gv__text-input__error-msg gv__form__error-msg",
    id: warningId
  }, warning && warningMsg));
};
TextInput.propTypes = propTypes; // defined at the top of the file
var _default = exports.default = TextInput;

},{"classnames":"classnames","lodash.throttle":"lodash.throttle","prop-types":"prop-types","react":"react","react-responsive":"react-responsive"}],157:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
// https://blog.logrocket.com/how-to-get-previous-props-state-with-react-hooks/
function usePrevious(value) {
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}
var _default = exports.default = usePrevious;

},{"react":"react"}],158:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _audio = require("./audio.js");
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const initPDFViewer = (el, i) => {
    const allDropdowns = el.querySelectorAll(".js-gv__pdf-viewer__dropdown");
    const downloadBtn = el.querySelector(".js-gv__pdf-viewer__download-button");
    const shareBtn = el.querySelector(".js-gv__pdf-viewer__share-button");
    const printButton = el.querySelector(".js-print");
    const audioBtn = el.querySelector(".js-gv__pdf-viewer__audio-button");
    // const searchBtn = el.querySelector(".js-gv__pdf-viewer__search-button");
    //const searchDropdown = el.querySelector(".js-gv__pdf-viewer__search-interaction");
    const versionSelect = el.querySelector(".js-gv__pdf-viewer__pdf-select");
    const versions = versionSelect.querySelectorAll("option");
    const directDownloadLink = el.querySelector(".js-direct-download-pdf");
    const checkBoxes = el.querySelectorAll(".js-gv__pdf-viewer__checkbox-text");
    const redirectOnDownloadBtn = el.querySelector(".js-gv__pdf-viewer__download-button-redirect") !== null;
    const audioPlayerMount = document.querySelector(".js-pdf-audio__mount");
    let focusBuffer = setTimeout(() => {}, 1);
    let styleBuffer = setTimeout(() => {}, 1);
    let audioPlayer;

    //directDownloadLink && directDownloadLink.setAttribute("href", versionSelect.value);

    if (audioPlayerMount) {
      audioPlayer = (0, _audio.initAudioPlayer)(audioPlayerMount);
    }
    const updateAlertBanner = value => {
      const banners = document.querySelectorAll(".js-toggle-pdf-banners");
      banners.forEach(element => {
        if (element.getAttribute("data-value") === value) {
          element.classList.add("show");
        } else {
          element.classList.remove("show"); // Remove 'show' from non-matching elements
        }
      });
    };
    if (versions.length <= 1) {
      const versionContainer = el.querySelector(".gv__pdf-viewer__pdf-source");
      versionSelect.style.display = "none";
      const versionTitle = document.createElement("span");
      //versionTitle.classList.add("gv__pdf-viewer__pdf-source-replace");
      //versionTitle.textContent = versions[0].text;
      //versionContainer.appendChild(versionTitle);
      versionContainer.querySelector(".gv__pdf-viewer__label");
      // versionContainer.style.display = "flex";
      // versionContainer.style.alignItems = "center"
      const banner = document.querySelector(".js-toggle-pdf-banners");
      banner && banner.classList.add("show");
    } else {
      updateAlertBanner(versionSelect.value);
    }
    const updateDownloadLink = e => {
      const pdfFile = e.currentTarget.value;
      directDownloadLink?.setAttribute("href", pdfFile);
      updateAlertBanner(pdfFile);
    };

    /*     const closeViewerDropdowns = (e) => {
          searchDropdown.classList.add("hidden");
          searchDropdown.setAttribute("aria-hidden", true);
          searchBtn.classList.remove("toggled");
          searchBtn.setAttribute("aria-expanded", false);
        }; */

    const closeAllDropdowns = e => {
      //downloadBtn && downloadBtn.setAttribute("aria-expanded", false);
      //shareBtn && shareBtn.setAttribute("aria-expanded", false);
      //searchBtn.setAttribute("aria-expanded", false);
      audioBtn && audioBtn.setAttribute("aria-expanded", false);
      const dropdowns = el.querySelectorAll("[data-flyout]");
      audioPlayer && audioPlayer.pause();
      window.downloadTrigger && window.downloadTrigger.setCardType(null);
      [...dropdowns].forEach(x => x.classList.contains("is-open") ? x.classList.remove("is-open") : null);
    };
    const positionTriangle = (triangle, div, button) => {
      triangle.removeAttribute("style");
      clearTimeout(styleBuffer);
      styleBuffer = setTimeout(() => {
        const buttonLeft = button.getBoundingClientRect().left;
        const divLeft = div.getBoundingClientRect().left;
        const widthAdjuster = button.getBoundingClientRect().width / 4;
        const trianglePosition = buttonLeft - divLeft + widthAdjuster;
        triangle.style.left = `${trianglePosition}px`;
        triangle.style.right = "auto";
      }, 10);
    };
    const toggleDropdown = (e, type) => {
      const button = e.target.closest("button");
      //closeViewerDropdowns(e);
      clearTimeout(focusBuffer);
      const parent = e.target.closest(".js-gv__pdf-viewer__dropdown-container");
      const div = parent.querySelector(`[data-flyout=${type}]`);
      const triangle = parent.querySelector(".js-dropdown-triangle");
      if (div.classList.contains("is-open")) {
        closeAllDropdowns(e);
      } else {
        closeAllDropdowns(e);
        button.setAttribute("aria-expanded", true);
        div.classList.add("is-open");
        positionTriangle(triangle, div, button);
        focusBuffer = setTimeout(() => {
          div.querySelectorAll("input,button,a,.fp-middle") && div.querySelectorAll("input,button,a")[0].focus();
        }, 350);
        if (type === "download") {
          window.downloadTrigger && window.downloadTrigger.setCardType(type);
        }
      }
    };

    /*     const searchAdjustments = (e) => {
          closeAllDropdowns(e);
          const button = e.target.closest("button");
          clearTimeout(focusBuffer);
          const div = document.querySelector(".js-gv__pdf-viewer__search-interaction");
          const triangle = div.querySelector(".js-dropdown-triangle");
          positionTriangle(triangle, div, button);
        }; */

    const toggleCheckbox = e => {
      if (e.key === "Enter") {
        e.target.previousElementSibling.checked = !e.target.previousElementSibling.checked;
      }
    };
    const closeOnShiftTab = e => {
      if (e.key === "Tab" && e.shiftKey) {
        closeAllDropdowns(e);
      }
    };
    const closeOnTab = e => {
      if (e.key === "Tab" && !e.shiftKey) {
        closeAllDropdowns(e);
      }
    };
    const redirectUnauthenticatedUser = e => {
      const redirectUrl = el.querySelector("#UnauthenticatedRedirectUrl").value;
      window.location.href = redirectUrl;
    };
    if (document.querySelectorAll(".gv__pdf-viewer__dropdown").length) {
      document.querySelector("body").addEventListener("keyup", e => {
        if (e.key === "Escape") {
          closeAllDropdowns(e);
        }
      });
    }
    if (printButton) {
      printButton.addEventListener("click", e => {
        console.log("%cweb/OWH.Web/OWH/assets-source/js/pdf-viewer.js:148 object", "color: #007acc;", "print");
        // const iwindow = window.frames['articleViewer'];
        // const iprint = iwindow.document.execCommand('print', false, null);
        // if (!iprint) {
        //   iwindow.print();
        // }
      });
    }
    if (redirectOnDownloadBtn) {
      downloadBtn && downloadBtn.addEventListener("click", e => redirectUnauthenticatedUser(e));
    } else {
      downloadBtn && downloadBtn.addEventListener("click", e => toggleDropdown(e, "download"));
    }
    if (shareBtn || /*searchBtn ||*/downloadBtn || audioBtn) {
      let buttons = [audioBtn, downloadBtn, shareBtn /*,searchBtn*/];
      let dropdowns = [].slice.call(allDropdowns);
      let triggers = buttons.concat(dropdowns);
      document.querySelector("body").addEventListener("click", e => {
        // have to add check for IE11
        if (e.path) {
          if (!e.path.some(x => triggers.includes(x))) {
            closeAllDropdowns(e);
          }
        }
      });
    }

    //searchBtn.addEventListener("click", (e) => searchAdjustments(e));
    audioBtn && audioBtn.addEventListener("click", e => toggleDropdown(e, "audio"));
    versionSelect.addEventListener("change", e => updateDownloadLink(e));
    [...checkBoxes].forEach(checkbox => checkbox.addEventListener("keydown", e => toggleCheckbox(e)));
    [...allDropdowns].forEach(dropdown => {
      let selectable = dropdown.querySelectorAll("a, button, input");
      if (selectable.length) {
        selectable[0].addEventListener("keydown", e => closeOnShiftTab(e));
        selectable[selectable.length - 1].addEventListener("keydown", e => closeOnTab(e));
        if (selectable[selectable.length - 1].disabled) {
          // if the final button is disabled, we want to add the event listener to the last.
          selectable[selectable.length - 2].addEventListener("keydown", e => {
            // have to double check in case the status has changed
            if (selectable[selectable.length - 1].disabled) {
              closeOnTab(e);
            }
          });
        }
      }
    });
  };
  if (document.querySelector("body.experience-editor") === null) {
    [...document.querySelectorAll(".js-gv__pdf-viewer__mount")].forEach(initPDFViewer);
  }
}
if (document.querySelector(".js-gv__pdf-viewer__toggle-expand")) {
  document.querySelector(".js-gv__pdf-viewer__toggle-expand").addEventListener("click", ev => {
    ev.preventDefault();
    console.log("click1");
    document.querySelector(".js-focus-visible").requestFullscreen();
  });
}

},{"./audio.js":26}],159:[function(require,module,exports){
"use strict";

require("core-js/features/object/assign.js");
require("core-js/features/object/entries.js");
require("core-js/features/array/find.js");
require("core-js/features/array/find-index.js");
require("core-js/features/array/fill.js");
require("core-js/features/array/includes.js");
require("core-js/features/string/includes.js");
require("core-js/features/array/from.js");
require("core-js/features/promise/index.js");
require("core-js/features/promise/finally.js");
require("core-js/features/symbol");
require("core-js/features/url");
require("core-js/features/url-search-params");
require("unfetch/polyfill");
require("abortcontroller-polyfill");
require("objectFitPolyfill/dist/objectFitPolyfill.basic.min.js");
var _picturefill = _interopRequireDefault(require("picturefill"));
require("focus-visible");
require("whatwg-fetch");
require("core-js/features/map/index.js");
require("core-js/features/set/index.js");
var _smoothscrollPolyfill = _interopRequireDefault(require("smoothscroll-polyfill"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//abort controller

// window.fetch

// for react 16
// https://facebook.github.io/react/blog/2017/09/26/react-v16.0.html#javascript-environment-requirements

//smooth scrolling in Safari, IE11

_smoothscrollPolyfill.default.polyfill();

//closest for IE11
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

//IE11 append
// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/append()/append().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty("append")) {
      return;
    }
    Object.defineProperty(item, "append", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function append() {
        var argArr = Array.prototype.slice.call(arguments),
          docFrag = document.createDocumentFragment();
        argArr.forEach(function (argItem) {
          var isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });
        this.appendChild(docFrag);
      }
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

//IE11 foreach
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

//IE11 Remove

// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty("remove")) {
      return;
    }
    Object.defineProperty(item, "remove", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode === null) {
          return;
        }
        this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

},{"abortcontroller-polyfill":"abortcontroller-polyfill","core-js/features/array/fill.js":"core-js/features/array/fill.js","core-js/features/array/find-index.js":"core-js/features/array/find-index.js","core-js/features/array/find.js":"core-js/features/array/find.js","core-js/features/array/from.js":"core-js/features/array/from.js","core-js/features/array/includes.js":"core-js/features/array/includes.js","core-js/features/map/index.js":"core-js/features/map/index.js","core-js/features/object/assign.js":"core-js/features/object/assign.js","core-js/features/object/entries.js":"core-js/features/object/entries.js","core-js/features/promise/finally.js":"core-js/features/promise/finally.js","core-js/features/promise/index.js":"core-js/features/promise/index.js","core-js/features/set/index.js":"core-js/features/set/index.js","core-js/features/string/includes.js":"core-js/features/string/includes.js","core-js/features/symbol":"core-js/features/symbol","core-js/features/url":"core-js/features/url","core-js/features/url-search-params":"core-js/features/url-search-params","focus-visible":"focus-visible","objectFitPolyfill/dist/objectFitPolyfill.basic.min.js":"objectFitPolyfill/dist/objectFitPolyfill.basic.min.js","picturefill":"picturefill","smoothscroll-polyfill":"smoothscroll-polyfill","unfetch/polyfill":"unfetch/polyfill","whatwg-fetch":"whatwg-fetch"}],160:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = printRoster;
function printRoster() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const triggerButton = document.querySelectorAll(".js-print-roster");
  [...triggerButton].forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      const studentContainer = document.querySelector(".js-gv__students-tab");
      if (studentContainer) {
        print();
      }
    });
  });
  const getStudentData = () => {
    const allStudents = document.querySelectorAll(".js-gv__edit-students");
    let studentString = "<table class='gv__print-table'><tr class='gv__print-table__heading'><th>First Name</th><th>Last Name</th><th>Email</th></tr>";
    [...allStudents].forEach(student => {
      const data = JSON.parse(student.dataset.student);
      studentString += `<tr><td>${data.firstName}</td><td>${data.lastName}</td><td>${data.email}</td></tr>`;
    });
    studentString += "</table>";
    return studentString;
  };
  const print = () => {
    const studentData = getStudentData();
    const windowObj = window.open("", "PrintWindow", "width=600,height=500,toolbars=no");
    const style = windowObj.document.createElement("style");
    style.type = "text/css";
    const css = `.gv__print-table { border-collapse: collapse; font-size: 1rem; font-family: HelveticaNeue, Helvetica, sans-serif, "Apple Color Emoji",
  "Segoe UI Emoji", "Segoe UI Symbol"; width: 100%;} .gv__print-table__heading {border-bottom: 2px solid #363636;} th {text-align:left} th, td { padding: 1.2rem} tr {border-bottom: 1px solid #363636;}`;
    windowObj.document.write(`<table>${studentData}</table>`);
    windowObj.document.head.appendChild(style);
    style.appendChild(windowObj.document.createTextNode(css));
    windowObj.focus();
    windowObj.print();
  };
}

},{}],161:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _reactModal = _interopRequireDefault(require("react-modal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PrivacyPolicyModal = props => {
  const [modalIsOpen, setModalIsOpen] = (0, _react.useState)(true);
  const [generalError, setGeneralError] = (0, _react.useState)(null);
  const [displayError, setDisplayError] = (0, _react.useState)(false);
  const checkboxInput = (0, _react.useRef)();
  const modalTitleRef = (0, _react.useRef)();
  const url = window.location.href;
  const param = new URLSearchParams(location.search).get("returnUrl");
  const submitForm = e => {
    e.preventDefault();
    if (checkboxInput.current.checked) {
      acceptPrivacy();
    } else {
      setDisplayError(true);
      checkboxInput.current.focus();
    }
  };
  const acceptPrivacy = () => {
    const params = {};
    fetch(`${props.requestUrl}/owh/user/AcceptActivePrivacyPolicy`, {
      method: "POST",
      body: JSON.stringify(params),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => response.json()).then(data => {
      if (data.IsValid) {
        closeModal();
        if (url.includes("returnUrl")) {
          window.location.replace(param);
        }
      } else {
        setGeneralError(data.Errors[0]);
        setDisplayError(true);
      }
    }).catch(error => {
      console.log(error);
    });
  };
  const handleChange = () => {
    if (displayError && checkboxInput.current.checked) {
      setDisplayError(false);
    }
  };
  const openModal = e => {
    (void 0).setState({
      modalIsOpen: true
    });
    e.target.setAttribute("aria-expanded", true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
  };
  const impCloseModal = () => {
    setCookie("impersonationPPClosed", true, 1);
    setModalIsOpen(false);
  };
  const afterOpenModal = () => {
    modalTitleRef.current.focus();
  };
  const CloseButtonDisplay = () => {
    if (props.isImpersonation) {
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        id: "close-btn",
        onClick: impCloseModal
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: "/OWH/assets-build/img/icons/x-close.svg",
        alt: ""
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__visually-hidden"
      }, "Close"));
    }
  };
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    //exdays from now
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";";
  }
  const {
    title,
    subtitle,
    checkboxText,
    buttonText,
    errorText
  } = props;
  const labelledBy = (0, _classnames.default)("acceptTerms", {
    acceptTermsError: displayError
  });
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: modalIsOpen,
    onAfterOpen: afterOpenModal,
    onRequestClose: closeModal,
    contentLabel: "Accept New Policy",
    bodyOpenClassName: null,
    overlayClassName: "gv__modal",
    className: "gv__modal__content",
    shouldCloseOnOverlayClick: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__privacy-modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__close-button"
  }, CloseButtonDisplay()), /*#__PURE__*/_react.default.createElement("h1", {
    tabIndex: "-1",
    ref: modalTitleRef,
    className: "gv__privacy-modal__title gv__page-title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__privacy-modal__subtitle gv__rte",
    dangerouslySetInnerHTML: {
      __html: subtitle
    }
  }), /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => submitForm(e)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item gv__form__item--checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: "acceptTerms",
    "aria-labelledby": labelledBy,
    type: "checkbox",
    placeholder: "",
    "aria-required": "true",
    "data-type": "checkbox",
    name: "text",
    className: "gv__form__field",
    ref: checkboxInput,
    onChange: () => handleChange()
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "acceptTerms",
    id: "acceptTermsLabel",
    className: "gv__form__label",
    dangerouslySetInnerHTML: {
      __html: checkboxText
    }
  }), displayError && /*#__PURE__*/_react.default.createElement("span", {
    role: "alert",
    className: "gv__form__error-msg has-error",
    id: "acceptTermsError"
  }, errorText)), generalError && /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__form__error-msg gv__form__error-msg--general has-error"
  }, generalError), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__privacy-modal__button-row gv__button-row"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "gv__button"
  }, buttonText)))));
};
PrivacyPolicyModal.propTypes = {
  title: _propTypes.string,
  subtitle: _propTypes.string,
  checkboxText: _propTypes.string,
  buttonText: _propTypes.string,
  errorText: _propTypes.string,
  requestUrl: _propTypes.string
};
var _default = exports.default = PrivacyPolicyModal;

},{"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-modal":"react-modal"}],162:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _PrivacyPolicyModal = _interopRequireDefault(require("./PrivacyPolicyModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//This is the original version of the community drawer with the RTE. We've preserved it since some pages are still using it

const el = document.querySelector(".js-privacy-policy-modal-mount");
if (el) {
  const props = {
    title: el.dataset.title || "",
    subtitle: el.dataset.subtitle || "",
    checkboxText: el.dataset.checkboxText || "",
    buttonText: el.dataset.buttonText || "",
    errorText: el.dataset.errorText || "",
    requestUrl: el.dataset.requestUrl || "",
    isImpersonation: el.dataset.isImpersonation
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_PrivacyPolicyModal.default, props), el);
}

},{"./PrivacyPolicyModal.jsx":161,"react":"react","react-dom":"react-dom"}],163:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const FeaturedWebinars = props => {
  const {
    data,
    bookLabel,
    joinLabel
  } = props;
  const [link, setLink] = (0, _react.useState)();
  const [linkText, setLinkText] = (0, _react.useState)();
  const linkDisplay = data => {
    if (data.zoomUrl) {
      setLink(data.zoomUrl);
      setLinkText(joinLabel);
    } else {
      setLink(data.eventLandingUrl);
      setLinkText(bookLabel);
    }
  };
  const directLink = e => {
    const link = e.currentTarget.querySelector(".js-link-src").getAttribute("href");
    window.location = link;
  };
  (0, _react.useEffect)(() => {
    if (data) {
      linkDisplay(data);
    }
  }, [data]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__featured"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `gv__teacher-resources__items__featured-item gv__material-item-card__container ${data.thumbnailImageUrl ? "" : "no-thumbnail"}`,
    onClick: e => directLink(e)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__featured-item__row"
  }, data.thumbnailImageUrl && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__featured-item__image gv__teacher-resources__featured-item__image--with-video"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: data.thumbnailImageUrl,
    alt: data.thumbnailImageAlt
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__featured-item__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__featured-item__head"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "gv__teacher-resources__items__featured-item__title"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: link,
    className: "js-link-src"
  }, /*#__PURE__*/_react.default.createElement("span", null, data.name)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__featured-item__body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__teacher-resources__items__featured-item__subtitle"
  }, data.topic), /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__teacher-resources__items__featured-item__date"
  }, data.dateSummary)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__featured-item__cta"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: link,
    className: "gv__teacher-resources__items__featured-item__btn"
  }, linkText))))));
};
var _default = exports.default = FeaturedWebinars;

},{"react":"react"}],164:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _FeaturedWebinars = _interopRequireDefault(require("./FeaturedWebinars.jsx"));
var _UpcomingWebinars = _interopRequireDefault(require("./UpcomingWebinars.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LearningWebinar = props => {
  const {
    webinarID,
    bookLabel,
    joinLabel
  } = props;
  const [featuredWebinar, setFeaturedWebinar] = (0, _react.useState)({});
  const [upcomingWebinars, setUpcomingWebinars] = (0, _react.useState)([]);
  const featuredWebinarsDisplay = () => {
    if (featuredWebinar) {
      return /*#__PURE__*/_react.default.createElement(_FeaturedWebinars.default, {
        data: featuredWebinar,
        bookLabel: bookLabel,
        joinLabel: joinLabel
      });
    }
  };
  const upcomingWebinarsDisplay = () => {
    if (upcomingWebinars) {
      return upcomingWebinars.map((webinar, i) => {
        return /*#__PURE__*/_react.default.createElement(_UpcomingWebinars.default, {
          data: webinar,
          bookLabel: bookLabel,
          joinLabel: joinLabel,
          key: `webinar-${i}`
        });
      });
    }
  };
  (0, _react.useEffect)(() => {
    fetch(`/owh/pd/GetProfessionLearningUpcomingWebinars?overrideFeaturedWebinarItemId=${webinarID}`).then(response => response.json()).then(data => {
      setFeaturedWebinar(data.result.featuredWebinar);
      setUpcomingWebinars(data.result.upcomingWebinars);
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__main-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__container"
  }, featuredWebinarsDisplay(), upcomingWebinars.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__content gv__material-item-card__container"
  }, upcomingWebinarsDisplay()))));
};
var _default = exports.default = LearningWebinar;

},{"./FeaturedWebinars.jsx":163,"./UpcomingWebinars.jsx":165,"prop-types":"prop-types","react":"react"}],165:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const UpcomingWebinars = props => {
  const {
    data,
    bookLabel,
    joinLabel
  } = props;
  const [link, setLink] = (0, _react.useState)();
  const [linkText, setLinkText] = (0, _react.useState)();
  const linkDisplay = data => {
    if (data.zoomUrl) {
      setLink(data.zoomUrl);
      setLinkText(joinLabel);
    } else {
      setLink(data.eventLandingUrl);
      setLinkText(bookLabel);
    }
  };
  const directLink = e => {
    const link = e.currentTarget.querySelector(".js-link-src").getAttribute("href");
    window.location = link;
  };
  (0, _react.useEffect)(() => {
    if (data) {
      linkDisplay(data);
    }
  }, [data]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__item gv__material-item-card__container js-link-area",
    onClick: e => directLink(e)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__type"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon icon--blue icon--medium"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: data.icon,
    alt: "Webinar icon"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__content"
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: "gv__teacher-resources__items__item__head"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "gv__teacher-resources__items__item__title"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: link,
    className: "js-link-src"
  }, /*#__PURE__*/_react.default.createElement("span", null, data.name)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__item__body"
  }, /*#__PURE__*/_react.default.createElement("p", null, data.topic), /*#__PURE__*/_react.default.createElement("p", null, data.dateSummary)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__featured-item__cta"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: link,
    className: "gv__teacher-resources__items__featured-item__btn"
  }, linkText)))));
};
var _default = exports.default = UpcomingWebinars;

},{"react":"react"}],166:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _LearningWebinar = _interopRequireDefault(require("./LearningWebinar.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const elements = document.querySelectorAll(".js-webinar-mount");
if (elements) {
  elements.forEach(element => {
    const webinarID = element.getAttribute("data-webinar");
    const bookLabel = element.getAttribute("data-book-label");
    const joinLabel = element.getAttribute("data-join-label");
    const webinarContainer = element.querySelector(".js-webinar-container");
    const props = {
      webinarID: webinarID,
      bookLabel: bookLabel,
      joinLabel: joinLabel
    };
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_LearningWebinar.default, props), webinarContainer);
  });
}

},{"./LearningWebinar.jsx":164,"react":"react","react-dom":"react-dom"}],167:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _lodash = _interopRequireDefault(require("lodash.debounce"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const setMax = () => {
  const windowHeight = window.innerHeight;
  const documentHeight = document.body.clientHeight;
  const maxHeight = documentHeight - windowHeight;
  return maxHeight;
};
const setValue = el => {
  const value = window.pageYOffset;
  el.setAttribute("value", value);
};
const initProgressBar = el => {
  el.setAttribute("max", setMax());
  const debouncedScroll = (0, _lodash.default)(setValue, 10);
  window.addEventListener("scroll", () => {
    debouncedScroll(el);
  });
  window.addEventListener("resize", () => {
    el.setAttribute("max", setMax());
  });
};
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-progress-bar")].forEach(initProgressBar);
}

},{"lodash.debounce":"lodash.debounce"}],168:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var R = _interopRequireWildcard(require("ramda"));
var fakeQuizQuestion = _interopRequireWildcard(require("./fake-quiz-question.json"));
var fakeQuizValidation = _interopRequireWildcard(require("./text-quiz-validation.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //Patternlab dummy data
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
_reactModal.default.setAppElement(document.querySelector(".js-page-content-wrapper"));
class Quiz extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const buttons = document.querySelectorAll(".js-take-quiz");
      this.checkIsDesktop();
      if (buttons) {
        buttons.forEach(button => {
          button.addEventListener("click", this.openModal);
        });
      }
      window.addEventListener("resize", () => this.checkIsDesktop());

      // check if Preview Mode
      if (this.props.previewQuestions) {
        const firstQuestion = this.props.previewQuestions.quizQuestions[0];
        this.setState({
          showIntro: false,
          showQuiz: true,
          questionText: firstQuestion.QuestionText,
          questionGuid: firstQuestion.QuestionGuid,
          questionImage: firstQuestion.QuestionImage,
          answers: this.randomizeAnswers(firstQuestion.Answers),
          previewQuestionsIndex: 0
        });
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      const buttons = document.querySelectorAll(".js-take-quiz");
      if (buttons) {
        buttons.forEach(button => button.setAttribute("aria-expanded", false));
      }
    });
    _defineProperty(this, "checkIsDesktop", () => {
      const isDesktop = window.innerWidth > 970;
      const isDesktopExisting = this.state.isDesktop;
      if (isDesktop !== isDesktopExisting) {
        this.setState({
          isDesktop
        });
      }
    });
    _defineProperty(this, "initialScreen", () => {
      const {
        practiceQuestionsLabel,
        beginTitle,
        beginSummary,
        beginButtonLabel,
        beginIcon
      } = this.props.dictionary;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__intro"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__intro-text"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__quiz-modal__practice-questions"
      }, practiceQuestionsLabel), /*#__PURE__*/_react.default.createElement("h1", {
        className: "gv__quiz-modal__begin-title"
      }, beginTitle), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__begin-summary"
      }, /*#__PURE__*/_react.default.createElement("p", null, beginSummary)), /*#__PURE__*/_react.default.createElement("button", {
        className: "gv__quiz-modal__button gv__button gv__button--arrow gv__button--rounded",
        onClick: () => this.fetchQuiz(),
        type: "button"
      }, beginButtonLabel, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__button__icon"
      }, /*#__PURE__*/_react.default.createElement("svg", {
        role: "img",
        width: "7",
        height: "12",
        "aria-labelledby": "arrowTitle",
        viewBox: "0 0 7 12",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("title", {
        id: "arrowTitle"
      }), /*#__PURE__*/_react.default.createElement("g", {
        strokeWidth: "1.3",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "square"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M1 10.95L5.95 6M1 1l4.95 4.95"
      })))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__begin-icon"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: beginIcon,
        alt: ""
      })));
    });
    _defineProperty(this, "endingScreen", () => {
      const {
        completeBottomMessage,
        completeTopMessage,
        completeIcon
      } = this.props.dictionary;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__complete"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__complete-text"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "gv__quiz-modal__complete-top"
      }, completeTopMessage), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__complete-icon"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: completeIcon,
        alt: ""
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__complete-bottom"
      }, completeBottomMessage)));
    });
    _defineProperty(this, "fetchQuiz", () => {
      const params = {
        assignmentId: this.props.assignmentId,
        QuizId: this.props.quizId,
        periodId: this.props.periodId
      };
      if (this.props.isPatternlab) {
        //TEST DATA 
        const question = fakeQuizQuestion.NextQuestion;
        this.setState({
          questionText: question.QuestionText,
          questionGuid: question.QuestionGuid,
          questionImage: question.QuestionImage,
          showIntro: false,
          showQuiz: true,
          answers: this.randomizeAnswers(question.Answers),
          threshold: fakeQuizQuestion.Threshold
        });
      } else {
        //real data
        fetch(`${this.props.requestUrl}/owh/quiz/StartQuiz`, {
          method: "POST",
          body: JSON.stringify(params),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => response.json()).then(data => {
          if (data.IsValid) {
            const question = data.NextQuestion;
            this.setState({
              questionText: question.QuestionText,
              questionGuid: question.QuestionGuid,
              questionImage: question.QuestionImage,
              answers: this.randomizeAnswers(question.Answers),
              showIntro: false,
              showQuiz: true,
              threshold: data.Threshold,
              assignmentId: data.AssignmentId
            });
          } else {
            let {
              generalError
            } = this.state;
            generalError.error = true;
            generalError.errorMsg = data.Errors[0];
            this.setState({
              generalError
            });
          }
        }).catch(error => {
          console.log(error);
        });
      }
    });
    _defineProperty(this, "evaluateAnswer", e => {
      e.preventDefault();
      let {
        generalError,
        currentAnswerId,
        submittedAnswerIds
      } = this.state;
      submittedAnswerIds.push(currentAnswerId);
      this.setState({
        submittedAnswerIds
      });
      if (this.state.currentAnswerId.length === 0) {
        generalError.error = true;
        generalError.errorMsg = this.props.quizErrorText;
        this.setState({
          generalError
        });
      } else {
        const params = {
          AssignmentId: this.state.assignmentId,
          QuizId: this.props.quizId,
          QuestionId: this.state.questionGuid,
          AnswerId: this.state.currentAnswerId,
          SubmittedAnswer: submittedAnswerIds.length,
          PeriodId: this.props.periodId
        };
        if (this.props.isPatternlab) {
          //fake data testing
          const answersRationale = this.state.answersRationale;
          answersRationale.push({
            AnswerId: currentAnswerId,
            Rationale: fakeQuizValidation.WrongAnswerRationale
          });
          let answerResult = Math.random() < 0.5;
          if (!answerResult) {
            answerResult = submittedAnswerIds.length === fakeQuizQuestion.NextQuestion.Answers.length - 1 ? true : answerResult;
          }
          if (answerResult) {
            //checking if it's the correct answer
            this.setState({
              isRightAnswer: answerResult,
              rightAnswerId: currentAnswerId,
              generalError: generalError,
              answersRationale: fakeQuizValidation.AnswersRationale,
              nextQuestion: fakeQuizQuestion.NextQuestion,
              submitted: true,
              threshold: submittedAnswerIds.length === 1 ? [...this.state.threshold, answerResult] : this.state.threshold
            }, () => {
              this.setState({
                hasMastered: this.checkThreshold()
              });
            });
          } else {
            //answer is wrong
            this.setState({
              generalError: generalError,
              isRightAnswer: answerResult,
              rightAnswerId: currentAnswerId,
              answersRationale: answersRationale,
              nextQuestion: fakeQuizQuestion.NextQuestion,
              submitted: true,
              threshold: submittedAnswerIds.length === 1 ? [...this.state.threshold, answerResult] : this.state.threshold
            }, () => {
              this.setState({
                hasMastered: this.checkThreshold()
              });
            });
            this.formRef.current.querySelector("input:checked").focus();
          }
        } else {
          // real data
          fetch(`${this.props.requestUrl}/owh/quiz/GradeQuestion`, {
            method: "POST",
            body: JSON.stringify(params),
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json"
            }
          }).then(response => response.json()).then(data => {
            if (data.IsError) {
              // isError checking if server issue
              generalError.error = true;
              generalError.errorMsg = data.ErrorText;
              this.setState({
                generalError
              });
            } else {
              //reset error
              generalError.error = false;
              generalError.errorMsg = "";
              if (data.IsRightAnswer) {
                //checking if it's the correct answer
                this.setState({
                  isRightAnswer: data.IsRightAnswer,
                  rightAnswerId: currentAnswerId,
                  generalError: generalError,
                  answersRationale: data.AnswersRationale,
                  hasMastered: data.HasMastered,
                  nextQuestion: data.NextQuestion,
                  submitted: true,
                  threshold: data.Threshold
                });
              } else {
                //answer is wrong
                const answersRationale = this.state.answersRationale;
                answersRationale.push({
                  AnswerId: currentAnswerId,
                  Rationale: data.WrongAnswerRationale
                });
                this.setState({
                  generalError: generalError,
                  isRightAnswer: data.IsRightAnswer,
                  rightAnswerId: currentAnswerId,
                  answersRationale: answersRationale,
                  hasMastered: data.HasMastered,
                  nextQuestion: data.NextQuestion,
                  submitted: true,
                  threshold: data.Threshold
                });
                this.formRef.current.querySelector("input:checked").focus();
              }
            }
          }).catch(error => {
            console.log(error);
          });
        }
      }
    });
    _defineProperty(this, "openModal", e => {
      if (this.props.modalId) {
        const targetButton = e.target.localName !== "button" ? e.target.offsetParent : e.target;
        if (targetButton.localName === "button" && targetButton.dataset.quizModalId === this.props.modalId) {
          this.setState({
            modalIsOpen: true
          });
          e.target.setAttribute("aria-expanded", true);
        }
      } else {
        this.setState({
          modalIsOpen: true
        });
        e.target.setAttribute("aria-expanded", true);
      }
      if (this.props.previewQuestions) {
        const targetButton = e.target.localName !== "button" ? e.target.offsetParent : e.target;
        const previewQuestionIndex = R.findIndex(R.propEq("QuestionGuid", targetButton.dataset.questionId))(this.props.previewQuestions.quizQuestions);
        const currentQuestion = this.props.previewQuestions.quizQuestions[previewQuestionIndex];
        this.setState({
          modalIsOpen: true,
          previewQuestionsIndex: previewQuestionIndex || 0,
          showIntro: false,
          showQuiz: true,
          questionText: currentQuestion.QuestionText,
          questionGuid: currentQuestion.QuestionGuid,
          questionImage: currentQuestion.QuestionImage,
          answers: this.randomizeAnswers(currentQuestion.Answers)
        });
      }
    });
    _defineProperty(this, "closeModal", () => {
      if (this.props.updateParent) {
        this.props.updateParent();
      }
      this.setState({
        modalIsOpen: false
      }, () => {
        if (window && !this.props.previewQuestions) {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    });
    _defineProperty(this, "handleAnswerSelect", e => {
      this.setState({
        currentAnswerId: e.target.value
      });
    });
    _defineProperty(this, "checkInput", (e, answerGuid) => {
      e.preventDefault();
      if (this.state.isRightAnswer === false || this.props.previewQuestions) {
        this.setState({
          currentAnswerId: answerGuid
        });
        // e.currentTarget.querySelector("input").focus();
      }
    });
    _defineProperty(this, "handleNextQuestion", e => {
      e.preventDefault();
      const {
        nextQuestion
      } = this.state;
      this.setState({
        questionText: nextQuestion.QuestionText,
        questionGuid: nextQuestion.QuestionGuid,
        answers: this.randomizeAnswers(nextQuestion.Answers),
        questionImage: nextQuestion.QuestionImage,
        submitted: false,
        //reset submitted
        nextQuestion: {},
        //reset nextquestion
        currentAnswerId: "",
        //reset selected answer
        isRightAnswer: false,
        //reset isRightAnswer
        answersRationale: [],
        //reset answers rational
        rightAnswerId: null,
        // reset right answer id
        submittedAnswerIds: [] // reset submitted answerids
      });
    });
    _defineProperty(this, "handleNextPracticeQuestion", e => {
      const newPreviewIndex = this.state.previewQuestionsIndex + 1;
      const newQuestion = this.props.previewQuestions.quizQuestions[newPreviewIndex];
      this.setState({
        previewQuestionsIndex: newPreviewIndex,
        questionText: newQuestion.QuestionText,
        questionGuid: newQuestion.QuestionGuid,
        answers: this.randomizeAnswers(newQuestion.Answers),
        questionImage: newQuestion.QuestionImage
      });
    });
    _defineProperty(this, "renderFilledBars", () => {
      const quizBars = new Array(this.props.totalQuestionCount).fill(null);
      return quizBars.map((bar, i) => {
        const quizClass = (0, _classnames.default)("gv__quiz-modal__bar", {
          "gv__quiz-modal__bar--filled": this.state.threshold[i],
          "gv__quiz-modal__bar--gray": this.state.threshold[i] !== undefined && !this.state.threshold[i]
        });
        return /*#__PURE__*/_react.default.createElement("div", {
          key: i,
          className: quizClass
        });
      });
    });
    _defineProperty(this, "renderProgressBar", () => {
      const {
        threshold,
        isRightAnswer,
        submittedAnswerIds,
        hasMastered,
        isDesktop
      } = this.state;
      const {
        correctLabel,
        streakLess4WrongAnswerLabel,
        QuizCompleteMessage,
        QuizNotPassTryAgain,
        QuizNotStarted
      } = this.props.dictionary;
      const isEndOfQuiz = threshold.length === this.props.totalQuestionCount;
      const labelClasses = (0, _classnames.default)("gv__quiz-modal__progress-bar-label", {
        "gv__quiz-modal__progress-bar-label--correct": isRightAnswer || hasMastered,
        "gv__quiz-modal__progress-bar-label--incorrect": threshold.length < this.props.totalQuestionCount && submittedAnswerIds.length > 0 && !isRightAnswer || isEndOfQuiz && this.getThreshold() === 0 && isRightAnswer
      });
      const starClasses = (0, _classnames.default)("gv__quiz-modal__progress-star", {
        "gv__quiz-modal__progress-star--mastered": hasMastered && isEndOfQuiz && isRightAnswer,
        "gv__quiz-modal__progress-star--notmastered": !hasMastered && isEndOfQuiz && isRightAnswer
      });
      let label;
      if (hasMastered) {
        label = QuizCompleteMessage;
      } else if (threshold.length < this.props.totalQuestionCount && submittedAnswerIds.length > 0 && !isRightAnswer) {
        label = streakLess4WrongAnswerLabel;
      } else if (threshold.length < this.props.totalQuestionCount && submittedAnswerIds.length > 0 && isRightAnswer) {
        label = `${correctLabel}!`;
      } else {
        label = QuizNotStarted;
      }
      if (threshold.length === this.props.totalQuestionCount && !hasMastered && isRightAnswer) {
        label = QuizNotPassTryAgain;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__left"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: labelClasses
      }, label), " ", /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__progress-bar-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__progress-bar"
      }, this.renderFilledBars()), /*#__PURE__*/_react.default.createElement("div", {
        className: starClasses
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__quiz-modal__progress-star-img"
      }, /*#__PURE__*/_react.default.createElement("svg", {
        role: "img",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
        id: "a",
        d: "M0 .12h20v18.694H0z"
      })), /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(0 .718)",
        fill: "none",
        fillRule: "evenodd"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.66.522l2.52 5c.107.212.314.36.554.394l5.635.802c.604.086.845.81.408 1.228L15.7 11.838a.71.71 0 00-.211.637l.962 5.496c.103.588-.527 1.037-1.067.759l-5.04-2.595a.75.75 0 00-.685 0L4.617 18.73c-.54.278-1.17-.171-1.067-.76l.963-5.495a.711.711 0 00-.212-.637L.223 7.946C-.213 7.529.027 6.804.63 6.718l5.636-.802a.735.735 0 00.554-.394l2.52-5a.743.743 0 011.32 0",
        fill: "currentColor",
        mask: "url(#b)"
      }))))), isDesktop && /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__quiz-modal__streak-label"
      }, `${correctLabel}: ${this.getThreshold()}/${this.props.totalQuestionCount}`)));
    });
    _defineProperty(this, "resetButtons", e => {
      this.setState({
        shouldContinue: true,
        threshold: [] // restart practice counter
      });
      this.handleNextQuestion(e);
    });
    _defineProperty(this, "handleQuizIsDone", () => {
      this.setState({
        showComplete: this.state.hasMastered,
        modalIsOpen: this.state.hasMastered,
        showQuiz: false
      }, () => {
        if (window && !this.state.showComplete && !this.props.previewQuestions) {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    });
    _defineProperty(this, "renderButtons", () => {
      const {
        doneLabel,
        checkAnswerLabel,
        keepPracticingLabel,
        nextQuestionLabel,
        closeLabel
      } = this.props.dictionary;
      const {
        previewQuestions
      } = this.props;
      const {
        threshold,
        currentAnswerId,
        isRightAnswer,
        submittedAnswerIds,
        previewQuestionsIndex
      } = this.state;
      const isDisabled = !!currentAnswerId && (submittedAnswerIds.length === 0 && currentAnswerId || submittedAnswerIds.length > 0 && currentAnswerId && isRightAnswer || !submittedAnswerIds.find(answerId => answerId === currentAnswerId)) ? false : true;
      if (!previewQuestions) {
        if (threshold.length === this.props.totalQuestionCount && isRightAnswer) {
          //"close"
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
            onClick: e => this.resetButtons(e),
            type: "button",
            className: "gv__button--secondary gv__button gv__quiz-modal__button gv__quiz-modal__button--quiz gv__button--rounded"
          }, keepPracticingLabel), /*#__PURE__*/_react.default.createElement("button", {
            onClick: this.handleQuizIsDone,
            type: "button",
            className: "gv__button gv__quiz-modal__button gv__quiz-modal__button--quiz gv__button--rounded"
          }, doneLabel));
        } else if (threshold.length < this.props.totalQuestionCount && submittedAnswerIds.length > 0 && isRightAnswer) {
          return /*#__PURE__*/_react.default.createElement("button", {
            type: "button",
            className: "gv__button  gv__quiz-modal__button gv__quiz-modal__button--quiz gv__button--rounded",
            onClick: e => this.handleNextQuestion(e)
          }, nextQuestionLabel);
        } else {
          return /*#__PURE__*/_react.default.createElement("button", {
            type: "submit",
            className: "gv__button  gv__quiz-modal__button gv__quiz-modal__button--quiz gv__button--rounded",
            disabled: isDisabled
          }, checkAnswerLabel);
        }
      } else {
        //if it's a practice mode
        const lengthCheck = previewQuestions.quizQuestions.length === previewQuestionsIndex + 1;
        if (lengthCheck) {
          return /*#__PURE__*/_react.default.createElement("button", {
            type: "button",
            className: "gv__button  gv__quiz-modal__button gv__quiz-modal__button--quiz gv__button--rounded",
            onClick: () => this.closeModal()
          }, closeLabel && closeLabel);
        } else {
          return /*#__PURE__*/_react.default.createElement("button", {
            type: "button",
            className: "gv__button  gv__quiz-modal__button gv__quiz-modal__button--quiz gv__button--rounded",
            onClick: e => this.handleNextPracticeQuestion(e)
          }, nextQuestionLabel);
        }
      }
    });
    _defineProperty(this, "afterOpenModal", () => {
      document.querySelectorAll(".gv__quiz-modal")[0].focus();
    });
    _defineProperty(this, "renderRationale", checkRationale => {
      if (checkRationale.length > 0) {
        return checkRationale.shift().Rationale;
      } else {
        return null;
      }
    });
    _defineProperty(this, "renderAnswers", answer => {
      const {
        AnswerText,
        AnswerGuid,
        isCorrect,
        AnswerRationale
      } = answer;
      const {
        previewQuestions
      } = this.props;
      const {
        currentAnswerId,
        isRightAnswer,
        submittedAnswerIds,
        answersRationale,
        submitted,
        rightAnswerId
      } = this.state;
      const checkRationale = R.filter(R.propEq("AnswerId", AnswerGuid), answersRationale);
      const rationale = this.renderRationale(checkRationale);
      const itemClass = (0, _classnames.default)("gv__form__item js-form-item gv__quiz-modal__item", {
        "gv__quiz-modal__item--current": AnswerGuid === currentAnswerId && !isRightAnswer,
        "gv__quiz-modal__item--correct": isRightAnswer && rightAnswerId === AnswerGuid || isCorrect,
        "gv__quiz-modal__item--incorrect": submitted && !isRightAnswer && submittedAnswerIds.includes(AnswerGuid) || currentAnswerId !== rightAnswerId && isRightAnswer || previewQuestions && !isCorrect
      });
      const isDisabled = previewQuestions || submitted && submittedAnswerIds.includes(AnswerGuid) || isRightAnswer;
      const ariaLive = isRightAnswer && rightAnswerId === AnswerGuid ? "assertive" : isRightAnswer && rightAnswerId !== AnswerGuid ? "off" : !isRightAnswer ? "assertive" : "off";
      const ariaAtomic = isRightAnswer && rightAnswerId === AnswerGuid ? true : isRightAnswer && rightAnswerId !== AnswerGuid ? false : !isRightAnswer ? true : false;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: itemClass,
        key: AnswerGuid,
        onClick: e => this.checkInput(e, AnswerGuid)
      }, /*#__PURE__*/_react.default.createElement("input", {
        name: "quiz",
        id: `Input${AnswerGuid}`,
        type: "radio",
        className: "gv__quiz-modal__option gv__form__field",
        onChange: e => this.handleAnswerSelect(e),
        "aria-describedby": `Rationale${AnswerGuid}`,
        value: AnswerGuid,
        checked: this.state.currentAnswerId === AnswerGuid,
        disabled: isDisabled
      }), /*#__PURE__*/_react.default.createElement("label", {
        id: `Label${AnswerGuid}`,
        htmlFor: `Input${AnswerGuid}`,
        className: "gv__form__label gv__quiz-modal__option-label"
      }, AnswerText), /*#__PURE__*/_react.default.createElement("span", {
        "aria-live": ariaLive,
        "aria-atomic": ariaAtomic,
        id: `Rationale${AnswerGuid}`,
        className: "gv__quiz-modal__rationale"
      }, rationale && rationale, previewQuestions && AnswerRationale));
    });
    _defineProperty(this, "randomizeAnswers", answers => {
      return answers.sort(() => Math.random() - 0.5);
    });
    _defineProperty(this, "getThreshold", () => {
      const correctAnswers = this.state.threshold.filter(answer => answer);
      return correctAnswers ? correctAnswers.length : 0;
    });
    _defineProperty(this, "checkThreshold", () => this.getThreshold() >= this.props.totalQuestionCount - 1);
    this.state = {
      modalIsOpen: props.modalIsOpen || false,
      generalError: {
        error: false,
        errorMsg: ""
      },
      assignmentId: this.props.assignmentId,
      questionText: "",
      questionGuid: "",
      questionImage: "",
      answers: [],
      currentAnswerId: "",
      shouldContinue: false,
      isRightAnswer: false,
      rightAnswerId: null,
      isDesktop: true,
      submitted: false,
      submittedAnswerIds: [],
      answersRationale: [],
      threshold: [],
      showIntro: true,
      showComplete: false,
      showQuiz: false
    };
    this.formRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      questionHeader,
      correctLabel
    } = this.props.dictionary;
    const {
      previewQuestions
    } = this.props;
    const {
      generalError,
      questionText,
      questionImage,
      isDesktop,
      threshold,
      answers,
      showIntro,
      showQuiz,
      showComplete
    } = this.state;
    const modalClasses = (0, _classnames.default)("gv__modal__content gv__quiz-modal__content", {
      "gv__quiz-modal__content--intro": showIntro,
      "gv__quiz-modal__content--quiz": showQuiz,
      "gv__quiz-modal__content--complete": showComplete
    });
    const questionTextClass = (0, _classnames.default)("gv__quiz-modal__question-text", {
      "gv__quiz-modal__question-text--full": isDesktop && !questionImage
    });
    const mobileContainerClasses = (0, _classnames.default)("gv__quiz-modal__button-container", {
      "gv__quiz-modal__button-container--end": threshold.length === this.props.totalQuestionCount
    });
    const questionAreaClasses = (0, _classnames.default)("gv__quiz-modal__question-area", {
      "gv__quiz-modal__question-area--full": !questionImage
    });
    const buttonRowClasses = (0, _classnames.default)("gv__quiz-modal__button-row gv__button-row", {
      "gv__quiz-modal__button-row--end": previewQuestions
    });
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: questionHeader,
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: modalClasses,
      shouldReturnFocusAfterClose: false
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__quiz-modal__close"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 47.971 47.971",
      fill: "currentColor"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M28.228 23.986L47.092 5.122a2.998 2.998 0 000-4.242 2.998 2.998 0 00-4.242 0L23.986 19.744 5.121.88a2.998 2.998 0 00-4.242 0 2.998 2.998 0 000 4.242l18.865 18.864L.879 42.85a2.998 2.998 0 104.242 4.241l18.865-18.864L42.85 47.091c.586.586 1.354.879 2.121.879s1.535-.293 2.121-.879a2.998 2.998 0 000-4.242L28.228 23.986z"
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__visuallyhidden"
    }, " close")), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__quiz-modal",
      tabIndex: "-1"
    }, showIntro && this.initialScreen(), showComplete && this.endingScreen(), showQuiz && /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: e => this.evaluateAnswer(e),
      ref: this.formRef
    }, generalError.error && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__form__error-msg gv__form__error-msg--general has-error"
    }, generalError.errorMsg), /*#__PURE__*/_react.default.createElement("fieldset", {
      className: "gv__form__fieldset gv__quiz-modal__fieldset"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: questionAreaClasses
    }, !isDesktop && questionImage && /*#__PURE__*/_react.default.createElement("img", {
      src: questionImage,
      className: "gv__quiz-modal__image",
      alt: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: questionTextClass
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__quiz-modal__question-header"
    }, questionHeader), /*#__PURE__*/_react.default.createElement("legend", {
      className: "gv__form__legend gv__quiz-modal__question",
      dangerouslySetInnerHTML: {
        __html: questionText
      }
    })), isDesktop && questionImage && /*#__PURE__*/_react.default.createElement("img", {
      src: questionImage,
      className: "gv__quiz-modal__image",
      alt: "Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: `gv__quiz-modal__answers-area ${this.state.isRightAnswer ? "gv__quiz-modal__answers-area--answered" : ""}`
    }, answers && answers.map(answer => this.renderAnswers(answer)))), /*#__PURE__*/_react.default.createElement("div", {
      className: buttonRowClasses
    }, !previewQuestions && this.renderProgressBar(), isDesktop && this.renderButtons()), " ", !isDesktop && /*#__PURE__*/_react.default.createElement("div", {
      className: mobileContainerClasses
    }, !previewQuestions && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__quiz-modal__streak-label"
    }, `${correctLabel}: ${this.getThreshold()}/${this.props.totalQuestionCount}`), this.renderButtons()))));
  }
}
exports.default = Quiz;
_defineProperty(Quiz, "propTypes", {
  periodId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  requestUrl: _propTypes.string,
  dictionary: (0, _propTypes.shape)({
    checkAnswerLabel: _propTypes.string,
    keepPracticingLabel: _propTypes.string,
    correctLabel: _propTypes.string,
    nextQuestionLabel: _propTypes.string,
    closeLabel: _propTypes.string,
    doneLabel: _propTypes.string,
    streakLess4WrongAnswerLabel: _propTypes.string,
    practiceQuestionsLabel: _propTypes.string,
    practiceQuestions: _propTypes.string,
    beginTitle: _propTypes.string,
    beginSummary: _propTypes.string,
    beginButtonLabel: _propTypes.string,
    beginIcon: _propTypes.string,
    questionHeader: _propTypes.string,
    completeBottomMessage: _propTypes.string,
    completeTopMessage: _propTypes.string,
    completeIcon: _propTypes.string,
    isPatternlab: _propTypes.string,
    QuizNotPassTryAgain: _propTypes.string,
    QuizNotStarted: _propTypes.string,
    QuizCompleteMessage: _propTypes.string
  }),
  quizId: _propTypes.string,
  modalId: _propTypes.string,
  quizErrorText: _propTypes.string,
  previewQuestions: _propTypes.object,
  assignmentId: _propTypes.string,
  modalIsOpen: _propTypes.bool,
  updateParent: _propTypes.func,
  totalQuestionCount: _propTypes.number
});

},{"./fake-quiz-question.json":169,"./text-quiz-validation.json":171,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-modal":"react-modal"}],169:[function(require,module,exports){
module.exports={
  "IsValid": true,
  "AssignmentId": 20272,
  "NextQuestion": {
    "QuestionText": "When humans migrated out of Africa and reached as far as the Americas, what was one big advantage of moving along coastlines?",
    "QuestionGuid": "b6d71c70-9a25-4717-865a-91722b64754d",
    "QuestionImage": "https://spaceholder.cc/542x293",
    "Answers": [
      {"AnswerText": "1. The coast provided ample resources like marine life that could be eaten.", "AnswerGuid": "bc5330c0-e398-4f06-b59c-21cca3fb83bf"},
      {"AnswerText": "2. The climate was generally better along the coasts than further inland.", "AnswerGuid": "96dbd6d5-69c7-4ae3-8926-6b508bc52b33"},
      {"AnswerText": "3. The coast provided ample resources like marine life that could be eaten.", "AnswerGuid": "56dbed6d5-69c7-4ae3-8926-6b508bc52b33"},
      {"AnswerText": "4. It allowed larger networks of people to come together for spiritual or religious purposes.", "AnswerGuid": "36dbedd6d5-69c7-4ae3-8926-6b508bc52b33"}
    ]
  },
  "Threshold": []
}

},{}],170:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _Quiz = _interopRequireDefault(require("./Quiz.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const els = document.querySelectorAll(".js-quiz-modal-mount");
if (els) {
  els.forEach(el => {
    const props = {
      requestUrl: el.dataset.requestUrl || "",
      isPatternlab: el.dataset.isPatternlab || null,
      periodId: el.dataset.periodId || "",
      dictionary: JSON.parse(el.dataset.dictionary) || "",
      quizId: el.dataset.quizId || "",
      modalId: el.dataset.modalId || "",
      assignmentId: el.dataset.assignmentId || "",
      quizErrorText: el.dataset.quizError || "Please select an answer.",
      previewQuestions: el.dataset.questions && JSON.parse(el.dataset.questions) || null,
      totalQuestionCount: Number.parseInt(el.dataset.totalQuestionCount) || 5
    };
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_Quiz.default, props), el);
  });
}

},{"./Quiz.jsx":168,"react":"react","react-dom":"react-dom"}],171:[function(require,module,exports){
module.exports={
  "IsRightAnswer": true,
  "WrongAnswerRationale": "is this a rationale",
  "NextQuestion": {
    "QuestionText": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
    "QuestionGuid": "f5b4e3cb-7b0e-495a-a9bc-5cbb8faf13ed",
    "Answers": [
      {"AnswerText": "answer 1 testing test", "AnswerGuid": "ca1ba7fb-2793-41c3-b749-a4ebebef8f1d"},
      {"AnswerText": "what is answer 2", "AnswerGuid": "00e6389d-ec88-4920-b903-74bd5b2429ca"},
      {"AnswerText": "Lorem ipsum dolor sit amet", "AnswerGuid": "00e6389d-ec88-4920-b903-74bd5b2429ca"}
    ]
  },
  "IsError": false,
  "ErrorText": null,
  "HasMastered": false,
  "Threshold": [],
  "AnswersRationale": [
    {"AnswerId": "79f8319f-9269-4565-b305-e7eb50aeaea0", "Rationale": "is this a rationale"},
    {"AnswerId": "38301a6c-c437-436c-8299-7f78359aa7d3", "Rationale": "rationale 2"},
    {"AnswerId": "38301a6c-c437-436c-8299-7f78359aa7d3", "Rationale": "rationale 3"},
    {"AnswerId": "38301a6c-c437-436c-8299-7f78359aa7d3", "Rationale": "rationale 4"}
  ]
}

},{}],172:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
require("regenerator-runtime/runtime");
var _classnames = _interopRequireDefault(require("classnames"));
var _UpcomingEventsCard = _interopRequireDefault(require("../partials/UpcomingEventsCard.jsx"));
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
var _fakeEvents = _interopRequireDefault(require("./fake-events.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const propTypes = {
  events: (0, _propTypes.shape)({
    registeredEventsText: _propTypes.string,
    emptyLabel: _propTypes.string,
    pastEventsText: _propTypes.string,
    endpoint: _propTypes.string,
    pdTabId: _propTypes.string,
    returnAllEvents: _propTypes.bool
  }),
  isPatternlab: _propTypes.bool
};
const RegisteredEvents = props => {
  const {
    events,
    isPatternlab
  } = props;
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [registeredEventData, setRegisteredEventData] = (0, _react.useState)([]);
  const [showPastEvents, setShowPastEvents] = (0, _react.useState)(false);
  const [sortedEvents, setSortedEvents] = (0, _react.useState)([]);
  const [numberOfPastEvents, setNumberOfPastEvents] = (0, _react.useState)([]);
  const [numberOfUpcomingRegisteredEvents, setNumberOfUpcomingRegisteredEvents] = (0, _react.useState)([]);
  const {
    registeredEventsText,
    emptyLabel,
    pastEventsText,
    endpoint,
    pdTabId,
    returnAllEvents
  } = events;
  (0, _react.useEffect)(() => {
    if (isPatternlab) {
      setRegisteredEventData(_fakeEvents.default.events);
      return;
    }
    const fetchData = async url => {
      setIsLoading(true);
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        });
        if (!response.ok) {
          throw new Error(`Error! status: ${response.status}`);
        }
        const result = await response.json();
        setRegisteredEventData(result.result);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
        setIsLoading(false);
      }
    };
    const tab = document.getElementById(pdTabId);
    tab.addEventListener("click", () => {
      var endpoint2 = endpoint;
      if (returnAllEvents) {
        endpoint2 = endpoint + "?t=1";
      }
      fetchData(endpoint2);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(() => {
    const sortData = () => {
      const sorted = registeredEventData.sort((a, b) => {
        return new Date(a.startDate) - new Date(b.startDate);
      });
      const today = new Date();
      const setPastEventProp = sorted.map(event => {
        const startDate = new Date(event.startDate);
        if (startDate < today) {
          event.isPastEvent = true;
        } else {
          event.isPastEvent = false;
        }
        return event;
      });
      setSortedEvents(setPastEventProp);
    };
    sortData();
  }, [registeredEventData]);
  (0, _react.useEffect)(() => {
    const getNumberOfPastEvents = () => {
      const pastEventNumber = sortedEvents.filter(event => event.isPastEvent === true).length;
      setNumberOfPastEvents(pastEventNumber);
    };
    const getNumberOfUpcomingRegisteredEvents = () => {
      const upcomingEventNumber = sortedEvents.filter(event => event.isPastEvent === false).length;
      setNumberOfUpcomingRegisteredEvents(upcomingEventNumber);
    };
    getNumberOfPastEvents();
    getNumberOfUpcomingRegisteredEvents();
  }, [sortedEvents]);
  const handleChange = () => {
    setShowPastEvents(!showPastEvents);
  };
  const listingContainerClasses = (0, _classnames.default)("gv__upcoming-events__listing-container", {
    "gv__registered-events__listing-container--past": showPastEvents
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events gv__component"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__container gv__upcoming-events__container "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__registered-events__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__heading gv__registered-events__heading-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__registered-events__heading"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__upcoming-events__heading-title"
  }, registeredEventsText), !isLoading && /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__upcoming-events__heading-event-count"
  }, `(${numberOfUpcomingRegisteredEvents || 0})`)), numberOfPastEvents > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item gv__form__item--checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    className: "gv__form__field",
    id: "pastEventsCheckbox",
    checked: showPastEvents,
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "gv__form__label",
    htmlFor: "pastEventsCheckbox"
  }, pastEventsText, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__upcoming-events__heading-event-count"
  }, `(${numberOfPastEvents})`)))), isLoading && /*#__PURE__*/_react.default.createElement(_loading.default, {
    isLoading: isLoading
  }), !isLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: listingContainerClasses
  }, Boolean(sortedEvents.length) && sortedEvents.map((listing, i) => {
    return /*#__PURE__*/_react.default.createElement(_UpcomingEventsCard.default, _extends({
      key: i
    }, listing));
  })), numberOfUpcomingRegisteredEvents === 0 && !showPastEvents && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__registered-events__no-events"
  }, emptyLabel)))));
};
RegisteredEvents.propTypes = propTypes;
var _default = exports.default = RegisteredEvents;

},{"../partials/UpcomingEventsCard.jsx":141,"../partials/loading.jsx":150,"./fake-events.json":173,"classnames":"classnames","prop-types":"prop-types","react":"react","regenerator-runtime/runtime":"regenerator-runtime/runtime"}],173:[function(require,module,exports){
module.exports={
  "events": [
    {
      "dateSummary": "Nov 1 to Nov 5",
      "endDate": "2022-11-05T17:30:00",
      "eventLandingUrl": null,
      "name": "Test Event",
      "redirectUrl": "",
      "redirectUrlText": "",
      "registerLink": "",
      "registerLinkText": "",
      "shortDescription": "",
      "startDate": "2022-11-01T12:40:00",
      "telligentId": "447788",
      "courses": ["1750 to the Present", "World History – AP®"],
      "timeZone": null,
      "eventTopic": "World History Project AP®︎"
    },
    {
      "dateSummary": "3 Aug 2021 12:00 PM to 5 Aug 2021 2:00 PM",
      "endDate": "2023-01-12T15:00:00Z",
      "eventLandingUrl": null,
      "name": "OC For Social Studies 2021",
      "redirectUrl": "https://dev-community.oerproject.com/oc-for-social-studies/oc-for-social-studies-2021/w/registration-confirmation",
      "redirectUrlText": "",
      "registerLink": "http://google.com",
      "registerLinkText": "Register Link",
      "shortDescription": "",
      "startDate": "2023-01-10T13:00:00Z",
      "telligentId": "22",
      "courses": ["Project Score Add Extra Text for GVOS-2097"],
      "timeZone": "Eastern Time",
      "eventTopic": ""
    },
    {
      "dateSummary": "Date Summary",
      "endDate": "2022-12-01T21:44:00Z",
      "eventLandingUrl": null,
      "name": "QA Event Test for PD",
      "redirectUrl": "https://www.google.com/",
      "redirectUrlText": "Event Redirect URL",
      "registerLink": "https://www.google.com/",
      "registerLinkText": "Event Register Link",
      "shortDescription": "Lorem ipsum. Lorem ipsum. Lorem ipsum. Lorem ipsum. Lorem ipsum. <strong>Add extra text</strong> to verify height of event items.",
      "startDate": "2022-11-28T20:11:00Z",
      "telligentId": "22",
      "courses": ["Big History"],
      "timeZone": "Eastern Time",
      "eventTopic": "State Conference"
    }
  ]
}

},{}],174:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _RegisteredEvents = _interopRequireDefault(require("./RegisteredEvents.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-registered-events-mount");
if (el) {
  const props = {
    events: JSON.parse(el.dataset.events) || {},
    isPatternlab: el.dataset.isPatternlab ? JSON.parse(el.dataset.isPatternlab) : false
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_RegisteredEvents.default, props), el);
}

},{"./RegisteredEvents.jsx":172,"react":"react","react-dom":"react-dom"}],175:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _d3Distribution = _interopRequireDefault(require("./charts/d3Distribution.js"));
var _d3Investigations = _interopRequireDefault(require("./charts/d3Investigations.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  document.querySelectorAll(".js-report-graph-distribution").forEach(el => {
    const data = el.dataset.scores.split(",").map(v => parseInt(v));
    _d3Distribution.default.create({
      el,
      data: data,
      label: el.dataset.label || "",
      isCurrent: current
    });
  });
  document.querySelectorAll(".js-report-graph-average").forEach(el => {
    const data = el.dataset.data && JSON.parse(el.dataset.data);
    const barData = el.dataset.scores && el.dataset.scores.split(",").map(v => parseInt(v)); // for old graphs
    const labelledBy = el.dataset.labelled || "";
    data && _d3Investigations.default.create({
      el,
      data: data,
      barData: data,
      label: el.dataset.label || "",
      color: el.dataset.color || "#213245",
      labelledBy: labelledBy
    });
  });
  document.querySelector("body").classList.add("js-loaded");
}

},{"./charts/d3Distribution.js":37,"./charts/d3Investigations.js":38}],176:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollDetection;
var _lodash = _interopRequireDefault(require("lodash.throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const inViewClassName = "in-view";
const initClass = ".js-scroll-into-view";
const mobileBp = 780;
function scrollDetection() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const elements = document.querySelectorAll(initClass);
  const handleScroll = () => {
    [...elements].forEach(el => {
      if (window.IntersectionObserver) {
        const observerCallback = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add(inViewClassName);
            }
          });
        };
        const options = {
          root: null,
          rootMargin: "-40% 0px -10%",
          threshold: 0.5
        };
        const observer = new IntersectionObserver(observerCallback, options);
        observer.observe(el);
      } else {
        if (window.innerWidth > mobileBp && window.scrollY >= el.offsetTop - 120) {
          el.classList.add(inViewClassName);
        }
      }
    });
  };
  if (elements) {
    window.addEventListener("load", handleScroll);
    window.addEventListener("scroll", (0, _lodash.default)(handleScroll, 100));
  }
}

},{"lodash.throttle":"lodash.throttle"}],177:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollDown;
function scrollDown() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const scrollDownLink = document.querySelector(".js-gv__scroll-down-link");
  if (!scrollDownLink) {
    return;
  }
  const pageLocation = scrollDownLink.getAttribute("href");
  function scrollDown(e) {
    e.preventDefault();
    document.querySelector(pageLocation).scrollIntoView({
      behavior: "smooth"
    });
  }
  scrollDownLink.addEventListener("click", scrollDown);
}

},{}],178:[function(require,module,exports){
"use strict";

/* This file is for links that scroll to items in the page.
    Not related to the left navigation
*/

// Add an event listener for all anchor links
const anchorLinks = document.querySelectorAll('.js-scroll-area a[href^="#"]');
const mobileViewport = window.matchMedia("(max-width: 970px)");
let pageOffset = 0;
const getOffset = () => {
  let lessonNavHeight = document.querySelector(".js-lesson-navigation") ? document.querySelector(".js-lesson-navigation").offsetHeight : 0;
  let globalHeaderHeight = document.querySelector(".js-global-header") ? document.querySelector(".js-global-header").offsetHeight : 0;
  let unitNavHeight = document.querySelector(".gv__unit-nav__wrapper") ? document.querySelector(".gv__unit-nav__wrapper").offsetHeight : 0;
  let breadcrumbHeight = document.querySelector(".gv__breadcrumbs") ? document.querySelector(".gv__breadcrumbs").offsetHeight : 0;
  if (mobileViewport.matches) {
    pageOffset = lessonNavHeight + globalHeaderHeight + unitNavHeight;
  } else {
    pageOffset = -breadcrumbHeight + 30;
  }
};
anchorLinks.forEach(link => {
  link.addEventListener("click", function (event) {
    event.preventDefault();
    getOffset();

    // Get the target element
    const targetId = this.getAttribute("href");
    const targetElement = document.querySelector(targetId);

    // Scroll to the target element with offset
    window.scrollTo({
      top: targetElement.offsetTop - pageOffset,
      behavior: "smooth"
    });
  });
});
let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    getOffset();
  }, 500);
});

},{}],179:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var R = _interopRequireWildcard(require("ramda"));
var _reactResponsive = require("react-responsive");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Pagination = props => {
  const numPages = Math.ceil(props.totalResults / 16);
  const [pageBlockRange, setPageBlockRange] = (0, _react.useState)(5);
  const numPagesVisible = Math.min(numPages, pageBlockRange);
  const showPrevious = props.currentPage !== 1;
  const showNext = props.currentPage < Math.ceil(props.totalResults / 16);
  const isMobile = (0, _reactResponsive.useMediaQuery)({
    query: '(max-width: 681px)'
  });
  (0, _react.useEffect)(() => {
    if (isMobile) {
      setPageBlockRange(3);
    } else {
      setPageBlockRange(5);
    }
  }, [isMobile]);
  const getStart = currentPage => {
    const potentialStart = currentPage - (pageBlockRange - 1);
    let start = currentPage - pageBlockRange === 1 ? 2 : Math.max(1, potentialStart);
    if (currentPage + pageBlockRange > numPages) {
      // (desired page range) - (Size of current page range)
      start -= numPagesVisible - (numPages - (start - 1));
    }
    return start;
  };
  const visiblePages = currentPage => {
    const start = getStart(currentPage);
    const pages = R.range(start, start + numPagesVisible);
    const finalPages = R.map(page => {
      return {
        num: page,
        label: page,
        current: page == currentPage
      };
    }, pages);
    return finalPages;
  };
  const pagination = () => {
    let pages = visiblePages(props.currentPage);
    const displayPages = pages.map(x => {
      const buttonClasses = (0, _classnames.default)("gv__search-results__pagination-button", {
        "is-active": x.current
      });
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "gv__search-results__pagination-item",
        key: x.num
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: buttonClasses,
        type: "button",
        onClick: e => props.handlePaginationClick(e, x.num)
      }, x.label));
    });
    return displayPages;
  };
  const start = getStart(props.currentPage);
  const previousButtonClass = (0, _classnames.default)("gv__search-results__pagination-prev-button gv__link");
  const nextButtonClass = (0, _classnames.default)("gv__search-results__pagination-next-button gv__link");
  const nextLiClass = (0, _classnames.default)("gv__search-results__pagination-next", {
    "has-dots": numPages > pageBlockRange && showNext && start !== numPages - pageBlockRange + 1
  }, {
    "gv__search-results__pagination-visible": showNext
  });
  const previousLiClass = (0, _classnames.default)("gv__search-results__pagination-prev", {
    "has-dots": numPages > pageBlockRange && start !== 1 && showPrevious
  }, {
    "gv__search-results__pagination-visible": showPrevious
  });
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "gv__search-results__pagination"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: previousLiClass
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.41 7.41L10.83 12L15.41 16.59L14 18L8 12L14 6L15.41 7.41Z",
    fill: "#213245"
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: previousButtonClass,
    type: "button",
    onClick: e => props.handlePreviousClick(e),
    disabled: !showPrevious
  }, props.searchPrevious)), pagination(), /*#__PURE__*/_react.default.createElement("li", {
    className: nextLiClass
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: nextButtonClass,
    type: "button",
    onClick: e => props.handleNextClick(e),
    disabled: !showNext
  }, props.searchNext), /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.59 7.41L13.17 12L8.59 16.59L10 18L16 12L10 6L8.59 7.41Z",
    fill: "#213245"
  }))));
};
Pagination.propTypes = {
  currentPage: _propTypes.number,
  index: _propTypes.number,
  handlePaginationClick: _propTypes.func,
  handleNextClick: _propTypes.func,
  handlePreviousClick: _propTypes.func,
  searchNext: _propTypes.string,
  searchPrevious: _propTypes.string,
  totalResults: _propTypes.number
};
var _default = exports.default = Pagination;

},{"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-responsive":"react-responsive"}],180:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SearchInput = _interopRequireDefault(require("../search-results/SearchInput.jsx"));
var _loading = _interopRequireDefault(require("../../partials/loading.jsx"));
var _useCanvasSearch = _interopRequireDefault(require("./useCanvasSearch.js"));
var _CanvasSearchResults = _interopRequireDefault(require("../../canvas-search-results/CanvasSearchResults.jsx"));
var _Pagination = _interopRequireDefault(require("../Pagination.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CanvasSearch = props => {
  const [searchDisplayToggled, setSearchDisplayToggled] = (0, _react.useState)(true);
  const [courses, setCourses] = (0, _react.useState)([]);
  const [units, setUnits] = (0, _react.useState)([]);
  const [types, setTypes] = (0, _react.useState)([]);
  const [selectedCourse, setSelectedCourse] = (0, _react.useState)("");
  const [selectedUnit, setSelectedUnit] = (0, _react.useState)("");
  const [selectedType, setSelectedType] = (0, _react.useState)("");
  const [unitsSelectDisabled, setUnitsSelectDisabled] = (0, _react.useState)(true);
  const [courseUnitId, setCourseUnitId] = (0, _react.useState)("");
  const [contentTypeId, setContentTypeId] = (0, _react.useState)("");
  const hideShowToggleButton = (0, _react.useRef)(null);
  const {
    inputText,
    handleSearchInputChange,
    onCanvasFormSubmit,
    facets,
    isLoading,
    results,
    totalResults,
    currentPage,
    handlePaginationClick,
    handlePreviousClick,
    handleNextClick,
    calculateNumShown,
    fetchQueryText
  } = (0, _useCanvasSearch.default)(props);
  const handleSearchDisplayToggle = () => {
    let timer;
    clearTimeout(timer);
    setSearchDisplayToggled(!searchDisplayToggled);
    timer = setTimeout(() => {
      hideShowToggleButton.current.focus();
    }, 50);
  };
  const handleSelect = event => {
    switch (event.target.name) {
      case "types":
        setSelectedType(event.target.value);
        break;
      case "units":
        setSelectedUnit(event.target.value);
        break;
      case "courses":
        setSelectedCourse(event.target.value);
        break;
    }
  };
  const handleClearAllFilters = () => {
    setSelectedCourse(courses[0].id);
    setSelectedType(types[0].id);
    setSelectedUnit(courses[0].values[0].id);
    onCanvasFormSubmit([]);
  };
  const handleForAllUnitsSelected = () => {
    if (selectedUnit.startsWith("ALL-")) {
      return selectedCourse;
    } else {
      return selectedUnit;
    }
  };
  const handleForAllTypesSelected = () => {
    // find the selected type
    // if it has values array
    // loop over each object in values array
    // push into a temp array
    // join and return that string
    // else return selectedType
    const selectedTypeObj = types.find(type => type.id === selectedType);
    if (selectedTypeObj.values) {
      const shallowCopy = selectedTypeObj.values.slice(1);
      let selectedTypeArray = [];
      shallowCopy.forEach(object => {
        selectedTypeArray.push(object.id);
      });
      return selectedTypeArray.join();
    } else {
      return selectedType;
    }
  };
  const handleCanvasFormSubmit = e => {
    e.preventDefault();
    let array = [];
    // if selected course does not start with "ALL"
    // insert into array
    if (!selectedCourse.startsWith("ALL-")) {
      const selectedUnits = handleForAllUnitsSelected();
      array.push({
        id: courseUnitId,
        value: selectedUnits
      });
    }
    if (!selectedType.startsWith("ALL-")) {
      const selectedTypes = handleForAllTypesSelected();
      array.push({
        id: contentTypeId,
        value: selectedTypes
      });
    }
    onCanvasFormSubmit(array);
  };
  function getDisplayedValue(value, children) {
    const selected = children.find(child => child.id === value);
    return selected?.label;
  }
  const renderSelectDropdown = function () {
    let listType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "courses";
    let selectDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let label = "",
      singularLabel = "",
      selected = "",
      selectName = "",
      selectId = "",
      disabled = false,
      options = [];
    switch (listType) {
      case "types":
        label = "Types";
        singularLabel = "Type";
        selectName = "types";
        selected = selectedType;
        disabled = selectDisabled;
        options = types;
        break;
      case "units":
        label = "Units";
        singularLabel = "Unit";
        selectName = "units";
        selected = selectedUnit;
        disabled = selectDisabled;
        options = units;
        break;
      default:
        label = "Courses";
        singularLabel = "Course";
        selectName = "courses";
        selected = selectedCourse;
        disabled = selectDisabled;
        options = courses;
        break;
    }
    selectId = `canvas-${selectName}-select`;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__select-input gv__form__item gv__canvas-select-input"
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: "gv__select-input__text gv__form__label gv__visuallyhidden",
      htmlFor: selectId
    }, label), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__select-input__input-wrapper"
    }, /*#__PURE__*/_react.default.createElement("select", {
      id: selectId,
      name: selectName,
      className: "gv__select-input__field gv__form__field gv__canvas-select-input__field",
      onChange: handleSelect,
      value: selected,
      disabled: disabled
    }, !!options.length && options.map((opt, index) => {
      const id = `${selectName}_${opt.id || index}`;
      if (opt.hide) return null;
      return /*#__PURE__*/_react.default.createElement("option", {
        key: id,
        value: opt.id
      }, opt.label);
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__select-input__field gv__form__field gv__canvas-select--presentational",
      disabled: disabled
    }, singularLabel, ": ", getDisplayedValue(selected, options))));
  };
  (0, _react.useEffect)(() => {
    const processCourses = () => {
      const coursesObject = facets.find(facet => facet.id === "c_courseunit");
      setCourseUnitId(coursesObject.id);
      const coursesArray = coursesObject?.values;
      setCourses(coursesArray);
    };
    const processUnits = () => {
      if (courses.length) {
        const selectedCourseObj = courses.find(course => course.selected);
        if (selectedCourseObj) {
          const unitsArray = selectedCourseObj.values;
          setUnits(unitsArray);
        } else {
          setUnits(courses[0].values);
        }
      }
    };
    const processTypes = () => {
      const typesObject = facets.find(facet => facet.id === "c_contenttype");
      setContentTypeId(typesObject.id);
      const typesArray = typesObject?.values;
      setTypes(typesArray);
    };
    if (facets.length) {
      processCourses();
      processUnits();
      processTypes();
    }
  }, [facets, courses]);
  (0, _react.useEffect)(() => {
    // handle for courses that have no units
    courses.forEach(course => {
      if (!course.values) {
        course.values = [{
          label: "All Units",
          id: `ALL-${course.id}`,
          number: 0,
          selected: false,
          values: null
        }];
      }
    });
  }, [courses]);
  (0, _react.useEffect)(() => {
    const processSelected = (array, fn) => {
      const selected = array.find(object => object.selected);
      if (selected) {
        fn(selected.id);
      } else if (array === units) {
        fn(courses[0].values[0].id);
      } else {
        fn(array[0].id);
      }
    };
    if (courses?.length && !selectedCourse) processSelected(courses, setSelectedCourse);
    if (units?.length && !selectedUnit) processSelected(units, setSelectedUnit);
    if (types?.length && !selectedType) processSelected(types, setSelectedType);
  }, [courses, types, units, selectedCourse, selectedType, selectedUnit]);
  (0, _react.useEffect)(() => {
    const findSelectedCourseUnits = () => {
      const selectedC = courses.find(course => selectedCourse === course.id);
      const units = selectedC?.values;
      setUnits(units);
    };
    const toggleEnableUnits = () => {
      // logic to disable/enable units dropdown
      // find which courses object is selected
      // if it is the first one, disable units select
      // else enable
      // this assumes that the 1st object is "all courses"
      if (selectedCourse === courses[0].id) {
        setUnitsSelectDisabled(true);
      } else {
        setUnitsSelectDisabled(false);
      }
    };
    const updateSelectedUnit = () => {
      if (units && units.length) {
        // if selectedCourse changes
        // check if any of its units are selected
        // if so set to that unit
        // else
        // reset selectedUnit to "all" / 1st obj
        // of the selected course units array
        const selectedU = units.find(unit => unit.selected);
        if (selectedU) {
          setSelectedUnit(selectedU.id);
        } else {
          setSelectedUnit(units[0].id);
        }
      }
    };
    if (courses.length && selectedCourse) {
      findSelectedCourseUnits();
      toggleEnableUnits();
      updateSelectedUnit();
    }
  }, [selectedCourse, courses, units]);
  const {
    dictionary
  } = props;
  const {
    inputString,
    searchShowing,
    searchOf,
    filterHeading,
    clearAll,
    searchPrevious,
    searchNext,
    filterResultsMobileLabel,
    showMoreLabel,
    viewIn,
    previewLabel,
    embedLabel,
    actionUrl
  } = dictionary;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-results__loading"
  }, /*#__PURE__*/_react.default.createElement(_loading.default, {
    isLoading: isLoading
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-container"
  }, searchDisplayToggled ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-input-container"
  }, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
    onFormSubmit: handleCanvasFormSubmit,
    newSearchQueryInput: {
      value: inputText
    },
    inputHint: inputString,
    handleSearchInputChange: handleSearchInputChange,
    onKeyUp: handleSearchInputChange
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: handleSearchDisplayToggle,
    className: "gv__link gv__toggle-search-button",
    "aria-expanded": searchDisplayToggled,
    ref: hideShowToggleButton
  }, "Hide", /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "13",
    viewBox: "0 0 16 13",
    fill: "none",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.00033 2.66667C9.84033 2.66667 11.3337 4.16 11.3337 6C11.3337 6.43333 11.247 6.84 11.0937 7.22L13.0403 9.16667C14.047 8.32667 14.8403 7.24 15.327 6C14.1737 3.07333 11.327 1 7.99366 1C7.06033 1 6.16699 1.16667 5.34033 1.46667L6.78033 2.90667C7.16033 2.75333 7.56699 2.66667 8.00033 2.66667ZM1.33366 0.846667L2.85366 2.36667L3.16033 2.67333C2.05366 3.53333 1.18699 4.68 0.666992 6C1.82033 8.92667 4.66699 11 8.00033 11C9.03366 11 10.0203 10.8 10.9203 10.44L11.2003 10.72L13.1537 12.6667L14.0003 11.82L2.18033 0L1.33366 0.846667ZM5.02033 4.53333L6.05366 5.56667C6.02033 5.70667 6.00033 5.85333 6.00033 6C6.00033 7.10667 6.89366 8 8.00033 8C8.14699 8 8.29366 7.98 8.43366 7.94667L9.46699 8.98C9.02033 9.2 8.52699 9.33333 8.00033 9.33333C6.16033 9.33333 4.66699 7.84 4.66699 6C4.66699 5.47333 4.80033 4.98 5.02033 4.53333ZM7.89366 4.01333L9.99366 6.11333L10.007 6.00667C10.007 4.9 9.11366 4.00667 8.00699 4.00667L7.89366 4.01333Z",
    fill: "#213245"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-filter-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-filter"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__filter-title"
  }, filterHeading ? filterHeading : "Filter by:"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: () => handleClearAllFilters(),
    className: "gv__search-facets__clear-all"
  }, clearAll ? clearAll : "Clear filters")), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-select"
  }, Boolean(courses?.length) && renderSelectDropdown("courses"), Boolean(units?.length) && renderSelectDropdown("units", unitsSelectDisabled), Boolean(types?.length) && renderSelectDropdown("types"), /*#__PURE__*/_react.default.createElement("button", {
    onClick: handleCanvasFormSubmit,
    className: "gv__button",
    "aria-label": "Apply"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "12",
    viewBox: "0 0 18 12",
    fill: "none",
    "aria-hidden": "true",
    className: "gv__canvas-button-svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 5H14.17L10.59 1.41L12 0L18 6L12 12L10.59 10.59L14.17 7H0V5Z",
    fill: "white"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__canvas-button-span"
  }, "Apply"))))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-button-container"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: handleSearchDisplayToggle,
    className: "gv__link gv__toggle-search-button",
    "aria-expanded": searchDisplayToggled,
    ref: hideShowToggleButton
  }, "Show search", /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "10",
    viewBox: "0 0 16 10",
    fill: "none",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.99935 0C4.66602 0 1.81935 2.07333 0.666016 5C1.81935 7.92667 4.66602 10 7.99935 10C11.3327 10 14.1793 7.92667 15.3327 5C14.1793 2.07333 11.3327 0 7.99935 0ZM7.99935 8.33333C6.15935 8.33333 4.66602 6.84 4.66602 5C4.66602 3.16 6.15935 1.66667 7.99935 1.66667C9.83935 1.66667 11.3327 3.16 11.3327 5C11.3327 6.84 9.83935 8.33333 7.99935 8.33333ZM7.99935 3C6.89268 3 5.99935 3.89333 5.99935 5C5.99935 6.10667 6.89268 7 7.99935 7C9.10602 7 9.99935 6.10667 9.99935 5C9.99935 3.89333 9.10602 3 7.99935 3Z",
    fill: "#213245"
  }))))), calculateNumShown() !== "" && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__canvas-search-results__number"
  }, searchShowing, " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__canvas-search-results__number-emphasis"
  }, calculateNumShown()), " ", searchOf, " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__canvas-search-results__number-emphasis"
  }, totalResults)), /*#__PURE__*/_react.default.createElement(_CanvasSearchResults.default, {
    results: results,
    previewLabel: previewLabel,
    embedLabel: embedLabel,
    actionUrl: actionUrl
  }), /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    currentPage: currentPage,
    handlePaginationClick: handlePaginationClick,
    handlePreviousClick: handlePreviousClick,
    handleNextClick: handleNextClick,
    searchPrevious: searchPrevious,
    searchNext: searchNext,
    totalResults: totalResults
  }));
};
CanvasSearch.propTypes = {
  requestUrl: _propTypes.string,
  dictionary: (0, _propTypes.shape)({
    inputString: _propTypes.string,
    searchShowing: _propTypes.string,
    searchOf: _propTypes.string,
    searchPrevious: _propTypes.string,
    searchNext: _propTypes.string,
    filterResultsMobileLabel: _propTypes.string,
    showMoreLabel: _propTypes.string,
    previewLabel: _propTypes.string,
    embedLabel: _propTypes.string,
    actionUrl: _propTypes.string
  })
};
var _default = exports.default = CanvasSearch;

},{"../../canvas-search-results/CanvasSearchResults.jsx":34,"../../partials/loading.jsx":150,"../Pagination.jsx":179,"../search-results/SearchInput.jsx":192,"./useCanvasSearch.js":182,"prop-types":"prop-types","react":"react"}],181:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _CanvasSearch = _interopRequireDefault(require("./CanvasSearch.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-canvas-search");
if (el) {
  const props = {
    requestUrl: el.dataset.requestUrl || "",
    dictionary: JSON.parse(el.dataset.dictionary) || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_CanvasSearch.default, props), el);
}

},{"./CanvasSearch.jsx":180,"react":"react","react-dom":"react-dom"}],182:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSearch;
var _react = require("react");
var R = _interopRequireWildcard(require("ramda"));
var _urijs = _interopRequireDefault(require("urijs"));
var _facets = require("../facets.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// local test
// import * as facetsData from "./search-facets.json";

let FETCH_COUNT = 0;
const URI_VARIABLE = new _urijs.default(window.location);
function useSearch(props) {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [results, setResults] = (0, _react.useState)([]);
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const [totalResults, setTotalResults] = (0, _react.useState)(0);
  const [inputText, setInputText] = (0, _react.useState)("");
  const [facets, setFacets] = (0, _react.useState)([]);
  const [fetchQueryText, setFetchQueryText] = (0, _react.useState)(() => {
    const searchParams = URI_VARIABLE.search(true);
    const term = searchParams.term ? searchParams.term : "";
    return term;
  });
  const createNewFacetObj = obj => {
    return Object.entries(obj).map(x => {
      return {
        id: x[0],
        value: x[1]
      };
    });
  };
  const [selectedFacets, setSelectedFacets] = (0, _react.useState)(() => {
    const currentQuery = R.omit(["term", "page", "share"], URI_VARIABLE.search(true));
    if (!R.isEmpty(currentQuery)) {
      return createNewFacetObj(currentQuery);
    } else {
      return [];
    }
  });
  const RESULTS_PER_PAGE = 10;
  const fetchSearchResults = (0, _react.useCallback)(() => {
    let focusTimer;
    let params = {
      term: fetchQueryText,
      page: currentPage,
      resultsPerPage: RESULTS_PER_PAGE,
      searchPageId: props.dictionary.searchPageId
    };
    FETCH_COUNT = FETCH_COUNT + 1;
    const fetchCount = FETCH_COUNT;
    if (!R.isEmpty(selectedFacets)) {
      params["selectedFacets"] = selectedFacets;
    }
    setIsLoading(true);

    // FE local test
    // setTimeout(() => {
    //   console.log("fetched");
    //   setFacets(facetsData.Facets);
    //   setIsLoading(false);
    // }, 3000);
    // return;
    // END FE local test

    fetch(`${props.requestUrl}`, {
      method: "POST",
      body: JSON.stringify(params),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => response.json()).then(data => {
      if (data.Message) {
        console.warn(data.Message);
        return;
      }
      if (FETCH_COUNT !== fetchCount) {
        return;
      }
      const results = data.Results.map(result => {
        return {
          id: result.id,
          url: result.url,
          title: result.title,
          summary: result.summary,
          material: result.material,
          thumbnail: result.thumbnail,
          definition: result.definition,
          listingTemplate: result.listingTemplate,
          wordForms: result.wordForms,
          vocabTermType: result.vocabTermType,
          canvasData: result.canvasData,
          courseUnit: result.courseUnit
        };
      });
      setTotalResults(data.TotalResultCount);
      setFacets(data.Facets);
      if (data.CurrentPage !== currentPage) {
        setCurrentPage(data.CurrentPage);
      }
      clearTimeout(focusTimer);
      if (!document.activeElement.classList.contains("gv__form__field")) {
        focusTimer = setTimeout(() => {
          if (document.querySelector(".gv__search-results__result .gv__link")) {
            document.querySelector(".gv__search-results__result .gv__link").focus();
            window.scrollTo({
              top: 100,
              behavior: "smooth"
            });
          }
        }, 50);
      }
      const preSelectedFacets = (0, _facets.allSelectedFacets)(data.Facets);
      const selectedState = preSelectedFacets;
      const selectedFormatted = selectedState.map(obj => {
        const id = obj.id;
        const value = obj.value;
        return {
          [id]: value
        };
      });
      if (currentPage) {
        const pageObj = {
          page: currentPage
        };
        selectedFormatted.unshift(pageObj);
      }
      selectedFormatted.unshift({
        share: "embed",
        term: fetchQueryText
      });
      const queryParams = R.mergeAll(selectedFormatted.map(x => x));
      const url = _urijs.default.decode((0, _urijs.default)(window.location.href).search(queryParams).toString());
      history.replaceState(null, null, url);
      setResults(results);
      setIsLoading(false);
    }).catch(err => {
      console.error(err);
      setIsLoading(false);
    });
    // excluding inputText in dependencies array
    // to not call API on every keystroke
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFacets, currentPage, fetchQueryText]);
  const onCanvasFormSubmit = selectedFacetsArray => {
    if (selectedFacetsArray.length) {
      setSelectedFacets(selectedFacetsArray);
    } else {
      setSelectedFacets([]);
    }
    setCurrentPage(1);
    setFetchQueryText(inputText);
  };
  const handleSearchInputChange = event => {
    setInputText(event.target.value);
  };
  const handlePaginationClick = (e, page) => {
    setCurrentPage(page);
  };
  const handlePreviousClick = e => {
    setCurrentPage(currentPage - 1);
  };
  const handleNextClick = e => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
  };
  const calculateNumShown = () => {
    let numberString;
    const max = currentPage * 10;
    const min = max - 9;
    if (results.length === 0) {
      numberString = "";
    } else if (results.length < 10 && results.length > 0) {
      numberString = min + " - " + totalResults;
    } else {
      numberString = min + " - " + max;
    }
    return numberString;
  };

  //on initial load, define setinputtext. [] MUST be empty
  (0, _react.useEffect)(() => {
    if (fetchQueryText !== "inputText") {
      setInputText(fetchQueryText);
    }
  }, [fetchQueryText]);
  (0, _react.useEffect)(() => {
    fetchSearchResults();
  }, [fetchSearchResults]);
  return {
    facets,
    results,
    totalResults,
    currentPage,
    inputText,
    isLoading,
    onCanvasFormSubmit,
    handleSearchInputChange,
    handlePaginationClick,
    handlePreviousClick,
    handleNextClick,
    calculateNumShown,
    fetchQueryText
  };
}

},{"../facets.js":183,"ramda":"ramda","react":"react","urijs":"urijs"}],183:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allSelectedFacets = allSelectedFacets;
exports.getParentId = getParentId;
exports.joinValues = joinValues;
exports.recursiveCurrentId = recursiveCurrentId;
exports.recursiveFacetGroupSelected = recursiveFacetGroupSelected;
exports.toggledGroup = toggledGroup;
var _ramda = _interopRequireDefault(require("ramda"));
var _helpers = require("../helpers.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** taken from Thread

/**
 * @typedef {Object} FacetValueShape
 * @property {Array} childValues Array of {@link FacetValueShape}
 * @property {number} count Number of available records
 * @property {string} id Identifier
 * @property {string} name Display Name
 * @property {boolean} selected Selection state
 */

/**
 * @typedef {Object} FacetGroupShape
 * @property {Array} childGroups Array of {@link FacetGroupShape}
 * @property {string} id Identifier for group

 * @property {string} label Display name for group
 * @property {array} values Array of {@link FacetValueShape}
 */

function getParentId(group, facets) {
  const flatFacets = (0, _helpers.flattenObj)(facets);
  const flatGroup = (0, _helpers.flattenObj)(group);
  let parentId;
  Object.entries(flatFacets).forEach(_ref => {
    let [key, value] = _ref;
    if (value === flatGroup.id) {
      const index = key.split(".")[0];
      parentId = flatFacets[`${index}.id`];
      return parentId;
    }
  });
  return parentId;
}
function recursiveCurrentId(group, facets, id) {
  let selected = [];
  //const getArray =  R.filter(R.propEq("id", id), group);
  const isId = group.id === id;
  let newGroup;
  if (isId) {
    newGroup = group;
  } else {
    if (group.hasOwnProperty("values") && group.values) {
      group.values.forEach(childGroup => {
        selected = selected.concat(recursiveCurrentId(childGroup, facets, id));
      });
    }
  }
  return selected = selected.concat([newGroup]);
}
function recursiveFacetGroupSelected(group, facets) {
  let selected = [];
  const checkSelected = _ramda.default.props(["selected"], group)[0];
  let newGroup;
  if (checkSelected) {
    newGroup = {
      id: getParentId(group, facets),
      value: group.id
    };
  }
  if (group.hasOwnProperty("values") && group.values) {
    group.values.forEach(childGroup => {
      selected = selected.concat(recursiveFacetGroupSelected(childGroup, facets));
    });
  }
  return selected = selected.concat([newGroup]);
}
function joinValues(arr, obj) {
  const filteredArr = arr.filter(o => o.id === obj.id);
  if (filteredArr.length) {
    filteredArr[0].value = filteredArr[0].value.concat(`,${obj.value}`);
  } else {
    arr.push(obj);
  }
  return arr;
}
/**
* adapted from Thread
 * Extract all facet value objects that are selected. Inclusive of all groups, subgroups and child values.
 * @param {Array<FacetGroupShape>} facets List of facet groups to be filtered
 * @returns {Array<FacetValueShape>} Only selected facet values
 */
function allSelectedFacets(facets) {
  const reducedFacets = facets.reduce((all, group) => {
    if (group.values) {
      return all.concat(recursiveFacetGroupSelected(group, facets));
    }
  }, []);
  const filteredFacets = reducedFacets.filter(x => x);
  const finalFacets = filteredFacets.reduce(joinValues, []);
  return finalFacets;
}
function toggledGroup(facets, id) {
  const reducedFacets = facets.reduce((all, group) => {
    if (group.values) {
      return all.concat(recursiveCurrentId(group, facets, id));
    }
  }, []);
  const filteredFacets = reducedFacets.filter(x => x);
  // const finalFacets = filteredFacets.reduce(joinValues, []);
  return filteredFacets;
}

},{"../helpers.js":110,"ramda":"ramda"}],184:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function Routes(_ref) {
  let {
    children
  } = _ref;
  let element = (0, _reactRouterDom.useRoutes)([{
    path: "/",
    element: children
  }]);
  return element;
}
Routes.propTypes = {
  children: _propTypes.node
};
var _default = exports.default = Routes;

},{"prop-types":"prop-types","react":"react","react-router-dom":"react-router-dom"}],185:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function useSearchParamsHook() {
  let [searchParams, setSearchParams] = (0, _reactRouterDom.useSearchParams)();
  const parameters = {};
  (0, _react.useEffect)(() => {
    for (const [key, value] of searchParams.entries()) {
      parameters[key] = value;
    }
  }, [parameters, searchParams]);
  return {
    parameters,
    setSearchParams
  };
}
var _default = exports.default = useSearchParamsHook;

},{"react":"react","react-router-dom":"react-router-dom"}],186:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = require("prop-types");
var _video = require("../../video.js");
var _classnames = _interopRequireDefault(require("classnames"));
var _ConditionalWrapper = _interopRequireDefault(require("../../partials/ConditionalWrapper.jsx"));
var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ResearchResultVideoModal = props => {
  const propTypes = {
    isOpen: _propTypes.string.isRequired,
    openModal: _propTypes.func
  };
  const {
    isOpen,
    closeModal,
    VideoViewModel,
    checked,
    handleCheck,
    afterOpenModal,
    cuePoints
  } = props;
  const videoId = VideoViewModel.VideoId;
  const videoModalClass = VideoViewModel ? "js-video-promo__modal" : " ";
  const hasCuepoints = cuePoints.length > 0;
  const [modalHeight, setModalHeight] = (0, _react.useState)("auto");
  const [modalExpanded, setModalExpanded] = (0, _react.useState)(true);
  const mountClassNames = (0, _classnames.default)("js-video-viewer__mount--modal flowplayer use-thin-controlbar use-play-2", {
    "is-checked": checked
  });
  const modalClassNames = (0, _classnames.default)("gv__modal__content gv__modal__content--video", {
    "gv__modal__content--video-cuepoints": hasCuepoints
  });
  const contentClass = (0, _classnames.default)("gv__video-viewer__content", {
    "gv__video-viewer__content--has-accordion js-accordion": hasCuepoints
  });
  const toggleHeight = e => {
    modalHeight !== 0 ? setModalHeight(0) : setModalHeight("auto");
    setModalExpanded(!modalExpanded);
  };

  //condition={hasCuepoints}
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: isOpen === videoId,
    bodyOpenClassName: null,
    overlayClassName: "gv__modal",
    className: modalClassNames,
    onAfterOpen: afterOpenModal,
    shouldCloseOnOverlayClick: true,
    onRequestClose: closeModal
  }, /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
    condition: hasCuepoints,
    wrapper: children => /*#__PURE__*/_react.default.createElement("div", {
      className: "js-gv__video-viewer__container gv__video-viewer__container"
    }, children)
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: closeModal,
    className: "gv__modal__close"
  }, "close"), /*#__PURE__*/_react.default.createElement("div", {
    className: mountClassNames,
    id: "async-player",
    "data-player-id": "252895bc-da7a-4bc4-9501-bcc79d1e9b25"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: contentClass
  }, hasCuepoints && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__video-viewer__lower js-gv__video-viewer__lower"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__video-viewer__pause"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    onChange: e => handleCheck(e),
    className: "gv__video-viewer__checkbox js-gv__video-viewer__checkbox",
    id: "pause-key-ideas"
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "pause-key-ideas",
    className: "gv__video-viewer__pause-text js-gv__video-viewer__pause-text"
  }, "Pause at Key Ideas"), " ", /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__video-viewer__expand gv__accordion-list__link",
    type: "button",
    onClick: e => toggleHeight(e),
    "aria-expanded": modalExpanded
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__visually-hidden"
  }, "Show Key Ideas")))), hasCuepoints && /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
    id: "keyframeAccordion",
    className: "gv__video-viewer__modal-key-ideas",
    duration: 500,
    height: modalHeight
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__video-viewer__key-ideas"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "gv__video-viewer__key-ideas-heading js-gv__video-viewer__count"
  }, "Key Ideas"), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__video-viewer__key-copy"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "js-gv__video-viewer__key-time gv__video-viewer__key-time"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "js-gv__video-viewer__key-ideas-description gv__video-viewer__key-ideas-description"
  }, "As this video progresses, key ideas will be introduced to invoke discussion.")))))));
};
var _default = exports.default = ResearchResultVideoModal;

},{"../../partials/ConditionalWrapper.jsx":135,"../../video.js":265,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-animate-height":"react-animate-height","react-modal":"react-modal"}],187:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _useSearchParams = _interopRequireDefault(require("../react-router/useSearchParams.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ResourceFacets = props => {
  const {
    parameters,
    setSearchParams
  } = (0, _useSearchParams.default)();
  const {
    courses,
    types,
    onFilterChange,
    selectedCourse,
    selectedType
  } = props;
  const ID_PREFIX = "RESOURCE_SEARCH_FACETS";
  const setType = value => {
    const selected = types.find(type => type.Value === value);
    if (selected) onFilterChange(selectedCourse, selected);
  };
  const setCourse = (0, _react.useCallback)(value => {
    const selected = courses.find(course => course.Value === value);
    if (selected) onFilterChange(selected, selectedType);
  });
  const handleSelect = event => {
    const value = event.target.value;
    switch (event.target.name) {
      case "types":
        setType(value);
        break;
      case "courses":
        setCourse(value);
        setSearchParams({
          filterID: value
        });
        break;
    }
  };
  const handleChange = event => {
    setType(event.target.value);
  };
  (0, _react.useEffect)(() => {
    setCourse(parameters["filterID"]);
  }, [parameters, setCourse]);
  const renderSelectDropdown = function (options) {
    let listType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "courses";
    let customClasses = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    let label = "",
      selectName = "",
      selected = "";
    switch (listType) {
      case "types":
        label = "Types";
        selectName = "types";
        selected = selectedType;
        break;
      default:
        label = "Courses";
        selectName = "courses";
        selected = selectedCourse;
        break;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `gv__resource-search__select-input gv__select-input ${customClasses}`
    }, /*#__PURE__*/_react.default.createElement("label", {
      className: "gv__select-input__text gv__form__label gv__visuallyhidden",
      htmlFor: "selectInput"
    }, label), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__select-input__input-wrapper"
    }, /*#__PURE__*/_react.default.createElement("select", {
      id: "selectInput",
      name: selectName,
      className: "gv__resource-search__select-input-field gv__select-input__field gv__form__field",
      onChange: handleSelect,
      value: selected.Value
    }, !!options.length && options.map((opt, index) => {
      const id = `${ID_PREFIX}_${selectName}_${opt.Value || index}`;
      return /*#__PURE__*/_react.default.createElement("option", {
        key: id,
        value: opt.Value,
        "data-index": index
      }, opt.Name);
    }))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderSelectDropdown(courses, "courses"), renderSelectDropdown(types, "types", "gv__resource-search__select-input--types gv__select-input--gray"), /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "gv__resource-search__facets",
    id: ID_PREFIX,
    "aria-labelledby": `${ID_PREFIX}_TOGGLE`
  }, !!types.length && types.map((facet, index) => {
    const id = `${ID_PREFIX}_RADIO_${facet.Value || index}`;
    const isChecked = selectedType.Value === facet.Value;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: id,
      className: "gv__resource-search__facet"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: "gv__resource-search__facet-input gv__visuallyhidden",
      type: "radio",
      name: "courses",
      value: facet.Value,
      id: id,
      onChange: handleChange,
      checked: isChecked
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "gv__resource-search__facet-label",
      htmlFor: id
    }, facet.Name));
  })));
};
ResourceFacets.prototype = {
  courses: _propTypes.array,
  types: _propTypes.array,
  onFilterChange: _propTypes.func,
  selectedType: _propTypes.object,
  selectedCourse: _propTypes.object
};
var _default = exports.default = ResourceFacets;

},{"../react-router/useSearchParams.jsx":185,"prop-types":"prop-types","react":"react"}],188:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ResourceResultItem = props => {
  const {
    Title,
    LengthAndType,
    LinkUrl,
    ImageUrl,
    dictionary,
    IsDownload,
    VideoViewModel,
    openModal,
    getModalInfo
  } = props;
  const target = !IsDownload ? "_blank" : VideoViewModel && !IsDownload ? null : null;
  const rel = !IsDownload ? "noopener noreferrer" : null;
  const videoModalClass = VideoViewModel ? "js-video-promo__modal" : " ";
  const cuepoints = VideoViewModel ? VideoViewModel.CuePoints : null;
  const videoTitle = VideoViewModel ? VideoViewModel.VideoTitle : null;
  const videoId = VideoViewModel ? VideoViewModel.VideoId : null;
  const videoPoster = VideoViewModel ? VideoViewModel.Thumbnail : null;
  const renderNewWindowIcon = () => {
    return /*#__PURE__*/_react.default.createElement("svg", {
      "aria-labelledby": "externalTitle",
      className: "icon",
      role: "img",
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("title", {
      id: "externalTitle"
    }, dictionary.newWindowLabel), /*#__PURE__*/_react.default.createElement("g", {
      strokeWidth: "1.3",
      fill: "none",
      fillRule: "evenodd",
      strokeLinejoin: "round"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M13 4V1h-3M13 1l-1 1M12 2L5.389 8.611"
    }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
      d: "M11 8.385V13H1V3h4.819"
    }))));
  };
  const renderDownloadIcon = () => {
    return /*#__PURE__*/_react.default.createElement("svg", {
      className: "icon",
      role: "img",
      "aria-labelledby": "downloadtitle",
      xmlns: "http://www.w3.org/2000/svg",
      height: "512pt",
      viewBox: "0 0 512 512",
      fill: "currentColor",
      width: "512pt"
    }, /*#__PURE__*/_react.default.createElement("title", {
      id: "downloadtitle"
    }, dictionary.downloadLabel), /*#__PURE__*/_react.default.createElement("path", {
      d: "M409.79 278.5 256 432.29 102.22 278.5l28.28-28.29L236 355.72V0h40v355.71l105.5-105.5zM512 472H0v40h512zm0 0"
    }));
  };
  if (VideoViewModel) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__resource-search__card gv__course-materials__card",
      tabIndex: "0",
      role: "button",
      "data-video-cuepoints": JSON.stringify({
        cuepoints
      }),
      "data-video-poster": videoPoster,
      "data-video-title": videoTitle,
      "data-primary-video": videoId,
      "data-placement-type": "modal",
      onClick: getModalInfo,
      onKeyUp: getModalInfo
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: ImageUrl,
      alt: "",
      className: "gv__course-materials__image"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-materials__card-title"
    }, Title), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-materials__card-info"
    }, !!LengthAndType && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-materials__card-type"
    }, LengthAndType)));
  } else {
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "gv__resource-search__card gv__course-materials__card",
      href: LinkUrl,
      download: IsDownload,
      target: target,
      rel: rel
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: ImageUrl,
      alt: "",
      className: "gv__course-materials__image"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-materials__card-title"
    }, Title), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-materials__card-info"
    }, !!LengthAndType && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-materials__card-type"
    }, LengthAndType), !!LinkUrl && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__course-materials__icon"
    }, IsDownload ? renderDownloadIcon() : renderNewWindowIcon())));
  }
};
ResourceResultItem.prototype = {
  Title: _propTypes.string,
  LengthAndType: _propTypes.string,
  LinkUrl: _propTypes.string,
  ImageUrl: _propTypes.string,
  dictionary: _propTypes.object,
  IsDownload: _propTypes.bool
};
var _default = exports.default = ResourceResultItem;

},{"prop-types":"prop-types","react":"react"}],189:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _ResourceResultItem = _interopRequireDefault(require("./ResourceResultItem.jsx"));
var _ResourceFacets = _interopRequireDefault(require("./ResourceFacets.jsx"));
var _loading = _interopRequireDefault(require("../../partials/loading.jsx"));
var _video = require("../../video.js");
var _propTypes = require("prop-types");
var _ResearchResultVideoModal = _interopRequireDefault(require("./ResearchResultVideoModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// For FE local testing
// import mockData from "./mockData.js";

const ResourceResults = props => {
  const {
    requestUrl,
    courses,
    types,
    pageId,
    dictionary
  } = props;
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [isServerError, setServerError] = (0, _react.useState)(false);
  const [results, setResults] = (0, _react.useState)([]);
  const [announceAlert, setAnnounceAlert] = (0, _react.useState)(false);
  const [selectedType, setSelectedType] = (0, _react.useState)(types[0] || {});
  const [selectedCourse, setSelectedCourse] = (0, _react.useState)(courses[0] || {});
  const ID_PREFIX = "RESOURCE-SEARCH";
  const [modalOpen, setModalOpen] = (0, _react.useState)("");
  const [checked, setChecked] = (0, _react.useState)(false);
  const [primaryVideo, setPrimaryVideo] = (0, _react.useState)("");
  const [secondaryVideo, setSecondaryVideo] = (0, _react.useState)("");
  const [videoTitle, setVideoTitle] = (0, _react.useState)("");
  const [subTitles, setSubTitles] = (0, _react.useState)([]);
  const [preload, setpreload] = (0, _react.useState)(false);
  const [poster, setPoster] = (0, _react.useState)("");
  const [cuepoints, setCuepoints] = (0, _react.useState)([]);
  const [videoGuid, setVideoGuid] = (0, _react.useState)("");
  const [trackVideo, setTrackVideo] = (0, _react.useState)(false);
  const [placementType, setPlacementType] = (0, _react.useState)("");
  const [player, setPlayer] = (0, _react.useState)({});
  const getModalInfo = e => {
    //if the user is using the keyboard return this function if they are not 
    // hitting enter to open the modal
    if (e.type === "keyup" && e.keyCode !== 13) {
      return;
    }
    const dataSource = e.currentTarget.dataset.primaryVideo ? e.currentTarget : e.currentTarget.closest("[data-primary-video]");
    setPrimaryVideo(dataSource.dataset.primaryVideo);
    setSecondaryVideo(dataSource.dataset.secondaryVideo);
    setVideoTitle(dataSource.dataset.videoTitle);
    const subtitles = dataSource.dataset.videoSubtitles ? JSON.parse(dataSource.dataset.videoSubtitles).subtitles : [];
    setSubTitles(subtitles);
    setpreload(dataSource.dataset.videoPreload);
    setPoster(dataSource.dataset.videoPoster);
    const cuepoints = dataSource.dataset.videoCuepoints ? JSON.parse(dataSource.dataset.videoCuepoints).cuepoints : [];
    setCuepoints(cuepoints);
    setVideoGuid(videoGuid);
    setTrackVideo(dataSource.dataset.trackVideo);
    setPlacementType(dataSource.dataset.placementType);
    openModal(e, dataSource.dataset.primaryVideo);
  };
  const handleCheck = e => {
    setChecked(!checked);
  };
  const openModal = (e, video) => {
    setModalOpen(video);
    e.target.setAttribute("aria-expanded", true);
  };
  const closeModal = () => {
    setModalOpen(false);
    handleCheck();
  };
  const afterOpenModal = () => {
    const mount = document.querySelectorAll(".gv__modal__content .js-video-viewer__mount--modal")[0];
    let focusBuffer = setTimeout(() => {}, 1);
    let player;
    const flowplayerObj = {
      token: "eyJraWQiOiJuVVJHSncwNjFzUlkiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6NCxcImlkXCI6XCJuVVJHSncwNjFzUllcIn0iLCJpc3MiOiJGbG93cGxheWVyIn0.Q0ETTfgixa1OKG0QPGFkzXj7nxbwvtbwt1fdBZCf1fM5vGMP_jgBH3p5NuTuvCZnwFWvBUBEUeeLAuyqtohYEQ",
      src: primaryVideo,
      hls: {},
      autoplay: true,
      poster: poster,
      preload: false
      /*subtitles: [],
      cuepoints: [],
      draw_cuepoints: false*/
    };
    if (!poster) {
      flowplayerObj.preload = preload;
    }
    if (subTitles.length > 0) {
      flowplayerObj.subtitles = {
        tracks: subTitles
      };
    }
    if (cuepoints.length > 0) {
      flowplayerObj.cuepoints = cuepoints;
      flowplayerObj.draw_cuepoints = true;
    }
    player = flowplayer(".js-video-viewer__mount--modal", flowplayerObj);
    //flowplayer automatically adds these and won't remove them unless the user re-orients their device
    player.removeAttribute("playsinline");
    player.removeAttribute("webkit-playsinline");
    setPlayer({
      player: player
    });
    player.addEventListener("loadeddata", function () {
      clearTimeout(focusBuffer);
      focusBuffer = setTimeout(() => {
        if (mount.querySelectorAll(".fp-btns svg")[0]) {
          mount.querySelectorAll(".fp-btns svg")[0].focus();
        }
      }, 500);
    });
    if (cuepoints.length > 0) {
      (0, _video.cuepointLogic)(player, mount);
    }

    // Adobe Omniture tracking
    const videostarted = () => {
      VideoMetrics !== undefined && VideoMetrics?.VideoStart(videoGuid, placementType);
    };
    const video30PCT = () => {
      VideoMetrics !== undefined && VideoMetrics?.Video30pct(videoGuid);
    };
    const video70PCT = () => {
      VideoMetrics !== undefined && VideoMetrics?.Video70pct(videoGuid);
    };
    const video90PCT = () => {
      VideoMetrics !== undefined && VideoMetrics?.Video90pct(videoGuid);
    };
    const callStartOnce = R.once(videostarted);
    const call30pctOnce = R.once(video30PCT);
    const call70pctOnce = R.once(video70PCT);
    const call90pctOnce = R.once(video90PCT);
    player.on("loadedmetadata", e => {
      var videoLength = player.duration;
      videoLength && player.on("timeupdate", e => {
        var currTime = player.currentTime;
        if (currTime / videoLength * 100 < 30) {
          callStartOnce();
        }
        if (currTime / videoLength * 100 > 30) {
          call30pctOnce();
        }
        if (currTime / videoLength * 100 > 70) {
          call70pctOnce();
        }
        if (currTime / videoLength * 100 > 90) {
          call90pctOnce();
        }
      });
    });
  };
  const fetchSearchResults = (0, _react.useCallback)(() => {
    let params = {
      selectedType: selectedType.Value,
      pageId: pageId,
      selectedCourses: selectedCourse.Value
    };
    setIsLoading(true);

    // FE local test
    // setTimeout(() => {
    //   console.log("fetched");
    //   setResults(mockData.results);
    //   setIsLoading(false);
    // }, 3000);
    // return;
    // END FE local test

    fetch(`${requestUrl}/owh/search/GetResources`, {
      method: "POST",
      body: JSON.stringify(params),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => response.json()).then(data => {
      setServerError(false);
      setResults(data || []);
      setIsLoading(false);
    }).catch(err => {
      console.error(err);
      setResults([]);
      setServerError(true);
      setIsLoading(false);
    });
  }, [requestUrl, selectedCourse, selectedType, pageId]);
  (0, _react.useEffect)(() => {
    if (!isLoading) {
      setTimeout(() => {
        setAnnounceAlert(true);
        setTimeout(() => setAnnounceAlert(false), 1000);
      }, 1000);
    }
  }, [isLoading]);
  const handleFilterChange = (course, type) => {
    setSelectedType(type);
    setSelectedCourse(course);
  };
  (0, _react.useEffect)(() => {
    fetchSearchResults();
  }, [fetchSearchResults, selectedType, selectedCourse]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "gv__resource-search"
  }, results.map((item, index) => {
    //If the videoViewModel exists in the item then return the modal component
    if (item.VideoViewModel) {
      return /*#__PURE__*/_react.default.createElement(_ResearchResultVideoModal.default, _extends({
        key: `RESOURCE_RESULT_MODAL_${index}`
      }, item, {
        isOpen: modalOpen,
        closeModal: closeModal,
        checked: checked,
        cuePoints: cuepoints,
        handleCheck: handleCheck,
        afterOpenModal: afterOpenModal
      }));
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__visuallyhidden",
    "aria-live": "polite"
  }, announceAlert && /*#__PURE__*/_react.default.createElement("span", null, dictionary.alertResults)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__resource-search__layout"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__resource-search__facets-container"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "gv__button gv__visuallyhidden gv__focusable",
    href: `#${ID_PREFIX}_RESULTS-SKIP`,
    id: `${ID_PREFIX}_FACETS-SKIP`
  }, dictionary.skipFacetsLabel), /*#__PURE__*/_react.default.createElement(_ResourceFacets.default, {
    courses: courses,
    types: types,
    selectedType: selectedType,
    selectedCourse: selectedCourse,
    onFilterChange: handleFilterChange
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__resource-search__results-container"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "gv__button gv__visuallyhidden gv__focusable",
    href: `#${ID_PREFIX}_FACETS-SKIP`,
    id: `${ID_PREFIX}_RESULTS-SKIP`
  }, dictionary.backToFacetsLabel), isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__resource-search__loading"
  }, /*#__PURE__*/_react.default.createElement(_loading.default, {
    isLoading: isLoading
  })), !isServerError && !results.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__resource-search__header-container"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__resource-search__header"
  }, dictionary.errorNoResultsTitle), /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__resource-search__copy"
  }, dictionary.errorNoResultsBody)), isServerError && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__resource-search__header-container"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__resource-search__header"
  }, dictionary.errorServerTitle), /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__resource-search__copy"
  }, dictionary.errorServerBody)), !isServerError && !!results.length && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__resource-search__header-container"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__resource-search__header"
  }, selectedType.Name), /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__resource-search__copy"
  }, selectedType.Description)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__resource-search__card-container gv__course-materials__card-container"
  }, results.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(_ResourceResultItem.default, _extends({
      key: `RESOURCE_RESULT_ITEM_${index}`
    }, item, {
      dictionary: dictionary,
      openModal: openModal,
      getModalInfo: getModalInfo
    }));
  }))))));
};
ResourceResults.propTypes = {
  requestUrl: _propTypes.string,
  courses: _propTypes.array,
  types: _propTypes.array,
  dictionary: _propTypes.object,
  pageId: _propTypes.string
};
var _default = exports.default = ResourceResults;

},{"../../partials/loading.jsx":150,"../../video.js":265,"./ResearchResultVideoModal.jsx":186,"./ResourceFacets.jsx":187,"./ResourceResultItem.jsx":188,"prop-types":"prop-types","ramda":"ramda","react":"react"}],190:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _ResourceResults = _interopRequireDefault(require("./ResourceResults.jsx"));
var _reactRouterDom = require("react-router-dom");
var _Routes = _interopRequireDefault(require("../react-router/Routes.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-resource-search");
if (el) {
  const props = {
    pageId: el.dataset.pageid || "",
    requestUrl: el.dataset.requestUrl || "",
    courses: JSON.parse(el.dataset.courses) || "",
    types: JSON.parse(el.dataset.types) || "",
    dictionary: JSON.parse(el.dataset.dictionary) || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, {
    basename: window.location.pathname
  }, /*#__PURE__*/_react.default.createElement(_Routes.default, null, /*#__PURE__*/_react.default.createElement(_ResourceResults.default, props))), el);
}

},{"../react-router/Routes.jsx":184,"./ResourceResults.jsx":189,"react":"react","react-dom":"react-dom","react-router-dom":"react-router-dom"}],191:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));
var _expandChevron = _interopRequireDefault(require("../../partials/expand-chevron.jsx"));
var _expandChevronSmall = _interopRequireDefault(require("../../partials/expand-chevron-small.jsx"));
var _reactResponsive = require("react-responsive");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SearchFacets = props => {
  const [mobileFacetsToggled, setMobileFacetsToggled] = (0, _react.useState)(false);
  const facetGroupRef = props.facets.map(() => /*#__PURE__*/(0, _react.createRef)());
  const [openAccordions, setOpenAccordions] = (0, _react.useState)([]);
  let contentBuffer = setTimeout(() => {}, 1);
  const isMobile = (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: 681px)"
  });
  const [dropdownHeight, setDropdownHeight] = (0, _react.useState)(0);
  const drowpDownButtonRefs = (0, _react.useRef)();
  const dropDownRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    //uncommenting the hook below will have the facet dropdowns open by default - we currently want them closed
    //setOpenAccordions(props.facets.map((x) => x.id));

    const checkedFacets = document.querySelectorAll(".gv__search-facets__checkbox:not(.gv__search-facets__exact-phrase-checkbox):checked");
    props.facetTotal(checkedFacets.length);
    if (openAccordions.length > 0) {
      document.querySelector("body").classList.add("mobile-accordion-open");
    } else {
      document.querySelector("body").classList.remove("mobile-accordion-open");
    }
    if (isMobile) {
      setDropdownHeight("100%");
    } else {
      setDropdownHeight("auto");
    }
  }, [props.facets, openAccordions, props.facetCount]);

  // This closes dropdown when clicking away but causes other issues
  // useEffect(() => { 
  //   let clickAway = (e) => {//dropDownRef
  //     if(!drowpDownButtonRefs.current.contains(e.target) || !dropDownRef.current.contains(e.target)){
  //       setOpenAccordions([]);
  //     }
  //   }

  //   document.addEventListener("mousedown", clickAway)

  //   return () => {
  //     document.removeEventListener("mousedown", clickAway);
  //   }
  // }, [])

  const toggleMobileFacets = e => {
    setMobileFacetsToggled(!mobileFacetsToggled);
  };
  const skipToResults = e => {
    const searchInput = document.querySelector(".gv__search-results .gv__text-input__field");
    if (searchInput) {
      searchInput.focus();
      searchInput.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest"
      });
    }
  };
  const renderFacetItem = (value, groupId, recursionLevel, collapse, showCount) => {
    const hasChildren = value.values ? true : false;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: value.id,
      className: "gv__search-facets__list-item"
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: value.id,
      "data-parent-category": groupId,
      "aria-labelledby": value.id + "Label",
      type: "checkbox",
      className: "gv__search-facets__checkbox",
      onChange: e => props.handleFacetToggle(e),
      checked: value.selected
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: value.id,
      className: "gv__search-facets__label",
      id: value.id + "Label",
      ref: dropDownRef
    }, /*#__PURE__*/_react.default.createElement("span", null, value.label, " ", showCount && `(${value.number})`)), hasChildren && renderFacetList(value.values, groupId, recursionLevel + 1, collapse, value.id, showCount));
  };
  const toggleAccordion = (e, key) => {
    const newOpenAccordions = openAccordions.map(x => x);
    if (newOpenAccordions.includes(key)) {
      const index = newOpenAccordions.indexOf(key);
      newOpenAccordions.splice(index, 1);
    } else {
      /** .splice params - index, count to remove, what to add
       * made the count 10 as I do not foresee there being that many filters
       * setting this will close one filter dropdown when another is opened
       */
      newOpenAccordions.splice(0, 10, key);
      //newOpenAccordions.push(key);
    }
    setOpenAccordions(newOpenAccordions);
  };
  const closeMobileFacets = e => {
    e.currentTarget.closest(".gv__search-facets__group").querySelector(".gv__search-facets__group-heading-button").click();
  };
  const renderFacetList = (values, groupId, recursionLevel, collapse, directParent, showCount) => {
    const divId = `${groupId}-${recursionLevel}-${directParent}`;
    const isExpanded = openAccordions.includes(divId);
    const shouldCollapse = recursionLevel >= 1 && collapse && values.length > 5 ? true : false;
    const listClassName = (0, _classnames.default)("gv__search-facets__list", {
      "gv__search-facets__list--nested-content": shouldCollapse
    });
    const accordionClassName = (0, _classnames.default)({
      "gv__search-facets__nested-accordion": shouldCollapse
    });
    const height = shouldCollapse && !isExpanded ? 0 : dropdownHeight;
    let valueItems = [];
    let expandedValueItems = [];
    if (shouldCollapse) {
      const valuesToManipulate = values.map(x => x);
      const toShow = valuesToManipulate.splice(0, Math.ceil(valuesToManipulate.length / 2));
      const toExpand = valuesToManipulate;
      valueItems = toShow.map(value => renderFacetItem(value, groupId, recursionLevel, collapse, showCount));
      expandedValueItems = toExpand.map(value => renderFacetItem(value, groupId, recursionLevel, collapse, showCount));
    } else {
      valueItems = values.map(value => renderFacetItem(value, groupId, recursionLevel, collapse, showCount));
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
      className: listClassName
    }, valueItems, !isMobile && /*#__PURE__*/_react.default.createElement("li", {
      className: "gv__search-facets__list-item clear"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__search-facets__clear-btn",
      onClick: props.handleClearFacet,
      onKeyUp: props.handleClearFacet
    }, "Clear All"))), expandedValueItems.length > 0 && /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
      id: divId,
      className: accordionClassName,
      duration: 500,
      height: height
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: listClassName
    }, expandedValueItems)), shouldCollapse && /*#__PURE__*/_react.default.createElement("button", {
      "aria-expanded": isExpanded,
      "aria-controls": divId,
      type: "button",
      className: "gv__search-facets__show-more",
      onClick: e => toggleAccordion(e, divId)
    }, props.showMoreLabel ? props.showMoreLabel : "Show More"), isMobile && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__search-facets__mobile-actions"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__search-facets__mobile-actions__clear",
      onClick: props.handleClearFacet,
      onKeyUp: props.handleClearFacet
    }, " Clear All"), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__search-facets__mobile-actions__apply",
      onClick: e => closeMobileFacets(e)
    }, " Apply Filters")));
  };
  const getFilterNumber = values => {
    const result = values.filter(value => value.selected === true).length;
    if (result === 0) {
      return;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "(", result, ")");
  };
  const renderFacetGroups = () => {
    const facets = props.facets.map((facetGroup, index) => {
      const isExpanded = openAccordions.includes(facetGroup.id);
      const facetGroupClass = (0, _classnames.default)(`gv__search-facets__group group-${index}`, {
        "js-has-nested-accordion": facetGroup.collapse
      });
      let height = isExpanded ? dropdownHeight : 0;
      const headingClasses = (0, _classnames.default)("gv__search-facets__group-heading", {
        "is-open": isExpanded
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        key: facetGroup.id,
        className: facetGroupClass,
        ref: facetGroupRef[index]
      }, index === 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__search-facets__heading"
      }, /*#__PURE__*/_react.default.createElement("h2", null, props.filterHeading ? props.filterHeading : "Filter", " ", props.facetCount > 0 ? `(${props.facetCount})` : ""), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: () => props.handleClearAll(),
        className: "gv__search-facets__clear-all"
      }, props.clearAll ? props.clearAll : "Clear All")), /*#__PURE__*/_react.default.createElement("h3", {
        className: headingClasses
      }, /*#__PURE__*/_react.default.createElement("button", {
        id: `${facetGroup.id}-button`,
        "aria-controls": `${facetGroup.id}-id`,
        type: "button",
        className: " gv__search-facets__group-heading-button",
        "aria-expanded": isExpanded,
        ref: drowpDownButtonRefs,
        onClick: e => toggleAccordion(e, facetGroup.id)
      }, facetGroup.label, " ", getFilterNumber(facetGroup.values), /*#__PURE__*/_react.default.createElement(_expandChevronSmall.default, {
        classes: "gv__search-facets__group-heading-arrow"
      }))), /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
        id: `${facetGroup.id}-id`,
        "aria-labelledby": `${facetGroup.id}-button`,
        className: "gv__search-facets__list-wrapper",
        duration: 500,
        height: height
      }, isMobile && /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__search-facets__mobile-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__search-facets__mobile-heading"
      }, " Filter By ", facetGroup.label, " ", getFilterNumber(facetGroup.values)), /*#__PURE__*/_react.default.createElement("button", {
        className: "gv__search-facets__mobile-close",
        onClick: e => closeMobileFacets(e)
      }, /*#__PURE__*/_react.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M1 11L11 1M1 1L11 11L1 1Z",
        stroke: "#333333",
        strokeWidth: "2"
      })))), renderFacetList(facetGroup.values, facetGroup.id, 0, facetGroup.collapse, facetGroup.id, facetGroup.showCount)));
    });
    return facets;
  };
  const facetsClassName = (0, _classnames.default)("gv__search-facets", {
    "is-open": mobileFacetsToggled
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "gv__visuallyhidden gv__focusable gv__button gv__search-facets__skip-link",
    onClick: e => skipToResults(e)
  }, props.skipFacetsLabel ? props.skipFacetsLabel : "Skip Facets"), renderFacetGroups());
};
SearchFacets.propTypes = {
  filterHeading: _propTypes.string,
  clearAll: _propTypes.string,
  filterResultsMobileLabel: _propTypes.string,
  handleFacetToggle: _propTypes.func,
  handleClearFacet: _propTypes.func,
  handleClearAll: _propTypes.func,
  showMoreLabel: _propTypes.string,
  facets: _propTypes.array,
  skipFacetsLabel: _propTypes.string
};
var _default = exports.default = SearchFacets;

},{"../../partials/expand-chevron-small.jsx":146,"../../partials/expand-chevron.jsx":147,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-animate-height":"react-animate-height","react-responsive":"react-responsive"}],192:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _textInput = _interopRequireDefault(require("../../partials/text-input.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SearchInput = props => {
  let newSearchQueryInput = props.newSearchQueryInput;
  const formClasses = (0, _classnames.default)("gv__search-box gv__form", {
    "is-active": props.isActive
  });
  return /*#__PURE__*/_react.default.createElement("form", {
    className: formClasses,
    onSubmit: props.onFormSubmit,
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search__heading"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Search"), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__search__exact-phrase-checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: "gv-search-exact-phrase",
    "aria-labelledby": "gv-search-exact-phrase-label",
    type: "checkbox",
    className: "gv__search-facets__checkbox gv__search-facets__exact-phrase-checkbox",
    onChange: e => props.handleExactPhraseToggle(e),
    checked: props.isExactPhrase
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "gv-search-exact-phrase",
    className: "gv__search-facets__label",
    id: "gv-search-exact-phrase-label"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Exact phrase")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-box__input"
  }, /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, newSearchQueryInput, {
    onChange: props.handleSearchInputChange,
    label: "Search",
    placeholder: props.inputHint,
    hiddenLabel: true,
    type: "text",
    onKeyUp: props.onKeyUp,
    autoSuggest: true,
    maxCharacters: "150"
  })), props.isActive && /*#__PURE__*/_react.default.createElement("button", {
    type: "reset",
    onClick: e => props.handleResetSearch(e),
    className: "gv__button gv__search-box__button gv__search-box__button--cancel"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__visuallyhidden"
  }, "Cancel Search")), /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "gv__search-box__button gv__search-box__button--submit",
    onClick: () => {
      props.setFixedSearchTerm("");
      props.setTypoSearchTerm("");
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__visuallyhidden"
  }, "Submit Search"), /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "17",
    viewBox: "0 0 17 17"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.15 10.692l4.85 4.86L15.552 17l-4.86-4.85v-.768l-.263-.272a6.29 6.29 0 0 1-4.111 1.526 6.318 6.318 0 1 1 6.318-6.318 6.29 6.29 0 0 1-1.526 4.111l.272.263h.768zm-5.832 0a4.368 4.368 0 0 0 4.374-4.374 4.368 4.368 0 0 0-4.374-4.374 4.368 4.368 0 0 0-4.374 4.374 4.368 4.368 0 0 0 4.374 4.374z",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
};
SearchInput.propTypes = {
  onFormSubmit: _propTypes.func,
  newSearchQueryInput: _propTypes.object,
  inputHint: _propTypes.string,
  isActive: _propTypes.bool,
  handleSearchInputChange: _propTypes.func,
  resetSearch: _propTypes.func
};
var _default = exports.default = SearchInput;

},{"../../partials/text-input.jsx":156,"classnames":"classnames","prop-types":"prop-types","react":"react"}],193:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _ShareInteractionModalApp = _interopRequireDefault(require("../../share-interaction-modal/ShareInteractionModalApp.jsx"));
var _DownloadInteractionModal = _interopRequireDefault(require("../../download-interaction-modal/DownloadInteractionModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// const materialLessons = [
//   {lessonName: "Lesson 2.0 OWH_Global_Of Origins to the Present", lessonUrl: "http://owh.gv.velir.com"},
//   {lessonName: "Lesson 3.0 OWH_Global_Of Origins to the Present", lessonUrl: "http://owh.gv.velir.com"},
//   {lessonName: "Lesson 4.0 OWH_Global_Of Origins to the Present", lessonUrl: "http://owh.gv.velir.com"}
// ];

const SearchResult = props => {
  const {
    thumbnailUrl,
    materialLessons,
    viewIn,
    title,
    vocabTermType,
    wordForms,
    definition,
    url,
    summary,
    courseTitle,
    contentType,
    contentTypeIconUrl,
    isVideo,
    color,
    pillLabel,
    ID,
    shareJson,
    isLocked,
    downloadJson
  } = props;
  const shareButtonRef = (0, _react.useRef)();
  const [showDownload, setShowDownload] = (0, _react.useState)(isLocked);
  const [downloadObj, setDownloadObj] = (0, _react.useState)();
  const [shareObj, setShareObj] = (0, _react.useState)();
  const [showDownloadModal, setShowDownloadModal] = (0, _react.useState)(false);
  const [showShareModal, setShowShareModal] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const viewVocabButtons = document.querySelectorAll(".js-view-vocab-button");
    const hiddenOpenBtn = document.querySelector(".js-hidden-open-btn");
    viewVocabButtons.forEach(viewVocabButton => {
      viewVocabButton.addEventListener("click", () => {
        hiddenOpenBtn.click();
      });
    });
  }, []);
  (0, _react.useEffect)(() => {
    if (!showDownload && downloadJson && downloadJson.length > 0) {
      try {
        const parseJSON = JSON.parse(downloadJson);
        setDownloadObj(parseJSON);
      } catch (error) {
        console.error("Error parsing downloadJson:", error);
      }
    }
  }, [showDownload, downloadJson]);
  (0, _react.useEffect)(() => {
    if (shareJson && shareJson.length > 0) {
      try {
        const parseJSON = JSON.parse(shareJson);
        setShareObj(parseJSON);
      } catch (error) {
        console.error("Error parsing shareJson:", error);
      }
    }
  }, [shareJson]);
  const closeModal = () => {
    setShowShareModal(false);
    setShowDownloadModal(false);

    //double check html body knows the modal is closed. 
    if (document.querySelector("body").classList.contains("gv__modal__body--modal-open")) {
      document.querySelector("body").classList.remove("gv__modal__body--modal-open");
    }
  };
  const renderViewIn = materialLessons => {
    if (materialLessons.length > 0) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__search-results__view-in"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__search-results__view-in__label"
      }, viewIn ? viewIn : "View In", ":"), /*#__PURE__*/_react.default.createElement("ul", {
        className: "gv__search-results__view-in__list"
      }, materialLessons.map((x, i) => {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: i,
          className: "gv__search-results__view-in__item"
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: x.lessonUrl,
          className: "gv__search-results__view-in__link"
        }, x.lessonName));
      })));
    } else {
      return;
    }
  };
  const displayBottomOverlay = () => {
    if (courseTitle) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__featured-materials__card-overlay",
        style: {
          background: color
        }
      }, courseTitle);
    } else {
      return;
    }
  };
  const directToURL = (e, target) => {
    e.preventDefault();
    const ENTER_KEY_CODE = 13;
    const SPACE_KEY_CODE = 32;
    if (e.type === "keyup") {
      if (e.which === ENTER_KEY_CODE || e.which === SPACE_KEY_CODE) {
        window.location = target;
      } else {
        return;
      }
    } else {
      window.location = target;
    }
  };
  if (props.isVocabTerm) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__search-results__result"
    }, title && /*#__PURE__*/_react.default.createElement("h2", {
      className: "gv__search-results__result-title"
    }, title), vocabTermType && wordForms && /*#__PURE__*/_react.default.createElement("p", {
      className: "gv__search-results__result-summary gv__search-results__result-word-forms"
    }, "(", vocabTermType, ") ", wordForms), definition && /*#__PURE__*/_react.default.createElement("p", {
      className: "gv__search-results__result-summary gv__search-results__result-definition"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__search-results__result-definition-title"
    }, "Definition: "), definition), renderViewIn(materialLessons), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__search-results__view-vocab-button js-view-vocab-button"
    }, "View All Vocab Terms >"));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: `gv__featured-materials__card gv__featured-materials__card--${contentType && contentType.toLowerCase()} js-link-area ${!downloadObj ? "gv__lock-download" : ""}`,
    tabIndex: "0",
    onClick: e => {
      directToURL(e, url);
    },
    onKeyUp: e => directToURL(e, url)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__featured-materials__card-image"
  }, pillLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__featured-materials__card-pill"
  }, pillLabel), thumbnailUrl && /*#__PURE__*/_react.default.createElement("img", {
    className: "gv__featured-materials__card-img",
    src: thumbnailUrl,
    alt: ""
  }), isVideo && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("svg", {
    className: "play-icon-svg",
    width: "100",
    height: "104",
    viewBox: "0 0 100 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter0_d_7837_6735)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: "play-border",
    d: "M48 80C65.6731 80 80 65.6731 80 48C80 30.3269 65.6731 16 48 16C30.3269 16 16 30.3269 16 48C16 65.6731 30.3269 80 48 80Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M61.9972 46.2676C63.3313 47.0373 63.3313 48.9627 61.9972 49.7324L41.9994 61.2696C40.6661 62.0388 39 61.0765 39 59.5372V36.4628C39 34.9235 40.6661 33.9612 41.9994 34.7304L61.9972 46.2676Z",
    fill: "#213245"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter0_d_7837_6735",
    x: "0",
    y: "0",
    width: "104",
    height: "104",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/_react.default.createElement("feOffset", {
    dx: "4",
    dy: "4"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "10"
  }), /*#__PURE__*/_react.default.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7837_6735"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7837_6735",
    result: "shape"
  }))))), displayBottomOverlay()), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__featured-materials__card-details"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__featured-materials__card-details-top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__featured-materials__card-details-left"
  }, contentTypeIconUrl && /*#__PURE__*/_react.default.createElement("img", {
    src: contentTypeIconUrl
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__featured-materials__card-type"
  }, contentType)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__featured-materials__card-interactions gv__featured-materials__card-details-right"
  }, downloadObj ? /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__interaction-btn  gv__interaction-btn--download",
    "aria-expanded": "false",
    "aria-haspopup": "true",
    "data-content-type": "download",
    "data-modal": `download-modal-${ID}`,
    title: "Download this lesson material",
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      setShowDownloadModal(true);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__interaction-btn-tooltip"
  }, "Download or save an editable version"), /*#__PURE__*/_react.default.createElement("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "path-1-outside-1_14209_79341",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "34",
    height: "34",
    fill: "black"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    width: "34",
    height: "34"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 17C1 8.16344 8.16344 1 17 1C25.8366 1 33 8.16344 33 17C33 25.8366 25.8366 33 17 33C8.16344 33 1 25.8366 1 17Z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 17C1 8.16344 8.16344 1 17 1C25.8366 1 33 8.16344 33 17C33 25.8366 25.8366 33 17 33C8.16344 33 1 25.8366 1 17Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17 32C8.71573 32 2 25.2843 2 17H0C0 26.3888 7.61116 34 17 34V32ZM32 17C32 25.2843 25.2843 32 17 32V34C26.3888 34 34 26.3888 34 17H32ZM17 2C25.2843 2 32 8.71573 32 17H34C34 7.61116 26.3888 0 17 0V2ZM17 0C7.61116 0 0 7.61116 0 17H2C2 8.71573 8.71573 2 17 2V0Z",
    fill: "#F8F9FA",
    mask: "url(#path-1-outside-1_14209_79341)"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "7",
    y1: "26.1",
    x2: "27",
    y2: "26.1",
    stroke: "#213245",
    strokeWidth: "1.8"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "16.9",
    y1: "7",
    x2: "16.9",
    y2: "22",
    stroke: "#213245",
    strokeWidth: "1.8"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "11.6364",
    y1: "16.3636",
    x2: "17.6364",
    y2: "22.3636",
    stroke: "#213245",
    strokeWidth: "1.8"
  }), /*#__PURE__*/_react.default.createElement("line", {
    y1: "-0.9",
    x2: "8.48528",
    y2: "-0.9",
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 23 17)",
    stroke: "#213245",
    strokeWidth: "1.8"
  }))) : shareObj ? /*#__PURE__*/_react.default.createElement("button", {
    className: "js-share-modal-toggle gv__interaction-btn",
    "aria-expanded": "false",
    "aria-haspopup": "true",
    "data-content-type": "share",
    "data-modal": `share-modal-${ID}`,
    title: "Share/Embed",
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      setShowShareModal(true);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__interaction-btn-tooltip"
  }, "Share/Embed"), /*#__PURE__*/_react.default.createElement("svg", {
    className: "gv__interaction__btn-icon gv__interaction__btn-icon-share",
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "path-1-outside-1_14857_635",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "34",
    height: "34",
    fill: "black"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    width: "34",
    height: "34"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 17C1 8.16344 8.16344 1 17 1C25.8366 1 33 8.16344 33 17C33 25.8366 25.8366 33 17 33C8.16344 33 1 25.8366 1 17Z"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 17C1 8.16344 8.16344 1 17 1C25.8366 1 33 8.16344 33 17C33 25.8366 25.8366 33 17 33C8.16344 33 1 25.8366 1 17Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17 32C8.71573 32 2 25.2843 2 17H0C0 26.3888 7.61116 34 17 34V32ZM32 17C32 25.2843 25.2843 32 17 32V34C26.3888 34 34 26.3888 34 17H32ZM17 2C25.2843 2 32 8.71573 32 17H34C34 7.61116 26.3888 0 17 0V2ZM17 0C7.61116 0 0 7.61116 0 17H2C2 8.71573 8.71573 2 17 2V0Z",
    fill: "#F8F9FA",
    mask: "url(#path-1-outside-1_14857_635)"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "22.625",
    cy: "23.875",
    r: "2.375",
    stroke: "#213245",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "22.625",
    cy: "10.125",
    r: "2.375",
    stroke: "#213245",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "11.375",
    cy: "17.625",
    r: "2.375",
    stroke: "#213245",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "14.0315",
    y1: "16.4143",
    x2: "20.2815",
    y2: "11.4143",
    stroke: "#213245",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "13.5854",
    y1: "18.8292",
    x2: "21.0854",
    y2: "22.5792",
    stroke: "#213245",
    strokeWidth: "1.5"
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__featured-materials__card-details-bottom"
  }, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "gv__featured-materials__card-title"
  }, /*#__PURE__*/_react.default.createElement("span", null, " ", title)), summary && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__featured-materials__card-desc",
    dangerouslySetInnerHTML: {
      __html: summary
    }
  })), renderViewIn(materialLessons)), showDownloadModal && /*#__PURE__*/_react.default.createElement("div", {
    id: `download-modal-${ID}`,
    className: "gv__download-embed-modal js-download-interaction-2",
    tabIndex: "-1",
    "data-dictionary": downloadObj
  }, /*#__PURE__*/_react.default.createElement(_DownloadInteractionModal.default, {
    dictionary: downloadObj,
    fromReact: true,
    showDownloadModal: showDownloadModal,
    setShowDownloadModal: setShowDownloadModal,
    closeModal: closeModal
  })), showShareModal && /*#__PURE__*/_react.default.createElement("div", {
    id: `share-modal-${ID}`,
    className: "gv__download-embed-modal js-download-interaction-2",
    tabIndex: "-1",
    "data-dictionary": shareObj
  }, /*#__PURE__*/_react.default.createElement(_ShareInteractionModalApp.default, {
    dictionary: shareObj,
    fromReact: true,
    showShareModal: showShareModal,
    setShowShareModal: setShowShareModal,
    closeModal: closeModal
  })));
};
SearchResult.propTypes = {
  url: _propTypes.string,
  title: _propTypes.string,
  viewIn: _propTypes.string,
  materialLessons: _propTypes.array,
  summary: _propTypes.string,
  definition: _propTypes.string,
  isVocabTerm: _propTypes.bool,
  ID: _propTypes.string,
  launchVocabModal: _propTypes.func,
  wordForms: _propTypes.string,
  vocabTermType: _propTypes.string
};
var _default = exports.default = SearchResult;

},{"../../download-interaction-modal/DownloadInteractionModal.jsx":68,"../../share-interaction-modal/ShareInteractionModalApp.jsx":211,"prop-types":"prop-types","react":"react"}],194:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SearchResult = _interopRequireDefault(require("./SearchResult.jsx"));
var _SearchInput = _interopRequireDefault(require("./SearchInput.jsx"));
var _Pagination = _interopRequireDefault(require("../Pagination.jsx"));
var _loading = _interopRequireDefault(require("../../partials/loading.jsx"));
var _propTypes = require("prop-types");
var _SearchFacets = _interopRequireDefault(require("./SearchFacets.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _facets = require("../facets.js");
var _urijs = _interopRequireDefault(require("urijs"));
var _reactResponsive = require("react-responsive");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// TEMPORARY
// import * as facetsData from "./search-facets.json";

let FETCH_COUNT = 0;
const URI_VARIABLE = new _urijs.default(window.location);
const SearchResults = props => {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [results, setResults] = (0, _react.useState)([]);
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const [totalResults, setTotalResults] = (0, _react.useState)(0);
  const [inputText, setInputText] = (0, _react.useState)("");

  // "Did you mean" functionality
  const [typoSearchTerm, setTypoSearchTerm] = (0, _react.useState)("");
  const [fixedSearchTerm, setFixedSearchTerm] = (0, _react.useState)("");
  const [forceTypoSearch, setForceTypoSearch] = (0, _react.useState)(() => {
    // A plus sign (can be encoded as a space) in front of the search term 
    // indicates the user is forcing a search with a misspelled term.
    const searchParams = URI_VARIABLE.search(true);
    if (searchParams.term?.startsWith(" ") || searchParams.term?.startsWith("+")) {
      return true;
    } else {
      return false;
    }
  });
  const [isExactPhrase, setIsExactPhrase] = (0, _react.useState)(() => {
    const searchParams = URI_VARIABLE.search(true);
    if (!searchParams.exactPhrase || searchParams.exactPhrase === "false") {
      return false;
    } else {
      return true;
    }
  });

  //local test
  // const [facets, setFacets] = useState(facetsData.Facets);
  const [facets, setFacets] = (0, _react.useState)([]);
  const [facetCount, setFacetCount] = (0, _react.useState)(0);
  const isMobile = (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: 681px)"
  });
  const facetTotal = num => {
    setFacetCount(num);
  };
  const [fetchQueryText, setFetchQueryText] = (0, _react.useState)(() => {
    const searchParams = URI_VARIABLE.search(true);
    const term = searchParams.term ? searchParams.term : "";
    return term;
  });
  const createNewFacetObj = obj => {
    return Object.entries(obj).map(x => {
      return {
        id: x[0],
        value: x[1]
      };
    });
  };
  const [selectedFacets, setSelectedFacets] = (0, _react.useState)(() => {
    const currentQuery = R.omit(["term", "page"], URI_VARIABLE.search(true));
    if (!R.isEmpty(currentQuery)) {
      return createNewFacetObj(currentQuery);
    } else {
      return [];
    }
  });
  const RESULTS_PER_PAGE = 16;
  const getSearchResults = () => {
    let focusTimer;
    let params = {
      term: fetchQueryText,
      page: currentPage,
      resultsPerPage: RESULTS_PER_PAGE,
      exactPhrase: isExactPhrase
    };
    FETCH_COUNT = FETCH_COUNT + 1;
    const fetchCount = FETCH_COUNT;
    if (!R.isEmpty(selectedFacets)) {
      params["selectedFacets"] = selectedFacets;
    }
    setIsLoading(true);
    fetch(`${props.requestUrl}/owh/search/submit`, {
      method: "POST",
      body: JSON.stringify(params),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => response.json()).then(data => {
      if (data.Message) {
        console.warn(data.Message);
        return;
      }
      if (FETCH_COUNT !== fetchCount) {
        return;
      }
      setFixedSearchTerm(data.CorrectedTerm);
      if (data.MisspelledTerm) setTypoSearchTerm(data.MisspelledTerm);
      const results = data.Results.map(result => {
        return {
          id: result.id,
          url: result.url,
          title: result.title,
          summary: result.summary,
          materialLessons: result.materialLessons,
          definition: result.definition,
          listingTemplate: result.listingTemplate,
          wordForms: result.wordForms,
          vocabTermType: result.vocabTermType,
          thumbnailUrl: result.thumbnailUrl,
          courseTitle: result.courseTitle,
          contentType: result.contentType,
          contentTypeIconUrl: result.contentTypeIconUrl,
          isVideo: result.isVideo,
          color: result.color,
          pillLabel: result.pillLabel,
          shareJson: result.shareJson,
          isLocked: result.isLocked,
          downloadJson: result.downloadJson
        };
      });
      setTotalResults(data.TotalResultCount);
      setFacets(data.Facets);
      // setFacets(facetsData.Facets);

      if (data.CurrentPage !== currentPage) {
        setCurrentPage(data.CurrentPage);
      }
      clearTimeout(focusTimer);
      if (!document.activeElement.classList.contains("gv__form__field")) {
        focusTimer = setTimeout(() => {
          if (document.querySelector(".gv__search-results")) {
            const results = document.querySelector(".gv__search-results");
            results.focus();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
          }
        }, 50);
      }
      const preSelectedFacets = (0, _facets.allSelectedFacets)(data.Facets);
      // const preSelectedFacets = allSelectedFacets(facetsData.Facets);

      //disabling for now to prevent it from looping
      //setSelectedFacets(preSelectedFacets);

      //map to URL
      const termObject = {
        term: fetchQueryText
      };
      const exactPhraseObject = {
        exactPhrase: isExactPhrase
      };
      const selectedState = preSelectedFacets;
      const selectedFormatted = selectedState.map(obj => {
        const id = obj.id;
        const value = obj.value;
        return {
          [id]: value
        };
      });
      if (currentPage) {
        const pageObj = {
          page: currentPage
        };
        selectedFormatted.unshift(pageObj);
      }
      selectedFormatted.unshift(termObject);
      selectedFormatted.unshift(exactPhraseObject);
      const queryParams = R.mergeAll(selectedFormatted.map(x => x));
      const url = _urijs.default.decode((0, _urijs.default)(window.location.href).search(queryParams).toString());
      history.replaceState(null, null, url);
      setResults(results);
      setIsLoading(false);
    }).catch(err => {
      console.error(err);
      setIsLoading(false);
    });
  };
  const fetchSearchResults = (0, _react.useCallback)(getSearchResults, [fetchQueryText, currentPage, selectedFacets, isExactPhrase, props.requestUrl]);
  const onFormSubmit = e => {
    e.preventDefault();
    setFetchQueryText(inputText);
    setCurrentPage(1);
  };
  const deleteObj = (arr, obj) => {
    const newArr = arr.filter(x => x.id !== obj.id);
    return newArr.filter(x => !R.isEmpty(x));
  };
  const checkForChildren = (currentId, groupId) => {
    const containingGroup = (0, _facets.toggledGroup)(facets, currentId);
    if (containingGroup[0].values) {
      return containingGroup[0].values;
    } else {
      return [];
    }
  };
  const handleExactPhraseToggle = e => {
    setIsExactPhrase(!isExactPhrase);
    setCurrentPage(1);
  };

  //welcome to my nightmare (╯°□°)╯︵ ┻━┻
  const handleFacetToggle = e => {
    const checkedFacet = e.target.getAttribute("id");
    const checkedStatus = e.target.checked;
    // if we don't map, react will think selectedFacets and currentSelected are the same and not trigger a re-render
    let currentSelected = selectedFacets.map(x => x);
    const groupId = e.target.dataset.parentCategory;
    const getFacets = R.filter(R.propEq("id", groupId), currentSelected);
    let facetsToSet = R.isEmpty(getFacets) ? {} : getFacets[0];
    //childValues are to be automatically (de)selected with parent
    const childValues = R.map(x => x.id, checkForChildren(checkedFacet, facets));
    let newValue = [];

    //currentSelected.value.split(",");
    if (checkedStatus) {
      if (R.isEmpty(facetsToSet)) {
        facetsToSet.id = groupId;
        if (childValues.length) {
          childValues.push(checkedFacet);
          facetsToSet.value = childValues.join();
        } else {
          facetsToSet.value = checkedFacet;
        }
      } else {
        childValues.join();
        newValue = facetsToSet.value.concat(",", checkedFacet);
        newValue = newValue.concat(",", childValues);
        newValue = newValue.split(",");
        let newValueUnique = R.uniq(newValue);
        //need to make sure there aren't any duplicates;
        newValueUnique.join();
        facetsToSet.value = facetsToSet.value.concat(",", newValueUnique);
        currentSelected = deleteObj(currentSelected, facetsToSet);
      }
      //
      currentSelected.push(facetsToSet);
      setFacetCount(facetCount + 1);
    }
    //if unchecked
    else {
      if (facetsToSet.value && facetsToSet.value.includes(checkedFacet)) {
        facetsToSet.value = facetsToSet.value.split(",");
        facetsToSet.value = R.uniq(facetsToSet.value);
        const checkedIndex = facetsToSet.value.indexOf(checkedFacet);
        facetsToSet.value.splice(checkedIndex, 1);
        //also need to remove childValues if they're already selected
        if (childValues.length) {
          facetsToSet.value = facetsToSet.value.filter(val => {
            return childValues.indexOf(val) == -1;
          });
        }
        facetsToSet.value = facetsToSet.value.join();
        if (R.isEmpty(facetsToSet.value)) {
          currentSelected = deleteObj(currentSelected, facetsToSet);
        } else {
          currentSelected = deleteObj(currentSelected, facetsToSet);
          currentSelected.push(facetsToSet);
        }
      } else {
        facetsToSet = {};
      }
      setFacetCount(facetCount - 1);
    }
    setCurrentPage(1);
    setSelectedFacets(currentSelected);
  };
  const handleClearAll = () => {
    setSelectedFacets([]);
    fetchSearchResults();
  };

  //Clears for just the facet group
  const handleClearFacet = e => {
    const allFacetInputs = e.currentTarget.closest(".gv__search-facets__list-wrapper").querySelector(".gv__search-facets__list").querySelectorAll(".gv__search-facets__checkbox");
    // allFacetInputs.checked = false;
    if (e.type === "keyup") {
      if (e.key === "Enter" || e.key === "SpaceBar") {
        allFacetInputs.forEach(input => {
          if (input.checked) {
            input.click();
          }
        });
      }
    } else if (e.type === "click") {
      allFacetInputs.forEach(input => {
        if (input.checked) {
          input.click();
        }
      });
    }
  };
  const calculateNumShown = () => {
    let numberString;
    const max = currentPage * 16;
    const min = max - 15;
    if (results.length === 0) {
      numberString = 0 + " - " + totalResults;
    } else if (results.length < 16 && results.length > 0) {
      numberString = min + " - " + totalResults;
    } else {
      numberString = min + " - " + max;
    }
    return numberString;
  };
  const handleForceTypoSearch = e => {
    setForceTypoSearch(true);
    if (!fetchQueryText.toString().startsWith(" ") || !fetchQueryText.toString().startsWith("+")) {
      setFetchQueryText("+" + typoSearchTerm);
      setInputText(typoSearchTerm);
    }
  };
  const handleDidYouMeanSearch = e => {
    setForceTypoSearch(false);
    setFetchQueryText(fixedSearchTerm);
  };
  const handleSearchInputChange = event => {
    setInputText(event.target.value);
  };
  const handlePaginationClick = (e, page) => {
    setCurrentPage(page);
  };
  const handlePreviousClick = e => {
    setCurrentPage(currentPage - 1);
  };
  const handleNextClick = e => {
    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
  };
  const launchVocabModal = vocabTerm => {
    console.log("term to send to vocab modal", vocabTerm);
  };

  //on initial load, define setinputtext. [] MUST be empty
  (0, _react.useEffect)(() => {
    if (fetchQueryText !== "inputText") {
      if (fetchQueryText.startsWith(" ") || fetchQueryText.startsWith("+")) {
        setInputText(fetchQueryText.slice(1));
      } else {
        setForceTypoSearch(false);
        setInputText(fetchQueryText);
      }
    }
  }, [fetchQueryText]);
  (0, _react.useEffect)(() => {
    fetchSearchResults();
  }, [fetchSearchResults]);
  const {
    dictionary
  } = props;
  const {
    inputHint,
    searchShowing,
    searchOf,
    filterHeading,
    clearAll,
    searchPrevious,
    searchNext,
    filterResultsMobileLabel,
    showMoreLabel,
    viewIn
  } = dictionary;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-results__loading"
  }, /*#__PURE__*/_react.default.createElement(_loading.default, {
    isLoading: isLoading
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-options"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-container gv__search-alignment"
  }, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
    onFormSubmit: onFormSubmit,
    newSearchQueryInput: {
      value: inputText
    },
    inputHint: inputHint,
    handleSearchInputChange: handleSearchInputChange,
    handleExactPhraseToggle: handleExactPhraseToggle,
    isExactPhrase: isExactPhrase,
    onKeyUp: handleSearchInputChange,
    setFixedSearchTerm: setFixedSearchTerm,
    setTypoSearchTerm: setTypoSearchTerm
  }), facets.length > 0 && /*#__PURE__*/_react.default.createElement(_SearchFacets.default, {
    facets: facets,
    handleFacetToggle: handleFacetToggle,
    handleClearAll: handleClearAll,
    handleClearFacet: handleClearFacet,
    facetCount: facetCount,
    facetTotal: facetTotal,
    filterHeading: filterHeading,
    clearAll: clearAll,
    filterResultsMobileLabel: filterResultsMobileLabel,
    showMoreLabel: showMoreLabel
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-alignment"
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (fetchQueryText || fixedSearchTerm) && !forceTypoSearch && /*#__PURE__*/_react.default.createElement("h1", {
    className: "gv__search-results__title"
  }, "Showing results for \"", fixedSearchTerm ? fixedSearchTerm : fetchQueryText, "\""), fixedSearchTerm && typoSearchTerm && !forceTypoSearch && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-results__subtitle"
  }, "Search instead for ", /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__search-results__button-link",
    onClick: handleForceTypoSearch
  }, typoSearchTerm)), forceTypoSearch && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", {
    className: "gv__search-results__title"
  }, "Did you mean: ", /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__search-results__button-link",
    onClick: handleDidYouMeanSearch
  }, fixedSearchTerm)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-results__subtitle"
  }, "Showing results for \"", typoSearchTerm, "\"")), /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__search-results__count"
  }, /*#__PURE__*/_react.default.createElement("strong", null, calculateNumShown()), " of ", /*#__PURE__*/_react.default.createElement("strong", null, totalResults), " ", totalResults == 1 ? "result" : "results")), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-results gv__featured-materials__cards",
    id: "searchResults"
  }, results.length > 0 ? results.map(result => {
    const keyPrefix = `SEARCH-RESULT_${Math.floor(Math.random() * 10000)}_${result.id.replace(/ /g, "")}`;
    return /*#__PURE__*/_react.default.createElement(_SearchResult.default, {
      key: keyPrefix,
      url: result.url,
      title: result.title,
      summary: result.summary,
      definition: result.definition,
      wordForms: result.wordForms,
      ID: result.id,
      isVocabTerm: result.listingTemplate === "Vocab Term",
      launchVocabModal: launchVocabModal,
      viewIn: viewIn,
      vocabTermType: result.vocabTermType,
      materialLessons: result.materialLessons,
      thumbnailUrl: result.thumbnailUrl,
      courseTitle: result.courseTitle,
      contentType: result.contentType,
      contentTypeIconUrl: result.contentTypeIconUrl,
      isVideo: result.isVideo,
      color: result.color,
      pillLabel: result.pillLabel,
      shareJson: result.shareJson,
      isLocked: result.isLocked,
      downloadJson: result.downloadJson
    });
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__alert-banner gv__alert-banner__alert gv__alert-banner__search"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/owh/assets-build/img/icons/alertbanner_alert.svg",
    alt: "Alert Banner"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__alert-banner__text"
  }, " Please try typing a different keyword or changing the filters"))), /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    currentPage: currentPage,
    handlePaginationClick: handlePaginationClick,
    handlePreviousClick: handlePreviousClick,
    handleNextClick: handleNextClick,
    searchPrevious: searchPrevious,
    searchNext: searchNext,
    totalResults: totalResults
  })));
};
SearchResults.propTypes = {
  requestUrl: _propTypes.string,
  dictionary: (0, _propTypes.shape)({
    inputHint: _propTypes.string,
    searchShowing: _propTypes.string,
    searchOf: _propTypes.string,
    searchPrevious: _propTypes.string,
    searchNext: _propTypes.string,
    filterResultsMobileLabel: _propTypes.string,
    showMoreLabel: _propTypes.string
  })
};
var _default = exports.default = SearchResults;

},{"../../partials/loading.jsx":150,"../Pagination.jsx":179,"../facets.js":183,"./SearchFacets.jsx":191,"./SearchInput.jsx":192,"./SearchResult.jsx":193,"prop-types":"prop-types","ramda":"ramda","react":"react","react-responsive":"react-responsive","urijs":"urijs"}],195:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _SearchResults = _interopRequireDefault(require("./SearchResults.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-search-results");
if (el) {
  const props = {
    requestUrl: el.dataset.requestUrl || "",
    dictionary: JSON.parse(el.dataset.dictionary) || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_SearchResults.default, props), el);
}

},{"./SearchResults.jsx":194,"react":"react","react-dom":"react-dom"}],196:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _textInput = _interopRequireDefault(require("../partials/text-input.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SearchInput = props => {
  let newSearchQueryInput = props.newSearchQueryInput;
  const formClasses = (0, _classnames.default)("gv__search-box gv__form", {
    "is-active": props.isActive
  });
  return /*#__PURE__*/_react.default.createElement("form", {
    className: formClasses,
    onSubmit: props.onFormSubmit,
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__search-box__input"
  }, /*#__PURE__*/_react.default.createElement(_textInput.default, _extends({}, newSearchQueryInput, {
    onChange: props.handleSearchInputChange,
    label: props.inputLabel,
    placeholder: props.inputHint,
    hiddenLabel: false,
    hideHintOnMobile: true,
    type: "text",
    onKeyUp: props.onKeyUp,
    autoSuggest: true,
    maxCharacters: "150",
    handleSearchClose: props.handleSearchClose
  })), props.isActive && /*#__PURE__*/_react.default.createElement("button", {
    type: "reset",
    onClick: e => props.handleResetSearch(e),
    className: "gv__button gv__search-box__button gv__search-box__button--cancel"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__visuallyhidden"
  }, "Cancel Search")), /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "gv__button gv__search-box__button gv__search-box__button--submit"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__visuallyhidden"
  }, "Submit Search"), /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "12",
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("line", {
    x1: "-6.55671e-08",
    y1: "6.25",
    x2: "15",
    y2: "6.25",
    stroke: "white",
    "stroke-width": "1.5"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "9.46967",
    y1: "11.4697",
    x2: "15.4697",
    y2: "5.46967",
    stroke: "white",
    "stroke-width": "1.5"
  }), /*#__PURE__*/_react.default.createElement("line", {
    y1: "-0.75",
    x2: "8.48528",
    y2: "-0.75",
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 10 0)",
    stroke: "white",
    "stroke-width": "1.5"
  })))));
};
SearchInput.propTypes = {
  onFormSubmit: _propTypes.func,
  newSearchQueryInput: _propTypes.object,
  inputHint: _propTypes.string,
  isActive: _propTypes.bool,
  handleSearchInputChange: _propTypes.func,
  resetSearch: _propTypes.func
};
var _default = exports.default = SearchInput;

},{"../partials/text-input.jsx":156,"classnames":"classnames","prop-types":"prop-types","react":"react"}],197:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sessionTracking;
exports.handleVideoPlay = void 0;
var _lodash = _interopRequireDefault(require("lodash.throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const completeClass = "gv__session-navigation__item--complete";
const sessions = document.querySelectorAll(".js-session-container");
const updateLock = {
  transitionsInProgress: {},
  isInProgress: function (session) {
    return this.transitionsInProgress[session.dataset.sessionId];
  },
  startUpdate: function (session) {
    this.transitionsInProgress[session.dataset.sessionId] = true;
    updateStatus(session);
  },
  finishUpdate: function (session) {
    delete this.transitionsInProgress[session.dataset.sessionId];
  }
};
function sessionTracking() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  window.addEventListener("scroll", (0, _lodash.default)(handleScroll, 200));

  //add applicable sessions to the object
  [...sessions].forEach(session => {
    if (session.dataset.complete.toLowerCase() === "false") {
      updateLock.transitionsInProgress[session.dataset.sessionId] = false;
    }
  });
}

//in order to use the flowplayer play event listnener, we export this to be referenced in video.js
const handleVideoPlay = sessionVideo => {
  const isComplete = sessionVideo.dataset.complete;
  const parentSession = sessionVideo.closest("[data-video]");
  if (isComplete.toLowerCase() === "false") {
    updateStatus(parentSession, sessionVideo);
  }
};
exports.handleVideoPlay = handleVideoPlay;
const handleScroll = () => {
  [...sessions].forEach(session => {
    if (session.dataset.complete.toLowerCase() === "false") {
      if (window.scrollY > session.offsetTop + session.offsetHeight) {
        if (updateLock.isInProgress(session) === false) {
          updateLock.startUpdate(session);
        }
      }
    }
  });

  //when we scroll to the bottom, do a check for all.
  if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
    const completableSections = [...sessions].filter(session => {
      return session.dataset.complete.toLowerCase() === "false" && session.dataset.video.toLowerCase() === "true";
    });
    completableSections.forEach(session => {
      if (!updateLock.isInProgress(session)) {
        updateLock.startUpdate(session);
      }
    });
  }
};
const updateStatus = (session, video) => {
  const requestUrl = session.dataset.requestUrl || "";
  // a. TrackingId (this would be a data attribute on the section and videos)
  // b.SectionId(this would be the same value on the data attribute in case of section and for videos this would be the data attribute for the section that is enclosing the video component)
  const trackingId = video ? video.dataset.sessionId : session.dataset.sessionId;
  const params = {
    TrackingId: trackingId,
    SectionId: session.dataset.sessionId
  };
  // for initial development
  if (session.dataset.teacherId) {
    params.TeacherId = session.dataset.teacherId;
  }
  fetch(`${requestUrl}/owh/teaching/AddTeacherTracking`, {
    method: "POST",
    body: JSON.stringify(params),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json"
    }
  }).then(response => response.json()).then(data => {
    if (data) {
      if (video && data.TrackingSucceeded) {
        updateVideo(video);
      }
      if (data.SectionComplete) {
        updateComplete(session);
      }
      //  1- SectionComplete (a bool to define if the section tracking is done. if it is true then we should show the section as complete in the left navigation)
      // 2- SectionId (The same parameter that you are sending me)
      // 3- TrackingSucceeded(just an indicator to show that the tracking of this element suceeded and might be used for debugging)

      return;
    } else {
      console.warn(data.Message);
    }
  }).catch(err => {
    console.error(err);
    updateLock.finishUpdate(session);
  });
};
const updateVideo = video => {
  video.setAttribute("data-complete", true);
};
const updateComplete = session => {
  const id = session.getAttribute("id");
  const nav = document.querySelector(`[data-session-reference-id=${id}]`);
  nav && nav.classList.add(completeClass);
  session.setAttribute("data-complete", true);
  session.setAttribute("data-video", true);
  updateLock.finishUpdate(session);
};

},{"lodash.throttle":"lodash.throttle"}],198:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setToolTipListeners;
function setToolTipListeners() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  let isMobile = window.innerWidth < 481;
  const tooltipElements = document.querySelectorAll(".js-tooltip");
  const toolTipTexts = document.querySelectorAll(".js-tooltip-text");
  const textElements = document.querySelectorAll(".js-tooltip-inner-text");
  const triggers = document.querySelectorAll(".js-tooltip-trigger");
  const dismissedClass = "is-dismissed";
  const visibleClass = "is-visible";
  const eventHandlers = {
    desktopClick: [],
    desktopHover: [],
    mobileFocusIn: [],
    mobileFocusOut: [],
    mobileClick: []
  };
  const TIMEOUT_LENGTH = 100;
  if (tooltipElements.length !== 0) {
    const setToolTipTextDisplayBlock = function (index) {
      let withFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const element = toolTipTexts[index];
      const close = element.querySelector(".js-tooltip-close");
      triggers[index].classList.remove(dismissedClass);
      element.classList.remove(dismissedClass);
      element.removeAttribute("aria-hidden");
      element.setAttribute("tabindex", "0");
      if (close) {
        close.removeAttribute("tabindex");
      }
      triggers[index].setAttribute("aria-expanded", true);
      if (withFocus) {
        setTimeout(() => {
          element.focus();
        }, TIMEOUT_LENGTH);
      }
    };
    const setToolTipTextDisplayNone = index => {
      const element = toolTipTexts[index];
      const close = element.querySelector(".js-tooltip-close");
      element.setAttribute("aria-hidden", true);
      element.setAttribute("tabindex", "-1");
      if (close) {
        close.setAttribute("tabindex", "-1");
      }
      triggers[index].setAttribute("aria-expanded", false);
      triggers[index].classList.add(dismissedClass);
      element.classList.add(dismissedClass);
    };
    const dismissToolTipText = function (index) {
      let shouldFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const trigger = triggers[index];
      setToolTipTextDisplayNone(index);
      trigger.setAttribute("tabindex", "0");
      if (shouldFocus) {
        setTimeout(() => {
          trigger.focus();
        }, TIMEOUT_LENGTH);
      }
    };
    const allowToolTipText = function (index) {
      let withFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const trigger = triggers[index];
      setToolTipTextDisplayBlock(index, withFocus);
      trigger.setAttribute("tabindex", "-1");
    };
    const toggleTooltipText = function (index) {
      let shouldFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const element = toolTipTexts[index];
      const isHidden = element.offsetParent === null || element.classList.contains(dismissedClass);
      if (isHidden) {
        allowToolTipText(index, shouldFocus);
      } else if (!isHidden) {
        dismissToolTipText(index);
      }
    };
    const desktopClickHandler = (event, index) => {
      toggleTooltipText(index, false);
    };
    const desktopHoverHandler = (event, index) => {
      allowToolTipText(index, false);
    };
    const mobileClickHandler = (event, index, tooltip) => {
      if (tooltip.classList.contains(visibleClass)) {
        tooltip.classList.remove(visibleClass);
        setToolTipTextDisplayNone(index);
      } else {
        tooltip.classList.add(visibleClass);
        setToolTipTextDisplayBlock(index, false);
      }
    };
    const mobileFocusOutHandler = (event, index, tooltip) => {
      tooltip.classList.remove(visibleClass);
      setToolTipTextDisplayNone(index);
    };
    const mobileFocusInHandler = (event, index, tooltip) => {
      if (event && tooltip.contains(event.target)) {
        setToolTipTextDisplayBlock(index);
      }
    };
    const bindEvents = (tooltip, index) => {
      triggers[index].removeEventListener("click", eventHandlers.desktopClick[index]);
      triggers[index].removeEventListener("mouseenter", eventHandlers.desktopHover[index]);
      triggers[index].removeEventListener("blur", eventHandlers.desktopHover[index]);
      triggers[index].removeEventListener("click", eventHandlers.mobileClick[index]);
      triggers[index].addEventListener("blur", eventHandlers.mobileFocusOut[index]);
      if (!isMobile) {
        allowToolTipText(index, false);
        tooltip.classList.remove(visibleClass);
        triggers[index].addEventListener("click", eventHandlers.desktopClick[index]);
        triggers[index].addEventListener("mouseenter", eventHandlers.desktopHover[index]);
        triggers[index].addEventListener("blur", eventHandlers.desktopHover[index]);
      }
      if (isMobile) {
        dismissToolTipText(index, false);
        triggers[index].addEventListener("click", eventHandlers.mobileClick[index]);
        triggers[index].addEventListener("blur", eventHandlers.mobileFocusOut[index]);
      }
    };
    [...tooltipElements].forEach((tooltip, index) => {
      const createCloseButton = () => {
        const closeButton = document.createElement("button");
        closeButton.setAttribute("type", "button");
        closeButton.setAttribute("aria-label", "Close tooltip");
        closeButton.classList.add("gv__tooltip__close", "js-tooltip-close");
        closeButton.addEventListener("click", () => {
          dismissToolTipText(index);
        });
        return closeButton;
      };
      const appendCloseButton = () => {
        const toolTipText = toolTipTexts[index];
        toolTipText.appendChild(createCloseButton());
      };
      eventHandlers.desktopClick.splice(index, 1, event => desktopClickHandler(event, index));
      eventHandlers.desktopHover.splice(index, 1, event => desktopHoverHandler(event, index));
      eventHandlers.mobileFocusIn.splice(index, 1, event => mobileFocusInHandler(event, index, tooltip));
      eventHandlers.mobileFocusOut.splice(index, 1, event => mobileFocusOutHandler(event, index, tooltip));
      eventHandlers.mobileClick.splice(index, 1, event => mobileClickHandler(event, index, tooltip));
      bindEvents(tooltip, index);
      triggers[index].addEventListener("keydown", event => {
        if (event.key === "Escape") {
          dismissToolTipText(index, false);
        }
      });
      toolTipTexts[index].addEventListener("keydown", event => {
        if (event.key === "Escape") {
          dismissToolTipText(index);
        }
      });
      appendCloseButton(index);
    });
    window.addEventListener("resize", () => {
      if (isMobile !== window.innerWidth < 415) {
        isMobile = window.innerWidth < 415;
        [...tooltipElements].forEach((tooltip, index) => {
          bindEvents(tooltip, index);
        });
      }
    });
  }
}

},{}],199:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const setCookie = el => {
  const cookieName = el.dataset.name || "SeenSurvey";
  const cookie = _jsCookie.default.get(cookieName);
  const id = el.getAttribute("id");
  var inTwentyHours = new Date(new Date().getTime() + 20 * 60 * 60 * 1000);
  if (cookie) {
    const newValue = cookie.concat(`, ${id}`);

    //need the converter to use the comma. js-cookie library converts to html entities
    const newCookie = _jsCookie.default.withConverter({
      write: function (value, name) {
        return value;
      }
    });
    newCookie.set(cookieName, newValue, {
      expires: inTwentyHours
    });
  } else {
    _jsCookie.default.set(cookieName, id, {
      expires: inTwentyHours
    });
  }
};
exports.setCookie = setCookie;

},{"js-cookie":"js-cookie"}],200:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function DownloadAction(props) {
  const {
    files,
    hasMultipleFiles,
    isGoogleDoc,
    dataActionType,
    mediaId
  } = props;
  const [isReady, setIsReady] = (0, _react.useState)(false);
  const renderGoogleDriveLinks = () => {
    window.gapi && window.gapi.savetodrive.go();
  };
  const setDriveButton = () => {
    gapi.savetodrive.render("savetodrive-div", {
      src: hasMultipleFiles === true ? files.url.trim() : files[0].url.trim(),
      filename: hasMultipleFiles === true ? files["download-title"].trim() : files[0]["download-title"].trim(),
      sitename: hasMultipleFiles === true ? files["download-title"].trim() : files[0]["download-title"].trim()
    });
  };
  (0, _react.useEffect)(() => {
    setIsReady(true);
  }, [isReady]);
  if (isReady) {
    if (!isGoogleDoc) {
      renderGoogleDriveLinks();
      setDriveButton();
    }
  }
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "gv__modal__option-list"
  }, !isGoogleDoc && /*#__PURE__*/_react.default.createElement("li", {
    className: "gv__modal__option-list-item"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "savetodrive-div",
    "data-actioncomplete": "download",
    "data-actiontype": dataActionType,
    "data-media-id": mediaId
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "g-savetodrive-text"
  }, "to Google Drive")), /*#__PURE__*/_react.default.createElement("li", {
    className: "gv__modal__option-list-item gv__modal__option-list-item-download"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "actionable",
    "data-actioncomplete": "download",
    "data-actiontype": dataActionType,
    "data-media-id": mediaId,
    download: true,
    href: hasMultipleFiles === true ? files.url : files[0].url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V14H18V9H13V4H6V20H15V22H6ZM21.95 22.375L19 19.425V21.65H17V16H22.65V18H20.4L23.35 20.95L21.95 22.375Z",
    fill: "#213245"
  })), /*#__PURE__*/_react.default.createElement("span", null, isGoogleDoc ? "Open Google Doc" : "Download to My Computer"))));
}
var _default = exports.default = DownloadAction;

},{"prop-types":"prop-types","react":"react"}],201:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function DownloadFileSelection(props) {
  const {
    files,
    downloadSelection,
    handleDownloadSelection,
    setDownloadSelection,
    step,
    setStep,
    saveChecked,
    dataActionType,
    mediaId
  } = props;
  const [checked, setChecked] = (0, _react.useState)();
  const firstOption = (0, _react.useRef)();
  const handleKeyboard = (e, selection) => {
    switch (e.key) {
      case " ":
      case "SpaceBar":
      case "Enter":
        handleDownloadSelection(e, selection);
        setChecked(selection.title);
        e.current.focus();
      case "ArrowUp":
        if (e.target.classList.contains("dropdown-item-0")) {
          firstOption.current.focus();
        } else {
          e.current.previousSibling.focus();
        }
        break;
      case "ArrowDown":
        if (e.target.classList.contains("dropdown-item-last")) {
          firstOption.current.focus();
        } else {
          e.current.nextSibling.focus();
        }
        break;
      default:
        break;
    }
  };
  const displayFiles = () => {
    if (files) {
      return files.map((target, i) => {
        const isDirectDownload = step === 0 && (target.Key === "googledoc" && !hasMultipleGoogleFiles && step === 0 || selectedOption?.Key === "googledoc" && hasMultipleGoogleFiles && step === 1);
        return /*#__PURE__*/_react.default.createElement("div", {
          className: `gv__modal__option-list-item radio-button dropdown-item-${i} ${i === files.length - 1 ? " dropdown-item-last" : ""} ${checked === target.title ? "is-checked" : ""}`,
          "data-actioncomplete": isDirectDownload && step === 0 || dataActionType && step !== 0 ? "download" : null,
          "data-actiontype": isDirectDownload && step === 0 ? target.Key : dataActionType && step !== 0 ? dataActionType : null,
          "data-media-id": mediaId,
          key: `download-option-${i}`,
          ref: i === 0 ? firstOption : null,
          onClick: e => {
            handleDownloadSelection(e, target);
            setChecked(target.title);
          },
          onKeyDown: e => {
            handleKeyboard(e, target);
          },
          "aria-checked": checked === target.title ? "true" : "false",
          tabIndex: "0"
        }, /*#__PURE__*/_react.default.createElement("input", {
          id: `download-option-${i}`,
          type: "radio",
          name: "radio-button",
          value: `download-option-${i}`,
          defaultChecked: checked === target.title
        }), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: `download-option-${i}`
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: target.icon,
          alt: target.iconAlt
        }), target.title));
      });
    }
  };
  (0, _react.useEffect)(() => {
    setChecked(saveChecked);
  }, [saveChecked]);
  return /*#__PURE__*/_react.default.createElement("form", {
    className: "gv__modal__option-list"
  }, displayFiles());
}
var _default = exports.default = DownloadFileSelection;

},{"prop-types":"prop-types","react":"react"}],202:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _DownloadAction = _interopRequireDefault(require("./DownloadAction.jsx"));
var _DownloadFileSelection = _interopRequireDefault(require("./DownloadFileSelection.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function DownloadSelection(props) {
  const {
    downloadDetails,
    step,
    setStep,
    hasMultipleFiles,
    setHasMultipleFiles,
    setDownloadNoteMessage,
    setModalTitle,
    modalLabel,
    mediaId
  } = props;
  const [downloadSelection, setDownloadSelection] = (0, _react.useState)();
  const [secondDownloadSelection, setSecondDownloadSelection] = (0, _react.useState)();
  const [isGoogleDoc, setIsGoogleDoc] = (0, _react.useState)(false);
  const [hasError, setHasError] = (0, _react.useState)(false);
  const [saveChecked, setSaveChecked] = (0, _react.useState)({
    firstSelection: "",
    secondSelection: ""
  });
  const [dataActionType, setDataActionType] = (0, _react.useState)(null);
  const handleDownloadSelection = (e, option) => {
    e.stopPropagation();
    e.preventDefault();
    if (step === 1) {
      if (option.title === "Google Doc") {
        setIsGoogleDoc(true);
      } else {
        setIsGoogleDoc(false);
      }
      setSaveChecked(prevState => ({
        ...prevState,
        firstSelection: option.title
      }));
      if (downloadDetails.Data.DownloadSelections.length !== 1 && hasMultipleFiles === false) {
        if (option.files.length > 1) {
          setHasMultipleFiles(true);
        } else {
          setHasMultipleFiles(false);
        }
        setDownloadSelection(option);
      } else {
        setDownloadSelection(option);
        setSaveChecked(prevState => ({
          ...prevState,
          secondSelection: option.title
        }));
      }
      setDataActionType(option.title);
    } else if (step === 2) {
      setSecondDownloadSelection(option);
      setSaveChecked(prevState => ({
        ...prevState,
        secondSelection: option.title
      }));
      setDataActionType(option.title);
    }
    setHasError(false);
  };
  const handleError = () => {
    setHasError(true);
  };
  const setNextStep = () => {
    if (step === 1) {
      if (downloadDetails.Data.DownloadSelections.length === 1 && hasMultipleFiles === false) {
        return;
      } else {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__modal__option-display__copy ",
          onClick: () => {
            downloadSelection ? setStep(step + 1) : handleError();
          }
        }, "Next");
      }
    } else if (step === 2) {
      if (downloadDetails.Data.DownloadSelections.length === 1 && hasMultipleFiles === true) {
        return;
      } else if (hasMultipleFiles === false) {
        return;
      } else if (hasMultipleFiles === true) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__modal__option-display__copy ",
          onClick: () => {
            secondDownloadSelection ? setStep(step + 1) : handleError();
          }
        }, "Next");
      }
    } else if (step === 3 && hasMultipleFiles === true) {
      return;
    }
  };
  const setDownloadOptions = () => {
    if (step === 1) {
      setDownloadNoteMessage(downloadDetails.HeaderText);
      if (downloadDetails.Data.DownloadSelections.length === 1) {
        if (hasMultipleFiles === false) {
          return /*#__PURE__*/_react.default.createElement(_DownloadAction.default, {
            isGoogleDoc: isGoogleDoc,
            hasMultipleFiles: hasMultipleFiles,
            files: downloadDetails.Data.DownloadSelections[0].files,
            dataActionType: dataActionType,
            mediaId: mediaId
          });
        } else {
          return /*#__PURE__*/_react.default.createElement(_DownloadFileSelection.default, {
            files: downloadDetails.Data.DownloadSelections[0].files,
            handleDownloadSelection: handleDownloadSelection,
            downloadSelection: downloadSelection,
            setDownloadSelection: setDownloadSelection,
            saveChecked: saveChecked.firstSelection,
            step: step,
            setStep: setStep,
            dataActionType: dataActionType,
            mediaId: mediaId
          });
        }
      } else {
        return /*#__PURE__*/_react.default.createElement(_DownloadFileSelection.default, {
          files: downloadDetails.Data.DownloadSelections,
          handleDownloadSelection: handleDownloadSelection,
          downloadSelection: downloadSelection,
          setDownloadSelection: setDownloadSelection,
          saveChecked: saveChecked.firstSelection,
          step: step,
          setStep: setStep,
          dataActionType: dataActionType,
          mediaId: mediaId
        });
      }
    } else if (step === 2) {
      if (downloadDetails.Data.DownloadSelections.length === 1 && hasMultipleFiles === true) {
        setDownloadNoteMessage(downloadDetails.ThirdStepHeaderText);
        return /*#__PURE__*/_react.default.createElement(_DownloadAction.default, {
          isGoogleDoc: isGoogleDoc,
          hasMultipleFiles: hasMultipleFiles,
          files: downloadSelection,
          dataActionType: dataActionType,
          mediaId: mediaId
        });
      } else {
        if (hasMultipleFiles === false) {
          setDownloadNoteMessage(downloadDetails.ThirdStepHeaderText);
          return /*#__PURE__*/_react.default.createElement(_DownloadAction.default, {
            isGoogleDoc: isGoogleDoc,
            hasMultipleFiles: hasMultipleFiles,
            files: downloadSelection.files,
            dataActionType: dataActionType,
            mediaId: mediaId
          });
        } else if (hasMultipleFiles === true) {
          setDownloadNoteMessage(downloadDetails.SecondStepHeaderText);
          return /*#__PURE__*/_react.default.createElement(_DownloadFileSelection.default, {
            files: downloadSelection.files,
            handleDownloadSelection: handleDownloadSelection,
            downloadSelection: downloadSelection,
            setDownloadSelection: setDownloadSelection,
            setSecondDownloadSelection: setSecondDownloadSelection,
            saveChecked: saveChecked.secondSelection,
            step: step,
            setStep: setStep,
            dataActionType: dataActionType,
            mediaId: mediaId
          });
        }
      }
    } else if (step === 3 && hasMultipleFiles === true) {
      setDownloadNoteMessage(downloadDetails.ThirdStepHeaderText);
      return /*#__PURE__*/_react.default.createElement(_DownloadAction.default, {
        isGoogleDoc: isGoogleDoc,
        hasMultipleFiles: hasMultipleFiles,
        files: secondDownloadSelection,
        dataActionType: dataActionType,
        mediaId: mediaId
      });
    }
  };
  (0, _react.useEffect)(() => {
    if (downloadDetails.Data.DownloadSelections.length === 1) {
      if (downloadDetails.Data.DownloadSelections[0].files.length > 1) {
        setHasMultipleFiles(true);
      }
    }
    setModalTitle(modalLabel);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__download"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__download"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__options gv__modal__options-full"
  }, setDownloadOptions(), hasError && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__options-error"
  }, "Please select and option to continue"), setNextStep()));
}
var _default = exports.default = DownloadSelection;

},{"./DownloadAction.jsx":200,"./DownloadFileSelection.jsx":201,"prop-types":"prop-types","react":"react"}],203:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function FileSelection(props) {
  const {
    files,
    fileSelection,
    setFileSelection,
    step,
    setStep,
    saveChecked,
    mediaId
  } = props;
  const [checkedFile, setCheckedFile] = (0, _react.useState)("");
  const [shareURL, setshareURL] = (0, _react.useState)("");
  const [goNext, setGoNext] = (0, _react.useState)(true);
  const firstOption = (0, _react.useRef)();
  const openGoogleClassroom = url => {
    const googleUrl = "https://classroom.google.com/share?url=" + url;
    window.open(googleUrl, "Google Classroom", "width=600,height=400");
  };
  const handleFileSelection = (e, target) => {
    if (step === 1) {
      if (target.files.length > 1) {
        setFileSelection(target.files);
        setGoNext(true);
        setCheckedFile(target.title);
      } else {
        setshareURL(target.files[0].url);
        setGoNext(false);
      }
    } else if (step === 2) {
      setGoNext(false);
      setshareURL(target.url);
    }
  };
  const setNextStep = () => {
    if (goNext === true) {
      setStep(step + 1);
    } else {
      openGoogleClassroom(shareURL);
    }
  };
  const displayFiles = () => {
    if (files) {
      return files.map((target, i) => {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: `gv__modal__option-list-item radio-button dropdown-item-${i} ${i === files.length - 1 ? " dropdown-item-last" : ""} ${checkedFile === target.title ? "is-checked" : ""}`,
          key: `download-option-${i}`,
          ref: i === 0 ? firstOption : null,
          onClick: e => {
            handleFileSelection(e, target);
            setCheckedFile(target.title);
          },
          onKeyDown: e => {
            handleKeyboard(e, target);
            setCheckedFile(target.title);
          },
          "aria-checked": checkedFile === target.title ? "true" : "false",
          tabIndex: "0"
        }, /*#__PURE__*/_react.default.createElement("input", {
          id: `download-option-${i}`,
          type: "radio",
          name: "radio-button",
          value: `download-option-${i}`,
          defaultChecked: checkedFile === target.title
        }), /*#__PURE__*/_react.default.createElement("label", {
          htmlFor: `download-option-${i}`
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: target.icon,
          alt: target.iconAlt
        }), target.title));
      });
    }
  };

  // useEffect(()=>{
  //   setChecked(saveChecked);

  // },[saveChecked]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__options gv__modal__options-full"
  }, /*#__PURE__*/_react.default.createElement("form", {
    className: "gv__modal__option-list"
  }, displayFiles()), /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__modal__option-display__copy gv__modal__option-display__next",
    "data-actioncomplete": goNext ? null : "share",
    "data-actiontype": goNext ? null : "googleclassroom",
    "data-media-id": goNext ? null : mediaId,
    onClick: () => setNextStep()
  }, "Next ", goNext ? '' : /*#__PURE__*/_react.default.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.63636 2.18173C1.33512 2.18173 1.09091 2.42594 1.09091 2.72718V10.3635C1.09091 10.6648 1.33512 10.909 1.63636 10.909H9.27273C9.57397 10.909 9.81818 10.6648 9.81818 10.3635V6.60094H10.9091V10.3635C10.9091 11.2673 10.1765 11.9999 9.27273 11.9999H1.63636C0.732625 11.9999 0 11.2673 0 10.3635V2.72718C0 1.82345 0.732625 1.09082 1.63636 1.09082H5.62601V2.18173H1.63636Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.6799 1.09073L5.45401 7.31666L4.68262 6.54527L10.9086 0.319336L11.6799 1.09073Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.9089 1.09091H8.18164V0H11.9998V3.81818H10.9089V1.09091Z",
    fill: "white"
  }))));
}
var _default = exports.default = FileSelection;

},{"prop-types":"prop-types","react":"react"}],204:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _FileSelection = _interopRequireDefault(require("./FileSelection.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function InitialOptions(props) {
  const {
    dictionary,
    options,
    copyURL,
    selectedOption,
    setSelectedOption,
    additionalOptions,
    setAdditionalOptions,
    step,
    setStep,
    setPromoData,
    setMultipleFileTypes,
    setModalTitle
  } = props;
  const [isCopied, setIsCopied] = (0, _react.useState)(false);
  const [buttonLabel, setButtonLabel] = (0, _react.useState)("");
  const [googleClassroomLabel, setGoogleClassroomLabel] = (0, _react.useState)("");
  const handleSelection = (e, key) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedOption(key);
    const embedOption = options.find(option => option.Key === "embed");
    if (key === "embed") {
      if (embedOption && dictionary.ModalData.EmbedTargets.Options) {
        setAdditionalOptions(dictionary.ModalData.EmbedTargets.Options);
      }
      if (dictionary.ModalData.EmbedTargets.PromoData !== null) {
        setPromoData(dictionary.ModalData.EmbedTargets.PromoData);
      }
      if (dictionary.ModalData.EmbedTargets.ButtonLabel !== null) {
        setModalTitle(dictionary.ModalData.EmbedTargets.ButtonLabel);
      }
      setStep(step + 1);
    } else {
      const shareOption = options.find(option => option.Key === key);
      setButtonLabel(shareOption.ButtonLabel);
    }
    //setIsCopied(false);
  };
  const handleMultipleFiles = (files, key) => {
    setSelectedOption(key);
    setMultipleFileTypes(files);
    setStep(step + 1);
  };
  const setTabDisplay = () => {
    return options.map((target, i) => {
      if (target.Key === "embed") {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__modal__option-list-item",
          id: target.Key,
          key: i,
          onClick: e => handleSelection(e, target.Key)
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
        }), /*#__PURE__*/_react.default.createElement("div", null, target.ButtonLabel));
      } else if (target.Key === "email") {
        return /*#__PURE__*/_react.default.createElement("a", {
          className: "gv__modal__option-list-item",
          "data-actioncomplete": "share",
          "data-actiontype": target.Key,
          "data-media-id": dictionary.MediaId,
          id: target.Key,
          key: i,
          href: `mailto:?body=Material URL: ${target.Data.ShareUrl}`
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
        }), /*#__PURE__*/_react.default.createElement("div", null, target.ButtonLabel));
      } else if (target.Key === "facebook") {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__modal__option-list-item",
          "data-actioncomplete": "share",
          "data-actiontype": target.Key,
          "data-media-id": dictionary.MediaId,
          onClick: e => handleOpenPopupWindow(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(target.Data.ShareUrl)}`, "facebook-share")
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
        }), /*#__PURE__*/_react.default.createElement("div", null, target.ButtonLabel));
      } else if (target.Key === "googleclassroom") {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__modal__option-list-item",
          "data-actioncomplete": target.Data?.ShareSelection ? null : "share",
          "data-actiontype": target.Data?.ShareSelection ? null : target.Key,
          "data-media-id": target.Data?.ShareSelection ? null : dictionary.MediaId,
          onClick: target.Data?.ShareSelection ? () => handleMultipleFiles(target.Data?.ShareSelection, target.Key) : () => openGoogleClassroom(target.Data.ShareUrl),
          key: i
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
        }), /*#__PURE__*/_react.default.createElement("div", null, target.ButtonLabel));
      }
    });
  };
  const copyTextFallback = text => {
    const scrollPosX = window.pageXOffset;
    const scrollPosY = window.pageYOffset;
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      setIsCopied(true);
      window.scrollTo(scrollPosX, scrollPosY);
    } catch (err) {
      console.error("Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
  };
  const copyText = text => {
    if (!navigator.clipboard) {
      copyTextFallback(text);
      return;
    }
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
    });
  };
  const handleCopyURL = (e, url) => {
    e.preventDefault();
    copyText(url);
  };
  const handleOpenPopupWindow = (url, name, width, height) => {
    const popupWindow = window.open(url, name, `height=${height || 500},width=${width || 650}`);
    window.focus && popupWindow.focus();
    return false;
  };
  const openGoogleClassroom = url => {
    const googleUrl = "https://classroom.google.com/share?url=" + url;
    window.open(googleUrl, "Google Classroom", "width=600,height=400");
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__options gv__modal__options-stacked"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-list",
    role: "tablist",
    tabIndex: 0
  }, setTabDisplay()), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-selections"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-display"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-display__details"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-display__url"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-display__url-container"
  }, /*#__PURE__*/_react.default.createElement("input", {
    readOnly: true,
    value: copyURL
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__modal__option-display__copy " + (isCopied === true ? "is-copied" : ""),
    "data-actioncomplete": "share",
    "data-actiontype": "link",
    "data-media-id": dictionary.MediaId,
    onClick: e => handleCopyURL(e, copyURL)
  }, isCopied === true ? /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_3173_8762)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.64736 9.15362L4.00091 9.50717L4.35447 9.15362L11.0676 2.44051L11.2938 2.66673L4.00091 9.95962L0.974685 6.9334L1.20091 6.70717L3.64736 9.15362Z",
    fill: "currentColor",
    stroke: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_3173_8762"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "12",
    height: "12",
    fill: "currentColor"
  })))) : "", isCopied === true ? "Copied" : "Copy")))))));
}
var _default = exports.default = InitialOptions;

},{"./FileSelection.jsx":203,"prop-types":"prop-types","react":"react"}],205:[function(require,module,exports){
arguments[4][70][0].apply(exports,arguments)
},{"dup":70,"prop-types":"prop-types","react":"react"}],206:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function OptionsFullWidth(props) {
  const {
    dictionary,
    step,
    setStep,
    selectedOption,
    setSelectedOption,
    setModalTitle
  } = props;
  const handleSelection = (e, option) => {
    e.preventDefault();
    setSelectedOption(option);
    setStep(step + 1);
    e.currentTarget.setAttribute("aria-selected", "true");
  };
  (0, _react.useEffect)(() => {
    setModalTitle(dictionary.ModalTitle);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__options gv__modal__options-full"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-list",
    role: "tablist",
    tabIndex: 0,
    "aria-activedescendant": selectedOption
  }, dictionary.ShareData && /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__modal__option-list-item",
    id: "share",
    role: "tab",
    onClick: e => handleSelection(e, "share"),
    "aria-selected": "false"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "17.625",
    cy: "18.875",
    r: "2.375",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "17.625",
    cy: "5.125",
    r: "2.375",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "6.375",
    cy: "12.625",
    r: "2.375",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "9.03148",
    y1: "11.4143",
    x2: "15.2815",
    y2: "6.41435",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "8.58541",
    y1: "13.8292",
    x2: "16.0854",
    y2: "17.5792",
    stroke: "currentColor",
    strokeWidth: "1.5"
  })), /*#__PURE__*/_react.default.createElement("span", null, dictionary.ShareData.ButtonLabel)), dictionary.EmbedData && /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__modal__option-list-item",
    id: "embed",
    role: "tab",
    onClick: e => handleSelection(e, "embed"),
    "aria-selected": "false"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_3173_8694)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.39922 16.6L3.92354 12L8.39922 7.4L7.03706 6L1.19922 12L7.03706 18L8.39922 16.6Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.6008 16.6L20.0765 12L15.6008 7.4L16.9629 6L22.8008 12L16.9629 18L15.6008 16.6Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "11.9004",
    y1: "2.3999",
    x2: "11.9004",
    y2: "20.3999",
    stroke: "currentColor"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_3173_8694"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))), /*#__PURE__*/_react.default.createElement("span", null, dictionary.EmbedData.ButtonLabel)), dictionary.DownloadData && /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__modal__option-list-item",
    id: "download",
    role: "tab",
    onClick: e => handleSelection(e, "download"),
    "aria-selected": "false"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("line", {
    x1: "2",
    y1: "21.1",
    x2: "22",
    y2: "21.1",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "11.9",
    y1: "2",
    x2: "11.9",
    y2: "17",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "6.6364",
    y1: "11.3636",
    x2: "12.6364",
    y2: "17.3636",
    stroke: "currentColor",
    strokeWidth: "1.8"
  }), /*#__PURE__*/_react.default.createElement("line", {
    y1: "-0.9",
    x2: "8.48528",
    y2: "-0.9",
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 18 12)",
    stroke: "currentColor",
    strokeWidth: "1.8"
  })), /*#__PURE__*/_react.default.createElement("span", null, dictionary.DownloadData.ButtonLabel))));
}
var _default = exports.default = OptionsFullWidth;

},{"prop-types":"prop-types","react":"react"}],207:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _FileSelection = _interopRequireDefault(require("./FileSelection.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function OptionsSelections(props) {
  const {
    dictionary,
    embedUrl,
    hasSelections,
    sectionTitle,
    options,
    setPromoData,
    setModalTitle,
    selectedOption
  } = props;
  const [secondSelectedOption, setSecondSelectedOption] = (0, _react.useState)();
  const [firstFileSelection, setFirstFileSelection] = (0, _react.useState)();
  const [secondFileSelection, setsecondFileSelection] = (0, _react.useState)();
  const [hasError, setHasError] = (0, _react.useState)(false);
  const [isCopied, setIsCopied] = (0, _react.useState)(false);
  const [googleClassroomLabel, setGoogleClassroomLabel] = (0, _react.useState)("");
  const handleSelection = (e, key) => {
    e.preventDefault();
    e.stopPropagation();
    setSecondSelectedOption(key);
    const findOption = options.find(option => option.Key === key);

    // if(findOption.PromoData) {
    //   setPromoData(findOption.PromoData);
    // }
    setIsCopied(false);
  };
  document.querySelectorAll(".gv__manual-modal__overlay").forEach(overlayButton => {
    overlayButton.addEventListener("click", e => {
      setIsCopied(false);
    });
  });
  const setTabDisplay = () => {
    return options.map((target, i) => {
      if (hasSelections) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__modal__option-list-item",
          role: "tab",
          id: target.Key,
          key: i,
          "aria-selected": secondSelectedOption === target.Key ? true : false,
          onClick: e => handleSelection(e, target.Key)
        }, " ", /*#__PURE__*/_react.default.createElement("img", {
          src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
        }), target.ButtonLabel);
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__modal__option-list-item no-selections",
          id: target.Key,
          key: i
        }, " ", /*#__PURE__*/_react.default.createElement("img", {
          src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
        }), target.ButtonLabel);
      }
    });
  };
  const copyTextFallback = text => {
    const scrollPosX = window.pageXOffset;
    const scrollPosY = window.pageYOffset;
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      setIsCopied(true);
      window.scrollTo(scrollPosX, scrollPosY);
    } catch (err) {
      console.error("Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
  };
  const buildEmbedIframe = (embedUrl, embedWidth, embedHeight, allowFullScreen) => {
    return `<iframe src="${embedUrl}" width="${embedWidth}" height="${embedHeight}" ${allowFullScreen ? "allowfullscreen=\"allowfullscreen\"" : ""}></iframe>`;
  };
  const copyText = text => {
    if (!navigator.clipboard) {
      copyTextFallback(text);
      return;
    }
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
    });
  };
  const handleCopyURL = (e, url, embedWidth, embedHeight, allowFullScreen) => {
    e.preventDefault();
    copyText(buildEmbedIframe(url, embedWidth, embedHeight, allowFullScreen));
  };
  const setTabPanelDisplay = () => {
    return options.map((target, i) => {
      if (i === 0) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__modal__option-display",
          role: "tabpanel",
          "aria-labelledby": target.Key,
          key: i,
          "aria-hidden": secondSelectedOption === target.Key ? false : true
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__modal__option-display__details"
        }, !hasSelections ? sectionTitle && /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__modal__option-display__title"
        }, sectionTitle) : target.SectionTitle && /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__modal__option-display__title"
        }, target.SectionTitle), /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__modal__option-display__url"
        }, buildEmbedIframe(embedUrl, target.EmbediFrameWidth, target.EmbediFrameHeight, target.AllowEmbediFrameFullScreen))), /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__modal__option-display__copy " + (isCopied === true ? "is-copied" : ""),
          "data-actioncomplete": "share",
          "data-actiontype": "embed",
          "data-media-id": dictionary.MediaId,
          onClick: e => handleCopyURL(e, embedUrl, target.EmbediFrameWidth, target.EmbediFrameHeight, target.AllowEmbediFrameFullScreen)
        }, isCopied === true ? /*#__PURE__*/_react.default.createElement("svg", {
          viewBox: "0 0 12 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/_react.default.createElement("g", {
          clipPath: "url(#clip0_3173_8762)"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M3.64736 9.15362L4.00091 9.50717L4.35447 9.15362L11.0676 2.44051L11.2938 2.66673L4.00091 9.95962L0.974685 6.9334L1.20091 6.70717L3.64736 9.15362Z",
          fill: "currentColor",
          stroke: "currentColor"
        })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
          id: "clip0_3173_8762"
        }, /*#__PURE__*/_react.default.createElement("rect", {
          width: "12",
          height: "12",
          fill: "currentColor"
        })))) : "", isCopied === true ? "Copied" : "Copy"));
      } else {
        return;
      }
    });
  };
  (0, _react.useEffect)(() => {
    options.map((target, i) => {
      if (i === 0) {
        setSecondSelectedOption(target.Key);
      }
    });
    if (selectedOption === "embed") {
      setModalTitle(dictionary.ModalData.EmbedTargets.ButtonLabel);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `gv__modal__options ${hasSelections ? "gv__modal__options-half" : "gv__modal__options-half gv__modal__options-no-selections"}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-list",
    role: "tablist",
    tabIndex: 0,
    "aria-activedescendant": secondSelectedOption
  }, setTabDisplay()), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-selections"
  }, setTabPanelDisplay()));
}
var _default = exports.default = OptionsSelections;

},{"./FileSelection.jsx":203,"prop-types":"prop-types","react":"react"}],208:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _FileSelection = _interopRequireDefault(require("./FileSelection.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function OptionsSelectionsDropdown(props) {
  const {
    shareDetails,
    embedDetails,
    options,
    selectedOption,
    step,
    setStep,
    setModalTitle,
    modalLabel,
    multipleFileTypes,
    setMultipleFileTypes
  } = props;
  const [secondSelectedOption, setSecondSelectedOption] = (0, _react.useState)("");
  const [isCopied, setIsCopied] = (0, _react.useState)(false);
  const [isOptionsOpen, setIsOptionsOpen] = (0, _react.useState)(false);
  const firstOption = (0, _react.useRef)();
  const dropdownButton = (0, _react.useRef)();
  const dropdownFocusTracking = [];
  const [firstFileSelection, setFirstFileSelection] = (0, _react.useState)();
  const [secondFileSelection, setsecondFileSelection] = (0, _react.useState)();
  const [hasError, setHasError] = (0, _react.useState)(false);
  const [googleClassroomLabel, setGoogleClassroomLabel] = (0, _react.useState)("");

  //For share Google Classroom file selection
  const handleFileSelection = (e, option) => {
    e.stopPropagation();
    e.preventDefault();
    if (step === 1) {
      setFirstFileSelection(option);
      if (option.files.length > 1) {
        setMultipleFileTypes(true);
      } else {
        setMultipleFileTypes(false);
      }
    } else if (step === 2) {
      setsecondFileSelection(option);
    }
    setHasError(false);
  };
  const handleError = () => {
    setHasError(true);
  };

  //For share Google Classroom file selection
  const setNextStep = () => {
    if (multipleFileTypes) {
      if (step === 1) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__modal__option-display__copy",
          onClick: () => {
            firstFileSelection ? setStep(step + 1) : handleError();
          }
        }, "Next");
      } else if (step === 2) {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__modal__option-display__copy",
          onClick: () => {
            secondFileSelection ? openGoogleClassroom(secondFileSelection.url) : handleError();
          }
        }, googleClassroomLabel);
      }
    } else {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "gv__modal__option-display__copy",
        onClick: () => {
          firstFileSelection ? openGoogleClassroom(firstFileSelection.files[0].url) : handleError();
        }
      }, googleClassroomLabel);
    }
  };

  //For share Google Classroom file selection
  const showFileSelection = files => {
    if (step === 1) {
      return /*#__PURE__*/_react.default.createElement(_FileSelection.default, {
        files: files,
        step: step,
        handleFileSelection: handleFileSelection
      });
    } else if (step === 2) {
      return /*#__PURE__*/_react.default.createElement(_FileSelection.default, {
        files: firstFileSelection.files,
        step: step,
        handleFileSelection: handleFileSelection
      });
    }
  };
  const toggleOptions = () => {
    setIsOptionsOpen(!isOptionsOpen);
  };
  const handleListKeyDown = e => {
    switch (e.key) {
      case "Escape":
        e.preventDefault();
        setIsOptionsOpen(false);
        break;
      case "ArrowUp":
        e.preventDefault();
        if (!isOptionsOpen) {
          setIsOptionsOpen(true);
        } else {
          firstOption.current.focus();
        }
        break;
      case "ArrowDown":
        e.preventDefault();
        if (!isOptionsOpen) {
          setIsOptionsOpen(true);
        } else {
          firstOption.current.focus();
        }
        break;
      default:
        break;
    }
  };
  const setSelectedOptionDisplay = () => {
    return options.Targets.filter(target => {
      return target.Key === secondSelectedOption;
    }).map((target, i) => {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "btn-text",
        key: target.Key + i
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
      }), /*#__PURE__*/_react.default.createElement("span", null, target.ButtonLabel));
    });
  };
  const setSelectedThenCloseDropdown = key => {
    setSecondSelectedOption(key);
    setIsOptionsOpen(false);
    setTimeout(function () {
      dropdownButton.current.focus();
    }, 100);
  };
  const handleKeyDown = key => e => {
    switch (e.key) {
      case " ":
      case "SpaceBar":
      case "Enter":
        e.preventDefault();
        setSelectedThenCloseDropdown(key);
      case "ArrowUp":
        e.preventDefault();
        if (e.target.classList.contains('dropdown-item-0')) {
          firstOption.current.focus();
        } else {
          e.target.previousSibling.focus();
        }
        break;
      case "ArrowDown":
        e.preventDefault();
        if (e.target.classList.contains('dropdown-item-last')) {
          firstOption.current.focus();
        } else {
          e.target.nextSibling.focus();
        }
        break;
      default:
        break;
    }
  };
  const setAllOptionsDisplay = () => {
    return options.Targets.map((target, index) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: `dropdown-item dropdown-item-${index} ${index === options.Targets.length - 1 ? " dropdown-item-last" : ""}`,
        key: target.Key + '-selection',
        id: target.Key,
        role: "option",
        "aria-selected": secondSelectedOption,
        tabIndex: 0,
        onKeyDown: handleKeyDown(target.Key),
        onClick: () => {
          setSelectedThenCloseDropdown(target.Key);
        },
        ref: index === 0 ? firstOption : null
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
      }), " ", /*#__PURE__*/_react.default.createElement("span", null, target.ButtonLabel));
    });
  };
  const copyTextFallback = text => {
    const scrollPosX = window.pageXOffset;
    const scrollPosY = window.pageYOffset;
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      setIsCopied(true);
      window.scrollTo(scrollPosX, scrollPosY);
    } catch (err) {
      console.error("Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
  };
  const buildEmbedIframe = embedUrl => {
    return `<iframe src="${embedUrl}" width="1500" height="1500" allowfullscreen="allowfullscreen"></iframe>`;
  };
  const copyText = text => {
    if (!navigator.clipboard) {
      copyTextFallback(text);
      return;
    }
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
    });
  };
  const handleCopyURL = (e, url) => {
    e.preventDefault();
    if (selectedOption === "embed") {
      copyText(buildEmbedIframe(url));
    } else {
      copyText(url);
    }
  };
  const handleOpenPopupWindow = (url, name, width, height) => {
    const popupWindow = window.open(url, name, `height=${height || 500},width=${width || 650}`);
    window.focus && popupWindow.focus();
    return false;
  };
  const openGoogleClassroom = url => {
    const googleUrl = "https://classroom.google.com/share?url=" + url;
    window.open(googleUrl, "Google Classroom", "width=600,height=400");
  };
  const selectFileType = fileTypes => {};
  const handleShareAction = (key, url, buttonLabel, fileTypes) => {
    if (key === "copy" || key === "blackboard" || key === "canvas" || key === "schoology") {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "gv__modal__option-display__copy " + (isCopied === true ? 'is-copied' : ''),
        onClick: e => handleCopyURL(e, url)
      }, isCopied === true ? /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_3173_8762)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M3.64736 9.15362L4.00091 9.50717L4.35447 9.15362L11.0676 2.44051L11.2938 2.66673L4.00091 9.95962L0.974685 6.9334L1.20091 6.70717L3.64736 9.15362Z",
        fill: "currentColor",
        stroke: "currentColor"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_3173_8762"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "12",
        height: "12",
        fill: "currentColor"
      })))) : "", isCopied === true ? `Copied` : "Copy");
    } else if (key === "email") {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "gv__modal__option-display__copy",
        href: `mailto:?body=Material URL: ${url}`
      }, buttonLabel);
    } else if (key === "facebook") {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "gv__modal__option-display__copy",
        onClick: e => handleOpenPopupWindow(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, "facebook-share")
      }, buttonLabel);
    } else if (key === "googleclassroom") {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "gv__modal__option-display__copy",
        onClick: fileTypes ? () => openGoogleClassroom(url) : () => selectFileType(fileTypes)
      }, buttonLabel);
    }
  };
  const setTabPanelDisplay = () => {
    return options.Targets.map((target, i) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display",
        role: "tabpanel",
        "aria-labelledby": target.Key,
        key: i,
        "aria-hidden": secondSelectedOption === target.Key ? false : true
      }, target.Data && target.Data.ShareSelection ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display__details"
      }, target.SectionTitle ? /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display__title"
      }, target.SectionTitle) : "", target.ShareText ? /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display__text"
      }, target.ShareText) : ""), showFileSelection(target.Data.ShareSelection)), hasError && /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__options-error"
      }, "Please select and option to continue"), setNextStep()) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display__details"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display__title"
      }, target.SectionTitle), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display__url"
      }, selectedOption === "share" ? target.Data.ShareUrl : buildEmbedIframe(options.Data.EmbedUrl, target.EmbediFrameWidth, target.EmbediFrameHeight, target.AllowEmbediFrameFullScreen))), selectedOption === "share" ? handleShareAction(target.Key, target.Data.ShareUrl, target.ButtonLabel, target.Data.ShareSelection) : handleShareAction(target.Key, options.Data.EmbedUrl, target.ButtonLabel, null, target.EmbediFrameWidth, target.EmbediFrameHeight, target.AllowEmbediFrameFullScreen)));
    });
  };
  (0, _react.useEffect)(() => {
    options.Targets.map((target, i) => {
      dropdownFocusTracking.push(target.Key);
      if (i === 0) {
        setSecondSelectedOption(target.Key);
      }
    });
    if (selectedOption === "share") {
      options.Targets.map((target, i) => {
        if (target.Key === "googleclassroom") {
          setGoogleClassroomLabel(target.ButtonLabel);
          if (target.Data) {
            if (target.Data.ShareSelection && target.Data.ShareSelection[0].files && target.Data.ShareSelection[0].files.length > 1) {
              setMultipleFileTypes(true);
            }
          }
        }
      });
    }
    setIsCopied(false);
    setModalTitle(modalLabel);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__options gv__modal__options-dropdown"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-list"
  }, /*#__PURE__*/_react.default.createElement("button", {
    tabIndex: 0,
    type: "button",
    "aria-haspopup": "listbox",
    "aria-expanded": isOptionsOpen,
    className: `gv__modal__option-list-btn ${isOptionsOpen ? "expanded" : ""}`,
    onClick: toggleOptions,
    onKeyDown: handleListKeyDown,
    ref: dropdownButton
  }, setSelectedOptionDisplay()), /*#__PURE__*/_react.default.createElement("ul", {
    className: `options ${isOptionsOpen ? "show" : ""}`,
    role: "listbox",
    "aria-activedescendant": secondSelectedOption,
    tabIndex: -1
  }, setAllOptionsDisplay())), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-selections"
  }, setTabPanelDisplay()));
}
var _default = exports.default = OptionsSelectionsDropdown;

},{"./FileSelection.jsx":203,"prop-types":"prop-types","react":"react"}],209:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _FileSelection = _interopRequireDefault(require("./FileSelection.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function OptionsSelectionsMobile(props) {
  const {
    dictionary,
    options,
    embedUrl,
    selectedOption,
    setSelectedOption,
    additionalOptions,
    setAdditionalOptions,
    step,
    setStep,
    setModalTitle
  } = props;
  const [secondSelectedOption, setSecondSelectedOption] = (0, _react.useState)("");
  const [isCopied, setIsCopied] = (0, _react.useState)(false);
  const [isOptionsOpen, setIsOptionsOpen] = (0, _react.useState)(false);
  const firstOption = (0, _react.useRef)();
  const dropdownButton = (0, _react.useRef)();
  const dropdownFocusTracking = [];
  const [firstFileSelection, setFirstFileSelection] = (0, _react.useState)();
  const [secondFileSelection, setsecondFileSelection] = (0, _react.useState)();
  const [hasError, setHasError] = (0, _react.useState)(false);
  const [googleClassroomLabel, setGoogleClassroomLabel] = (0, _react.useState)("");
  const toggleOptions = () => {
    setIsOptionsOpen(!isOptionsOpen);
  };
  const handleListKeyDown = e => {
    switch (e.key) {
      case "Escape":
        e.preventDefault();
        setIsOptionsOpen(false);
        break;
      case "ArrowUp":
        e.preventDefault();
        if (!isOptionsOpen) {
          setIsOptionsOpen(true);
        } else {
          firstOption.current.focus();
        }
        break;
      case "ArrowDown":
        e.preventDefault();
        if (!isOptionsOpen) {
          setIsOptionsOpen(true);
        } else {
          firstOption.current.focus();
        }
        break;
      default:
        break;
    }
  };
  const setSelectedOptionDisplay = () => {
    return options.filter(target => {
      return target.Key === secondSelectedOption;
    }).map((target, i) => {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "btn-text",
        key: target.Key + i
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
      }), /*#__PURE__*/_react.default.createElement("span", null, target.ButtonLabel));
    });
  };
  const setSelectedThenCloseDropdown = key => {
    setSecondSelectedOption(key);
    setIsOptionsOpen(false);
    setTimeout(function () {
      dropdownButton.current.focus();
    }, 100);
  };
  const handleKeyDown = key => e => {
    switch (e.key) {
      case " ":
      case "SpaceBar":
      case "Enter":
        e.preventDefault();
        setSelectedThenCloseDropdown(key);
      case "ArrowUp":
        e.preventDefault();
        if (e.target.classList.contains("dropdown-item-0")) {
          firstOption.current.focus();
        } else {
          e.target.previousSibling.focus();
        }
        break;
      case "ArrowDown":
        e.preventDefault();
        if (e.target.classList.contains("dropdown-item-last")) {
          firstOption.current.focus();
        } else {
          e.target.nextSibling.focus();
        }
        break;
      default:
        break;
    }
  };
  const setAllOptionsDisplay = () => {
    return options.map((target, index) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: `dropdown-item dropdown-item-${index} ${index === options.length - 1 ? " dropdown-item-last" : ""}`,
        key: target.Key + "-selection",
        id: target.Key,
        role: "option",
        "aria-selected": secondSelectedOption,
        tabIndex: 0,
        onKeyDown: handleKeyDown(target.Key),
        onClick: () => {
          setSelectedThenCloseDropdown(target.Key);
        },
        ref: index === 0 ? firstOption : null
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: `/OWH/assets-build/img/icons/share-${target.Key}-icon.svg`
      }), " ", /*#__PURE__*/_react.default.createElement("span", null, target.ButtonLabel));
    });
  };
  const copyTextFallback = text => {
    const scrollPosX = window.pageXOffset;
    const scrollPosY = window.pageYOffset;
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      setIsCopied(true);
      window.scrollTo(scrollPosX, scrollPosY);
    } catch (err) {
      console.error("Oops, unable to copy", err);
    }
    document.body.removeChild(textArea);
  };
  const buildEmbedIframe = embedUrl => {
    return `<iframe src="${embedUrl}" width="1500" height="1500" allowfullscreen="allowfullscreen"></iframe>`;
  };
  const copyText = text => {
    if (!navigator.clipboard) {
      copyTextFallback(text);
      return;
    }
    navigator.clipboard.writeText(text).then(() => {
      setIsCopied(true);
    });
  };
  const handleCopyURL = (e, url) => {
    e.preventDefault();
    copyText(buildEmbedIframe(url));
  };
  const openGoogleClassroom = url => {
    const googleUrl = "https://classroom.google.com/share?url=" + url;
    window.open(googleUrl, "Google Classroom", "width=600,height=400");
  };
  (0, _react.useEffect)(() => {
    if (selectedOption === "embed") {
      setModalTitle(dictionary.ModalData.EmbedTargets.ButtonLabel);
    }
  }, []);
  const setTabPanelDisplay = () => {
    return options.map((target, i) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display",
        role: "tabpanel",
        "aria-labelledby": target.Key,
        key: i,
        "aria-hidden": secondSelectedOption === target.Key ? false : true
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display__details"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display__title"
      }, target.SectionTitle), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__option-display__url"
      }, buildEmbedIframe(embedUrl, target.EmbediFrameWidth, target.EmbediFrameHeight, target.AllowEmbediFrameFullScreen))), /*#__PURE__*/_react.default.createElement("button", {
        className: "gv__modal__option-display__copy " + (isCopied === true ? "is-copied" : ""),
        "data-actioncomplete": "share",
        "data-actiontype": "embed",
        "data-media-id": dictionary.MediaId,
        onClick: e => handleCopyURL(e, embedUrl)
      }, isCopied === true ? /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("g", {
        clipPath: "url(#clip0_3173_8762)"
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M3.64736 9.15362L4.00091 9.50717L4.35447 9.15362L11.0676 2.44051L11.2938 2.66673L4.00091 9.95962L0.974685 6.9334L1.20091 6.70717L3.64736 9.15362Z",
        fill: "currentColor",
        stroke: "currentColor"
      })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
        id: "clip0_3173_8762"
      }, /*#__PURE__*/_react.default.createElement("rect", {
        width: "12",
        height: "12",
        fill: "currentColor"
      })))) : "", isCopied === true ? "Copied" : "Copy"));
    });
  };
  (0, _react.useEffect)(() => {
    options.map((target, i) => {
      dropdownFocusTracking.push(target.Key);
      if (i === 0) {
        setSecondSelectedOption(target.Key);
      }
    });
    setIsCopied(false);
    // setModalTitle(modalLabel);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__options gv__modal__options-dropdown"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-list"
  }, /*#__PURE__*/_react.default.createElement("button", {
    tabIndex: 0,
    type: "button",
    "aria-haspopup": "listbox",
    "aria-expanded": isOptionsOpen,
    className: `gv__modal__option-list-btn ${isOptionsOpen ? "expanded" : ""}`,
    onClick: toggleOptions,
    onKeyDown: handleListKeyDown,
    ref: dropdownButton
  }, setSelectedOptionDisplay()), /*#__PURE__*/_react.default.createElement("ul", {
    className: `options ${isOptionsOpen ? "show" : ""}`,
    role: "listbox",
    "aria-activedescendant": secondSelectedOption,
    tabIndex: -1
  }, setAllOptionsDisplay())), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal__option-selections"
  }, setTabPanelDisplay()));
}
var _default = exports.default = OptionsSelectionsMobile;

},{"./FileSelection.jsx":203,"prop-types":"prop-types","react":"react"}],210:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _dompurify = _interopRequireDefault(require("dompurify"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function PromoDisplay(props) {
  const {
    isMainPromo,
    promo
  } = props;
  const displayPromo = () => {
    if (isMainPromo) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__promo"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__promo-title"
      }, promo.Title), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__promo-content"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: promo.IconUrl,
        alt: promo.IconAlt
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__promo-desc",
        dangerouslySetInnerHTML: {
          __html: _dompurify.default.sanitize(promo.Text)
        }
      })));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__promo"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__modal__promo-title"
      }, "Did you know?"), promo.map((item, i) => {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__modal__promo-content",
          key: `promo-${i}`
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: item.IconUrl,
          alt: item.IconAlt
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "gv__modal__promo-desc",
          dangerouslySetInnerHTML: {
            __html: _dompurify.default.sanitize(item.Text)
          }
        }));
      }));
    }
  };
  return displayPromo();
}
var _default = exports.default = PromoDisplay;

},{"dompurify":"dompurify","prop-types":"prop-types","react":"react"}],211:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _OptionsFullWidth = _interopRequireDefault(require("./OptionsFullWidth.jsx"));
var _OptionsSelections = _interopRequireDefault(require("./OptionsSelections.jsx"));
var _reactResponsive = require("react-responsive");
var _OptionsSelectionsDropdown = _interopRequireDefault(require("./OptionsSelectionsDropdown.jsx"));
var _DownloadSelection = _interopRequireDefault(require("./DownloadSelection.jsx"));
var _PromoDisplay = _interopRequireDefault(require("./PromoDisplay.jsx"));
var _NoteDisplay = _interopRequireDefault(require("./NoteDisplay.jsx"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _InitialOptions = _interopRequireDefault(require("./InitialOptions.jsx"));
var _OptionsSelectionsMobile = _interopRequireDefault(require("./OptionsSelectionsMobile.jsx"));
var _FileSelection = _interopRequireDefault(require("./FileSelection.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ShareInteractionModalApp = props => {
  const {
    dictionary,
    triggerButton,
    fromReact,
    showShareModal,
    setShowShareModal,
    closeModal
  } = props;
  const [step, setStep] = (0, _react.useState)(0);
  const [showVanillaJsModal, setShowVanillaJsModal] = (0, _react.useState)(false);
  const [modalTitle, setModalTitle] = (0, _react.useState)("");
  const [selectedOption, setSelectedOption] = (0, _react.useState)("");
  const [initialOptions, setInitialOptions] = (0, _react.useState)([]);
  const [allOptions, setAllOptions] = (0, _react.useState)([]);
  const [additionalOptions, setAdditionalOptions] = (0, _react.useState)([]);
  const isSmallTabletorMobile = (0, _reactResponsive.useMediaQuery)({
    query: "(max-width: 780px)"
  });
  const [promoData, setPromoData] = (0, _react.useState)({});

  //multiple files for download
  const [hasMultipleFiles, setHasMultipleFiles] = (0, _react.useState)(false);
  //multiple files for share
  const [multipleFileTypes, setMultipleFileTypes] = (0, _react.useState)([]);
  const [fileSelection, setFileSelection] = (0, _react.useState)([]);
  const [downloadNoteMessage, setDownloadNoteMessage] = (0, _react.useState)();
  var shareTypes = [];
  const [hasOneShareType, setHasOneShareType] = (0, _react.useState)(false);
  const [hasSelections, setHasSelections] = (0, _react.useState)(false);
  const [copyURL, setCopyURL] = (0, _react.useState)("");
  const noteDisplay = () => {
    if (step === 0) {
      if (dictionary.HeaderText) {
        return /*#__PURE__*/_react.default.createElement(_NoteDisplay.default, {
          headerText: dictionary.HeaderText
        });
      }
    } else if (step > 0) {
      if (hasSelections) {
        const findOption = allOptions.find(option => option.Key === selectedOption);
        if (findOption.HeaderText) {
          return /*#__PURE__*/_react.default.createElement(_NoteDisplay.default, {
            headerText: findOption.HeaderText
          });
        }
      } else {
        if (selectedOption === "embed") {
          if (dictionary.ModalData.EmbedTargets.HeaderText) {
            return /*#__PURE__*/_react.default.createElement(_NoteDisplay.default, {
              headerText: dictionary.ModalData.EmbedTargets.HeaderText
            });
          }
        } else if (selectedOption === "googleclassroom") {
          const findGoogleClassroom = dictionary.ModalData.ShareTargets.find(option => option.Key === "googleclassroom");
          if (findGoogleClassroom.HeaderText) {
            return /*#__PURE__*/_react.default.createElement(_NoteDisplay.default, {
              headerText: findGoogleClassroom.HeaderText
            });
          }
        }
      }
    }
  };
  const stepDisplay = () => {
    if (step === 0) {
      return /*#__PURE__*/_react.default.createElement(_InitialOptions.default, {
        dictionary: dictionary,
        options: initialOptions,
        copyURL: copyURL,
        selectedOption: selectedOption,
        setSelectedOption: setSelectedOption,
        additionalOptions: additionalOptions,
        setAdditionalOptions: setAdditionalOptions,
        step: step,
        setStep: setStep,
        setPromoData: setPromoData,
        setMultipleFileTypes: setMultipleFileTypes,
        setModalTitle: setModalTitle
      });
    } else if (step === 1) {
      if (hasMultipleFiles) {
        return /*#__PURE__*/_react.default.createElement(_FileSelection.default, {
          step: step,
          setStep: setStep,
          files: multipleFileTypes,
          fileSelection: fileSelection,
          setFileSelection: setFileSelection,
          mediaId: dictionary.MediaId
        });
      } else {
        if (hasSelections) {
          return isSmallTabletorMobile ? /*#__PURE__*/_react.default.createElement(_OptionsSelectionsMobile.default, {
            dictionary: dictionary,
            embedUrl: dictionary.ModalData.EmbedTargets.Data.EmbedUrl,
            step: step,
            setStep: setStep,
            options: additionalOptions,
            setPromoData: setPromoData,
            setModalTitle: setModalTitle
          }) : /*#__PURE__*/_react.default.createElement(_OptionsSelections.default, {
            dictionary: dictionary,
            copyURL: copyURL,
            embedUrl: dictionary.ModalData.EmbedTargets.Data.EmbedUrl,
            step: step,
            setStep: setStep,
            setPromoData: setPromoData,
            options: additionalOptions,
            setModalTitle: setModalTitle,
            selectedOption: selectedOption,
            setSelectedOption: setSelectedOption
          });
        } else {
          return /*#__PURE__*/_react.default.createElement(_OptionsSelections.default, {
            dictionary: dictionary,
            hasSelections: false,
            sectionTitle: dictionary.ModalData.EmbedTargets.EmbedTitle,
            copyURL: copyURL,
            embedUrl: dictionary.ModalData.EmbedTargets.Data.EmbedUrl,
            step: step,
            setStep: setStep,
            setPromoData: setPromoData,
            options: additionalOptions,
            setModalTitle: setModalTitle,
            selectedOption: selectedOption,
            setSelectedOption: setSelectedOption
          });
        }
      }
    } else if (step === 2) {
      return /*#__PURE__*/_react.default.createElement(_FileSelection.default, {
        step: step,
        setStep: setStep,
        files: fileSelection,
        fileSelection: fileSelection,
        setFileSelection: setFileSelection,
        mediaId: dictionary.MediaId
      });
    }
  };
  const mainPromoDisplay = () => {
    if (promoData) {
      if (step === 0) {
        return /*#__PURE__*/_react.default.createElement(_PromoDisplay.default, {
          isMainPromo: true,
          promo: promoData
        });
      } else {
        return /*#__PURE__*/_react.default.createElement(_PromoDisplay.default, {
          isMainPromo: true,
          promo: promoData
        });
      }
    }
  };
  const backButtonDisplay = () => {
    if (step > 0) {
      if (step === 1 && hasOneShareType === true) {
        return;
      } else {
        return /*#__PURE__*/_react.default.createElement("button", {
          className: "gv__manual-modal-share__back gv__back-button",
          onClick: () => {
            setStep(step - 1);
          }
        }, /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "40",
          height: "40",
          viewBox: "0 0 40 40",
          fill: "none"
        }, /*#__PURE__*/_react.default.createElement("path", {
          d: "M25.6836 27.65L18.0503 20L25.6836 12.35L23.3336 10L13.3336 20L23.3336 30L25.6836 27.65Z",
          fill: "white"
        })));
      }
    }
  };
  if (!fromReact) {
    triggerButton?.addEventListener("click", e => setShowVanillaJsModal(true));
  }
  const closeVanillaJsModal = () => {
    setStep(0);
    setShowVanillaJsModal(false);

    //double check html body knows the modal is closed. 
    if (document.querySelector("body").classList.contains("gv__modal__body--modal-open")) {
      document.querySelector("body").classList.remove("gv__modal__body--modal-open");
    }
  };
  (0, _react.useEffect)(() => {
    setDownloadNoteMessage(dictionary.DownloadData?.HeaderText);
    fromReact ? setShowShareModal(true) : setShowVanillaJsModal(true);
  }, [setDownloadNoteMessage]);
  (0, _react.useEffect)(() => {
    if (step === 0) {
      setModalTitle(dictionary.ModalTitle);
      setPromoData(dictionary.ModalData.PromoData);
    } else if (step > 1) {
      if (selectedOption === "embed") {
        setModalTitle(dictionary.EmbedModalTitle);
        setPromoData(dictionary.ModalData.EmbedTargets.PromoData);
      } else if (selectedOption === "googleclassroom") {
        const findGoogleClassroom = dictionary.ModalData.ShareTargets.find(option => option.Key === "googleclassroom");
        if (findGoogleClassroom.ShareText) {
          setModalTitle(findGoogleClassroom.ShareText);
        }
      }
    }
  }, [step]);
  (0, _react.useEffect)(() => {
    // Extract the array from ShareTargets
    const shareTargets = dictionary.ModalData.ShareTargets;

    // Find the object with Key "embed" from EmbedTargets
    const embedTarget = dictionary.ModalData.EmbedTargets?.Options.find(target => target.Key === "embed");
    const allEmbedTargets = dictionary.ModalData.EmbedTargets?.Options;

    // Combine ShareTargets and the EmbedTarget with key "embed" (if it exists)
    const combinedOptions = embedTarget ? [embedTarget, ...shareTargets] : [...shareTargets];
    const allCombinedOptions = embedTarget ? [...allEmbedTargets, ...shareTargets] : [...shareTargets];
    const copyURL = combinedOptions.find(option => option.Key === "copy").Data.ShareUrl;
    setCopyURL(copyURL);

    // Set the state with the combined array
    setInitialOptions(combinedOptions);
    setAllOptions(allCombinedOptions);
  }, []);
  (0, _react.useEffect)(() => {
    if (multipleFileTypes.length > 0) {
      setHasMultipleFiles(true);
    } else {
      setHasMultipleFiles(false);
    }
  }, [multipleFileTypes]);
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: fromReact ? showShareModal : showVanillaJsModal,
    bodyOpenClassName: "overflow",
    htmlOpenClassName: "overflow",
    overlayClassName: "gv__modal",
    className: "gv__modal-interaction gv__modal-share-embed",
    onRequestClose: fromReact ? closeModal : closeVanillaJsModal,
    shouldCloseOnOverlayClick: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal-v2-body gv__modal-share"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__modal-v2-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `gv__manual-modal__header gv__manual-modal__header-${step}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__manual-modal__modal-label"
  }, backButtonDisplay(), /*#__PURE__*/_react.default.createElement("span", null, modalTitle)), /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__manual-modal-v2__close js-close-manual-modal",
    type: "button",
    onClick: () => fromReact ? (closeModal(), setStep(0)) : closeVanillaJsModal()
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 17L17 7M7 7L17 17L7 7Z",
    stroke: "currentColor",
    strokeWidth: "2"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__manual-modal__container"
  }, noteDisplay(), stepDisplay(), mainPromoDisplay()))));
};
var _default = exports.default = ShareInteractionModalApp;

},{"./DownloadSelection.jsx":202,"./FileSelection.jsx":203,"./InitialOptions.jsx":204,"./NoteDisplay.jsx":205,"./OptionsFullWidth.jsx":206,"./OptionsSelections.jsx":207,"./OptionsSelectionsDropdown.jsx":208,"./OptionsSelectionsMobile.jsx":209,"./PromoDisplay.jsx":210,"prop-types":"prop-types","react":"react","react-modal":"react-modal","react-responsive":"react-responsive"}],212:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _ShareInteractionModalApp = _interopRequireDefault(require("./ShareInteractionModalApp.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// var modalAttr;

const triggerButtons = document.querySelectorAll(".js-share-modal-toggle");
const renderShare = e => {
  e.preventDefault();
  e.stopPropagation();
  var button = e.currentTarget;
  const modalId = e.currentTarget.dataset.modal;
  const expanded = e.currentTarget.setAttribute("aria-expanded", "true");
  const modal = document.querySelector(`#${modalId}`);
  const dictionary = modal.getAttribute("data-dictionary");
  var props = {
    dictionary: JSON.parse(dictionary) || null,
    triggerButton: e.currentTarget
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_ShareInteractionModalApp.default, props), modal);
};
triggerButtons.forEach(button => {
  button.addEventListener("click", e => renderShare(e));
});

},{"./ShareInteractionModalApp.jsx":211,"react":"react","react-dom":"react-dom"}],213:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classNames = _interopRequireDefault(require("classNames"));
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ShareInteractionApp extends _react.Component {
  constructor(props) {
    super(props);
    // determine has the needed data to render
    _defineProperty(this, "componentDidMount", () => {
      // add event to open buttons to reset the component state
      this.props.triggerButtons && this.props.triggerButtons.forEach(button => {
        button.addEventListener("click", () => this.reset());
      });

      // handle dependencies loading
      if (this.isReady && this.props.services) {
        const {
          services,
          servicesSettings
        } = this.props;
      }
    });
    _defineProperty(this, "componentDidUpdate", (prevProp, prevState) => {
      if (this.state.currentContent === "link-share") {
        this.handleFocus(this.linkShareRef);
      }
    });
    _defineProperty(this, "copyText", text => {
      if (!navigator.clipboard) {
        this.copyTextFallback(text);
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.setState({
          isCopied: true
        });
      });
    });
    _defineProperty(this, "copyTextFallback", text => {
      const scrollPosX = window.pageXOffset;
      const scrollPosY = window.pageYOffset;
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        this.setState({
          isCopied: true
        });
        window.scrollTo(scrollPosX, scrollPosY);
      } catch (err) {
        console.error("Oops, unable to copy", err);
      }
      document.body.removeChild(textArea);
    });
    _defineProperty(this, "handleCopyURL", e => {
      e.preventDefault();
      this.copyText(this.buildShareUrl(this.props.materialPageUrl, "link"));
    });
    _defineProperty(this, "handleEmbedURL", e => {
      e.preventDefault();
      this.copyText(this.buildEmbedIframe(this.props.materialPageUrl, "embed"));
    });
    _defineProperty(this, "handleFocus", ref => {
      // find focusable elements
      const focusableElems = ref.current.querySelectorAll(".js-focusable, a, button, input");
      focusableElems.length && focusableElems[0].focus();
    });
    _defineProperty(this, "handleLinkShare", e => {
      this.setState({
        currentContent: "link-share"
      });
    });
    _defineProperty(this, "handleEmbed", e => {
      this.setState({
        currentContent: "embed"
      });
    });
    _defineProperty(this, "handleOpenPopupWindow", (url, name, width, height) => {
      const popupWindow = window.open(url, name, `height=${height || 500},width=${width || 650}`);
      window.focus && popupWindow.focus();
      return false;
    });
    _defineProperty(this, "reset", () => {
      this.setState({
        currentContent: "default",
        isCopied: false
      });
    });
    _defineProperty(this, "buildShareUrl", (materialPageUrl, medium) => {
      if (materialPageUrl.includes("?")) {
        return materialPageUrl + `&share=${medium}`;
      } else {
        return materialPageUrl + `?share=${medium}`;
      }
    });
    _defineProperty(this, "buildEmbedIframe", materialPageUrl => {
      return `<iframe src="${this.buildShareUrl(materialPageUrl, "embed")}" width="1500" height="1500" allowfullscreen="allowfullscreen"></iframe>`;
    });
    _defineProperty(this, "handleGoogleClassroom", e => {
      this.setState({
        currentContent: "google-share"
      });
    });
    /* openGoogleClassroomActivity runs for only Activity media types so that it can prompt the user before redirecting */
    _defineProperty(this, "openGoogleClassroomActivity", url => {
      const queryString = encodeURIComponent(this.buildShareUrl(url, "google-classroom"));
      const googleUrl = "https://classroom.google.com/share?url=" + queryString;
      window.open(googleUrl, "Google Classroom", "width=600,height=400");
    });
    _defineProperty(this, "openGoogleClassroom", () => {
      const materialPageUrl = this.props.materialPageUrl;
      const queryString = encodeURIComponent(this.buildShareUrl(materialPageUrl, "google-classroom"));
      const googleUrl = "https://classroom.google.com/share?url=" + queryString;
      window.open(googleUrl, "Google Classroom", "width=600,height=400");
    });
    this.hasURL = this.props.materialPageUrl;
    this.hasServicesData = !this.props.services || !this.props.servicesSettings ? false : true;
    this.isReady = this.hasURL && this.hasServicesData;
    this.isMediaTypeActivity = this.props.mediaType === "ActivityPdfItem" ? true : false;

    // compute initial state
    this.state = {
      currentContent: "default",
      isCopied: false,
      isReady: this.isReady,
      googleShare: null,
      googleShareReady: false,
      isMediaTypeActivity: this.isMediaTypeActivity
    };

    // define refs
    this.linkShareRef = /*#__PURE__*/_react.default.createRef();
    this.shareRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      currentContent,
      isCopied,
      isReady,
      isMediaTypeActivity
    } = this.state;
    const {
      dictionary,
      services,
      servicesSettings,
      materialPageUrl,
      shareGoogle,
      mediaType
    } = this.props;
    const classes = (0, _classNames.default)("gv__share-interaction");
    const notificationClasses = (0, _classNames.default)("notification", {
      "notification--active": isCopied
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: classes,
      ref: this.shareRef
    }, isReady && currentContent === "default" && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__share-interaction__content gv__share-interaction__content--default",
      ref: this.step2Ref
    }, services && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__share-interaction__services"
    }, services.includes("email") && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__service-item gv__service-item--email"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "actionable",
      href: `mailto:?body=Material URL: ${encodeURIComponent(this.buildShareUrl(materialPageUrl, "email"))}`
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/OWH/assets-build/img/icons/share-email.svg",
      alt: `Share by ${dictionary && dictionary.shareEmailLabel || "E-mail"}`
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      "aria-hidden": "true"
    }, dictionary && dictionary.shareEmailLabel || "E-mail")), services.includes("link") && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__service-item gv__service-item--link"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "actionable",
      onClick: e => this.handleLinkShare(e),
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/OWH/assets-build/img/icons/share-link.svg",
      alt: `Share by ${dictionary && dictionary.shareLinkLabel || "Copy Link"}`
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      "aria-hidden": "true"
    }, dictionary && dictionary.shareLinkLabel || "Copy Link")), services.includes("embed") && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__service-item gv__service-item--embed"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "actionable",
      onClick: e => this.handleEmbed(e),
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/OWH/assets-build/img/icons/share-embed.svg",
      alt: `Share by ${dictionary && dictionary.shareEmbedLabel || "Embed"}`
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      "aria-hidden": "true"
    }, dictionary && dictionary.shareEmbedLabel || "Embed")), services.includes("googleClassroom") && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__service-item gv__service-item--google-classroom"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      "data-share-type": "google-classroom",
      type: "button",
      onClick: isMediaTypeActivity ? () => this.handleGoogleClassroom() : () => this.openGoogleClassroom()
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/OWH/assets-build/img/icons/share-googleclassroom.svg",
      alt: `Share on ${dictionary && dictionary.shareGoogleClassroomLabel || "Google Classroom"}`
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      "aria-hidden": "true"
    }, dictionary && dictionary.shareGoogleClassroomLabel || "Google Classroom")), services.includes("facebook") && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__service-item gv__service-item--facebook"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      "data-share-type": "facebook",
      className: "actionable",
      onClick: e => this.handleOpenPopupWindow(`${servicesSettings.facebook.url}?u=${encodeURIComponent(this.buildShareUrl(materialPageUrl, "facebook"))}`, "facebook-share"),
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/OWH/assets-build/img/icons/share-facebook.svg",
      alt: `Share on ${dictionary && dictionary.shareFacebookLabel || "Facebook"}`
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      "aria-hidden": "true"
    }, dictionary && dictionary.shareFacebookLabel || "Facebook")), services.includes("twitter") && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__service-item gv__service-item--twitter"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      "data-share-type": "twitter",
      className: "actionable",
      onClick: e => this.handleOpenPopupWindow(`${servicesSettings.twitter.url}?url=${encodeURIComponent(this.buildShareUrl(materialPageUrl, "twitter"))}`, "twitter-share"),
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/OWH/assets-build/img/icons/share-twitter.svg",
      alt: `Share on ${dictionary && dictionary.shareTwitterLabel || "Twitter"}`
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      "aria-hidden": "true"
    }, dictionary && dictionary.shareTwitterLabel || "Twitter")), services.includes("pinterest") && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__service-item gv__service-item--pinterest"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      "data-share-type": "pinterest",
      className: "actionable",
      onClick: e => this.handleOpenPopupWindow(`${servicesSettings.pinterest.url}/?url=${encodeURIComponent(this.buildShareUrl(materialPageUrl, "pinterest"))}`, "pinterest-share"),
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/OWH/assets-build/img/icons/share-pinterest.svg",
      alt: `Share to ${dictionary && dictionary.sharePinterestLabel || "Pinterest"}`
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, dictionary && dictionary.sharePinterestLabel || "Pinterest")))), isReady && currentContent === "link-share" && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__share-interaction__content gv__share-interaction__content--link-share",
      ref: this.linkShareRef
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: notificationClasses
    }, dictionary && dictionary.shareLinkCopySuccessMessage || "Link copied!"), /*#__PURE__*/_react.default.createElement("h2", {
      className: "title"
    }, dictionary && dictionary.shareLinkCopyLabel || "Copy URL to share"), /*#__PURE__*/_react.default.createElement("div", {
      className: "url"
    }, /*#__PURE__*/_react.default.createElement("p", null, this.buildShareUrl(materialPageUrl, "link"))), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__button",
      onClick: e => this.handleCopyURL(e)
    }, /*#__PURE__*/_react.default.createElement("span", null, dictionary && dictionary.shareLinkCopyButton || "Copy"))), isReady && currentContent === "embed" && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__share-interaction__content gv__share-interaction__content--embed"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: notificationClasses
    }, dictionary && dictionary.shareEmbedCopySuccessMessage || "Embed code copied to clipboard!"), /*#__PURE__*/_react.default.createElement("h2", {
      className: "title"
    }, dictionary && dictionary.shareEmbedCopyLabel || "Copy code to embed"), /*#__PURE__*/_react.default.createElement("div", {
      className: "url"
    }, /*#__PURE__*/_react.default.createElement("p", null, this.buildEmbedIframe(materialPageUrl))), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__button",
      onClick: e => this.handleEmbedURL(e)
    }, /*#__PURE__*/_react.default.createElement("span", null, dictionary && dictionary.shareEmbedCopyButton || "Copy Embed"))), isReady && currentContent === "google-share" && isMediaTypeActivity && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__share-interaction__content gv__share-interaction__content--google-share"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "title"
    }, "Select file type:"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__share-interaction__services gv__share-interaction__services--google-classroom"
    }, shareGoogle.map((shareItem, index) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__service-item gv__service-item--google-classroom",
        key: index
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "content"
      }, /*#__PURE__*/_react.default.createElement("button", {
        "data-share-type": "google-classroom",
        type: "button",
        onClick: () => this.openGoogleClassroomActivity(shareItem.files[0].url)
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: shareItem.icon,
        alt: shareItem.iconAlt
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "label",
        "aria-hidden": "true"
      }, shareItem.title));
    }))), !isReady && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__share-interaction__message"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Sorry, there are no sharing options available."))));
  }
}
exports.default = ShareInteractionApp;
_defineProperty(ShareInteractionApp, "propTypes", {
  dictionary: _propTypes.object,
  services: _propTypes.array,
  servicesSettings: _propTypes.object,
  materialPageUrl: _propTypes.string,
  triggerButtons: _propTypes.object,
  isDropdown: _propTypes.bool,
  mediaType: _propTypes.string
});
_defineProperty(ShareInteractionApp, "defaultProps", {
  dictionary: null,
  services: null,
  servicesSettings: null,
  materialPageUrl: null,
  triggerButtons: null,
  mediaType: null
});

},{"classNames":"classNames","prop-types":"prop-types","react":"react"}],214:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _ShareInteractionApp = _interopRequireDefault(require("./ShareInteractionApp.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const elements = document.querySelectorAll(".js-share-interaction");
if (elements) {
  elements.forEach(element => {
    const container = element.closest(".js-gv__material-card__container");
    const is5050Promo = element.closest(".gv__session-container--50-50") ? true : false;
    const triggerButtons = is5050Promo ? document.querySelectorAll(".js-manual-modal-toggle") : container && container.querySelectorAll('[data-content-type="share"].js-gv-material-card__btn') || document.querySelectorAll(".js-gv__dropdown-menu__btn").length && document.querySelectorAll(".js-gv__dropdown-menu__btn") || document.querySelectorAll(".js-gv__pdf-viewer__share-button").length && document.querySelectorAll(".js-gv__pdf-viewer__share-button");
    const isDropdown = element.closest(".js-gv__dropdown-menu") ? true : false;
    const isLoggedin = window._DataLayer && window._DataLayer.loggedin || null;
    const userType = window._DataLayer && window._DataLayer.userType || null;
    const userId = window._DataLayer && window._DataLayer.userID || null;
    var shareUrl = element.dataset.shareUrl || null;
    if (shareUrl && isLoggedin === "True" && userType === "'Teacher'") {
      shareUrl += "?Id=" + userId;
    }
    var services = element.dataset.services || null;
    if (isLoggedin === "True" && userType === "'Student'") {
      services = "[\"email\", \"link\"]";
    }
    const shareGoogle = JSON.parse(element.dataset.shareGoogle) || null;
    const shareMediatype = element.dataset.shareMediatype || null;
    const props = {
      dictionary: JSON.parse(element.dataset.dictionary) || null,
      services: JSON.parse(services) || null,
      servicesSettings: JSON.parse(element.dataset.servicesSettings) || null,
      materialPageUrl: shareUrl,
      triggerButtons,
      isDropdown: isDropdown,
      shareGoogle: shareGoogle.length > 0 ? shareGoogle : null,
      mediaType: shareMediatype
    };
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_ShareInteractionApp.default, props), element);
  });
}

},{"./ShareInteractionApp.jsx":213,"react":"react","react-dom":"react-dom"}],215:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-form-show-password")].forEach(el => {
    const field = document.querySelector(".js-form-show-password-field");
    const button = document.querySelector(".js-form-show-password-button");
    const showText = button.querySelectorAll(".js-show-password-text");
    const showPasswordText = "show password text";
    const hidePasswordText = "hide password text";
    let showPassword = !field.getAttribute("type") === "password";
    button.addEventListener("click", e => {
      if (showPassword) {
        field.setAttribute("type", "password");
        button.setAttribute("aria-label", showPasswordText);
        showText.forEach(x => x.textContent = "Show");
      } else {
        button.setAttribute("aria-label", hidePasswordText);
        field.setAttribute("type", "text");
        showText.forEach(x => x.textContent = " Hide");
      }
      showPassword = !showPassword;
    });
  });
}

},{}],216:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.initSimpleImageSlider = void 0;
const initSimpleImageSlider = (el, i) => {
  const isExperienceEditor = document.querySelector("body").classList.contains("experience-editor");
  const pausedClass = "is-paused";
  const visibleClass = "gv__unauthenticated-header__image--visible";
  const visibleBtnClass = "gv__unauthenticated-header__pause-button--visible";
  const pauseButton = el.querySelector(".js-simple-image-slider-pause");
  const imagesArr = el.querySelectorAll(".js-simple-image-slider-img");
  const prefersLessMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (imagesArr.length <= 1) {
    return;
  }
  let CURRENT_SLIDE = 0;
  let IS_PAUSED = el.classList.contains(pausedClass);
  let SLIDER_INTERVAL = setInterval(() => {}, 3500);
  pauseButton.classList.add(visibleBtnClass);
  const iterateThroughSlides = () => {
    if (IS_PAUSED) {
      el.getAnimations({
        subtree: true
      }).map(animation => animation.pause());
      clearInterval(SLIDER_INTERVAL);
      return;
    } else {
      imagesArr.forEach((x, i) => {
        imagesArr[i].style.opacity = 0;
        imagesArr[i].classList.remove(visibleClass);
      });
      CURRENT_SLIDE = CURRENT_SLIDE != imagesArr.length - 1 ? CURRENT_SLIDE + 1 : 0;
      imagesArr[CURRENT_SLIDE].style.opacity = 1;
      imagesArr[CURRENT_SLIDE].classList.add(visibleClass);
      imagesArr[CURRENT_SLIDE].animate([
      // keyframes
      {
        transform: "scale3d(1, 1, 1)"
      }, {
        transform: "scale3d(1.5, 1.5, 1.5)"
      }], {
        // timing options
        duration: 60000,
        iterations: Infinity,
        fill: "forwards"
      });
    }
  };
  const pauseSlideShow = () => {
    if (IS_PAUSED) {
      el.classList.remove(pausedClass);
      IS_PAUSED = false;
      SLIDER_INTERVAL = setInterval(iterateThroughSlides, 3500);
    } else {
      el.classList.add(pausedClass);
      IS_PAUSED = true;
    }
  };
  pauseButton.addEventListener("click", pauseSlideShow);
  if (prefersLessMotion.matches || IS_PAUSED || isExperienceEditor) {
    return;
  } else {
    SLIDER_INTERVAL = setInterval(iterateThroughSlides, 3500);
  }
};
exports.initSimpleImageSlider = initSimpleImageSlider;
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-simple-image-slider")].forEach(initSimpleImageSlider);
}

},{}],217:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _lodash = _interopRequireDefault(require("lodash.throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const initSimpleSlider = (el, i) => {
    const isExperienceEditor = document.querySelector("body").classList.contains("experience-editor");
    const buttonJsClass = "js-slider-button";
    const customButtonClass = el.dataset.button;
    const slideContainer = el.querySelector(".js-simple-slider-container");
    const scrollContainer = el.querySelector(".js-simple-slider-scroll-container"); //how we control slide position outside of focus
    let slideCounter = 0;
    const slideButtonPrev = el.querySelector(".js-slider-button-prev");
    const slideButtonNext = el.querySelector(".js-slider-button-next");
    const buttonContainer = el.querySelector(".js-slider-button-container");
    const counterContainer = el.querySelector(".js-counter-container");
    const counterCurrent = document.querySelector(".js-counter-current");
    const counterTotal = document.querySelector(".js-counter-total");
    const buttonArray = new Array();
    const initialWindowSize = window.innerWidth;
    const isResponsive = el.dataset.responsive === "true";
    let CURRENT_SLIDE;
    let SLIDES = el.querySelectorAll(".js-simple-slider-slide");
    const handleSize = e => {
      e.preventDefault();
      if (!isResponsive) {
        slideContainer.style.width = `${SLIDES.length * 100}vw`;
      }
      if (window.innerWidth != initialWindowSize) {
        //update the nodelist
        SLIDES = el.querySelectorAll(".js-simple-slider-slide");
        const scrollLeft = CURRENT_SLIDE * window.innerWidth;
        scrollContainer.scrollLeft = scrollLeft;
      }
    };
    const setSlideInView = (el, button) => {
      if (!el) return null;
      const container = isResponsive ? slideContainer : scrollContainer;

      // there's an ios bug that is preventing scrolling from working
      // https://developer.apple.com/forums/thread/703294
      // this can probably be cleaned up later

      const onScrollComplete = event => {
        if (event.target.scrollLeft === el.offsetLeft) {
          container.removeEventListener("scroll", onScrollComplete);
          counterContainer ? button.focus() : el.focus();
          container.style.removeProperty("overflow");
        }
      };
      container.addEventListener("scroll", onScrollComplete);
      container.style.overflow = "auto";
      setTimeout(() => {
        container.scrollTo({
          top: 0,
          left: el.offsetLeft,
          behavior: "smooth"
        });
      }, 100);
    };
    const handleCounter = () => {
      counterCurrent.textContent = `${slideCounter + 1}`;
      counterContainer.setAttribute("aria-label", `${slideCounter + 1} of ${SLIDES.length}`);
    };
    const handleSlideDirection = e => {
      const slideDirection = e.currentTarget.dataset.direction;
      if (slideDirection === "prev") {
        if (slideCounter > 0) {
          slideCounter -= 1;
        } else if (slideCounter === 0 && counterContainer) {
          slideCounter = SLIDES.length - 1;
        }
      } else if (slideDirection === "next") {
        if (slideCounter < SLIDES.length - 1) {
          slideCounter += 1;
        } else if (slideCounter === SLIDES.length - 1 && counterContainer) {
          slideCounter = 0;
        }
      }
      setSlideInView(SLIDES[slideCounter], e.target);
      buttonContainer && buttonArray.forEach(x => x.removeAttribute("aria-current"));
      buttonContainer && buttonArray[slideCounter].setAttribute("aria-current", true);
      counterContainer && handleCounter(e);
    };
    const handleSlideSelect = e => {
      e.preventDefault();
      const button = e.target;
      const chosenSlideIndex = button.dataset.slide;
      CURRENT_SLIDE = chosenSlideIndex;
      setSlideInView(SLIDES[chosenSlideIndex]);
      buttonArray.forEach(x => x.removeAttribute("aria-current"));
      button.setAttribute("aria-current", true);
    };
    const handleSlideFocus = e => {
      const slide = e.target;
      const slideIndex = [].indexOf.call(SLIDES, slide);
      buttonArray.forEach(x => x.removeAttribute("aria-current"));
      buttonArray[slideIndex].setAttribute("aria-current", true);
      CURRENT_SLIDE = slideIndex;
    };
    if (!isExperienceEditor) {
      window.addEventListener("load", handleSize);
      window.addEventListener("resize", (0, _lodash.default)(handleSize, 500));
      slideButtonPrev.addEventListener("click", handleSlideDirection);
      slideButtonNext.addEventListener("click", handleSlideDirection);
      if (buttonContainer) {
        SLIDES.forEach((slide, i) => {
          const button = document.createElement("button");
          button.setAttribute("type", "button");
          button.className = `${buttonJsClass} ${customButtonClass}`;
          button.setAttribute("aria-label", `slide ${i + 1}`);
          i === 0 && button.setAttribute("aria-current", true);
          button.setAttribute("data-slide", i);
          button.textContent = `${i + 1}`;
          button.onclick = e => handleSlideSelect(e);
          buttonContainer.appendChild(button);
          buttonArray.push(button);
          CURRENT_SLIDE = 0;
          slide.addEventListener("focus", handleSlideFocus);
        });
      } else if (counterContainer) {
        CURRENT_SLIDE = 0;
        counterContainer.setAttribute("aria-label", `${CURRENT_SLIDE + 1} of ${SLIDES.length}`);
        counterCurrent.textContent = `${CURRENT_SLIDE + 1}`;
        counterTotal.textContent = `${SLIDES.length}`;
        SLIDES.forEach((slide, i) => {
          slide.addEventListener("focus", e => {
            const slide = e.target;
            const slideIndex = [].indexOf.call(SLIDES, slide);
            CURRENT_SLIDE = slideIndex;
            slideCounter = slideIndex;
            handleCounter();
          });
        });
      }
    }
  };
  [...document.querySelectorAll(".js-simple-slider")].forEach(initSimpleSlider);
}

},{"lodash.throttle":"lodash.throttle"}],218:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stickyNav = void 0;
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _getElemDistance = require("./getElemDistance.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const stickyNav = el => {
  const stickyNav = el;
  const evaluatePosition = (navPosition, stickyNav) => {
    if (window.pageYOffset >= navPosition) {
      stickyNav.classList.add("gv__base-template__sticky-nav--scroll-padding");
    } else {
      stickyNav.classList.remove("gv__base-template__sticky-nav--scroll-padding");
    }
  };
  if (stickyNav) {
    const debouncePosition = (0, _lodash.default)(evaluatePosition, 100);
    window.addEventListener("scroll", () => {
      const navPosition = (0, _getElemDistance.getElemDistance)(stickyNav);
      debouncePosition(navPosition, stickyNav);
    });
  }
};
exports.stickyNav = stickyNav;

},{"./getElemDistance.js":90,"lodash.debounce":"lodash.debounce"}],219:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _getElemDistance = require("./getElemDistance.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const initialPrevNext = document.querySelector(".js-prev-next");
  const stickyNav = document.querySelector(".js-top-nav");
  const evaluatePosition = (navPosition, initialPrevNext) => {
    if (window.pageYOffset >= navPosition - 100) {
      stickyNav.classList.add("is-sticky");
    } else {
      stickyNav.classList.remove("is-sticky");
    }
  };
  if (initialPrevNext) {
    const debouncePosition = (0, _lodash.default)(evaluatePosition, 50);
    window.addEventListener("scroll", () => {
      if (window.innerWidth > 680) {
        const navPosition = (0, _getElemDistance.getElemDistance)(initialPrevNext);
        debouncePosition(navPosition, initialPrevNext);
      }
    });
  }
}

},{"./getElemDistance.js":90,"lodash.debounce":"lodash.debounce"}],220:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _eyeIcon = _interopRequireDefault(require("../partials/eye-icon.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AssignmentGroup = props => {
  const {
    UnitName,
    Assignments
  } = props.assignmentGroup;
  const renderStatus = (preText, postText, iconClass, preTextClass) => {
    // preTextClass

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__student-periods__status-display"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: `gv__assignment-list__status ${preTextClass}`
    }, preText), /*#__PURE__*/_react.default.createElement("div", {
      className: `gv__student-periods__status ${iconClass}`
    }, /*#__PURE__*/_react.default.createElement("span", null, postText)));
  };
  const renderLink = (link, name) => {
    if (link) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: link,
        className: "gv__link gv__student-periods__link"
      }, name);
    } else {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__student-periods__link"
      }, name);
    }
  };
  const renderAssignment = (assignment, i) => {
    const {
      AssignmentName,
      AssignmentId,
      AssignmentGuid,
      AssignmentType,
      LaunchUrl,
      ReportUrl,
      SubmissionDate,
      PreText,
      PostText,
      IconClass,
      PreTextClass
    } = assignment;
    const reportLabel = props.reportLabel;
    const submissionDate = SubmissionDate ? SubmissionDate : "-";
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: i
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__student-periods__cell",
      "data-header": "Assignment"
    }, renderLink(LaunchUrl, AssignmentName)), /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__student-periods__cell",
      "data-header": "Status"
    }, renderStatus(PreText, PostText, IconClass, PreTextClass)), /*#__PURE__*/_react.default.createElement("td", {
      className: "gv__student-periods__cell gv__student-periods__submission-date",
      "data-header": "Date"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__student-periods__results"
    }, /*#__PURE__*/_react.default.createElement("span", null, " ", submissionDate), ReportUrl && /*#__PURE__*/_react.default.createElement("a", {
      href: ReportUrl,
      title: `${reportLabel} for ${AssignmentName}`,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "gv__student-periods__report-link gv__link"
    }, " ", /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__assignment-list__reports-text"
    }, " ", /*#__PURE__*/_react.default.createElement(_eyeIcon.default, null), reportLabel)))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
    className: "gv__student-periods__unit-title",
    colSpan: "3"
  }, UnitName)), Assignments.map((assignment, index) => renderAssignment(assignment, index)));
};
AssignmentGroup.propTypes = {
  assignmentGroup: _propTypes.object
};
var _default = exports.default = AssignmentGroup;

},{"../partials/eye-icon.jsx":149,"classnames":"classnames","prop-types":"prop-types","react":"react"}],221:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
var _EditStudent = _interopRequireDefault(require("../edit-student/EditStudent.jsx"));
var _AssignmentGroup = _interopRequireDefault(require("./AssignmentGroup.jsx"));
var assignmentData = _interopRequireWildcard(require("./fake-student-details.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class StudentDetails extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const select = document.querySelector(".js-student-detail-select");
      select.addEventListener("change", e => this.detectStudentChange(e));

      //get initial values
      const firstName = select.options[select.selectedIndex].dataset.studentFname;
      const lastName = select.options[select.selectedIndex].dataset.studentLname;
      const email = select.options[select.selectedIndex].dataset.studentEmail;
      const lastActive = select.options[select.selectedIndex].dataset.lastActive;
      const initialStudentId = select.options[select.selectedIndex].dataset.studentId;
      const initialStudentName = `${firstName} ${lastName}`;
      const initialStudentMembershipId = select.options[select.selectedIndex].value;
      const editStudentModal = document.querySelector(".js-edit-student-modal");
      if (editStudentModal) {
        const modalProps = {
          dictionary: JSON.parse(editStudentModal.dataset.dictionary) || {},
          periodId: editStudentModal.dataset.periodId || "",
          requestUrl: editStudentModal.dataset.requestUrl || "",
          teacherId: editStudentModal.dataset.teacherId || "",
          deleteModal: JSON.parse(editStudentModal.dataset.delete) || {},
          isClever: editStudentModal.dataset.periodIsClever && editStudentModal.dataset.periodIsClever.toLowerCase() === "true" ? true : false
        };
        this.setState({
          modalProps
        });
      }
      this.setState({
        studentId: initialStudentId,
        studentMembershipId: initialStudentMembershipId,
        studentName: initialStudentName,
        email: email,
        firstName: firstName,
        lastName: lastName,
        lastActive: lastActive
      });
    });
    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevState.studentId !== this.state.studentId) {
        if (this.state.studentId && this.state.studentId) {
          this.fetchStudentDetails();
        }
      }
    });
    _defineProperty(this, "fetchStudentDetails", () => {
      const params = {
        PeriodId: this.props.periodId,
        CourseId: this.props.courseId,
        StudentMembershipId: this.state.studentMembershipId
      };
      if (this.props.isPatternlab) {
        this.setState({
          isLoading: false,
          assignments: assignmentData.data
        });
      } else {
        fetch(`${this.props.requestUrl}/owh/assignment/GetStudentAssignments`, {
          method: "POST",
          body: JSON.stringify(params),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => response.json()).then(data => {
          if (data.length === 0) {
            this.setState({
              isLoading: false
            });
            return;
          } else {
            this.setState({
              isLoading: false,
              assignments: data
            });
          }
        }).catch(err => {
          console.error(err);
          this.setState({
            isLoading: false
          });
        });
      }
    });
    _defineProperty(this, "detectStudentChange", e => {
      const select = e.target;
      const firstName = select.options[select.selectedIndex].dataset.studentFname;
      const lastName = select.options[select.selectedIndex].dataset.studentLname;
      const email = select.options[select.selectedIndex].dataset.studentEmail;
      const newStudentName = `${firstName} ${lastName}`;
      const lastActive = select.options[select.selectedIndex].dataset.lastActive;
      const newStudentId = select.options[select.selectedIndex].dataset.studentId;
      const newStudentMembershipId = select.options[select.selectedIndex].value;
      this.setState({
        studentId: newStudentId,
        studentName: newStudentName,
        email: email,
        firstName: firstName,
        lastName: lastName,
        lastActive: lastActive,
        isLoading: true,
        studentMembershipId: newStudentMembershipId
      });
    });
    this.state = {
      assignments: [],
      studentMembershipId: null,
      studentId: null,
      studentName: null,
      email: null,
      firstName: null,
      lastName: null,
      isLoading: true,
      modalProps: null
    };
  }
  render() {
    const {
      assignments,
      studentId,
      studentName,
      isLoading,
      firstName,
      lastName,
      email,
      lastActive,
      modalProps
    } = this.state;
    const {
      assignmentHeader,
      statusHeader,
      resultsHeader,
      dateHeader,
      lastActiveLabel,
      viewReportLabel
    } = this.props.dictionary;
    const displayAssignments = !isLoading && assignments.length > 0;
    console.log("assignments", assignments, assignments.length);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading && /*#__PURE__*/_react.default.createElement(_loading.default, {
      isLoading: isLoading
    }), !isLoading && /*#__PURE__*/_react.default.createElement("section", {
      className: "gv__student-details gv__component"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__student-details__container gv__container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__student-details__head"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "gv__student-details__title"
    }, studentName), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__student-details__edit"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: "gv__student-details__edit-button gv__link js-gv__edit-students",
      "data-student": `{
                    "firstName": "${firstName}",
                    "lastName":"${lastName}",
                    "email":"${email}",
                    "studentId": "${studentId}"
                  }`
    }, "Edit")), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__student-details__last-active"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__student-details__last-active-label"
    }, lastActiveLabel), ":", " ", lastActive))), displayAssignments && /*#__PURE__*/_react.default.createElement("table", {
      className: "gv__student-periods__table gv__container"
    }, /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement("tr", {
      className: "gv__student-periods__heading"
    }, /*#__PURE__*/_react.default.createElement("th", {
      scope: "col"
    }, assignmentHeader), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col",
      className: "gv__student-periods__heading-status"
    }, statusHeader), /*#__PURE__*/_react.default.createElement("th", {
      scope: "col"
    }, dateHeader)), assignments.map((assignment, i) => /*#__PURE__*/_react.default.createElement(_AssignmentGroup.default, {
      reportLabel: viewReportLabel,
      key: i,
      assignmentGroup: assignment
    })))), modalProps && /*#__PURE__*/_react.default.createElement(_EditStudent.default, modalProps)));
  }
}
exports.default = StudentDetails;
_defineProperty(StudentDetails, "propTypes", {
  requestUrl: _propTypes.string,
  periodId: _propTypes.string,
  courseId: _propTypes.string,
  dictionary: _propTypes.object,
  isPatternlab: _propTypes.bool
});

},{"../edit-student/EditStudent.jsx":78,"../partials/loading.jsx":150,"./AssignmentGroup.jsx":220,"./fake-student-details.json":222,"prop-types":"prop-types","react":"react"}],222:[function(require,module,exports){
module.exports={ "data": [
    {
        "UnitName": "Era 1: Our Big History",
        "Assignments": [
            {
                "AssignmentName": "1.0 Practice Set: History Stories",
                "AssignmentId": 0,
                "AssignmentGuid": "4e11e25f-7735-41d5-853c-480e3f491b66",
                "SubmissionDate": "12/12/12",
                "ReportUrl": "#",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=4e11e25f-7735-41d5-853c-480e3f491b66",
                "AssignmentType": 1,
                "PreText": "Closed",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "Student Survey: Beginning of the Year",
                "AssignmentId": 0,
                "AssignmentGuid": "ac652740-27f8-4b24-b4b6-42953eaed3c5",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=ac652740-27f8-4b24-b4b6-42953eaed3c5",
                "AssignmentType": 2,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "1.1 Practice Set: Era 1 Overview",
                "AssignmentId": 0,
                "AssignmentGuid": "4b5634c6-ee99-4a0d-a61e-4d93e947f35f",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=4b5634c6-ee99-4a0d-a61e-4d93e947f35f",
                "AssignmentType": 1,
                "PreText": "Closed",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "1.2 Practice Set: History Frames",
                "AssignmentId": 0,
                "AssignmentGuid": "ffdb3193-32f8-4c89-8938-c100110ba861",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=ffdb3193-32f8-4c89-8938-c100110ba861",
                "AssignmentType": 1,
                "PreText": "Closed",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "Score – DBQ 0",
                "AssignmentId": 0,
                "AssignmentGuid": "597b06df-48e3-4935-af30-2dd0f117f1b5",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=597b06df-48e3-4935-af30-2dd0f117f1b5",
                "AssignmentType": 3,
                "PreText": "Closed",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "1.3 Practice Set: The Big History Story",
                "AssignmentId": 0,
                "AssignmentGuid": "a998c2f1-c6a8-47f9-81cb-a7d0619fdbb3",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=a998c2f1-c6a8-47f9-81cb-a7d0619fdbb3",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            }
        ]
    },
    {
        "UnitName": "Era 2: Early Humans",
        "Assignments": [
            {
                "AssignmentName": "2.0 Practice Set: Era 2 Overview",
                "AssignmentId": 0,
                "AssignmentGuid": "dcf8e663-2a3d-41d5-aa57-a20bb690fb79",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=dcf8e663-2a3d-41d5-aa57-a20bb690fb79",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "2.1 Practice Set: Humans as a Divergence",
                "AssignmentId": 0,
                "AssignmentGuid": "5ed63bdf-38fb-48c1-94a3-567670146f64",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=5ed63bdf-38fb-48c1-94a3-567670146f64",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "2.2 Practice Set: Foragers",
                "AssignmentId": 0,
                "AssignmentGuid": "ef02bb06-69a7-442d-9c13-cba35eac8a3d",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=ef02bb06-69a7-442d-9c13-cba35eac8a3d",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "2.3 Practice Set: Farmer Revolution",
                "AssignmentId": 0,
                "AssignmentGuid": "60619dc8-d6f6-4b57-97fa-58f6e41a53fe",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=60619dc8-d6f6-4b57-97fa-58f6e41a53fe",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "Era 2 LEQ",
                "AssignmentId": 0,
                "AssignmentGuid": "2e14d299-60c9-4139-bfd5-b928621b2df5",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": null,
                "AssignmentType": 2,
                "PreText": "Not Assigned",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "2.4 Practice Set: Was Farming a Good Idea?",
                "AssignmentId": 0,
                "AssignmentGuid": "8cf0521a-57f0-47fc-aa3d-147344b9a416",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=8cf0521a-57f0-47fc-aa3d-147344b9a416",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            }
        ]
    },
    {
        "UnitName": "Era 3: Cities, Societies, and Empires ",
        "Assignments": [
            {
                "AssignmentName": "3.0 Practice Set: Era 3 Overview",
                "AssignmentId": 0,
                "AssignmentGuid": "b57347cc-ad58-4ad8-a239-cea84f1fdf04",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=b57347cc-ad58-4ad8-a239-cea84f1fdf04",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "3.1 Practice Set: Village Networks",
                "AssignmentId": 0,
                "AssignmentGuid": "6419f63c-a651-4bad-b44c-766219c7fbc5",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=6419f63c-a651-4bad-b44c-766219c7fbc5",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "3.2 Practice Set: Long Distance Trade",
                "AssignmentId": 0,
                "AssignmentGuid": "bea4868a-fd32-4ba3-82f1-60af500ddf25",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=bea4868a-fd32-4ba3-82f1-60af500ddf25",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "3.3 Practice Set: Comparing Early Agrarian Societies",
                "AssignmentId": 0,
                "AssignmentGuid": "4b4bb528-9c9b-4563-9464-c26b266495d7",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=4b4bb528-9c9b-4563-9464-c26b266495d7",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "3.4 Practice Set: What is a State",
                "AssignmentId": 0,
                "AssignmentGuid": "e1c981d3-ceb3-420f-a31d-aac9ade3f747",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=e1c981d3-ceb3-420f-a31d-aac9ade3f747",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "3.5 Practice Set: Development of Portable Belief Systems",
                "AssignmentId": 0,
                "AssignmentGuid": "cc8a90da-8a30-4e87-9cd3-b3278a1068dd",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=cc8a90da-8a30-4e87-9cd3-b3278a1068dd",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "3.6 Practice Set: The Growth of Empires",
                "AssignmentId": 0,
                "AssignmentGuid": "4175920b-580c-4ffe-b27b-6291ff34bc1b",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=4175920b-580c-4ffe-b27b-6291ff34bc1b",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "Era 3 DBQ",
                "AssignmentId": 0,
                "AssignmentGuid": "1ba8379d-91f6-45b1-8d81-a621fb44747e",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": null,
                "AssignmentType": 2,
                "PreText": "Not Assigned",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "3.7 Practice Set: Comparing the Roman Empire and the Han Dynasty",
                "AssignmentId": 0,
                "AssignmentGuid": "0d7cf0c1-ac0e-4a01-b20d-db6fd996f1e8",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=0d7cf0c1-ac0e-4a01-b20d-db6fd996f1e8",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            }
        ]
    },
    {
        "UnitName": "Era 4: Regional Webs",
        "Assignments": [
            {
                "AssignmentName": "4.0 Practice Set: Era 4 Overview",
                "AssignmentId": 0,
                "AssignmentGuid": "32fc91b3-35b8-4e8c-99ed-c64e4adeb6f3",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=32fc91b3-35b8-4e8c-99ed-c64e4adeb6f3",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "4.1 Practice Set: Systems Collapse",
                "AssignmentId": 0,
                "AssignmentGuid": "6a9dfd1d-fcfd-42b3-8c39-3b563f5a0d14",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=6a9dfd1d-fcfd-42b3-8c39-3b563f5a0d14",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "4.2 Practice Set: Systems Restructure",
                "AssignmentId": 0,
                "AssignmentGuid": "ea49490c-3da5-450b-8dac-85f5e9c1ad04",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=ea49490c-3da5-450b-8dac-85f5e9c1ad04",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "Era 4 LEQ",
                "AssignmentId": 0,
                "AssignmentGuid": "d9e7335a-d541-47d2-8adc-ca851ee784ff",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": null,
                "AssignmentType": 2,
                "PreText": "Not Assigned",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "4.3 Practice Set: A Dark Age?",
                "AssignmentId": 0,
                "AssignmentGuid": "f53c8109-9192-4f61-beca-b551383350a7",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=f53c8109-9192-4f61-beca-b551383350a7",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            }
        ]
    },
    {
        "UnitName": "Era 5: The First Global Age",
        "Assignments": [
            {
                "AssignmentName": "5.0 Practice Set: Era 5 Overview",
                "AssignmentId": 0,
                "AssignmentGuid": "57a3175e-97fe-4295-b055-f26ea9b0eefb",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=57a3175e-97fe-4295-b055-f26ea9b0eefb",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "5.1 Practice Set: Land-Based Empires",
                "AssignmentId": 0,
                "AssignmentGuid": "2b01b80e-70e7-4e4f-9ccd-9807ef12a23b",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=2b01b80e-70e7-4e4f-9ccd-9807ef12a23b",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "5.2 Practice Set: Old World Webs",
                "AssignmentId": 0,
                "AssignmentGuid": "a66301f6-8cfb-4054-a8d2-a7834b176f5e",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=a66301f6-8cfb-4054-a8d2-a7834b176f5e",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "5.3 Practice Set: The Columbian Exchange",
                "AssignmentId": 0,
                "AssignmentGuid": "cdeb9e34-ef5c-44e0-8b14-97d7e81ea85c",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=cdeb9e34-ef5c-44e0-8b14-97d7e81ea85c",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "5.4 Practice Set: The Transatlantic Slave Trade",
                "AssignmentId": 0,
                "AssignmentGuid": "a8d1de7e-46df-4725-97ac-cfc284ce5eb8",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=a8d1de7e-46df-4725-97ac-cfc284ce5eb8",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "Score – DBQ 5",
                "AssignmentId": 0,
                "AssignmentGuid": "40e9273f-3926-43b0-8ad8-7a2e58646cee",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=40e9273f-3926-43b0-8ad8-7a2e58646cee",
                "AssignmentType": 3,
                "PreText": "Closed",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "5.5 Practice Set: New Economic Systems",
                "AssignmentId": 0,
                "AssignmentGuid": "73edc10f-0169-4be1-ad50-0a7d7ba8d1bb",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=73edc10f-0169-4be1-ad50-0a7d7ba8d1bb",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            }
        ]
    },
    {
        "UnitName": "Era 6: The Long Nineteenth Century",
        "Assignments": [
            {
                "AssignmentName": "6.0 Practice Set: Era 6 Overview",
                "AssignmentId": 0,
                "AssignmentGuid": "9dd9dd37-9e6d-4b70-a037-473db5e6930d",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=9dd9dd37-9e6d-4b70-a037-473db5e6930d",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "6.1 Practice Set: Liberal and National Revolutions",
                "AssignmentId": 0,
                "AssignmentGuid": "62cc8ab3-c477-4ce4-b117-8f4f85ff55c2",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=62cc8ab3-c477-4ce4-b117-8f4f85ff55c2",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "6.2 Practice Set: Industrialization",
                "AssignmentId": 0,
                "AssignmentGuid": "5f7ab37a-98ec-45c3-908d-74b7a9ff8b70",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=5f7ab37a-98ec-45c3-908d-74b7a9ff8b70",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "6.3 Practice Set: Imperialism",
                "AssignmentId": 0,
                "AssignmentGuid": "9f86deae-1113-41ba-af16-ca4f105363cc",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=9f86deae-1113-41ba-af16-ca4f105363cc",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "Era 6 LEQ",
                "AssignmentId": 0,
                "AssignmentGuid": "dbc7b76a-6939-4382-908b-1a1c5c5b8234",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": null,
                "AssignmentType": 2,
                "PreText": "Not Assigned",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "6.4 Practice Set: Transformation of Labor",
                "AssignmentId": 0,
                "AssignmentGuid": "4f12693b-d2ab-428c-84df-b122bd4433ea",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=4f12693b-d2ab-428c-84df-b122bd4433ea",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            }
        ]
    },
    {
        "UnitName": "Era 7: The Great Convergence and Divergence",
        "Assignments": [
            {
                "AssignmentName": "7.0 Practice Set: Era 7 Overview",
                "AssignmentId": 0,
                "AssignmentGuid": "e64e3126-10e5-4954-8eef-07f6668f2ad1",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=e64e3126-10e5-4954-8eef-07f6668f2ad1",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "7.1 Practice Set: World War I",
                "AssignmentId": 0,
                "AssignmentGuid": "5c575048-eaa1-415c-ab61-679680df8807",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=5c575048-eaa1-415c-ab61-679680df8807",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "7.2 Practice Set: Interwar",
                "AssignmentId": 0,
                "AssignmentGuid": "d9ebad9b-f259-44eb-8104-c5da6a927e22",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=d9ebad9b-f259-44eb-8104-c5da6a927e22",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "7.3 Practice Set: World War II",
                "AssignmentId": 0,
                "AssignmentGuid": "4f92d43e-07fd-4c65-9c9b-01baee4983ef",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=4f92d43e-07fd-4c65-9c9b-01baee4983ef",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "7.4 Practice Set: End of Empires and Cold War",
                "AssignmentId": 0,
                "AssignmentGuid": "5bdc7cdc-51bd-4c20-a8cc-5f225772c2b7",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=5bdc7cdc-51bd-4c20-a8cc-5f225772c2b7",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "7.5 Practice Set: Global Interactions and Institutions",
                "AssignmentId": 0,
                "AssignmentGuid": "d4da59ab-e9d4-427d-a241-992ce606c637",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=d4da59ab-e9d4-427d-a241-992ce606c637",
                "AssignmentType": 1,
                "PreText": "Open",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--open"
            },
            {
                "AssignmentName": "Score – DBQ 7",
                "AssignmentId": 0,
                "AssignmentGuid": "ed9fef74-deb1-4190-9ba5-c97031c6d730",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": null,
                "AssignmentType": 3,
                "PreText": "Not Assigned",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            },
            {
                "AssignmentName": "7.6 Practice Set: Yeah, But?",
                "AssignmentId": 0,
                "AssignmentGuid": "6c77c085-0fba-4864-905d-91fc2e01c95c",
                "SubmissionDate": "-",
                "ReportUrl": "",
                "LaunchUrl": "/Teacher-Dashboard/Assignment-Details?Period_Id=10163&AssignmentGuid=6c77c085-0fba-4864-905d-91fc2e01c95c",
                "AssignmentType": 1,
                "PreText": "Closed",
                "PostText": "Not Started",
                "IconClass": "gv__student-periods__status--not-submitted",
                "PreTextClass": "gv__student-periods__status-open-closed--closed"
            }
        ]
    }
]}
},{}],223:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _StudentDetails = _interopRequireDefault(require("./StudentDetails.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-student-details-mount");
if (el) {
  const props = {
    dictionary: JSON.parse(el.dataset.dictionary) || "",
    courseId: el.dataset.courseId || "",
    periodId: el.dataset.periodId || "",
    isPatternlab: el.dataset.isPatternlab === "true" ? true : false,
    requestUrl: el.dataset.requestUrl || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_StudentDetails.default, props), el);
}

},{"./StudentDetails.jsx":221,"react":"react","react-dom":"react-dom"}],224:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _fakeCourses = _interopRequireDefault(require("./fake-courses.json"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _loading = _interopRequireDefault(require("../partials/loading.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  courses: (0, _propTypes.shape)({
    suggestedOnDemandCoursesTitle: _propTypes.string
  }),
  endpoint: _propTypes.string,
  pdTabId: _propTypes.string,
  isPatternlab: _propTypes.bool
};
const SuggestedCourses = props => {
  const {
    courses,
    isPatternlab
  } = props;
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [courseData, setCourseData] = (0, _react.useState)([]);
  const {
    suggestedOnDemandCoursesTitle,
    endpoint,
    pdTabId,
    emptyLabel
  } = courses;
  (0, _react.useEffect)(() => {
    if (isPatternlab) {
      setCourseData(_fakeCourses.default.courses);
      return;
    }
    const url = `${endpoint}`;
    const fetchData = async url => {
      setIsLoading(true);
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        });
        if (!response.ok) {
          throw new Error(`Error! status: ${response.status}`);
        }
        const result = await response.json();
        setCourseData(result.result.courses);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
        setIsLoading(false);
      }
    };
    const tab = document.getElementById(pdTabId);
    tab.addEventListener("click", () => {
      fetchData(url);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__suggested-courses gv__component"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__container gv__suggested-courses__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__suggested-courses__heading"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__suggested-courses__heading-title"
  }, suggestedOnDemandCoursesTitle), !isLoading && /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__suggested-courses__heading-event-count"
  }, `(${courseData.length})` || 0)), isLoading && /*#__PURE__*/_react.default.createElement(_loading.default, {
    isLoading: isLoading
  }), !isLoading && (courseData.length ? courseData.map((course, i) => {
    const courseClass = (0, _classnames.default)("gv__suggested-courses__course", {
      "gv__suggested-courses__course--image-right": i % 2 === 1
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: courseClass,
      key: i
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__container gv__suggested-courses__container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__suggested-courses__content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__suggested-courses__media"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: course.courseImage,
      alt: ""
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__suggested-courses__info"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "gv__suggested-courses__title"
    }, course.courseName), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__suggested-courses__body"
    }, /*#__PURE__*/_react.default.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: `${course.courseDescription}`
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__suggested-courses__cta"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: course.courseLink,
      className: "gv__button gv__button--external gv__suggested-courses__button"
    }, /*#__PURE__*/_react.default.createElement("span", null, course.courseLinkLabel), /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__button__icon"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      role: "img",
      width: "7",
      height: "12",
      viewBox: "0 0 7 12",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("title", null), /*#__PURE__*/_react.default.createElement("g", {
      strokeWidth: "1.3",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "square"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M1 10.95L5.95 6M1 1l4.95 4.95"
    }))))))))));
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__suggested-courses__no-courses"
  }, emptyLabel))));
};
SuggestedCourses.propTypes = propTypes;
var _default = exports.default = SuggestedCourses;

},{"../partials/loading.jsx":150,"./fake-courses.json":225,"classnames":"classnames","prop-types":"prop-types","react":"react"}],225:[function(require,module,exports){
module.exports={
  "courses": [
    {
      "courseName": "Teaching Big History",
      "courseDescription": "Build your knowledge and skills with Big History Project's on-demand professional development course. Whether you’re getting ready to teach for the first time or looking to refresh your approach as a returning teacher, the Teaching BHP course has something for you.",
      "courseImage": "https://spaceholder.cc/1640x640",
      "courseLinkLabel": "Learn more about this course",
      "courseLink": "https://www.velir.com"
    },
    {
      "courseName": "Teaching WHP Origins to the Present",
      "courseDescription": "Build your knowledge and skills with Big History Project's on-demand professional development course. Whether you’re getting ready to teach for the first time or looking to refresh your approach as a returning teacher, the Teaching BHP course has something for you.",
      "courseImage": "https://spaceholder.cc/1640x640",
      "courseLinkLabel": "Learn more about this course",
      "courseLink": "https://www.velir.com"
    },
    {
      "courseName": "Teaching WHP 1200 to the Present",
      "courseDescription": "Build your knowledge and skills with Big History Project's on-demand professional development course. Whether you’re getting ready to teach for the first time or looking to refresh your approach as a returning teacher, the Teaching BHP course has something for you.",
      "courseImage": "https://spaceholder.cc/1640x640",
      "courseLinkLabel": "Learn more about this course",
      "courseLink": "https://www.velir.com"
    },
    {
      "courseName": "Teaching WHP 1750 to the Present",
      "courseDescription": "Build your knowledge and skills with Big History Project's on-demand professional development course. Whether you’re getting ready to teach for the first time or looking to refresh your approach as a returning teacher, the Teaching BHP course has something for you.",
      "courseImage": "https://spaceholder.cc/1640x640",
      "courseLinkLabel": "Learn more about this course",
      "courseLink": "https://www.velir.com"
    },
    {
      "courseName": "Teaching World History Project AP®",
      "courseDescription": "Build your knowledge and skills with Big History Project's on-demand professional development course. Whether you’re getting ready to teach for the first time or looking to refresh your approach as a returning teacher, the Teaching BHP course has something for you.",
      "courseImage": "https://spaceholder.cc/1640x640",
      "courseLinkLabel": "Learn more about this course",
      "courseLink": "https://www.velir.com"
    }
  ]
}
},{}],226:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _SuggestedCourses = _interopRequireDefault(require("./SuggestedCourses.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-suggested-courses-mount");
if (el) {
  const props = {
    courses: JSON.parse(el.dataset.events) || {},
    isPatternlab: el.dataset.isPatternlab ? JSON.parse(el.dataset.isPatternlab) : false
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_SuggestedCourses.default, props), el);
}

},{"./SuggestedCourses.jsx":224,"react":"react","react-dom":"react-dom"}],227:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TeacherCourseListingCard = _interopRequireDefault(require("./TeacherCourseListingCard.jsx"));
var _propTypes = require("prop-types");
var R = _interopRequireWildcard(require("ramda"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactTransitionGroup = require("react-transition-group");
var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TeacherCourseListing = props => {
  const {
    isPatternlab
  } = props;
  const [sectionData, setSectionData] = (0, _react.useState)(window.teacherCourseListingData);
  const [courseOptions, setCourseOptions] = (0, _react.useState)([]);
  const [isAnimating] = (0, _react.useState)(false);
  const prefersLessMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const {
    unpinnedCourses,
    pinnedCourses,
    addClassLabel,
    courseHomeLabel,
    coursesModalDropdown,
    isClever
  } = sectionData;
  const mergedPinnedCourses = pinnedCourses.subsections.flatMap(section => section.courses);
  const mergedUnpinnedCourses = (0, _react.useMemo)(() => {
    return unpinnedCourses.subsections.flatMap(section => section.courses);
  }, [unpinnedCourses]);
  const hasPinnedCourses = !!mergedPinnedCourses && !!mergedPinnedCourses.length;
  const courseListingEl = (0, _react.useRef)(null);
  const unpinnedCourseListEl = (0, _react.useRef)(null);
  const pinnedCourseListEl = (0, _react.useRef)(null);
  const noPinnedEl = (0, _react.useRef)(null);
  const personalizedHeader = document.querySelector(".personalized-header");
  const hasPinnedBackground = hasPinnedCourses && !personalizedHeader;

  /**
   * Gets the course options
   * @returns
   */
  const getCourseOptions = () => {
    const courses = coursesModalDropdown.map(course => {
      return {
        label: course.CourseName,
        detail: course.CourseSummary,
        value: course.CourseId
      };
    });
    setCourseOptions(courses);
  };
  const getCoursesEffect = () => getCourseOptions();
  (0, _react.useEffect)(getCoursesEffect, []);
  const removeFromSection = (courseItem, isPinned) => {
    const coursesType = isPinned ? "unpinnedCourses" : "pinnedCourses";
    const section = isPinned ? unpinnedCourses : pinnedCourses;
    const sectionCopy = {
      ...section
    };
    let newSectionData = {};
    let subsectionTitle = "";
    section.subsections.map((subsection, index) => {
      const itemIndex = subsection.courses.indexOf(courseItem);
      if (itemIndex > -1) {
        subsectionTitle = subsection.subSectionTitle;
        const newList = R.remove(itemIndex, 1, subsection.courses);
        const newSection = {
          subSectionTitle: subsectionTitle,
          courses: newList
        };
        sectionCopy.subsections[index] = newSection;
        newSectionData = {
          ...sectionData,
          [`${coursesType}`]: sectionCopy
        };
      }
    });
    return {
      subsectionTitle,
      newSectionData
    };
  };
  const addToSection = (courseItem, isPinned, sectionObj) => {
    const {
      subsectionTitle,
      newSectionData
    } = sectionObj;
    const data = !newSectionData ? sectionData : newSectionData;
    if (data) {
      const coursesType = isPinned ? "pinnedCourses" : "unpinnedCourses";
      const section = isPinned ? data.pinnedCourses : data.unpinnedCourses;
      const sectionCopy = {
        ...section
      };
      const subsection = sectionCopy.subsections.find(subsection => subsection.subSectionTitle === subsectionTitle);
      const courseSort = R.sortWith([R.ascend(R.prop("courseOrder"))]);
      if (subsection) {
        subsection.courses.push(courseItem);
        subsection.courses = courseSort(subsection.courses);
        setSectionData({
          ...data,
          [`${coursesType}`]: sectionCopy
        });
      }
    }
  };
  const updateWelcomeHeaderBackground = () => {
    const welcomeHeader = document.querySelector(".gv__welcome-header");
    welcomeHeader && !personalizedHeader && (hasPinnedCourses ? welcomeHeader.classList.add("gv__welcome-header--pinned") : welcomeHeader.classList.remove("gv__welcome-header--pinned"));
  };
  (0, _react.useEffect)(updateWelcomeHeaderBackground, [hasPinnedCourses]);
  const createPlaceholder = (id, order, height) => {
    const placeholder = document.createElement("li");
    placeholder.setAttribute("data-id", `placeholder${id}`);
    placeholder.setAttribute("data-order", `${order}`);
    placeholder.style.height = `${height}px`;
    placeholder.classList.add("gv__teacher-course-listing__course-item", "gv__teacher-course-listing__course-item--placeholder", "is-animating", "is-collapsed");
    return placeholder;
  };
  const animateToSection = (courseItem, isPinned, sectionDataObj) => {
    const courseListEl = isPinned ? unpinnedCourseListEl : pinnedCourseListEl;
    const courseItemEl = courseListEl.current.querySelector(`[data-id="${courseItem.courseId}"]`);
    const courseItemCard = courseItemEl.querySelector(".gv__teacher-course-listing-card");
    const itemHeight = courseItemEl.getBoundingClientRect().height + 30;
    const offsetTop = courseItemEl.getBoundingClientRect().top + window.scrollY;
    courseItemEl.style.height = `${itemHeight}px`;
    courseItemEl.classList.add("is-animating");
    setTimeout(() => {
      courseItemEl.classList.add("is-collapsed");
    }, 100);
    const placeholder = createPlaceholder(courseItem.courseId, courseItem.courseOrder, itemHeight);
    const targetCourseListEl = isPinned ? pinnedCourseListEl : unpinnedCourseListEl;
    if (isPinned) {
      const parent = targetCourseListEl.current.closest(".gv__teacher-course-listing__courses");
      if (parent) parent.classList.add("is-full");
      targetCourseListEl.current.appendChild(placeholder);
    } else {
      const targetListEl = targetCourseListEl.current.querySelector(`[data-subsection="${sectionDataObj.subsectionTitle}"]`);
      const placeholderOrder = parseInt(placeholder.getAttribute("data-order"), 10);
      const insertBefore = targetListEl.querySelector(`[data-order="${placeholderOrder + 1}"]`);
      insertBefore ? insertBefore.insertAdjacentElement("beforebegin", placeholder) : targetListEl.appendChild(placeholder);
    }
    const itemPosition = placeholder.getBoundingClientRect().top + window.scrollY - itemHeight - offsetTop + 30;
    setTimeout(() => {
      placeholder.classList.remove("is-collapsed");
      courseItemCard.style.top = `${itemPosition}px`;
      if (isPinned && !courseItem.isVersion3_0) {
        courseItemEl.classList.add("is-pinned");
      } else {
        courseItemEl.classList.remove("is-pinned");
      }
    }, 100);
    setTimeout(() => {
      placeholder.remove();
      addToSection(courseItem, isPinned, sectionDataObj);
      noPinnedEl.current.style.removeProperty("opacity");
    }, 400);
  };
  const swapSections = (courseItem, isPinned) => {
    const sectionDataObj = removeFromSection(courseItem, isPinned);
    prefersLessMotion ? addToSection(courseItem, isPinned, sectionDataObj) : animateToSection(courseItem, isPinned, sectionDataObj);
  };
  const animateToUnpinned = id => {
    const courseItem = mergedPinnedCourses.find(course => course.courseId === id);
    if (courseItem && courseListingEl.current) {
      swapSections(courseItem, false);
    }
  };
  const animateToPinned = id => {
    const courseItem = mergedUnpinnedCourses.find(course => course.courseId === id);
    if (courseItem) {
      noPinnedEl.current.style.opacity = "0";
      swapSections(courseItem, true);
    }
  };
  const handlePinning = (id, isPinned) => {
    if (isPinned) {
      animateToPinned(id);
    } else {
      animateToUnpinned(id);
    }
  };
  const renderCard = (course, index, isPinned, isVersion3_0) => {
    const keyPrefix = `TEACHER_COURSE_LISTING_ITEM_${Math.floor(Math.random() * 10000)}_${index}`;
    const dictionary = {
      pinLabel: unpinnedCourses.pinLabel,
      unpinLabel: pinnedCourses.unpinLabel,
      periodTitleLabel: pinnedCourses.periodTitleLabel,
      addClassLabel: addClassLabel,
      courseHomeLabel: courseHomeLabel
    };
    return /*#__PURE__*/_react.default.createElement("li", {
      key: `${keyPrefix}_${index}`,
      className: (0, _classnames.default)("gv__teacher-course-listing__course-item", {
        "is-pinned": isPinned && !isVersion3_0
      }),
      "data-id": `${course.courseId}`,
      "data-order": `${course.courseOrder}`
    }, /*#__PURE__*/_react.default.createElement(_TeacherCourseListingCard.default, _extends({}, course, {
      dictionary: dictionary,
      courseOptions: courseOptions,
      isClever: isClever,
      isPatternlab: isPatternlab,
      defaultPinned: isPinned,
      onPin: handlePinning,
      isAnimating: isAnimating
    })));
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "gv__teacher-course-listing",
    ref: courseListingEl
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _classnames.default)("gv__teacher-course-listing__pinned", {
      "gv__teacher-course-listing__pinned--gray-background": hasPinnedBackground,
      "gv__teacher-course-listing__pinned--no-pad": !hasPinnedCourses
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing__pinned-container"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__teacher-course-listing__pin-count"
  }, pinnedCourses.numberPinnedRegularLabel, " ", /*#__PURE__*/_react.default.createElement("strong", null, mergedPinnedCourses.length === 0 && `${mergedPinnedCourses.length} ${pinnedCourses.numberPinnedBoldLabel}`, mergedPinnedCourses.length === 1 && `${mergedPinnedCourses.length} ${pinnedCourses.numberPinnedBoldSingularLabel}`, mergedPinnedCourses.length > 1 && `${mergedPinnedCourses.length} ${pinnedCourses.numberPinnedBoldLabel}`)), /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
    className: (0, _classnames.default)("gv__teacher-course-listing__no-pinned-container", {
      "is-displayed": !hasPinnedCourses
    }),
    height: hasPinnedCourses ? 10 : 40
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: !hasPinnedCourses,
    timeout: 350,
    classNames: "fade-slide"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__teacher-course-listing__no-pinned",
    ref: noPinnedEl
  }, /*#__PURE__*/_react.default.createElement("span", null, pinnedCourses.noPinnedLabel), /*#__PURE__*/_react.default.createElement("svg", {
    className: "gv__teacher-course-listing__pin-icon",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 15"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 12.74c.28-.44.38-.93.3-1.37-.06-.32-.1-.76.07-1l2.5-3.8c.17-.26.31-.45.33-.44l.02.03c.38.37.98.4 1.5.14.27-.14.25-.52 0-.76L9.16.97C8.9.73 8.54.7 8.4.97c-.28.52-.24 1.13.14 1.5l.02.03c.01.01-.18.15-.43.32l-3.8 2.5c-.25.17-.69.13-1 .07-.45-.08-.94.02-1.38.3-.25.15-.23.53.02.77l2.7 2.7-2.62 2.63C1 12.92.36 13.94.6 14.17c.22.22 1.24-.42 2.36-1.47l2.63-2.62 2.65 2.66c.25.24.62.27.78.01Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("gv__teacher-course-listing__courses", {
      "is-full": hasPinnedCourses
    })
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "gv__teacher-course-listing__courses-list",
    ref: pinnedCourseListEl
  }, mergedPinnedCourses.map((course, index) => renderCard(course, index, true, course.isVersion3_0)))))), /*#__PURE__*/_react.default.createElement("section", {
    className: "gv__teacher-course-listing__unpinned"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing__unpinned-container",
    ref: unpinnedCourseListEl
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__teacher-course-listing__section-title"
  }, unpinnedCourses.sectionTitle), unpinnedCourses.subsections.map((subsection, index) => {
    const {
      subSectionTitle,
      courses
    } = subsection;
    const keyPrefix = `TEACHER_COURSE_LISTING_UNPINNED_${Math.floor(Math.random() * 10000)}_${index}`;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: keyPrefix,
      className: "gv__teacher-course-listing__courses is-full"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "gv__teacher-course-listing__subsection-title"
    }, subSectionTitle, " (", courses.length, ")"), /*#__PURE__*/_react.default.createElement("ul", {
      className: "gv__teacher-course-listing__courses-list",
      "data-subsection": subSectionTitle
    }, courses.map((course, childIndex) => renderCard(course, childIndex, false))));
  }))));
};
TeacherCourseListing.propTypes = {
  isPatternlab: _propTypes.bool
};
var _default = exports.default = TeacherCourseListing;

},{"./TeacherCourseListingCard.jsx":228,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-animate-height":"react-animate-height","react-transition-group":"react-transition-group"}],228:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _classnames = _interopRequireDefault(require("classnames"));
var _NewClassForm = _interopRequireDefault(require("../partials/NewClassForm.jsx"));
var _NewCleverClassForm = _interopRequireDefault(require("../partials/NewCleverClassForm.jsx"));
var _validation = require("../validation.js");
var _externalLinkIcon = _interopRequireDefault(require("../partials/external-link-icon.jsx"));
var _TeachingThisCourseModal = _interopRequireDefault(require("./TeachingThisCourseModal.jsx"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
_reactModal.default.setAppElement(document.querySelector(".js-page-content-wrapper"));
const TeacherCourseListingCard = props => {
  const {
    title,
    courseUrl,
    isVersion3_0,
    courseParent,
    imageSrc,
    thumbnailSrc,
    description,
    courseLinks,
    courseInformation,
    dictionary,
    courseOptions,
    courseId,
    isClever,
    periods,
    managePeriods,
    isPatternlab,
    defaultPinned,
    onPin,
    isAnimating
  } = props;
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [isLinkModalOpen, setIsLinkModalOpen] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [isPinned, setIsPinned] = (0, _react.useState)(!!defaultPinned);
  const [selectedCourseDetails, setSelectedCourseDetails] = (0, _react.useState)("");
  const [selectedCourse, setSelectedCourse] = (0, _react.useState)("");
  const [cleverPeriods, setCleverPeriods] = (0, _react.useState)(null);
  const [cleverId, setCleverId] = (0, _react.useState)("");
  const [classCode, setClassCode] = (0, _react.useState)("");
  const [modalData] = (0, _react.useState)(window.teacherCourseListingData.modalData);
  const [newPeriodInput, setNewPeriodInput] = (0, _react.useState)({
    value: "",
    error: false,
    errorMsg: ""
  });
  const modalTitleRef = (0, _react.useRef)(null);
  const cardEl = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const defaultCourse = courseOptions.find(opt => `${opt.value}` === `${courseId}`);
    if (defaultCourse) {
      setSelectedCourseDetails(defaultCourse.detail);
      setSelectedCourse(defaultCourse.value);
    }
  }, [courseId, courseOptions]);

  /**
   * Sets the given id as the new clever id
   * @param {String} id
   */
  const updateCleverId = id => {
    setCleverId(id);
  };

  /**
   * Sets the new selected course
   * @param {Event} event
   */
  const updateSelectState = event => {
    const value = event.target.value;
    const filteredResults = R.filter(R.propEq("value", parseInt(value)), courseOptions);
    setSelectedCourse(event.target.value);
    setSelectedCourseDetails(filteredResults[0].detail);
  };

  /**
   * Fetches the data for Clever periods
   */
  const getCleverPeriods = () => {
    setIsLoading(true);
    if (isPatternlab) {
      setIsLoading(false);
      const fakeData = [{
        periodName: "Clever period name 1",
        cleverId: "123",
        numberOfStudents: 30
      }, {
        periodName: "Clever period name 2",
        cleverId: "126",
        numberOfStudents: 30
      }, {
        periodName: "Clever period name 3",
        cleverId: "127",
        numberOfStudents: 30
      }, {
        periodName: "Clever period name 4",
        cleverId: "128",
        numberOfStudents: 30
      }, {
        periodName: "Clever period name 5",
        cleverId: "129",
        numberOfStudents: 30
      }];
      setCleverPeriods(fakeData);
    } else {
      fetch("/owh/clever/GetCleverPeriods", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        setIsLoading(false);
        if (data.Message) {
          console.warn(data.Message);
          return;
        }
        const cleverPeriods = data.map(period => {
          return {
            periodName: period.PeriodName,
            cleverId: period.CleverId,
            numberOfStudents: period.NumberOfStudents
          };
        });
        setCleverPeriods(cleverPeriods);
      }).catch(err => {
        setIsLoading(false);
        console.error(err);
      });
    }
  };

  /**
   * Closes the add class modal
   */
  const closeModal = () => {
    setIsOpen(false);
  };

  /**
   * Opens the add class modal
   */
  const openModal = () => {
    setIsOpen(true);
    if (isClever) {
      getCleverPeriods();
    }
  };

  /**
   * Closes the Teaching This Course link modal
   */
  const closeLinkModal = () => {
    setIsLinkModalOpen(false);
  };

  /**
   * Opens the Teaching This Course link modal
   */
  const openLinkModal = () => {
    setIsLinkModalOpen(true);
  };

  /**
   * Handles when a user types in the new class title
   * @param {Event} event
   */
  const handleNewClassInput = event => {
    const temp = {};
    const value = event.target.value.substr(0, 45);
    const length = value.length;
    temp.value = value;
    temp.error = !(0, _validation.validateField)("text", newPeriodInput.value);
    temp.warning = length > 0 && length >= 3;
    if (length > 0 && length < 3) {
      temp.error = true;
      temp.errorMsg = modalData.nameSizeError;
    } else if (length > 0 && length >= 3) {
      temp.warningMsg = `${45 - length} ${modalData.characterCountLabel}`;
    }
    setNewPeriodInput({
      ...newPeriodInput,
      ...temp
    });
  };

  /**
   * Adds the new class
   */
  const addClass = () => {
    const params = {
      PeriodName: newPeriodInput.value,
      CourseID: selectedCourse
    };
    if (isClever) {
      params.CleverId = cleverId;
    }
    const fetchUrl = isClever ? "/owh/clever/AddCleverPeriod" : "/owh/period/AddPeriod";
    setIsLoading(true);
    if (isPatternlab) {
      setIsLoading(false);
      closeModal();
      window.location.reload();
      return;
    } else {
      fetch(fetchUrl, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data && data.Succeeded) {
          setClassCode(data.PeriodCode);
          closeModal();
          // this.setState({
          //   classCode: data.PeriodCode,
          //   joinUrl: data.JoinUrl, // needed?
          // });
          window.location = data.PeriodPageUrl;
        } else {
          setNewPeriodInput({
            ...newPeriodInput,
            error: true,
            errorMsg: data.Message
          });
          setIsLoading(false);
          setClassCode("");
        }
      }).catch(error => {
        console.error(error);
        setNewPeriodInput({
          ...newPeriodInput,
          error: true,
          errorMsg: error
        });
        setIsLoading(false);
        setClassCode("");
      });
    }
  };

  /**
   * Handles when the form to add a new class is submitted
   * @param {Event} event
   */
  const onFormSubmit = event => {
    event.preventDefault();
    const {
      blankError
    } = modalData;
    if (!newPeriodInput.error) {
      if (newPeriodInput.value.length === 0) {
        setNewPeriodInput({
          ...newPeriodInput,
          error: true,
          errorMsg: blankError
        });
        document.querySelectorAll(".gv__class-list-modal .gv__text-input__field")[0].focus();
      } else {
        addClass();
      }
    }
  };
  const togglePinning = event => {
    const params = {
      courseId: courseId
    };
    if (isPinned) {
      if (isPatternlab) {
        onPin(courseId, false);
        setIsPinned(false);
        return;
      }
      fetch("/owh/course/UnPinCourse", {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(isSuccess => {
        if (isSuccess) {
          onPin(courseId, false);
          setIsPinned(false);
        }
      });
    } else {
      if (isPatternlab) {
        onPin(courseId, true);
        setIsPinned(true);
        return;
      }
      fetch("/owh/course/PinCourse", {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(isSuccess => {
        if (isSuccess) {
          onPin(courseId, true);
          setIsPinned(true);
        }
      });
    }
  };
  const styleClassModal = (0, _classnames.default)("gv__modal__content", {
    "gv__class-list-modal__content--clever": isClever
  });

  /**
   * Renders Add Class button and modal it triggers
   * @returns {JSX.Element} Add Class button and modal
   */
  const renderAddBtn = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
      onClick: openModal,
      className: "gv__teacher-course-listing-card__add-btn gv__button gv__button--secondary gv__button--arrow"
    }, dictionary.addClassLabel, " ", /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__button__icon",
      "aria-hidden": "true"
    }, "+")), /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: isOpen,
      onRequestClose: closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: styleClassModal
    }, !isClever && classCode === "" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement(_NewClassForm.default, {
      courseOptions: courseOptions,
      newPeriodInput: newPeriodInput,
      selectedCourseDetails: selectedCourseDetails,
      isLoading: isLoading,
      modalData: modalData,
      updateSelectState: updateSelectState,
      handleNewClassInput: handleNewClassInput,
      onFormSubmit: onFormSubmit,
      ref: modalTitleRef,
      defaultValue: courseId
    })), isClever && /*#__PURE__*/_react.default.createElement(_NewCleverClassForm.default, {
      newPeriodInput: newPeriodInput,
      isLoading: isLoading,
      cleverPeriods: cleverPeriods,
      selectedCourseDetails: selectedCourseDetails,
      modalData: modalData,
      setCleverId: updateCleverId,
      courseOptions: courseOptions,
      onFormSubmit: onFormSubmit,
      handleNewClassInput: handleNewClassInput,
      updateSelectState: updateSelectState,
      ref: modalTitleRef,
      defaultValue: courseId,
      closeModal: closeModal
    })));
  };

  /**
   * Renders the pin button element
   * @param {Boolean} isDesktop if this is the desktop version
   * @returns {JSX.Element} Pin Button
   */
  const renderPinBtn = function () {
    let isDesktop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    const styleClassPinBtn = (0, _classnames.default)("gv__teacher-course-listing-card__pin-cta", {
      "gv__teacher-course-listing-card__pin-cta--desktop": isDesktop
    });
    const btnText = isPinned ? "Unpin this course" : dictionary.pinLabel;
    return /*#__PURE__*/_react.default.createElement("button", {
      className: styleClassPinBtn,
      onClick: togglePinning
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__teacher-course-listing-card__pin-text"
    }, btnText), /*#__PURE__*/_react.default.createElement("svg", {
      className: "gv__teacher-course-listing-card__pin-icon",
      "aria-hidden": "true",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 14 15"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M9 12.74c.28-.44.38-.93.3-1.37-.06-.32-.1-.76.07-1l2.5-3.8c.17-.26.31-.45.33-.44l.02.03c.38.37.98.4 1.5.14.27-.14.25-.52 0-.76L9.16.97C8.9.73 8.54.7 8.4.97c-.28.52-.24 1.13.14 1.5l.02.03c.01.01-.18.15-.43.32l-3.8 2.5c-.25.17-.69.13-1 .07-.45-.08-.94.02-1.38.3-.25.15-.23.53.02.77l2.7 2.7-2.62 2.63C1 12.92.36 13.94.6 14.17c.22.22 1.24-.42 2.36-1.47l2.63-2.62 2.65 2.66c.25.24.62.27.78.01Z",
      fill: "currentColor",
      fillRule: "nonzero"
    })));
  };

  /**
   * Renders the course image
   * @returns {JSX.Element} Image section
   */
  const renderImage = () => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__teacher-course-listing-card__image-section"
    }, !!courseParent && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__teacher-course-listing-card__parent-wrapper"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__teacher-course-listing-card__parent"
    }, courseParent)), /*#__PURE__*/_react.default.createElement("picture", {
      className: "gv__teacher-course-listing-card__picture"
    }, /*#__PURE__*/_react.default.createElement("source", {
      srcSet: imageSrc,
      media: "(min-width: 481px) and (max-width: 781px)"
    }), /*#__PURE__*/_react.default.createElement("img", {
      alt: "",
      className: "gv__teacher-course-listing-card__image",
      src: thumbnailSrc
    })));
  };

  /**
   * Renders the period list
   * @returns {JSX.Element} Period list
   */
  const renderPeriodList = periods => {
    if (!!periods && periods.length > 0) {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "gv__teacher-course-listing-card__periods-list"
      }, periods.map((period, index) => {
        const keyPrefix = `TEACHER_COURSE_LISTING_PERIOD_${index}`;
        return /*#__PURE__*/_react.default.createElement("li", {
          key: keyPrefix,
          className: "gv__teacher-course-listing-card__period-item"
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: period.linkUrl,
          className: "gv__teacher-course-listing-card__period-link"
        }, period.linkText));
      }));
    } else if (!!periods && periods.length === 0) {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "gv__teacher-course-listing-card__periods-list"
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
        onClick: openModal,
        className: "gv__teacher-course-listing-card__periods-add-link"
      }, dictionary.addClassLabel)));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("gv__teacher-course-listing-card", {
      "gv__teacher-course-listing-card--animate": isAnimating
    }),
    ref: cardEl
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing-card__left-section"
  }, renderImage()), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing-card__middle-section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing-card__header"
  }, renderPinBtn(), /*#__PURE__*/_react.default.createElement("h3", {
    className: "gv__teacher-course-listing-card__title",
    ref: modalTitleRef
  }, title), renderPinBtn(true)), /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__teacher-course-listing-card__description"
  }, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing-card__btn-group"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: courseUrl,
    className: "gv__teacher-course-listing-card__home-btn gv__button gv__button--arrow"
  }, dictionary.courseHomeLabel, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__button__icon"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    "aria-hidden": "true",
    width: "7",
    height: "12",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    strokeWidth: "1.3",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 10.95L5.95 6M1 1l4.95 4.95"
  }))))), !isVersion3_0 && renderAddBtn()), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing-card__link-group"
  }, courseLinks.map((link, index) => {
    const {
      linkUrl,
      linkText,
      isNewWindow,
      isModal,
      modalData
    } = link;
    const target = isNewWindow ? "_blank" : null;
    const uID = Math.floor(Math.random() * 10000);
    const keyPrefix = `TEACHER_COURSE_LISTING_CARD_${uID}_${index}`;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: keyPrefix
    }, isModal ? /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__teacher-course-listing-card__link"
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "gv__teaching-this-course-modal__toggle",
      onClick: openLinkModal
    }, modalData.teachingThisCourseText), /*#__PURE__*/_react.default.createElement(_TeachingThisCourseModal.default, {
      isLinkModalOpen: isLinkModalOpen,
      closeLinkModal: closeLinkModal,
      modalTitle: modalData.modalTitle,
      modalSubtitle: modalData.modalSubtitle,
      teachingText: modalData.teachingThisCourseText,
      teachingUrl: modalData.teachingThisCourseUrl,
      teachingTarget: modalData.teachingThisCourseTarget,
      teachingDescription: modalData.teachingThisCourseDescription,
      informationText: modalData.informationSessionsText,
      informationUrl: modalData.informationSessionsUrl,
      informationTarget: modalData.informationSessionsTarget,
      informationDescription: modalData.informationSessionsDescription,
      onboardingText: modalData.onBoardingSessionsText,
      onboardingUrl: modalData.onBoardingSessionsUrl,
      onboardingTarget: modalData.onBoardingSessionsTarget,
      onboardingDescription: modalData.onBoardingSessionsDescription
    })) : /*#__PURE__*/_react.default.createElement("a", {
      key: keyPrefix,
      href: linkUrl,
      target: target,
      className: "gv__teacher-course-listing-card__link"
    }, linkText, isNewWindow && /*#__PURE__*/_react.default.createElement(_externalLinkIcon.default, {
      classes: "gv__external-link-icon"
    })));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing-card__right-section"
  }, renderImage(), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing-card__content-container"
  }, /*#__PURE__*/_react.default.createElement("dl", {
    className: (0, _classnames.default)("gv__teacher-course-listing-card__course-details", {
      "is-active": !isPinned || isAnimating || isVersion3_0
    })
  }, !!courseInformation && courseInformation.map((info, index) => {
    const {
      infoLabel,
      boldedValue,
      appendedValue,
      dropDownValues,
      iconUrl
    } = info;
    const keyPrefix = `TCLC_COURSE_INFO_${Math.floor(Math.random() * 10000)}_${index}`;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: keyPrefix,
      className: "gv__teacher-course-listing-card__detail"
    }, /*#__PURE__*/_react.default.createElement("dt", {
      className: "gv__teacher-course-listing-card__detail-label"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__teacher-course-listing-card__detail-label-icon",
      "aria-hidden": "true"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: iconUrl,
      alt: infoLabel
    }))), /*#__PURE__*/_react.default.createElement("dd", {
      className: "gv__teacher-course-listing-card__detail-value"
    }, !!boldedValue && /*#__PURE__*/_react.default.createElement("strong", null, boldedValue, "\xA0"), /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: `${appendedValue}`
      }
    }), !!dropDownValues && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-card__tooltip gv__teacher-course-listing-card__tooltip js-tooltip"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": "see resources",
      className: "gv__course-card__tooltip-trigger js-tooltip-trigger",
      "aria-expanded": "false",
      tabIndex: "-1"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M8.756 11.968c0 .272-.22.492-.492.492h-.528a.492.492 0 0 1-.492-.492V6.732c0-.271.22-.492.492-.492h.528c.271 0 .492.22.492.492v5.236ZM8 3.851a.879.879 0 1 0 0 1.757.879.879 0 0 0 0-1.757Z",
      fill: "currentColor",
      fillRule: "nonzero"
    }), /*#__PURE__*/_react.default.createElement("circle", {
      stroke: "currentColor",
      strokeWidth: "1.4",
      cx: "8",
      cy: "8.155",
      r: "6.728"
    })))), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__course-card__tooltip-content js-tooltip-text"
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      ,
      tabIndex: "0"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "js-tooltip-inner-text"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "gv__course-card__list"
    }, dropDownValues.map((value, childIndex) => {
      const {
        imageUrl,
        name,
        numberOfMaterials
      } = value;
      const childKeyPrefix = `${keyPrefix}_DD_${childIndex}_${Math.floor(Math.random() * 1000)}`;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: childKeyPrefix,
        className: "gv__course-card__list-item"
      }, /*#__PURE__*/_react.default.createElement("img", {
        loading: "lazy",
        src: imageUrl,
        alt: "",
        className: "gv__course-card__tooltip-icon"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__course-card__material"
      }, name), /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__course-card__line"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__course-card__count"
      }, numberOfMaterials));
    })))))));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("gv__teacher-course-listing-card__periods", {
      "is-active": (isPinned || isAnimating) && !isVersion3_0
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-course-listing-card__periods-header"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "gv__teacher-course-listing-card__periods-title"
  }, dictionary.periodTitleLabel), !!managePeriods && !!managePeriods.linkUrl && /*#__PURE__*/_react.default.createElement("a", {
    className: "gv__teacher-course-listing-card__periods-manage",
    href: managePeriods.linkUrl
  }, managePeriods.linkText)), renderPeriodList(periods)))));
};
TeacherCourseListingCard.propTypes = {
  title: _propTypes.string,
  imageSrc: _propTypes.string,
  thumbnailSrc: _propTypes.string,
  description: _propTypes.string,
  courseLinks: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    linkText: _propTypes.string,
    linkUrl: _propTypes.string,
    isNewWindow: _propTypes.bool
  })),
  courseInformation: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    boldedValue: _propTypes.string,
    infoLabel: _propTypes.string,
    appendedValue: _propTypes.string
  })),
  dictionary: _propTypes.object,
  courseOptions: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    detail: _propTypes.string
  })),
  courseId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  isClever: _propTypes.bool
};
var _default = exports.default = TeacherCourseListingCard;

},{"../partials/NewClassForm.jsx":138,"../partials/NewCleverClassForm.jsx":139,"../partials/external-link-icon.jsx":148,"../validation.js":262,"./TeachingThisCourseModal.jsx":229,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-modal":"react-modal"}],229:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactModal = _interopRequireDefault(require("react-modal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  isLinkModalOpen: _propTypes.bool,
  closeLinkModal: _propTypes.func,
  modalTitle: _propTypes.string,
  modalSubtitle: _propTypes.string,
  teachingText: _propTypes.string,
  teachingUrl: _propTypes.string,
  teachingTarget: _propTypes.string,
  teachingDescription: _propTypes.string,
  informationText: _propTypes.string,
  informationUrl: _propTypes.string,
  informationTarget: _propTypes.string,
  informationDescription: _propTypes.string,
  onboardingText: _propTypes.string,
  onboardingUrl: _propTypes.string,
  onboardingTarget: _propTypes.string,
  onboardingDescription: _propTypes.string
};
const TeachingThisCourseModal = props => {
  const modalTitleRef = (0, _react.useRef)();
  const {
    isLinkModalOpen,
    closeLinkModal,
    modalTitle,
    modalSubtitle,
    teachingText,
    teachingUrl,
    teachingTarget,
    teachingDescription,
    informationText,
    informationUrl,
    informationTarget,
    informationDescription,
    onboardingText,
    onboardingUrl,
    onboardingTarget,
    onboardingDescription
  } = props;
  const afterOpenModal = () => {
    modalTitleRef.current.focus();
  };
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: isLinkModalOpen,
    onAfterOpen: afterOpenModal,
    onRequestClose: closeLinkModal,
    bodyOpenClassName: null,
    overlayClassName: "gv__modal",
    className: "gv__modal__content",
    shouldCloseOnOverlayClick: true
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "close",
    type: "button",
    onClick: closeLinkModal,
    className: "gv__modal__close gv__teaching-this-course-modal__close"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teaching-this-course-modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teaching-this-course-modal__heading",
    ref: modalTitleRef
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__teaching-this-course-modal__heading-type"
  }, modalTitle), /*#__PURE__*/_react.default.createElement("span", null, modalSubtitle)), teachingText && teachingDescription && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teaching-this-course-modal__link-item"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: teachingUrl,
    className: "gv__teaching-this-course-modal__link",
    target: teachingTarget || null,
    rel: teachingTarget ? "noopener noreferrer" : null
  }, /*#__PURE__*/_react.default.createElement("span", null, teachingText), teachingTarget && /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "#213245",
    strokeWidth: "1.3",
    fill: "none",
    fillRule: "evenodd",
    "stroke-line-join": "round"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.867 4.625V1.25h-3.4m3.4 0-1.134 1.125m0 0L6.241 9.813M12.6 9.558v5.192H1.267V3.5h5.461"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teaching-this-course-modal__link-description gv__rte",
    dangerouslySetInnerHTML: {
      __html: teachingDescription
    }
  })), informationText && informationDescription && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teaching-this-course-modal__link-item"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: informationUrl,
    className: "gv__teaching-this-course-modal__link",
    target: informationTarget || null,
    rel: informationTarget ? "noopener noreferrer" : null
  }, /*#__PURE__*/_react.default.createElement("span", null, informationText), informationTarget && /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "#213245",
    strokeWidth: "1.3",
    fill: "none",
    fillRule: "evenodd",
    "stroke-line-join": "round"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.867 4.625V1.25h-3.4m3.4 0-1.134 1.125m0 0L6.241 9.813M12.6 9.558v5.192H1.267V3.5h5.461"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teaching-this-course-modal__link-description gv__rte",
    dangerouslySetInnerHTML: {
      __html: informationDescription
    }
  })), onboardingText && onboardingDescription && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teaching-this-course-modal__link-item"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: onboardingUrl,
    className: "gv__teaching-this-course-modal__link",
    target: onboardingTarget || null,
    rel: onboardingTarget ? "noopener noreferrer" : null
  }, /*#__PURE__*/_react.default.createElement("span", null, onboardingText), onboardingTarget && /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "#213245",
    strokeWidth: "1.3",
    fill: "none",
    fillRule: "evenodd",
    "stroke-line-join": "round"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.867 4.625V1.25h-3.4m3.4 0-1.134 1.125m0 0L6.241 9.813M12.6 9.558v5.192H1.267V3.5h5.461"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teaching-this-course-modal__link-description gv__rte",
    dangerouslySetInnerHTML: {
      __html: onboardingDescription
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teaching-this-course-modal__cta"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "close",
    type: "button",
    onClick: closeLinkModal,
    className: "gv__teaching-this-course-modal__button gv__button"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Close")))));
};
TeachingThisCourseModal.propTypes = propTypes;
var _default = exports.default = TeachingThisCourseModal;

},{"prop-types":"prop-types","react":"react","react-modal":"react-modal"}],230:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _TeacherCourseListing = _interopRequireDefault(require("./TeacherCourseListing.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-teacher-course-listing-app");
if (el) {
  const props = {
    isPatternlab: el.dataset.isPatternlab === "true" ? true : false
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_TeacherCourseListing.default, props), el);
}

},{"./TeacherCourseListing.jsx":227,"react":"react","react-dom":"react-dom"}],231:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _TeacherRegistrationFirstStep = _interopRequireDefault(require("./TeacherRegistrationFirstStep.jsx"));
var _TeacherRegistrationSecondStep = _interopRequireDefault(require("./TeacherRegistrationSecondStep.jsx"));
var _useStateReducer = _interopRequireDefault(require("./useStateReducer.js"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function TeacherRegistration(props) {
  const {
    firstStepData,
    secondStepData,
    currentStep,
    nextButton,
    previousButton,
    submitButton,
    isImpersonation
  } = props;
  const [isModalOpen, setIsModalOpen] = (0, _react.useState)(true);
  const [stateSelect, setStateSelect] = (0, _react.useState)("");
  const [stateInput, setStateInput] = (0, _react.useState)({});
  const [countryField, setCountryField] = (0, _react.useState)({});
  const [zip, setZip] = (0, _react.useState)({});
  const stateInputHandler = select => {
    setStateInput(select);
  };
  const stateSelectHandler = select => {
    setStateSelect(select);
  };
  const countryFieldHandler = field => {
    setCountryField(field);
  };
  const zipHandler = zipCode => {
    setZip(zipCode);
  };
  const {
    state: appState,
    setState: setAppState
  } = (0, _useStateReducer.default)(R.mergeAll(firstStepData?.FormData?.map(field => {
    if (field.FieldIdentifier === "gradesTaught") {
      return {
        [`${field.FieldIdentifier}`]: field.SelectedValues.map((item, index) => item.OriginalValue)
      };
    } else if (field.FieldIdentifier === "acceptTermsAndPrivacy") {
      return {
        [`${field.FieldIdentifier}`]: false
      };
    } else {
      return {
        [`${field.FieldIdentifier}`]: {
          ...field.SelectedValue
        }
      };
    }
  })));
  const {
    state: secondAppState,
    setState: setSecondAppState
  } = (0, _useStateReducer.default)(R.mergeAll(secondStepData?.FormData?.map(field => {
    if (field.FieldIdentifier === "schoolType") {
      return {
        [`${field.FieldIdentifier}`]: {
          ...field.SelectedValue
        }
      };
    }
    return {
      [`${field.FieldIdentifier}`]: field.OriginalValue
    };
  })));
  const populateProvidence = (country, populatingMigratedData) => {
    fetch(`/owh/school/StatesByCountry?country=${country}`).then(response => response.json()).then(function (data) {
      stateSelect.current.innerHTML = "<option></option>";
      data.map(state => {
        const option = document.createElement("option");
        option.textContent = state.StateProvince;
        option.value = state.Abbreviation;
        stateSelect.current.append(option);
        if (populatingMigratedData && appState.country.OriginalValue === option.value) {
          option.setAttribute("selected", "true");
        }
      });
    }).catch(error => {
      console.error("There has been a problem retrieving form data." + error);
    });
  };
  const onCountryChange = populatingMigratedData => {
    let countryValue = countryField.current.value;
    switch (countryValue) {
      case "Australia":
      case "Canada":
        populateProvidence(countryValue, populatingMigratedData);
        break;
      case "United States":
        if (populatingMigratedData) {
          zip.current.value = secondAppState.postalCode;
          // populateSchoolNames(populatingMigratedData);
        }
        break;
      case "":
        break;
      default:
    }
  };

  // set the state of the step 0 being the first step
  const [step, setStep] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    if (currentStep === 1) {
      setStep(0);
    } else if (currentStep === 2) {
      setStep(1);
    }
  }, [setStep]);
  const formErrorMessage = formRef => {
    formRef.current.querySelectorAll(".has-error")[0].querySelector("input, select").focus();
    formRef.current.querySelectorAll(".has-error")[0].querySelector(".gv__form__error-msg").setAttribute("role", "alert");
    [...formRef.current.querySelectorAll(".has-error")].forEach((element, index) => {
      const errorId = element.querySelector(".gv__form__error-msg").getAttribute("id");
      const input = element.querySelector(".gv__form__field");
      input.removeAttribute("aria-describedby");
      const inputLabels = input.getAttribute("aria-labelledby") ? element.querySelector(".gv__form__field").getAttribute("aria-labelledby") : "";
      const newLabel = inputLabels.concat(" ", errorId);
      element.querySelector(".gv__form__error-msg").setAttribute("role", "alert");
      input.setAttribute("aria-labelledby", newLabel);
      if (index > 0) {
        element.querySelector(".gv__form__error-msg").removeAttribute("role");
      }
    });
    [...formRef.current.querySelectorAll("[aria-required]")].forEach(element => {
      element.setAttribute("aria-invalid", true);
    });
  };
  const StepDisplay = () => {
    if (step === 0) {
      return /*#__PURE__*/_react.default.createElement(_TeacherRegistrationFirstStep.default, {
        firstStep: firstStepData,
        setStep: setStep,
        globalState: {
          appState,
          setAppState
        },
        setIsModalOpen: setIsModalOpen,
        nextButton: nextButton,
        submitButton: submitButton,
        stateSelectHandler: stateSelectHandler,
        stateInput: stateInput,
        countryFieldHandler: countryFieldHandler,
        onCountryChange: onCountryChange,
        countryField: countryField
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_TeacherRegistrationSecondStep.default, {
        secondStep: secondStepData,
        step: step,
        setStep: setStep,
        globalState: {
          secondAppState,
          setSecondAppState
        },
        countryValue: appState.country.ValueText,
        gradesTaughtValue: appState.gradesTaught,
        setIsModalOpen: setIsModalOpen,
        previousButton: previousButton,
        submitButton: submitButton,
        populateProvidence: populateProvidence,
        stateSelectHandler: stateSelectHandler,
        stateInputHandler: stateInputHandler,
        zipHandler: zipHandler,
        zip: zip,
        stateInput: stateInput
      });
    }
  };
  const closeModal = () => {
    setCookie("impersonationTRClosed", true, 1);
    setIsModalOpen(false);
  };
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    //exdays from now
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";";
  }
  const CloseButtonDisplay = () => {
    if (isImpersonation) {
      return /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        id: "close-btn",
        onClick: closeModal
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: "/OWH/assets-build/img/icons/x-close.svg",
        alt: ""
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__visually-hidden"
      }, "Close"));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: isModalOpen,
    bodyOpenClassName: null,
    overlayClassName: "gv__modal",
    className: "gv__modal-teacher-registration"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-registration-form"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__close-button"
  }, CloseButtonDisplay()), StepDisplay()));
}
var _default = exports.default = TeacherRegistration;

},{"./TeacherRegistrationFirstStep.jsx":232,"./TeacherRegistrationSecondStep.jsx":233,"./useStateReducer.js":246,"prop-types":"prop-types","ramda":"ramda","react":"react","react-modal":"react-modal"}],232:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _validation = require("../validation.js");
var _CountryField = _interopRequireDefault(require("./fields/CountryField.jsx"));
var _GradesTaughtField = _interopRequireDefault(require("./fields/GradesTaughtField.jsx"));
var _TeacherRoleField = _interopRequireDefault(require("./fields/TeacherRoleField.jsx"));
var _TeacherRegistrationTitleSection = _interopRequireDefault(require("./TeacherRegistrationTitleSection.jsx"));
var _propTypes = require("prop-types");
var _PrivacyTermsField = _interopRequireDefault(require("./fields/PrivacyTermsField.jsx"));
var _formHelper = require("./form-helper.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function TeacherRegistrationFirstStep(props) {
  const {
    firstStep,
    setStep,
    globalState,
    setIsModalOpen,
    nextButton,
    submitButton,
    onCountryChange,
    countryFieldHandler,
    countryField
  } = props;
  const [returnUrl, setReturnUrl] = (0, _react.useState)("");
  const [nextStepValid, setNextStepValid] = (0, _react.useState)(true);
  const {
    appState,
    setAppState
  } = globalState;
  const [generalErrorMessage, setGeneralErrorMessage] = (0, _react.useState)("Errors");
  const formRef = (0, _react.useRef)();
  const countryValue = appState.country.ValueText;
  const teacherRoleOther = "280560004";
  var populateMigratedData = formRef?.current?.querySelector("#Is_Migrated_User") !== null && formRef?.current?.querySelector("#Is_Migrated_User").value === "True";
  const goToNextStep = roleValue => {
    //If the teach role is other the form does not go to the next step and gets submitted
    if (roleValue === teacherRoleOther) {
      setNextStepValid(false);
    } else {
      setNextStepValid(true);
    }
  };

  //form sepecific handlers
  function resetButton(button) {
    button.classList.remove("is-loading");
  }
  const showMessage = (status, msg, el) => {
    if (status === "error") {
      setGeneralErrorMessage("Please Fill out the required fields");
    }
  };
  const successHandler = elForm => {
    const errorbox = elForm.querySelectorAll(".js-form-general-success");
    showMessage("success", "Your changes have been successfully updated", errorbox);
  };
  const validateField = (type, value, value2) => {
    let valid = true;
    const passwordStrengthTest = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*])(?=.{8,20})(?!.*[<&])");
    const globalPostalTest = new RegExp(/^(?!-$)[a-z0-9]+[ -]?[a-z0-9]*$/i);
    const usZipTest = new RegExp("^\\d{5}(-{0,1}\\d{4})?$");
    switch (type) {
      case "email":
        valid = !!value.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+/i);
        break;
      case "password":
        // more than eight characters, less than 20
        // contains digits
        // contains lower case alpha
        // contains upper case alpha
        // contains special characters
        // does not contain white space

        valid = passwordStrengthTest.test(value);
        break;
      case "new-password":
        //valid password that doesnt match other password
        const passwordFields = [value, value2];

        //only return true when there are 2 new password fields
        if (passwordFields.length > 1 && passwordFields.length < 3) {
          /*
                //if password fields are blank or
                //bothfields pass regex and are not
                //equal the new passwords are valid
                */

          const isBlank = passwordFields.reduce((a, b) => a + b) === "";
          const Eq = passwordFields[0] === passwordFields[1] && passwordStrengthTest.test(passwordFields[0]) && passwordStrengthTest.test(passwordFields[1]);
          valid = isBlank ? isBlank : Eq;
        } else {
          valid = false;
        }
        break;
      case "tel":
        valid = !!value.match(/^[0-9]*^[()-]*$/) || value === "";
        break;
      case "extension":
        valid = !!value.match(/^\d{1,4}$/) || value === "";
        break;
      case "zip":
        valid = !!value.match(globalPostalTest) || !!value.match(usZipTest);
        break;
      case "website":
        valid = !!value.match(/^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/) || value === "";
        break;
      case "text-length":
        valid = strip(unescape(value)).length <= 50 && strip(unescape(value)).length > 0;
        break;
      case "checkbox-array":
        const checkboxArray = value !== "" ? JSON.parse(value) : value;
        valid = checkboxArray.length > 0;
        break;
      case "checkbox":
      case "select":
      case "text":
      case "file":
      default:
        if (value.trim().length === 0) {
          valid = false;
        }
    }
    return valid;
  };
  const validFields = (items, elForm) => {
    let valid = true;
    items.forEach(item => {
      const field = item.querySelector("[aria-required]");
      if (field === null) {
        return;
      }
      const validCheck = field.dataset.type === "checkbox" ? field.checked : validateField(field.dataset.type, field.value);
      if (validCheck) {
        item.classList.remove("has-error");
      } else {
        if (field.getAttribute("readonly") !== null) {
          return;
        } else {
          item.classList.add("has-error");
          valid = false;
        }
      }
    });
    return valid;
  };
  const errorHandler = elForm => {
    const errorbox = elForm.querySelectorAll(".js-form-general-success");
    const submitButtons = elForm.querySelectorAll("button[type=submit]");
    [...elForm.querySelectorAll(".js-form-general-error")].forEach(el => {
      el.classList.add("has-error");
      if (el.dataset.hasText !== "true") {
        const msg = "Server Error. Please try again";
        showMessage("error", msg, el);
      }
      el.setAttribute("role", "alert");
    });
    [...submitButtons].forEach(resetButton);
    if (errorbox.length) {
      setGeneralErrorMessage("error", "Whoops, something went wrong please try again later.", errorbox);
    }
  };
  const submitForm = e => {
    e.preventDefault();
    if (formRef?.current) {
      if (validFields([...formRef.current.querySelectorAll(".js-form-required")], formRef.current)) {
        const newFormData = new FormData(formRef.current);
        let formJson = {};
        [...newFormData].map(_ref => {
          let [k, v] = _ref;
          formJson = {
            ...formJson,
            [`${k}`]: v
          };
        });
        fetch(`${firstStep.PostUrl}`, {
          method: "POST",
          body: JSON.stringify(formJson),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => response.json()).then(data => {
          //handle data
          if (data.IsValid) {
            successHandler(formRef.current);
            if (nextStepValid) {
              setStep(currPage => currPage + 1);
            } else {
              setIsModalOpen(false);
              if (returnUrl !== "") {
                window.location.replace(returnUrl);
              }
            }
          } else {
            setGeneralErrorMessage("this is an error");
            errorHandler(formRef.current);
          }
        }).catch(error => {
          errorHandler(formRef.current);
          console.log(error);
        });
      } else {
        formRef.current.querySelectorAll(".has-error")[0].querySelector("input, select").focus();
        formRef.current.querySelectorAll(".has-error")[0].querySelector(".gv__form__error-msg").setAttribute("role", "alert");
        [...formRef.current.querySelectorAll(".has-error")].forEach((element, index) => {
          const errorId = element.querySelector(".gv__form__error-msg").getAttribute("id");
          const input = element.querySelector(".gv__form__field");
          input.removeAttribute("aria-describedby");
          const inputLabels = input.getAttribute("aria-labelledby") ? element.querySelector(".gv__form__field").getAttribute("aria-labelledby") : "";
          const newLabel = inputLabels.concat(" ", errorId);
          element.querySelector(".gv__form__error-msg").setAttribute("role", "alert");
          input.setAttribute("aria-labelledby", newLabel);
          if (index > 0) {
            element.querySelector(".gv__form__error-msg").removeAttribute("role");
          }
        });
        [...formRef.current.querySelectorAll("[aria-required]")].forEach(element => {
          element.setAttribute("aria-invalid", true);
        });
      }
    }
  };
  const populateCountries = () => {
    fetch("/owh/school/countries").then(response => response.json()).then(function (data) {
      if (!countryField.current) {
        return;
      }
      const selectedValue = countryValue;
      data.map(country => {
        const option = document.createElement("option");
        option.textContent = country.CountryName;
        option.value = country.CountryName;
        if (country.CountryName === selectedValue) {
          option.setAttribute("selected", "true");
        }
        countryField?.current.append(option);
      });
      if (populateMigratedData) {
        onCountryChange(true);
      }
    }).catch(error => {
      console.error("There has been a problem retrieving form data." + error);
    });
  };
  (0, _react.useEffect)(() => {
    const elItems = formRef?.current?.querySelectorAll(".js-form-required");
    //form field validation
    elItems.forEach(item => {
      (0, _validation.validationListeners)(item, formRef?.current);
    });
  }, []);
  (0, _react.useEffect)(() => {
    if (appState.role.OriginalValue === "280560004") {
      setNextStepValid(false);
    }
    firstStep.FormData.map((data, i) => {
      if (data.FieldIdentifier === "returnUrl") {
        setReturnUrl(data.OriginalValue);
      }
    });
    populateCountries();
  }, [firstStep.FormData, countryField.current]);
  return /*#__PURE__*/_react.default.createElement("form", {
    className: "gv__form js-form-react js-form-changes",
    method: "POST",
    onSubmit: submitForm,
    ref: formRef
  }, /*#__PURE__*/_react.default.createElement(_TeacherRegistrationTitleSection.default, {
    firstTitle: firstStep.TitleFirstRow,
    secondTitle: firstStep.TitleSecondRow,
    subTitle: firstStep.Subtitle
  }), /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "gv__class-fieldset gv__form__fieldset js-class-fieldset-react"
  }, firstStep.FormData && firstStep.FormData.map((data, i) => {
    if (data.FieldIdentifier === "country") {
      return /*#__PURE__*/_react.default.createElement(_CountryField.default, {
        getCountryField: countryFieldHandler,
        defaultValue: appState.country.ValueText,
        formData: data,
        key: i,
        handleChange: e => {
          setAppState({
            country: {
              OriginalValue: appState?.country?.ValueText,
              ValueText: e.target.value
            }
          });
          onCountryChange();
        }
      });
    } else if (data.FieldIdentifier === "role") {
      return /*#__PURE__*/_react.default.createElement(_TeacherRoleField.default, {
        defaultValue: appState.role.OriginalValue,
        formData: data,
        key: i,
        handleChange: e => {
          setAppState({
            role: {
              OriginalValue: e.target.value,
              ValueText: e.target.value
            }
          });
          goToNextStep(e.target.value);
        }
      });
    } else if (data.FieldIdentifier === "gradesTaught") {
      return /*#__PURE__*/_react.default.createElement(_GradesTaughtField.default, {
        defaultValue: appState?.gradesTaught,
        formData: data,
        key: i,
        setGradesTaught: {
          appState,
          setAppState
        }
      });
    } else if (data.FieldIdentifier === "acceptTermsAndPrivacy") {
      return /*#__PURE__*/_react.default.createElement(_PrivacyTermsField.default, {
        defaultValue: appState?.acceptTermsAndPrivacy,
        formData: data,
        key: i,
        handleChange: () => {
          setAppState({
            acceptTermsAndPrivacy: !appState?.acceptTermsAndPrivacy
          });
        }
      });
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "gv__button"
  }, /*#__PURE__*/_react.default.createElement("span", null, nextStepValid ? nextButton : submitButton)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__general-success js-form-general-success",
    "aria-atomic": "true",
    role: "alert"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__error-msg gv__form__general-error js-form-general-error",
    "aria-atomic": "true",
    role: "alert"
  }, generalErrorMessage));
}
TeacherRegistrationFirstStep.propTypes = {
  firstStep: _propTypes.object.isRequired,
  setStep: _propTypes.func.isRequired,
  globalState: _propTypes.object.isRequired,
  onCountryChange: _propTypes.func.isRequired,
  countryFieldHandler: _propTypes.func.isRequired,
  countryField: _propTypes.object.isRequired,
  setIsModalOpen: _propTypes.func.isRequired,
  nextButton: _propTypes.string.isRequired,
  submitButton: _propTypes.string.isRequired
};
var _default = exports.default = TeacherRegistrationFirstStep;

},{"../validation.js":262,"./TeacherRegistrationTitleSection.jsx":234,"./fields/CountryField.jsx":236,"./fields/GradesTaughtField.jsx":237,"./fields/PrivacyTermsField.jsx":239,"./fields/TeacherRoleField.jsx":243,"./form-helper.js":244,"prop-types":"prop-types","react":"react"}],233:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TeacherRegistrationTitleSection = _interopRequireDefault(require("./TeacherRegistrationTitleSection.jsx"));
var _propTypes = require("prop-types");
var _SchoolTypeField = _interopRequireDefault(require("./fields/SchoolTypeField.jsx"));
var _PostalCodeField = _interopRequireDefault(require("./fields/PostalCodeField.jsx"));
var _SchoolNameField = _interopRequireDefault(require("./fields/SchoolNameField.jsx"));
var _StateField = _interopRequireDefault(require("./fields/StateField.jsx"));
var _CityField = _interopRequireDefault(require("./fields/CityField.jsx"));
var _PrivacyTermsField = _interopRequireDefault(require("./fields/PrivacyTermsField.jsx"));
var _validation = require("../validation");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function TeacherRegistrationSecondStep(props) {
  const {
    secondStep,
    step,
    setStep,
    globalState,
    countryValue,
    gradesTaughtValue,
    setIsModalOpen,
    previousButton,
    submitButton,
    populateProvidence,
    stateSelectHandler,
    stateInputHandler,
    zipHandler,
    zip,
    stateInput
  } = props;
  const {
    secondAppState,
    setSecondAppState
  } = globalState;
  const [returnUrl, setReturnUrl] = (0, _react.useState)("");
  const [generalErrorMessage, setGeneralErrorMessage] = (0, _react.useState)("");
  const [enableFields, setEnableFields] = (0, _react.useState)(true);
  const [schoolType, setSchoolType] = (0, _react.useState)("");
  const [schoolNameInput, setSchoolNameInput] = (0, _react.useState)("");
  const [schoolNameSelect, setSchoolNameSelect] = (0, _react.useState)("");
  const [cityInput, setCityInput] = (0, _react.useState)("");
  const [stateSelectVisible, setStateSelectVisible] = (0, _react.useState)(false);
  const regExp = /[a-zA-Z]/g;
  var schoolList = [];
  const formRef = (0, _react.useRef)();
  //These are all hidden fields
  const hiddenCountryFieldRef = (0, _react.useRef)();
  const hiddenGradesTaughtRef = (0, _react.useRef)();
  const schoolIDref = (0, _react.useRef)();
  const districtInputRef = (0, _react.useRef)();
  const schoolTypeHiddenRef = (0, _react.useRef)();
  var populateMigratedData = formRef?.current?.querySelector("#Is_Migrated_User") !== null && formRef?.current?.querySelector("#Is_Migrated_User").value === "True";
  const schoolTypeHandler = type => {
    setSchoolType(type);
  };
  const schoolNameSelectHandler = select => {
    setSchoolNameSelect(select);
  };
  const schoolNameInputHandler = select => {
    setSchoolNameInput(select);
  };
  const cityInputHandler = select => {
    setCityInput(select);
  };
  const onSchoolTypeChange = populatingMigratedData => {
    setEnableFields(false);
    zip.current.value = "";
    schoolNameInput.current.value = "";
    stateInput.current.value = "";
    cityInput.current.value = "";
    stateInput.current.setAttribute("type", "input");
    schoolNameInput.current.setAttribute("type", "input");
    const selectValueText = schoolType.current.options[schoolType.current.selectedIndex].text;
    const hiddenCountryFieldValue = hiddenCountryFieldRef.current.dataset.savedValue;
    if (schoolType.current.value === "280560002" || schoolType.current.value === "280560003") {
      cityInput.current.removeAttribute("readonly");
      schoolNameInput.current.removeAttribute("readonly");
      schoolNameInput.current.value = selectValueText === "Other / Not Applicable" ? "Other / Not Applicable" : "Home School";
      schoolNameInput.current.setAttribute("type", "text");
    }
    if (hiddenCountryFieldValue === "Australia" || hiddenCountryFieldValue === "United States" || hiddenCountryFieldValue === "Canada") {
      //if the user selects the school type of Home School or Other
      if (schoolType.current.value === "280560002" || schoolType.current.value === "280560003") {
        schoolIDref.current.value = "";
        if (populatingMigratedData) {
          cityInput.current.value = cityInput.dataset.originalValue;
          stateInput.current.value = stateInput.dataset.originalValue;
        }
        stateInput.current.setAttribute("type", "hidden");
        stateInput.current.removeAttribute("readonly");
        setStateSelectVisible(true);
        populateProvidence(hiddenCountryFieldRef.current.dataset.savedValue, populatingMigratedData);
      } else if (selectValueText !== "" && selectValueText >= 0 && selectValueText < schoolList.length) {
        cityInput.current.setAttribute("readonly", true);
        stateInput.current.setAttribute("readonly", true);
        stateInput.current.setAttribute("type", "text");
        schoolNameInput.current.value = schoolList[selectValueText].Name;
        zip.current.value = schoolList[selectValueText].Zip;
        cityInput.current.value = schoolList[selectValueText].City;
        stateInput.current.value = schoolList[selectValueText].State;
        schoolIDref.current.value = schoolList[selectValueText].GsId;
        districtInputRef.current.value = schoolList[selectValueText].District;
        schoolTypeHiddenRef.current.value = schoolList[selectValueText].SchoolType;
        (0, _validation.forceValidation)(schoolNameInput.current, formRef.closest("form"));
      }
    } else {
      if (selectValueText !== "" && selectValueText >= 0 && selectValueText < schoolList.length) {
        cityInput.current.setAttribute("readonly", true);
        stateInput.current.setAttribute("readonly", true);
        stateInput.current.setAttribute("type", "text");
        schoolNameInput.current.value = schoolList[selectValueText].Name;
        zip.current.value = schoolList[selectValueText].Zip;
        cityInput.current.value = schoolList[selectValueText].City;
        stateInput.current.value = schoolList[selectValueText].State;
        schoolIDref.current.value = schoolList[selectValueText].GsId;
        districtInputRef.current.value = schoolList[selectValueText].District;
        schoolTypeHiddenRef.current.value = schoolList[selectValueText].SchoolType;
        (0, _validation.forceValidation)(schoolNameInput.current, formRef.closest("form"));
      }
    }
  };

  //form sepecific handlers
  function resetButton(button) {
    button.classList.remove("is-loading");
  }
  const showMessage = (status, msg, el) => {
    if (status === "error") {
      setGeneralErrorMessage(msg);
    }
  };
  const successHandler = elForm => {
    const errorbox = elForm.querySelectorAll(".js-form-general-success");
    showMessage("success", "Your changes have been successfully updated", errorbox);
  };
  function fetchSchoolNames(zip, grade) {
    return fetch(`/owh/school/GetNearbySchools?zip=${zip}&limit=200&gradesTaught=${grade}`).then(response => response.json()).then(data => {
      if (data && data.length > 0) {
        return data.sort((a, b) => {
          if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
            return -1;
          }
          if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
            return 1;
          }
          return 0;
        });
      } else {
        return [];
      }
    }).catch(error => {
      console.error("There has been a problem retrieving form data." + error);
    });
  }
  const validateStateInput = () => {
    (0, _validation.forceValidation)(stateInput.current, formRef.current);
  };
  const onNameChange = populatingMigratedData => {
    const nameValue = schoolNameSelect.current.value;
    schoolNameInput.current.value = "";
    cityInput.current.value = "";
    stateInput.current.value = "";
    schoolIDref.current.value = "";
    districtInputRef.current.value = "";
    schoolTypeHiddenRef.current.value = "";
    if (nameValue === "") {
      return;
    }
    if (nameValue === "HOME" || nameValue === "OTHER") {
      cityInput.current.removeAttribute("readonly");
      schoolNameInput.current.removeAttribute("readonly");
      schoolNameInput.current.setAttribute("type", "text");
      schoolNameInput.current.value = nameValue === "OTHER" ? "Other" : "Home School";
      schoolIDref.current.value = "";
      if (populatingMigratedData) {
        cityInput.current.value = cityInput.current.dataset.originalValue === undefined ? "" : cityInput.current.dataset.originalValue;
        stateInput.current.value = stateInput.current.dataset.originalValue;
      }
      populateProvidence(countryValue, populatingMigratedData);
      stateInput.current.setAttribute("type", "hidden");
      stateInput.current.removeAttribute("readonly");
    } else if (nameValue >= 0 && nameValue < schoolList.length) {
      cityInput.current.setAttribute("readonly", true);
      stateInput.current.setAttribute("readonly", true);
      stateInput.current.setAttribute("type", "text");
      schoolNameInput.current.value = schoolList[nameValue].Name;
      zip.current.value = schoolList[nameValue].Zip;
      cityInput.current.value = schoolList[nameValue].City;
      stateInput.current.value = schoolList[nameValue].State;
      schoolIDref.current.value = schoolList[nameValue].GsId;
      districtInputRef.current.value = schoolList[nameValue].District;
      schoolTypeHiddenRef.current.value = schoolList[nameValue].SchoolType;
      (0, _validation.forceValidation)(schoolNameInput.current, formRef.current);
    }
  };
  const populateSchoolNames = populatingMigratedData => {
    if (countryValue === "United States" && zip?.current?.value.length > 0 && regExp.test(zip?.current?.value) || zip?.current?.value.length >= 5) {
      (0, _validation.forceValidationClean)(zip?.current, formRef?.current);
      //if this returns true then the form is invalid
      if (!(0, _validation.forceValidationClean)(zip?.current, formRef?.current)) {
        return;
      }
    }
    if (schoolType?.current) {
      if (schoolType.current.value === "280560002" || schoolType.current.value === "280560003") {
        return;
      }
    }
    if (zip?.current) {
      const zipValue = zip.current.value.slice(0, 5);
      if (zip.current.value.trim().length < 5 || hiddenCountryFieldRef.current.dataset.savedValue !== "United States") {
        return;
      }
      fetchSchoolNames(zipValue, hiddenGradesTaughtRef.current.dataset.savedValue).then(function (data) {
        schoolList = data;
        schoolNameSelect.current.innerHTML = "<option></option>";
        const selectSchool = document.createElement("option");
        document.createElement("option");
        selectSchool.textContent = "Select School";
        selectSchool.value = "";
        selectSchool.setAttribute("selected", "true");
        schoolNameSelect.current.append(selectSchool);
        schoolList.map((school, i) => {
          const option = document.createElement("option");
          option.textContent = school.Name;
          option.value = i;
          if (populatingMigratedData && schoolNameSelect.current.dataset.originalValue === option.textContent) {
            option.setAttribute("selected", "true");
          }
          schoolNameSelect.current.append(option);
        });
        const otherSchool = document.createElement("option");
        otherSchool.textContent = "-- Other / Not Applicable";
        otherSchool.value = "OTHER";
        if (populatingMigratedData && schoolNameInput.current.dataset.originalValue === otherSchool.textContent) {
          otherSchool.setAttribute("selected", "true");
        }
        schoolNameSelect.current.append(otherSchool);
        schoolNameInput.current.setAttribute("type", "hidden");
        schoolNameInput.current.value = "";
        cityInput.current.value = "";
        stateInput.current.value = "";
        onNameChange(populatingMigratedData);
      });
    }
  };
  const validateField = (type, value, value2) => {
    let valid = true;
    const passwordStrengthTest = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*])(?=.{8,20})(?!.*[<&])");
    const globalPostalTest = new RegExp(/^(?!-$)[a-z0-9]+[ -]?[a-z0-9]*$/i);
    const usZipTest = new RegExp("^\\d{5}(-{0,1}\\d{4})?$");
    switch (type) {
      case "email":
        valid = !!value.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+/i);
        break;
      case "password":
        // more than eight characters, less than 20
        // contains digits
        // contains lower case alpha
        // contains upper case alpha
        // contains special characters
        // does not contain white space

        valid = passwordStrengthTest.test(value);
        break;
      case "new-password":
        //valid password that doesnt match other password
        const passwordFields = [value, value2];

        //only return true when there are 2 new password fields
        if (passwordFields.length > 1 && passwordFields.length < 3) {
          /*
                //if password fields are blank or
                //bothfields pass regex and are not
                //equal the new passwords are valid
                */

          const isBlank = passwordFields.reduce((a, b) => a + b) === "";
          const Eq = passwordFields[0] === passwordFields[1] && passwordStrengthTest.test(passwordFields[0]) && passwordStrengthTest.test(passwordFields[1]);
          valid = isBlank ? isBlank : Eq;
        } else {
          valid = false;
        }
        break;
      case "tel":
        valid = !!value.match(/^[0-9]*^[()-]*$/) || value === "";
        break;
      case "extension":
        valid = !!value.match(/^\d{1,4}$/) || value === "";
        break;
      case "zip":
        valid = !!value.match(globalPostalTest) || !!value.match(usZipTest);
        break;
      case "website":
        valid = !!value.match(/^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/) || value === "";
        break;
      case "text-length":
        valid = strip(unescape(value)).length <= 50 && strip(unescape(value)).length > 0;
        break;
      case "checkbox":
      case "select":
      case "text":
      case "file":
      default:
        if (value.trim().length === 0) {
          valid = false;
        }
    }
    return valid;
  };
  const validFields = (items, elForm) => {
    let valid = true;
    items.forEach(item => {
      const field = item.querySelector("[aria-required]");
      if (field === null) {
        return;
      }
      const validCheck = field.dataset.type === "checkbox" ? field.checked : validateField(field.dataset.type, field.value);
      if (validCheck) {
        item.classList.remove("has-error");
      } else {
        if (field.getAttribute("readonly") !== null) {
          return;
        } else {
          item.classList.add("has-error");
          valid = false;
        }
      }
    });
    return valid;
  };
  const errorHandler = elForm => {
    const errorbox = elForm.querySelectorAll(".js-form-general-success");
    const submitButtons = elForm.querySelectorAll("button[type=submit]");
    [...elForm.querySelectorAll(".js-form-general-error")].forEach(el => {
      el.classList.add("has-error");
      if (el.dataset.hasText !== "true") {
        const msg = "Server Error. Please try again";
        showMessage("error", msg, el);
      }
      el.setAttribute("role", "alert");
    });
    [...submitButtons].forEach(resetButton);
    if (errorbox.length) {
      setGeneralErrorMessage("error", "Whoops, something went wrong please try again later.", errorbox);
    }
  };
  const submitForm = e => {
    e.preventDefault();
    if (formRef?.current) {
      if (validFields([...formRef.current.querySelectorAll(".js-form-required")], formRef.current)) {
        const newFormData = new FormData(formRef.current);
        let formJson = {};
        [...newFormData].map(_ref => {
          let [k, v] = _ref;
          formJson = {
            ...formJson,
            [`${k}`]: v
          };
        });
        fetch(`${secondStep.PostUrl}`, {
          method: "POST",
          body: JSON.stringify(formJson),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          }
        }).then(response => response.json()).then(data => {
          //handle data
          if (data.IsValid) {
            setIsModalOpen(false);
            if (returnUrl !== "") {
              window.location.replace(returnUrl);
            }
          } else {
            errorHandler(formRef.current);
          }
        }).catch(error => {
          errorHandler(formRef.current);
          console.log(error);
        });
      } else {
        formErrorMessage(formRef);
      }
    }
  };
  (0, _react.useEffect)(() => {
    if (countryValue !== "United States") {
      setEnableFields(false);
    } else {
      setEnableFields(true);
    }
    secondStep.FormData.map((data, i) => {
      if (data.FieldIdentifier === "returnUrl") {
        setReturnUrl(data.OriginalValue);
      }
    });
  }, [countryValue, secondStep.FormData]);
  (0, _react.useEffect)(() => {
    const elItems = formRef?.current?.querySelectorAll(".js-form-required");
    //form field validation
    elItems.forEach(item => {
      (0, _validation.validationListeners)(item, formRef?.current);
    });
    if (hiddenGradesTaughtRef || hiddenCountryFieldRef) {
      if ((hiddenGradesTaughtRef.current.dataset.savedValue !== "" || hiddenGradesTaughtRef.current.savedValue !== undefined) && (hiddenCountryFieldRef.current.dataset.savedValue !== "" || hiddenCountryFieldRef.current.dataset.savedValue !== undefined) && secondAppState.postalCode !== null && secondAppState.schoolType.ValueText !== null) {
        populateSchoolNames();
      }
    }
    if (zip.current) {
      if (countryValue === "United States" && regExp.test(zip?.current.value) || zip?.current.value.length > 0) {
        (0, _validation.forceValidationClean)(zip?.current, formRef?.current);
      }
    }
  }, [hiddenGradesTaughtRef, hiddenCountryFieldRef, zip]);
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("form", {
    className: "gv__form js-form-react js-form-changes",
    method: "POST",
    onSubmit: submitForm,
    ref: formRef
  }, /*#__PURE__*/_react.default.createElement("fieldset", {
    className: "gv__class-fieldset gv__form__fieldset js-class-fieldset-react"
  }, /*#__PURE__*/_react.default.createElement(_TeacherRegistrationTitleSection.default, {
    firstTitle: secondStep.TitleFirstRow,
    secondTitle: secondStep.TitleSecondRow,
    subTitle: secondStep.Subtitle
  }), secondStep.FormData && secondStep.FormData.map((data, i) => {
    if (data.FieldIdentifier === "schoolType") {
      return /*#__PURE__*/_react.default.createElement(_SchoolTypeField.default, {
        getSchoolType: schoolTypeHandler,
        defaultValue: secondAppState.schoolType.OriginalValue,
        formData: data,
        key: i,
        handleChange: e => {
          setSecondAppState({
            schoolType: {
              OriginalValue: e.target.value,
              ValueText: e.target.value
            }
          });
          onSchoolTypeChange();
        }
      });
    } else if (data.FieldIdentifier === "postalCode") {
      return /*#__PURE__*/_react.default.createElement(_PostalCodeField.default, {
        countryValue: countryValue,
        getZip: zipHandler,
        populateSchoolNames: populateSchoolNames,
        defaultValue: secondAppState.postalCode,
        enableFields: enableFields,
        formData: data,
        key: i,
        handleChange: e => {
          setSecondAppState({
            postalCode: e.target.value
          });
        }
      });
    } else if (data.FieldIdentifier === "schoolName") {
      return /*#__PURE__*/_react.default.createElement(_SchoolNameField.default, {
        getSchoolNameSelect: schoolNameSelectHandler,
        getSchoolNameInput: schoolNameInputHandler,
        onNameChange: onNameChange,
        defaultValue: secondAppState.schoolName,
        enableFields: enableFields,
        formData: data,
        key: i,
        handleChange: e => {
          setSecondAppState({
            schoolName: e.target.value
          });
        }
      });
    }
    if (data.FieldIdentifier === "state" || data.FieldIdentifier === "city") {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: `gv__form__split gv__form__split-${i}`,
        key: i
      }, (() => {
        if (data.FieldIdentifier === "state") {
          return /*#__PURE__*/_react.default.createElement(_StateField.default, {
            stateSelectVisible: stateSelectVisible,
            getStateInput: stateInputHandler,
            getStateSelect: stateSelectHandler,
            defaultValue: secondAppState.state,
            enableFields: enableFields,
            formData: data,
            handleChange: e => {
              setSecondAppState({
                state: e.target.value
              });
            }
          });
        } else if (data.FieldIdentifier === "city") {
          return /*#__PURE__*/_react.default.createElement(_CityField.default, {
            getCityInput: cityInputHandler,
            defaultValue: secondAppState.city,
            enableFields: enableFields,
            formData: data,
            handleChange: e => {
              setSecondAppState({
                city: e.target.value
              });
            }
          });
        }
      })());
    } else if (data.FieldIdentifier === "acceptTermsAndPrivacy") {
      return /*#__PURE__*/_react.default.createElement(_PrivacyTermsField.default, {
        defaultValue: secondAppState?.acceptTermsAndPrivacy,
        formData: data,
        key: i,
        handleChange: e => {
          setSecondAppState({
            acceptTermsAndPrivacy: !secondAppState?.acceptTermsAndPrivacy
          });
        }
      });
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "js-class-fieldset-gradesTaught-field-input",
    "data-saved-value": gradesTaughtValue,
    ref: hiddenGradesTaughtRef
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "js-class-fieldset-country-field-input",
    "data-saved-value": countryValue,
    ref: hiddenCountryFieldRef
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "school_id",
    className: "js-class-fieldset-school-id-input",
    ref: schoolIDref
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "district",
    className: "js-class-fieldset-district-input",
    ref: districtInputRef
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "schoolType",
    className: "js-class-fieldset-school-type-input",
    ref: schoolTypeHiddenRef
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "gv__button gv__button-prev",
    type: "button",
    disabled: step === 0,
    onClick: () => {
      setStep(currPage => currPage - 1);
    }
  }, previousButton), /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    className: "gv__button gv__button-next"
  }, /*#__PURE__*/_react.default.createElement("span", null, submitButton)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__general-success js-form-general-success",
    "aria-atomic": "true",
    role: "alert"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__error-msg gv__form__general-error js-form-general-error",
    "aria-atomic": "true",
    role: "alert"
  }, generalErrorMessage)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__information gv__rte",
    dangerouslySetInnerHTML: {
      __html: secondStep.BottomText
    }
  }));
}
TeacherRegistrationSecondStep.propTypes = {
  secondStep: _propTypes.object.isRequired,
  step: _propTypes.number.isRequired,
  setStep: _propTypes.func.isRequired,
  globalState: _propTypes.object.isRequired,
  countryValue: _propTypes.string.isRequired,
  previousButton: _propTypes.string.isRequired,
  submitButton: _propTypes.string.isRequired,
  gradesTaughtValue: _propTypes.array.isRequired,
  setIsModalOpen: _propTypes.func.isRequired,
  populateProvidence: _propTypes.func.isRequired,
  stateSelectHandler: _propTypes.func.isRequired,
  stateInputHandler: _propTypes.func.isRequired,
  zipHandler: _propTypes.func.isRequired,
  zip: _propTypes.object.isRequired,
  stateInput: _propTypes.object.isRequired
};
var _default = exports.default = TeacherRegistrationSecondStep;

},{"../validation":262,"./TeacherRegistrationTitleSection.jsx":234,"./fields/CityField.jsx":235,"./fields/PostalCodeField.jsx":238,"./fields/PrivacyTermsField.jsx":239,"./fields/SchoolNameField.jsx":240,"./fields/SchoolTypeField.jsx":241,"./fields/StateField.jsx":242,"prop-types":"prop-types","react":"react"}],234:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function TeacherRegistrationTitleSection(props) {
  const {
    firstTitle,
    secondTitle,
    subTitle
  } = props;
  const SecondTitleDisplay = () => {
    if (secondTitle || secondTitle !== "") {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "gv__page-title__title-break"
      }, secondTitle);
    }
  };
  const SubTitleDisplay = () => {
    if (subTitle || subTitle !== "") {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "gv__rte gv__page-summary gv__page-summary-react gv__sub-title"
      }, subTitle);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("legend", {
    className: "gv__form__legend gv__form__legend-react"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__form__legend gv__page-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__page-title__title-break"
  }, firstTitle), SecondTitleDisplay())), SubTitleDisplay());
}
TeacherRegistrationTitleSection.propTypes = {
  firstTitle: _propTypes.string,
  secondTitle: _propTypes.string,
  subTitle: _propTypes.string
};
var _default = exports.default = TeacherRegistrationTitleSection;

},{"prop-types":"prop-types","react":"react"}],235:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function CityField(props) {
  const {
    formData,
    handleChange,
    defaultValue,
    getCityInput
  } = props;
  const cityRef = (0, _react.useRef)("");
  const getCityElement = () => {
    getCityInput(cityRef);
  };
  (0, _react.useEffect)(() => {
    getCityElement();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item js-form-required"
  }, /*#__PURE__*/_react.default.createElement("label", {
    id: "cityLabel",
    htmlFor: "cityInput",
    className: "gv__form__label"
  }, formData.LabelText), /*#__PURE__*/_react.default.createElement("input", {
    "aria-required": "true",
    id: "cityInput",
    autoComplete: "address-level2",
    type: "text",
    placeholder: "",
    "data-type": "text",
    name: "school_city",
    className: "gv__form__field js-class-fieldset-city",
    defaultValue: defaultValue,
    "data-value": defaultValue,
    onChange: e => handleChange(e),
    "data-original-value": defaultValue,
    ref: cityRef
  }), /*#__PURE__*/_react.default.createElement("span", {
    id: "cityError",
    "aria-atomic": "true",
    className: "gv__form__error-msg"
  }, formData.ErrorMessage), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    id: "schoolCityErrorConditional",
    className: "gv__form__error-msg-conditional"
  }));
}
CityField.propTypes = {
  formData: _propTypes.object.isRequired,
  handleChange: _propTypes.func.isRequired,
  defaultValue: _propTypes.string
};
var _default = exports.default = CityField;

},{"prop-types":"prop-types","react":"react"}],236:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function CountryField(props) {
  const {
    formData,
    handleChange,
    defaultValue,
    getCountryField
  } = props;
  const countryFieldRef = (0, _react.useRef)("");
  const getCountryFieldElement = () => {
    getCountryField(countryFieldRef);
  };
  (0, _react.useEffect)(() => {
    getCountryFieldElement();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__select-input gv__form__item js-form-required"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "gv__select-input__text gv__form__label",
    id: "countryLabel",
    htmlFor: "countryInput"
  }, formData.LabelText), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__select-input__input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("select", {
    id: "countryInput",
    "aria-labelledby": "countryLabel",
    "data-type": "select",
    "aria-required": "true",
    name: "country",
    className: "gv__select-input__field gv__form__field js-class-fieldset-country",
    defaultValue: defaultValue,
    "data-value": defaultValue,
    onChange: e => handleChange(e),
    "data-original-value": defaultValue,
    ref: countryFieldRef
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }))), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    id: "countryError",
    className: "gv__form__error-msg"
  }, formData.ErrorMessage));
}
CountryField.propTypes = {
  formData: _propTypes.object.isRequired,
  handleChange: _propTypes.func.isRequired,
  defaultValue: _propTypes.string,
  getCountryField: _propTypes.func.isRequired
};
var _default = exports.default = CountryField;

},{"prop-types":"prop-types","react":"react"}],237:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function GradesTaughtField(props) {
  const {
    formData,
    defaultValue,
    setGradesTaught
  } = props;
  const {
    appState,
    setAppState
  } = setGradesTaught;
  const inputRef = (0, _react.useRef)();
  const multiSelectDropdown = (0, _react.useRef)();
  const multiSelectDropdownLabel = (0, _react.useRef)();
  const [showDropdownLabel, setShowDropdownLabel] = (0, _react.useState)(true);
  const [selectedOptions, setselectedOptions] = (0, _react.useState)(defaultValue);
  const [openDropdown, setOpenDropdown] = (0, _react.useState)(false);
  const closeDropdownRef = (0, _react.useRef)();
  const dropdownTokenRef = (0, _react.useRef)();
  const jsDropdownRef = (0, _react.useRef)();
  const dropdownToggle = (0, _react.useRef)();
  var obj = {};
  var checkboxKeyboardTracking = [];
  const DOWN_ARROW_KEY_CODE = 40;
  const UP_ARROW_KEY_CODE = 38;
  const ENTER_KEY_CODE = 13;
  const SPACE_KEY_CODE = 32;
  const ESCAPE_KEY_CODE = 32;
  const TAB_KEY_CODE = 9;
  const SHIFT_KEY_CODE = 16;
  const firstCheckbox = (0, _react.useRef)();
  const focusNextListItem = direction => {
    const activeElementId = document.activeElement.id;
    const currentActiveElementIndex = checkboxKeyboardTracking.indexOf(activeElementId);
    if (direction === DOWN_ARROW_KEY_CODE) {
      const currentActiveElementIsNotLastItem = currentActiveElementIndex < checkboxKeyboardTracking.length - 1;
      if (currentActiveElementIsNotLastItem) {
        const nextListItemId = checkboxKeyboardTracking[currentActiveElementIndex + 1];
        document.querySelector(`#${nextListItemId}`).focus();
      }
    } else if (direction === UP_ARROW_KEY_CODE) {
      const currentActiveElementIsNotFirstItem = currentActiveElementIndex > 0;
      if (currentActiveElementIsNotFirstItem) {
        const nextListItemId = checkboxKeyboardTracking[currentActiveElementIndex - 1];
        document.querySelector(`#${nextListItemId}`).focus();
      } else {
        return;
      }
    }
  };
  const toggleDropdownVisibility = e => {
    const downArrowToNavigate = openDropdown === true && e.which === DOWN_ARROW_KEY_CODE || openDropdown === true;
    if (e.type === "keyup") {
      if (!openDropdown) {
        if (e.which === DOWN_ARROW_KEY_CODE || e.which === ENTER_KEY_CODE || e.which === SPACE_KEY_CODE) {
          setOpenDropdown(true);
          return;
        }
      } else if (e.which === ENTER_KEY_CODE) {
        setOpenDropdown(!openDropdown);
      } else if (e.which === DOWN_ARROW_KEY_CODE && openDropdown === true) {
        firstCheckbox.current.focus();
      } else if (e.which === UP_ARROW_KEY_CODE && openDropdown === true) {
        setOpenDropdown(false);
      } else if (e.which === ESCAPE_KEY_CODE) {
        setOpenDropdown(false);
        dropdownToggle.current.focus();
      }
    } else {
      if (e.target.classList.contains("checkbox-dropdown__token")) {
        return;
      } else {
        setOpenDropdown(!openDropdown);
      }
    }
  };
  const toggleCheckedCheckboxes = (e, value) => {
    if (e.which === DOWN_ARROW_KEY_CODE) {
      focusNextListItem(DOWN_ARROW_KEY_CODE);
      return;
    }
    if (e.which === UP_ARROW_KEY_CODE) {
      focusNextListItem(UP_ARROW_KEY_CODE);
      return;
    }
    if (e.which === ESCAPE_KEY_CODE) {
      setOpenDropdown(false);
      dropdownToggle.current.focus();
    }
    if (e.type === "keyup") {
      if (e.which === ENTER_KEY_CODE || e.which === SPACE_KEY_CODE) {
        setselectedOptions(previousState => {
          /* Check if value exists in prev state
           if it does exists in prev state, remove it. IF it doesn't, add it [...previousState, value]*/
          if (value === "280560009") {
            if (previousState.includes(value)) {
              const notApplicableArr = previousState.splice(0, previousState.length);
              return [...previousState];
            } else {
              const notApplicableArr = previousState.splice(0, previousState.length);
              return [...previousState, value];
            }
          } else {
            if (previousState.includes(value)) {
              const index = previousState.indexOf(value);
              const newState = previousState.splice(index, 1);
              return [...previousState];
            } else {
              if (previousState.includes("280560009")) {
                const notApplicableIndex = previousState.indexOf("280560009");
                const removeNotApplicable = previousState.splice(notApplicableIndex, 1);
              }
              return [...previousState, value];
            }
          }
        });
      } else {
        return;
      }
    } else if (e.type === "click") {
      setselectedOptions(previousState => {
        /* Check if value exists in prev state
         if it does exists in prev state, remove it. IF it doesn't, add it [...previousState, value]*/
        if (value === "280560009") {
          if (previousState.includes(value)) {
            const notApplicableArr = previousState.splice(0, previousState.length);
            return [...previousState];
          } else {
            const notApplicableArr = previousState.splice(0, previousState.length);
            return [...previousState, value];
          }
        } else {
          if (previousState.includes(value)) {
            const index = previousState.indexOf(value);
            const newState = previousState.splice(index, 1);
            return [...previousState];
          } else {
            if (previousState.includes("280560009")) {
              const notApplicableIndex = previousState.indexOf("280560009");
              const removeNotApplicable = previousState.splice(notApplicableIndex, 1);
            }
            return [...previousState, value];
          }
        }
      });
    }
    setAppState({
      gradesTaught: selectedOptions
    });
  };
  (0, _react.useEffect)(() => {
    const inputStoredValues = JSON.parse(inputRef.current.value);
    setAppState({
      gradesTaught: selectedOptions
    });
    //setMultiSelectCheckboxDropdown(multiSelectDropdown.current, multiSelectDropdownLabel.current);

    let handler = e => {
      if (!closeDropdownRef.current.contains(e.target)) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [selectedOptions]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item js-form-required js-multiselect-checkbox-dropdown",
    ref: multiSelectDropdown
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__label",
    id: "gradesTaughtLabel"
  }, formData.LabelText), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("gv__form__checkbox-dropdown", {
      "js-open-dropdown": openDropdown
    }),
    ref: closeDropdownRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__select-input__input-wrapper gv__form__checkbox-dropdown-select js-dropdown-toggle",
    "aria-haspopup": "true",
    "aria-controls": "checkbox-list",
    "aria-expanded": openDropdown,
    role: "combobox",
    tabIndex: "0",
    onClick: e => {
      toggleDropdownVisibility(e);
    },
    onKeyUp: e => {
      toggleDropdownVisibility(e);
    },
    ref: dropdownToggle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__select-input__field gv__form__field js__select-input__field"
  }, selectedOptions.length == 0 ? /*#__PURE__*/_react.default.createElement("span", {
    className: "js-default-label",
    "aria-labelledby": "checkbox-dropdown",
    ref: multiSelectDropdownLabel
  }, " Select Grades") : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "js-token-container"
  }, formData.Options.map((item, i) => {
    if (selectedOptions.includes(item.Value)) {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "checkbox-dropdown__token",
        ref: dropdownTokenRef,
        tabIndex: "0",
        "data-value": item.Value,
        key: item.Value,
        onClick: e => {
          toggleCheckedCheckboxes(e, item.Value);
        },
        onKeyUp: e => {
          toggleCheckedCheckboxes(e, item.Value);
        }
      }, item.Text);
    }
  }).filter(item => !!item)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__checkbox-dropdown-list js-dropdown",
    role: "checkbox-list",
    id: "checkbox-list",
    "aria-labelledby": "checkbox-dropdown",
    "aria-multiselectable": "true",
    ref: jsDropdownRef
  }, formData.Options.map((item, i) => {
    checkboxKeyboardTracking.push(`grades-taught-label-${i}`);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__form__item gv__checkbox-layout js-form-checkbox gv__form__item--checkbox",
      id: `grades-taught-${i}`,
      key: i,
      onClick: e => {
        toggleCheckedCheckboxes(e, item.Value);
      },
      onKeyUp: e => {
        toggleCheckedCheckboxes(e, item.Value);
      },
      role: "checkbox",
      tabIndex: 0,
      "aria-checked": selectedOptions.includes(item.Value) ? true : false
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      "data-type": "checkbox",
      id: `gradesTaught-${item.Text}`,
      className: "js-class-fieldset-grades-taught-input gv__form__field",
      value: item.Value,
      "data-label-text": item.Text,
      tabIndex: "-1",
      defaultChecked: selectedOptions.includes(item.Value) ? true : false,
      "data-checked": selectedOptions.includes(item.Value) ? true : false
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: "gv__form__label",
      htmlFor: "gradesTaught",
      id: `grades-taught-label-${i}`,
      ref: i === 0 ? firstCheckbox : null,
      tabIndex: 0
    }, item.Text));
  }).filter(item => !!item))), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    "data-type": "checkbox-array",
    name: "gradesTaught",
    className: "js-stored-checkbox-values",
    "aria-required": "true",
    ref: inputRef,
    defaultValue: JSON.stringify(selectedOptions),
    "data-original-value": JSON.stringify(defaultValue)
  }), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    className: "gv__form__error-msg",
    id: "gradesTaughtError"
  }, formData.ErrorMessage));
}
GradesTaughtField.propTypes = {
  formData: _propTypes.object.isRequired,
  defaultValue: _propTypes.array
};
var _default = exports.default = GradesTaughtField;

},{"classnames":"classnames","prop-types":"prop-types","react":"react"}],238:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function PostalCodeField(props) {
  const {
    formData,
    handleChange,
    defaultValue,
    getZip,
    populateSchoolNames,
    countryValue
  } = props;
  const zipRef = (0, _react.useRef)("");
  const getZipElement = () => {
    getZip(zipRef);
  };
  (0, _react.useEffect)(() => {
    getZipElement();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item js-form-required"
  }, /*#__PURE__*/_react.default.createElement("label", {
    id: "postCodeLabel",
    htmlFor: "postCodeInput",
    className: "gv__form__label"
  }, formData.LabelText), /*#__PURE__*/_react.default.createElement("input", {
    "aria-required": "true",
    id: "postCodeInput",
    autoComplete: "postal-code",
    className: "gv__form__field js-class-fieldset-zipcode",
    type: "text",
    placeholder: "",
    "data-type": countryValue === "United States" ? "zip-us" : "zip",
    name: "zip_code",
    defaultValue: defaultValue,
    "data-value": defaultValue,
    onChange: e => handleChange(e),
    onKeyUp: populateSchoolNames,
    "data-original-value": defaultValue,
    ref: zipRef
  }), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    id: "postCodeError",
    className: "gv__form__error-msg"
  }, formData.ErrorMessage), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    id: "postCodeErrorConditional",
    className: "gv__form__error-msg-conditional"
  }));
}
PostalCodeField.propTypes = {
  formData: _propTypes.object.isRequired,
  // handleChange: func.isRequired,
  defaultValue: _propTypes.string,
  getZip: _propTypes.func.isRequired,
  populateSchoolNames: _propTypes.func.isRequired
};
var _default = exports.default = PostalCodeField;

},{"prop-types":"prop-types","react":"react"}],239:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function PrivacyTermsField(props) {
  const {
    formData,
    handleChange,
    defaultValue,
    enableFields
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item gv__form__item--checkbox js-form-item js-form-required"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: "acceptTerms",
    type: "checkbox",
    "aria-required": "true",
    "data-type": "checkbox",
    "data-checked": defaultValue,
    name: "text",
    defaultChecked: defaultValue,
    className: "gv__form__field",
    onChange: e => handleChange(e)
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "acceptTerms",
    id: "acceptTermsLabel",
    className: "gv__form__label",
    dangerouslySetInnerHTML: {
      __html: formData.LabelText
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    role: "alert",
    className: "gv__form__error-msg",
    id: "acceptTermsError"
  }, formData.ErrorMessage));
}
PrivacyTermsField.propTypes = {
  formData: _propTypes.object.isRequired,
  handleChange: _propTypes.func.isRequired,
  defaultValue: _propTypes.bool
};
var _default = exports.default = PrivacyTermsField;

},{"prop-types":"prop-types","react":"react"}],240:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function SchoolNameField(props) {
  const {
    formData,
    handleChange,
    defaultValue,
    enableFields,
    getSchoolNameSelect,
    getSchoolNameInput,
    onNameChange
  } = props;
  const schoolNameSelectRef = (0, _react.useRef)("");
  const schoolNameInputRef = (0, _react.useRef)("");
  const getSchoolNameSelectElement = () => {
    getSchoolNameSelect(schoolNameSelectRef);
  };
  const getSchoolNameInputElement = () => {
    getSchoolNameInput(schoolNameInputRef);
  };
  (0, _react.useEffect)(() => {
    getSchoolNameSelectElement();
    getSchoolNameInputElement();
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item js-form-required"
  }, /*#__PURE__*/_react.default.createElement("label", {
    id: "schoolNameLabel",
    className: "gv__form__label"
  }, formData.LabelText), /*#__PURE__*/_react.default.createElement("input", {
    "aria-required": "true",
    "aria-labelledby": "schoolNameLabel",
    id: "schoolNameInput",
    type: "text",
    placeholder: "",
    "data-type": "text",
    name: "school_name",
    className: "gv__form__field js-class-fieldset-name-input",
    defaultValue: defaultValue,
    "data-value": defaultValue,
    onChange: e => handleChange(e),
    "data-original-value": defaultValue,
    ref: schoolNameInputRef
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__select-input__input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("select", {
    id: "schoolNameSelect",
    "aria-labelledby": "schoolNameLabel",
    className: "gv__select-input__field gv__form__field js-class-fieldset-name-select",
    ref: schoolNameSelectRef,
    onChange: onNameChange
  })), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    id: "schoolNameError",
    className: "gv__form__error-msg"
  }, formData.ErrorMessage), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    id: "schoolNameErrorConditional",
    className: "gv__form__error-msg-conditional"
  }));
}
SchoolNameField.propTypes = {
  formData: _propTypes.object.isRequired,
  //handleChange: func.isRequired,
  defaultValue: _propTypes.string
};
var _default = exports.default = SchoolNameField;

},{"prop-types":"prop-types","react":"react"}],241:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function SchoolTypeField(props) {
  const {
    formData,
    handleChange,
    defaultValue,
    getSchoolType
  } = props;
  const schoolTypeRef = (0, _react.useRef)("");
  const getSchoolTypeElement = () => {
    getSchoolType(schoolTypeRef);
  };
  (0, _react.useEffect)(() => {
    getSchoolTypeElement();
  }, []);
  const SetOptions = () => {
    return formData.Options.map((item, i) => {
      return /*#__PURE__*/_react.default.createElement("option", {
        value: item.Value,
        key: i
      }, item.Text);
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item gv__select-input js-form-item js-form-required"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "gv__form__label",
    id: "teacherSchoolTypeLabel",
    htmlFor: "teacherSchoolTypeType"
  }, "School Type"), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__select-input__input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("select", {
    name: "teacherSchoolType",
    id: "teacherSchoolType",
    "aria-required": "true",
    "data-type": "select",
    className: "gv__select-input__field gv__form__field js-class-fieldset-school-type",
    defaultValue: defaultValue,
    "data-value": defaultValue,
    onChange: e => handleChange(e),
    "data-original-value": defaultValue,
    ref: schoolTypeRef
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }), SetOptions()), /*#__PURE__*/_react.default.createElement("span", {
    id: "teacherSchoolTypeError",
    "aria-atomic": "true",
    className: "gv__form__error-msg"
  })));
}
SchoolTypeField.propTypes = {
  formData: _propTypes.object.isRequired,
  //handleChange: func.isRequired,
  defaultValue: _propTypes.string
};
var _default = exports.default = SchoolTypeField;

},{"prop-types":"prop-types","react":"react"}],242:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function StateField(props) {
  const {
    formData,
    handleChange,
    defaultValue,
    enableFields,
    getStateInput,
    getStateSelect,
    stateSelectVisible
  } = props;
  const stateInputRef = (0, _react.useRef)("");
  const stateSelectRef = (0, _react.useRef)("");
  const getStateElement = () => {
    getStateInput(stateInputRef);
  };
  const getStateSelectElement = () => {
    getStateSelect(stateSelectRef);
  };
  (0, _react.useEffect)(() => {
    getStateElement();
    getStateSelectElement();
  }, []);
  (0, _react.useEffect)(() => {
    if (stateSelectVisible) {
      getStateSelectElement();
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item gv__form__item--toggle js-form-required"
  }, /*#__PURE__*/_react.default.createElement("label", {
    id: "stateLabel",
    className: "gv__form__label"
  }, formData.LabelText), /*#__PURE__*/_react.default.createElement("input", {
    id: "stateInput",
    "aria-labelledby": "stateLabel",
    autoComplete: "address-level1",
    type: "text",
    placeholder: "",
    "aria-required": "true",
    "data-type": "text",
    name: "school_state",
    className: "gv__form__field js-class-fieldset-state-input",
    defaultValue: defaultValue,
    "data-value": defaultValue,
    onChange: e => handleChange(e),
    "data-original-value": defaultValue,
    ref: stateInputRef
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__select-input__input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("select", {
    onChange: e => handleChange(e),
    "aria-labelledby": "stateLabel",
    id: "stateSelect",
    className: "gv__select-input__field gv__form__field js-class-fieldset-state-select",
    ref: stateSelectRef
  })), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    id: "stateError",
    className: "gv__form__error-msg"
  }, formData.ErrorMessage), /*#__PURE__*/_react.default.createElement("span", {
    "aria-atomic": "true",
    id: "schoolStateErrorConditional",
    className: "gv__form__error-msg-conditional"
  }));
}
StateField.propTypes = {
  formData: _propTypes.object.isRequired,
  //handleChange: func.isRequired,
  defaultValue: _propTypes.string,
  enableFields: _propTypes.bool,
  getStateInput: _propTypes.func.isRequired,
  getStateSelect: _propTypes.func.isRequired,
  stateSelectVisible: _propTypes.bool.isRequired
};
var _default = exports.default = StateField;

},{"prop-types":"prop-types","react":"react"}],243:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function TeacherRoleField(props) {
  const {
    formData,
    handleChange,
    defaultValue
  } = props;
  const SetOptions = () => {
    return formData.Options.map((item, i) => {
      return /*#__PURE__*/_react.default.createElement("option", {
        value: item.Value,
        key: i
      }, item.Text);
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__form__item gv__select-input js-form-required"
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "gv__form__label",
    id: "teacherRoleLabel",
    htmlFor: "teacherRole"
  }, formData.LabelText), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__select-input__input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("select", {
    name: "role",
    id: "teacherRole",
    "aria-required": "true",
    "data-type": "select",
    className: "gv__select-input__field gv__form__field js-class-fieldset-role",
    defaultValue: defaultValue,
    "data-value": defaultValue,
    onChange: e => handleChange(e),
    "data-original-value": defaultValue
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: ""
  }), SetOptions()), /*#__PURE__*/_react.default.createElement("span", {
    id: "teacherRoleError",
    "aria-atomic": "true",
    className: "gv__form__error-msg"
  }, formData.ErrorMessage)));
}
TeacherRoleField.propTypes = {
  formData: _propTypes.object.isRequired,
  handleChange: _propTypes.func.isRequired
};
var _default = exports.default = TeacherRoleField;

},{"prop-types":"prop-types","react":"react"}],244:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateField = exports.validFields = exports.successHandler = exports.errorHandler = void 0;
// export const showMessage = (status, msg, el) => {
//   if(status === "error"){
//     //setGeneralErrorMessage("Please Fill out the required fields");
//   }  
// };

//form sepecific handlers
function resetButton(button) {
  button.classList.remove("is-loading");
}
function showMessage(status, msg, el) {
  [...el].forEach(el => {
    el.querySelector(".js-error-msg").innerHTML = msg;
    el.classList.remove("is-hidden");
    if (status === "error") {
      el.setAttribute("role", "alert");
    }
  });
}

//handle successfull form response
const errorHandler = elForm => {
  const errorbox = elForm.querySelectorAll(".js-error-box");
  const recaptcha = elForm.querySelector(".g-recaptcha");
  const submitButtons = elForm.querySelectorAll("button[type=submit]");
  [...elForm.querySelectorAll(".js-form-general-error")].forEach(el => {
    el.classList.add("has-error");
    if (el.dataset.hasText !== "true") {
      el.textContent = "Server Error. Please try again";
    }
    el.setAttribute("role", "alert");
  });
  [...submitButtons].forEach(resetButton);
  if (errorbox.length) {
    showMessage("error", "Whoops, something went wrong please try again later.", errorbox);
  }
  if (recaptcha) {
    grecaptcha.reset();
  }
};
exports.errorHandler = errorHandler;
const successHandler = elForm => {
  const errorbox = elForm.querySelectorAll(".js-form-general-success");
};
exports.successHandler = successHandler;
const validateField = (type, value, value2) => {
  let valid = true;
  const passwordStrengthTest = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*])(?=.{8,20})(?!.*[<&])");
  const globalPostalTest = new RegExp(/^(?!-$)[a-z0-9]+[ -]?[a-z0-9]*$/i);
  const usZipTest = new RegExp("^\\d{5}(-{0,1}\\d{4})?$");
  switch (type) {
    case "email":
      valid = !!value.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+/i);
      break;
    case "password":
      // more than eight characters, less than 20
      // contains digits
      // contains lower case alpha
      // contains upper case alpha
      // contains special characters
      // does not contain white space

      valid = passwordStrengthTest.test(value);
      break;
    case "new-password":
      //valid password that doesnt match other password
      const passwordFields = [value, value2];

      //only return true when there are 2 new password fields
      if (passwordFields.length > 1 && passwordFields.length < 3) {
        /*
              //if password fields are blank or
              //bothfields pass regex and are not
              //equal the new passwords are valid
              */

        const isBlank = passwordFields.reduce((a, b) => a + b) === "";
        const Eq = passwordFields[0] === passwordFields[1] && passwordStrengthTest.test(passwordFields[0]) && passwordStrengthTest.test(passwordFields[1]);
        valid = isBlank ? isBlank : Eq;
      } else {
        valid = false;
      }
      break;
    case "tel":
      valid = !!value.match(/^[0-9]*^[()-]*$/) || value === "";
      break;
    case "extension":
      valid = !!value.match(/^\d{1,4}$/) || value === "";
      break;
    case "zip":
      valid = !!value.match(globalPostalTest) || !!value.match(usZipTest);
      break;
    case "website":
      valid = !!value.match(/^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/) || value === "";
      break;
    case "text-length":
      valid = strip(unescape(value)).length <= 50 && strip(unescape(value)).length > 0;
      break;
    case "checkbox-array":
      const checkboxArray = value === "" ? value : JSON.parse(value);
      valid = checkboxArray.length > 0;
      break;
    case "checkbox":
    case "select":
    case "text":
    case "file":
    default:
      if (value.trim().length === 0) {
        valid = false;
      }
  }
  return valid;
};
exports.validateField = validateField;
const validFields = (items, elForm) => {
  let valid = true;
  items.forEach(item => {
    const field = item.querySelector("[aria-required]");
    if (field === null) {
      return;
    }
    const validCheck = field.dataset.type === "checkbox" ? field.checked : validateField(field.dataset.type, field.value);
    if (validCheck) {
      item.classList.remove("has-error");
    } else {
      if (field.getAttribute("readonly") !== null) {
        return;
      } else {
        item.classList.add("has-error");
        valid = false;
      }
    }
  });
  return valid;
};
exports.validFields = validFields;

},{}],245:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _TeacherRegistration = _interopRequireDefault(require("./TeacherRegistration.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const els = document.querySelectorAll(".js-tre-modal-mount");
if (els) {
  els.forEach(el => {
    const TeacherRegistrationData = JSON.parse(el.getAttribute("data-steps"));
    const props = {
      allData: TeacherRegistrationData,
      nextButton: TeacherRegistrationData.NextButton,
      previousButton: TeacherRegistrationData.PreviousButton,
      submitButton: TeacherRegistrationData.SubmitButton,
      currentStep: TeacherRegistrationData.CurrentStep,
      firstStepData: TeacherRegistrationData.FirstStep || null,
      secondStepData: TeacherRegistrationData.SecondStep || null,
      isImpersonation: TeacherRegistrationData.IsImpersonation
    };
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_TeacherRegistration.default, props), el);
  });
}

},{"./TeacherRegistration.jsx":231,"react":"react","react-dom":"react-dom"}],246:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
// Initial state object
const initial = {};

// Reducer function
const r = (prevState, updatedProperty) => ({
  ...prevState,
  ...updatedProperty
});

/**
 * @param  {Object} initialState
 * @param  {Function} reducer
 * @returns {Object, Function, Function} state, setState, clearState
 * example:
 *  const { state, setState, clearState } = useReducedState(defaultState);
 * // setState will add or replace page in context state
 *  setState({page: 1});
 * // clearState resets state to defaults
 * clearState()
 **/
const useReducedState = function () {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
  let reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r;
  const [state, dispatch] = (0, _react.useReducer)(reducer, initialState);
  const setState = (0, _react.useCallback)(newState => dispatch(newState), [dispatch]);
  const clearState = (0, _react.useCallback)(() => dispatch(initialState), [initialState]);
  return {
    state,
    setState,
    clearState
  };
};
var _default = exports.default = useReducedState;

},{"react":"react"}],247:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _WebinarSection = _interopRequireDefault(require("./WebinarSection.jsx"));
var _WebinarSkelaton = _interopRequireDefault(require("./WebinarSkelaton.jsx"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const propTypes = {
  exculdedWebinar: _propTypes.array,
  bookLabel: _propTypes.string,
  joinLabel: _propTypes.string
};
const App = props => {
  const {
    exculdedWebinar,
    bookLabel,
    joinLabel
  } = props;
  const [isLoading, setIsLoading] = (0, _react.useState)(true);
  const [dateSummary, setDateSummary] = (0, _react.useState)("");
  const [name, setName] = (0, _react.useState)("");
  const [taxonomy, setTaxonomy] = (0, _react.useState)("");
  const [thumbnailImageAlt, setThumbnailImageAlt] = (0, _react.useState)("");
  const [thumbnailImageUrl, setThumbnailImageUrl] = (0, _react.useState)("");
  const [topic, setTopic] = (0, _react.useState)("");
  const [buttonCopy, setButtonCopy] = (0, _react.useState)(bookLabel);
  const [buttonUrl, setButtonUrl] = (0, _react.useState)("");
  const [noResult, setNoResult] = (0, _react.useState)(false);
  const setButtonUrlandCopy = (eventLandingUrl, zoomUrl) => {
    if (eventLandingUrl) {
      setButtonUrl(eventLandingUrl);
      setButtonCopy(bookLabel);
    } else {
      setButtonUrl(zoomUrl);
      setButtonCopy(joinLabel);
    }
  };
  (0, _react.useEffect)(() => {
    //owh/pd/GetUpcomingWebinar?excludedTopics=[array of strings]
    fetch("/owh/pd/GetUpcomingWebinar", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        excludedTopics: exculdedWebinar.split(",")
      })
    }).then(response => response.json()).then(data => {
      if (data.success === true && data.result) {
        setDateSummary(data.result.dateSummary);
        setName(data.result.name);
        setTaxonomy(data.result.taxonomy);
        setThumbnailImageAlt(data.result.thumbnailImageAlt);
        setThumbnailImageUrl(data.result.thumbnailImageUrl);
        setTopic(data.result.topic);
        setButtonUrlandCopy(data.result.eventLandingUrl, data.result.zoomUrl);
      } else {
        setNoResult(true);
      }
      setIsLoading(false);
    }).catch(error => {
      setNoResult(true);
      setIsLoading(false);
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    "aria-live": "polite",
    className: "gv__teacher-resource__webinar"
  }, isLoading ? /*#__PURE__*/_react.default.createElement(_WebinarSkelaton.default, null) : noResult ? /*#__PURE__*/_react.default.createElement("p", null, "No Upcoming Webinar") : name && /*#__PURE__*/_react.default.createElement(_WebinarSection.default, {
    dateSummary: dateSummary,
    name: name,
    taxonomy: taxonomy,
    thumbnailImageAlt: thumbnailImageAlt,
    thumbnailImageUrl: thumbnailImageUrl,
    topic: topic,
    buttonUrl: buttonUrl,
    buttonCopy: buttonCopy
  }));
};
var _default = exports.default = App;

},{"./WebinarSection.jsx":248,"./WebinarSkelaton.jsx":249,"classnames":"classnames","prop-types":"prop-types","react":"react"}],248:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propsTypes = {
  dateSummary: _propTypes.string,
  eventLandingUrl: _propTypes.string,
  name: _propTypes.string,
  taxonomy: _propTypes.string,
  thumbnailImageAlt: _propTypes.string,
  thumbnailImageUrl: _propTypes.string,
  topic: _propTypes.string,
  zoomUrl: _propTypes.string,
  buttonUrl: _propTypes.string,
  buttonCopy: _propTypes.string
};
const WebinarSection = props => {
  const {
    dateSummary,
    name,
    taxonomy,
    thumbnailImageAlt,
    thumbnailImageUrl,
    topic,
    buttonUrl,
    buttonCopy
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__content"
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: "gv__teacher-resources__items__item__head"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "gv__teacher-resources__items__item__title"
  }, /*#__PURE__*/_react.default.createElement("span", null, taxonomy)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__material-item-card__interactions"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: buttonUrl,
    className: "gv__teacher-webinar__btn",
    "aria-label": `${buttonCopy} for ${name}`
  }, /*#__PURE__*/_react.default.createElement("span", null, buttonCopy)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__item__body"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__teacher-webinar__topic"
  }, topic, " \u2014 ", name), /*#__PURE__*/_react.default.createElement("p", {
    className: "gv__teacher-webinar__date"
  }, dateSummary)));
};
WebinarSection.propTypes = propsTypes;
var _default = exports.default = WebinarSection;

},{"prop-types":"prop-types","react":"react"}],249:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const WebinarSkelaton = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__content gv__teacher-resources--skelaton-placeholder"
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: "gv__teacher-resources__items__item__head"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "gv__teacher-resources__items__item__title"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gradient"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-resources__items__item__body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-webinar__topic"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gradient"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__teacher-webinar__date"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gradient"
  }))));
};
var _default = exports.default = WebinarSkelaton;

},{"prop-types":"prop-types","react":"react"}],250:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _App = _interopRequireDefault(require("./App.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const elements = document.querySelectorAll(".js-teacher-resource-container");
if (elements) {
  elements.forEach(element => {
    if (!element.querySelector(".js-teacher-webinar")) return;
    const webinarCountainer = element.querySelector(".js-teacher-webinar");
    const mount = webinarCountainer.querySelector(".js-teacher-webinar-mount");
    const exculdedWebinar = webinarCountainer.getAttribute("data-webinar-excluded-topics");
    const bookLabel = webinarCountainer.getAttribute("data-book-label");
    const joinLabel = webinarCountainer.getAttribute("data-join-label");
    const props = {
      exculdedWebinar,
      bookLabel,
      joinLabel
    };
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_App.default, props), mount);
  });
}

},{"./App.jsx":247,"react":"react","react-dom":"react-dom"}],251:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _reactModal = _interopRequireDefault(require("react-modal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TeacherResourceModal = props => {
  const {
    iFrameURL,
    pageTitle,
    triggerButton
  } = props;
  const [isModalOpen, setIsModalOpen] = (0, _react.useState)();
  const openModal = (e, button) => {
    ;
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  triggerButton?.addEventListener("click", e => openModal(e));
  (0, _react.useEffect)(() => {
    openModal();
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: isModalOpen,
    bodyOpenClassName: null,
    overlayClassName: "gv__modal",
    className: "gv__teacher-resources-iframe-modal",
    onRequestClose: closeModal,
    shouldCloseOnOverlayClick: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "gv__teacher-resources-iframe-modal__header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    class: "gv__teacher-resources-iframe-modal__title"
  }, pageTitle), /*#__PURE__*/_react.default.createElement("button", {
    class: "gv__manual-modal-v2__close js-close-manual-modal",
    type: "button",
    onClick: () => closeModal()
  }, /*#__PURE__*/_react.default.createElement("span", null, " Close "), /*#__PURE__*/_react.default.createElement("svg", {
    width: "37",
    height: "37",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 17L17 7M7 7L17 17L7 7Z",
    stroke: "black",
    "stroke-width": "2"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    class: "gv__activity-iframe__container"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    src: `${iFrameURL}?share=embed&iframe=true`
  })));
};
var _default = exports.default = TeacherResourceModal;

},{"prop-types":"prop-types","react":"react","react-modal":"react-modal"}],252:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _TeacherResourceModal = _interopRequireDefault(require("./TeacherResourceModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// var modalAttr;

const triggerButtons = document.querySelectorAll(".js-resource-modal");
const renderShare = e => {
  e.preventDefault();
  e.stopPropagation();
  var button = e.currentTarget;
  const modalId = e.currentTarget.getAttribute("data-tr-modal");
  const modal = document.querySelector(`#${modalId}`);
  const expanded = e.currentTarget.setAttribute("aria-expanded", "true");
  const pageURL = e.currentTarget.getAttribute("data-modal-href");
  const pageTitle = e.currentTarget.getAttribute("data-modal-title");
  const originalModalID = button && button.closest(".gv__teacher-resource__modal") && button.closest(".gv__teacher-resource__modal").getAttribute("id");
  localStorage.setItem("fromOpenedModal", "true");
  localStorage.setItem("modalID", originalModalID);
  window.location = pageURL;

  // var props = {
  //   triggerButton: e.currentTarget,
  //   iFrameURL: pageURL,
  //   pageTitle: pageTitle
  // };

  // render(<TeacherResourceModal {...props} />, modal);
};
triggerButtons.forEach(button => {
  button.addEventListener("click", e => renderShare(e));
});
document.addEventListener("DOMContentLoaded", event => {
  if (localStorage.getItem("returnedFromMaterial") === "true") {
    const openedModalID = localStorage.getItem("modalID");
    document.querySelector(`.${openedModalID}`).click();
    localStorage.setItem("fromOpenedModal", "false");
    localStorage.setItem("modalID", "");
    localStorage.setItem("returnedFromMaterial", "false");
  }
});

},{"./TeacherResourceModal.jsx":251,"react":"react","react-dom":"react-dom"}],253:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toastNotification;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TOAST_COOKIE_NAME = "toast_closed";
const footer = document.querySelector(".gv__global-footer");
const isExperienceEditor = document.body.classList.contains("experience-editor");
const initToastNotification = el => {
  // Check for existing removal listener
  if (window.removeResizeEventListener) {
    window.removeResizeEventListener();
  }
  const resizeEventWrapper = e => {
    updateFooterMargin(el);
  };
  window.addEventListener("resize", resizeEventWrapper);
  window.removeResizeEventListener = () => {
    window.removeEventListener("resize", resizeEventWrapper);
  };
  if (isExperienceEditor) {
    showToastNotification(el);
    return;
  } else if (_jsCookie.default.get(TOAST_COOKIE_NAME)) {
    hideToastNotification(el);
  } else {
    showToastNotification(el);
    const closeButton = el.querySelector(".js-close-toast-notification");
    closeButton.addEventListener("click", e => {
      e.preventDefault();
      hideToastNotification(el);
      setToastCookie(el, closeButton);
    });
  }
};
const removeResize = () => {
  if (window.removeResizeEventListener) window.removeResizeEventListener();
};
const updateFooterMargin = el => {
  if (footer) {
    // Minus 5 here is to account for the extra white space that can appear under the footer.
    footer.style.marginBottom = el.clientHeight - 5 + "px";
  }
};
const showToastNotification = el => {
  el.classList.contains("is-hidden") && el.classList.remove("is-hidden");
  updateFooterMargin(el);
};
const hideToastNotification = el => {
  el.classList.add("is-hidden");
  if (footer && footer.style.marginBottom !== "") {
    footer.style.removeProperty("margin-bottom");
  }
  removeResize();
};
const setToastCookie = (el, closeButton) => {
  const toastId = el.getAttribute("id");
  const tenHours = new Date(new Date().getTime() + 10 * 60 * 60 * 1000);
  _jsCookie.default.set(TOAST_COOKIE_NAME, toastId, {
    expires: tenHours
  });
  closeButton.removeEventListener("click", setToastCookie);
};
function toastNotification() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  if (document.querySelectorAll(".js-toast-notification")) {
    [...document.querySelectorAll(".js-toast-notification")].forEach(initToastNotification);
  }
}

},{"js-cookie":"js-cookie"}],254:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class UnArchivePeriod extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const buttons = document.querySelectorAll(".js-unarchive-class__btn");
      this.setState({
        buttons
      });
      if (buttons) {
        buttons.forEach(button => {
          button.addEventListener("click", this.openModal);
        });
      }
    });
    _defineProperty(this, "componentDidUpdate", prevProps => {
      if (this.props.modalIsOpen !== prevProps.modalIsOpen) {
        this.setState({
          modalIsOpen: this.props.modalIsOpen
        });
      }
      if (this.state.buttons) {
        this.state.buttons.forEach(button => button.setAttribute("aria-expanded", false));
      }
    });
    _defineProperty(this, "unarchivePeriod", e => {
      e.preventDefault();
      const params = {
        periodId: this.props.periodId
      };
      fetch(`${this.props.requestUrl}/owh/period/UnarchivePeriod`, {
        method: "POST",
        body: JSON.stringify(params),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => response.json()).then(data => {
        if (data.Message) {
          location.reload();
          return;
        }
      }).catch(err => {
        console.error(err);
      });
    });
    _defineProperty(this, "openModal", e => {
      this.setState({
        modalIsOpen: true
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      if (this.props.updateParent) {
        this.props.updateParent();
      }
      this.setState({
        modalIsOpen: false
      });
    });
    _defineProperty(this, "afterOpenModal", () => {
      this.modalTitleRef.current.focus();
    });
    this.state = {
      buttons: null,
      modalIsOpen: props.modalIsOpen || false,
      isLoading: false,
      generalError: {
        error: false,
        errorMsg: ""
      }
    };
    this.modalTitleRef = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    const {
      dictionary
    } = this.props;
    const {
      generalError
    } = this.state;
    const {
      archivePeriodTitle,
      archivePeriodSubtitle,
      archivePeriodCancelLabel,
      archivePeriodButtonLabel
    } = dictionary;
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: "gv__modal__content"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__delete-modal"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      tabIndex: "-1",
      ref: this.modalTitleRef,
      className: "gv__delete-modal__title gv__page-title"
    }, archivePeriodTitle), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__delete-modal__subtitle",
      dangerouslySetInnerHTML: {
        __html: archivePeriodSubtitle
      }
    }), /*#__PURE__*/_react.default.createElement("form", {
      onSubmit: e => this.unarchivePeriod(e)
    }, generalError.error && /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__form__error-msg gv__form__error-msg--general has-error"
    }, generalError.errorMsg), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__delete-modal__button-row gv__button-row"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__button gv__button--secondary"
    }, archivePeriodCancelLabel), /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "gv__button"
    }, archivePeriodButtonLabel)))));
  }
}
exports.default = UnArchivePeriod;
_defineProperty(UnArchivePeriod, "propTypes", {
  periodId: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  requestUrl: _propTypes.string,
  dictionary: (0, _propTypes.shape)({
    archivePeriodTitle: _propTypes.string,
    archivePeriodSubtitle: _propTypes.string,
    archivePeriodCancelLabel: _propTypes.string,
    archivePeriodButtonLabel: _propTypes.string
  }),
  modalIsOpen: _propTypes.bool,
  updateParent: _propTypes.func
});

},{"prop-types":"prop-types","react":"react","react-modal":"react-modal"}],255:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _UnArchivePeriodModal = _interopRequireDefault(require("./UnArchivePeriodModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-unarchive-period-mount");
if (el) {
  const props = {
    requestUrl: el.dataset.requestUrl || "",
    periodId: el.dataset.periodId || "",
    dictionary: JSON.parse(el.dataset.dictionary) || ""
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_UnArchivePeriodModal.default, props), el);
}

},{"./UnArchivePeriodModal.jsx":254,"react":"react","react-dom":"react-dom"}],256:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lessonNavigation;
function lessonNavigation() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  const links = document.querySelectorAll(".js-in-page-unit-nav-link");
  const isCoursePage = document.querySelector("#gv__main").classList.contains('gv__base-template--course-detail-3');
  const urlPath = location.pathname;
  const unitDropdownText = document.querySelector(".js-current-unit-text ");
  const unitDropdownName = unitDropdownText?.querySelector(".js-in-page-unit-name");
  const unitDropdownOrientation = unitDropdownText?.querySelector(".js-in-page-unit-orientation");

  //js-in-page-unit-name

  [...links].forEach((link, index) => {
    if (link.getAttribute("href") === urlPath) {
      link.classList.add("is-active");
    }
  });
}

},{}],257:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
require("regenerator-runtime/runtime");
var _RegisterLinkIcon = _interopRequireDefault(require("../partials/RegisterLinkIcon.jsx"));
var _UpcomingEventsCard = _interopRequireDefault(require("../partials/UpcomingEventsCard.jsx"));
var _fakeEvents = _interopRequireDefault(require("./fake-events.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const propTypes = {
  events: (0, _propTypes.shape)({
    suggestedEventsText: _propTypes.string,
    allEventsLinkText: _propTypes.string,
    allEventsLinkUrl: _propTypes.string,
    courseBoost: _propTypes.string,
    segmentBoost: _propTypes.string,
    endpoint: _propTypes.string,
    pdTabId: _propTypes.string
  }),
  isPatternlab: _propTypes.bool
};
const UpcomingEvents = props => {
  const {
    events,
    isPatternlab
  } = props;
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [upcomingEventData, setUpcomingEventData] = (0, _react.useState)([]);
  const {
    suggestedEventsText,
    allEventsLinkText,
    allEventsLinkUrl,
    courseBoost,
    segmentBoost,
    endpoint,
    pdTabId
  } = events;
  (0, _react.useEffect)(() => {
    if (isPatternlab) {
      setUpcomingEventData(_fakeEvents.default.events);
      return;
    }
    const url = `${endpoint}?courseBoost=${courseBoost}&segmentBoost=${segmentBoost}`;
    const fetchData = async url => {
      setIsLoading(true);
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json"
          }
        });
        if (!response.ok) {
          throw new Error(`Error! status: ${response.status}`);
        }
        const result = await response.json();
        setUpcomingEventData(result.result);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
        setIsLoading(false);
      }
    };
    const tab = document.getElementById(pdTabId);
    tab.addEventListener("click", () => {
      fetchData(url);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events gv__component"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__container gv__upcoming-events__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__heading"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__upcoming-events__heading-title"
  }, suggestedEventsText), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__upcoming-events__heading-event-count"
  }, `(${upcomingEventData.length})` || 0)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__listing-container"
  }, upcomingEventData.length ? upcomingEventData.map((listing, i) => {
    return /*#__PURE__*/_react.default.createElement(_UpcomingEventsCard.default, _extends({
      key: i
    }, listing));
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__upcoming-events__no-events"
  }, "No upcoming events")), allEventsLinkUrl && allEventsLinkText && /*#__PURE__*/_react.default.createElement("a", {
    href: allEventsLinkUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "gv__upcoming-events__listing-cta"
  }, /*#__PURE__*/_react.default.createElement("span", null, allEventsLinkText), /*#__PURE__*/_react.default.createElement(_RegisterLinkIcon.default, null))));
};
UpcomingEvents.propTypes = propTypes;
var _default = exports.default = UpcomingEvents;

},{"../partials/RegisterLinkIcon.jsx":140,"../partials/UpcomingEventsCard.jsx":141,"./fake-events.json":258,"prop-types":"prop-types","react":"react","regenerator-runtime/runtime":"regenerator-runtime/runtime"}],258:[function(require,module,exports){
module.exports={
  "events": [
    {
      "dateSummary": "Nov 1 to Nov 5",
      "endDate": "2022-11-05T17:30:00",
      "eventLandingUrl": null,
      "name": "Test Event",
      "redirectUrl": "",
      "redirectUrlText": "",
      "registerLink": "",
      "registerLinkText": "",
      "shortDescription": "",
      "startDate": "2022-11-01T12:40:00",
      "telligentId": "447788",
      "courses": ["1750 to the Present", "World History AP"],
      "timeZone": null,
      "eventTopic": "World History Project AP"
    },
    {
      "dateSummary": "3 Aug 2021 12:00 PM to 5 Aug 2021 2:00 PM",
      "endDate": "2023-01-12T15:00:00Z",
      "eventLandingUrl": null,
      "name": "OC For Social Studies 2021",
      "redirectUrl": "https://dev-community.oerproject.com/oc-for-social-studies/oc-for-social-studies-2021/w/registration-confirmation",
      "redirectUrlText": "",
      "registerLink": "http://google.com",
      "registerLinkText": "Register Link",
      "shortDescription": "",
      "startDate": "2023-01-10T13:00:00Z",
      "telligentId": "22",
      "courses": ["Project Score Add Extra Text for GVOS-2097"],
      "timeZone": "Eastern Time",
      "eventTopic": ""
    },
    {
      "dateSummary": "Date Summary",
      "endDate": "2022-12-01T21:44:00Z",
      "eventLandingUrl": null,
      "name": "QA Event Test for PD",
      "redirectUrl": "https://www.google.com/",
      "redirectUrlText": "Event Redirect URL",
      "registerLink": "https://www.google.com/",
      "registerLinkText": "Event Register Link",
      "shortDescription": "Lorem ipsum. Lorem ipsum. Lorem ipsum. Lorem ipsum. Lorem ipsum. <strong>Add extra text</strong> to verify height of event items.",
      "startDate": "2022-11-28T20:11:00Z",
      "telligentId": "22",
      "courses": ["Big History"],
      "timeZone": "Eastern Time",
      "eventTopic": "State Conference"
    }
  ]
}

},{}],259:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _UpcomingEvents = _interopRequireDefault(require("./UpcomingEvents.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-upcoming-events-mount");
if (el) {
  const props = {
    events: JSON.parse(el.dataset.events) || {},
    isPatternlab: el.dataset.isPatternlab ? JSON.parse(el.dataset.isPatternlab) : false
  };
  (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_UpcomingEvents.default, props), el);
}

},{"./UpcomingEvents.jsx":257,"react":"react","react-dom":"react-dom"}],260:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _urijs = _interopRequireDefault(require("urijs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const URI_VARIABLE = new _urijs.default(window.location);
const updateQueryString = el => {
  const searchQuery = el.dataset.query;
  const assignmentId = el.dataset.assignmentId;
  const updateQuery = URI_VARIABLE.setQuery(searchQuery, assignmentId);
  const newUrl = _urijs.default.decode(updateQuery.toString());
  history.replaceState(null, null, newUrl);
};
const initUpdateUrl = el => {
  el.addEventListener("click", () => updateQueryString(el));
};
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-assignment-update")].forEach(initUpdateUrl);
}

},{"urijs":"urijs"}],261:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _react = require("react");
function _default(_ref) {
  let {
    containerRef,
    onClose,
    isVisible,
    closeAll,
    activeTab,
    tabIndex,
    recheckLinks
  } = _ref;
  const [tabbedIndex, setTabbedIndex] = (0, _react.useState)(0); // key tab handlers
  const [tabNavIndex, setTabNavIndex] = (0, _react.useState)(0); // navigation tabs handlers
  const wasOpen = usePrevious(isVisible);
  const [allNavItems, setAllNavItems] = (0, _react.useState)([]);
  const [allNavTabs, setAllNavTabs] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    // If menu was just opened, reset tabbed index
    // Update items to tab through
    if (!wasOpen && isVisible && containerRef.current) {
      const navTabs = containerRef.current.querySelectorAll(".gv__primary-nav__tab");
      const navItems = containerRef.current.querySelectorAll("a, button");
      setAllNavItems(navItems);
      setAllNavTabs(navTabs);
      setTabbedIndex(0);
      setTabNavIndex(0);
    }
  }, [wasOpen, isVisible, containerRef]);
  (0, _react.useEffect)(() => {
    if (activeTab && containerRef.current) {
      const navItems = containerRef.current.querySelectorAll("a, button");
      setAllNavItems(navItems);
      setTabbedIndex(tabIndex);
    }
  }, [activeTab, containerRef, tabIndex]);
  (0, _react.useEffect)(() => {
    if (recheckLinks && containerRef.current) {
      const navItems = containerRef.current.querySelectorAll("a, button");
      setAllNavItems(navItems);
    }
  }, [containerRef, recheckLinks]);
  (0, _react.useEffect)(() => {
    if (allNavItems[tabbedIndex] && isVisible) {
      allNavItems[tabbedIndex].focus();
    }
  }, [allNavItems, isVisible, tabbedIndex]);
  (0, _react.useEffect)(() => {
    if (allNavTabs[tabNavIndex] && isVisible) {
      allNavTabs[tabNavIndex].focus();
    }
  }, [allNavTabs, isVisible, tabNavIndex]);
  const nextNavTab = () => {
    setTabNavIndex((tabNavIndex + 1) % allNavTabs.length);
  };

  // const prevNavTab = () => {
  //   setTabNavIndex((allNavTabs.length + tabNavIndex - 1) % allNavTabs.length);
  // };

  const nextTab = () => {
    setTabbedIndex((tabbedIndex + 1) % allNavItems.length);
  };
  const prevTab = () => {
    setTabbedIndex((allNavItems.length + tabbedIndex - 1) % allNavItems.length);
  };
  const handleMobileKeydown = e => {
    if (!isVisible) {
      return;
    }
    e.preventDefault();
    const activeEl = document.activeElement;
    switch (e.key) {
      case " ":
      case "Enter":
        activeEl.click();
        break;
      case "Escape":
        closeAll();
        break;
      case "ArrowDown":
        nextTab();
        break;
      case "ArrowUp":
        prevTab();
        break;
      case "ArrowLeft":
        if (activeEl.classList.contains("gv__primary-nav__tab")) {
          nextNavTab();
        } else if (onClose) {
          onClose();
        }
        break;
      case "ArrowRight":
        if (activeEl.classList.contains("js-has-submenu")) {
          activeEl.click(); // open next nav item
        }
        if (activeEl.classList.contains("gv__primary-nav__tab")) {
          nextNavTab();
        }
        break;
      case "Tab":
        if (e.shiftKey) {
          if (tabbedIndex === 0) {
            closeAll();
          } else {
            prevTab();
          }
        } else {
          if (tabbedIndex < allNavItems.length - 1) {
            nextTab();
          } else {
            // closeAll();
            allNavItems[0].focus();
            setTabbedIndex(0);
          }
        }
        break;
    }
  };
  return handleMobileKeydown;
}

// https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
function usePrevious(value) {
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}

},{"react":"react"}],262:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationListeners = exports.validateField = exports.validFields = exports.strip = exports.setDefaults = exports.resetDefaults = exports.postFormData = exports.matchfields = exports.isFormReady = exports.handleSubmit = exports.forceValidationClean = exports.forceValidation = exports.checkIfDirty = void 0;
const strip = html => {
  var doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};
exports.strip = strip;
const checkIfDirty = field => {
  if (field.dataset.isDirty === "true") {
    if (field.value === field.dataset.originalValue) {
      field.dataset.isDirty = "false";
    }
  } else {
    if (field.value !== field.dataset.originalValue) {
      field.dataset.isDirty = "true";
    }
  }
  return field.dataset.isDirty;
};

// takes in a field items
// returns true or false
// adds error class to invalid fields
exports.checkIfDirty = checkIfDirty;
const validateField = (type, value, value2) => {
  let valid = true;
  const passwordStrengthTest = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^*])(?=.{8,20})(?!.*[<&])");
  const globalPostalTest = new RegExp(/^(?!-$)[a-z0-9]+[ -]?[a-z0-9]*$/i);
  const usZipTest = new RegExp("^\\d{5}$");
  switch (type) {
    case "email":
      valid = !!value.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+/i);
      break;
    case "password":
      // more than eight characters, less than 20
      // contains digits
      // contains lower case alpha
      // contains upper case alpha
      // contains special characters
      // does not contain white space

      valid = passwordStrengthTest.test(value);
      break;
    case "new-password":
      //valid password that doesnt match other password
      const passwordFields = [value, value2];

      //only return true when there are 2 new password fields
      if (passwordFields.length > 1 && passwordFields.length < 3) {
        /*
              //if password fields are blank or
              //bothfields pass regex and are not
              //equal the new passwords are valid
              */

        const isBlank = passwordFields.reduce((a, b) => a + b) === "";
        const Eq = passwordFields[0] === passwordFields[1] && passwordStrengthTest.test(passwordFields[0]) && passwordStrengthTest.test(passwordFields[1]);
        valid = isBlank ? isBlank : Eq;
      } else {
        valid = false;
      }
      break;
    case "tel":
      valid = !!value.match(/^[0-9]*^[()-]*$/) || value === "";
      break;
    case "extension":
      valid = !!value.match(/^\d{1,4}$/) || value === "";
      break;
    case "zip":
      valid = !!value.match(globalPostalTest) || !!value.match(usZipTest);
      break;
    case "zip-us":
      valid = !!value.match(usZipTest);
      break;
    case "website":
      valid = !!value.match(/^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/) || value === "";
      break;
    case "text-length":
      valid = strip(unescape(value)).length <= 50 && strip(unescape(value)).length > 0;
      break;
    case "recaptcha":
      var response = grecaptcha.getResponse();
      if (response.length > 0) {
        valid = true;
      } else {
        valid = false;
      }
      break;
    case "checkbox":
    case "select":
    case "text":
    case "file":
    default:
      if (value.trim().length === 0) {
        valid = false;
      }
  }
  return valid;
};
exports.validateField = validateField;
const handleSubmit = (elForm, handleSuccess, handleError) => {
  const url = elForm.getAttribute("data-post-url") || elForm.getAttribute("action");
  if (elForm.classList.contains('js-newsletter-form')) {
    [...elForm.querySelectorAll(".has-error")].forEach(el => {
      el.querySelector(".gv__form__error-msg") && el.querySelector(".gv__form__error-msg").removeAttribute("role", "alert");
    });
    [...elForm.querySelectorAll(".js-form-general-error")].forEach(el => {
      el.classList.remove("has-error");
      el.removeAttribute("role");
    });
    [...elForm.querySelectorAll("[aria-required]")].forEach(el => {
      el.setAttribute("aria-invalid", false);
    });
    if (validFields([...elForm.querySelectorAll(".js-form-required")], elForm)) {
      return true;
    } else {
      elForm.querySelectorAll(".has-error")[0].querySelector("input, select").focus();
      elForm.querySelectorAll(".has-error")[0].querySelector(".gv__form__error-msg").setAttribute("role", "alert");
      [...elForm.querySelectorAll(".has-error")].forEach((el, index) => {
        const errorId = el.querySelector(".gv__form__error-msg").getAttribute("id");
        const input = el.querySelector(".gv__form__field");
        input.removeAttribute("aria-describedby");
        const inputLabels = input.getAttribute("aria-labelledby") ? el.querySelector(".gv__form__field").getAttribute("aria-labelledby") : "";
        const newLabel = inputLabels.concat(" ", errorId);
        el.querySelector(".gv__form__error-msg").setAttribute("role", "alert");
        input.setAttribute("aria-labelledby", newLabel);
        if (index > 0) {
          el.querySelector(".gv__form__error-msg").removeAttribute("role");
        }
      });
      [...elForm.querySelectorAll("[aria-required]")].forEach(el => {
        el.setAttribute("aria-invalid", true);
      });
      return false;
    }
  } else {
    elForm.addEventListener("submit", e => {
      e.preventDefault();
      [...elForm.querySelectorAll(".has-error")].forEach(el => {
        el.querySelector(".gv__form__error-msg") && el.querySelector(".gv__form__error-msg").removeAttribute("role", "alert");
      });
      [...elForm.querySelectorAll(".js-form-general-error")].forEach(el => {
        el.classList.remove("has-error");
        el.removeAttribute("role");
      });
      [...elForm.querySelectorAll("[aria-required]")].forEach(el => {
        el.setAttribute("aria-invalid", false);
      });
      if (validFields([...elForm.querySelectorAll(".js-form-required")], elForm)) {
        if (elForm.getAttribute("method").toLowerCase() === "get") {
          elForm.submit();
          window.showLoadingOverlay();
        } else {
          [...elForm.querySelectorAll("button[type=submit]")].forEach(el => {
            el.classList.add("is-loading");
            el.setAttribute("disabled", true);
          });
          postFormData(url, handleSuccess, handleError, elForm);
        }
      } else {
        elForm.querySelectorAll(".has-error")[0].querySelector("input, select").focus();
        elForm.querySelectorAll(".has-error")[0].querySelector(".gv__form__error-msg").setAttribute("role", "alert");
        [...elForm.querySelectorAll(".has-error")].forEach((el, index) => {
          const errorId = el.querySelector(".gv__form__error-msg").getAttribute("id");
          const input = el.querySelector(".gv__form__field");
          input.removeAttribute("aria-describedby");
          const inputLabels = input.getAttribute("aria-labelledby") ? el.querySelector(".gv__form__field").getAttribute("aria-labelledby") : "";
          const newLabel = inputLabels.concat(" ", errorId);
          el.querySelector(".gv__form__error-msg").setAttribute("role", "alert");
          input.setAttribute("aria-labelledby", newLabel);
          if (index > 0) {
            el.querySelector(".gv__form__error-msg").removeAttribute("role");
          }
        });
        [...elForm.querySelectorAll("[aria-required]")].forEach(el => {
          el.setAttribute("aria-invalid", true);
        });
      }
    });
  }
};
exports.handleSubmit = handleSubmit;
const matchfields = (elForm, items) => {
  let valid = true;
  const submitButtons = elForm.querySelectorAll("button[type=submit]");
  items.forEach(item => {
    const field = item.querySelector("[aria-required]");
    const field2Match = elForm.querySelector(`[name=${field.dataset.match}]`);
    if (field === null) {
      return;
    }
    if (field2Match && field2Match.value !== field.value) {
      item.classList.add("has-error");
      valid = false;
    } else {
      item.classList.remove("has-error");
    }

    // check form status and handle submit buttons
    if (isFormReady(elForm)) {
      submitButtons.forEach(el => {
        el.removeAttribute("disabled");
      });
    }
  });
  return valid;
};

// // takes in a node array of field items
// // returns true or false
exports.matchfields = matchfields;
const validFields = (items, elForm) => {
  let valid = true;
  items.forEach(item => {
    const field = item.querySelector("[aria-required]");
    if (field === null) {
      return;
    }
    const validCheck = field.dataset.type === "checkbox" ? field.checked : validateField(field.dataset.type, field.value);
    if (validCheck) {
      item.classList.remove("has-error");
    } else {
      if (field.getAttribute("readonly") !== null) {
        return;
      } else {
        item.classList.add("has-error");
        valid = false;
      }
    }
  });
  return valid;
};

/**
 * Checks if a form is ready to be submitted by having no validation errors
 * and having some dirty fields on it
 */
exports.validFields = validFields;
const isFormReady = elForm => {
  if (elForm.querySelectorAll(".has-error").length === 0 && elForm.querySelectorAll('[data-is-dirty="true"]').length !== 0) {
    return true;
  }
  return false;
};

//stripped down submit handler taken from thread/forms/forms.js
//takes form el, action url, and success and error handler fns
exports.isFormReady = isFormReady;
const postFormData = (url, handleSuccess, handleError, elForm) => {
  window.showLoadingOverlay();
  const reEnableFormSubmitButtons = () => {
    [...elForm.querySelectorAll("button[type=submit]")].forEach(el => {
      el.classList.remove("is-loading");
      el.removeAttribute("disabled");
    });
  };
  const params = new FormData(elForm);
  for (let pair of params.entries()) {
    if (typeof pair[1] === "string") {
      params.set(pair[0], pair[1].trim());
    }
  }
  fetch(url, {
    body: params,
    credentials: "same-origin",
    method: "post"
  }).then(response => response.json()).then(data => {
    if (data.IsValid) {
      if (data.IsLoginForm) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer = window.dataLayer.filter(x => !x.loggedInStatus);
        window.dataLayer.push({
          event: "sign_in",
          loggedInStatus: "Yes"
        });
        if (data.RedirectUrl) {
          window.location.href = data.RedirectUrl;
        }
      } else if (data.RedirectUrl) {
        window.location.href = data.RedirectUrl;
      } else {
        window.hideLoadingOverlay();
        reEnableFormSubmitButtons();
        handleSuccess();
      }
    } else {
      window.hideLoadingOverlay();
      reEnableFormSubmitButtons();
      elForm.querySelectorAll(".js-form-general-error").forEach(el => {
        handleError();
        // adding a message blink
        el.textContent = "";
        setTimeout(() => {
          const errors = data.Errors.join(" ");
          if (data.IsRichText) {
            el.innerHTML = errors;
          } else {
            el.textContent = errors;
          }
          el.setAttribute("role", "alert");
        }, 300);
      });
    }
  }).catch(err => {
    window.hideLoadingOverlay();
    reEnableFormSubmitButtons();
    handleError();
  });
};
exports.postFormData = postFormData;
const setDefaults = elForm => {
  elForm.querySelectorAll("input:not([type=submit]), textarea, select")
  //create dataset for form fields
  .forEach(field => {
    field.dataset.isDirty = false;
    if (field.type === "checkbox" || field.type === "radio") {
      field.dataset.checked = field.checked;
    } else if (field.type === "file" && elForm.querySelector(`img[data-preview="${field.id}"]`)) {
      field.dataset.originalValue = elForm.querySelector(`img[data-preview="${field.id}"]`).getAttribute("src");
    } else {
      field.dataset.originalValue = field.value;
    }
  });
};
exports.setDefaults = setDefaults;
const resetDefaults = elForm => {
  elForm.querySelectorAll("input:not([type=submit]), textarea, select").forEach(field => {
    field.dataset.isDirty = false;
    if (field.type === "checkbox" || field.type === "radio") {
      if (field.dataset.checked === "true") {
        field.checked = true;
      } else {
        field.checked = false;
      }
    } else if (field.type === "file" && elForm.querySelector(`img[data-preview="${field.id}"]`)) {
      elForm.querySelector(`img[data-preview="${field.id}"]`).setAttribute("src", field.dataset.originalValue);
    } else {
      field.value = field.dataset.originalValue;
    }
  });
};
exports.resetDefaults = resetDefaults;
const forceValidation = (field, elForm) => {
  const submitButtons = elForm.querySelectorAll("button[type=submit]");
  const label = field.closest(".gv__form__item ");
  if (checkIfDirty(field)) {
    if (validateField(field.dataset.type, field.value)) {
      label.classList.remove("has-error");
      return true;
    } else {
      label.classList.add("has-error");
      return false;
    }
  }
};

/*
Same as function above to check a validation if a form needs to when it hasn't been updated
This will be removed when 2729/2730 is released
*/
exports.forceValidation = forceValidation;
const forceValidationClean = (field, elForm) => {
  const submitButtons = elForm.querySelectorAll("button[type=submit]");
  const label = field.closest(".gv__form__item ");
  if (validateField(field.dataset.type, field.value)) {
    label.classList.remove("has-error");
    return true;
  } else {
    label.classList.add("has-error");
    return false;
  }
};
exports.forceValidationClean = forceValidationClean;
const validationListeners = (item, elForm) => {
  const field = item.querySelector("[aria-required]");
  const errorId = item.querySelector(".gv__form__error-msg").getAttribute("id");
  if (field === null) {
    return;
  }
  if (field.dataset.type === "select") {
    field.addEventListener("change", e => {
      if (checkIfDirty(field)) {
        if (validateField(field.dataset.type, field.value)) {
          item.classList.remove("has-error");
          field.removeAttribute("aria-describedby");
        } else {
          item.classList.add("has-error");
          field.setAttribute("aria-describedby", errorId);
        }
      }
    });
  } else if (field.dataset.type === "checkbox") {
    field.addEventListener("change", e => {
      if (checkIfDirty(field)) {
        if (field.checked) {
          item.classList.remove("has-error");
          field.removeAttribute("aria-describedby");
        } else {
          item.classList.add("has-error");
          field.setAttribute("aria-describedby", errorId);
        }
      }
    });
  } else if (field.dataset.type === "checkbox-array") {
    field.addEventListener("change", e => {
      if (checkIfDirty(field)) {
        if (field.value !== "[]") {
          item.classList.remove("has-error");
          field.removeAttribute("aria-describedby");
        } else {
          item.classList.add("has-error");
          field.setAttribute("aria-describedby", errorId);
        }
      }
    });
  } else {
    field.addEventListener("keyup", e => {
      if (field.getAttribute("data-type") !== "new-password") {
        if (field.dataset.isDirty === "true") {
          [...elForm.querySelectorAll(".js-form-general-error")].forEach(el => {
            el.classList.remove("has-error");
            el.removeAttribute("role");
            field.setAttribute("aria-describedby", errorId);
            item.querySelector(".gv__form__error-msg").removeAttribute("role");
          });
          if (validateField(field.dataset.type, field.value)) {
            item.classList.remove("has-error");
            field.removeAttribute("aria-describedby");
          } else {
            item.classList.add("has-error");
            field.removeAttribute("aria-describedby");
            item.querySelector(".gv__form__error-msg").setAttribute("role", "alert");
          }
        }
      }
    });
    field.addEventListener("blur", e => {
      if (field.getAttribute("data-type") !== "new-password") {
        if (validateField(field.dataset.type, field.value)) {
          item.classList.remove("has-error");
          field.removeAttribute("aria-describedby");
          field.setAttribute("aria-invalid", false);
          item.querySelector(".gv__form__error-msg").removeAttribute("role");
          if (item.classList.contains("has-error-conditional")) {
            item.classList.remove("has-error-conditional");
            item.querySelector(".gv__form__error-msg-conditional").removeAttribute("role");
          }
        } else {
          if (e.target.value.length > 0 && checkIfDirty(field)) {
            item.classList.add("has-error");
            field.setAttribute("aria-describedby", errorId);
            field.setAttribute("aria-invalid", true);
            item.querySelector(".gv__form__error-msg").setAttribute("role", "alert");
          } else {
            item.classList.remove("has-error-conditional");
            field.removeAttribute("aria-describedby");
            item.querySelector(".gv__form__error-msg-conditional").removeAttribute("role");
          }
        }
      }
    });
    field.addEventListener("input", e => {
      if (elForm.classList.contains("has-submitted")) {
        elForm.classList.remove("has-submitted");
        [...elForm.querySelectorAll("button[type=submit]")].forEach(el => {
          el.classList.remove("is-loading");
          el.removeAttribute("disabled");
        });
        elForm.querySelectorAll(".js-form-general-success").forEach(el => {
          el.classList.remove("is-visible");
        });
      }
    });
    field.addEventListener("focus", e => {
      if (field.getAttribute("data-type") !== "new-password" && field.dataset.isDirty === "false") {
        if (field.getAttribute("readonly") !== null && field.value.length === 0) {
          item.classList.add("has-error-conditional");
          field.removeAttribute("aria-describedby");
          item.querySelector(".gv__form__error-msg-conditional").setAttribute("role", "alert");
        }
      }
    });
  }
};
exports.validationListeners = validationListeners;

},{}],263:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.initAccordion = void 0;
const initAccordion = (el, i) => {
  const editorView = document.querySelector("body.experience-editor");
  const link = el.querySelector(".js-accordion-link");
  const contentWrapper = el.querySelector(".js-accordion-content-wrapper");
  const content = el.querySelector(".js-accordion-content");
  const copyButton = el.querySelector(".js-copy-accordion-text");
  // JSON.parse to convert string to bool and prevent breaking
  let expanded = link.getAttribute("aria-expanded") ? JSON.parse(link.getAttribute("aria-expanded")) : false;
  let contentBuffer = setTimeout(() => {}, 1);
  if (el.classList.contains("is-open") || editorView) {
    expanded = true;
    toggleContent(expanded);
  }
  link.setAttribute("aria-expanded", expanded);
  link.setAttribute("id", `accordion-link-${i}`);
  link.setAttribute("aria-controls", `accordion-content-${i}`);
  contentWrapper.setAttribute("id", `accordion-content-${i}`);
  contentWrapper.setAttribute("aria-labelledby", `accordion-link-${i}`);
  if (editorView === null) {
    link.addEventListener("click", e => {
      e.preventDefault();
      expanded = !expanded;
      toggleContent(expanded);
    });
  }
  function toggleContent(expanded) {
    const height = content.scrollHeight;
    link.setAttribute("aria-expanded", expanded);
    clearTimeout(contentBuffer);
    if (expanded) {
      copyButton?.removeAttribute("disabled");
      el.classList.add("is-open");
      contentWrapper.setAttribute("style", `height:${height}px`);
      contentBuffer = setTimeout(() => {
        contentWrapper.setAttribute("style", "height: auto");
      }, 600);
    } else {
      copyButton?.setAttribute("disabled", "true");
      el.classList.remove("is-open");
      contentWrapper.setAttribute("style", `height:${height}px`);
      setTimeout(() => {
        contentWrapper.setAttribute("style", "height: 0");
      }, 20);
    }
  }
};
exports.initAccordion = initAccordion;
function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  [...document.querySelectorAll(".js-video-key-ideas-accordion")].forEach(initAccordion);
}

},{}],264:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = require("prop-types");
var _video = require("../video.js");
var _classnames = _interopRequireDefault(require("classnames"));
var _ConditionalWrapper = _interopRequireDefault(require("../partials/ConditionalWrapper.jsx"));
var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
document.querySelector(".js-video-promo__modal-mount") && _reactModal.default.setAppElement(".js-video-promo__modal-mount");
class VideoModal extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const modalTriggers = document.querySelectorAll(".js-video-promo__modal");
      [...modalTriggers].forEach(trigger => trigger.addEventListener("click", e => this.getModalInfo(e)));
      document.addEventListener("keyup", this.listenForEscape);
    });
    _defineProperty(this, "componentWillUnmount", () => {
      document.removeEventListener("keyup", this.listenForEscape);
    });
    _defineProperty(this, "componentDidUpdate", () => {});
    _defineProperty(this, "getModalInfo", e => {
      const dataSource = e.currentTarget.dataset.primaryVideo ? e.currentTarget : e.currentTarget.closest("[data-primary-video]");
      const primaryVideo = dataSource.dataset.primaryVideo;
      const secondaryVideo = dataSource.dataset.secondaryVideo;
      const videoTitle = dataSource.dataset.videoTitle;
      const subtitles = dataSource.dataset.videoSubtitles ? JSON.parse(dataSource.dataset.videoSubtitles).subtitles : [];
      const preload = dataSource.dataset.videoPreload;
      const poster = dataSource.dataset.videoPoster;
      const cuepoints = dataSource.dataset.videoCuepoints ? JSON.parse(dataSource.dataset.videoCuepoints).cuepoints : [];
      const videoGuid = dataSource.dataset.videoGuid;
      const trackVideo = dataSource.dataset.trackVideo;
      // TODO: add this attribute to mount 
      const placementType = dataSource.dataset.placementType;
      this.setState({
        primaryVideo: primaryVideo,
        secondaryVideo: secondaryVideo,
        videoTitle: videoTitle,
        subtitles: subtitles,
        preload: preload,
        poster: poster,
        currentTrigger: e.currentTarget,
        cuepoints: cuepoints,
        videoGuid: videoGuid,
        trackVideo: trackVideo,
        placementType: placementType
      });
      this.openModal(e);
    });
    _defineProperty(this, "handleCheck", e => {
      const checked = this.state.checked;
      this.setState({
        checked: !checked
      });
    });
    _defineProperty(this, "closeCards", () => {
      const ariaFlyout = document.querySelectorAll(".js-gv__material-card__flyout");
      const hasFlyout = document.querySelectorAll(".content-is-open");
      const hasCardOpen = document.querySelectorAll(".card-is-open");
      if (hasFlyout.length > 0) {
        [...hasFlyout].forEach(flyout => flyout.classList.remove("content-is-open"));
      }
      if (hasCardOpen.length > 0) {
        [...hasCardOpen].forEach(card => card.classList.remove("card-is-open"));
      }
      if (ariaFlyout.length > 0) {
        [...ariaFlyout].forEach(flyout => {
          if (flyout.getAttribute("aria-hidden") === "false") {
            flyout.setAttribute("aria-hidden", true);
          }
        });
      }
    });
    _defineProperty(this, "openModal", e => {
      this.closeCards();
      this.setState({
        modalIsOpen: true
      });
      e.target.setAttribute("aria-expanded", true);
    });
    _defineProperty(this, "closeModal", () => {
      this.state.player && this.state.player.destroy();
      this.setState({
        modalIsOpen: false,
        primaryVideo: null,
        secondaryVideo: null,
        player: null
      });
      this.state.currentTrigger && this.state.currentTrigger.focus();
      //change the state of the "pause at key ideas"
      this.handleCheck();
    });
    _defineProperty(this, "afterOpenModal", () => {
      const mount = document.querySelectorAll(".gv__modal__content .js-video-viewer__mount--modal")[0];
      let focusBuffer = setTimeout(() => {}, 1);
      let player;
      const flowplayerObj = {
        token: "eyJraWQiOiJuVVJHSncwNjFzUlkiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6NCxcImlkXCI6XCJuVVJHSncwNjFzUllcIn0iLCJpc3MiOiJGbG93cGxheWVyIn0.Q0ETTfgixa1OKG0QPGFkzXj7nxbwvtbwt1fdBZCf1fM5vGMP_jgBH3p5NuTuvCZnwFWvBUBEUeeLAuyqtohYEQ",
        src: this.state.primaryVideo,
        hls: {},
        autoplay: true,
        poster: this.state.poster
      };
      if (!this.state.poster) {
        flowplayerObj.preload = this.state.preload;
      }
      if (this.state.subtitles.length > 0) {
        flowplayerObj.subtitles = {
          tracks: this.state.subtitles
        };
      }
      if (this.state.cuepoints.length > 0) {
        flowplayerObj.cuepoints = this.state.cuepoints;
        flowplayerObj.draw_cuepoints = true;
      }
      player = flowplayer(".js-video-viewer__mount--modal", flowplayerObj);
      //flowplayer automatically adds these and won't remove them unless the user re-orients their device
      player.removeAttribute("playsinline");
      player.removeAttribute("webkit-playsinline");
      this.setState({
        player: player
      });
      player.addEventListener("loadeddata", function () {
        clearTimeout(focusBuffer);
        focusBuffer = setTimeout(() => {
          if (mount.querySelectorAll(".fp-btns svg")[0]) {
            mount.querySelectorAll(".fp-btns svg")[0].focus();
          }
        }, 500);
      });
      if (this.state.cuepoints.length > 0) {
        (0, _video.cuepointLogic)(player, mount);
      }

      // Adobe Omniture tracking
      const videostarted = () => {
        VideoMetrics !== undefined && VideoMetrics?.VideoStart(this.state.videoGuid, this.state.placementType);
      };
      const video30PCT = () => {
        VideoMetrics !== undefined && VideoMetrics?.Video30pct(this.state.videoGuid);
      };
      const video70PCT = () => {
        VideoMetrics !== undefined && VideoMetrics?.Video70pct(this.state.videoGuid);
      };
      const video90PCT = () => {
        VideoMetrics !== undefined && VideoMetrics?.Video90pct(this.state.videoGuid);
      };
      const callStartOnce = R.once(videostarted);
      const call30pctOnce = R.once(video30PCT);
      const call70pctOnce = R.once(video70PCT);
      const call90pctOnce = R.once(video90PCT);
      player.on("loadedmetadata", e => {
        var videoLength = player.duration;
        videoLength && player.on("timeupdate", e => {
          var currTime = player.currentTime;
          if (currTime / videoLength * 100 < 30) {
            callStartOnce();
          }
          if (currTime / videoLength * 100 > 30) {
            call30pctOnce();
          }
          if (currTime / videoLength * 100 > 70) {
            call70pctOnce();
          }
          if (currTime / videoLength * 100 > 90) {
            call90pctOnce();
          }
        });
      });
    });
    _defineProperty(this, "listenForEscape", e => {
      // this will prevent modal from closing if user escapes menu in flowplayer
      if (e.key === "Escape" && !e.target.closest(".fp-menu-container")) {
        this.closeModal();
      }
    });
    _defineProperty(this, "toggleHeight", e => {
      const height = this.state.height !== 0 ? 0 : "auto";
      const expanded = !this.state.expanded;
      this.setState({
        height,
        expanded
      });
    });
    this.state = {
      modalIsOpen: props.modalIsOpen || false,
      primaryVideo: null,
      secondaryVideo: null,
      videoTitle: null,
      isLoading: true,
      player: null,
      preload: true,
      subtitles: [],
      currentTrigger: null,
      checked: false,
      cuepoints: [],
      height: "auto",
      expanded: true,
      videoGuid: null,
      trackVideo: false
    };
  }
  render() {
    const hasCuepoints = this.state.cuepoints.length > 0;
    const mountClassNames = (0, _classnames.default)("js-video-viewer__mount--modal flowplayer use-thin-controlbar use-play-2", {
      "is-checked": this.state.checked
    });
    const modalClassNames = (0, _classnames.default)("gv__modal__content gv__modal__content--video", {
      "gv__modal__content--video-cuepoints": hasCuepoints
    });
    const contentClass = (0, _classnames.default)("gv__video-viewer__content", {
      "gv__video-viewer__content--has-accordion js-accordion": hasCuepoints
    });
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
      isOpen: this.state.modalIsOpen,
      onAfterOpen: this.afterOpenModal,
      onRequestClose: this.closeModal,
      contentLabel: "New Class Form",
      bodyOpenClassName: null,
      overlayClassName: "gv__modal",
      className: modalClassNames,
      shouldCloseOnEsc: false
    }, /*#__PURE__*/_react.default.createElement(_ConditionalWrapper.default, {
      condition: hasCuepoints,
      wrapper: children => /*#__PURE__*/_react.default.createElement("div", {
        className: "js-gv__video-viewer__container gv__video-viewer__container"
      }, children)
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      onClick: this.closeModal,
      className: "gv__modal__close"
    }, "close"), /*#__PURE__*/_react.default.createElement("div", {
      className: mountClassNames,
      id: "async-player",
      "data-player-id": "252895bc-da7a-4bc4-9501-bcc79d1e9b25"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: contentClass
    }, hasCuepoints && /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__video-viewer__lower js-gv__video-viewer__lower"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__video-viewer__pause"
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      onChange: e => this.handleCheck(e),
      className: "gv__video-viewer__checkbox js-gv__video-viewer__checkbox",
      id: "pause-key-ideas"
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "pause-key-ideas",
      className: "gv__video-viewer__pause-text js-gv__video-viewer__pause-text"
    }, "Pause at Key Ideas"), " ", /*#__PURE__*/_react.default.createElement("button", {
      className: "gv__video-viewer__expand gv__accordion-list__link",
      type: "button",
      onClick: e => this.toggleHeight(e),
      "aria-expanded": this.state.expanded
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "gv__visually-hidden"
    }, "Show Key Ideas")))), hasCuepoints && /*#__PURE__*/_react.default.createElement(_reactAnimateHeight.default, {
      id: "keyframeAccordion",
      className: "gv__video-viewer__modal-key-ideas",
      duration: 500,
      height: this.state.height
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__video-viewer__key-ideas"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "gv__video-viewer__key-ideas-heading js-gv__video-viewer__count"
    }, "Key Ideas"), /*#__PURE__*/_react.default.createElement("div", {
      className: "gv__video-viewer__key-copy"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "js-gv__video-viewer__key-time gv__video-viewer__key-time"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "js-gv__video-viewer__key-ideas-description gv__video-viewer__key-ideas-description"
    }, "As this video progresses, key ideas will be introduced to invoke discussion.")))))));
  }
}
exports.default = VideoModal;
_defineProperty(VideoModal, "propTypes", {
  modalIsOpen: _propTypes.bool
});

},{"../partials/ConditionalWrapper.jsx":135,"../video.js":265,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react","react-animate-height":"react-animate-height","react-modal":"react-modal"}],265:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cuepointLogic = void 0;
exports.default = _default;
exports.handleCheck = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var R = _interopRequireWildcard(require("ramda"));
var _VideoModal = _interopRequireDefault(require("./video-modal/VideoModal.jsx"));
var _sessionTracking = require("./sessionTracking.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import {loadScript} from "./loadscript";

function _default() {
  let document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  let playBuffer = setTimeout(() => {}, 1);
  const el = document.querySelector(".js-video-promo__modal-mount");
  if (el) {
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_VideoModal.default, null), el);
  }
  [...document.querySelectorAll(".js-video-viewer__mount")].forEach(initVideoPlayer);

  //start function
  function initVideoPlayer(el, i) {
    let subtitles;
    if (el.dataset.videoSubtitles) {
      subtitles = {
        tracks: [JSON.parse(el.dataset.videoSubtitles), {
          src: "",
          label: "None",
          is_default: false
        }]
      };
    }
    const flowplayerConfig = {
      token: "eyJraWQiOiJuVVJHSncwNjFzUlkiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6NCxcImlkXCI6XCJuVVJHSncwNjFzUllcIn0iLCJpc3MiOiJGbG93cGxheWVyIn0.Q0ETTfgixa1OKG0QPGFkzXj7nxbwvtbwt1fdBZCf1fM5vGMP_jgBH3p5NuTuvCZnwFWvBUBEUeeLAuyqtohYEQ",
      hls: {},
      src: el.dataset.videoSrc,
      cuepoints: el.dataset.videoCuepoints && JSON.parse(el.dataset.videoCuepoints).cuepoints,
      draw_cuepoints: true,
      auto_orient: true
    };
    if (el.dataset.poster) {
      flowplayerConfig.poster = el.dataset.poster;
    }
    if (subtitles) {
      flowplayerConfig.subtitles = subtitles;
    }
    const video = window.flowplayer(el, flowplayerConfig);
    const shouldTrackPlay = el.dataset.sessionId;
    shouldTrackPlay && sessionTrackVideo(video, el);
    cuepointLogic(video, el);

    // TODO: we need to add data-video-guid, and data-placement-type to all videos
    // Adobe Omniture tracking
    const videostarted = () => {
      VideoMetrics !== undefined && VideoMetrics?.VideoStart(el.dataset.videoGuid, el.dataset.placementType);
    };
    const video30PCT = () => {
      VideoMetrics !== undefined && VideoMetrics?.Video30pct(el.dataset.videoGuid);
    };
    const video70PCT = () => {
      VideoMetrics !== undefined && VideoMetrics?.Video70pct(el.dataset.videoGuid);
    };
    const video90PCT = () => {
      VideoMetrics !== undefined && VideoMetrics?.Video90pct(el.dataset.videoGuid);
    };
    const callStartOnce = R.once(videostarted);
    const call30pctOnce = R.once(video30PCT);
    const call70pctOnce = R.once(video70PCT);
    const call90pctOnce = R.once(video90PCT);
    video.on("timeupdate", e => {
      var currTime = video.currentTime;
      if (currTime / video.duration * 100 < 30) {
        callStartOnce();
      }
      if (currTime / video.duration * 100 > 30) {
        call30pctOnce();
      }
      if (currTime / video.duration * 100 > 70) {
        call70pctOnce();
      }
      if (currTime / video.duration * 100 > 90) {
        call90pctOnce();
      }
    });
    const checkbox = el.closest(".js-gv__video-viewer__container").querySelector(".js-gv__video-viewer__checkbox");
    const replayBtn = el.querySelector(".js-fp-custom-replay");
    replayBtn && replayBtn.addEventListener("click", e => handleReplay(e, video));
    const controls = el.querySelector(".fp-controls");
    // const replay = el.querySelector(".fp-custom-replay");
    // controls.append(replay);
    if (checkbox) {
      const checkboxLabel = el.closest(".js-gv__video-viewer__container").querySelector(".js-gv__video-viewer__pause-text");
      checkboxLabel.addEventListener("click", e => handleCheck(e, el));
      checkbox.addEventListener("keyup", e => {
        {
          (e.code === "Space" || e.code === "Enter") && handleCheck(e, el);
        }
      });
    }
    //flowplayer automatically adds these and won't remove them unless the user re-orients their device
    video.removeAttribute("playsinline");
    video.removeAttribute("webkit-playsinline");

    // now that we're disabling subtitles by default, I'm hiding this for now.
    // let trackElement = el.querySelector("track");
    // trackElement.addEventListener("load", e => updateSubtitle(e), false);
    // //update cue position to be above controls
    // const updateSubtitle = e => {
    //   let cues = el.querySelector("video").textTracks[0].cues;
    //   let totalCues = cues.length;

    //   for (i = 0; i < totalCues; i++) {
    //     const cue = el.querySelector("video").textTracks[0].cues[i];
    //     cue.line = -5;
    //     cue.size = 100;
    //   }
    // };
  }
  const handleReplay = (e, player) => {
    clearTimeout(playBuffer);
    player.pause();
    player.currentTime = "0";
    playBuffer = setTimeout(() => {
      player.play();
    }, 300);
  };
}
const cuepointLogic = (video, el) => {
  const cuepointDescription = el.closest(".js-gv__video-viewer__container").querySelector(".js-gv__video-viewer__key-ideas-description");
  const cuepointTimestamp = el.closest(".js-gv__video-viewer__container").querySelector(".js-gv__video-viewer__key-time");
  const cuepointCount = el.closest(".js-gv__video-viewer__container").querySelector(".js-gv__video-viewer__count");
  const keyIdeasAcc = el.closest(".js-gv__video-viewer__container").querySelector(".js-accordion");
  const contentWrapper = el.closest(".js-gv__video-viewer__container").querySelector(".js-accordion-content-wrapper");

  //display key idea when cuepoint is reached
  const totalCuepoints = video.opts.cuepoints?.length;
  video.on("cuepointstart", function (e) {
    const cuepointIndex = R.findIndex(R.propEq("startTime", e.data.cuepoint.startTime), video.opts.cuepoints);
    if (!keyIdeasAcc.classList.contains('is-open')) {
      keyIdeasAcc.classList.add('is-open');
      contentWrapper.setAttribute("style", "height: auto");
    }
    setCuepoint(video, e.data.cuepoint, cuepointIndex, totalCuepoints);
  });

  //display a key idea if we seek past a cuepoint
  video.on("seeking seeked", function (e) {
    const time = Math.round(video.currentTime);
    const cueTimes = video.opts.cuepoints.map(cue => Math.round(cue.startTime));
    let newCue;
    for (const [index, cue] of cueTimes.entries()) {
      if (time < cue) {
        if (index > 0) {
          setCuepoint(video, newCue, index - 1, totalCuepoints);
        } else if (time < cueTimes[0]) {
          cuepointDescription.classList.contains("active-cue") && cuepointDescription.classList.remove("active-cue");
          cuepointCount.innerText = "";
          cuepointCount.classList.remove("is-visible");
        }
        break;
      } else {
        newCue = video.opts.cuepoints[index];
        setCuepoint(video, newCue, index, totalCuepoints);
      }
    }
  });
  const setCuepoint = (video, cuepointData, cuepointIndex, totalCuepoints) => {
    cuepointCount.innerText = `Key Idea ${cuepointIndex + 1} of ${totalCuepoints}`;
    cuepointDescription.classList.contains("active-cue") && cuepointDescription.classList.remove("active-cue");
    cuepointDescription.innerHTML = cuepointData.msg;
    cuepointDescription.classList.add("active-cue");
    cuepointTimestamp.innerHTML = convertCuepoints(cuepointData.startTime);
    if (el.classList.contains("is-checked")) {
      video.pause();
    }
  };

  // https://stackoverflow.com/questions/5539028/converting-seconds-into-hhmmss
  const convertCuepoints = d => {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor(d % 3600 / 60);
    const s = Math.floor(d % 3600 % 60);
    const hDisplay = h > 0 ? h < 10 ? `0${h}` : h + ":" : "";
    const mDisplay = m > 0 ? m < 10 ? `0${m}:` : m + ":" : "00:";
    const sDisplay = s > 0 ? s < 10 ? `0${s}` : s : "00";
    return hDisplay + mDisplay + sDisplay;
  };
};
exports.cuepointLogic = cuepointLogic;
const sessionTrackVideo = (video, trackPlay) => {
  video.on("playing", e => {
    (0, _sessionTracking.handleVideoPlay)(trackPlay);
  });
};
const handleCheck = (e, el) => {
  e.stopPropagation();
  e.preventDefault();
  //  kinda hacky, but basically we want to determine whether we clicked the label or the input. Keyboard users would have hit the input, mouse the label
  const checkbox = e.target.classList.contains("js-gv__video-viewer__checkbox") ? e.target : e.target.closest(".js-gv__video-viewer__container").querySelector(".js-gv__video-viewer__checkbox");
  const wasChecked = checkbox.checked;
  const isChecked = checkbox.checked = !wasChecked;
  if (isChecked) {
    el.classList.add("is-checked");
  } else {
    el.classList.contains("is-checked") && el.classList.remove("is-checked");
  }
};
exports.handleCheck = handleCheck;

},{"./sessionTracking.js":197,"./video-modal/VideoModal.jsx":264,"ramda":"ramda","react":"react","react-dom":"react-dom"}],266:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VocabEntry = props => {
  const {
    id,
    showLinks,
    closeModal
  } = props;
  const {
    wordFormsTitle,
    definitionTitle,
    synonymsTitle,
    antonymsTitle,
    useInSentenceTitle,
    linkToLessonTitle
  } = props.titles;
  const {
    vocabTerm,
    termType,
    wordForms,
    definition,
    synonyms,
    antonyms,
    useInSentence,
    materialLessons
  } = props.content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry",
    id: id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__term"
  }, vocabTerm && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__term-name"
  }, vocabTerm), termType && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__term-type"
  }, `(${termType})`)), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__jump-links"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#alphabet-index-top",
    className: "gv__vocab-entry__jump-link gv__visuallyhidden gv__focusable"
  }, "Jump To Navigation"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "gv__vocab-entry__jump-link gv__vocab-entry__jump-link--btn gv__visuallyhidden gv__focusable",
    onClick: closeModal
  }, "Close")), wordFormsTitle && wordForms && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-title"
  }, wordFormsTitle), /*#__PURE__*/_react.default.createElement("p", null, wordForms)), definitionTitle && definition && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-title"
  }, definitionTitle), /*#__PURE__*/_react.default.createElement("p", null, definition)), synonymsTitle && synonyms && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-title"
  }, synonymsTitle), /*#__PURE__*/_react.default.createElement("p", null, synonyms)), antonymsTitle && antonyms && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-title"
  }, antonymsTitle), /*#__PURE__*/_react.default.createElement("p", null, antonyms)), useInSentenceTitle && useInSentence && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-title"
  }, useInSentenceTitle), /*#__PURE__*/_react.default.createElement("p", null, useInSentence)), showLinks && /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__detail-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__lesson-link-wrapper"
  }, materialLessons && materialLessons.map((lesson, i) => /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-entry__lesson-link",
    key: i
  }, /*#__PURE__*/_react.default.createElement("span", null, `${linkToLessonTitle}: `), /*#__PURE__*/_react.default.createElement("a", {
    href: lesson.lessonUrl
  }, lesson.lessonName))))));
};
VocabEntry.propTypes = {
  id: _propTypes.string,
  showLinks: _propTypes.bool,
  closeModal: _propTypes.func,
  content: (0, _propTypes.shape)({
    vocabTerm: _propTypes.string,
    termType: _propTypes.string,
    wordForms: _propTypes.string,
    definition: _propTypes.string,
    synonyms: _propTypes.string,
    antonyms: _propTypes.string,
    useInSentence: _propTypes.string
  }),
  titles: (0, _propTypes.shape)({
    wordFormsTitle: _propTypes.string,
    definitionTitle: _propTypes.string,
    synonymsTitle: _propTypes.string,
    antonymsTitle: _propTypes.string,
    useInSentenceTitle: _propTypes.string
  })
};
var _default = exports.default = VocabEntry;

},{"prop-types":"prop-types","react":"react"}],267:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _VocabEntry = _interopRequireDefault(require("./VocabEntry.jsx"));
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const VocabModal = props => {
  const mdBreakpoint = 780;
  const [modalOpen, setModalOpen] = (0, _react.useState)(false);
  const [overlayOpen, setOverlayOpen] = (0, _react.useState)(false);
  const [ariaHidden, setAriaHidden] = (0, _react.useState)(false);
  const [narrowView, setNarrowView] = (0, _react.useState)(window.innerWidth <= mdBreakpoint);
  const {
    vocabEntryTitles,
    vocabEntries,
    showLinks
  } = props;
  let focusBuffer = setTimeout(() => {}, 1);
  const didMountRef = (0, _react.useRef)(false);
  const vocabModalRef = (0, _react.useRef)();

  // keyboard navigation
  (0, _react.useEffect)(() => {
    const checkTab = e => {
      if (e.key === "Tab") {} else if (e.key === "Escape") {
        closeModal();
      }
      return;
    };
    clearTimeout(focusBuffer);
    if (didMountRef.current) {
      if (modalOpen) {
        setAriaHidden(false);
        document.querySelector("body").addEventListener("keyup", e => checkTab(e));
      } else {
        setAriaHidden(true);
        document.querySelector("body").removeEventListener("keyup", e => checkTab(e));
      }
    } else {
      didMountRef.current = true;
    }
  }, [focusBuffer, modalOpen]);

  // remote buttons
  (0, _react.useEffect)(() => {
    const vocabItems = document.querySelectorAll(".js-vocab-item");
    const hiddenOpenBtn = document.querySelector(".js-hidden-open-btn");
    const handleRemoteClick = vocabItem => {
      openModal();
      const vocabItemLink = vocabItem.querySelector("a");
      const vocabModalEl = vocabModalRef.current;
      const target = vocabModalEl.querySelector(`${vocabItemLink.getAttribute("href")}`);
      if (narrowView) {
        handleScroll(target, vocabModalEl, 149, 200);
      } else {
        handleScroll(target, vocabModalEl, 81, 200);
      }
    };
    vocabItems.forEach(vocabItem => {
      vocabItem.addEventListener("click", () => handleRemoteClick(vocabItem));
    });
    hiddenOpenBtn.addEventListener("click", () => {
      openModal();
    });
    return (handleRemoteClick, vocabItem) => {
      vocabItems.forEach(vocabItem => {
        vocabItem.removeEventListener("click", () => handleRemoteClick(vocabItem));
      });
    };
  }, [narrowView]);

  // click away
  (0, _react.useEffect)(() => {
    const handleClickAway = e => {
      if (modalOpen && !vocabModalRef.current.contains(e.target)) {
        closeModal();
      }
    };
    document.addEventListener("click", handleClickAway);
    return () => {
      document.removeEventListener("click", handleClickAway);
    };
  }, [modalOpen]);

  // window resize
  (0, _react.useEffect)(() => {
    // initialize width for mobile slide-in effect if narrow viewport
    window.innerWidth <= mdBreakpoint && (vocabModalRef.current.style.width = `${innerWidth}px`);
  }, [vocabModalRef]);
  (0, _react.useEffect)(() => {
    // note: using debounce from "lodash.debounce" does not always remove width property reliably when window is resized
    const handleWindowResize = () => {
      setNarrowView(window.innerWidth <= mdBreakpoint);

      // set width for mobile slide-in effect on resize
      if (window.innerWidth <= mdBreakpoint) {
        vocabModalRef.current.style.width = `${innerWidth}px`;
      } else {
        vocabModalRef.current.style.removeProperty("width");
      }
    };
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [mdBreakpoint]);

  // alphabetic index
  (0, _react.useEffect)(() => {
    const alphaIndexes = document.querySelectorAll(".gv__vocab-modal__alphabet-list-item a");

    // const handleIndexActive = (alphaIndexes, e) => {
    //   alphaIndexes.forEach(alphaIndex => {
    //     alphaIndex.classList.remove("is-active");
    //   });
    //   e.currentTarget.classList.add("is-active");
    // };

    alphaIndexes.forEach(alphaIndex => {
      const handleAlphaIndexClick = e => {
        const vocabModalEl = vocabModalRef.current;
        const target = vocabModalEl.querySelector(`${alphaIndex.getAttribute("href")}`);
        // handleIndexActive(alphaIndexes, e);

        if (narrowView) {
          handleScroll(target, vocabModalEl, 149, 50);
        } else {
          handleScroll(target, vocabModalEl, 81, 50);
        }
      };
      alphaIndex.addEventListener("click", handleAlphaIndexClick);
    });
    return handleAlphaIndexClick => {
      alphaIndexes.forEach(alphaIndex => {
        alphaIndex.removeEventListener("click", handleAlphaIndexClick);
      });
    };
  }, [narrowView]);
  const openModal = () => {
    setOverlayOpen(true);
    setTimeout(() => {
      setModalOpen(true);
    }, 100);
    document.querySelector("body").classList.add("gv__vocab-modal__open");
  };
  const closeModal = () => {
    setOverlayOpen(false);
    setModalOpen(false);
    document.querySelector("body").classList.remove("gv__vocab-modal__open");
    const alphaIndexes = document.querySelectorAll(".gv__vocab-modal__alphabet-list-item a");
    alphaIndexes.forEach(alphaIndex => {
      alphaIndex.classList.remove("is-active");
    });
  };
  const handleScroll = (target, ref, offset, delay) => {
    const targetOffset = target.offsetTop - offset;
    setTimeout(() => {
      ref.scrollTo({
        top: targetOffset,
        behavior: "smooth"
      });
    }, delay);
  };
  const vocabTermToID = term => {
    const lcTerm = term.toLowerCase();
    return lcTerm.replace(/\s+/g, "-").replace("(", "").replace(")", "");
  };
  const sortedVocabWords = R.compose(R.map(vocabEntry => vocabEntry.toLowerCase().replace(/\s+/g, "-")), R.sortBy(R.identity), R.pluck("vocabTerm"))(vocabEntries);
  const renderVocabEntries = () => {
    return vocabEntries.map((entry, i) => {
      const vocabID = vocabTermToID(entry.vocabTerm);
      return /*#__PURE__*/_react.default.createElement(_VocabEntry.default, {
        titles: vocabEntryTitles,
        content: entry,
        id: vocabID,
        showLinks: showLinks,
        closeModal: closeModal,
        key: i
      });
    });
  };
  const renderAlphabetNav = sortedVocabWords => {
    const alphabet = "abcdefghijklmnopqrstuvwxyz";
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: "gv__vocab-modal__alphabet-list"
    }, [...alphabet].map((letter, i) => {
      const linkedTerm = sortedVocabWords.filter(word => word.startsWith(letter))[0] || null;
      const firstLinkedTerm = sortedVocabWords[0];
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "gv__vocab-modal__alphabet-list-item",
        key: i
      }, linkedTerm ? /*#__PURE__*/_react.default.createElement("a", {
        href: `#${linkedTerm}`,
        id: linkedTerm === firstLinkedTerm ? "alphabet-index-top" : null
      }, letter) : /*#__PURE__*/_react.default.createElement("span", null, letter));
    }));
  };
  const modalOverlayClasses = (0, _classnames.default)("gv__vocab-modal__overlay", {
    "is-open": overlayOpen
  });
  const modalContainerClasses = (0, _classnames.default)("gv__vocab-modal__container", {
    "is-open": modalOpen
  });
  const modalClasses = (0, _classnames.default)("gv__vocab-modal", {
    "is-open": modalOpen
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: modalOverlayClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: modalContainerClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: modalClasses,
    "aria-hidden": ariaHidden,
    ref: vocabModalRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-modal__heading-wrapper"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "gv__vocab-modal__heading"
  }, vocabEntryTitles.vocabModalTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-modal__alphabet-nav",
    id: "alphabet-nav"
  }, renderAlphabetNav(sortedVocabWords))), /*#__PURE__*/_react.default.createElement("button", {
    "aria-expanded": modalOpen,
    className: "gv__vocab-modal__close-btn js-vocab-modal-close",
    type: "button",
    id: "close-btn",
    onClick: () => {
      closeModal();
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: "/OWH/assets-build/img/icons/x-close.svg",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "gv__visually-hidden"
  }, "Close")), /*#__PURE__*/_react.default.createElement("div", {
    className: "gv__vocab-modal__vocab-entries"
  }, renderVocabEntries())))));
};
VocabModal.propTypes = {
  vocabEntryTitles: _propTypes.object,
  vocabEntries: _propTypes.array,
  showLinks: _propTypes.bool
};
var _default = exports.default = VocabModal;

},{"./VocabEntry.jsx":266,"classnames":"classnames","prop-types":"prop-types","ramda":"ramda","react":"react"}],268:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _VocabModal = _interopRequireDefault(require("./VocabModal.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const el = document.querySelector(".js-vocab-modal-mount");
if (el) {
  // pattern lab:
  // const props = {
  //   vocabEntryTitles: JSON.parse(el.dataset.vocab).vocabEntryTitles || {},
  //   vocabEntries: JSON.parse(el.dataset.vocab).vocabEntries || []
  // };

  // support site:
  const props = vocabTermsModalData;
  console.log('%cweb/OWH.Web/OWH/assets-source/js/vocab-modal/vocab-modal.js:15 props', 'color: #007acc;', props);
  if (props.vocabEntries.length) {
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_VocabModal.default, props), el);
  }
}

},{"./VocabModal.jsx":267,"react":"react","react-dom":"react-dom"}],269:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const propTypes = {
  vocabulary: _propTypes.string
};
const VocabButton = props => {
  const vocabulary = props.vocabulary;
  const linkedTerm = vocabulary.toLowerCase().replace(/\s+/g, "-").replace("(", "").replace(")", "");
  return /*#__PURE__*/_react.default.createElement("a", {
    href: `#${linkedTerm}`,
    className: "gv__lesson-step__vocab-button"
  }, vocabulary);
};
VocabButton.propTypes = propTypes;
var _default = exports.default = VocabButton;

},{"prop-types":"prop-types","react":"react"}],270:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _VocabButton = _interopRequireDefault(require("./VocabButton.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const els = [...document.querySelectorAll(".js-vocab-item")];
if (els) {
  els.forEach(el => {
    const vocabulary = el.dataset.vocabulary;
    const props = {
      vocabulary
    };
    (0, _reactDom.render)(/*#__PURE__*/_react.default.createElement(_VocabButton.default, props), el);
  });
}

},{"./VocabButton.jsx":269,"react":"react","react-dom":"react-dom"}]},{},[118]);
